{
  "㐁": "rarely-used",
  "㐌": "rarely-used",
  "㐖": "rarely-used",
  "㐜": "rarely-used",
  "㐤": "rarely-used",
  "㐨": "rarely-used",
  "㐩": "rarely-used",
  "㐲": "rarely-used",
  "㐻": "rarely-used",
  "㐼": "rarely-used",
  "㑁": "rarely-used",
  "㑃": "rarely-used",
  "㑉": "rarely-used",
  "㑊": "rarely-used",
  "㑋": "rarely-used",
  "㑍": "rarely-used",
  "㑎": "rarely-used",
  "㑐": "rarely-used",
  "㑗": "rarely-used",
  "㑙": "rarely-used",
  "㑚": "rarely-used",
  "㑛": "rarely-used",
  "㑜": "rarely-used",
  "㑝": "rarely-used",
  "㑞": "rarely-used",
  "㑟": "rarely-used",
  "㑣": "rarely-used",
  "㑦": "rarely-used",
  "㑮": "rarely-used",
  "㑯": "rarely-used",
  "㑳": "rarely-used",
  "㑵": "rarely-used",
  "㑶": "rarely-used",
  "㑻": "rarely-used",
  "㑼": "rarely-used",
  "㑾": "rarely-used",
  "㑿": "rarely-used",
  "㒀": "rarely-used",
  "㒁": "rarely-used",
  "㒂": "rarely-used",
  "㒄": "rarely-used",
  "㒅": "rarely-used",
  "㒈": "rarely-used",
  "㒊": "rarely-used",
  "㒎": "rarely-used",
  "㒑": "rarely-used",
  "㒒": "rarely-used",
  "㒓": "rarely-used",
  "㒔": "rarely-used",
  "㒕": "rarely-used",
  "㒙": "rarely-used",
  "㒚": "rarely-used",
  "㒛": "rarely-used",
  "㒜": "rarely-used",
  "㒝": "rarely-used",
  "㒟": "rarely-used",
  "㒠": "rarely-used",
  "㒡": "rarely-used",
  "㒤": "rarely-used",
  "㒥": "rarely-used",
  "㒦": "rarely-used",
  "㒩": "rarely-used",
  "㒴": "rarely-used",
  "㒸": "rarely-used",
  "㒻": "rarely-used",
  "㒼": "rarely-used",
  "㒽": "rarely-used",
  "㒾": "rarely-used",
  "㒿": "rarely-used",
  "㓃": "rarely-used",
  "㓄": "rarely-used",
  "㓅": "rarely-used",
  "㓈": "rarely-used",
  "㓉": "rarely-used",
  "㓊": "rarely-used",
  "㓋": "rarely-used",
  "㓌": "rarely-used",
  "㓎": "rarely-used",
  "㓏": "rarely-used",
  "㓐": "rarely-used",
  "㓑": "rarely-used",
  "㓓": "rarely-used",
  "㓔": "rarely-used",
  "㓖": "rarely-used",
  "㓘": "rarely-used",
  "㓚": "rarely-used",
  "㓞": "rarely-used",
  "㓟": "rarely-used",
  "㓠": "rarely-used",
  "㓡": "rarely-used",
  "㓢": "rarely-used",
  "㓣": "rarely-used",
  "㓤": "rarely-used",
  "㓧": "rarely-used",
  "㓩": "rarely-used",
  "㓬": "rarely-used",
  "㓭": "rarely-used",
  "㓱": "rarely-used",
  "㓲": "rarely-used",
  "㓳": "rarely-used",
  "㓴": "rarely-used",
  "㓵": "rarely-used",
  "㓹": "rarely-used",
  "㓺": "rarely-used",
  "㓼": "rarely-used",
  "㓽": "rarely-used",
  "㓾": "rarely-used",
  "㔀": "rarely-used",
  "㔁": "rarely-used",
  "㔂": "rarely-used",
  "㔃": "rarely-used",
  "㔄": "rarely-used",
  "㔅": "rarely-used",
  "㔆": "rarely-used",
  "㔇": "rarely-used",
  "㔊": "rarely-used",
  "㔋": "rarely-used",
  "㔌": "rarely-used",
  "㔍": "rarely-used",
  "㔎": "rarely-used",
  "㔏": "rarely-used",
  "㔒": "rarely-used",
  "㔓": "rarely-used",
  "㔕": "rarely-used",
  "㔗": "rarely-used",
  "㔙": "rarely-used",
  "㔝": "rarely-used",
  "㔞": "rarely-used",
  "㔠": "rarely-used",
  "㔡": "rarely-used",
  "㔣": "rarely-used",
  "㔤": "rarely-used",
  "㔥": "rarely-used",
  "㔦": "rarely-used",
  "㔨": "rarely-used",
  "㔩": "rarely-used",
  "㔪": "rarely-used",
  "㔮": "rarely-used",
  "㔯": "rarely-used",
  "㔱": "rarely-used",
  "㔴": "rarely-used",
  "㔵": "rarely-used",
  "㔶": "rarely-used",
  "㔸": "rarely-used",
  "㔹": "rarely-used",
  "㕃": "rarely-used",
  "㕄": "rarely-used",
  "㕅": "rarely-used",
  "㕆": "rarely-used",
  "㕇": "rarely-used",
  "㕊": "rarely-used",
  "㕋": "rarely-used",
  "㕌": "rarely-used",
  "㕎": "rarely-used",
  "㕐": "rarely-used",
  "㕒": "rarely-used",
  "㕙": "rarely-used",
  "㕚": "rarely-used",
  "㕞": "rarely-used",
  "㕢": "rarely-used",
  "㕣": "rarely-used",
  "㕥": "rarely-used",
  "㕦": "rarely-used",
  "㕧": "rarely-used",
  "㕩": "rarely-used",
  "㕪": "rarely-used",
  "㕫": "rarely-used",
  "㕬": "rarely-used",
  "㕭": "rarely-used",
  "㕮": "rarely-used",
  "㕯": "rarely-used",
  "㕰": "rarely-used",
  "㕱": "rarely-used",
  "㕲": "rarely-used",
  "㕸": "rarely-used",
  "㕹": "rarely-used",
  "㕻": "rarely-used",
  "㖀": "rarely-used",
  "㖅": "rarely-used",
  "㖆": "rarely-used",
  "㖇": "rarely-used",
  "㖏": "rarely-used",
  "㖐": "rarely-used",
  "㖑": "rarely-used",
  "㖒": "rarely-used",
  "㖓": "rarely-used",
  "㖔": "rarely-used",
  "㖕": "rarely-used",
  "㖘": "rarely-used",
  "㖟": "rarely-used",
  "㖡": "rarely-used",
  "㖢": "rarely-used",
  "㖤": "rarely-used",
  "㖥": "rarely-used",
  "㖦": "rarely-used",
  "㖧": "rarely-used",
  "㖨": "rarely-used",
  "㖩": "rarely-used",
  "㖪": "rarely-used",
  "㖴": "rarely-used",
  "㖵": "rarely-used",
  "㖶": "rarely-used",
  "㖷": "rarely-used",
  "㖹": "rarely-used",
  "㖺": "rarely-used",
  "㖻": "rarely-used",
  "㖼": "rarely-used",
  "㖿": "rarely-used",
  "㗀": "rarely-used",
  "㗂": "rarely-used",
  "㗅": "rarely-used",
  "㗆": "rarely-used",
  "㗇": "rarely-used",
  "㗈": "rarely-used",
  "㗊": "rarely-used",
  "㗌": "rarely-used",
  "㗓": "rarely-used",
  "㗔": "rarely-used",
  "㗕": "rarely-used",
  "㗗": "rarely-used",
  "㗘": "rarely-used",
  "㗙": "rarely-used",
  "㗚": "rarely-used",
  "㗢": "rarely-used",
  "㗥": "rarely-used",
  "㗦": "rarely-used",
  "㗧": "rarely-used",
  "㗨": "rarely-used",
  "㗩": "rarely-used",
  "㗪": "rarely-used",
  "㗫": "rarely-used",
  "㗬": "rarely-used",
  "㗭": "rarely-used",
  "㗰": "rarely-used",
  "㗱": "rarely-used",
  "㗲": "rarely-used",
  "㗴": "rarely-used",
  "㗵": "rarely-used",
  "㗻": "rarely-used",
  "㗼": "rarely-used",
  "㗾": "rarely-used",
  "㗿": "rarely-used",
  "㘀": "rarely-used",
  "㘁": "rarely-used",
  "㘂": "rarely-used",
  "㘆": "rarely-used",
  "㘇": "rarely-used",
  "㘈": "rarely-used",
  "㘉": "rarely-used",
  "㘊": "rarely-used",
  "㘋": "rarely-used",
  "㘌": "rarely-used",
  "㘍": "rarely-used",
  "㘐": "rarely-used",
  "㘑": "rarely-used",
  "㘓": "rarely-used",
  "㘔": "rarely-used",
  "㘖": "rarely-used",
  "㘙": "rarely-used",
  "㘚": "rarely-used",
  "㘛": "rarely-used",
  "㘝": "rarely-used",
  "㘞": "rarely-used",
  "㘟": "rarely-used",
  "㘠": "rarely-used",
  "㘢": "rarely-used",
  "㘣": "rarely-used",
  "㘤": "rarely-used",
  "㘦": "rarely-used",
  "㘧": "rarely-used",
  "㘨": "rarely-used",
  "㘫": "rarely-used",
  "㘿": "rarely-used",
  "㙀": "rarely-used",
  "㙁": "rarely-used",
  "㙂": "rarely-used",
  "㙃": "rarely-used",
  "㙇": "rarely-used",
  "㙈": "rarely-used",
  "㙊": "rarely-used",
  "㙎": "rarely-used",
  "㙏": "rarely-used",
  "㙐": "rarely-used",
  "㙓": "rarely-used",
  "㙙": "rarely-used",
  "㙛": "rarely-used",
  "㙝": "rarely-used",
  "㙞": "rarely-used",
  "㙠": "rarely-used",
  "㙡": "rarely-used",
  "㙢": "rarely-used",
  "㙣": "rarely-used",
  "㙥": "rarely-used",
  "㙩": "rarely-used",
  "㙪": "rarely-used",
  "㙫": "rarely-used",
  "㙰": "rarely-used",
  "㙱": "rarely-used",
  "㙳": "rarely-used",
  "㙴": "rarely-used",
  "㙷": "rarely-used",
  "㙹": "rarely-used",
  "㙺": "rarely-used",
  "㚀": "rarely-used",
  "㚁": "rarely-used",
  "㚂": "rarely-used",
  "㚃": "rarely-used",
  "㚅": "rarely-used",
  "㚇": "rarely-used",
  "㚉": "rarely-used",
  "㚊": "rarely-used",
  "㚋": "rarely-used",
  "㚍": "rarely-used",
  "㚒": "rarely-used",
  "㚓": "rarely-used",
  "㚔": "rarely-used",
  "㚕": "rarely-used",
  "㚖": "rarely-used",
  "㚗": "rarely-used",
  "㚘": "rarely-used",
  "㚚": "rarely-used",
  "㚜": "rarely-used",
  "㚞": "rarely-used",
  "㚠": "rarely-used",
  "㚡": "rarely-used",
  "㚤": "rarely-used",
  "㚥": "rarely-used",
  "㚧": "rarely-used",
  "㚨": "rarely-used",
  "㚫": "rarely-used",
  "㚬": "rarely-used",
  "㚭": "rarely-used",
  "㚰": "rarely-used",
  "㚱": "rarely-used",
  "㚲": "rarely-used",
  "㚴": "rarely-used",
  "㚵": "rarely-used",
  "㚷": "less-than-common",
  "㚸": "rarely-used",
  "㚻": "rarely-used",
  "㚼": "rarely-used",
  "㚽": "rarely-used",
  "㚾": "rarely-used",
  "㚿": "rarely-used",
  "㛁": "rarely-used",
  "㛃": "rarely-used",
  "㛄": "rarely-used",
  "㛅": "rarely-used",
  "㛊": "rarely-used",
  "㛍": "rarely-used",
  "㛎": "rarely-used",
  "㛏": "rarely-used",
  "㛒": "rarely-used",
  "㛓": "rarely-used",
  "㛖": "rarely-used",
  "㛗": "rarely-used",
  "㛘": "rarely-used",
  "㛙": "rarely-used",
  "㛚": "rarely-used",
  "㛜": "rarely-used",
  "㛝": "rarely-used",
  "㛞": "rarely-used",
  "㛥": "rarely-used",
  "㛦": "rarely-used",
  "㛧": "rarely-used",
  "㛨": "rarely-used",
  "㛪": "rarely-used",
  "㛫": "rarely-used",
  "㛬": "rarely-used",
  "㛭": "rarely-used",
  "㛯": "rarely-used",
  "㛱": "rarely-used",
  "㛳": "rarely-used",
  "㛴": "rarely-used",
  "㛵": "rarely-used",
  "㛶": "rarely-used",
  "㛷": "rarely-used",
  "㛸": "rarely-used",
  "㛹": "rarely-used",
  "㛻": "rarely-used",
  "㛼": "rarely-used",
  "㛾": "rarely-used",
  "㜂": "rarely-used",
  "㜃": "rarely-used",
  "㜄": "rarely-used",
  "㜅": "rarely-used",
  "㜆": "rarely-used",
  "㜇": "rarely-used",
  "㜈": "rarely-used",
  "㜉": "rarely-used",
  "㜊": "rarely-used",
  "㜋": "rarely-used",
  "㜌": "rarely-used",
  "㜍": "rarely-used",
  "㜎": "rarely-used",
  "㜐": "rarely-used",
  "㜒": "rarely-used",
  "㜓": "rarely-used",
  "㜕": "rarely-used",
  "㜖": "rarely-used",
  "㜗": "rarely-used",
  "㜘": "rarely-used",
  "㜙": "rarely-used",
  "㜚": "rarely-used",
  "㜝": "rarely-used",
  "㜞": "rarely-used",
  "㜠": "rarely-used",
  "㜡": "rarely-used",
  "㜢": "rarely-used",
  "㜣": "rarely-used",
  "㜤": "rarely-used",
  "㜥": "rarely-used",
  "㜦": "rarely-used",
  "㜨": "rarely-used",
  "㜩": "rarely-used",
  "㜪": "rarely-used",
  "㜮": "rarely-used",
  "㜯": "rarely-used",
  "㜰": "rarely-used",
  "㜱": "rarely-used",
  "㜳": "rarely-used",
  "㜴": "rarely-used",
  "㜶": "rarely-used",
  "㜷": "rarely-used",
  "㜹": "rarely-used",
  "㜺": "rarely-used",
  "㝁": "rarely-used",
  "㝂": "rarely-used",
  "㝅": "rarely-used",
  "㝌": "rarely-used",
  "㝏": "rarely-used",
  "㝓": "rarely-used",
  "㝗": "rarely-used",
  "㝘": "rarely-used",
  "㝜": "rarely-used",
  "㝝": "rarely-used",
  "㝞": "rarely-used",
  "㝣": "rarely-used",
  "㝤": "rarely-used",
  "㝥": "rarely-used",
  "㝩": "rarely-used",
  "㝪": "rarely-used",
  "㝫": "rarely-used",
  "㝬": "rarely-used",
  "㝭": "rarely-used",
  "㝮": "rarely-used",
  "㝯": "rarely-used",
  "㝰": "rarely-used",
  "㝵": "rarely-used",
  "㝸": "rarely-used",
  "㝺": "rarely-used",
  "㝻": "rarely-used",
  "㝼": "rarely-used",
  "㝽": "rarely-used",
  "㝾": "rarely-used",
  "㝿": "rarely-used",
  "㞀": "rarely-used",
  "㞁": "rarely-used",
  "㞂": "rarely-used",
  "㞃": "rarely-used",
  "㞄": "rarely-used",
  "㞅": "rarely-used",
  "㞆": "rarely-used",
  "㞇": "rarely-used",
  "㞈": "rarely-used",
  "㞉": "rarely-used",
  "㞊": "rarely-used",
  "㞋": "rarely-used",
  "㞏": "rarely-used",
  "㞒": "rarely-used",
  "㞓": "rarely-used",
  "㞖": "rarely-used",
  "㞗": "rarely-used",
  "㞚": "rarely-used",
  "㞛": "rarely-used",
  "㞜": "rarely-used",
  "㞟": "rarely-used",
  "㞤": "rarely-used",
  "㞥": "rarely-used",
  "㞦": "rarely-used",
  "㞨": "rarely-used",
  "㞪": "rarely-used",
  "㞬": "rarely-used",
  "㞭": "rarely-used",
  "㞰": "rarely-used",
  "㞱": "rarely-used",
  "㞲": "rarely-used",
  "㞳": "rarely-used",
  "㞴": "rarely-used",
  "㞷": "rarely-used",
  "㞻": "rarely-used",
  "㞽": "rarely-used",
  "㞾": "rarely-used",
  "㟀": "rarely-used",
  "㟃": "rarely-used",
  "㟄": "rarely-used",
  "㟅": "rarely-used",
  "㟇": "rarely-used",
  "㟈": "rarely-used",
  "㟉": "rarely-used",
  "㟊": "rarely-used",
  "㟋": "rarely-used",
  "㟌": "rarely-used",
  "㟍": "rarely-used",
  "㟎": "rarely-used",
  "㟏": "rarely-used",
  "㟐": "rarely-used",
  "㟑": "rarely-used",
  "㟓": "rarely-used",
  "㟖": "rarely-used",
  "㟘": "rarely-used",
  "㟙": "rarely-used",
  "㟞": "rarely-used",
  "㟨": "rarely-used",
  "㟬": "rarely-used",
  "㟯": "rarely-used",
  "㟰": "rarely-used",
  "㟱": "rarely-used",
  "㟳": "rarely-used",
  "㟶": "rarely-used",
  "㟸": "rarely-used",
  "㟹": "rarely-used",
  "㟼": "rarely-used",
  "㟽": "rarely-used",
  "㟾": "rarely-used",
  "㟿": "rarely-used",
  "㠅": "rarely-used",
  "㠆": "rarely-used",
  "㠇": "rarely-used",
  "㠈": "rarely-used",
  "㠉": "rarely-used",
  "㠊": "rarely-used",
  "㠌": "rarely-used",
  "㠍": "rarely-used",
  "㠎": "rarely-used",
  "㠏": "rarely-used",
  "㠑": "rarely-used",
  "㠓": "rarely-used",
  "㠔": "rarely-used",
  "㠕": "rarely-used",
  "㠚": "rarely-used",
  "㠛": "rarely-used",
  "㠠": "rarely-used",
  "㠡": "rarely-used",
  "㠢": "rarely-used",
  "㠥": "rarely-used",
  "㠦": "rarely-used",
  "㠧": "rarely-used",
  "㠨": "rarely-used",
  "㠭": "rarely-used",
  "㠱": "rarely-used",
  "㠲": "rarely-used",
  "㠴": "rarely-used",
  "㠵": "rarely-used",
  "㠷": "rarely-used",
  "㠹": "rarely-used",
  "㠺": "rarely-used",
  "㠽": "rarely-used",
  "㠾": "rarely-used",
  "㠿": "rarely-used",
  "㡁": "rarely-used",
  "㡂": "rarely-used",
  "㡅": "rarely-used",
  "㡆": "rarely-used",
  "㡇": "rarely-used",
  "㡈": "rarely-used",
  "㡉": "rarely-used",
  "㡊": "rarely-used",
  "㡋": "rarely-used",
  "㡏": "rarely-used",
  "㡐": "rarely-used",
  "㡑": "rarely-used",
  "㡒": "rarely-used",
  "㡔": "rarely-used",
  "㡕": "rarely-used",
  "㡖": "rarely-used",
  "㡗": "rarely-used",
  "㡘": "rarely-used",
  "㡙": "rarely-used",
  "㡚": "rarely-used",
  "㡜": "rarely-used",
  "㡝": "rarely-used",
  "㡞": "rarely-used",
  "㡟": "rarely-used",
  "㡥": "rarely-used",
  "㡦": "rarely-used",
  "㡨": "rarely-used",
  "㡩": "rarely-used",
  "㡪": "rarely-used",
  "㡮": "rarely-used",
  "㡱": "rarely-used",
  "㡲": "rarely-used",
  "㡴": "rarely-used",
  "㡵": "rarely-used",
  "㡶": "rarely-used",
  "㡷": "rarely-used",
  "㡸": "rarely-used",
  "㡹": "rarely-used",
  "㡺": "rarely-used",
  "㡻": "rarely-used",
  "㡼": "rarely-used",
  "㡽": "rarely-used",
  "㡾": "rarely-used",
  "㢀": "rarely-used",
  "㢁": "rarely-used",
  "㢂": "rarely-used",
  "㢃": "rarely-used",
  "㢄": "rarely-used",
  "㢅": "rarely-used",
  "㢈": "rarely-used",
  "㢉": "rarely-used",
  "㢊": "rarely-used",
  "㢋": "rarely-used",
  "㢌": "rarely-used",
  "㢍": "rarely-used",
  "㢎": "rarely-used",
  "㢏": "rarely-used",
  "㢑": "rarely-used",
  "㢒": "rarely-used",
  "㢔": "rarely-used",
  "㢖": "rarely-used",
  "㢗": "rarely-used",
  "㢚": "rarely-used",
  "㢛": "rarely-used",
  "㢜": "rarely-used",
  "㢝": "rarely-used",
  "㢞": "rarely-used",
  "㢟": "rarely-used",
  "㢥": "rarely-used",
  "㢦": "rarely-used",
  "㢨": "rarely-used",
  "㢩": "rarely-used",
  "㢬": "rarely-used",
  "㢯": "rarely-used",
  "㢰": "rarely-used",
  "㢳": "rarely-used",
  "㢵": "rarely-used",
  "㢺": "rarely-used",
  "㢻": "rarely-used",
  "㢾": "rarely-used",
  "㣀": "rarely-used",
  "㣁": "rarely-used",
  "㣂": "rarely-used",
  "㣄": "rarely-used",
  "㣅": "rarely-used",
  "㣆": "rarely-used",
  "㣇": "rarely-used",
  "㣈": "rarely-used",
  "㣌": "rarely-used",
  "㣍": "rarely-used",
  "㣎": "rarely-used",
  "㣑": "rarely-used",
  "㣒": "rarely-used",
  "㣓": "rarely-used",
  "㣙": "rarely-used",
  "㣚": "rarely-used",
  "㣛": "rarely-used",
  "㣜": "rarely-used",
  "㣝": "rarely-used",
  "㣞": "rarely-used",
  "㣟": "rarely-used",
  "㣢": "rarely-used",
  "㣣": "rarely-used",
  "㣤": "rarely-used",
  "㣥": "rarely-used",
  "㣫": "rarely-used",
  "㣬": "rarely-used",
  "㣭": "rarely-used",
  "㣯": "rarely-used",
  "㣰": "rarely-used",
  "㣱": "rarely-used",
  "㣶": "rarely-used",
  "㣷": "rarely-used",
  "㣻": "rarely-used",
  "㣾": "rarely-used",
  "㣿": "rarely-used",
  "㤄": "rarely-used",
  "㤆": "rarely-used",
  "㤈": "rarely-used",
  "㤉": "rarely-used",
  "㤌": "rarely-used",
  "㤍": "rarely-used",
  "㤎": "rarely-used",
  "㤏": "rarely-used",
  "㤒": "rarely-used",
  "㤔": "rarely-used",
  "㤕": "rarely-used",
  "㤖": "rarely-used",
  "㤚": "rarely-used",
  "㤜": "rarely-used",
  "㤝": "rarely-used",
  "㤞": "rarely-used",
  "㤡": "rarely-used",
  "㤢": "rarely-used",
  "㤥": "rarely-used",
  "㤦": "rarely-used",
  "㤧": "rarely-used",
  "㤨": "rarely-used",
  "㤮": "rarely-used",
  "㤯": "rarely-used",
  "㤱": "rarely-used",
  "㤲": "rarely-used",
  "㤳": "rarely-used",
  "㤴": "rarely-used",
  "㤶": "rarely-used",
  "㤷": "rarely-used",
  "㤻": "rarely-used",
  "㤾": "rarely-used",
  "㤿": "rarely-used",
  "㥀": "rarely-used",
  "㥂": "rarely-used",
  "㥄": "rarely-used",
  "㥅": "rarely-used",
  "㥆": "rarely-used",
  "㥇": "rarely-used",
  "㥈": "rarely-used",
  "㥊": "rarely-used",
  "㥋": "rarely-used",
  "㥌": "rarely-used",
  "㥏": "rarely-used",
  "㥒": "rarely-used",
  "㥓": "rarely-used",
  "㥔": "rarely-used",
  "㥖": "rarely-used",
  "㥚": "rarely-used",
  "㥛": "rarely-used",
  "㥜": "rarely-used",
  "㥝": "rarely-used",
  "㥟": "rarely-used",
  "㥡": "rarely-used",
  "㥢": "rarely-used",
  "㥣": "rarely-used",
  "㥤": "rarely-used",
  "㥥": "rarely-used",
  "㥨": "rarely-used",
  "㥩": "rarely-used",
  "㥬": "rarely-used",
  "㥮": "rarely-used",
  "㥯": "rarely-used",
  "㥰": "rarely-used",
  "㥲": "rarely-used",
  "㥳": "rarely-used",
  "㥴": "rarely-used",
  "㥶": "rarely-used",
  "㥷": "rarely-used",
  "㥹": "rarely-used",
  "㥼": "rarely-used",
  "㥽": "rarely-used",
  "㥾": "rarely-used",
  "㦀": "rarely-used",
  "㦁": "rarely-used",
  "㦃": "rarely-used",
  "㦅": "rarely-used",
  "㦆": "rarely-used",
  "㦇": "rarely-used",
  "㦊": "rarely-used",
  "㦋": "rarely-used",
  "㦌": "rarely-used",
  "㦎": "rarely-used",
  "㦏": "rarely-used",
  "㦐": "rarely-used",
  "㦑": "rarely-used",
  "㦓": "rarely-used",
  "㦕": "rarely-used",
  "㦗": "rarely-used",
  "㦘": "rarely-used",
  "㦚": "rarely-used",
  "㦛": "rarely-used",
  "㦜": "rarely-used",
  "㦝": "rarely-used",
  "㦟": "rarely-used",
  "㦡": "rarely-used",
  "㦢": "rarely-used",
  "㦣": "rarely-used",
  "㦥": "rarely-used",
  "㦦": "rarely-used",
  "㦩": "rarely-used",
  "㦪": "rarely-used",
  "㦫": "rarely-used",
  "㦬": "rarely-used",
  "㦭": "rarely-used",
  "㦰": "rarely-used",
  "㦴": "rarely-used",
  "㦵": "rarely-used",
  "㦶": "rarely-used",
  "㦹": "rarely-used",
  "㦺": "rarely-used",
  "㦻": "rarely-used",
  "㦼": "rarely-used",
  "㦿": "rarely-used",
  "㧀": "rarely-used",
  "㧁": "rarely-used",
  "㧃": "rarely-used",
  "㧄": "rarely-used",
  "㧅": "rarely-used",
  "㧆": "rarely-used",
  "㧇": "rarely-used",
  "㧉": "rarely-used",
  "㧊": "rarely-used",
  "㧋": "rarely-used",
  "㧌": "rarely-used",
  "㧎": "rarely-used",
  "㧒": "rarely-used",
  "㧓": "rarely-used",
  "㧔": "rarely-used",
  "㧕": "rarely-used",
  "㧗": "rarely-used",
  "㧘": "rarely-used",
  "㧙": "rarely-used",
  "㧚": "rarely-used",
  "㧡": "rarely-used",
  "㧢": "rarely-used",
  "㧣": "rarely-used",
  "㧤": "rarely-used",
  "㧥": "rarely-used",
  "㧦": "rarely-used",
  "㧩": "rarely-used",
  "㧪": "rarely-used",
  "㧫": "rarely-used",
  "㧬": "rarely-used",
  "㧭": "rarely-used",
  "㧮": "rarely-used",
  "㧯": "rarely-used",
  "㧲": "rarely-used",
  "㧳": "rarely-used",
  "㧴": "rarely-used",
  "㧶": "rarely-used",
  "㧷": "rarely-used",
  "㧸": "rarely-used",
  "㧹": "rarely-used",
  "㧺": "rarely-used",
  "㧻": "rarely-used",
  "㨁": "rarely-used",
  "㨂": "rarely-used",
  "㨃": "rarely-used",
  "㨄": "rarely-used",
  "㨅": "rarely-used",
  "㨆": "rarely-used",
  "㨊": "rarely-used",
  "㨋": "rarely-used",
  "㨌": "rarely-used",
  "㨍": "rarely-used",
  "㨎": "rarely-used",
  "㨏": "rarely-used",
  "㨐": "rarely-used",
  "㨑": "rarely-used",
  "㨒": "rarely-used",
  "㨔": "rarely-used",
  "㨖": "rarely-used",
  "㨙": "rarely-used",
  "㨚": "rarely-used",
  "㨛": "rarely-used",
  "㨜": "rarely-used",
  "㨝": "rarely-used",
  "㨞": "rarely-used",
  "㨟": "rarely-used",
  "㨠": "rarely-used",
  "㨡": "rarely-used",
  "㨢": "rarely-used",
  "㨥": "rarely-used",
  "㨧": "rarely-used",
  "㨪": "rarely-used",
  "㨭": "rarely-used",
  "㨮": "rarely-used",
  "㨰": "rarely-used",
  "㨳": "rarely-used",
  "㨴": "rarely-used",
  "㨷": "rarely-used",
  "㨸": "rarely-used",
  "㨹": "rarely-used",
  "㨺": "rarely-used",
  "㨻": "rarely-used",
  "㨾": "rarely-used",
  "㩄": "rarely-used",
  "㩆": "rarely-used",
  "㩇": "rarely-used",
  "㩈": "rarely-used",
  "㩊": "rarely-used",
  "㩋": "rarely-used",
  "㩌": "rarely-used",
  "㩍": "rarely-used",
  "㩐": "rarely-used",
  "㩖": "rarely-used",
  "㩚": "rarely-used",
  "㩝": "rarely-used",
  "㩠": "rarely-used",
  "㩡": "rarely-used",
  "㩢": "rarely-used",
  "㩣": "rarely-used",
  "㩤": "rarely-used",
  "㩧": "rarely-used",
  "㩨": "rarely-used",
  "㩩": "rarely-used",
  "㩯": "rarely-used",
  "㩱": "rarely-used",
  "㩲": "rarely-used",
  "㩳": "rarely-used",
  "㩴": "rarely-used",
  "㩵": "rarely-used",
  "㩶": "rarely-used",
  "㩷": "rarely-used",
  "㩹": "rarely-used",
  "㩻": "rarely-used",
  "㩼": "rarely-used",
  "㩽": "rarely-used",
  "㩾": "rarely-used",
  "㩿": "rarely-used",
  "㪀": "rarely-used",
  "㪁": "rarely-used",
  "㪄": "rarely-used",
  "㪇": "rarely-used",
  "㪈": "rarely-used",
  "㪋": "rarely-used",
  "㪌": "rarely-used",
  "㪎": "rarely-used",
  "㪏": "rarely-used",
  "㪑": "rarely-used",
  "㪒": "rarely-used",
  "㪓": "rarely-used",
  "㪕": "rarely-used",
  "㪖": "rarely-used",
  "㪜": "rarely-used",
  "㪝": "rarely-used",
  "㪞": "rarely-used",
  "㪠": "rarely-used",
  "㪡": "rarely-used",
  "㪢": "rarely-used",
  "㪤": "rarely-used",
  "㪥": "rarely-used",
  "㪦": "rarely-used",
  "㪨": "rarely-used",
  "㪩": "rarely-used",
  "㪬": "rarely-used",
  "㪭": "rarely-used",
  "㪮": "rarely-used",
  "㪱": "rarely-used",
  "㪴": "rarely-used",
  "㪵": "rarely-used",
  "㪹": "rarely-used",
  "㪺": "rarely-used",
  "㪻": "rarely-used",
  "㪼": "rarely-used",
  "㪾": "rarely-used",
  "㫂": "rarely-used",
  "㫃": "rarely-used",
  "㫊": "rarely-used",
  "㫍": "rarely-used",
  "㫎": "rarely-used",
  "㫏": "rarely-used",
  "㫐": "rarely-used",
  "㫒": "rarely-used",
  "㫓": "rarely-used",
  "㫗": "rarely-used",
  "㫘": "rarely-used",
  "㫙": "rarely-used",
  "㫛": "rarely-used",
  "㫜": "rarely-used",
  "㫝": "rarely-used",
  "㫞": "rarely-used",
  "㫟": "rarely-used",
  "㫠": "rarely-used",
  "㫰": "rarely-used",
  "㫱": "rarely-used",
  "㫲": "rarely-used",
  "㫵": "rarely-used",
  "㫶": "rarely-used",
  "㫷": "rarely-used",
  "㫸": "rarely-used",
  "㫹": "rarely-used",
  "㫻": "rarely-used",
  "㫽": "rarely-used",
  "㬂": "rarely-used",
  "㬃": "rarely-used",
  "㬇": "rarely-used",
  "㬈": "rarely-used",
  "㬊": "rarely-used",
  "㬋": "rarely-used",
  "㬎": "rarely-used",
  "㬏": "rarely-used",
  "㬒": "rarely-used",
  "㬓": "rarely-used",
  "㬔": "rarely-used",
  "㬗": "rarely-used",
  "㬘": "rarely-used",
  "㬚": "rarely-used",
  "㬛": "rarely-used",
  "㬣": "rarely-used",
  "㬦": "rarely-used",
  "㬬": "rarely-used",
  "㬮": "rarely-used",
  "㬯": "rarely-used",
  "㬲": "rarely-used",
  "㬳": "rarely-used",
  "㬴": "rarely-used",
  "㬵": "rarely-used",
  "㬸": "rarely-used",
  "㬹": "rarely-used",
  "㬻": "rarely-used",
  "㬼": "rarely-used",
  "㬿": "rarely-used",
  "㭁": "rarely-used",
  "㭂": "rarely-used",
  "㭄": "rarely-used",
  "㭇": "rarely-used",
  "㭈": "rarely-used",
  "㭉": "rarely-used",
  "㭌": "rarely-used",
  "㭑": "rarely-used",
  "㭒": "rarely-used",
  "㭔": "rarely-used",
  "㭕": "rarely-used",
  "㭘": "rarely-used",
  "㭙": "rarely-used",
  "㭚": "rarely-used",
  "㭛": "rarely-used",
  "㭜": "rarely-used",
  "㭝": "rarely-used",
  "㭞": "rarely-used",
  "㭠": "rarely-used",
  "㭡": "rarely-used",
  "㭢": "rarely-used",
  "㭩": "rarely-used",
  "㭪": "rarely-used",
  "㭫": "rarely-used",
  "㭬": "rarely-used",
  "㭭": "rarely-used",
  "㭯": "rarely-used",
  "㭰": "rarely-used",
  "㭸": "rarely-used",
  "㭹": "rarely-used",
  "㭺": "rarely-used",
  "㭼": "rarely-used",
  "㭽": "rarely-used",
  "㭾": "rarely-used",
  "㭿": "rarely-used",
  "㮀": "rarely-used",
  "㮁": "rarely-used",
  "㮂": "rarely-used",
  "㮃": "rarely-used",
  "㮅": "rarely-used",
  "㮇": "rarely-used",
  "㮈": "rarely-used",
  "㮏": "rarely-used",
  "㮐": "rarely-used",
  "㮑": "rarely-used",
  "㮔": "rarely-used",
  "㮕": "rarely-used",
  "㮖": "rarely-used",
  "㮗": "rarely-used",
  "㮘": "rarely-used",
  "㮙": "rarely-used",
  "㮛": "rarely-used",
  "㮜": "rarely-used",
  "㮝": "rarely-used",
  "㮟": "rarely-used",
  "㮣": "less-than-common",
  "㮥": "rarely-used",
  "㮦": "rarely-used",
  "㮧": "rarely-used",
  "㮨": "rarely-used",
  "㮩": "rarely-used",
  "㮪": "rarely-used",
  "㮫": "rarely-used",
  "㮬": "rarely-used",
  "㮭": "rarely-used",
  "㮯": "rarely-used",
  "㮰": "rarely-used",
  "㮱": "rarely-used",
  "㮲": "rarely-used",
  "㮴": "rarely-used",
  "㮶": "rarely-used",
  "㮷": "rarely-used",
  "㮹": "rarely-used",
  "㮿": "rarely-used",
  "㯀": "rarely-used",
  "㯁": "rarely-used",
  "㯂": "rarely-used",
  "㯃": "rarely-used",
  "㯄": "rarely-used",
  "㯅": "rarely-used",
  "㯆": "rarely-used",
  "㯊": "rarely-used",
  "㯋": "rarely-used",
  "㯎": "rarely-used",
  "㯔": "rarely-used",
  "㯕": "rarely-used",
  "㯗": "rarely-used",
  "㯘": "rarely-used",
  "㯙": "rarely-used",
  "㯛": "rarely-used",
  "㯝": "rarely-used",
  "㯞": "rarely-used",
  "㯠": "rarely-used",
  "㯡": "rarely-used",
  "㯢": "rarely-used",
  "㯤": "rarely-used",
  "㯥": "rarely-used",
  "㯫": "rarely-used",
  "㯬": "rarely-used",
  "㯮": "rarely-used",
  "㯯": "rarely-used",
  "㯱": "rarely-used",
  "㯲": "rarely-used",
  "㯷": "rarely-used",
  "㯸": "rarely-used",
  "㯺": "rarely-used",
  "㯻": "rarely-used",
  "㯾": "rarely-used",
  "㯿": "rarely-used",
  "㰀": "rarely-used",
  "㰁": "rarely-used",
  "㰂": "rarely-used",
  "㰃": "rarely-used",
  "㰈": "rarely-used",
  "㰊": "rarely-used",
  "㰋": "rarely-used",
  "㰌": "rarely-used",
  "㰑": "rarely-used",
  "㰔": "rarely-used",
  "㰘": "rarely-used",
  "㰚": "rarely-used",
  "㰛": "rarely-used",
  "㰝": "rarely-used",
  "㰟": "rarely-used",
  "㰠": "rarely-used",
  "㰡": "rarely-used",
  "㰢": "rarely-used",
  "㰣": "rarely-used",
  "㰤": "rarely-used",
  "㰥": "rarely-used",
  "㰧": "rarely-used",
  "㰨": "rarely-used",
  "㰩": "rarely-used",
  "㰪": "rarely-used",
  "㰫": "rarely-used",
  "㰬": "rarely-used",
  "㰭": "rarely-used",
  "㰮": "rarely-used",
  "㰯": "rarely-used",
  "㰰": "rarely-used",
  "㰲": "rarely-used",
  "㰳": "rarely-used",
  "㰴": "rarely-used",
  "㰵": "rarely-used",
  "㰶": "rarely-used",
  "㰹": "rarely-used",
  "㰺": "rarely-used",
  "㰻": "rarely-used",
  "㰼": "rarely-used",
  "㰽": "rarely-used",
  "㰾": "rarely-used",
  "㰿": "rarely-used",
  "㱁": "rarely-used",
  "㱂": "rarely-used",
  "㱄": "rarely-used",
  "㱆": "rarely-used",
  "㱇": "rarely-used",
  "㱈": "rarely-used",
  "㱊": "rarely-used",
  "㱌": "rarely-used",
  "㱍": "rarely-used",
  "㱎": "rarely-used",
  "㱖": "rarely-used",
  "㱗": "rarely-used",
  "㱙": "rarely-used",
  "㱚": "rarely-used",
  "㱛": "rarely-used",
  "㱜": "rarely-used",
  "㱞": "rarely-used",
  "㱟": "rarely-used",
  "㱠": "rarely-used",
  "㱡": "rarely-used",
  "㱢": "rarely-used",
  "㱣": "rarely-used",
  "㱤": "rarely-used",
  "㱥": "rarely-used",
  "㱦": "rarely-used",
  "㱧": "rarely-used",
  "㱫": "rarely-used",
  "㱬": "rarely-used",
  "㱯": "rarely-used",
  "㱰": "rarely-used",
  "㱱": "rarely-used",
  "㱲": "rarely-used",
  "㱳": "rarely-used",
  "㱴": "rarely-used",
  "㱵": "rarely-used",
  "㱶": "rarely-used",
  "㱸": "rarely-used",
  "㱹": "rarely-used",
  "㱺": "rarely-used",
  "㱻": "rarely-used",
  "㱼": "rarely-used",
  "㱽": "rarely-used",
  "㱾": "rarely-used",
  "㲀": "rarely-used",
  "㲁": "rarely-used",
  "㲂": "rarely-used",
  "㲃": "rarely-used",
  "㲅": "rarely-used",
  "㲆": "rarely-used",
  "㲉": "rarely-used",
  "㲋": "rarely-used",
  "㲌": "rarely-used",
  "㲍": "rarely-used",
  "㲏": "rarely-used",
  "㲓": "rarely-used",
  "㲔": "rarely-used",
  "㲕": "rarely-used",
  "㲖": "rarely-used",
  "㲗": "rarely-used",
  "㲙": "rarely-used",
  "㲚": "rarely-used",
  "㲛": "rarely-used",
  "㲝": "rarely-used",
  "㲞": "rarely-used",
  "㲟": "rarely-used",
  "㲡": "rarely-used",
  "㲢": "rarely-used",
  "㲤": "rarely-used",
  "㲥": "rarely-used",
  "㲦": "rarely-used",
  "㲧": "rarely-used",
  "㲪": "rarely-used",
  "㲫": "rarely-used",
  "㲬": "rarely-used",
  "㲯": "rarely-used",
  "㲰": "rarely-used",
  "㲲": "rarely-used",
  "㲳": "rarely-used",
  "㲴": "rarely-used",
  "㲸": "rarely-used",
  "㲹": "rarely-used",
  "㲺": "rarely-used",
  "㲼": "rarely-used",
  "㲽": "rarely-used",
  "㳀": "rarely-used",
  "㳁": "rarely-used",
  "㳆": "rarely-used",
  "㳋": "rarely-used",
  "㳌": "rarely-used",
  "㳍": "rarely-used",
  "㳎": "rarely-used",
  "㳏": "rarely-used",
  "㳐": "rarely-used",
  "㳖": "rarely-used",
  "㳗": "rarely-used",
  "㳘": "rarely-used",
  "㳚": "rarely-used",
  "㳛": "rarely-used",
  "㳜": "rarely-used",
  "㳞": "rarely-used",
  "㳥": "rarely-used",
  "㳦": "rarely-used",
  "㳧": "rarely-used",
  "㳩": "rarely-used",
  "㳪": "rarely-used",
  "㳫": "rarely-used",
  "㳳": "rarely-used",
  "㳴": "rarely-used",
  "㳵": "rarely-used",
  "㳶": "rarely-used",
  "㳷": "rarely-used",
  "㳸": "rarely-used",
  "㳹": "rarely-used",
  "㳻": "rarely-used",
  "㳼": "rarely-used",
  "㳾": "rarely-used",
  "㴀": "rarely-used",
  "㴁": "rarely-used",
  "㴂": "rarely-used",
  "㴄": "rarely-used",
  "㴈": "rarely-used",
  "㴏": "rarely-used",
  "㴐": "rarely-used",
  "㴒": "rarely-used",
  "㴓": "rarely-used",
  "㴔": "rarely-used",
  "㴗": "rarely-used",
  "㴘": "rarely-used",
  "㴙": "rarely-used",
  "㴚": "rarely-used",
  "㴛": "rarely-used",
  "㴝": "rarely-used",
  "㴥": "rarely-used",
  "㴦": "rarely-used",
  "㴧": "rarely-used",
  "㴨": "rarely-used",
  "㴪": "rarely-used",
  "㴫": "rarely-used",
  "㴬": "rarely-used",
  "㴭": "rarely-used",
  "㴯": "rarely-used",
  "㴰": "rarely-used",
  "㴲": "rarely-used",
  "㴳": "rarely-used",
  "㴵": "rarely-used",
  "㴶": "rarely-used",
  "㴷": "rarely-used",
  "㴸": "rarely-used",
  "㴼": "rarely-used",
  "㴽": "rarely-used",
  "㵀": "rarely-used",
  "㵂": "rarely-used",
  "㵃": "rarely-used",
  "㵅": "rarely-used",
  "㵊": "rarely-used",
  "㵋": "rarely-used",
  "㵌": "rarely-used",
  "㵍": "rarely-used",
  "㵐": "rarely-used",
  "㵑": "rarely-used",
  "㵒": "rarely-used",
  "㵔": "rarely-used",
  "㵖": "rarely-used",
  "㵗": "rarely-used",
  "㵘": "rarely-used",
  "㵝": "rarely-used",
  "㵞": "rarely-used",
  "㵟": "rarely-used",
  "㵠": "rarely-used",
  "㵡": "rarely-used",
  "㵢": "rarely-used",
  "㵣": "rarely-used",
  "㵤": "rarely-used",
  "㵧": "rarely-used",
  "㵨": "rarely-used",
  "㵩": "rarely-used",
  "㵪": "rarely-used",
  "㵫": "rarely-used",
  "㵬": "rarely-used",
  "㵭": "rarely-used",
  "㵮": "rarely-used",
  "㵯": "rarely-used",
  "㵴": "rarely-used",
  "㵵": "rarely-used",
  "㵶": "rarely-used",
  "㵷": "rarely-used",
  "㵹": "rarely-used",
  "㵺": "rarely-used",
  "㵻": "rarely-used",
  "㵽": "rarely-used",
  "㵾": "rarely-used",
  "㵿": "rarely-used",
  "㶀": "rarely-used",
  "㶄": "rarely-used",
  "㶆": "rarely-used",
  "㶇": "rarely-used",
  "㶌": "rarely-used",
  "㶍": "rarely-used",
  "㶒": "rarely-used",
  "㶓": "rarely-used",
  "㶔": "rarely-used",
  "㶕": "rarely-used",
  "㶖": "rarely-used",
  "㶗": "rarely-used",
  "㶘": "rarely-used",
  "㶛": "rarely-used",
  "㶞": "rarely-used",
  "㶟": "rarely-used",
  "㶠": "rarely-used",
  "㶣": "rarely-used",
  "㶦": "rarely-used",
  "㶧": "rarely-used",
  "㶬": "rarely-used",
  "㶮": "rarely-used",
  "㶯": "rarely-used",
  "㶰": "rarely-used",
  "㶲": "rarely-used",
  "㶴": "rarely-used",
  "㶹": "rarely-used",
  "㶺": "rarely-used",
  "㶼": "rarely-used",
  "㶿": "rarely-used",
  "㷂": "rarely-used",
  "㷃": "rarely-used",
  "㷄": "rarely-used",
  "㷅": "rarely-used",
  "㷆": "rarely-used",
  "㷇": "rarely-used",
  "㷈": "rarely-used",
  "㷋": "rarely-used",
  "㷍": "rarely-used",
  "㷏": "rarely-used",
  "㷒": "rarely-used",
  "㷕": "rarely-used",
  "㷘": "rarely-used",
  "㷟": "rarely-used",
  "㷡": "rarely-used",
  "㷣": "rarely-used",
  "㷤": "rarely-used",
  "㷫": "rarely-used",
  "㷬": "rarely-used",
  "㷮": "rarely-used",
  "㷯": "rarely-used",
  "㷰": "rarely-used",
  "㷳": "rarely-used",
  "㷴": "rarely-used",
  "㷵": "rarely-used",
  "㷹": "rarely-used",
  "㷾": "rarely-used",
  "㷿": "rarely-used",
  "㸅": "rarely-used",
  "㸊": "rarely-used",
  "㸌": "rarely-used",
  "㸍": "rarely-used",
  "㸎": "rarely-used",
  "㸑": "rarely-used",
  "㸒": "rarely-used",
  "㸓": "rarely-used",
  "㸖": "rarely-used",
  "㸗": "rarely-used",
  "㸙": "rarely-used",
  "㸚": "rarely-used",
  "㸛": "rarely-used",
  "㸜": "rarely-used",
  "㸝": "rarely-used",
  "㸞": "rarely-used",
  "㸟": "rarely-used",
  "㸡": "rarely-used",
  "㸢": "rarely-used",
  "㸨": "rarely-used",
  "㸩": "rarely-used",
  "㸪": "rarely-used",
  "㸭": "rarely-used",
  "㸮": "rarely-used",
  "㸯": "rarely-used",
  "㸰": "rarely-used",
  "㸲": "rarely-used",
  "㸳": "rarely-used",
  "㸵": "rarely-used",
  "㸶": "rarely-used",
  "㸸": "rarely-used",
  "㸹": "rarely-used",
  "㸺": "rarely-used",
  "㸻": "rarely-used",
  "㹁": "rarely-used",
  "㹂": "rarely-used",
  "㹃": "rarely-used",
  "㹄": "rarely-used",
  "㹆": "rarely-used",
  "㹇": "rarely-used",
  "㹉": "rarely-used",
  "㹊": "rarely-used",
  "㹋": "rarely-used",
  "㹌": "rarely-used",
  "㹍": "rarely-used",
  "㹎": "rarely-used",
  "㹏": "rarely-used",
  "㹐": "rarely-used",
  "㹑": "rarely-used",
  "㹒": "rarely-used",
  "㹓": "rarely-used",
  "㹔": "rarely-used",
  "㹕": "rarely-used",
  "㹗": "rarely-used",
  "㹘": "rarely-used",
  "㹙": "rarely-used",
  "㹛": "rarely-used",
  "㹜": "rarely-used",
  "㹝": "rarely-used",
  "㹟": "rarely-used",
  "㹣": "rarely-used",
  "㹥": "rarely-used",
  "㹦": "rarely-used",
  "㹫": "rarely-used",
  "㹱": "rarely-used",
  "㹲": "rarely-used",
  "㹳": "rarely-used",
  "㹴": "rarely-used",
  "㹵": "rarely-used",
  "㹶": "rarely-used",
  "㹹": "rarely-used",
  "㹺": "rarely-used",
  "㹼": "rarely-used",
  "㹽": "rarely-used",
  "㹾": "rarely-used",
  "㹿": "rarely-used",
  "㺁": "rarely-used",
  "㺂": "rarely-used",
  "㺇": "rarely-used",
  "㺈": "rarely-used",
  "㺉": "rarely-used",
  "㺊": "rarely-used",
  "㺋": "rarely-used",
  "㺌": "rarely-used",
  "㺐": "rarely-used",
  "㺑": "rarely-used",
  "㺒": "rarely-used",
  "㺓": "rarely-used",
  "㺔": "rarely-used",
  "㺕": "rarely-used",
  "㺖": "rarely-used",
  "㺗": "rarely-used",
  "㺘": "rarely-used",
  "㺛": "rarely-used",
  "㺜": "rarely-used",
  "㺝": "rarely-used",
  "㺞": "rarely-used",
  "㺟": "rarely-used",
  "㺠": "rarely-used",
  "㺡": "rarely-used",
  "㺣": "rarely-used",
  "㺤": "rarely-used",
  "㺥": "rarely-used",
  "㺦": "rarely-used",
  "㺧": "rarely-used",
  "㺨": "rarely-used",
  "㺩": "rarely-used",
  "㺭": "rarely-used",
  "㺱": "rarely-used",
  "㺴": "rarely-used",
  "㺸": "rarely-used",
  "㺹": "rarely-used",
  "㺿": "rarely-used",
  "㻂": "rarely-used",
  "㻃": "rarely-used",
  "㻈": "rarely-used",
  "㻉": "rarely-used",
  "㻌": "rarely-used",
  "㻍": "rarely-used",
  "㻑": "rarely-used",
  "㻒": "rarely-used",
  "㻓": "rarely-used",
  "㻔": "rarely-used",
  "㻕": "rarely-used",
  "㻖": "rarely-used",
  "㻝": "rarely-used",
  "㻞": "rarely-used",
  "㻟": "rarely-used",
  "㻠": "rarely-used",
  "㻯": "rarely-used",
  "㻱": "rarely-used",
  "㻲": "rarely-used",
  "㻵": "rarely-used",
  "㻶": "rarely-used",
  "㻷": "rarely-used",
  "㻸": "rarely-used",
  "㻹": "rarely-used",
  "㻽": "rarely-used",
  "㻾": "rarely-used",
  "㻿": "rarely-used",
  "㼉": "rarely-used",
  "㼊": "rarely-used",
  "㼋": "rarely-used",
  "㼌": "rarely-used",
  "㼍": "rarely-used",
  "㼎": "rarely-used",
  "㼏": "rarely-used",
  "㼐": "rarely-used",
  "㼑": "rarely-used",
  "㼒": "rarely-used",
  "㼓": "rarely-used",
  "㼔": "rarely-used",
  "㼕": "rarely-used",
  "㼖": "rarely-used",
  "㼗": "rarely-used",
  "㼘": "rarely-used",
  "㼞": "rarely-used",
  "㼟": "rarely-used",
  "㼠": "rarely-used",
  "㼡": "rarely-used",
  "㼢": "rarely-used",
  "㼣": "rarely-used",
  "㼤": "rarely-used",
  "㼥": "rarely-used",
  "㼦": "rarely-used",
  "㼧": "rarely-used",
  "㼨": "rarely-used",
  "㼩": "rarely-used",
  "㼪": "rarely-used",
  "㼫": "rarely-used",
  "㼬": "rarely-used",
  "㼭": "rarely-used",
  "㼮": "rarely-used",
  "㼯": "rarely-used",
  "㼰": "rarely-used",
  "㼱": "rarely-used",
  "㼲": "rarely-used",
  "㼳": "rarely-used",
  "㼴": "rarely-used",
  "㼵": "rarely-used",
  "㼶": "rarely-used",
  "㼷": "rarely-used",
  "㼸": "rarely-used",
  "㼹": "rarely-used",
  "㼺": "rarely-used",
  "㼻": "rarely-used",
  "㼽": "rarely-used",
  "㼾": "rarely-used",
  "㼿": "rarely-used",
  "㽀": "rarely-used",
  "㽂": "rarely-used",
  "㽃": "rarely-used",
  "㽄": "rarely-used",
  "㽆": "rarely-used",
  "㽇": "rarely-used",
  "㽈": "rarely-used",
  "㽉": "rarely-used",
  "㽊": "rarely-used",
  "㽋": "rarely-used",
  "㽌": "rarely-used",
  "㽎": "rarely-used",
  "㽑": "rarely-used",
  "㽕": "rarely-used",
  "㽘": "rarely-used",
  "㽚": "rarely-used",
  "㽛": "rarely-used",
  "㽝": "rarely-used",
  "㽟": "rarely-used",
  "㽠": "rarely-used",
  "㽡": "rarely-used",
  "㽢": "rarely-used",
  "㽤": "rarely-used",
  "㽥": "rarely-used",
  "㽦": "rarely-used",
  "㽧": "rarely-used",
  "㽨": "rarely-used",
  "㽩": "rarely-used",
  "㽪": "rarely-used",
  "㽫": "rarely-used",
  "㽬": "rarely-used",
  "㽰": "rarely-used",
  "㽱": "rarely-used",
  "㽴": "rarely-used",
  "㽷": "rarely-used",
  "㽹": "rarely-used",
  "㽺": "rarely-used",
  "㽾": "rarely-used",
  "㽿": "rarely-used",
  "㾀": "rarely-used",
  "㾁": "rarely-used",
  "㾂": "rarely-used",
  "㾃": "rarely-used",
  "㾅": "rarely-used",
  "㾇": "rarely-used",
  "㾈": "rarely-used",
  "㾉": "rarely-used",
  "㾊": "rarely-used",
  "㾋": "rarely-used",
  "㾍": "rarely-used",
  "㾎": "rarely-used",
  "㾏": "rarely-used",
  "㾑": "rarely-used",
  "㾒": "rarely-used",
  "㾓": "rarely-used",
  "㾔": "rarely-used",
  "㾕": "rarely-used",
  "㾖": "rarely-used",
  "㾘": "rarely-used",
  "㾙": "rarely-used",
  "㾚": "rarely-used",
  "㾛": "rarely-used",
  "㾜": "rarely-used",
  "㾝": "rarely-used",
  "㾞": "rarely-used",
  "㾟": "rarely-used",
  "㾠": "rarely-used",
  "㾢": "rarely-used",
  "㾣": "rarely-used",
  "㾤": "rarely-used",
  "㾥": "rarely-used",
  "㾦": "rarely-used",
  "㾧": "rarely-used",
  "㾨": "rarely-used",
  "㾩": "rarely-used",
  "㾪": "rarely-used",
  "㾫": "rarely-used",
  "㾭": "rarely-used",
  "㾯": "rarely-used",
  "㾰": "rarely-used",
  "㾷": "rarely-used",
  "㾸": "rarely-used",
  "㾹": "rarely-used",
  "㾺": "rarely-used",
  "㾻": "rarely-used",
  "㾼": "rarely-used",
  "㾾": "rarely-used",
  "㾿": "rarely-used",
  "㿁": "rarely-used",
  "㿃": "rarely-used",
  "㿄": "rarely-used",
  "㿆": "rarely-used",
  "㿇": "rarely-used",
  "㿊": "rarely-used",
  "㿌": "rarely-used",
  "㿎": "rarely-used",
  "㿑": "rarely-used",
  "㿒": "rarely-used",
  "㿓": "rarely-used",
  "㿕": "rarely-used",
  "㿖": "rarely-used",
  "㿘": "rarely-used",
  "㿙": "rarely-used",
  "㿚": "rarely-used",
  "㿛": "rarely-used",
  "㿟": "rarely-used",
  "㿣": "rarely-used",
  "㿤": "rarely-used",
  "㿥": "rarely-used",
  "㿦": "rarely-used",
  "㿩": "rarely-used",
  "㿪": "rarely-used",
  "㿫": "rarely-used",
  "㿬": "rarely-used",
  "㿭": "rarely-used",
  "㿮": "rarely-used",
  "㿯": "rarely-used",
  "㿰": "rarely-used",
  "㿱": "rarely-used",
  "㿳": "rarely-used",
  "㿴": "rarely-used",
  "㿷": "rarely-used",
  "㿸": "rarely-used",
  "㿹": "rarely-used",
  "㿺": "rarely-used",
  "㿻": "rarely-used",
  "㿼": "rarely-used",
  "㿽": "rarely-used",
  "㿾": "rarely-used",
  "㿿": "rarely-used",
  "䀀": "rarely-used",
  "䀁": "rarely-used",
  "䀂": "rarely-used",
  "䀃": "rarely-used",
  "䀄": "rarely-used",
  "䀅": "rarely-used",
  "䀇": "rarely-used",
  "䀈": "rarely-used",
  "䀉": "rarely-used",
  "䀊": "rarely-used",
  "䀍": "rarely-used",
  "䀐": "rarely-used",
  "䀒": "rarely-used",
  "䀓": "rarely-used",
  "䀔": "rarely-used",
  "䀕": "rarely-used",
  "䀖": "rarely-used",
  "䀗": "rarely-used",
  "䀘": "rarely-used",
  "䀙": "rarely-used",
  "䀚": "rarely-used",
  "䀛": "rarely-used",
  "䀠": "rarely-used",
  "䀢": "rarely-used",
  "䀣": "rarely-used",
  "䀤": "rarely-used",
  "䀧": "rarely-used",
  "䀨": "rarely-used",
  "䀩": "rarely-used",
  "䀫": "rarely-used",
  "䀬": "rarely-used",
  "䀭": "rarely-used",
  "䀮": "rarely-used",
  "䀯": "rarely-used",
  "䀰": "rarely-used",
  "䀱": "rarely-used",
  "䀲": "rarely-used",
  "䀴": "rarely-used",
  "䀵": "rarely-used",
  "䀶": "rarely-used",
  "䀷": "rarely-used",
  "䀸": "rarely-used",
  "䀺": "rarely-used",
  "䀻": "rarely-used",
  "䀼": "rarely-used",
  "䀽": "rarely-used",
  "䀾": "rarely-used",
  "䀿": "rarely-used",
  "䁂": "rarely-used",
  "䁃": "rarely-used",
  "䁄": "rarely-used",
  "䁅": "rarely-used",
  "䁆": "rarely-used",
  "䁇": "rarely-used",
  "䁈": "rarely-used",
  "䁊": "rarely-used",
  "䁋": "rarely-used",
  "䁌": "rarely-used",
  "䁍": "rarely-used",
  "䁎": "rarely-used",
  "䁏": "rarely-used",
  "䁐": "rarely-used",
  "䁒": "rarely-used",
  "䁓": "rarely-used",
  "䁔": "rarely-used",
  "䁕": "rarely-used",
  "䁗": "rarely-used",
  "䁘": "rarely-used",
  "䁙": "rarely-used",
  "䁚": "rarely-used",
  "䁛": "rarely-used",
  "䁜": "rarely-used",
  "䁝": "rarely-used",
  "䁟": "rarely-used",
  "䁠": "rarely-used",
  "䁢": "rarely-used",
  "䁣": "rarely-used",
  "䁤": "rarely-used",
  "䁥": "rarely-used",
  "䁧": "rarely-used",
  "䁨": "rarely-used",
  "䁩": "rarely-used",
  "䁫": "rarely-used",
  "䁬": "rarely-used",
  "䁭": "rarely-used",
  "䁮": "rarely-used",
  "䁯": "rarely-used",
  "䁰": "rarely-used",
  "䁱": "rarely-used",
  "䁲": "rarely-used",
  "䁳": "rarely-used",
  "䁴": "rarely-used",
  "䁵": "rarely-used",
  "䁶": "rarely-used",
  "䁷": "rarely-used",
  "䁸": "rarely-used",
  "䁺": "rarely-used",
  "䁻": "rarely-used",
  "䁼": "rarely-used",
  "䁽": "rarely-used",
  "䁾": "rarely-used",
  "䁿": "rarely-used",
  "䂀": "rarely-used",
  "䂁": "rarely-used",
  "䂂": "rarely-used",
  "䂃": "rarely-used",
  "䂅": "rarely-used",
  "䂆": "rarely-used",
  "䂇": "rarely-used",
  "䂈": "rarely-used",
  "䂉": "rarely-used",
  "䂊": "rarely-used",
  "䂍": "rarely-used",
  "䂎": "rarely-used",
  "䂏": "rarely-used",
  "䂐": "rarely-used",
  "䂑": "rarely-used",
  "䂒": "rarely-used",
  "䂔": "rarely-used",
  "䂕": "rarely-used",
  "䂗": "rarely-used",
  "䂘": "rarely-used",
  "䂚": "rarely-used",
  "䂛": "rarely-used",
  "䂜": "rarely-used",
  "䂟": "rarely-used",
  "䂠": "rarely-used",
  "䂢": "rarely-used",
  "䂣": "rarely-used",
  "䂤": "rarely-used",
  "䂦": "rarely-used",
  "䂩": "rarely-used",
  "䂫": "rarely-used",
  "䂬": "rarely-used",
  "䂭": "rarely-used",
  "䂮": "rarely-used",
  "䂰": "rarely-used",
  "䂱": "rarely-used",
  "䂳": "rarely-used",
  "䂴": "rarely-used",
  "䂶": "rarely-used",
  "䂷": "rarely-used",
  "䂸": "rarely-used",
  "䂹": "rarely-used",
  "䂺": "rarely-used",
  "䂻": "rarely-used",
  "䂼": "rarely-used",
  "䂽": "rarely-used",
  "䂾": "rarely-used",
  "䂿": "rarely-used",
  "䃀": "rarely-used",
  "䃁": "rarely-used",
  "䃂": "rarely-used",
  "䃇": "rarely-used",
  "䃈": "rarely-used",
  "䃊": "rarely-used",
  "䃋": "rarely-used",
  "䃌": "rarely-used",
  "䃎": "rarely-used",
  "䃏": "rarely-used",
  "䃑": "rarely-used",
  "䃒": "rarely-used",
  "䃓": "rarely-used",
  "䃔": "rarely-used",
  "䃕": "rarely-used",
  "䃗": "rarely-used",
  "䃙": "rarely-used",
  "䃚": "rarely-used",
  "䃛": "rarely-used",
  "䃝": "rarely-used",
  "䃞": "rarely-used",
  "䃠": "rarely-used",
  "䃡": "rarely-used",
  "䃤": "rarely-used",
  "䃥": "rarely-used",
  "䃦": "rarely-used",
  "䃧": "rarely-used",
  "䃪": "rarely-used",
  "䃫": "rarely-used",
  "䃭": "rarely-used",
  "䃮": "rarely-used",
  "䃰": "rarely-used",
  "䃳": "rarely-used",
  "䃴": "rarely-used",
  "䃵": "rarely-used",
  "䃶": "rarely-used",
  "䃷": "rarely-used",
  "䃸": "rarely-used",
  "䃹": "rarely-used",
  "䃽": "rarely-used",
  "䃾": "rarely-used",
  "䃿": "rarely-used",
  "䄁": "rarely-used",
  "䄄": "rarely-used",
  "䄅": "rarely-used",
  "䄆": "rarely-used",
  "䄇": "rarely-used",
  "䄈": "rarely-used",
  "䄉": "rarely-used",
  "䄋": "rarely-used",
  "䄌": "rarely-used",
  "䄍": "rarely-used",
  "䄎": "rarely-used",
  "䄐": "rarely-used",
  "䄑": "rarely-used",
  "䄓": "rarely-used",
  "䄔": "rarely-used",
  "䄘": "rarely-used",
  "䄙": "rarely-used",
  "䄚": "rarely-used",
  "䄛": "rarely-used",
  "䄜": "rarely-used",
  "䄝": "rarely-used",
  "䄟": "rarely-used",
  "䄤": "rarely-used",
  "䄥": "rarely-used",
  "䄦": "rarely-used",
  "䄧": "rarely-used",
  "䄨": "rarely-used",
  "䄪": "rarely-used",
  "䄮": "rarely-used",
  "䄰": "rarely-used",
  "䄱": "rarely-used",
  "䄲": "rarely-used",
  "䄶": "rarely-used",
  "䄷": "rarely-used",
  "䄸": "rarely-used",
  "䄻": "rarely-used",
  "䄼": "rarely-used",
  "䄾": "rarely-used",
  "䄿": "rarely-used",
  "䅀": "rarely-used",
  "䅁": "rarely-used",
  "䅂": "rarely-used",
  "䅃": "rarely-used",
  "䅄": "rarely-used",
  "䅆": "rarely-used",
  "䅊": "rarely-used",
  "䅋": "rarely-used",
  "䅌": "rarely-used",
  "䅍": "rarely-used",
  "䅎": "rarely-used",
  "䅑": "rarely-used",
  "䅓": "rarely-used",
  "䅔": "rarely-used",
  "䅕": "rarely-used",
  "䅖": "rarely-used",
  "䅘": "rarely-used",
  "䅙": "rarely-used",
  "䅚": "rarely-used",
  "䅛": "rarely-used",
  "䅜": "rarely-used",
  "䅝": "rarely-used",
  "䅞": "rarely-used",
  "䅡": "rarely-used",
  "䅢": "rarely-used",
  "䅤": "rarely-used",
  "䅥": "rarely-used",
  "䅦": "rarely-used",
  "䅧": "rarely-used",
  "䅩": "rarely-used",
  "䅬": "rarely-used",
  "䅭": "rarely-used",
  "䅮": "rarely-used",
  "䅯": "rarely-used",
  "䅰": "rarely-used",
  "䅳": "rarely-used",
  "䅴": "rarely-used",
  "䅵": "rarely-used",
  "䅷": "rarely-used",
  "䅸": "rarely-used",
  "䅺": "rarely-used",
  "䅻": "rarely-used",
  "䅼": "rarely-used",
  "䅾": "rarely-used",
  "䅿": "rarely-used",
  "䆀": "rarely-used",
  "䆁": "rarely-used",
  "䆃": "rarely-used",
  "䆄": "rarely-used",
  "䆅": "rarely-used",
  "䆉": "rarely-used",
  "䆊": "rarely-used",
  "䆍": "rarely-used",
  "䆎": "rarely-used",
  "䆏": "rarely-used",
  "䆑": "rarely-used",
  "䆓": "rarely-used",
  "䆔": "rarely-used",
  "䆕": "rarely-used",
  "䆖": "rarely-used",
  "䆘": "rarely-used",
  "䆙": "rarely-used",
  "䆚": "rarely-used",
  "䆛": "rarely-used",
  "䆜": "rarely-used",
  "䆝": "rarely-used",
  "䆟": "rarely-used",
  "䆡": "rarely-used",
  "䆢": "rarely-used",
  "䆣": "rarely-used",
  "䆦": "rarely-used",
  "䆧": "rarely-used",
  "䆨": "rarely-used",
  "䆪": "rarely-used",
  "䆬": "rarely-used",
  "䆭": "rarely-used",
  "䆯": "rarely-used",
  "䆰": "rarely-used",
  "䆱": "rarely-used",
  "䆲": "rarely-used",
  "䆵": "rarely-used",
  "䆶": "rarely-used",
  "䆷": "rarely-used",
  "䆸": "rarely-used",
  "䆹": "rarely-used",
  "䆺": "rarely-used",
  "䆼": "rarely-used",
  "䆽": "rarely-used",
  "䆾": "rarely-used",
  "䆿": "rarely-used",
  "䇀": "rarely-used",
  "䇁": "rarely-used",
  "䇅": "rarely-used",
  "䇈": "rarely-used",
  "䇋": "rarely-used",
  "䇌": "rarely-used",
  "䇍": "rarely-used",
  "䇎": "rarely-used",
  "䇏": "rarely-used",
  "䇐": "rarely-used",
  "䇑": "rarely-used",
  "䇒": "rarely-used",
  "䇓": "rarely-used",
  "䇔": "rarely-used",
  "䇖": "rarely-used",
  "䇗": "rarely-used",
  "䇘": "rarely-used",
  "䇙": "rarely-used",
  "䇛": "rarely-used",
  "䇜": "rarely-used",
  "䇝": "rarely-used",
  "䇞": "rarely-used",
  "䇠": "rarely-used",
  "䇡": "rarely-used",
  "䇢": "rarely-used",
  "䇣": "rarely-used",
  "䇤": "rarely-used",
  "䇦": "rarely-used",
  "䇧": "rarely-used",
  "䇨": "rarely-used",
  "䇩": "rarely-used",
  "䇪": "rarely-used",
  "䇫": "rarely-used",
  "䇬": "rarely-used",
  "䇮": "rarely-used",
  "䇯": "rarely-used",
  "䇰": "rarely-used",
  "䇶": "rarely-used",
  "䇷": "rarely-used",
  "䇸": "rarely-used",
  "䇻": "rarely-used",
  "䇼": "rarely-used",
  "䇽": "rarely-used",
  "䇾": "rarely-used",
  "䈀": "rarely-used",
  "䈁": "rarely-used",
  "䈂": "rarely-used",
  "䈃": "rarely-used",
  "䈅": "rarely-used",
  "䈆": "rarely-used",
  "䈈": "rarely-used",
  "䈉": "rarely-used",
  "䈊": "rarely-used",
  "䈋": "rarely-used",
  "䈌": "rarely-used",
  "䈍": "rarely-used",
  "䈎": "rarely-used",
  "䈏": "rarely-used",
  "䈐": "rarely-used",
  "䈑": "rarely-used",
  "䈒": "rarely-used",
  "䈓": "rarely-used",
  "䈕": "rarely-used",
  "䈖": "rarely-used",
  "䈗": "rarely-used",
  "䈘": "rarely-used",
  "䈙": "rarely-used",
  "䈛": "rarely-used",
  "䈜": "rarely-used",
  "䈝": "rarely-used",
  "䈞": "rarely-used",
  "䈟": "rarely-used",
  "䈠": "rarely-used",
  "䈡": "rarely-used",
  "䈢": "rarely-used",
  "䈣": "rarely-used",
  "䈦": "rarely-used",
  "䈧": "rarely-used",
  "䈪": "rarely-used",
  "䈫": "rarely-used",
  "䈬": "rarely-used",
  "䈭": "rarely-used",
  "䈮": "rarely-used",
  "䈯": "rarely-used",
  "䈱": "rarely-used",
  "䈲": "rarely-used",
  "䈳": "rarely-used",
  "䈴": "rarely-used",
  "䈵": "rarely-used",
  "䈶": "rarely-used",
  "䈷": "rarely-used",
  "䈸": "rarely-used",
  "䈹": "rarely-used",
  "䈺": "rarely-used",
  "䈻": "rarely-used",
  "䈽": "rarely-used",
  "䈿": "rarely-used",
  "䉀": "rarely-used",
  "䉁": "rarely-used",
  "䉂": "rarely-used",
  "䉃": "rarely-used",
  "䉄": "rarely-used",
  "䉅": "rarely-used",
  "䉆": "rarely-used",
  "䉈": "rarely-used",
  "䉉": "rarely-used",
  "䉊": "rarely-used",
  "䉋": "rarely-used",
  "䉌": "rarely-used",
  "䉍": "rarely-used",
  "䉎": "rarely-used",
  "䉏": "rarely-used",
  "䉐": "rarely-used",
  "䉑": "rarely-used",
  "䉓": "rarely-used",
  "䉔": "rarely-used",
  "䉕": "rarely-used",
  "䉖": "rarely-used",
  "䉗": "rarely-used",
  "䉚": "rarely-used",
  "䉛": "rarely-used",
  "䉜": "rarely-used",
  "䉝": "rarely-used",
  "䉞": "rarely-used",
  "䉟": "rarely-used",
  "䉠": "rarely-used",
  "䉡": "rarely-used",
  "䉢": "rarely-used",
  "䉣": "rarely-used",
  "䉥": "rarely-used",
  "䉦": "rarely-used",
  "䉧": "rarely-used",
  "䉩": "rarely-used",
  "䉪": "rarely-used",
  "䉬": "rarely-used",
  "䉭": "rarely-used",
  "䉮": "rarely-used",
  "䉯": "rarely-used",
  "䉰": "rarely-used",
  "䉲": "rarely-used",
  "䉳": "rarely-used",
  "䉴": "rarely-used",
  "䉶": "rarely-used",
  "䉷": "rarely-used",
  "䉸": "rarely-used",
  "䉺": "rarely-used",
  "䉻": "rarely-used",
  "䉿": "rarely-used",
  "䊂": "rarely-used",
  "䊃": "rarely-used",
  "䊄": "rarely-used",
  "䊅": "rarely-used",
  "䊆": "rarely-used",
  "䊈": "rarely-used",
  "䊍": "rarely-used",
  "䊎": "rarely-used",
  "䊓": "rarely-used",
  "䊔": "rarely-used",
  "䊕": "rarely-used",
  "䊖": "rarely-used",
  "䊙": "rarely-used",
  "䊝": "rarely-used",
  "䊞": "rarely-used",
  "䊟": "rarely-used",
  "䊣": "rarely-used",
  "䊤": "rarely-used",
  "䊥": "rarely-used",
  "䊦": "rarely-used",
  "䊧": "rarely-used",
  "䊨": "rarely-used",
  "䊩": "rarely-used",
  "䊫": "rarely-used",
  "䊬": "rarely-used",
  "䊭": "rarely-used",
  "䊮": "rarely-used",
  "䊰": "rarely-used",
  "䊱": "rarely-used",
  "䊲": "rarely-used",
  "䊳": "rarely-used",
  "䊴": "rarely-used",
  "䊵": "rarely-used",
  "䊺": "rarely-used",
  "䊻": "rarely-used",
  "䊼": "rarely-used",
  "䊽": "rarely-used",
  "䊾": "rarely-used",
  "䋀": "rarely-used",
  "䋂": "rarely-used",
  "䋃": "rarely-used",
  "䋈": "rarely-used",
  "䋉": "rarely-used",
  "䋊": "rarely-used",
  "䋌": "rarely-used",
  "䋏": "rarely-used",
  "䋐": "rarely-used",
  "䋑": "rarely-used",
  "䋔": "rarely-used",
  "䋖": "rarely-used",
  "䋙": "rarely-used",
  "䋛": "rarely-used",
  "䋟": "rarely-used",
  "䋢": "rarely-used",
  "䋤": "rarely-used",
  "䋥": "rarely-used",
  "䋦": "rarely-used",
  "䋨": "rarely-used",
  "䋩": "rarely-used",
  "䋪": "rarely-used",
  "䋫": "rarely-used",
  "䋬": "rarely-used",
  "䋭": "rarely-used",
  "䋰": "rarely-used",
  "䋱": "rarely-used",
  "䋴": "rarely-used",
  "䋵": "rarely-used",
  "䋶": "rarely-used",
  "䋷": "rarely-used",
  "䋸": "rarely-used",
  "䋻": "rarely-used",
  "䋼": "rarely-used",
  "䋽": "rarely-used",
  "䋾": "rarely-used",
  "䋿": "rarely-used",
  "䌀": "rarely-used",
  "䌂": "rarely-used",
  "䌅": "rarely-used",
  "䌆": "rarely-used",
  "䌈": "rarely-used",
  "䌍": "rarely-used",
  "䌎": "rarely-used",
  "䌏": "rarely-used",
  "䌐": "rarely-used",
  "䌑": "rarely-used",
  "䌒": "rarely-used",
  "䌖": "rarely-used",
  "䌗": "rarely-used",
  "䌘": "rarely-used",
  "䌙": "rarely-used",
  "䌚": "rarely-used",
  "䌜": "rarely-used",
  "䌝": "rarely-used",
  "䌞": "rarely-used",
  "䌟": "rarely-used",
  "䌡": "rarely-used",
  "䌢": "rarely-used",
  "䌣": "rarely-used",
  "䌤": "rarely-used",
  "䌥": "rarely-used",
  "䌦": "rarely-used",
  "䌨": "rarely-used",
  "䌩": "rarely-used",
  "䌪": "rarely-used",
  "䌬": "rarely-used",
  "䌮": "rarely-used",
  "䌯": "rarely-used",
  "䌰": "rarely-used",
  "䌴": "rarely-used",
  "䌵": "rarely-used",
  "䍃": "rarely-used",
  "䍄": "rarely-used",
  "䍆": "rarely-used",
  "䍇": "rarely-used",
  "䍉": "rarely-used",
  "䍊": "rarely-used",
  "䍍": "rarely-used",
  "䍎": "rarely-used",
  "䍓": "rarely-used",
  "䍔": "rarely-used",
  "䍕": "rarely-used",
  "䍘": "rarely-used",
  "䍚": "rarely-used",
  "䍛": "rarely-used",
  "䍜": "rarely-used",
  "䍝": "rarely-used",
  "䍡": "rarely-used",
  "䍣": "rarely-used",
  "䍤": "rarely-used",
  "䍥": "rarely-used",
  "䍦": "rarely-used",
  "䍨": "rarely-used",
  "䍪": "rarely-used",
  "䍫": "rarely-used",
  "䍬": "rarely-used",
  "䍮": "rarely-used",
  "䍱": "rarely-used",
  "䍲": "rarely-used",
  "䍳": "rarely-used",
  "䍴": "rarely-used",
  "䍵": "rarely-used",
  "䍶": "rarely-used",
  "䍷": "rarely-used",
  "䍸": "rarely-used",
  "䍺": "rarely-used",
  "䍻": "rarely-used",
  "䍼": "rarely-used",
  "䍽": "rarely-used",
  "䍾": "rarely-used",
  "䍿": "rarely-used",
  "䎀": "rarely-used",
  "䎁": "rarely-used",
  "䎂": "rarely-used",
  "䎃": "rarely-used",
  "䎄": "rarely-used",
  "䎆": "rarely-used",
  "䎇": "rarely-used",
  "䎉": "rarely-used",
  "䎊": "rarely-used",
  "䎋": "rarely-used",
  "䎌": "rarely-used",
  "䎎": "rarely-used",
  "䎏": "rarely-used",
  "䎐": "rarely-used",
  "䎑": "rarely-used",
  "䎒": "rarely-used",
  "䎔": "rarely-used",
  "䎕": "rarely-used",
  "䎖": "rarely-used",
  "䎗": "rarely-used",
  "䎘": "rarely-used",
  "䎙": "rarely-used",
  "䎜": "rarely-used",
  "䎟": "rarely-used",
  "䎠": "rarely-used",
  "䎡": "rarely-used",
  "䎢": "rarely-used",
  "䎤": "rarely-used",
  "䎦": "rarely-used",
  "䎧": "rarely-used",
  "䎨": "rarely-used",
  "䎩": "rarely-used",
  "䎪": "rarely-used",
  "䎭": "rarely-used",
  "䎮": "rarely-used",
  "䎯": "rarely-used",
  "䎰": "rarely-used",
  "䎲": "rarely-used",
  "䎳": "rarely-used",
  "䎴": "rarely-used",
  "䎵": "rarely-used",
  "䎶": "rarely-used",
  "䎷": "rarely-used",
  "䎸": "rarely-used",
  "䎺": "rarely-used",
  "䎻": "rarely-used",
  "䎼": "rarely-used",
  "䎽": "rarely-used",
  "䎿": "rarely-used",
  "䏁": "rarely-used",
  "䏂": "rarely-used",
  "䏃": "rarely-used",
  "䏄": "rarely-used",
  "䏅": "rarely-used",
  "䏆": "rarely-used",
  "䏇": "rarely-used",
  "䏉": "rarely-used",
  "䏌": "rarely-used",
  "䏎": "rarely-used",
  "䏏": "rarely-used",
  "䏐": "rarely-used",
  "䏒": "rarely-used",
  "䏓": "rarely-used",
  "䏖": "rarely-used",
  "䏘": "rarely-used",
  "䏚": "rarely-used",
  "䏜": "rarely-used",
  "䏞": "rarely-used",
  "䏠": "rarely-used",
  "䏡": "rarely-used",
  "䏢": "rarely-used",
  "䏣": "rarely-used",
  "䏥": "rarely-used",
  "䏧": "rarely-used",
  "䏪": "rarely-used",
  "䏬": "rarely-used",
  "䏰": "rarely-used",
  "䏱": "rarely-used",
  "䏳": "rarely-used",
  "䏶": "rarely-used",
  "䏹": "rarely-used",
  "䏺": "rarely-used",
  "䏽": "rarely-used",
  "䏾": "rarely-used",
  "䏿": "rarely-used",
  "䐀": "rarely-used",
  "䐂": "rarely-used",
  "䐃": "rarely-used",
  "䐄": "rarely-used",
  "䐅": "rarely-used",
  "䐈": "rarely-used",
  "䐉": "rarely-used",
  "䐋": "rarely-used",
  "䐎": "rarely-used",
  "䐏": "rarely-used",
  "䐐": "rarely-used",
  "䐑": "rarely-used",
  "䐒": "rarely-used",
  "䐓": "rarely-used",
  "䐔": "rarely-used",
  "䐕": "rarely-used",
  "䐘": "rarely-used",
  "䐙": "rarely-used",
  "䐚": "rarely-used",
  "䐛": "rarely-used",
  "䐜": "rarely-used",
  "䐝": "rarely-used",
  "䐞": "rarely-used",
  "䐟": "rarely-used",
  "䐠": "rarely-used",
  "䐢": "rarely-used",
  "䐣": "rarely-used",
  "䐤": "rarely-used",
  "䐥": "rarely-used",
  "䐦": "rarely-used",
  "䐧": "rarely-used",
  "䐨": "rarely-used",
  "䐩": "rarely-used",
  "䐫": "rarely-used",
  "䐬": "rarely-used",
  "䐮": "rarely-used",
  "䐯": "rarely-used",
  "䐱": "rarely-used",
  "䐲": "rarely-used",
  "䐴": "rarely-used",
  "䐵": "rarely-used",
  "䐶": "rarely-used",
  "䐷": "rarely-used",
  "䐸": "rarely-used",
  "䐹": "rarely-used",
  "䐺": "rarely-used",
  "䐻": "rarely-used",
  "䐼": "rarely-used",
  "䐾": "rarely-used",
  "䐿": "rarely-used",
  "䑀": "rarely-used",
  "䑁": "rarely-used",
  "䑂": "rarely-used",
  "䑃": "rarely-used",
  "䑄": "rarely-used",
  "䑆": "rarely-used",
  "䑇": "rarely-used",
  "䑈": "rarely-used",
  "䑉": "rarely-used",
  "䑊": "rarely-used",
  "䑋": "rarely-used",
  "䑌": "rarely-used",
  "䑍": "rarely-used",
  "䑎": "rarely-used",
  "䑏": "rarely-used",
  "䑔": "rarely-used",
  "䑗": "rarely-used",
  "䑘": "rarely-used",
  "䑜": "rarely-used",
  "䑠": "rarely-used",
  "䑣": "rarely-used",
  "䑤": "rarely-used",
  "䑥": "rarely-used",
  "䑦": "rarely-used",
  "䑫": "rarely-used",
  "䑬": "rarely-used",
  "䑯": "rarely-used",
  "䑰": "rarely-used",
  "䑱": "rarely-used",
  "䑳": "rarely-used",
  "䑴": "rarely-used",
  "䑶": "rarely-used",
  "䑻": "rarely-used",
  "䑼": "rarely-used",
  "䑿": "rarely-used",
  "䒀": "rarely-used",
  "䒁": "rarely-used",
  "䒄": "rarely-used",
  "䒅": "rarely-used",
  "䒆": "rarely-used",
  "䒈": "rarely-used",
  "䒉": "rarely-used",
  "䒊": "rarely-used",
  "䒋": "rarely-used",
  "䒌": "rarely-used",
  "䒍": "rarely-used",
  "䒎": "rarely-used",
  "䒏": "rarely-used",
  "䒐": "rarely-used",
  "䒓": "rarely-used",
  "䒕": "rarely-used",
  "䒖": "rarely-used",
  "䒚": "rarely-used",
  "䒛": "rarely-used",
  "䒜": "rarely-used",
  "䒞": "rarely-used",
  "䒟": "rarely-used",
  "䒡": "rarely-used",
  "䒢": "rarely-used",
  "䒤": "rarely-used",
  "䒥": "rarely-used",
  "䒦": "rarely-used",
  "䒧": "rarely-used",
  "䒨": "rarely-used",
  "䒩": "rarely-used",
  "䒪": "rarely-used",
  "䒫": "rarely-used",
  "䒰": "rarely-used",
  "䒲": "rarely-used",
  "䒴": "rarely-used",
  "䒵": "rarely-used",
  "䒷": "rarely-used",
  "䒸": "rarely-used",
  "䒹": "rarely-used",
  "䒻": "rarely-used",
  "䒼": "rarely-used",
  "䓂": "rarely-used",
  "䓃": "rarely-used",
  "䓄": "rarely-used",
  "䓆": "rarely-used",
  "䓇": "rarely-used",
  "䓈": "rarely-used",
  "䓉": "rarely-used",
  "䓊": "rarely-used",
  "䓋": "rarely-used",
  "䓌": "rarely-used",
  "䓎": "rarely-used",
  "䓐": "rarely-used",
  "䓓": "rarely-used",
  "䓘": "rarely-used",
  "䓙": "rarely-used",
  "䓚": "rarely-used",
  "䓛": "rarely-used",
  "䓜": "rarely-used",
  "䓝": "rarely-used",
  "䓞": "rarely-used",
  "䓟": "rarely-used",
  "䓠": "rarely-used",
  "䓡": "rarely-used",
  "䓢": "rarely-used",
  "䓣": "rarely-used",
  "䓤": "rarely-used",
  "䓥": "rarely-used",
  "䓧": "rarely-used",
  "䓭": "rarely-used",
  "䓮": "rarely-used",
  "䓯": "rarely-used",
  "䓲": "rarely-used",
  "䓳": "rarely-used",
  "䓴": "rarely-used",
  "䓵": "rarely-used",
  "䓶": "rarely-used",
  "䓸": "rarely-used",
  "䓼": "rarely-used",
  "䓽": "rarely-used",
  "䓾": "rarely-used",
  "䔀": "rarely-used",
  "䔁": "rarely-used",
  "䔂": "rarely-used",
  "䔃": "rarely-used",
  "䔄": "rarely-used",
  "䔅": "rarely-used",
  "䔇": "rarely-used",
  "䔈": "rarely-used",
  "䔉": "rarely-used",
  "䔊": "rarely-used",
  "䔌": "rarely-used",
  "䔎": "rarely-used",
  "䔏": "rarely-used",
  "䔐": "rarely-used",
  "䔑": "rarely-used",
  "䔓": "rarely-used",
  "䔔": "rarely-used",
  "䔕": "rarely-used",
  "䔗": "rarely-used",
  "䔘": "rarely-used",
  "䔙": "rarely-used",
  "䔚": "rarely-used",
  "䔝": "rarely-used",
  "䔞": "rarely-used",
  "䔟": "rarely-used",
  "䔠": "rarely-used",
  "䔡": "rarely-used",
  "䔣": "rarely-used",
  "䔤": "rarely-used",
  "䔪": "rarely-used",
  "䔬": "rarely-used",
  "䔭": "rarely-used",
  "䔮": "rarely-used",
  "䔯": "rarely-used",
  "䔱": "rarely-used",
  "䔲": "rarely-used",
  "䔳": "rarely-used",
  "䔴": "rarely-used",
  "䔶": "rarely-used",
  "䔷": "rarely-used",
  "䔸": "rarely-used",
  "䔹": "rarely-used",
  "䔺": "rarely-used",
  "䔻": "rarely-used",
  "䔼": "rarely-used",
  "䔽": "rarely-used",
  "䔾": "rarely-used",
  "䔿": "rarely-used",
  "䕀": "rarely-used",
  "䕁": "rarely-used",
  "䕅": "rarely-used",
  "䕆": "rarely-used",
  "䕇": "rarely-used",
  "䕈": "rarely-used",
  "䕉": "rarely-used",
  "䕊": "rarely-used",
  "䕋": "rarely-used",
  "䕍": "rarely-used",
  "䕎": "rarely-used",
  "䕒": "rarely-used",
  "䕓": "rarely-used",
  "䕔": "rarely-used",
  "䕗": "rarely-used",
  "䕙": "rarely-used",
  "䕛": "rarely-used",
  "䕞": "rarely-used",
  "䕟": "rarely-used",
  "䕡": "rarely-used",
  "䕢": "rarely-used",
  "䕦": "rarely-used",
  "䕧": "rarely-used",
  "䕩": "rarely-used",
  "䕪": "rarely-used",
  "䕭": "rarely-used",
  "䕰": "rarely-used",
  "䕱": "rarely-used",
  "䕳": "rarely-used",
  "䕵": "rarely-used",
  "䕸": "rarely-used",
  "䕻": "rarely-used",
  "䕼": "rarely-used",
  "䕽": "rarely-used",
  "䕾": "rarely-used",
  "䖁": "rarely-used",
  "䖂": "rarely-used",
  "䖃": "rarely-used",
  "䖆": "rarely-used",
  "䖇": "rarely-used",
  "䖉": "rarely-used",
  "䖊": "rarely-used",
  "䖌": "rarely-used",
  "䖎": "rarely-used",
  "䖐": "rarely-used",
  "䖑": "rarely-used",
  "䖒": "rarely-used",
  "䖓": "rarely-used",
  "䖔": "rarely-used",
  "䖗": "rarely-used",
  "䖘": "rarely-used",
  "䖙": "rarely-used",
  "䖚": "rarely-used",
  "䖛": "rarely-used",
  "䖜": "rarely-used",
  "䖞": "rarely-used",
  "䖡": "rarely-used",
  "䖢": "rarely-used",
  "䖦": "rarely-used",
  "䖧": "rarely-used",
  "䖨": "rarely-used",
  "䖩": "rarely-used",
  "䖪": "rarely-used",
  "䖭": "rarely-used",
  "䖯": "rarely-used",
  "䖰": "rarely-used",
  "䖱": "rarely-used",
  "䖲": "rarely-used",
  "䖳": "rarely-used",
  "䖴": "rarely-used",
  "䖵": "rarely-used",
  "䖶": "rarely-used",
  "䖷": "rarely-used",
  "䖺": "rarely-used",
  "䖻": "rarely-used",
  "䖿": "rarely-used",
  "䗀": "rarely-used",
  "䗁": "rarely-used",
  "䗂": "rarely-used",
  "䗃": "rarely-used",
  "䗄": "rarely-used",
  "䗅": "rarely-used",
  "䗆": "rarely-used",
  "䗇": "rarely-used",
  "䗉": "rarely-used",
  "䗎": "rarely-used",
  "䗐": "rarely-used",
  "䗒": "rarely-used",
  "䗔": "rarely-used",
  "䗗": "rarely-used",
  "䗘": "rarely-used",
  "䗚": "rarely-used",
  "䗛": "rarely-used",
  "䗜": "rarely-used",
  "䗟": "rarely-used",
  "䗠": "rarely-used",
  "䗡": "rarely-used",
  "䗣": "rarely-used",
  "䗤": "rarely-used",
  "䗥": "rarely-used",
  "䗧": "rarely-used",
  "䗨": "rarely-used",
  "䗩": "rarely-used",
  "䗮": "rarely-used",
  "䗯": "rarely-used",
  "䗰": "rarely-used",
  "䗱": "rarely-used",
  "䗲": "rarely-used",
  "䗴": "rarely-used",
  "䗵": "rarely-used",
  "䗷": "rarely-used",
  "䗸": "rarely-used",
  "䗺": "rarely-used",
  "䗼": "rarely-used",
  "䗽": "rarely-used",
  "䘄": "rarely-used",
  "䘋": "rarely-used",
  "䘎": "rarely-used",
  "䘓": "rarely-used",
  "䘕": "rarely-used",
  "䘖": "rarely-used",
  "䘗": "rarely-used",
  "䘘": "rarely-used",
  "䘝": "rarely-used",
  "䘟": "rarely-used",
  "䘡": "rarely-used",
  "䘢": "rarely-used",
  "䘣": "rarely-used",
  "䘤": "rarely-used",
  "䘥": "rarely-used",
  "䘦": "rarely-used",
  "䘨": "rarely-used",
  "䘪": "rarely-used",
  "䘬": "rarely-used",
  "䘭": "rarely-used",
  "䘯": "rarely-used",
  "䘰": "rarely-used",
  "䘳": "rarely-used",
  "䘴": "rarely-used",
  "䘵": "rarely-used",
  "䘶": "rarely-used",
  "䘷": "rarely-used",
  "䘹": "rarely-used",
  "䘻": "rarely-used",
  "䘼": "rarely-used",
  "䘽": "rarely-used",
  "䘾": "rarely-used",
  "䘿": "rarely-used",
  "䙁": "rarely-used",
  "䙃": "rarely-used",
  "䙄": "rarely-used",
  "䙅": "rarely-used",
  "䙆": "rarely-used",
  "䙈": "rarely-used",
  "䙎": "rarely-used",
  "䙒": "rarely-used",
  "䙔": "rarely-used",
  "䙕": "rarely-used",
  "䙘": "rarely-used",
  "䙙": "rarely-used",
  "䙜": "rarely-used",
  "䙞": "rarely-used",
  "䙟": "rarely-used",
  "䙠": "rarely-used",
  "䙡": "rarely-used",
  "䙢": "rarely-used",
  "䙣": "rarely-used",
  "䙤": "rarely-used",
  "䙦": "rarely-used",
  "䙨": "rarely-used",
  "䙩": "rarely-used",
  "䙬": "rarely-used",
  "䙱": "rarely-used",
  "䙲": "rarely-used",
  "䙵": "rarely-used",
  "䙹": "rarely-used",
  "䙼": "rarely-used",
  "䙽": "rarely-used",
  "䙾": "rarely-used",
  "䙿": "rarely-used",
  "䚀": "rarely-used",
  "䚂": "rarely-used",
  "䚄": "rarely-used",
  "䚅": "rarely-used",
  "䚆": "rarely-used",
  "䚇": "rarely-used",
  "䚈": "rarely-used",
  "䚉": "rarely-used",
  "䚊": "rarely-used",
  "䚋": "rarely-used",
  "䚌": "rarely-used",
  "䚍": "rarely-used",
  "䚏": "rarely-used",
  "䚐": "rarely-used",
  "䚒": "rarely-used",
  "䚔": "rarely-used",
  "䚕": "rarely-used",
  "䚗": "rarely-used",
  "䚘": "rarely-used",
  "䚙": "rarely-used",
  "䚚": "rarely-used",
  "䚛": "rarely-used",
  "䚜": "rarely-used",
  "䚝": "rarely-used",
  "䚞": "rarely-used",
  "䚠": "rarely-used",
  "䚡": "rarely-used",
  "䚢": "rarely-used",
  "䚣": "rarely-used",
  "䚦": "rarely-used",
  "䚧": "rarely-used",
  "䚨": "rarely-used",
  "䚩": "rarely-used",
  "䚪": "rarely-used",
  "䚫": "rarely-used",
  "䚭": "rarely-used",
  "䚮": "rarely-used",
  "䚯": "rarely-used",
  "䚳": "rarely-used",
  "䚴": "rarely-used",
  "䚵": "rarely-used",
  "䚶": "rarely-used",
  "䚷": "rarely-used",
  "䚸": "rarely-used",
  "䚻": "rarely-used",
  "䚼": "rarely-used",
  "䚽": "rarely-used",
  "䚿": "rarely-used",
  "䛀": "rarely-used",
  "䛃": "rarely-used",
  "䛄": "rarely-used",
  "䛅": "rarely-used",
  "䛆": "rarely-used",
  "䛇": "rarely-used",
  "䛈": "rarely-used",
  "䛉": "rarely-used",
  "䛊": "rarely-used",
  "䛋": "rarely-used",
  "䛌": "rarely-used",
  "䛍": "rarely-used",
  "䛎": "rarely-used",
  "䛏": "rarely-used",
  "䛔": "rarely-used",
  "䛗": "rarely-used",
  "䛘": "rarely-used",
  "䛙": "rarely-used",
  "䛚": "rarely-used",
  "䛝": "rarely-used",
  "䛞": "rarely-used",
  "䛠": "rarely-used",
  "䛢": "rarely-used",
  "䛣": "rarely-used",
  "䛤": "rarely-used",
  "䛥": "rarely-used",
  "䛨": "rarely-used",
  "䛩": "rarely-used",
  "䛪": "rarely-used",
  "䛫": "rarely-used",
  "䛬": "rarely-used",
  "䛭": "rarely-used",
  "䛯": "rarely-used",
  "䛰": "rarely-used",
  "䛱": "rarely-used",
  "䛲": "rarely-used",
  "䛳": "rarely-used",
  "䛴": "rarely-used",
  "䛷": "rarely-used",
  "䛹": "rarely-used",
  "䛽": "rarely-used",
  "䛾": "rarely-used",
  "䛿": "rarely-used",
  "䜂": "rarely-used",
  "䜃": "rarely-used",
  "䜅": "rarely-used",
  "䜆": "rarely-used",
  "䜇": "rarely-used",
  "䜈": "rarely-used",
  "䜉": "rarely-used",
  "䜋": "rarely-used",
  "䜌": "rarely-used",
  "䜍": "rarely-used",
  "䜎": "rarely-used",
  "䜏": "rarely-used",
  "䜑": "rarely-used",
  "䜒": "rarely-used",
  "䜓": "rarely-used",
  "䜕": "rarely-used",
  "䜗": "rarely-used",
  "䜙": "rarely-used",
  "䜚": "rarely-used",
  "䜜": "rarely-used",
  "䜝": "rarely-used",
  "䜞": "rarely-used",
  "䜡": "rarely-used",
  "䜢": "rarely-used",
  "䜪": "rarely-used",
  "䜫": "rarely-used",
  "䜭": "rarely-used",
  "䜮": "rarely-used",
  "䜯": "rarely-used",
  "䜰": "rarely-used",
  "䜱": "rarely-used",
  "䜲": "rarely-used",
  "䜴": "rarely-used",
  "䜶": "rarely-used",
  "䜷": "rarely-used",
  "䜸": "rarely-used",
  "䜺": "rarely-used",
  "䜼": "rarely-used",
  "䜽": "rarely-used",
  "䜾": "rarely-used",
  "䝀": "rarely-used",
  "䝁": "rarely-used",
  "䝃": "rarely-used",
  "䝄": "rarely-used",
  "䝅": "rarely-used",
  "䝆": "rarely-used",
  "䝋": "rarely-used",
  "䝍": "rarely-used",
  "䝏": "rarely-used",
  "䝐": "rarely-used",
  "䝑": "rarely-used",
  "䝒": "rarely-used",
  "䝕": "rarely-used",
  "䝖": "rarely-used",
  "䝚": "rarely-used",
  "䝣": "rarely-used",
  "䝦": "rarely-used",
  "䝧": "rarely-used",
  "䝩": "rarely-used",
  "䝪": "rarely-used",
  "䝫": "rarely-used",
  "䝬": "rarely-used",
  "䝭": "rarely-used",
  "䝰": "rarely-used",
  "䝱": "rarely-used",
  "䝳": "rarely-used",
  "䝵": "rarely-used",
  "䝶": "rarely-used",
  "䝷": "rarely-used",
  "䝸": "rarely-used",
  "䝹": "rarely-used",
  "䝻": "rarely-used",
  "䝽": "rarely-used",
  "䞀": "rarely-used",
  "䞁": "rarely-used",
  "䞂": "rarely-used",
  "䞃": "rarely-used",
  "䞆": "rarely-used",
  "䞈": "rarely-used",
  "䞊": "rarely-used",
  "䞑": "rarely-used",
  "䞒": "rarely-used",
  "䞔": "rarely-used",
  "䞕": "rarely-used",
  "䞖": "rarely-used",
  "䞗": "rarely-used",
  "䞘": "rarely-used",
  "䞙": "rarely-used",
  "䞚": "rarely-used",
  "䞝": "rarely-used",
  "䞞": "rarely-used",
  "䞟": "rarely-used",
  "䞠": "rarely-used",
  "䞡": "rarely-used",
  "䞢": "rarely-used",
  "䞤": "rarely-used",
  "䞥": "rarely-used",
  "䞦": "rarely-used",
  "䞧": "rarely-used",
  "䞩": "rarely-used",
  "䞪": "rarely-used",
  "䞫": "rarely-used",
  "䞭": "rarely-used",
  "䞮": "rarely-used",
  "䞯": "rarely-used",
  "䞱": "rarely-used",
  "䞴": "rarely-used",
  "䞵": "rarely-used",
  "䞶": "rarely-used",
  "䞹": "rarely-used",
  "䞺": "rarely-used",
  "䞻": "rarely-used",
  "䞽": "rarely-used",
  "䞾": "rarely-used",
  "䞿": "rarely-used",
  "䟀": "rarely-used",
  "䟁": "rarely-used",
  "䟂": "rarely-used",
  "䟃": "rarely-used",
  "䟄": "rarely-used",
  "䟅": "rarely-used",
  "䟆": "rarely-used",
  "䟇": "rarely-used",
  "䟈": "rarely-used",
  "䟉": "rarely-used",
  "䟊": "rarely-used",
  "䟋": "rarely-used",
  "䟍": "rarely-used",
  "䟏": "rarely-used",
  "䟐": "rarely-used",
  "䟑": "rarely-used",
  "䟒": "rarely-used",
  "䟓": "rarely-used",
  "䟔": "rarely-used",
  "䟕": "rarely-used",
  "䟗": "rarely-used",
  "䟘": "rarely-used",
  "䟙": "rarely-used",
  "䟛": "rarely-used",
  "䟜": "rarely-used",
  "䟝": "rarely-used",
  "䟟": "rarely-used",
  "䟠": "rarely-used",
  "䟡": "rarely-used",
  "䟣": "rarely-used",
  "䟤": "rarely-used",
  "䟧": "rarely-used",
  "䟨": "rarely-used",
  "䟩": "rarely-used",
  "䟪": "rarely-used",
  "䟫": "rarely-used",
  "䟬": "rarely-used",
  "䟮": "rarely-used",
  "䟯": "rarely-used",
  "䟰": "rarely-used",
  "䟴": "rarely-used",
  "䟵": "rarely-used",
  "䟶": "rarely-used",
  "䟷": "rarely-used",
  "䟸": "rarely-used",
  "䟹": "rarely-used",
  "䟺": "rarely-used",
  "䟻": "rarely-used",
  "䟼": "rarely-used",
  "䟾": "rarely-used",
  "䟿": "rarely-used",
  "䠀": "rarely-used",
  "䠃": "rarely-used",
  "䠄": "rarely-used",
  "䠅": "rarely-used",
  "䠆": "rarely-used",
  "䠇": "rarely-used",
  "䠈": "rarely-used",
  "䠉": "rarely-used",
  "䠋": "rarely-used",
  "䠍": "rarely-used",
  "䠏": "rarely-used",
  "䠐": "rarely-used",
  "䠑": "rarely-used",
  "䠒": "rarely-used",
  "䠔": "rarely-used",
  "䠕": "rarely-used",
  "䠗": "rarely-used",
  "䠘": "rarely-used",
  "䠙": "rarely-used",
  "䠛": "rarely-used",
  "䠜": "rarely-used",
  "䠝": "rarely-used",
  "䠟": "rarely-used",
  "䠡": "rarely-used",
  "䠢": "rarely-used",
  "䠤": "rarely-used",
  "䠦": "rarely-used",
  "䠨": "rarely-used",
  "䠩": "rarely-used",
  "䠫": "rarely-used",
  "䠬": "rarely-used",
  "䠭": "rarely-used",
  "䠯": "rarely-used",
  "䠳": "rarely-used",
  "䠴": "rarely-used",
  "䠵": "rarely-used",
  "䠷": "rarely-used",
  "䠸": "rarely-used",
  "䠼": "rarely-used",
  "䠽": "rarely-used",
  "䠾": "rarely-used",
  "䠿": "rarely-used",
  "䡁": "rarely-used",
  "䡂": "rarely-used",
  "䡃": "rarely-used",
  "䡆": "rarely-used",
  "䡉": "rarely-used",
  "䡊": "rarely-used",
  "䡍": "rarely-used",
  "䡐": "rarely-used",
  "䡑": "rarely-used",
  "䡓": "rarely-used",
  "䡔": "rarely-used",
  "䡕": "rarely-used",
  "䡗": "rarely-used",
  "䡘": "rarely-used",
  "䡚": "rarely-used",
  "䡛": "rarely-used",
  "䡜": "rarely-used",
  "䡝": "rarely-used",
  "䡞": "rarely-used",
  "䡟": "rarely-used",
  "䡠": "rarely-used",
  "䡡": "rarely-used",
  "䡢": "rarely-used",
  "䡣": "rarely-used",
  "䡤": "rarely-used",
  "䡦": "rarely-used",
  "䡧": "rarely-used",
  "䡩": "rarely-used",
  "䡪": "rarely-used",
  "䡫": "rarely-used",
  "䡬": "rarely-used",
  "䡭": "rarely-used",
  "䡮": "rarely-used",
  "䡯": "rarely-used",
  "䡰": "rarely-used",
  "䡲": "rarely-used",
  "䡳": "rarely-used",
  "䡴": "rarely-used",
  "䡵": "rarely-used",
  "䡶": "rarely-used",
  "䡷": "rarely-used",
  "䡽": "rarely-used",
  "䡾": "rarely-used",
  "䢃": "rarely-used",
  "䢅": "rarely-used",
  "䢇": "rarely-used",
  "䢈": "rarely-used",
  "䢋": "rarely-used",
  "䢌": "rarely-used",
  "䢍": "rarely-used",
  "䢎": "rarely-used",
  "䢑": "rarely-used",
  "䢒": "rarely-used",
  "䢓": "rarely-used",
  "䢔": "rarely-used",
  "䢕": "rarely-used",
  "䢖": "rarely-used",
  "䢙": "rarely-used",
  "䢝": "rarely-used",
  "䢞": "rarely-used",
  "䢡": "rarely-used",
  "䢢": "rarely-used",
  "䢥": "rarely-used",
  "䢦": "rarely-used",
  "䢧": "rarely-used",
  "䢭": "rarely-used",
  "䢮": "rarely-used",
  "䢱": "rarely-used",
  "䢲": "rarely-used",
  "䢳": "rarely-used",
  "䢴": "rarely-used",
  "䢸": "rarely-used",
  "䢹": "rarely-used",
  "䢻": "rarely-used",
  "䢼": "rarely-used",
  "䢿": "rarely-used",
  "䣀": "rarely-used",
  "䣁": "rarely-used",
  "䣂": "rarely-used",
  "䣄": "rarely-used",
  "䣅": "rarely-used",
  "䣆": "rarely-used",
  "䣇": "rarely-used",
  "䣊": "rarely-used",
  "䣋": "rarely-used",
  "䣍": "rarely-used",
  "䣎": "rarely-used",
  "䣏": "rarely-used",
  "䣐": "rarely-used",
  "䣓": "rarely-used",
  "䣔": "rarely-used",
  "䣕": "rarely-used",
  "䣗": "rarely-used",
  "䣘": "rarely-used",
  "䣙": "rarely-used",
  "䣚": "rarely-used",
  "䣛": "rarely-used",
  "䣜": "rarely-used",
  "䣝": "rarely-used",
  "䣡": "rarely-used",
  "䣢": "rarely-used",
  "䣪": "rarely-used",
  "䣫": "rarely-used",
  "䣬": "rarely-used",
  "䣮": "rarely-used",
  "䣯": "rarely-used",
  "䣵": "rarely-used",
  "䣶": "rarely-used",
  "䣷": "rarely-used",
  "䣸": "rarely-used",
  "䣹": "rarely-used",
  "䣺": "rarely-used",
  "䣻": "rarely-used",
  "䣼": "rarely-used",
  "䣽": "rarely-used",
  "䣾": "rarely-used",
  "䣿": "rarely-used",
  "䤁": "rarely-used",
  "䤂": "rarely-used",
  "䤃": "rarely-used",
  "䤅": "rarely-used",
  "䤆": "rarely-used",
  "䤉": "rarely-used",
  "䤌": "rarely-used",
  "䤍": "rarely-used",
  "䤎": "rarely-used",
  "䤏": "rarely-used",
  "䤐": "rarely-used",
  "䤑": "rarely-used",
  "䤒": "rarely-used",
  "䤓": "rarely-used",
  "䤔": "rarely-used",
  "䤕": "rarely-used",
  "䤖": "rarely-used",
  "䤗": "rarely-used",
  "䤘": "rarely-used",
  "䤙": "rarely-used",
  "䤝": "rarely-used",
  "䤡": "rarely-used",
  "䤢": "rarely-used",
  "䤤": "rarely-used",
  "䤥": "rarely-used",
  "䤧": "rarely-used",
  "䤪": "rarely-used",
  "䤬": "rarely-used",
  "䤭": "rarely-used",
  "䤮": "rarely-used",
  "䤰": "rarely-used",
  "䤳": "rarely-used",
  "䤴": "rarely-used",
  "䤵": "rarely-used",
  "䤶": "rarely-used",
  "䤺": "rarely-used",
  "䤻": "rarely-used",
  "䤽": "rarely-used",
  "䤾": "rarely-used",
  "䥀": "rarely-used",
  "䥂": "rarely-used",
  "䥃": "rarely-used",
  "䥄": "rarely-used",
  "䥈": "rarely-used",
  "䥉": "rarely-used",
  "䥋": "rarely-used",
  "䥍": "rarely-used",
  "䥎": "rarely-used",
  "䥏": "rarely-used",
  "䥒": "rarely-used",
  "䥔": "rarely-used",
  "䥗": "rarely-used",
  "䥙": "rarely-used",
  "䥝": "rarely-used",
  "䥞": "rarely-used",
  "䥟": "rarely-used",
  "䥡": "rarely-used",
  "䥤": "rarely-used",
  "䥨": "rarely-used",
  "䥩": "rarely-used",
  "䥮": "rarely-used",
  "䥯": "rarely-used",
  "䥰": "rarely-used",
  "䥱": "rarely-used",
  "䥲": "rarely-used",
  "䥳": "rarely-used",
  "䥵": "rarely-used",
  "䦈": "rarely-used",
  "䦊": "rarely-used",
  "䦋": "rarely-used",
  "䦌": "rarely-used",
  "䦍": "rarely-used",
  "䦎": "rarely-used",
  "䦏": "rarely-used",
  "䦑": "rarely-used",
  "䦒": "rarely-used",
  "䦓": "rarely-used",
  "䦔": "rarely-used",
  "䦖": "rarely-used",
  "䦘": "rarely-used",
  "䦙": "rarely-used",
  "䦚": "rarely-used",
  "䦝": "rarely-used",
  "䦠": "rarely-used",
  "䦡": "rarely-used",
  "䦢": "rarely-used",
  "䦣": "rarely-used",
  "䦤": "rarely-used",
  "䦥": "rarely-used",
  "䦪": "rarely-used",
  "䦫": "rarely-used",
  "䦭": "rarely-used",
  "䦮": "rarely-used",
  "䦯": "rarely-used",
  "䦱": "rarely-used",
  "䦲": "rarely-used",
  "䦳": "rarely-used",
  "䦴": "rarely-used",
  "䦵": "rarely-used",
  "䦹": "rarely-used",
  "䦺": "rarely-used",
  "䦻": "rarely-used",
  "䦼": "rarely-used",
  "䧁": "rarely-used",
  "䧃": "rarely-used",
  "䧄": "rarely-used",
  "䧅": "rarely-used",
  "䧆": "rarely-used",
  "䧇": "rarely-used",
  "䧊": "rarely-used",
  "䧋": "rarely-used",
  "䧌": "rarely-used",
  "䧎": "rarely-used",
  "䧑": "rarely-used",
  "䧒": "rarely-used",
  "䧓": "rarely-used",
  "䧔": "rarely-used",
  "䧖": "rarely-used",
  "䧗": "rarely-used",
  "䧘": "rarely-used",
  "䧝": "rarely-used",
  "䧞": "rarely-used",
  "䧤": "rarely-used",
  "䧥": "rarely-used",
  "䧨": "rarely-used",
  "䧪": "rarely-used",
  "䧬": "rarely-used",
  "䧮": "rarely-used",
  "䧯": "rarely-used",
  "䧰": "rarely-used",
  "䧴": "rarely-used",
  "䧶": "rarely-used",
  "䧷": "rarely-used",
  "䨁": "rarely-used",
  "䨄": "rarely-used",
  "䨈": "rarely-used",
  "䨊": "rarely-used",
  "䨏": "rarely-used",
  "䨐": "rarely-used",
  "䨑": "rarely-used",
  "䨒": "rarely-used",
  "䨗": "rarely-used",
  "䨛": "rarely-used",
  "䨜": "rarely-used",
  "䨝": "rarely-used",
  "䨞": "rarely-used",
  "䨟": "rarely-used",
  "䨡": "rarely-used",
  "䨣": "rarely-used",
  "䨤": "rarely-used",
  "䨥": "rarely-used",
  "䨨": "rarely-used",
  "䨰": "rarely-used",
  "䨱": "rarely-used",
  "䨲": "rarely-used",
  "䨳": "rarely-used",
  "䨴": "rarely-used",
  "䨵": "rarely-used",
  "䨸": "rarely-used",
  "䨹": "rarely-used",
  "䨺": "rarely-used",
  "䨻": "rarely-used",
  "䨼": "rarely-used",
  "䨽": "rarely-used",
  "䨿": "rarely-used",
  "䩀": "rarely-used",
  "䩁": "rarely-used",
  "䩂": "rarely-used",
  "䩃": "rarely-used",
  "䩅": "rarely-used",
  "䩆": "rarely-used",
  "䩇": "rarely-used",
  "䩉": "rarely-used",
  "䩊": "rarely-used",
  "䩋": "rarely-used",
  "䩌": "rarely-used",
  "䩍": "rarely-used",
  "䩏": "rarely-used",
  "䩒": "rarely-used",
  "䩓": "rarely-used",
  "䩔": "rarely-used",
  "䩕": "rarely-used",
  "䩖": "rarely-used",
  "䩙": "rarely-used",
  "䩛": "rarely-used",
  "䩞": "rarely-used",
  "䩟": "rarely-used",
  "䩠": "rarely-used",
  "䩡": "rarely-used",
  "䩢": "rarely-used",
  "䩣": "rarely-used",
  "䩤": "rarely-used",
  "䩥": "rarely-used",
  "䩧": "rarely-used",
  "䩪": "rarely-used",
  "䩬": "rarely-used",
  "䩯": "rarely-used",
  "䩰": "rarely-used",
  "䩱": "rarely-used",
  "䩲": "rarely-used",
  "䩳": "rarely-used",
  "䩴": "rarely-used",
  "䩵": "rarely-used",
  "䩶": "rarely-used",
  "䩸": "rarely-used",
  "䩹": "rarely-used",
  "䩺": "rarely-used",
  "䩻": "rarely-used",
  "䩼": "rarely-used",
  "䩽": "rarely-used",
  "䩾": "rarely-used",
  "䪁": "rarely-used",
  "䪂": "rarely-used",
  "䪃": "rarely-used",
  "䪆": "rarely-used",
  "䪈": "rarely-used",
  "䪉": "rarely-used",
  "䪊": "rarely-used",
  "䪋": "rarely-used",
  "䪌": "rarely-used",
  "䪎": "rarely-used",
  "䪏": "rarely-used",
  "䪐": "rarely-used",
  "䪑": "rarely-used",
  "䪒": "rarely-used",
  "䪓": "rarely-used",
  "䪕": "rarely-used",
  "䪗": "rarely-used",
  "䪙": "rarely-used",
  "䪚": "rarely-used",
  "䪛": "rarely-used",
  "䪞": "rarely-used",
  "䪤": "rarely-used",
  "䪦": "rarely-used",
  "䪧": "rarely-used",
  "䪨": "rarely-used",
  "䪫": "rarely-used",
  "䪬": "rarely-used",
  "䪭": "rarely-used",
  "䪮": "rarely-used",
  "䪯": "rarely-used",
  "䪰": "rarely-used",
  "䪱": "rarely-used",
  "䪲": "rarely-used",
  "䪳": "rarely-used",
  "䪴": "rarely-used",
  "䪵": "rarely-used",
  "䪶": "rarely-used",
  "䪷": "rarely-used",
  "䪸": "rarely-used",
  "䪺": "rarely-used",
  "䪻": "rarely-used",
  "䪼": "rarely-used",
  "䪽": "rarely-used",
  "䪾": "rarely-used",
  "䫀": "rarely-used",
  "䫁": "rarely-used",
  "䫂": "rarely-used",
  "䫃": "rarely-used",
  "䫄": "rarely-used",
  "䫅": "rarely-used",
  "䫆": "rarely-used",
  "䫈": "rarely-used",
  "䫋": "rarely-used",
  "䫌": "rarely-used",
  "䫎": "rarely-used",
  "䫐": "rarely-used",
  "䫑": "rarely-used",
  "䫒": "rarely-used",
  "䫔": "rarely-used",
  "䫕": "rarely-used",
  "䫖": "rarely-used",
  "䫗": "rarely-used",
  "䫘": "rarely-used",
  "䫚": "rarely-used",
  "䫛": "rarely-used",
  "䫜": "rarely-used",
  "䫞": "rarely-used",
  "䫟": "rarely-used",
  "䫠": "rarely-used",
  "䫡": "rarely-used",
  "䫢": "rarely-used",
  "䫣": "rarely-used",
  "䫤": "rarely-used",
  "䫦": "rarely-used",
  "䫧": "rarely-used",
  "䫨": "rarely-used",
  "䫩": "rarely-used",
  "䫪": "rarely-used",
  "䫬": "rarely-used",
  "䫭": "rarely-used",
  "䫮": "rarely-used",
  "䫲": "rarely-used",
  "䫴": "rarely-used",
  "䫵": "rarely-used",
  "䫶": "rarely-used",
  "䫷": "rarely-used",
  "䫸": "rarely-used",
  "䫹": "rarely-used",
  "䫺": "rarely-used",
  "䫻": "rarely-used",
  "䫽": "rarely-used",
  "䫾": "rarely-used",
  "䫿": "rarely-used",
  "䬀": "rarely-used",
  "䬁": "rarely-used",
  "䬂": "rarely-used",
  "䬄": "rarely-used",
  "䬅": "rarely-used",
  "䬆": "rarely-used",
  "䬇": "rarely-used",
  "䬈": "rarely-used",
  "䬉": "rarely-used",
  "䬊": "rarely-used",
  "䬋": "rarely-used",
  "䬌": "rarely-used",
  "䬍": "rarely-used",
  "䬎": "rarely-used",
  "䬏": "rarely-used",
  "䬐": "rarely-used",
  "䬑": "rarely-used",
  "䬓": "rarely-used",
  "䬔": "rarely-used",
  "䬕": "rarely-used",
  "䬘": "rarely-used",
  "䬝": "rarely-used",
  "䬞": "rarely-used",
  "䬟": "rarely-used",
  "䬣": "rarely-used",
  "䬦": "rarely-used",
  "䬧": "rarely-used",
  "䬨": "rarely-used",
  "䬫": "rarely-used",
  "䬬": "rarely-used",
  "䬯": "rarely-used",
  "䬰": "rarely-used",
  "䬱": "rarely-used",
  "䬲": "rarely-used",
  "䬵": "rarely-used",
  "䬶": "rarely-used",
  "䬷": "rarely-used",
  "䬹": "rarely-used",
  "䬼": "rarely-used",
  "䬽": "rarely-used",
  "䬾": "rarely-used",
  "䬿": "rarely-used",
  "䭀": "rarely-used",
  "䭁": "rarely-used",
  "䭂": "rarely-used",
  "䭃": "rarely-used",
  "䭅": "rarely-used",
  "䭆": "rarely-used",
  "䭈": "rarely-used",
  "䭉": "rarely-used",
  "䭊": "rarely-used",
  "䭍": "rarely-used",
  "䭎": "rarely-used",
  "䭐": "rarely-used",
  "䭑": "rarely-used",
  "䭒": "rarely-used",
  "䭓": "rarely-used",
  "䭔": "rarely-used",
  "䭕": "rarely-used",
  "䭖": "rarely-used",
  "䭘": "rarely-used",
  "䭙": "rarely-used",
  "䭚": "rarely-used",
  "䭝": "rarely-used",
  "䭞": "rarely-used",
  "䭟": "rarely-used",
  "䭠": "rarely-used",
  "䭡": "rarely-used",
  "䭢": "rarely-used",
  "䭧": "rarely-used",
  "䭨": "rarely-used",
  "䭭": "rarely-used",
  "䭰": "rarely-used",
  "䭱": "rarely-used",
  "䭲": "rarely-used",
  "䭳": "rarely-used",
  "䭴": "rarely-used",
  "䭵": "rarely-used",
  "䭷": "rarely-used",
  "䭸": "rarely-used",
  "䭹": "rarely-used",
  "䭺": "rarely-used",
  "䭻": "rarely-used",
  "䭿": "rarely-used",
  "䮂": "rarely-used",
  "䮄": "rarely-used",
  "䮉": "rarely-used",
  "䮊": "rarely-used",
  "䮌": "rarely-used",
  "䮎": "rarely-used",
  "䮏": "rarely-used",
  "䮑": "rarely-used",
  "䮒": "rarely-used",
  "䮓": "rarely-used",
  "䮔": "rarely-used",
  "䮕": "rarely-used",
  "䮖": "rarely-used",
  "䮗": "rarely-used",
  "䮘": "rarely-used",
  "䮙": "rarely-used",
  "䮚": "rarely-used",
  "䮜": "rarely-used",
  "䮝": "rarely-used",
  "䮞": "rarely-used",
  "䮠": "rarely-used",
  "䮡": "rarely-used",
  "䮢": "rarely-used",
  "䮣": "rarely-used",
  "䮤": "rarely-used",
  "䮦": "rarely-used",
  "䮧": "rarely-used",
  "䮨": "rarely-used",
  "䮩": "rarely-used",
  "䮪": "rarely-used",
  "䮫": "rarely-used",
  "䮬": "rarely-used",
  "䮭": "rarely-used",
  "䮰": "rarely-used",
  "䮱": "rarely-used",
  "䮳": "rarely-used",
  "䮴": "rarely-used",
  "䮵": "rarely-used",
  "䮷": "rarely-used",
  "䮸": "rarely-used",
  "䮹": "rarely-used",
  "䮺": "rarely-used",
  "䮾": "rarely-used",
  "䯀": "rarely-used",
  "䯂": "rarely-used",
  "䯆": "rarely-used",
  "䯇": "rarely-used",
  "䯈": "rarely-used",
  "䯉": "rarely-used",
  "䯊": "rarely-used",
  "䯋": "rarely-used",
  "䯌": "rarely-used",
  "䯍": "rarely-used",
  "䯏": "rarely-used",
  "䯑": "rarely-used",
  "䯒": "rarely-used",
  "䯓": "rarely-used",
  "䯔": "rarely-used",
  "䯕": "rarely-used",
  "䯖": "rarely-used",
  "䯘": "rarely-used",
  "䯙": "rarely-used",
  "䯚": "rarely-used",
  "䯛": "rarely-used",
  "䯜": "rarely-used",
  "䯞": "rarely-used",
  "䯟": "rarely-used",
  "䯠": "rarely-used",
  "䯡": "rarely-used",
  "䯣": "rarely-used",
  "䯤": "rarely-used",
  "䯥": "rarely-used",
  "䯦": "rarely-used",
  "䯨": "rarely-used",
  "䯪": "rarely-used",
  "䯫": "rarely-used",
  "䯭": "rarely-used",
  "䯮": "rarely-used",
  "䯰": "rarely-used",
  "䯱": "rarely-used",
  "䯲": "rarely-used",
  "䯴": "rarely-used",
  "䯵": "rarely-used",
  "䯷": "rarely-used",
  "䯸": "rarely-used",
  "䯹": "rarely-used",
  "䯼": "rarely-used",
  "䯽": "rarely-used",
  "䯾": "rarely-used",
  "䯿": "rarely-used",
  "䰀": "rarely-used",
  "䰁": "rarely-used",
  "䰂": "rarely-used",
  "䰃": "rarely-used",
  "䰄": "rarely-used",
  "䰆": "rarely-used",
  "䰈": "rarely-used",
  "䰉": "rarely-used",
  "䰊": "rarely-used",
  "䰌": "rarely-used",
  "䰎": "rarely-used",
  "䰐": "rarely-used",
  "䰒": "rarely-used",
  "䰓": "rarely-used",
  "䰕": "rarely-used",
  "䰖": "rarely-used",
  "䰘": "rarely-used",
  "䰙": "rarely-used",
  "䰚": "rarely-used",
  "䰠": "rarely-used",
  "䰡": "rarely-used",
  "䰢": "rarely-used",
  "䰤": "rarely-used",
  "䰦": "rarely-used",
  "䰧": "rarely-used",
  "䰩": "rarely-used",
  "䰫": "rarely-used",
  "䰬": "rarely-used",
  "䰯": "rarely-used",
  "䰰": "rarely-used",
  "䰲": "rarely-used",
  "䰴": "rarely-used",
  "䰵": "rarely-used",
  "䰷": "rarely-used",
  "䰸": "rarely-used",
  "䰼": "rarely-used",
  "䰽": "rarely-used",
  "䰾": "rarely-used",
  "䱀": "rarely-used",
  "䱁": "rarely-used",
  "䱂": "rarely-used",
  "䱃": "rarely-used",
  "䱅": "rarely-used",
  "䱉": "rarely-used",
  "䱊": "rarely-used",
  "䱋": "rarely-used",
  "䱌": "rarely-used",
  "䱎": "rarely-used",
  "䱏": "rarely-used",
  "䱐": "rarely-used",
  "䱑": "rarely-used",
  "䱓": "rarely-used",
  "䱕": "rarely-used",
  "䱙": "rarely-used",
  "䱚": "rarely-used",
  "䱜": "rarely-used",
  "䱝": "rarely-used",
  "䱞": "rarely-used",
  "䱟": "rarely-used",
  "䱠": "rarely-used",
  "䱡": "rarely-used",
  "䱢": "rarely-used",
  "䱣": "rarely-used",
  "䱤": "rarely-used",
  "䱥": "rarely-used",
  "䱦": "rarely-used",
  "䱬": "rarely-used",
  "䱮": "rarely-used",
  "䱯": "rarely-used",
  "䱱": "rarely-used",
  "䱲": "rarely-used",
  "䱵": "rarely-used",
  "䱸": "rarely-used",
  "䱺": "rarely-used",
  "䱻": "rarely-used",
  "䱼": "rarely-used",
  "䱾": "rarely-used",
  "䱿": "rarely-used",
  "䲀": "rarely-used",
  "䲁": "rarely-used",
  "䲂": "rarely-used",
  "䲃": "rarely-used",
  "䲅": "rarely-used",
  "䲆": "rarely-used",
  "䲉": "rarely-used",
  "䲊": "rarely-used",
  "䲌": "rarely-used",
  "䲏": "rarely-used",
  "䲐": "rarely-used",
  "䲑": "rarely-used",
  "䲒": "rarely-used",
  "䲓": "rarely-used",
  "䲕": "rarely-used",
  "䲖": "rarely-used",
  "䲗": "rarely-used",
  "䲙": "rarely-used",
  "䲚": "rarely-used",
  "䲜": "rarely-used",
  "䲥": "rarely-used",
  "䲦": "rarely-used",
  "䲧": "rarely-used",
  "䲨": "rarely-used",
  "䲪": "rarely-used",
  "䲬": "rarely-used",
  "䲭": "rarely-used",
  "䲮": "rarely-used",
  "䲰": "rarely-used",
  "䲲": "rarely-used",
  "䲸": "rarely-used",
  "䲹": "rarely-used",
  "䲺": "rarely-used",
  "䲻": "rarely-used",
  "䲼": "rarely-used",
  "䲽": "rarely-used",
  "䲾": "rarely-used",
  "䳁": "rarely-used",
  "䳂": "rarely-used",
  "䳅": "rarely-used",
  "䳆": "rarely-used",
  "䳉": "rarely-used",
  "䳋": "rarely-used",
  "䳍": "rarely-used",
  "䳎": "rarely-used",
  "䳐": "rarely-used",
  "䳑": "rarely-used",
  "䳓": "rarely-used",
  "䳔": "rarely-used",
  "䳕": "rarely-used",
  "䳖": "rarely-used",
  "䳙": "rarely-used",
  "䳚": "rarely-used",
  "䳛": "rarely-used",
  "䳝": "rarely-used",
  "䳞": "rarely-used",
  "䳟": "rarely-used",
  "䳠": "rarely-used",
  "䳣": "rarely-used",
  "䳤": "rarely-used",
  "䳦": "rarely-used",
  "䳩": "rarely-used",
  "䳪": "rarely-used",
  "䳫": "rarely-used",
  "䳬": "rarely-used",
  "䳮": "rarely-used",
  "䳯": "rarely-used",
  "䳲": "rarely-used",
  "䳳": "rarely-used",
  "䳴": "rarely-used",
  "䳵": "rarely-used",
  "䳷": "rarely-used",
  "䳸": "rarely-used",
  "䳻": "rarely-used",
  "䳾": "rarely-used",
  "䳿": "rarely-used",
  "䴀": "rarely-used",
  "䴁": "rarely-used",
  "䴂": "rarely-used",
  "䴃": "rarely-used",
  "䴄": "rarely-used",
  "䴅": "rarely-used",
  "䴆": "rarely-used",
  "䴇": "rarely-used",
  "䴈": "rarely-used",
  "䴉": "rarely-used",
  "䴍": "rarely-used",
  "䴐": "rarely-used",
  "䴑": "rarely-used",
  "䴚": "rarely-used",
  "䴛": "rarely-used",
  "䴝": "rarely-used",
  "䴞": "rarely-used",
  "䴟": "rarely-used",
  "䴠": "rarely-used",
  "䴣": "rarely-used",
  "䴤": "rarely-used",
  "䴦": "rarely-used",
  "䴧": "rarely-used",
  "䴩": "rarely-used",
  "䴪": "rarely-used",
  "䴬": "rarely-used",
  "䴭": "rarely-used",
  "䴮": "rarely-used",
  "䴯": "rarely-used",
  "䴰": "rarely-used",
  "䴱": "rarely-used",
  "䴲": "rarely-used",
  "䴳": "rarely-used",
  "䴶": "rarely-used",
  "䴷": "rarely-used",
  "䴹": "rarely-used",
  "䴺": "rarely-used",
  "䴻": "rarely-used",
  "䴼": "rarely-used",
  "䴽": "rarely-used",
  "䴾": "rarely-used",
  "䴿": "rarely-used",
  "䵀": "rarely-used",
  "䵁": "rarely-used",
  "䵂": "rarely-used",
  "䵃": "rarely-used",
  "䵈": "rarely-used",
  "䵉": "rarely-used",
  "䵋": "rarely-used",
  "䵌": "rarely-used",
  "䵎": "rarely-used",
  "䵏": "rarely-used",
  "䵐": "rarely-used",
  "䵒": "rarely-used",
  "䵔": "rarely-used",
  "䵕": "rarely-used",
  "䵖": "rarely-used",
  "䵗": "rarely-used",
  "䵘": "rarely-used",
  "䵙": "rarely-used",
  "䵚": "rarely-used",
  "䵜": "rarely-used",
  "䵝": "rarely-used",
  "䵟": "rarely-used",
  "䵠": "rarely-used",
  "䵡": "rarely-used",
  "䵢": "rarely-used",
  "䵣": "rarely-used",
  "䵤": "rarely-used",
  "䵥": "rarely-used",
  "䵦": "rarely-used",
  "䵧": "rarely-used",
  "䵨": "rarely-used",
  "䵩": "rarely-used",
  "䵪": "rarely-used",
  "䵫": "rarely-used",
  "䵬": "rarely-used",
  "䵭": "rarely-used",
  "䵮": "rarely-used",
  "䵯": "rarely-used",
  "䵰": "rarely-used",
  "䵱": "rarely-used",
  "䵲": "rarely-used",
  "䵳": "rarely-used",
  "䵴": "rarely-used",
  "䵵": "rarely-used",
  "䵶": "rarely-used",
  "䵻": "rarely-used",
  "䵽": "rarely-used",
  "䵾": "rarely-used",
  "䶁": "rarely-used",
  "䶂": "rarely-used",
  "䶃": "rarely-used",
  "䶄": "rarely-used",
  "䶅": "rarely-used",
  "䶆": "rarely-used",
  "䶈": "rarely-used",
  "䶊": "rarely-used",
  "䶋": "rarely-used",
  "䶎": "rarely-used",
  "䶏": "rarely-used",
  "䶐": "rarely-used",
  "䶑": "rarely-used",
  "䶒": "rarely-used",
  "䶓": "rarely-used",
  "䶔": "rarely-used",
  "䶕": "rarely-used",
  "䶖": "rarely-used",
  "䶗": "rarely-used",
  "䶘": "rarely-used",
  "䶙": "rarely-used",
  "䶚": "rarely-used",
  "䶛": "rarely-used",
  "䶜": "rarely-used",
  "䶝": "rarely-used",
  "䶞": "rarely-used",
  "䶟": "rarely-used",
  "䶠": "rarely-used",
  "䶡": "rarely-used",
  "䶣": "rarely-used",
  "䶤": "rarely-used",
  "䶨": "rarely-used",
  "䶩": "rarely-used",
  "䶪": "rarely-used",
  "䶬": "rarely-used",
  "䶯": "rarely-used",
  "䶰": "rarely-used",
  "䶱": "rarely-used",
  "䶳": "rarely-used",
  "䶴": "rarely-used",
  "䶷": "rarely-used",
  "䶹": "rarely-used",
  "䶻": "rarely-used",
  "䶽": "rarely-used",
  "一": "common",
  "丁": "common",
  "丂": "rarely-used",
  "七": "common",
  "万": "less-than-common",
  "丈": "common",
  "三": "common",
  "上": "common",
  "下": "common",
  "丌": "less-than-common",
  "不": "common",
  "与": "less-than-common",
  "丏": "less-than-common",
  "丐": "common",
  "丑": "common",
  "且": "common",
  "丕": "common",
  "世": "common",
  "丘": "common",
  "丙": "common",
  "丞": "common",
  "丟": "common",
  "並": "common",
  "丨": "rarely-used",
  "丩": "rarely-used",
  "丫": "common",
  "中": "common",
  "丮": "less-than-common",
  "丯": "rarely-used",
  "丰": "less-than-common",
  "丱": "less-than-common",
  "串": "common",
  "丳": "rarely-used",
  "丵": "rarely-used",
  "丶": "rarely-used",
  "丸": "common",
  "丹": "common",
  "主": "common",
  "丼": "rarely-used",
  "丿": "rarely-used",
  "乀": "rarely-used",
  "乁": "rarely-used",
  "乂": "less-than-common",
  "乃": "common",
  "久": "common",
  "乇": "rarely-used",
  "么": "common",
  "之": "common",
  "乍": "common",
  "乎": "common",
  "乏": "common",
  "乒": "common",
  "乓": "common",
  "乔": "rarely-used",
  "乖": "common",
  "乘": "common",
  "乙": "common",
  "乜": "less-than-common",
  "九": "common",
  "乞": "common",
  "也": "common",
  "乣": "rarely-used",
  "乩": "common",
  "乪": "rarely-used",
  "乳": "common",
  "乴": "rarely-used",
  "乵": "rarely-used",
  "乾": "common",
  "乿": "rarely-used",
  "亂": "common",
  "亃": "rarely-used",
  "亄": "rarely-used",
  "亅": "rarely-used",
  "了": "common",
  "予": "common",
  "事": "common",
  "二": "common",
  "亍": "less-than-common",
  "于": "common",
  "云": "common",
  "互": "common",
  "亓": "less-than-common",
  "五": "common",
  "井": "common",
  "亙": "common",
  "些": "common",
  "亞": "common",
  "亟": "common",
  "亡": "common",
  "亢": "less-than-common",
  "交": "common",
  "亥": "common",
  "亦": "common",
  "亨": "common",
  "享": "common",
  "京": "common",
  "亭": "common",
  "亮": "common",
  "亳": "less-than-common",
  "亴": "rarely-used",
  "亶": "less-than-common",
  "亹": "less-than-common",
  "人": "common",
  "亼": "rarely-used",
  "什": "common",
  "仁": "common",
  "仂": "less-than-common",
  "仃": "common",
  "仄": "common",
  "仆": "common",
  "仇": "common",
  "仈": "rarely-used",
  "仉": "less-than-common",
  "今": "common",
  "介": "common",
  "仍": "common",
  "仔": "common",
  "仕": "common",
  "他": "common",
  "仗": "common",
  "付": "common",
  "仙": "common",
  "仚": "rarely-used",
  "仜": "less-than-common",
  "仝": "less-than-common",
  "仞": "common",
  "仟": "common",
  "仠": "rarely-used",
  "仡": "less-than-common",
  "代": "common",
  "令": "common",
  "以": "common",
  "仨": "less-than-common",
  "仩": "less-than-common",
  "仯": "rarely-used",
  "仰": "common",
  "仱": "less-than-common",
  "仲": "common",
  "仳": "common",
  "仴": "rarely-used",
  "仵": "less-than-common",
  "件": "common",
  "价": "less-than-common",
  "仸": "rarely-used",
  "仹": "rarely-used",
  "任": "common",
  "份": "common",
  "仿": "common",
  "伀": "less-than-common",
  "企": "common",
  "伂": "rarely-used",
  "伄": "rarely-used",
  "伅": "rarely-used",
  "伆": "rarely-used",
  "伈": "rarely-used",
  "伉": "common",
  "伊": "common",
  "伋": "less-than-common",
  "伌": "rarely-used",
  "伍": "common",
  "伎": "less-than-common",
  "伏": "common",
  "伐": "common",
  "休": "common",
  "伒": "rarely-used",
  "伓": "rarely-used",
  "伔": "less-than-common",
  "伕": "common",
  "优": "less-than-common",
  "伙": "common",
  "伝": "rarely-used",
  "伢": "rarely-used",
  "伬": "less-than-common",
  "伭": "rarely-used",
  "伯": "common",
  "估": "common",
  "伳": "rarely-used",
  "伴": "common",
  "伶": "common",
  "伷": "rarely-used",
  "伸": "common",
  "伹": "rarely-used",
  "伺": "common",
  "伻": "less-than-common",
  "似": "common",
  "伽": "common",
  "伾": "less-than-common",
  "伿": "rarely-used",
  "佁": "less-than-common",
  "佃": "common",
  "佅": "rarely-used",
  "但": "common",
  "佇": "common",
  "佈": "less-than-common",
  "佉": "less-than-common",
  "佊": "rarely-used",
  "佌": "less-than-common",
  "位": "common",
  "低": "common",
  "住": "common",
  "佐": "common",
  "佑": "common",
  "佒": "less-than-common",
  "体": "less-than-common",
  "佔": "common",
  "何": "common",
  "佖": "less-than-common",
  "佗": "common",
  "佘": "less-than-common",
  "余": "common",
  "佚": "less-than-common",
  "佛": "common",
  "作": "common",
  "佝": "common",
  "佞": "common",
  "佟": "less-than-common",
  "你": "common",
  "佡": "rarely-used",
  "佢": "less-than-common",
  "佣": "common",
  "佤": "less-than-common",
  "佧": "less-than-common",
  "佩": "common",
  "佪": "less-than-common",
  "佫": "rarely-used",
  "佬": "common",
  "佭": "rarely-used",
  "佮": "rarely-used",
  "佯": "common",
  "佰": "common",
  "佳": "common",
  "佴": "less-than-common",
  "併": "common",
  "佶": "less-than-common",
  "佷": "less-than-common",
  "佸": "less-than-common",
  "佹": "less-than-common",
  "佺": "less-than-common",
  "佻": "common",
  "佼": "less-than-common",
  "佽": "less-than-common",
  "佾": "common",
  "使": "common",
  "侀": "less-than-common",
  "侁": "less-than-common",
  "侂": "rarely-used",
  "侃": "common",
  "侄": "less-than-common",
  "侅": "less-than-common",
  "來": "common",
  "侇": "less-than-common",
  "侈": "common",
  "侉": "less-than-common",
  "侊": "rarely-used",
  "例": "common",
  "侍": "common",
  "侏": "common",
  "侐": "less-than-common",
  "侑": "less-than-common",
  "侒": "rarely-used",
  "侓": "rarely-used",
  "侔": "less-than-common",
  "侕": "rarely-used",
  "侖": "common",
  "侗": "less-than-common",
  "侘": "less-than-common",
  "侙": "rarely-used",
  "侚": "less-than-common",
  "供": "common",
  "侜": "less-than-common",
  "依": "common",
  "侞": "less-than-common",
  "侮": "common",
  "侯": "common",
  "侰": "rarely-used",
  "侱": "rarely-used",
  "侲": "less-than-common",
  "侳": "less-than-common",
  "侵": "common",
  "侶": "common",
  "侷": "less-than-common",
  "侸": "rarely-used",
  "侹": "rarely-used",
  "侺": "rarely-used",
  "侻": "less-than-common",
  "侼": "rarely-used",
  "侾": "rarely-used",
  "便": "common",
  "俀": "rarely-used",
  "俁": "less-than-common",
  "係": "common",
  "促": "common",
  "俄": "common",
  "俅": "less-than-common",
  "俆": "rarely-used",
  "俇": "less-than-common",
  "俈": "rarely-used",
  "俉": "less-than-common",
  "俊": "common",
  "俋": "less-than-common",
  "俍": "less-than-common",
  "俎": "common",
  "俏": "common",
  "俐": "common",
  "俑": "common",
  "俒": "rarely-used",
  "俓": "less-than-common",
  "俔": "less-than-common",
  "俕": "rarely-used",
  "俖": "rarely-used",
  "俗": "common",
  "俘": "common",
  "俙": "less-than-common",
  "俚": "common",
  "俛": "less-than-common",
  "俜": "less-than-common",
  "保": "common",
  "俞": "common",
  "俟": "common",
  "俠": "common",
  "信": "common",
  "俬": "rarely-used",
  "修": "common",
  "俯": "common",
  "俰": "rarely-used",
  "俱": "common",
  "俳": "common",
  "俴": "less-than-common",
  "俵": "less-than-common",
  "俶": "less-than-common",
  "俷": "less-than-common",
  "俸": "common",
  "俹": "rarely-used",
  "俺": "common",
  "俾": "common",
  "俿": "rarely-used",
  "倀": "common",
  "倁": "rarely-used",
  "倃": "rarely-used",
  "倄": "rarely-used",
  "倅": "less-than-common",
  "倆": "common",
  "倇": "less-than-common",
  "倉": "common",
  "倊": "rarely-used",
  "個": "common",
  "倌": "common",
  "倍": "common",
  "倎": "rarely-used",
  "倏": "common",
  "們": "common",
  "倒": "common",
  "倓": "less-than-common",
  "倔": "common",
  "倕": "less-than-common",
  "倖": "common",
  "倗": "less-than-common",
  "倘": "common",
  "候": "common",
  "倚": "common",
  "倛": "less-than-common",
  "倜": "less-than-common",
  "倝": "rarely-used",
  "倞": "less-than-common",
  "借": "common",
  "倠": "less-than-common",
  "倡": "common",
  "倢": "less-than-common",
  "倣": "common",
  "倥": "common",
  "倦": "common",
  "倧": "rarely-used",
  "倨": "common",
  "倩": "common",
  "倪": "common",
  "倫": "common",
  "倬": "less-than-common",
  "倭": "common",
  "倯": "rarely-used",
  "倰": "less-than-common",
  "倱": "rarely-used",
  "倲": "rarely-used",
  "倳": "less-than-common",
  "倴": "rarely-used",
  "倵": "rarely-used",
  "倷": "less-than-common",
  "值": "common",
  "偀": "rarely-used",
  "偁": "less-than-common",
  "偂": "rarely-used",
  "偃": "common",
  "偄": "rarely-used",
  "偅": "less-than-common",
  "偆": "rarely-used",
  "假": "common",
  "偈": "less-than-common",
  "偉": "common",
  "偊": "less-than-common",
  "偋": "less-than-common",
  "偌": "common",
  "偍": "less-than-common",
  "偎": "common",
  "偏": "common",
  "偑": "rarely-used",
  "偒": "rarely-used",
  "偓": "less-than-common",
  "偔": "rarely-used",
  "偕": "common",
  "偗": "rarely-used",
  "偙": "rarely-used",
  "做": "common",
  "偛": "less-than-common",
  "停": "common",
  "偝": "less-than-common",
  "偞": "less-than-common",
  "偟": "less-than-common",
  "偠": "less-than-common",
  "偡": "less-than-common",
  "偢": "less-than-common",
  "偣": "rarely-used",
  "偤": "rarely-used",
  "健": "common",
  "偦": "rarely-used",
  "偧": "rarely-used",
  "偨": "less-than-common",
  "偩": "less-than-common",
  "偪": "less-than-common",
  "偫": "less-than-common",
  "偭": "less-than-common",
  "偮": "rarely-used",
  "偯": "less-than-common",
  "偰": "less-than-common",
  "偱": "rarely-used",
  "偲": "less-than-common",
  "偳": "rarely-used",
  "側": "common",
  "偵": "common",
  "偶": "common",
  "偷": "common",
  "偺": "common",
  "偽": "common",
  "傀": "common",
  "傂": "less-than-common",
  "傃": "less-than-common",
  "傄": "rarely-used",
  "傅": "common",
  "傆": "rarely-used",
  "傇": "rarely-used",
  "傈": "rarely-used",
  "傉": "rarely-used",
  "傊": "rarely-used",
  "傋": "less-than-common",
  "傌": "less-than-common",
  "傍": "common",
  "傎": "less-than-common",
  "傏": "rarely-used",
  "傐": "rarely-used",
  "傑": "common",
  "傒": "less-than-common",
  "傔": "less-than-common",
  "傕": "less-than-common",
  "傖": "common",
  "傗": "rarely-used",
  "傘": "common",
  "備": "common",
  "傚": "less-than-common",
  "傛": "less-than-common",
  "傜": "less-than-common",
  "傝": "less-than-common",
  "傞": "less-than-common",
  "傟": "rarely-used",
  "傠": "rarely-used",
  "傢": "common",
  "傣": "less-than-common",
  "傪": "rarely-used",
  "催": "common",
  "傭": "common",
  "傮": "less-than-common",
  "傯": "common",
  "傰": "less-than-common",
  "傱": "less-than-common",
  "傲": "common",
  "傳": "common",
  "傴": "less-than-common",
  "債": "common",
  "傶": "rarely-used",
  "傷": "common",
  "傸": "rarely-used",
  "傺": "less-than-common",
  "傻": "common",
  "傼": "rarely-used",
  "傽": "less-than-common",
  "傾": "common",
  "傿": "less-than-common",
  "僀": "rarely-used",
  "僁": "less-than-common",
  "僂": "less-than-common",
  "僄": "less-than-common",
  "僅": "common",
  "僆": "less-than-common",
  "僇": "less-than-common",
  "僈": "less-than-common",
  "僉": "less-than-common",
  "僊": "less-than-common",
  "僋": "less-than-common",
  "僌": "rarely-used",
  "僎": "less-than-common",
  "像": "common",
  "僐": "rarely-used",
  "僑": "common",
  "僒": "rarely-used",
  "僓": "less-than-common",
  "僔": "less-than-common",
  "僕": "common",
  "僖": "common",
  "僗": "less-than-common",
  "僘": "rarely-used",
  "僙": "rarely-used",
  "僚": "common",
  "僛": "less-than-common",
  "僜": "rarely-used",
  "僝": "less-than-common",
  "僟": "rarely-used",
  "僠": "rarely-used",
  "僣": "rarely-used",
  "僤": "less-than-common",
  "僥": "common",
  "僦": "less-than-common",
  "僧": "common",
  "僨": "less-than-common",
  "僩": "less-than-common",
  "僪": "less-than-common",
  "僬": "less-than-common",
  "僭": "common",
  "僮": "common",
  "僯": "rarely-used",
  "僰": "less-than-common",
  "僱": "common",
  "僳": "less-than-common",
  "僵": "common",
  "僶": "less-than-common",
  "僸": "less-than-common",
  "價": "common",
  "僺": "rarely-used",
  "僻": "common",
  "僽": "less-than-common",
  "僾": "less-than-common",
  "僿": "less-than-common",
  "儀": "common",
  "儂": "common",
  "儃": "less-than-common",
  "億": "common",
  "儅": "rarely-used",
  "儆": "less-than-common",
  "儇": "less-than-common",
  "儈": "common",
  "儉": "common",
  "儊": "rarely-used",
  "儋": "less-than-common",
  "儌": "less-than-common",
  "儐": "common",
  "儑": "less-than-common",
  "儒": "common",
  "儓": "less-than-common",
  "儔": "common",
  "儕": "less-than-common",
  "儖": "rarely-used",
  "儗": "less-than-common",
  "儘": "common",
  "儙": "rarely-used",
  "儚": "less-than-common",
  "儜": "less-than-common",
  "儝": "rarely-used",
  "償": "common",
  "儠": "less-than-common",
  "儡": "common",
  "儢": "less-than-common",
  "儣": "rarely-used",
  "儤": "less-than-common",
  "儥": "less-than-common",
  "儦": "less-than-common",
  "儨": "rarely-used",
  "儩": "rarely-used",
  "優": "common",
  "儭": "rarely-used",
  "儮": "rarely-used",
  "儯": "rarely-used",
  "儰": "less-than-common",
  "儱": "less-than-common",
  "儲": "common",
  "儳": "less-than-common",
  "儴": "less-than-common",
  "儵": "less-than-common",
  "儶": "rarely-used",
  "儷": "common",
  "儸": "less-than-common",
  "儹": "less-than-common",
  "儺": "less-than-common",
  "儻": "less-than-common",
  "儼": "common",
  "儽": "less-than-common",
  "儾": "rarely-used",
  "儿": "rarely-used",
  "兀": "common",
  "允": "common",
  "元": "common",
  "兄": "common",
  "充": "common",
  "兆": "common",
  "兇": "common",
  "先": "common",
  "光": "common",
  "克": "common",
  "兌": "common",
  "免": "common",
  "兒": "common",
  "兓": "rarely-used",
  "兔": "common",
  "兕": "common",
  "兗": "common",
  "党": "less-than-common",
  "兜": "common",
  "兟": "rarely-used",
  "兢": "common",
  "入": "common",
  "內": "common",
  "全": "common",
  "兩": "common",
  "八": "common",
  "公": "common",
  "六": "common",
  "兮": "common",
  "共": "common",
  "兵": "common",
  "其": "common",
  "具": "common",
  "典": "common",
  "兼": "common",
  "冀": "common",
  "冇": "less-than-common",
  "冉": "common",
  "冊": "common",
  "再": "common",
  "冏": "less-than-common",
  "冑": "common",
  "冒": "common",
  "冓": "less-than-common",
  "冔": "less-than-common",
  "冕": "common",
  "冗": "common",
  "冘": "less-than-common",
  "冞": "less-than-common",
  "冟": "rarely-used",
  "冠": "common",
  "冢": "common",
  "冣": "rarely-used",
  "冤": "common",
  "冥": "common",
  "冪": "less-than-common",
  "冬": "common",
  "冭": "rarely-used",
  "冰": "common",
  "冱": "less-than-common",
  "冶": "common",
  "冷": "common",
  "冹": "rarely-used",
  "冼": "less-than-common",
  "冽": "common",
  "冾": "rarely-used",
  "冿": "rarely-used",
  "凁": "rarely-used",
  "凄": "less-than-common",
  "凅": "less-than-common",
  "准": "common",
  "凇": "rarely-used",
  "凈": "rarely-used",
  "凊": "less-than-common",
  "凋": "common",
  "凌": "common",
  "凍": "common",
  "凎": "rarely-used",
  "凐": "rarely-used",
  "凓": "rarely-used",
  "凔": "less-than-common",
  "凕": "rarely-used",
  "凗": "rarely-used",
  "凘": "less-than-common",
  "凙": "rarely-used",
  "凚": "rarely-used",
  "凜": "common",
  "凝": "common",
  "凞": "rarely-used",
  "几": "common",
  "凡": "common",
  "凰": "common",
  "凱": "common",
  "凳": "common",
  "凶": "common",
  "凸": "common",
  "凹": "common",
  "出": "common",
  "函": "common",
  "刀": "common",
  "刁": "common",
  "刃": "common",
  "刅": "rarely-used",
  "分": "common",
  "切": "common",
  "刈": "common",
  "刉": "less-than-common",
  "刊": "common",
  "刌": "less-than-common",
  "刎": "common",
  "刏": "rarely-used",
  "刐": "rarely-used",
  "刑": "common",
  "划": "common",
  "刓": "less-than-common",
  "刔": "rarely-used",
  "刕": "rarely-used",
  "刖": "less-than-common",
  "列": "common",
  "刜": "less-than-common",
  "初": "common",
  "刞": "less-than-common",
  "刡": "rarely-used",
  "刢": "rarely-used",
  "刣": "rarely-used",
  "判": "common",
  "別": "common",
  "刨": "common",
  "利": "common",
  "刪": "common",
  "刮": "common",
  "刯": "rarely-used",
  "到": "common",
  "刱": "less-than-common",
  "刲": "less-than-common",
  "刳": "less-than-common",
  "刵": "less-than-common",
  "制": "common",
  "刷": "common",
  "券": "common",
  "刺": "common",
  "刻": "common",
  "剁": "common",
  "剃": "common",
  "剄": "less-than-common",
  "剅": "rarely-used",
  "剆": "less-than-common",
  "則": "common",
  "剈": "rarely-used",
  "剉": "less-than-common",
  "削": "common",
  "剋": "common",
  "剌": "common",
  "前": "common",
  "剎": "common",
  "剒": "less-than-common",
  "剔": "common",
  "剕": "less-than-common",
  "剖": "common",
  "剘": "rarely-used",
  "剚": "less-than-common",
  "剛": "common",
  "剜": "common",
  "剝": "common",
  "剞": "less-than-common",
  "剟": "less-than-common",
  "剡": "less-than-common",
  "剢": "rarely-used",
  "剨": "rarely-used",
  "剩": "common",
  "剪": "common",
  "剫": "less-than-common",
  "剬": "less-than-common",
  "剭": "less-than-common",
  "剮": "rarely-used",
  "副": "common",
  "割": "common",
  "剴": "common",
  "創": "common",
  "剶": "rarely-used",
  "剷": "common",
  "剸": "less-than-common",
  "剹": "rarely-used",
  "剺": "less-than-common",
  "剻": "less-than-common",
  "剼": "less-than-common",
  "剽": "common",
  "剾": "rarely-used",
  "剿": "common",
  "劀": "less-than-common",
  "劁": "less-than-common",
  "劂": "less-than-common",
  "劃": "common",
  "劄": "less-than-common",
  "劆": "rarely-used",
  "劇": "common",
  "劈": "common",
  "劉": "common",
  "劊": "less-than-common",
  "劋": "less-than-common",
  "劌": "less-than-common",
  "劍": "common",
  "劐": "rarely-used",
  "劑": "common",
  "劓": "less-than-common",
  "劕": "rarely-used",
  "劖": "less-than-common",
  "劗": "less-than-common",
  "劘": "less-than-common",
  "劙": "less-than-common",
  "力": "common",
  "劜": "rarely-used",
  "功": "common",
  "加": "common",
  "劣": "common",
  "劤": "rarely-used",
  "劥": "rarely-used",
  "劦": "less-than-common",
  "劧": "rarely-used",
  "助": "common",
  "努": "common",
  "劫": "common",
  "劬": "common",
  "劭": "less-than-common",
  "劮": "rarely-used",
  "劯": "rarely-used",
  "劰": "rarely-used",
  "劶": "rarely-used",
  "劷": "rarely-used",
  "劸": "rarely-used",
  "劺": "rarely-used",
  "劻": "rarely-used",
  "劼": "less-than-common",
  "劽": "rarely-used",
  "劾": "common",
  "勀": "rarely-used",
  "勁": "common",
  "勂": "rarely-used",
  "勃": "common",
  "勆": "rarely-used",
  "勇": "common",
  "勉": "common",
  "勍": "less-than-common",
  "勏": "rarely-used",
  "勒": "common",
  "勓": "rarely-used",
  "動": "common",
  "勖": "less-than-common",
  "勗": "common",
  "勘": "common",
  "務": "common",
  "勛": "common",
  "勜": "rarely-used",
  "勝": "common",
  "勞": "common",
  "募": "common",
  "勢": "common",
  "勣": "less-than-common",
  "勤": "common",
  "勦": "common",
  "勨": "rarely-used",
  "勩": "less-than-common",
  "勪": "rarely-used",
  "勫": "rarely-used",
  "勬": "rarely-used",
  "勭": "rarely-used",
  "勮": "rarely-used",
  "勯": "rarely-used",
  "勰": "less-than-common",
  "勱": "less-than-common",
  "勴": "less-than-common",
  "勵": "common",
  "勶": "rarely-used",
  "勷": "rarely-used",
  "勸": "common",
  "勺": "less-than-common",
  "勻": "common",
  "勼": "rarely-used",
  "勽": "rarely-used",
  "勾": "common",
  "勿": "common",
  "包": "common",
  "匆": "common",
  "匈": "common",
  "匉": "rarely-used",
  "匊": "less-than-common",
  "匋": "rarely-used",
  "匌": "rarely-used",
  "匍": "common",
  "匎": "rarely-used",
  "匏": "common",
  "匐": "common",
  "匑": "rarely-used",
  "匒": "rarely-used",
  "匕": "common",
  "化": "common",
  "北": "common",
  "匙": "common",
  "匚": "rarely-used",
  "匜": "less-than-common",
  "匝": "common",
  "匟": "rarely-used",
  "匠": "common",
  "匡": "common",
  "匢": "less-than-common",
  "匣": "common",
  "匤": "rarely-used",
  "匨": "rarely-used",
  "匪": "common",
  "匬": "rarely-used",
  "匭": "less-than-common",
  "匯": "common",
  "匰": "less-than-common",
  "匱": "common",
  "匴": "less-than-common",
  "匷": "less-than-common",
  "匸": "rarely-used",
  "匹": "common",
  "医": "rarely-used",
  "匼": "less-than-common",
  "匽": "less-than-common",
  "匾": "common",
  "匿": "common",
  "區": "common",
  "十": "common",
  "卂": "rarely-used",
  "千": "common",
  "卅": "common",
  "升": "common",
  "午": "common",
  "卉": "common",
  "半": "common",
  "卌": "less-than-common",
  "卍": "less-than-common",
  "卑": "common",
  "卒": "common",
  "卓": "common",
  "協": "common",
  "南": "common",
  "卙": "rarely-used",
  "博": "common",
  "卜": "common",
  "卞": "common",
  "卟": "rarely-used",
  "占": "common",
  "卡": "common",
  "卣": "less-than-common",
  "卦": "common",
  "卩": "rarely-used",
  "卬": "less-than-common",
  "卮": "common",
  "卯": "common",
  "印": "common",
  "危": "common",
  "卲": "rarely-used",
  "即": "common",
  "卵": "common",
  "卶": "rarely-used",
  "卷": "common",
  "卸": "common",
  "卹": "common",
  "卻": "common",
  "卼": "less-than-common",
  "卾": "rarely-used",
  "卿": "common",
  "厂": "less-than-common",
  "厃": "rarely-used",
  "厄": "common",
  "厊": "rarely-used",
  "厎": "less-than-common",
  "厏": "rarely-used",
  "厒": "less-than-common",
  "厔": "rarely-used",
  "厖": "less-than-common",
  "厗": "less-than-common",
  "厘": "rarely-used",
  "厙": "rarely-used",
  "厚": "common",
  "厜": "less-than-common",
  "厝": "common",
  "厞": "less-than-common",
  "原": "common",
  "厤": "less-than-common",
  "厥": "common",
  "厧": "rarely-used",
  "厬": "less-than-common",
  "厭": "common",
  "厱": "rarely-used",
  "厲": "common",
  "厴": "rarely-used",
  "厶": "rarely-used",
  "厸": "rarely-used",
  "厹": "less-than-common",
  "去": "common",
  "厽": "rarely-used",
  "叀": "rarely-used",
  "參": "common",
  "叄": "less-than-common",
  "又": "common",
  "叉": "common",
  "及": "common",
  "友": "common",
  "反": "common",
  "叔": "common",
  "叕": "rarely-used",
  "取": "common",
  "受": "common",
  "叛": "common",
  "叝": "rarely-used",
  "叟": "common",
  "叡": "less-than-common",
  "叢": "common",
  "口": "common",
  "古": "common",
  "句": "common",
  "另": "common",
  "叨": "common",
  "叩": "common",
  "只": "common",
  "叫": "common",
  "召": "common",
  "叭": "common",
  "叮": "common",
  "可": "common",
  "台": "common",
  "叱": "common",
  "史": "common",
  "右": "common",
  "叵": "common",
  "司": "common",
  "叻": "less-than-common",
  "叼": "common",
  "叿": "rarely-used",
  "吀": "rarely-used",
  "吁": "common",
  "吂": "rarely-used",
  "吃": "common",
  "各": "common",
  "吆": "common",
  "吇": "rarely-used",
  "合": "common",
  "吉": "common",
  "吊": "common",
  "吋": "common",
  "同": "common",
  "名": "common",
  "后": "common",
  "吏": "common",
  "吐": "common",
  "向": "common",
  "吒": "common",
  "吖": "rarely-used",
  "吘": "rarely-used",
  "吙": "rarely-used",
  "君": "common",
  "吜": "rarely-used",
  "吝": "common",
  "吞": "common",
  "吟": "common",
  "吠": "common",
  "吤": "rarely-used",
  "吥": "rarely-used",
  "否": "common",
  "吧": "common",
  "吨": "rarely-used",
  "吩": "common",
  "吪": "less-than-common",
  "含": "common",
  "听": "less-than-common",
  "吭": "common",
  "吮": "common",
  "吰": "less-than-common",
  "吱": "common",
  "吳": "common",
  "吵": "common",
  "吶": "common",
  "吷": "less-than-common",
  "吸": "common",
  "吹": "common",
  "吺": "rarely-used",
  "吻": "common",
  "吼": "common",
  "吽": "rarely-used",
  "吾": "common",
  "呀": "common",
  "呁": "rarely-used",
  "呂": "common",
  "呃": "common",
  "呄": "rarely-used",
  "呅": "rarely-used",
  "呆": "common",
  "呇": "rarely-used",
  "呈": "common",
  "告": "common",
  "呍": "rarely-used",
  "呎": "common",
  "呏": "rarely-used",
  "呔": "less-than-common",
  "呟": "rarely-used",
  "呠": "rarely-used",
  "呡": "rarely-used",
  "呢": "common",
  "呣": "rarely-used",
  "呤": "rarely-used",
  "呥": "less-than-common",
  "呦": "less-than-common",
  "呧": "rarely-used",
  "周": "common",
  "呫": "less-than-common",
  "呬": "less-than-common",
  "呮": "rarely-used",
  "呯": "rarely-used",
  "呰": "less-than-common",
  "呱": "common",
  "呲": "rarely-used",
  "味": "common",
  "呴": "less-than-common",
  "呵": "common",
  "呶": "common",
  "呷": "common",
  "呸": "common",
  "呹": "rarely-used",
  "呺": "less-than-common",
  "呻": "common",
  "呼": "common",
  "命": "common",
  "呾": "less-than-common",
  "呿": "less-than-common",
  "咀": "common",
  "咁": "less-than-common",
  "咂": "less-than-common",
  "咃": "rarely-used",
  "咄": "common",
  "咅": "rarely-used",
  "咆": "common",
  "咇": "less-than-common",
  "咈": "less-than-common",
  "咉": "rarely-used",
  "咋": "common",
  "和": "common",
  "咍": "less-than-common",
  "咎": "common",
  "咐": "common",
  "咑": "less-than-common",
  "咒": "common",
  "咓": "rarely-used",
  "咕": "common",
  "咖": "common",
  "咘": "rarely-used",
  "咚": "common",
  "咠": "less-than-common",
  "咡": "less-than-common",
  "咢": "less-than-common",
  "咣": "rarely-used",
  "咥": "less-than-common",
  "咦": "common",
  "咧": "less-than-common",
  "咨": "common",
  "咩": "less-than-common",
  "咪": "common",
  "咫": "common",
  "咬": "common",
  "咭": "less-than-common",
  "咮": "less-than-common",
  "咯": "common",
  "咰": "rarely-used",
  "咱": "common",
  "咳": "common",
  "咴": "rarely-used",
  "咶": "less-than-common",
  "咷": "less-than-common",
  "咸": "common",
  "咹": "rarely-used",
  "咺": "less-than-common",
  "咻": "common",
  "咼": "less-than-common",
  "咽": "common",
  "咾": "rarely-used",
  "咿": "less-than-common",
  "哀": "common",
  "品": "common",
  "哂": "common",
  "哃": "less-than-common",
  "哄": "common",
  "哅": "less-than-common",
  "哆": "less-than-common",
  "哇": "common",
  "哈": "common",
  "哉": "common",
  "哊": "rarely-used",
  "哎": "common",
  "哏": "less-than-common",
  "哐": "rarely-used",
  "哖": "less-than-common",
  "哚": "rarely-used",
  "哞": "rarely-used",
  "哠": "rarely-used",
  "員": "common",
  "哢": "less-than-common",
  "哤": "less-than-common",
  "哥": "common",
  "哦": "common",
  "哧": "less-than-common",
  "哨": "common",
  "哩": "common",
  "哪": "common",
  "哫": "less-than-common",
  "哬": "rarely-used",
  "哭": "common",
  "哮": "common",
  "哯": "rarely-used",
  "哱": "rarely-used",
  "哲": "common",
  "哳": "less-than-common",
  "哴": "rarely-used",
  "哵": "rarely-used",
  "哷": "rarely-used",
  "哸": "rarely-used",
  "哹": "rarely-used",
  "哺": "common",
  "哻": "rarely-used",
  "哼": "common",
  "哽": "less-than-common",
  "哾": "rarely-used",
  "哿": "less-than-common",
  "唀": "rarely-used",
  "唁": "common",
  "唂": "rarely-used",
  "唃": "rarely-used",
  "唄": "less-than-common",
  "唅": "less-than-common",
  "唆": "common",
  "唇": "less-than-common",
  "唈": "less-than-common",
  "唉": "common",
  "唊": "rarely-used",
  "唋": "rarely-used",
  "唌": "less-than-common",
  "唍": "rarely-used",
  "唎": "rarely-used",
  "唏": "less-than-common",
  "唐": "common",
  "唑": "less-than-common",
  "唒": "less-than-common",
  "唓": "rarely-used",
  "唔": "common",
  "唕": "rarely-used",
  "唗": "less-than-common",
  "唚": "less-than-common",
  "唦": "less-than-common",
  "唧": "common",
  "唩": "rarely-used",
  "唪": "less-than-common",
  "唬": "common",
  "唭": "rarely-used",
  "售": "common",
  "唯": "common",
  "唰": "less-than-common",
  "唱": "common",
  "唲": "less-than-common",
  "唳": "common",
  "唴": "less-than-common",
  "唵": "less-than-common",
  "唶": "less-than-common",
  "唷": "common",
  "唸": "common",
  "唹": "rarely-used",
  "唻": "rarely-used",
  "唼": "less-than-common",
  "唾": "common",
  "啀": "rarely-used",
  "啁": "less-than-common",
  "啂": "rarely-used",
  "啃": "common",
  "啄": "common",
  "啅": "less-than-common",
  "商": "common",
  "啇": "rarely-used",
  "啈": "rarely-used",
  "啉": "rarely-used",
  "啊": "common",
  "啋": "rarely-used",
  "啌": "rarely-used",
  "啍": "less-than-common",
  "啎": "less-than-common",
  "問": "common",
  "啐": "less-than-common",
  "啑": "less-than-common",
  "啒": "less-than-common",
  "啕": "common",
  "啖": "common",
  "啗": "less-than-common",
  "啘": "rarely-used",
  "啛": "rarely-used",
  "啜": "common",
  "啝": "rarely-used",
  "啞": "common",
  "啟": "common",
  "啡": "common",
  "啢": "less-than-common",
  "啣": "common",
  "啤": "common",
  "啥": "less-than-common",
  "啦": "common",
  "啨": "rarely-used",
  "啪": "common",
  "啵": "less-than-common",
  "啶": "less-than-common",
  "啷": "less-than-common",
  "啻": "common",
  "啼": "common",
  "啽": "less-than-common",
  "啾": "common",
  "啿": "rarely-used",
  "喀": "common",
  "喁": "less-than-common",
  "喂": "common",
  "喃": "common",
  "善": "common",
  "喅": "rarely-used",
  "喇": "common",
  "喈": "less-than-common",
  "喉": "common",
  "喊": "common",
  "喋": "common",
  "喌": "less-than-common",
  "喍": "less-than-common",
  "喎": "rarely-used",
  "喏": "less-than-common",
  "喐": "rarely-used",
  "喑": "less-than-common",
  "喒": "less-than-common",
  "喓": "less-than-common",
  "喔": "common",
  "喕": "rarely-used",
  "喖": "rarely-used",
  "喗": "rarely-used",
  "喘": "common",
  "喙": "less-than-common",
  "喚": "common",
  "喛": "rarely-used",
  "喜": "common",
  "喝": "common",
  "喟": "common",
  "喠": "rarely-used",
  "喡": "rarely-used",
  "喢": "less-than-common",
  "喣": "less-than-common",
  "喤": "less-than-common",
  "喥": "less-than-common",
  "喦": "less-than-common",
  "喧": "common",
  "喨": "less-than-common",
  "喪": "common",
  "喫": "less-than-common",
  "喬": "common",
  "喭": "less-than-common",
  "單": "common",
  "喱": "common",
  "喲": "common",
  "喳": "common",
  "喴": "rarely-used",
  "喵": "less-than-common",
  "喻": "common",
  "喿": "less-than-common",
  "嗀": "less-than-common",
  "嗂": "rarely-used",
  "嗃": "less-than-common",
  "嗄": "less-than-common",
  "嗅": "common",
  "嗆": "common",
  "嗇": "common",
  "嗈": "less-than-common",
  "嗉": "less-than-common",
  "嗊": "less-than-common",
  "嗋": "less-than-common",
  "嗌": "less-than-common",
  "嗍": "rarely-used",
  "嗎": "common",
  "嗏": "less-than-common",
  "嗐": "less-than-common",
  "嗑": "common",
  "嗒": "less-than-common",
  "嗓": "common",
  "嗔": "less-than-common",
  "嗕": "less-than-common",
  "嗖": "less-than-common",
  "嗗": "rarely-used",
  "嗘": "rarely-used",
  "嗙": "rarely-used",
  "嗚": "common",
  "嗛": "less-than-common",
  "嗜": "common",
  "嗝": "less-than-common",
  "嗞": "rarely-used",
  "嗟": "common",
  "嗡": "common",
  "嗢": "less-than-common",
  "嗣": "common",
  "嗤": "common",
  "嗥": "common",
  "嗦": "common",
  "嗨": "common",
  "嗩": "less-than-common",
  "嗪": "rarely-used",
  "嗯": "common",
  "嗲": "less-than-common",
  "嗶": "less-than-common",
  "嗷": "common",
  "嗹": "rarely-used",
  "嗺": "less-than-common",
  "嗻": "rarely-used",
  "嗼": "less-than-common",
  "嗽": "common",
  "嗾": "common",
  "嗿": "less-than-common",
  "嘀": "common",
  "嘁": "less-than-common",
  "嘂": "less-than-common",
  "嘃": "rarely-used",
  "嘄": "less-than-common",
  "嘆": "common",
  "嘇": "rarely-used",
  "嘈": "common",
  "嘉": "common",
  "嘋": "rarely-used",
  "嘌": "less-than-common",
  "嘍": "common",
  "嘎": "common",
  "嘏": "less-than-common",
  "嘐": "less-than-common",
  "嘒": "less-than-common",
  "嘓": "less-than-common",
  "嘔": "common",
  "嘕": "less-than-common",
  "嘖": "common",
  "嘗": "common",
  "嘙": "rarely-used",
  "嘛": "common",
  "嘜": "less-than-common",
  "嘝": "less-than-common",
  "嘟": "common",
  "嘦": "rarely-used",
  "嘧": "less-than-common",
  "嘩": "common",
  "嘪": "rarely-used",
  "嘬": "less-than-common",
  "嘭": "rarely-used",
  "嘮": "common",
  "嘯": "common",
  "嘰": "common",
  "嘲": "common",
  "嘳": "less-than-common",
  "嘴": "common",
  "嘵": "less-than-common",
  "嘶": "common",
  "嘸": "less-than-common",
  "嘹": "common",
  "嘺": "rarely-used",
  "嘻": "common",
  "嘼": "rarely-used",
  "嘽": "less-than-common",
  "嘾": "less-than-common",
  "嘿": "common",
  "噀": "less-than-common",
  "噁": "less-than-common",
  "噂": "less-than-common",
  "噃": "rarely-used",
  "噅": "less-than-common",
  "噆": "less-than-common",
  "噇": "rarely-used",
  "噈": "less-than-common",
  "噉": "less-than-common",
  "噊": "less-than-common",
  "噌": "less-than-common",
  "噍": "less-than-common",
  "噎": "common",
  "噓": "common",
  "噔": "rarely-used",
  "噗": "common",
  "噘": "less-than-common",
  "噙": "common",
  "噚": "less-than-common",
  "噞": "less-than-common",
  "噠": "less-than-common",
  "噢": "common",
  "噣": "less-than-common",
  "噤": "common",
  "噥": "common",
  "噦": "less-than-common",
  "噧": "rarely-used",
  "器": "common",
  "噩": "common",
  "噪": "common",
  "噫": "common",
  "噬": "common",
  "噭": "less-than-common",
  "噮": "less-than-common",
  "噯": "common",
  "噰": "less-than-common",
  "噱": "common",
  "噲": "less-than-common",
  "噳": "less-than-common",
  "噴": "common",
  "噶": "less-than-common",
  "噷": "rarely-used",
  "噸": "common",
  "噹": "common",
  "噻": "rarely-used",
  "噾": "rarely-used",
  "噿": "rarely-used",
  "嚀": "common",
  "嚁": "rarely-used",
  "嚂": "rarely-used",
  "嚃": "less-than-common",
  "嚄": "less-than-common",
  "嚅": "common",
  "嚆": "less-than-common",
  "嚇": "common",
  "嚈": "rarely-used",
  "嚊": "rarely-used",
  "嚌": "less-than-common",
  "嚍": "less-than-common",
  "嚎": "common",
  "嚏": "common",
  "嚐": "common",
  "嚓": "less-than-common",
  "嚕": "common",
  "嚗": "less-than-common",
  "嚘": "less-than-common",
  "嚙": "rarely-used",
  "嚚": "less-than-common",
  "嚛": "rarely-used",
  "嚜": "less-than-common",
  "嚝": "rarely-used",
  "嚟": "rarely-used",
  "嚥": "common",
  "嚦": "less-than-common",
  "嚧": "less-than-common",
  "嚨": "common",
  "嚩": "rarely-used",
  "嚪": "less-than-common",
  "嚫": "less-than-common",
  "嚬": "less-than-common",
  "嚭": "less-than-common",
  "嚮": "common",
  "嚱": "rarely-used",
  "嚲": "less-than-common",
  "嚳": "less-than-common",
  "嚴": "common",
  "嚵": "less-than-common",
  "嚶": "common",
  "嚷": "common",
  "嚼": "common",
  "嚽": "less-than-common",
  "嚾": "less-than-common",
  "嚿": "rarely-used",
  "囀": "common",
  "囁": "common",
  "囂": "common",
  "囃": "less-than-common",
  "囅": "less-than-common",
  "囆": "less-than-common",
  "囈": "common",
  "囉": "common",
  "囊": "common",
  "囋": "less-than-common",
  "囌": "common",
  "囍": "less-than-common",
  "囐": "rarely-used",
  "囑": "common",
  "囓": "less-than-common",
  "囔": "less-than-common",
  "囗": "less-than-common",
  "囚": "common",
  "四": "common",
  "囜": "rarely-used",
  "囝": "less-than-common",
  "回": "common",
  "囟": "less-than-common",
  "因": "common",
  "囡": "less-than-common",
  "囤": "common",
  "囥": "rarely-used",
  "囧": "less-than-common",
  "囩": "rarely-used",
  "囪": "common",
  "囫": "less-than-common",
  "囮": "less-than-common",
  "困": "common",
  "囲": "rarely-used",
  "囷": "less-than-common",
  "囹": "less-than-common",
  "固": "common",
  "囿": "less-than-common",
  "圁": "less-than-common",
  "圂": "less-than-common",
  "圃": "common",
  "圄": "less-than-common",
  "圇": "less-than-common",
  "圈": "common",
  "圉": "less-than-common",
  "圊": "less-than-common",
  "國": "common",
  "圌": "less-than-common",
  "圍": "common",
  "圐": "rarely-used",
  "圑": "rarely-used",
  "園": "common",
  "圓": "common",
  "圔": "rarely-used",
  "圖": "common",
  "團": "common",
  "圚": "rarely-used",
  "圛": "rarely-used",
  "圜": "less-than-common",
  "圞": "less-than-common",
  "土": "common",
  "圠": "less-than-common",
  "圢": "rarely-used",
  "圣": "rarely-used",
  "圥": "rarely-used",
  "在": "common",
  "圩": "less-than-common",
  "圪": "rarely-used",
  "圬": "common",
  "圭": "common",
  "圮": "less-than-common",
  "圯": "common",
  "地": "common",
  "圱": "rarely-used",
  "圳": "common",
  "圴": "rarely-used",
  "圵": "rarely-used",
  "圶": "rarely-used",
  "圻": "less-than-common",
  "圼": "rarely-used",
  "圾": "common",
  "圿": "rarely-used",
  "址": "common",
  "坁": "less-than-common",
  "坄": "rarely-used",
  "坅": "less-than-common",
  "均": "common",
  "坈": "rarely-used",
  "坉": "rarely-used",
  "坊": "common",
  "坋": "rarely-used",
  "坌": "less-than-common",
  "坍": "common",
  "坎": "common",
  "坏": "common",
  "坐": "common",
  "坑": "common",
  "坒": "rarely-used",
  "坡": "common",
  "坢": "rarely-used",
  "坤": "common",
  "坥": "rarely-used",
  "坦": "common",
  "坨": "rarely-used",
  "坩": "common",
  "坪": "common",
  "坫": "less-than-common",
  "坬": "rarely-used",
  "坭": "less-than-common",
  "坯": "less-than-common",
  "坰": "less-than-common",
  "坱": "less-than-common",
  "坲": "less-than-common",
  "坳": "less-than-common",
  "坴": "less-than-common",
  "坵": "less-than-common",
  "坶": "less-than-common",
  "坷": "common",
  "坹": "rarely-used",
  "坺": "rarely-used",
  "坻": "less-than-common",
  "坼": "common",
  "坽": "rarely-used",
  "坾": "rarely-used",
  "垀": "less-than-common",
  "垁": "rarely-used",
  "垂": "common",
  "垃": "common",
  "型": "common",
  "垌": "less-than-common",
  "垍": "rarely-used",
  "垎": "rarely-used",
  "垏": "rarely-used",
  "垑": "rarely-used",
  "垒": "rarely-used",
  "垓": "less-than-common",
  "垔": "less-than-common",
  "垕": "rarely-used",
  "垗": "less-than-common",
  "垘": "less-than-common",
  "垙": "rarely-used",
  "垚": "rarely-used",
  "垛": "less-than-common",
  "垝": "less-than-common",
  "垞": "less-than-common",
  "垟": "less-than-common",
  "垠": "common",
  "垡": "rarely-used",
  "垢": "common",
  "垣": "common",
  "垤": "less-than-common",
  "垥": "rarely-used",
  "垬": "rarely-used",
  "垮": "common",
  "垴": "rarely-used",
  "垵": "less-than-common",
  "垶": "rarely-used",
  "垷": "rarely-used",
  "垸": "rarely-used",
  "垹": "rarely-used",
  "垺": "less-than-common",
  "垼": "less-than-common",
  "垽": "less-than-common",
  "垿": "rarely-used",
  "埁": "rarely-used",
  "埂": "common",
  "埃": "common",
  "埆": "less-than-common",
  "埇": "rarely-used",
  "埉": "rarely-used",
  "埋": "common",
  "埌": "less-than-common",
  "埍": "rarely-used",
  "城": "common",
  "埏": "less-than-common",
  "埐": "rarely-used",
  "埒": "less-than-common",
  "埔": "common",
  "埕": "less-than-common",
  "埜": "less-than-common",
  "埝": "rarely-used",
  "域": "common",
  "埠": "common",
  "埡": "rarely-used",
  "埢": "less-than-common",
  "埣": "rarely-used",
  "埤": "common",
  "埥": "rarely-used",
  "埧": "rarely-used",
  "埩": "rarely-used",
  "埪": "rarely-used",
  "埫": "rarely-used",
  "埬": "rarely-used",
  "埭": "less-than-common",
  "埮": "rarely-used",
  "埯": "rarely-used",
  "埰": "rarely-used",
  "埱": "rarely-used",
  "埲": "rarely-used",
  "埳": "less-than-common",
  "埴": "less-than-common",
  "埵": "less-than-common",
  "埶": "less-than-common",
  "執": "common",
  "埸": "less-than-common",
  "培": "common",
  "基": "common",
  "埻": "less-than-common",
  "埼": "rarely-used",
  "埽": "less-than-common",
  "埾": "rarely-used",
  "堀": "less-than-common",
  "堁": "rarely-used",
  "堂": "common",
  "堄": "rarely-used",
  "堅": "common",
  "堆": "common",
  "堇": "less-than-common",
  "堈": "less-than-common",
  "堉": "rarely-used",
  "堊": "common",
  "堋": "less-than-common",
  "堌": "rarely-used",
  "堍": "rarely-used",
  "堎": "rarely-used",
  "堐": "rarely-used",
  "堗": "rarely-used",
  "堙": "less-than-common",
  "堚": "rarely-used",
  "堛": "rarely-used",
  "堜": "rarely-used",
  "堝": "less-than-common",
  "堞": "less-than-common",
  "堟": "rarely-used",
  "堠": "less-than-common",
  "堡": "common",
  "堣": "less-than-common",
  "堤": "common",
  "堥": "less-than-common",
  "堧": "less-than-common",
  "堨": "less-than-common",
  "堩": "less-than-common",
  "堪": "common",
  "堫": "rarely-used",
  "堬": "rarely-used",
  "堭": "rarely-used",
  "堮": "rarely-used",
  "堯": "common",
  "堰": "common",
  "報": "common",
  "堲": "less-than-common",
  "堳": "rarely-used",
  "場": "common",
  "堵": "common",
  "堶": "rarely-used",
  "堷": "less-than-common",
  "堸": "rarely-used",
  "堹": "rarely-used",
  "堻": "rarely-used",
  "堼": "rarely-used",
  "堽": "rarely-used",
  "堿": "rarely-used",
  "塃": "rarely-used",
  "塄": "rarely-used",
  "塅": "rarely-used",
  "塈": "less-than-common",
  "塉": "less-than-common",
  "塊": "common",
  "塋": "less-than-common",
  "塌": "common",
  "塍": "less-than-common",
  "塎": "rarely-used",
  "塏": "less-than-common",
  "塑": "common",
  "塒": "less-than-common",
  "塓": "less-than-common",
  "塔": "common",
  "塕": "less-than-common",
  "塗": "common",
  "塘": "common",
  "塙": "rarely-used",
  "塚": "common",
  "塛": "rarely-used",
  "塝": "rarely-used",
  "塞": "common",
  "塢": "common",
  "塣": "rarely-used",
  "塤": "less-than-common",
  "塥": "rarely-used",
  "塧": "rarely-used",
  "塨": "less-than-common",
  "填": "common",
  "塬": "rarely-used",
  "塭": "common",
  "塯": "less-than-common",
  "塱": "rarely-used",
  "塳": "rarely-used",
  "塴": "less-than-common",
  "塵": "common",
  "塶": "rarely-used",
  "塸": "rarely-used",
  "塹": "common",
  "塺": "less-than-common",
  "塻": "rarely-used",
  "塼": "less-than-common",
  "塽": "rarely-used",
  "塾": "common",
  "塿": "less-than-common",
  "墀": "common",
  "墁": "less-than-common",
  "墂": "rarely-used",
  "境": "common",
  "墄": "rarely-used",
  "墅": "common",
  "墆": "less-than-common",
  "墇": "rarely-used",
  "墈": "rarely-used",
  "墉": "less-than-common",
  "墊": "common",
  "墋": "less-than-common",
  "墌": "rarely-used",
  "墎": "rarely-used",
  "墏": "rarely-used",
  "墐": "less-than-common",
  "墑": "rarely-used",
  "墒": "rarely-used",
  "墓": "common",
  "墔": "rarely-used",
  "墘": "less-than-common",
  "墚": "rarely-used",
  "墜": "common",
  "墝": "less-than-common",
  "增": "common",
  "墟": "common",
  "墠": "less-than-common",
  "墡": "rarely-used",
  "墢": "rarely-used",
  "墣": "less-than-common",
  "墥": "rarely-used",
  "墦": "less-than-common",
  "墨": "common",
  "墩": "less-than-common",
  "墫": "less-than-common",
  "墬": "less-than-common",
  "墭": "rarely-used",
  "墮": "common",
  "墯": "less-than-common",
  "墱": "less-than-common",
  "墲": "rarely-used",
  "墳": "common",
  "墷": "rarely-used",
  "墺": "rarely-used",
  "墼": "rarely-used",
  "墽": "less-than-common",
  "墾": "common",
  "墿": "rarely-used",
  "壁": "common",
  "壂": "rarely-used",
  "壅": "common",
  "壆": "rarely-used",
  "壇": "common",
  "壈": "less-than-common",
  "壉": "rarely-used",
  "壎": "less-than-common",
  "壏": "rarely-used",
  "壑": "common",
  "壒": "rarely-used",
  "壓": "common",
  "壔": "rarely-used",
  "壕": "common",
  "壖": "less-than-common",
  "壘": "common",
  "壙": "common",
  "壚": "less-than-common",
  "壛": "less-than-common",
  "壝": "less-than-common",
  "壞": "common",
  "壟": "common",
  "壢": "common",
  "壣": "rarely-used",
  "壤": "common",
  "壧": "rarely-used",
  "壨": "rarely-used",
  "壩": "common",
  "士": "common",
  "壬": "common",
  "壯": "common",
  "壴": "less-than-common",
  "壹": "common",
  "壺": "common",
  "壼": "less-than-common",
  "壽": "common",
  "壾": "less-than-common",
  "壿": "less-than-common",
  "夂": "rarely-used",
  "夃": "less-than-common",
  "夆": "less-than-common",
  "夊": "rarely-used",
  "夋": "rarely-used",
  "夌": "less-than-common",
  "复": "less-than-common",
  "夎": "less-than-common",
  "夏": "common",
  "夒": "less-than-common",
  "夔": "common",
  "夕": "common",
  "外": "common",
  "夗": "less-than-common",
  "夙": "common",
  "多": "common",
  "夜": "common",
  "夝": "rarely-used",
  "夠": "common",
  "夡": "rarely-used",
  "夢": "common",
  "夤": "common",
  "夥": "common",
  "夦": "rarely-used",
  "大": "common",
  "夨": "rarely-used",
  "天": "common",
  "太": "common",
  "夫": "common",
  "夬": "less-than-common",
  "夭": "common",
  "央": "common",
  "夯": "less-than-common",
  "夰": "rarely-used",
  "失": "common",
  "夲": "rarely-used",
  "夵": "rarely-used",
  "夷": "common",
  "夸": "common",
  "夼": "rarely-used",
  "夽": "rarely-used",
  "夾": "common",
  "夿": "rarely-used",
  "奀": "rarely-used",
  "奃": "rarely-used",
  "奄": "common",
  "奅": "less-than-common",
  "奆": "rarely-used",
  "奇": "common",
  "奈": "common",
  "奉": "common",
  "奊": "less-than-common",
  "奋": "rarely-used",
  "奎": "common",
  "奏": "common",
  "奐": "common",
  "契": "common",
  "奒": "rarely-used",
  "奓": "less-than-common",
  "奔": "common",
  "奕": "common",
  "套": "common",
  "奘": "common",
  "奚": "common",
  "奛": "rarely-used",
  "奜": "rarely-used",
  "奝": "rarely-used",
  "奞": "rarely-used",
  "奟": "rarely-used",
  "奠": "common",
  "奡": "less-than-common",
  "奢": "common",
  "奣": "rarely-used",
  "奤": "rarely-used",
  "奦": "rarely-used",
  "奧": "common",
  "奩": "common",
  "奪": "common",
  "奫": "less-than-common",
  "奭": "less-than-common",
  "奮": "common",
  "奯": "rarely-used",
  "奰": "less-than-common",
  "奱": "rarely-used",
  "奲": "less-than-common",
  "女": "common",
  "奴": "common",
  "奵": "rarely-used",
  "奶": "common",
  "奷": "rarely-used",
  "奸": "common",
  "她": "common",
  "奻": "rarely-used",
  "奼": "less-than-common",
  "好": "common",
  "奾": "rarely-used",
  "奿": "rarely-used",
  "妀": "less-than-common",
  "妁": "common",
  "如": "common",
  "妃": "common",
  "妄": "common",
  "妅": "rarely-used",
  "妊": "common",
  "妋": "rarely-used",
  "妌": "rarely-used",
  "妍": "common",
  "妎": "less-than-common",
  "妏": "rarely-used",
  "妐": "less-than-common",
  "妑": "rarely-used",
  "妒": "common",
  "妓": "common",
  "妔": "rarely-used",
  "妕": "rarely-used",
  "妖": "common",
  "妗": "less-than-common",
  "妘": "less-than-common",
  "妙": "common",
  "妜": "rarely-used",
  "妝": "common",
  "妞": "common",
  "妟": "rarely-used",
  "妠": "less-than-common",
  "妡": "rarely-used",
  "妢": "less-than-common",
  "妣": "common",
  "妤": "common",
  "妥": "common",
  "妦": "less-than-common",
  "妧": "rarely-used",
  "妨": "common",
  "妭": "rarely-used",
  "妮": "common",
  "妯": "common",
  "妰": "rarely-used",
  "妱": "rarely-used",
  "妲": "less-than-common",
  "妳": "common",
  "妴": "rarely-used",
  "妵": "less-than-common",
  "妶": "rarely-used",
  "妹": "common",
  "妺": "less-than-common",
  "妻": "common",
  "妼": "rarely-used",
  "妽": "rarely-used",
  "妾": "common",
  "妿": "rarely-used",
  "姀": "rarely-used",
  "姁": "less-than-common",
  "姂": "rarely-used",
  "姃": "rarely-used",
  "姄": "rarely-used",
  "姅": "rarely-used",
  "姆": "common",
  "姇": "rarely-used",
  "姈": "rarely-used",
  "姊": "common",
  "始": "common",
  "姌": "less-than-common",
  "姍": "common",
  "姎": "less-than-common",
  "姏": "less-than-common",
  "姐": "common",
  "姑": "common",
  "姒": "common",
  "姓": "common",
  "委": "common",
  "姕": "rarely-used",
  "姖": "rarely-used",
  "姘": "common",
  "姚": "common",
  "姛": "rarely-used",
  "姜": "common",
  "姝": "less-than-common",
  "姞": "less-than-common",
  "姟": "rarely-used",
  "姠": "rarely-used",
  "姡": "less-than-common",
  "姣": "common",
  "姤": "less-than-common",
  "姥": "common",
  "姦": "common",
  "姨": "common",
  "姩": "rarely-used",
  "姪": "common",
  "姫": "rarely-used",
  "姬": "common",
  "姭": "rarely-used",
  "姮": "less-than-common",
  "姯": "rarely-used",
  "姰": "rarely-used",
  "姱": "less-than-common",
  "姲": "rarely-used",
  "姳": "rarely-used",
  "姴": "rarely-used",
  "姵": "rarely-used",
  "姶": "less-than-common",
  "姷": "rarely-used",
  "姺": "less-than-common",
  "姻": "common",
  "姼": "less-than-common",
  "姽": "less-than-common",
  "姾": "rarely-used",
  "姿": "common",
  "娀": "less-than-common",
  "威": "common",
  "娃": "common",
  "娉": "less-than-common",
  "娊": "rarely-used",
  "娋": "rarely-used",
  "娌": "common",
  "娍": "rarely-used",
  "娎": "rarely-used",
  "娏": "rarely-used",
  "娐": "rarely-used",
  "娑": "common",
  "娓": "common",
  "娕": "rarely-used",
  "娖": "less-than-common",
  "娗": "rarely-used",
  "娘": "common",
  "娙": "less-than-common",
  "娛": "common",
  "娜": "common",
  "娝": "rarely-used",
  "娞": "rarely-used",
  "娟": "common",
  "娠": "common",
  "娡": "rarely-used",
  "娢": "rarely-used",
  "娣": "common",
  "娥": "common",
  "娧": "rarely-used",
  "娨": "rarely-used",
  "娩": "common",
  "娪": "rarely-used",
  "娫": "rarely-used",
  "娭": "less-than-common",
  "娮": "rarely-used",
  "娳": "rarely-used",
  "娵": "less-than-common",
  "娶": "common",
  "娷": "less-than-common",
  "娸": "less-than-common",
  "娹": "rarely-used",
  "娺": "rarely-used",
  "娻": "rarely-used",
  "娼": "common",
  "娽": "rarely-used",
  "娾": "rarely-used",
  "婀": "common",
  "婁": "common",
  "婂": "rarely-used",
  "婃": "rarely-used",
  "婄": "rarely-used",
  "婅": "rarely-used",
  "婆": "common",
  "婇": "rarely-used",
  "婈": "rarely-used",
  "婉": "common",
  "婊": "common",
  "婋": "rarely-used",
  "婌": "rarely-used",
  "婍": "rarely-used",
  "婎": "rarely-used",
  "婐": "less-than-common",
  "婑": "rarely-used",
  "婒": "rarely-used",
  "婓": "less-than-common",
  "婕": "less-than-common",
  "婖": "rarely-used",
  "婗": "less-than-common",
  "婘": "less-than-common",
  "婚": "common",
  "婛": "rarely-used",
  "婜": "rarely-used",
  "婝": "rarely-used",
  "婞": "less-than-common",
  "婟": "less-than-common",
  "婠": "less-than-common",
  "婡": "rarely-used",
  "婢": "common",
  "婤": "less-than-common",
  "婥": "less-than-common",
  "婦": "common",
  "婧": "less-than-common",
  "婨": "rarely-used",
  "婩": "rarely-used",
  "婪": "common",
  "婫": "rarely-used",
  "婬": "less-than-common",
  "婭": "less-than-common",
  "婮": "rarely-used",
  "婰": "rarely-used",
  "婷": "common",
  "婸": "less-than-common",
  "婺": "less-than-common",
  "婻": "rarely-used",
  "婼": "less-than-common",
  "婽": "rarely-used",
  "婿": "common",
  "媀": "rarely-used",
  "媁": "rarely-used",
  "媂": "rarely-used",
  "媃": "rarely-used",
  "媄": "rarely-used",
  "媅": "rarely-used",
  "媈": "rarely-used",
  "媉": "rarely-used",
  "媊": "rarely-used",
  "媋": "rarely-used",
  "媌": "rarely-used",
  "媎": "rarely-used",
  "媏": "rarely-used",
  "媐": "rarely-used",
  "媑": "rarely-used",
  "媒": "common",
  "媓": "rarely-used",
  "媔": "less-than-common",
  "媕": "less-than-common",
  "媖": "rarely-used",
  "媗": "rarely-used",
  "媘": "rarely-used",
  "媙": "rarely-used",
  "媚": "common",
  "媛": "common",
  "媜": "rarely-used",
  "媝": "rarely-used",
  "媞": "less-than-common",
  "媟": "less-than-common",
  "媡": "rarely-used",
  "媢": "less-than-common",
  "媣": "rarely-used",
  "媥": "less-than-common",
  "媦": "less-than-common",
  "媧": "less-than-common",
  "媨": "rarely-used",
  "媩": "rarely-used",
  "媬": "less-than-common",
  "媮": "less-than-common",
  "媯": "less-than-common",
  "媰": "less-than-common",
  "媱": "less-than-common",
  "媲": "common",
  "媳": "common",
  "媴": "rarely-used",
  "媵": "less-than-common",
  "媶": "rarely-used",
  "媷": "rarely-used",
  "媸": "less-than-common",
  "媹": "rarely-used",
  "媺": "less-than-common",
  "媻": "less-than-common",
  "媼": "common",
  "媽": "common",
  "媾": "common",
  "媿": "less-than-common",
  "嫀": "rarely-used",
  "嫁": "common",
  "嫂": "common",
  "嫃": "rarely-used",
  "嫄": "less-than-common",
  "嫅": "rarely-used",
  "嫆": "rarely-used",
  "嫇": "less-than-common",
  "嫈": "less-than-common",
  "嫉": "common",
  "嫊": "rarely-used",
  "嫋": "less-than-common",
  "嫌": "common",
  "嫍": "rarely-used",
  "嫎": "rarely-used",
  "嫏": "rarely-used",
  "嫐": "rarely-used",
  "嫕": "less-than-common",
  "嫖": "common",
  "嫗": "common",
  "嫘": "common",
  "嫙": "rarely-used",
  "嫚": "less-than-common",
  "嫛": "less-than-common",
  "嫜": "less-than-common",
  "嫝": "rarely-used",
  "嫞": "rarely-used",
  "嫟": "rarely-used",
  "嫠": "less-than-common",
  "嫡": "common",
  "嫢": "less-than-common",
  "嫣": "common",
  "嫤": "rarely-used",
  "嫥": "less-than-common",
  "嫦": "common",
  "嫧": "rarely-used",
  "嫨": "rarely-used",
  "嫩": "common",
  "嫪": "less-than-common",
  "嫫": "less-than-common",
  "嫬": "rarely-used",
  "嫭": "less-than-common",
  "嫮": "less-than-common",
  "嫯": "rarely-used",
  "嫳": "less-than-common",
  "嫴": "less-than-common",
  "嫵": "common",
  "嫶": "less-than-common",
  "嫷": "less-than-common",
  "嫸": "rarely-used",
  "嫹": "rarely-used",
  "嫻": "common",
  "嫼": "rarely-used",
  "嫽": "less-than-common",
  "嫾": "rarely-used",
  "嫿": "less-than-common",
  "嬁": "rarely-used",
  "嬂": "rarely-used",
  "嬃": "less-than-common",
  "嬄": "rarely-used",
  "嬅": "rarely-used",
  "嬆": "rarely-used",
  "嬇": "rarely-used",
  "嬈": "less-than-common",
  "嬉": "common",
  "嬋": "common",
  "嬌": "common",
  "嬎": "less-than-common",
  "嬏": "rarely-used",
  "嬐": "less-than-common",
  "嬑": "rarely-used",
  "嬒": "rarely-used",
  "嬓": "less-than-common",
  "嬕": "rarely-used",
  "嬖": "less-than-common",
  "嬗": "less-than-common",
  "嬘": "rarely-used",
  "嬙": "less-than-common",
  "嬚": "rarely-used",
  "嬛": "less-than-common",
  "嬜": "rarely-used",
  "嬝": "common",
  "嬞": "rarely-used",
  "嬟": "rarely-used",
  "嬠": "rarely-used",
  "嬡": "less-than-common",
  "嬣": "rarely-used",
  "嬤": "common",
  "嬥": "less-than-common",
  "嬦": "rarely-used",
  "嬧": "rarely-used",
  "嬨": "rarely-used",
  "嬩": "rarely-used",
  "嬪": "common",
  "嬫": "rarely-used",
  "嬬": "rarely-used",
  "嬭": "less-than-common",
  "嬮": "rarely-used",
  "嬯": "rarely-used",
  "嬰": "common",
  "嬲": "less-than-common",
  "嬳": "rarely-used",
  "嬴": "common",
  "嬵": "rarely-used",
  "嬸": "common",
  "嬹": "rarely-used",
  "嬻": "rarely-used",
  "嬼": "rarely-used",
  "嬽": "less-than-common",
  "嬾": "less-than-common",
  "嬿": "less-than-common",
  "孀": "common",
  "孁": "rarely-used",
  "孂": "rarely-used",
  "孃": "less-than-common",
  "孅": "less-than-common",
  "孇": "rarely-used",
  "孈": "less-than-common",
  "孊": "rarely-used",
  "孋": "less-than-common",
  "孌": "less-than-common",
  "孍": "rarely-used",
  "孎": "rarely-used",
  "子": "common",
  "孑": "common",
  "孒": "rarely-used",
  "孓": "common",
  "孔": "common",
  "孕": "common",
  "孖": "rarely-used",
  "字": "common",
  "存": "common",
  "孚": "common",
  "孛": "less-than-common",
  "孜": "common",
  "孝": "common",
  "孟": "common",
  "孡": "rarely-used",
  "孢": "less-than-common",
  "季": "common",
  "孤": "common",
  "孥": "less-than-common",
  "孨": "rarely-used",
  "孩": "common",
  "孫": "common",
  "孬": "less-than-common",
  "孮": "rarely-used",
  "孯": "rarely-used",
  "孰": "common",
  "孱": "common",
  "孲": "less-than-common",
  "孳": "common",
  "孴": "rarely-used",
  "孵": "common",
  "孷": "less-than-common",
  "學": "common",
  "孺": "common",
  "孻": "rarely-used",
  "孽": "common",
  "孿": "common",
  "宀": "rarely-used",
  "宁": "less-than-common",
  "它": "common",
  "宄": "less-than-common",
  "宅": "common",
  "宇": "common",
  "守": "common",
  "安": "common",
  "宊": "rarely-used",
  "宋": "common",
  "完": "common",
  "宎": "less-than-common",
  "宏": "common",
  "宒": "rarely-used",
  "宓": "less-than-common",
  "宕": "less-than-common",
  "宖": "rarely-used",
  "宗": "common",
  "官": "common",
  "宙": "common",
  "定": "common",
  "宛": "common",
  "宜": "common",
  "客": "common",
  "宣": "common",
  "室": "common",
  "宥": "common",
  "宦": "common",
  "宧": "less-than-common",
  "宨": "less-than-common",
  "宬": "rarely-used",
  "宭": "rarely-used",
  "宮": "common",
  "宯": "rarely-used",
  "宰": "common",
  "宱": "rarely-used",
  "害": "common",
  "宴": "common",
  "宵": "common",
  "家": "common",
  "宸": "common",
  "容": "common",
  "宺": "rarely-used",
  "宿": "common",
  "寀": "less-than-common",
  "寁": "less-than-common",
  "寂": "common",
  "寄": "common",
  "寅": "common",
  "密": "common",
  "寇": "common",
  "寊": "rarely-used",
  "寋": "less-than-common",
  "富": "common",
  "寍": "less-than-common",
  "寎": "rarely-used",
  "寏": "rarely-used",
  "寐": "common",
  "寑": "less-than-common",
  "寒": "common",
  "寓": "common",
  "寔": "less-than-common",
  "寖": "less-than-common",
  "寘": "less-than-common",
  "寙": "less-than-common",
  "寞": "common",
  "察": "common",
  "寠": "less-than-common",
  "寡": "common",
  "寢": "common",
  "寣": "rarely-used",
  "寤": "common",
  "寥": "common",
  "實": "common",
  "寧": "common",
  "寨": "common",
  "審": "common",
  "寪": "less-than-common",
  "寫": "common",
  "寬": "common",
  "寭": "rarely-used",
  "寮": "common",
  "寯": "rarely-used",
  "寰": "less-than-common",
  "寱": "less-than-common",
  "寲": "rarely-used",
  "寴": "rarely-used",
  "寵": "common",
  "寶": "common",
  "寷": "rarely-used",
  "寸": "common",
  "寺": "common",
  "尀": "rarely-used",
  "封": "common",
  "尃": "less-than-common",
  "射": "common",
  "將": "common",
  "專": "common",
  "尉": "common",
  "尊": "common",
  "尋": "common",
  "尌": "less-than-common",
  "對": "common",
  "導": "common",
  "小": "common",
  "尐": "less-than-common",
  "少": "common",
  "尒": "less-than-common",
  "尔": "less-than-common",
  "尕": "rarely-used",
  "尖": "common",
  "尚": "common",
  "尟": "less-than-common",
  "尢": "rarely-used",
  "尤": "common",
  "尥": "rarely-used",
  "尨": "less-than-common",
  "尪": "less-than-common",
  "尬": "common",
  "尯": "rarely-used",
  "尰": "less-than-common",
  "就": "common",
  "尳": "less-than-common",
  "尵": "rarely-used",
  "尷": "common",
  "尸": "common",
  "尹": "common",
  "尺": "common",
  "尻": "less-than-common",
  "尼": "common",
  "尾": "common",
  "尿": "common",
  "局": "common",
  "屁": "common",
  "屄": "less-than-common",
  "居": "common",
  "屆": "common",
  "屇": "rarely-used",
  "屈": "common",
  "屋": "common",
  "屌": "less-than-common",
  "屍": "common",
  "屎": "common",
  "屏": "common",
  "屐": "common",
  "屑": "common",
  "屒": "rarely-used",
  "屔": "less-than-common",
  "展": "common",
  "屖": "less-than-common",
  "屘": "less-than-common",
  "屙": "less-than-common",
  "屚": "rarely-used",
  "屜": "common",
  "屝": "less-than-common",
  "屠": "common",
  "屢": "common",
  "屣": "less-than-common",
  "層": "common",
  "履": "common",
  "屧": "less-than-common",
  "屨": "less-than-common",
  "屩": "less-than-common",
  "屪": "rarely-used",
  "屬": "common",
  "屭": "less-than-common",
  "屮": "less-than-common",
  "屯": "common",
  "屰": "rarely-used",
  "山": "common",
  "屳": "rarely-used",
  "屴": "less-than-common",
  "屵": "rarely-used",
  "屸": "rarely-used",
  "屹": "common",
  "屺": "less-than-common",
  "屻": "rarely-used",
  "屼": "less-than-common",
  "屾": "rarely-used",
  "岄": "rarely-used",
  "岆": "rarely-used",
  "岇": "rarely-used",
  "岈": "less-than-common",
  "岉": "less-than-common",
  "岊": "less-than-common",
  "岋": "less-than-common",
  "岌": "common",
  "岍": "less-than-common",
  "岎": "rarely-used",
  "岏": "less-than-common",
  "岐": "common",
  "岑": "common",
  "岒": "less-than-common",
  "岓": "rarely-used",
  "岔": "common",
  "岕": "rarely-used",
  "岜": "rarely-used",
  "岝": "less-than-common",
  "岟": "less-than-common",
  "岠": "less-than-common",
  "岡": "common",
  "岢": "less-than-common",
  "岣": "less-than-common",
  "岤": "less-than-common",
  "岥": "rarely-used",
  "岦": "rarely-used",
  "岧": "less-than-common",
  "岨": "less-than-common",
  "岩": "common",
  "岪": "less-than-common",
  "岫": "common",
  "岬": "less-than-common",
  "岭": "less-than-common",
  "岮": "less-than-common",
  "岯": "less-than-common",
  "岰": "rarely-used",
  "岱": "common",
  "岲": "rarely-used",
  "岳": "common",
  "岵": "less-than-common",
  "岶": "rarely-used",
  "岷": "common",
  "岸": "common",
  "岻": "rarely-used",
  "峁": "rarely-used",
  "峆": "rarely-used",
  "峇": "less-than-common",
  "峈": "rarely-used",
  "峉": "less-than-common",
  "峊": "less-than-common",
  "峋": "less-than-common",
  "峌": "less-than-common",
  "峎": "rarely-used",
  "峏": "rarely-used",
  "峐": "less-than-common",
  "峑": "rarely-used",
  "峒": "less-than-common",
  "峓": "rarely-used",
  "峔": "rarely-used",
  "峖": "rarely-used",
  "峗": "less-than-common",
  "峘": "less-than-common",
  "峙": "common",
  "峚": "less-than-common",
  "峛": "less-than-common",
  "峜": "rarely-used",
  "峞": "less-than-common",
  "峟": "rarely-used",
  "峨": "common",
  "峪": "common",
  "峫": "rarely-used",
  "峬": "less-than-common",
  "峭": "common",
  "峮": "less-than-common",
  "峰": "common",
  "峱": "less-than-common",
  "峲": "rarely-used",
  "峳": "rarely-used",
  "峴": "less-than-common",
  "島": "common",
  "峷": "less-than-common",
  "峸": "rarely-used",
  "峹": "rarely-used",
  "峺": "rarely-used",
  "峻": "common",
  "峼": "rarely-used",
  "峽": "common",
  "峾": "rarely-used",
  "峿": "less-than-common",
  "崀": "rarely-used",
  "崁": "common",
  "崆": "common",
  "崇": "common",
  "崉": "rarely-used",
  "崊": "rarely-used",
  "崋": "less-than-common",
  "崌": "less-than-common",
  "崍": "less-than-common",
  "崎": "common",
  "崏": "less-than-common",
  "崑": "common",
  "崒": "less-than-common",
  "崔": "common",
  "崖": "common",
  "崗": "less-than-common",
  "崙": "common",
  "崚": "less-than-common",
  "崛": "common",
  "崜": "rarely-used",
  "崝": "less-than-common",
  "崞": "less-than-common",
  "崟": "less-than-common",
  "崠": "less-than-common",
  "崡": "rarely-used",
  "崢": "common",
  "崣": "less-than-common",
  "崤": "less-than-common",
  "崥": "less-than-common",
  "崦": "less-than-common",
  "崧": "less-than-common",
  "崨": "less-than-common",
  "崩": "common",
  "崬": "rarely-used",
  "崮": "rarely-used",
  "崰": "less-than-common",
  "崱": "less-than-common",
  "崲": "rarely-used",
  "崳": "less-than-common",
  "崴": "less-than-common",
  "崵": "less-than-common",
  "崶": "rarely-used",
  "崷": "less-than-common",
  "崸": "rarely-used",
  "崹": "rarely-used",
  "崺": "less-than-common",
  "崼": "rarely-used",
  "崽": "less-than-common",
  "崾": "rarely-used",
  "崿": "less-than-common",
  "嵀": "rarely-used",
  "嵁": "less-than-common",
  "嵂": "less-than-common",
  "嵃": "less-than-common",
  "嵄": "rarely-used",
  "嵅": "rarely-used",
  "嵇": "less-than-common",
  "嵈": "rarely-used",
  "嵉": "rarely-used",
  "嵊": "less-than-common",
  "嵋": "less-than-common",
  "嵌": "common",
  "嵍": "rarely-used",
  "嵎": "less-than-common",
  "嵐": "common",
  "嵑": "less-than-common",
  "嵒": "less-than-common",
  "嵕": "less-than-common",
  "嵖": "rarely-used",
  "嵙": "less-than-common",
  "嵛": "rarely-used",
  "嵞": "less-than-common",
  "嵟": "rarely-used",
  "嵡": "rarely-used",
  "嵢": "rarely-used",
  "嵣": "less-than-common",
  "嵥": "less-than-common",
  "嵦": "rarely-used",
  "嵧": "rarely-used",
  "嵨": "rarely-used",
  "嵩": "common",
  "嵪": "rarely-used",
  "嵫": "less-than-common",
  "嵬": "less-than-common",
  "嵭": "rarely-used",
  "嵯": "less-than-common",
  "嵰": "rarely-used",
  "嵱": "less-than-common",
  "嵲": "less-than-common",
  "嵴": "rarely-used",
  "嵷": "less-than-common",
  "嵹": "rarely-used",
  "嵺": "less-than-common",
  "嵻": "rarely-used",
  "嵼": "rarely-used",
  "嵽": "less-than-common",
  "嵾": "less-than-common",
  "嵿": "rarely-used",
  "嶀": "less-than-common",
  "嶁": "less-than-common",
  "嶂": "less-than-common",
  "嶄": "common",
  "嶅": "rarely-used",
  "嶆": "less-than-common",
  "嶇": "common",
  "嶈": "less-than-common",
  "嶉": "less-than-common",
  "嶊": "less-than-common",
  "嶍": "rarely-used",
  "嶏": "rarely-used",
  "嶐": "rarely-used",
  "嶑": "rarely-used",
  "嶒": "less-than-common",
  "嶓": "less-than-common",
  "嶔": "less-than-common",
  "嶕": "less-than-common",
  "嶗": "less-than-common",
  "嶘": "rarely-used",
  "嶙": "less-than-common",
  "嶚": "less-than-common",
  "嶜": "less-than-common",
  "嶝": "common",
  "嶞": "less-than-common",
  "嶟": "less-than-common",
  "嶠": "less-than-common",
  "嶡": "less-than-common",
  "嶢": "less-than-common",
  "嶦": "rarely-used",
  "嶧": "less-than-common",
  "嶨": "less-than-common",
  "嶩": "less-than-common",
  "嶪": "less-than-common",
  "嶬": "less-than-common",
  "嶭": "less-than-common",
  "嶮": "less-than-common",
  "嶯": "rarely-used",
  "嶰": "less-than-common",
  "嶱": "less-than-common",
  "嶲": "less-than-common",
  "嶴": "rarely-used",
  "嶵": "less-than-common",
  "嶷": "less-than-common",
  "嶸": "less-than-common",
  "嶺": "common",
  "嶼": "common",
  "嶽": "common",
  "嶾": "rarely-used",
  "巀": "less-than-common",
  "巁": "rarely-used",
  "巂": "less-than-common",
  "巃": "less-than-common",
  "巆": "less-than-common",
  "巇": "less-than-common",
  "巈": "rarely-used",
  "巉": "less-than-common",
  "巊": "rarely-used",
  "巋": "less-than-common",
  "巍": "common",
  "巏": "less-than-common",
  "巐": "rarely-used",
  "巑": "less-than-common",
  "巒": "common",
  "巔": "common",
  "巕": "less-than-common",
  "巖": "common",
  "巘": "less-than-common",
  "巙": "rarely-used",
  "巚": "rarely-used",
  "巜": "rarely-used",
  "川": "common",
  "州": "common",
  "巟": "less-than-common",
  "巠": "rarely-used",
  "巡": "common",
  "巢": "common",
  "工": "common",
  "左": "common",
  "巧": "common",
  "巨": "common",
  "巫": "common",
  "差": "common",
  "巰": "less-than-common",
  "己": "common",
  "已": "common",
  "巳": "common",
  "巴": "common",
  "巷": "common",
  "巸": "rarely-used",
  "巹": "less-than-common",
  "巽": "common",
  "巾": "common",
  "巿": "less-than-common",
  "市": "common",
  "布": "common",
  "帄": "rarely-used",
  "帆": "common",
  "帇": "rarely-used",
  "帉": "rarely-used",
  "帊": "less-than-common",
  "希": "common",
  "帍": "rarely-used",
  "帎": "rarely-used",
  "帑": "common",
  "帓": "rarely-used",
  "帔": "less-than-common",
  "帕": "common",
  "帖": "common",
  "帗": "less-than-common",
  "帘": "common",
  "帙": "less-than-common",
  "帚": "common",
  "帛": "common",
  "帝": "common",
  "帟": "less-than-common",
  "帠": "less-than-common",
  "帡": "less-than-common",
  "帢": "less-than-common",
  "帣": "less-than-common",
  "帤": "less-than-common",
  "帥": "common",
  "帨": "less-than-common",
  "帩": "less-than-common",
  "帪": "rarely-used",
  "師": "common",
  "席": "common",
  "帳": "common",
  "帴": "less-than-common",
  "帵": "rarely-used",
  "帶": "common",
  "帷": "common",
  "常": "common",
  "帹": "rarely-used",
  "帺": "rarely-used",
  "帽": "common",
  "帾": "less-than-common",
  "帿": "rarely-used",
  "幀": "common",
  "幁": "rarely-used",
  "幃": "less-than-common",
  "幄": "less-than-common",
  "幅": "common",
  "幆": "rarely-used",
  "幊": "rarely-used",
  "幋": "rarely-used",
  "幌": "common",
  "幍": "rarely-used",
  "幎": "less-than-common",
  "幏": "less-than-common",
  "幒": "rarely-used",
  "幓": "less-than-common",
  "幔": "common",
  "幕": "common",
  "幖": "rarely-used",
  "幗": "common",
  "幘": "less-than-common",
  "幙": "less-than-common",
  "幛": "common",
  "幜": "rarely-used",
  "幝": "less-than-common",
  "幟": "common",
  "幠": "less-than-common",
  "幡": "less-than-common",
  "幢": "common",
  "幣": "common",
  "幦": "less-than-common",
  "幧": "less-than-common",
  "幨": "less-than-common",
  "幩": "less-than-common",
  "幪": "less-than-common",
  "幫": "common",
  "幬": "less-than-common",
  "幭": "less-than-common",
  "幮": "rarely-used",
  "幯": "rarely-used",
  "幰": "less-than-common",
  "幱": "rarely-used",
  "干": "common",
  "平": "common",
  "年": "common",
  "幵": "less-than-common",
  "并": "common",
  "幸": "common",
  "幹": "common",
  "幻": "common",
  "幼": "common",
  "幽": "common",
  "幾": "common",
  "广": "rarely-used",
  "庀": "less-than-common",
  "庁": "rarely-used",
  "庂": "less-than-common",
  "庄": "rarely-used",
  "庇": "common",
  "庈": "less-than-common",
  "庉": "less-than-common",
  "床": "common",
  "庋": "less-than-common",
  "庌": "less-than-common",
  "庍": "rarely-used",
  "庎": "rarely-used",
  "序": "common",
  "底": "common",
  "庖": "common",
  "店": "common",
  "庘": "rarely-used",
  "庚": "common",
  "庛": "less-than-common",
  "府": "common",
  "庠": "common",
  "庡": "rarely-used",
  "庢": "less-than-common",
  "庣": "less-than-common",
  "庤": "less-than-common",
  "庥": "less-than-common",
  "度": "common",
  "座": "common",
  "庨": "less-than-common",
  "庩": "rarely-used",
  "庪": "less-than-common",
  "庫": "common",
  "庬": "less-than-common",
  "庭": "common",
  "庮": "less-than-common",
  "庯": "rarely-used",
  "庰": "less-than-common",
  "庱": "less-than-common",
  "庲": "less-than-common",
  "庳": "less-than-common",
  "庴": "less-than-common",
  "庵": "common",
  "庶": "common",
  "康": "common",
  "庸": "common",
  "庹": "less-than-common",
  "庾": "common",
  "廁": "common",
  "廂": "common",
  "廄": "less-than-common",
  "廅": "less-than-common",
  "廆": "less-than-common",
  "廇": "less-than-common",
  "廈": "common",
  "廉": "common",
  "廊": "common",
  "廋": "less-than-common",
  "廌": "less-than-common",
  "廎": "less-than-common",
  "廑": "less-than-common",
  "廒": "rarely-used",
  "廓": "common",
  "廔": "rarely-used",
  "廕": "less-than-common",
  "廖": "common",
  "廗": "less-than-common",
  "廘": "less-than-common",
  "廙": "less-than-common",
  "廚": "common",
  "廛": "less-than-common",
  "廜": "less-than-common",
  "廝": "common",
  "廞": "less-than-common",
  "廟": "common",
  "廠": "common",
  "廡": "less-than-common",
  "廢": "common",
  "廣": "common",
  "廥": "less-than-common",
  "廦": "less-than-common",
  "廧": "less-than-common",
  "廨": "less-than-common",
  "廩": "less-than-common",
  "廬": "common",
  "廮": "less-than-common",
  "廯": "less-than-common",
  "廱": "less-than-common",
  "廲": "rarely-used",
  "廳": "common",
  "廴": "rarely-used",
  "廵": "rarely-used",
  "延": "common",
  "廷": "common",
  "建": "common",
  "廾": "less-than-common",
  "廿": "common",
  "弁": "common",
  "异": "less-than-common",
  "弄": "common",
  "弅": "less-than-common",
  "弆": "rarely-used",
  "弇": "less-than-common",
  "弈": "common",
  "弊": "common",
  "弋": "less-than-common",
  "式": "common",
  "弒": "common",
  "弓": "common",
  "弔": "common",
  "引": "common",
  "弗": "common",
  "弘": "common",
  "弙": "rarely-used",
  "弚": "less-than-common",
  "弛": "common",
  "弜": "rarely-used",
  "弝": "less-than-common",
  "弞": "rarely-used",
  "弟": "common",
  "弡": "rarely-used",
  "弢": "less-than-common",
  "弣": "less-than-common",
  "弤": "less-than-common",
  "弦": "common",
  "弧": "common",
  "弨": "less-than-common",
  "弩": "common",
  "弫": "rarely-used",
  "弬": "rarely-used",
  "弭": "common",
  "弮": "less-than-common",
  "弰": "rarely-used",
  "弱": "common",
  "弲": "rarely-used",
  "弳": "less-than-common",
  "弴": "rarely-used",
  "張": "common",
  "弶": "less-than-common",
  "強": "common",
  "弸": "less-than-common",
  "弼": "common",
  "弿": "rarely-used",
  "彀": "less-than-common",
  "彃": "less-than-common",
  "彄": "less-than-common",
  "彆": "common",
  "彇": "rarely-used",
  "彈": "common",
  "彉": "less-than-common",
  "彊": "less-than-common",
  "彋": "less-than-common",
  "彌": "common",
  "彎": "common",
  "彏": "less-than-common",
  "彐": "rarely-used",
  "彔": "less-than-common",
  "彖": "less-than-common",
  "彗": "common",
  "彘": "less-than-common",
  "彙": "common",
  "彝": "common",
  "彠": "rarely-used",
  "彡": "rarely-used",
  "形": "common",
  "彤": "common",
  "彥": "common",
  "彧": "less-than-common",
  "彩": "common",
  "彪": "common",
  "彫": "common",
  "彬": "common",
  "彭": "common",
  "彮": "rarely-used",
  "彯": "less-than-common",
  "彰": "common",
  "影": "common",
  "彳": "less-than-common",
  "彴": "less-than-common",
  "彵": "rarely-used",
  "彶": "rarely-used",
  "彷": "common",
  "彸": "less-than-common",
  "役": "common",
  "彺": "rarely-used",
  "彼": "common",
  "彽": "rarely-used",
  "彾": "less-than-common",
  "彿": "common",
  "往": "common",
  "征": "common",
  "徂": "less-than-common",
  "待": "common",
  "徆": "rarely-used",
  "徇": "common",
  "很": "common",
  "徉": "less-than-common",
  "徊": "common",
  "律": "common",
  "後": "common",
  "徍": "rarely-used",
  "徎": "rarely-used",
  "徐": "common",
  "徑": "common",
  "徒": "common",
  "徖": "rarely-used",
  "得": "common",
  "徘": "common",
  "徙": "common",
  "徛": "less-than-common",
  "徜": "less-than-common",
  "徝": "rarely-used",
  "從": "common",
  "徟": "rarely-used",
  "徠": "less-than-common",
  "御": "common",
  "徢": "rarely-used",
  "徥": "less-than-common",
  "徦": "less-than-common",
  "徨": "common",
  "復": "common",
  "循": "common",
  "徫": "rarely-used",
  "徬": "common",
  "徭": "less-than-common",
  "微": "common",
  "徯": "less-than-common",
  "徲": "less-than-common",
  "徵": "common",
  "徶": "rarely-used",
  "德": "common",
  "徹": "common",
  "徻": "rarely-used",
  "徼": "less-than-common",
  "徽": "common",
  "徾": "less-than-common",
  "徿": "less-than-common",
  "忀": "less-than-common",
  "忁": "less-than-common",
  "心": "common",
  "必": "common",
  "忇": "rarely-used",
  "忉": "less-than-common",
  "忊": "rarely-used",
  "忋": "rarely-used",
  "忌": "common",
  "忍": "common",
  "忏": "rarely-used",
  "忐": "less-than-common",
  "忑": "less-than-common",
  "忒": "less-than-common",
  "忓": "rarely-used",
  "忔": "less-than-common",
  "忕": "less-than-common",
  "忖": "common",
  "志": "common",
  "忘": "common",
  "忙": "common",
  "忚": "rarely-used",
  "忝": "common",
  "忞": "less-than-common",
  "忠": "common",
  "忡": "less-than-common",
  "忣": "less-than-common",
  "忤": "less-than-common",
  "忥": "less-than-common",
  "忦": "rarely-used",
  "忧": "rarely-used",
  "忨": "less-than-common",
  "忪": "less-than-common",
  "快": "common",
  "忭": "less-than-common",
  "忮": "less-than-common",
  "忯": "less-than-common",
  "忱": "common",
  "忳": "less-than-common",
  "忴": "rarely-used",
  "念": "common",
  "忷": "less-than-common",
  "忸": "less-than-common",
  "忹": "rarely-used",
  "忺": "less-than-common",
  "忻": "less-than-common",
  "忽": "common",
  "忾": "rarely-used",
  "忿": "common",
  "怀": "rarely-used",
  "怇": "rarely-used",
  "怉": "rarely-used",
  "怊": "less-than-common",
  "怋": "less-than-common",
  "怌": "rarely-used",
  "怍": "less-than-common",
  "怎": "common",
  "怏": "common",
  "怐": "less-than-common",
  "怑": "rarely-used",
  "怒": "common",
  "怓": "less-than-common",
  "怔": "common",
  "怕": "common",
  "怖": "common",
  "怗": "less-than-common",
  "怘": "rarely-used",
  "怙": "less-than-common",
  "怚": "less-than-common",
  "怛": "less-than-common",
  "怜": "rarely-used",
  "思": "common",
  "怞": "less-than-common",
  "怟": "rarely-used",
  "怠": "common",
  "怡": "common",
  "怢": "less-than-common",
  "怤": "rarely-used",
  "急": "common",
  "怦": "less-than-common",
  "性": "common",
  "怨": "common",
  "怩": "less-than-common",
  "怪": "common",
  "怫": "less-than-common",
  "怬": "less-than-common",
  "怭": "less-than-common",
  "怮": "less-than-common",
  "怯": "common",
  "怰": "rarely-used",
  "怲": "less-than-common",
  "怳": "less-than-common",
  "怴": "less-than-common",
  "怵": "common",
  "怶": "rarely-used",
  "怷": "less-than-common",
  "怹": "less-than-common",
  "恀": "less-than-common",
  "恁": "less-than-common",
  "恂": "less-than-common",
  "恃": "common",
  "恄": "rarely-used",
  "恅": "less-than-common",
  "恆": "common",
  "恇": "less-than-common",
  "恈": "rarely-used",
  "恉": "less-than-common",
  "恌": "less-than-common",
  "恍": "common",
  "恎": "rarely-used",
  "恏": "rarely-used",
  "恐": "common",
  "恑": "rarely-used",
  "恓": "less-than-common",
  "恔": "less-than-common",
  "恕": "common",
  "恗": "rarely-used",
  "恘": "rarely-used",
  "恙": "common",
  "恚": "less-than-common",
  "恛": "less-than-common",
  "恜": "rarely-used",
  "恝": "less-than-common",
  "恞": "less-than-common",
  "恟": "less-than-common",
  "恢": "common",
  "恣": "common",
  "恤": "common",
  "恥": "common",
  "恦": "rarely-used",
  "恧": "less-than-common",
  "恨": "common",
  "恩": "common",
  "恪": "common",
  "恫": "common",
  "恬": "common",
  "恭": "common",
  "恮": "rarely-used",
  "息": "common",
  "恰": "common",
  "恲": "less-than-common",
  "恾": "rarely-used",
  "恿": "common",
  "悀": "less-than-common",
  "悁": "less-than-common",
  "悂": "rarely-used",
  "悃": "less-than-common",
  "悄": "common",
  "悅": "common",
  "悆": "less-than-common",
  "悇": "less-than-common",
  "悈": "less-than-common",
  "悉": "common",
  "悊": "less-than-common",
  "悌": "common",
  "悍": "common",
  "悎": "rarely-used",
  "悐": "less-than-common",
  "悒": "less-than-common",
  "悔": "common",
  "悕": "less-than-common",
  "悖": "common",
  "悗": "less-than-common",
  "悘": "rarely-used",
  "悙": "rarely-used",
  "悚": "common",
  "悛": "less-than-common",
  "悜": "rarely-used",
  "悝": "less-than-common",
  "悟": "common",
  "悠": "common",
  "悢": "less-than-common",
  "患": "common",
  "您": "common",
  "悰": "less-than-common",
  "悱": "less-than-common",
  "悲": "common",
  "悴": "common",
  "悵": "common",
  "悶": "common",
  "悷": "less-than-common",
  "悸": "common",
  "悹": "less-than-common",
  "悺": "less-than-common",
  "悻": "common",
  "悼": "common",
  "悽": "common",
  "悾": "less-than-common",
  "悿": "rarely-used",
  "惀": "rarely-used",
  "惁": "rarely-used",
  "惂": "rarely-used",
  "惃": "rarely-used",
  "惄": "less-than-common",
  "情": "common",
  "惆": "common",
  "惇": "less-than-common",
  "惈": "less-than-common",
  "惉": "less-than-common",
  "惊": "rarely-used",
  "惋": "common",
  "惌": "less-than-common",
  "惍": "rarely-used",
  "惎": "less-than-common",
  "惏": "less-than-common",
  "惐": "rarely-used",
  "惑": "common",
  "惓": "less-than-common",
  "惔": "less-than-common",
  "惕": "common",
  "惗": "rarely-used",
  "惘": "common",
  "惙": "less-than-common",
  "惚": "common",
  "惛": "less-than-common",
  "惜": "common",
  "惝": "less-than-common",
  "惟": "common",
  "惠": "common",
  "惡": "common",
  "惢": "less-than-common",
  "惤": "less-than-common",
  "惦": "common",
  "惪": "rarely-used",
  "惰": "common",
  "惱": "common",
  "惲": "less-than-common",
  "想": "common",
  "惴": "common",
  "惵": "less-than-common",
  "惶": "common",
  "惷": "less-than-common",
  "惸": "less-than-common",
  "惹": "common",
  "惺": "common",
  "惻": "common",
  "惼": "less-than-common",
  "惾": "less-than-common",
  "惿": "rarely-used",
  "愀": "common",
  "愁": "common",
  "愃": "rarely-used",
  "愄": "rarely-used",
  "愅": "less-than-common",
  "愆": "less-than-common",
  "愇": "rarely-used",
  "愈": "common",
  "愉": "common",
  "愊": "less-than-common",
  "愋": "rarely-used",
  "愌": "rarely-used",
  "愍": "less-than-common",
  "愎": "common",
  "意": "common",
  "愐": "rarely-used",
  "愒": "less-than-common",
  "愓": "less-than-common",
  "愔": "less-than-common",
  "愕": "common",
  "愖": "less-than-common",
  "愗": "rarely-used",
  "愘": "rarely-used",
  "愚": "common",
  "愛": "common",
  "愜": "common",
  "愝": "rarely-used",
  "感": "common",
  "愢": "rarely-used",
  "愣": "common",
  "愧": "common",
  "愨": "less-than-common",
  "愩": "rarely-used",
  "愪": "rarely-used",
  "愫": "less-than-common",
  "愬": "less-than-common",
  "愭": "rarely-used",
  "愮": "less-than-common",
  "愯": "less-than-common",
  "愰": "rarely-used",
  "愲": "less-than-common",
  "愴": "common",
  "愵": "rarely-used",
  "愶": "less-than-common",
  "愷": "less-than-common",
  "愺": "rarely-used",
  "愻": "rarely-used",
  "愾": "common",
  "愿": "common",
  "慀": "rarely-used",
  "慁": "less-than-common",
  "慃": "rarely-used",
  "慄": "common",
  "慅": "less-than-common",
  "慆": "less-than-common",
  "慇": "common",
  "慈": "common",
  "慉": "less-than-common",
  "慊": "less-than-common",
  "態": "common",
  "慌": "common",
  "慍": "common",
  "慎": "common",
  "慏": "rarely-used",
  "慒": "less-than-common",
  "慓": "less-than-common",
  "慔": "less-than-common",
  "慕": "common",
  "慖": "rarely-used",
  "慗": "rarely-used",
  "慘": "common",
  "慚": "common",
  "慛": "less-than-common",
  "慜": "rarely-used",
  "慝": "common",
  "慞": "less-than-common",
  "慟": "common",
  "慡": "rarely-used",
  "慢": "common",
  "慣": "common",
  "慥": "less-than-common",
  "慦": "rarely-used",
  "慧": "common",
  "慨": "common",
  "慪": "rarely-used",
  "慫": "common",
  "慬": "less-than-common",
  "慮": "common",
  "慯": "rarely-used",
  "慰": "common",
  "慱": "less-than-common",
  "慲": "less-than-common",
  "慳": "less-than-common",
  "慴": "less-than-common",
  "慵": "less-than-common",
  "慶": "common",
  "慷": "common",
  "慹": "less-than-common",
  "慺": "less-than-common",
  "慻": "rarely-used",
  "慼": "common",
  "慾": "common",
  "憀": "less-than-common",
  "憁": "rarely-used",
  "憂": "common",
  "憃": "less-than-common",
  "憄": "rarely-used",
  "憈": "rarely-used",
  "憉": "less-than-common",
  "憊": "common",
  "憋": "less-than-common",
  "憌": "rarely-used",
  "憍": "less-than-common",
  "憎": "common",
  "憏": "rarely-used",
  "憐": "common",
  "憑": "common",
  "憒": "less-than-common",
  "憓": "less-than-common",
  "憔": "common",
  "憕": "rarely-used",
  "憖": "less-than-common",
  "憚": "common",
  "憛": "less-than-common",
  "憝": "less-than-common",
  "憟": "less-than-common",
  "憡": "less-than-common",
  "憢": "less-than-common",
  "憣": "rarely-used",
  "憤": "common",
  "憥": "rarely-used",
  "憦": "rarely-used",
  "憧": "common",
  "憨": "less-than-common",
  "憩": "common",
  "憪": "less-than-common",
  "憫": "common",
  "憬": "common",
  "憭": "less-than-common",
  "憮": "less-than-common",
  "憯": "less-than-common",
  "憰": "less-than-common",
  "憱": "less-than-common",
  "憲": "common",
  "憳": "rarely-used",
  "憴": "less-than-common",
  "憵": "less-than-common",
  "憶": "common",
  "憷": "rarely-used",
  "憸": "less-than-common",
  "憹": "rarely-used",
  "憺": "less-than-common",
  "憼": "less-than-common",
  "憽": "rarely-used",
  "憾": "common",
  "憿": "less-than-common",
  "懀": "rarely-used",
  "懁": "less-than-common",
  "懂": "common",
  "懃": "less-than-common",
  "懅": "less-than-common",
  "懆": "less-than-common",
  "懇": "common",
  "懈": "common",
  "應": "common",
  "懊": "common",
  "懋": "less-than-common",
  "懌": "less-than-common",
  "懍": "common",
  "懎": "rarely-used",
  "懏": "rarely-used",
  "懖": "rarely-used",
  "懗": "rarely-used",
  "懘": "less-than-common",
  "懚": "rarely-used",
  "懛": "rarely-used",
  "懜": "rarely-used",
  "懝": "rarely-used",
  "懞": "less-than-common",
  "懟": "less-than-common",
  "懠": "less-than-common",
  "懡": "rarely-used",
  "懢": "rarely-used",
  "懣": "common",
  "懤": "less-than-common",
  "懥": "less-than-common",
  "懦": "common",
  "懧": "less-than-common",
  "懨": "less-than-common",
  "懩": "rarely-used",
  "懪": "less-than-common",
  "懫": "less-than-common",
  "懬": "rarely-used",
  "懭": "less-than-common",
  "懮": "less-than-common",
  "懯": "rarely-used",
  "懰": "less-than-common",
  "懱": "less-than-common",
  "懲": "common",
  "懳": "rarely-used",
  "懵": "common",
  "懶": "common",
  "懷": "common",
  "懸": "common",
  "懹": "rarely-used",
  "懺": "common",
  "懻": "less-than-common",
  "懼": "common",
  "懽": "less-than-common",
  "懾": "common",
  "懿": "common",
  "戀": "common",
  "戁": "less-than-common",
  "戂": "rarely-used",
  "戃": "less-than-common",
  "戄": "less-than-common",
  "戇": "less-than-common",
  "戈": "common",
  "戉": "less-than-common",
  "戊": "common",
  "戌": "common",
  "戍": "common",
  "戎": "common",
  "成": "common",
  "我": "common",
  "戒": "common",
  "戓": "rarely-used",
  "戔": "less-than-common",
  "戕": "common",
  "或": "common",
  "戙": "rarely-used",
  "戚": "common",
  "戛": "common",
  "戜": "rarely-used",
  "戟": "common",
  "戠": "less-than-common",
  "戡": "common",
  "戢": "common",
  "戣": "less-than-common",
  "戤": "rarely-used",
  "戥": "less-than-common",
  "戧": "less-than-common",
  "戩": "less-than-common",
  "截": "common",
  "戫": "rarely-used",
  "戭": "less-than-common",
  "戮": "common",
  "戰": "common",
  "戲": "common",
  "戳": "common",
  "戴": "common",
  "戵": "rarely-used",
  "戶": "common",
  "戺": "less-than-common",
  "戻": "rarely-used",
  "戽": "less-than-common",
  "戾": "common",
  "房": "common",
  "所": "common",
  "扁": "common",
  "扂": "less-than-common",
  "扃": "less-than-common",
  "扅": "rarely-used",
  "扆": "less-than-common",
  "扇": "common",
  "扈": "common",
  "扉": "common",
  "扊": "less-than-common",
  "手": "common",
  "才": "common",
  "扎": "common",
  "扏": "rarely-used",
  "扐": "less-than-common",
  "扑": "less-than-common",
  "扒": "common",
  "打": "common",
  "扔": "common",
  "托": "common",
  "扙": "rarely-used",
  "扚": "rarely-used",
  "扛": "common",
  "扜": "less-than-common",
  "扝": "rarely-used",
  "扞": "less-than-common",
  "扟": "rarely-used",
  "扠": "rarely-used",
  "扡": "less-than-common",
  "扢": "less-than-common",
  "扣": "common",
  "扤": "less-than-common",
  "扥": "rarely-used",
  "扦": "less-than-common",
  "扭": "common",
  "扮": "common",
  "扯": "common",
  "扰": "rarely-used",
  "扱": "less-than-common",
  "扲": "rarely-used",
  "扳": "common",
  "扴": "rarely-used",
  "扶": "common",
  "扷": "rarely-used",
  "扸": "rarely-used",
  "批": "common",
  "扺": "less-than-common",
  "扻": "less-than-common",
  "扼": "common",
  "扽": "rarely-used",
  "找": "common",
  "承": "common",
  "技": "common",
  "抁": "rarely-used",
  "抂": "rarely-used",
  "抃": "less-than-common",
  "抄": "common",
  "抆": "less-than-common",
  "抇": "less-than-common",
  "抈": "rarely-used",
  "抉": "common",
  "把": "common",
  "抌": "less-than-common",
  "抎": "less-than-common",
  "抏": "less-than-common",
  "抐": "rarely-used",
  "抑": "common",
  "抒": "common",
  "抓": "common",
  "抔": "less-than-common",
  "投": "common",
  "抖": "common",
  "抗": "common",
  "折": "common",
  "抧": "rarely-used",
  "抨": "common",
  "抩": "rarely-used",
  "抪": "less-than-common",
  "披": "common",
  "抬": "common",
  "抭": "less-than-common",
  "抮": "less-than-common",
  "抯": "rarely-used",
  "抰": "rarely-used",
  "抱": "common",
  "抲": "rarely-used",
  "抳": "rarely-used",
  "抴": "less-than-common",
  "抵": "common",
  "抶": "less-than-common",
  "抷": "rarely-used",
  "抸": "rarely-used",
  "抹": "common",
  "抺": "rarely-used",
  "抻": "rarely-used",
  "押": "common",
  "抽": "common",
  "抾": "less-than-common",
  "抿": "common",
  "拂": "common",
  "拄": "common",
  "拆": "common",
  "拇": "common",
  "拈": "common",
  "拉": "common",
  "拊": "less-than-common",
  "拋": "common",
  "拌": "common",
  "拍": "common",
  "拎": "common",
  "拏": "less-than-common",
  "拐": "common",
  "拑": "less-than-common",
  "拒": "common",
  "拓": "common",
  "拔": "common",
  "拖": "common",
  "拗": "common",
  "拘": "common",
  "拙": "common",
  "拚": "common",
  "招": "common",
  "拜": "common",
  "拤": "rarely-used",
  "拫": "less-than-common",
  "括": "common",
  "拭": "common",
  "拮": "common",
  "拯": "common",
  "拰": "rarely-used",
  "拱": "common",
  "拲": "less-than-common",
  "拳": "common",
  "拴": "common",
  "拵": "less-than-common",
  "拶": "less-than-common",
  "拷": "common",
  "拸": "less-than-common",
  "拹": "less-than-common",
  "拺": "rarely-used",
  "拻": "rarely-used",
  "拼": "common",
  "拽": "common",
  "拾": "common",
  "拿": "common",
  "挀": "less-than-common",
  "持": "common",
  "挂": "less-than-common",
  "挃": "less-than-common",
  "挆": "rarely-used",
  "指": "common",
  "挈": "common",
  "按": "common",
  "挋": "less-than-common",
  "挌": "less-than-common",
  "挍": "less-than-common",
  "挎": "less-than-common",
  "挏": "less-than-common",
  "挐": "less-than-common",
  "挑": "common",
  "挒": "rarely-used",
  "挓": "rarely-used",
  "挔": "rarely-used",
  "挕": "rarely-used",
  "挖": "common",
  "挨": "common",
  "挩": "less-than-common",
  "挪": "common",
  "挫": "common",
  "挬": "less-than-common",
  "挭": "rarely-used",
  "挮": "rarely-used",
  "振": "common",
  "挰": "rarely-used",
  "挲": "less-than-common",
  "挳": "rarely-used",
  "挴": "less-than-common",
  "挶": "less-than-common",
  "挸": "rarely-used",
  "挹": "less-than-common",
  "挺": "common",
  "挻": "less-than-common",
  "挼": "less-than-common",
  "挽": "common",
  "挾": "common",
  "捀": "rarely-used",
  "捁": "less-than-common",
  "捂": "common",
  "捃": "less-than-common",
  "捄": "less-than-common",
  "捅": "less-than-common",
  "捆": "common",
  "捇": "rarely-used",
  "捈": "rarely-used",
  "捉": "common",
  "捊": "less-than-common",
  "捋": "less-than-common",
  "捌": "less-than-common",
  "捍": "less-than-common",
  "捎": "common",
  "捏": "common",
  "捐": "common",
  "捑": "rarely-used",
  "捒": "rarely-used",
  "捔": "less-than-common",
  "捕": "common",
  "捖": "less-than-common",
  "捗": "rarely-used",
  "捘": "less-than-common",
  "捙": "rarely-used",
  "捚": "rarely-used",
  "捛": "rarely-used",
  "捥": "less-than-common",
  "捧": "common",
  "捨": "common",
  "捩": "common",
  "捪": "rarely-used",
  "捫": "common",
  "捭": "less-than-common",
  "据": "less-than-common",
  "捯": "less-than-common",
  "捰": "rarely-used",
  "捱": "common",
  "捲": "common",
  "捳": "rarely-used",
  "捵": "less-than-common",
  "捶": "common",
  "捷": "common",
  "捸": "rarely-used",
  "捹": "rarely-used",
  "捺": "less-than-common",
  "捻": "common",
  "捼": "less-than-common",
  "捽": "less-than-common",
  "捾": "rarely-used",
  "掀": "common",
  "掁": "rarely-used",
  "掂": "less-than-common",
  "掃": "common",
  "掄": "common",
  "掅": "rarely-used",
  "掆": "rarely-used",
  "掇": "less-than-common",
  "授": "common",
  "掉": "common",
  "掊": "less-than-common",
  "掋": "rarely-used",
  "掌": "common",
  "掍": "rarely-used",
  "掎": "less-than-common",
  "掏": "common",
  "掐": "less-than-common",
  "掑": "rarely-used",
  "排": "common",
  "掓": "rarely-used",
  "掔": "less-than-common",
  "掕": "rarely-used",
  "掖": "common",
  "掗": "less-than-common",
  "掘": "common",
  "掙": "common",
  "掚": "rarely-used",
  "掛": "common",
  "掜": "less-than-common",
  "掝": "less-than-common",
  "掞": "less-than-common",
  "掟": "rarely-used",
  "掠": "common",
  "採": "common",
  "探": "common",
  "掣": "common",
  "掤": "less-than-common",
  "接": "common",
  "控": "common",
  "推": "common",
  "掩": "common",
  "措": "common",
  "掫": "less-than-common",
  "掬": "common",
  "掭": "less-than-common",
  "掮": "less-than-common",
  "掯": "less-than-common",
  "掰": "less-than-common",
  "掱": "less-than-common",
  "掽": "less-than-common",
  "掾": "less-than-common",
  "揀": "common",
  "揂": "rarely-used",
  "揃": "less-than-common",
  "揄": "less-than-common",
  "揅": "less-than-common",
  "揆": "common",
  "揇": "rarely-used",
  "揈": "rarely-used",
  "揉": "common",
  "揊": "less-than-common",
  "揋": "rarely-used",
  "揌": "rarely-used",
  "揍": "common",
  "揎": "less-than-common",
  "描": "common",
  "提": "common",
  "插": "common",
  "揓": "rarely-used",
  "揕": "less-than-common",
  "揖": "common",
  "揗": "rarely-used",
  "揘": "less-than-common",
  "揙": "rarely-used",
  "揚": "common",
  "換": "common",
  "揜": "less-than-common",
  "揝": "less-than-common",
  "揞": "rarely-used",
  "揟": "less-than-common",
  "揠": "less-than-common",
  "握": "common",
  "揢": "rarely-used",
  "揣": "common",
  "揤": "less-than-common",
  "揥": "less-than-common",
  "揦": "rarely-used",
  "揧": "rarely-used",
  "揨": "less-than-common",
  "揩": "common",
  "揪": "common",
  "揫": "less-than-common",
  "揬": "rarely-used",
  "揭": "common",
  "揮": "common",
  "揯": "less-than-common",
  "揰": "rarely-used",
  "揱": "less-than-common",
  "揲": "less-than-common",
  "揳": "less-than-common",
  "援": "common",
  "揵": "less-than-common",
  "揶": "less-than-common",
  "揹": "less-than-common",
  "搆": "less-than-common",
  "搈": "rarely-used",
  "搉": "less-than-common",
  "搊": "less-than-common",
  "搋": "less-than-common",
  "搌": "less-than-common",
  "損": "common",
  "搎": "rarely-used",
  "搏": "common",
  "搐": "less-than-common",
  "搑": "rarely-used",
  "搒": "less-than-common",
  "搓": "common",
  "搔": "common",
  "搕": "less-than-common",
  "搖": "common",
  "搗": "common",
  "搘": "less-than-common",
  "搙": "rarely-used",
  "搚": "less-than-common",
  "搛": "rarely-used",
  "搜": "common",
  "搝": "rarely-used",
  "搞": "common",
  "搟": "less-than-common",
  "搠": "less-than-common",
  "搡": "rarely-used",
  "搢": "less-than-common",
  "搣": "less-than-common",
  "搤": "less-than-common",
  "搥": "less-than-common",
  "搦": "less-than-common",
  "搧": "less-than-common",
  "搨": "less-than-common",
  "搩": "rarely-used",
  "搪": "common",
  "搫": "less-than-common",
  "搬": "common",
  "搭": "common",
  "搮": "rarely-used",
  "搯": "less-than-common",
  "搰": "less-than-common",
  "搱": "rarely-used",
  "搲": "rarely-used",
  "搳": "less-than-common",
  "搴": "less-than-common",
  "搵": "less-than-common",
  "搶": "common",
  "搷": "less-than-common",
  "搸": "rarely-used",
  "搹": "less-than-common",
  "搽": "common",
  "搾": "common",
  "搿": "rarely-used",
  "摀": "less-than-common",
  "摁": "less-than-common",
  "摃": "less-than-common",
  "摋": "less-than-common",
  "摌": "rarely-used",
  "摍": "less-than-common",
  "摎": "less-than-common",
  "摐": "less-than-common",
  "摑": "common",
  "摒": "common",
  "摓": "less-than-common",
  "摔": "common",
  "摕": "rarely-used",
  "摖": "rarely-used",
  "摗": "rarely-used",
  "摘": "common",
  "摙": "rarely-used",
  "摚": "rarely-used",
  "摛": "less-than-common",
  "摜": "less-than-common",
  "摝": "less-than-common",
  "摞": "less-than-common",
  "摟": "common",
  "摠": "less-than-common",
  "摡": "less-than-common",
  "摢": "rarely-used",
  "摣": "rarely-used",
  "摥": "rarely-used",
  "摦": "less-than-common",
  "摧": "common",
  "摨": "rarely-used",
  "摩": "common",
  "摪": "rarely-used",
  "摫": "rarely-used",
  "摬": "rarely-used",
  "摭": "less-than-common",
  "摮": "less-than-common",
  "摯": "common",
  "摰": "less-than-common",
  "摱": "rarely-used",
  "摲": "less-than-common",
  "摳": "less-than-common",
  "摴": "less-than-common",
  "摵": "less-than-common",
  "摶": "less-than-common",
  "摷": "rarely-used",
  "摸": "common",
  "摹": "common",
  "摺": "common",
  "摻": "less-than-common",
  "摼": "rarely-used",
  "摽": "less-than-common",
  "摿": "less-than-common",
  "撀": "rarely-used",
  "撂": "less-than-common",
  "撅": "less-than-common",
  "撇": "common",
  "撈": "common",
  "撉": "rarely-used",
  "撊": "less-than-common",
  "撋": "less-than-common",
  "撌": "less-than-common",
  "撍": "rarely-used",
  "撎": "rarely-used",
  "撏": "less-than-common",
  "撐": "common",
  "撒": "common",
  "撓": "common",
  "撔": "rarely-used",
  "撕": "common",
  "撖": "less-than-common",
  "撗": "less-than-common",
  "撘": "rarely-used",
  "撙": "less-than-common",
  "撚": "common",
  "撛": "rarely-used",
  "撜": "less-than-common",
  "撝": "less-than-common",
  "撞": "common",
  "撟": "less-than-common",
  "撠": "less-than-common",
  "撢": "less-than-common",
  "撣": "less-than-common",
  "撤": "common",
  "撥": "common",
  "撦": "less-than-common",
  "撨": "rarely-used",
  "撩": "common",
  "撫": "common",
  "撬": "common",
  "播": "common",
  "撮": "common",
  "撰": "common",
  "撱": "rarely-used",
  "撲": "common",
  "撳": "less-than-common",
  "撻": "common",
  "撼": "common",
  "撽": "less-than-common",
  "撾": "less-than-common",
  "撿": "common",
  "擀": "rarely-used",
  "擁": "common",
  "擂": "common",
  "擃": "rarely-used",
  "擄": "common",
  "擅": "common",
  "擆": "rarely-used",
  "擇": "common",
  "擉": "less-than-common",
  "擊": "common",
  "擋": "common",
  "擌": "rarely-used",
  "操": "common",
  "擎": "common",
  "擏": "less-than-common",
  "擐": "less-than-common",
  "擒": "common",
  "擓": "rarely-used",
  "擔": "common",
  "擖": "less-than-common",
  "擗": "less-than-common",
  "擘": "common",
  "擙": "rarely-used",
  "據": "common",
  "擛": "rarely-used",
  "擟": "rarely-used",
  "擠": "common",
  "擢": "less-than-common",
  "擣": "less-than-common",
  "擤": "less-than-common",
  "擦": "common",
  "擨": "less-than-common",
  "擩": "less-than-common",
  "擫": "less-than-common",
  "擬": "common",
  "擭": "less-than-common",
  "擯": "less-than-common",
  "擰": "common",
  "擱": "common",
  "擲": "common",
  "擳": "rarely-used",
  "擴": "common",
  "擶": "rarely-used",
  "擷": "less-than-common",
  "擸": "less-than-common",
  "擺": "common",
  "擻": "common",
  "擼": "rarely-used",
  "擽": "less-than-common",
  "擾": "common",
  "擿": "less-than-common",
  "攀": "common",
  "攁": "rarely-used",
  "攃": "rarely-used",
  "攄": "less-than-common",
  "攆": "common",
  "攇": "less-than-common",
  "攉": "less-than-common",
  "攋": "rarely-used",
  "攌": "less-than-common",
  "攍": "less-than-common",
  "攎": "rarely-used",
  "攏": "common",
  "攐": "less-than-common",
  "攑": "rarely-used",
  "攓": "less-than-common",
  "攔": "common",
  "攕": "less-than-common",
  "攖": "less-than-common",
  "攗": "less-than-common",
  "攘": "common",
  "攙": "common",
  "攛": "less-than-common",
  "攜": "common",
  "攝": "common",
  "攞": "rarely-used",
  "攠": "less-than-common",
  "攡": "less-than-common",
  "攢": "less-than-common",
  "攣": "common",
  "攤": "common",
  "攥": "rarely-used",
  "攦": "less-than-common",
  "攧": "rarely-used",
  "攩": "less-than-common",
  "攪": "common",
  "攫": "common",
  "攬": "common",
  "攭": "less-than-common",
  "攮": "less-than-common",
  "支": "common",
  "攱": "rarely-used",
  "攲": "less-than-common",
  "攳": "less-than-common",
  "攴": "rarely-used",
  "收": "common",
  "攷": "less-than-common",
  "攸": "less-than-common",
  "改": "common",
  "攺": "rarely-used",
  "攻": "common",
  "攼": "rarely-used",
  "攽": "less-than-common",
  "放": "common",
  "政": "common",
  "敀": "rarely-used",
  "敁": "less-than-common",
  "敃": "rarely-used",
  "敄": "rarely-used",
  "故": "common",
  "敆": "less-than-common",
  "敇": "rarely-used",
  "效": "common",
  "敉": "less-than-common",
  "敊": "less-than-common",
  "敋": "rarely-used",
  "敌": "rarely-used",
  "敏": "common",
  "敐": "rarely-used",
  "救": "common",
  "敒": "rarely-used",
  "敓": "less-than-common",
  "敔": "less-than-common",
  "敕": "less-than-common",
  "敖": "common",
  "敗": "common",
  "敘": "common",
  "教": "common",
  "敜": "less-than-common",
  "敝": "common",
  "敞": "common",
  "敟": "rarely-used",
  "敠": "rarely-used",
  "敡": "rarely-used",
  "敢": "common",
  "散": "common",
  "敤": "less-than-common",
  "敥": "rarely-used",
  "敦": "common",
  "敧": "less-than-common",
  "敨": "rarely-used",
  "敪": "less-than-common",
  "敫": "rarely-used",
  "敬": "common",
  "敮": "rarely-used",
  "敯": "less-than-common",
  "敱": "rarely-used",
  "敲": "common",
  "敳": "less-than-common",
  "整": "common",
  "敵": "common",
  "敶": "less-than-common",
  "敷": "common",
  "數": "common",
  "敹": "less-than-common",
  "敺": "less-than-common",
  "敻": "less-than-common",
  "敼": "rarely-used",
  "敿": "less-than-common",
  "斀": "less-than-common",
  "斁": "less-than-common",
  "斂": "common",
  "斃": "common",
  "斄": "less-than-common",
  "文": "common",
  "斌": "less-than-common",
  "斐": "common",
  "斑": "common",
  "斒": "less-than-common",
  "斔": "less-than-common",
  "斕": "less-than-common",
  "斖": "less-than-common",
  "斗": "common",
  "斘": "rarely-used",
  "料": "common",
  "斛": "less-than-common",
  "斜": "common",
  "斝": "less-than-common",
  "斞": "less-than-common",
  "斟": "common",
  "斠": "less-than-common",
  "斡": "common",
  "斢": "rarely-used",
  "斣": "rarely-used",
  "斤": "common",
  "斥": "common",
  "斦": "rarely-used",
  "斧": "common",
  "斨": "less-than-common",
  "斪": "less-than-common",
  "斫": "common",
  "斬": "common",
  "斮": "less-than-common",
  "斯": "common",
  "新": "common",
  "斲": "less-than-common",
  "斳": "rarely-used",
  "斶": "less-than-common",
  "斷": "common",
  "斸": "rarely-used",
  "方": "common",
  "斺": "rarely-used",
  "斻": "less-than-common",
  "於": "common",
  "施": "common",
  "斿": "less-than-common",
  "旁": "common",
  "旂": "less-than-common",
  "旃": "less-than-common",
  "旄": "less-than-common",
  "旅": "common",
  "旆": "less-than-common",
  "旇": "rarely-used",
  "旋": "common",
  "旌": "common",
  "旍": "less-than-common",
  "旎": "common",
  "族": "common",
  "旐": "less-than-common",
  "旒": "less-than-common",
  "旓": "less-than-common",
  "旔": "rarely-used",
  "旖": "common",
  "旗": "common",
  "旚": "less-than-common",
  "旛": "less-than-common",
  "旝": "less-than-common",
  "旞": "less-than-common",
  "旟": "less-than-common",
  "旡": "rarely-used",
  "既": "common",
  "日": "common",
  "旦": "common",
  "旨": "common",
  "早": "common",
  "旫": "rarely-used",
  "旬": "common",
  "旭": "common",
  "旮": "less-than-common",
  "旯": "less-than-common",
  "旰": "less-than-common",
  "旱": "common",
  "旲": "rarely-used",
  "旳": "less-than-common",
  "旴": "less-than-common",
  "旵": "rarely-used",
  "旺": "common",
  "旻": "less-than-common",
  "旼": "less-than-common",
  "旽": "rarely-used",
  "旿": "rarely-used",
  "昀": "common",
  "昂": "common",
  "昃": "less-than-common",
  "昄": "less-than-common",
  "昅": "rarely-used",
  "昆": "common",
  "昇": "less-than-common",
  "昈": "less-than-common",
  "昉": "less-than-common",
  "昊": "less-than-common",
  "昋": "rarely-used",
  "昌": "common",
  "昍": "rarely-used",
  "明": "common",
  "昏": "common",
  "昐": "rarely-used",
  "昑": "rarely-used",
  "昒": "less-than-common",
  "易": "common",
  "昔": "common",
  "昕": "less-than-common",
  "昛": "rarely-used",
  "昜": "less-than-common",
  "昝": "less-than-common",
  "星": "common",
  "映": "common",
  "昡": "less-than-common",
  "昢": "less-than-common",
  "昣": "rarely-used",
  "昤": "rarely-used",
  "春": "common",
  "昦": "less-than-common",
  "昧": "common",
  "昨": "common",
  "昩": "rarely-used",
  "昪": "rarely-used",
  "昫": "less-than-common",
  "昭": "common",
  "昮": "rarely-used",
  "是": "common",
  "昱": "less-than-common",
  "昲": "less-than-common",
  "昳": "less-than-common",
  "昴": "less-than-common",
  "昵": "less-than-common",
  "昶": "less-than-common",
  "昹": "rarely-used",
  "昺": "less-than-common",
  "晀": "rarely-used",
  "晁": "less-than-common",
  "時": "common",
  "晃": "common",
  "晅": "less-than-common",
  "晆": "rarely-used",
  "晇": "less-than-common",
  "晉": "common",
  "晊": "less-than-common",
  "晌": "common",
  "晎": "rarely-used",
  "晏": "common",
  "晐": "rarely-used",
  "晑": "rarely-used",
  "晒": "common",
  "晗": "rarely-used",
  "晘": "rarely-used",
  "晙": "less-than-common",
  "晚": "common",
  "晛": "less-than-common",
  "晜": "less-than-common",
  "晝": "common",
  "晞": "less-than-common",
  "晟": "less-than-common",
  "晡": "less-than-common",
  "晢": "less-than-common",
  "晤": "common",
  "晥": "less-than-common",
  "晦": "common",
  "晨": "common",
  "晪": "rarely-used",
  "晫": "rarely-used",
  "晬": "less-than-common",
  "普": "common",
  "景": "common",
  "晰": "common",
  "晱": "rarely-used",
  "晲": "rarely-used",
  "晴": "common",
  "晵": "rarely-used",
  "晶": "common",
  "晷": "less-than-common",
  "晸": "rarely-used",
  "晹": "rarely-used",
  "智": "common",
  "晻": "less-than-common",
  "晼": "less-than-common",
  "晽": "rarely-used",
  "晾": "less-than-common",
  "晿": "rarely-used",
  "暀": "less-than-common",
  "暄": "less-than-common",
  "暆": "less-than-common",
  "暇": "common",
  "暈": "common",
  "暉": "common",
  "暊": "rarely-used",
  "暋": "less-than-common",
  "暌": "less-than-common",
  "暍": "less-than-common",
  "暐": "less-than-common",
  "暑": "common",
  "暓": "rarely-used",
  "暔": "rarely-used",
  "暕": "less-than-common",
  "暖": "common",
  "暗": "common",
  "暘": "less-than-common",
  "暙": "rarely-used",
  "暚": "rarely-used",
  "暛": "rarely-used",
  "暝": "less-than-common",
  "暟": "rarely-used",
  "暠": "less-than-common",
  "暡": "less-than-common",
  "暢": "common",
  "暣": "rarely-used",
  "暥": "rarely-used",
  "暨": "common",
  "暩": "less-than-common",
  "暪": "rarely-used",
  "暫": "common",
  "暬": "rarely-used",
  "暮": "common",
  "暯": "rarely-used",
  "暰": "less-than-common",
  "暱": "less-than-common",
  "暲": "rarely-used",
  "暳": "rarely-used",
  "暴": "common",
  "暵": "less-than-common",
  "暶": "rarely-used",
  "暷": "rarely-used",
  "暸": "rarely-used",
  "暹": "common",
  "暺": "rarely-used",
  "暻": "rarely-used",
  "暼": "rarely-used",
  "暽": "rarely-used",
  "暾": "less-than-common",
  "曀": "less-than-common",
  "曂": "rarely-used",
  "曃": "rarely-used",
  "曄": "less-than-common",
  "曆": "common",
  "曇": "less-than-common",
  "曈": "less-than-common",
  "曉": "common",
  "曊": "less-than-common",
  "曋": "less-than-common",
  "曌": "rarely-used",
  "曏": "less-than-common",
  "曒": "less-than-common",
  "曔": "rarely-used",
  "曕": "rarely-used",
  "曖": "common",
  "曘": "rarely-used",
  "曙": "common",
  "曚": "less-than-common",
  "曛": "less-than-common",
  "曜": "less-than-common",
  "曝": "common",
  "曞": "rarely-used",
  "曠": "common",
  "曣": "less-than-common",
  "曤": "rarely-used",
  "曥": "rarely-used",
  "曦": "common",
  "曧": "rarely-used",
  "曨": "less-than-common",
  "曩": "less-than-common",
  "曪": "rarely-used",
  "曫": "rarely-used",
  "曭": "less-than-common",
  "曮": "less-than-common",
  "曰": "common",
  "曱": "rarely-used",
  "曲": "common",
  "曳": "common",
  "更": "common",
  "曶": "less-than-common",
  "曷": "common",
  "書": "common",
  "曹": "common",
  "曼": "common",
  "曾": "common",
  "替": "common",
  "最": "common",
  "朁": "less-than-common",
  "會": "common",
  "朄": "less-than-common",
  "朅": "less-than-common",
  "朆": "rarely-used",
  "月": "common",
  "有": "common",
  "朊": "rarely-used",
  "朋": "common",
  "服": "common",
  "朎": "rarely-used",
  "朏": "less-than-common",
  "朐": "less-than-common",
  "朒": "less-than-common",
  "朓": "less-than-common",
  "朔": "common",
  "朕": "common",
  "朗": "common",
  "朘": "less-than-common",
  "朚": "rarely-used",
  "望": "common",
  "朝": "common",
  "期": "common",
  "朠": "rarely-used",
  "朡": "less-than-common",
  "朢": "less-than-common",
  "朣": "less-than-common",
  "朦": "common",
  "朧": "common",
  "木": "common",
  "未": "common",
  "末": "common",
  "本": "common",
  "札": "common",
  "朮": "common",
  "朱": "common",
  "朲": "rarely-used",
  "朳": "rarely-used",
  "朴": "common",
  "朵": "common",
  "朷": "rarely-used",
  "朸": "less-than-common",
  "朹": "less-than-common",
  "机": "less-than-common",
  "朻": "less-than-common",
  "朼": "less-than-common",
  "朽": "common",
  "朾": "less-than-common",
  "朿": "less-than-common",
  "杅": "less-than-common",
  "杆": "less-than-common",
  "杇": "less-than-common",
  "杈": "less-than-common",
  "杉": "common",
  "杋": "rarely-used",
  "杌": "less-than-common",
  "杍": "rarely-used",
  "李": "common",
  "杏": "common",
  "材": "common",
  "村": "common",
  "杒": "rarely-used",
  "杓": "less-than-common",
  "杔": "rarely-used",
  "杕": "less-than-common",
  "杖": "common",
  "杗": "less-than-common",
  "杘": "rarely-used",
  "杙": "less-than-common",
  "杚": "rarely-used",
  "杛": "rarely-used",
  "杜": "common",
  "杝": "less-than-common",
  "杞": "common",
  "束": "common",
  "杠": "less-than-common",
  "杪": "less-than-common",
  "杫": "rarely-used",
  "杬": "less-than-common",
  "杭": "common",
  "杯": "common",
  "杰": "common",
  "東": "common",
  "杲": "less-than-common",
  "杳": "common",
  "杴": "less-than-common",
  "杵": "common",
  "杶": "less-than-common",
  "杷": "common",
  "杸": "rarely-used",
  "杹": "rarely-used",
  "杺": "rarely-used",
  "杻": "less-than-common",
  "杼": "less-than-common",
  "杽": "rarely-used",
  "松": "common",
  "板": "common",
  "极": "rarely-used",
  "枂": "rarely-used",
  "枃": "rarely-used",
  "构": "less-than-common",
  "枅": "less-than-common",
  "枆": "less-than-common",
  "枇": "common",
  "枈": "rarely-used",
  "枉": "common",
  "枊": "rarely-used",
  "枋": "common",
  "枌": "less-than-common",
  "枍": "less-than-common",
  "枎": "less-than-common",
  "析": "common",
  "枑": "rarely-used",
  "枒": "less-than-common",
  "枓": "less-than-common",
  "枔": "rarely-used",
  "枕": "common",
  "枖": "rarely-used",
  "林": "common",
  "枘": "less-than-common",
  "枙": "rarely-used",
  "枚": "common",
  "枛": "rarely-used",
  "果": "common",
  "枝": "common",
  "枟": "rarely-used",
  "枮": "rarely-used",
  "枯": "common",
  "枰": "less-than-common",
  "枲": "less-than-common",
  "枳": "less-than-common",
  "枴": "common",
  "枵": "less-than-common",
  "架": "common",
  "枷": "less-than-common",
  "枸": "common",
  "枹": "less-than-common",
  "枺": "less-than-common",
  "枻": "less-than-common",
  "枼": "rarely-used",
  "柀": "less-than-common",
  "柁": "less-than-common",
  "柂": "less-than-common",
  "柃": "rarely-used",
  "柄": "common",
  "柅": "less-than-common",
  "柆": "rarely-used",
  "柇": "rarely-used",
  "柈": "less-than-common",
  "柉": "rarely-used",
  "柊": "rarely-used",
  "柋": "rarely-used",
  "柌": "rarely-used",
  "柍": "less-than-common",
  "柎": "less-than-common",
  "柏": "common",
  "某": "common",
  "柑": "common",
  "柒": "less-than-common",
  "染": "common",
  "柔": "common",
  "柖": "rarely-used",
  "柘": "less-than-common",
  "柙": "less-than-common",
  "柚": "common",
  "柛": "rarely-used",
  "柜": "less-than-common",
  "柝": "less-than-common",
  "柞": "common",
  "柟": "less-than-common",
  "柡": "rarely-used",
  "柢": "less-than-common",
  "柣": "less-than-common",
  "柤": "less-than-common",
  "查": "common",
  "柦": "rarely-used",
  "柧": "less-than-common",
  "柨": "rarely-used",
  "柩": "common",
  "柪": "rarely-used",
  "柫": "less-than-common",
  "柬": "common",
  "柭": "rarely-used",
  "柮": "less-than-common",
  "柯": "common",
  "柰": "less-than-common",
  "柱": "common",
  "柲": "less-than-common",
  "柳": "common",
  "柴": "common",
  "柵": "common",
  "柶": "less-than-common",
  "柷": "less-than-common",
  "柸": "less-than-common",
  "柺": "rarely-used",
  "柼": "rarely-used",
  "柿": "common",
  "栒": "less-than-common",
  "栓": "common",
  "栔": "less-than-common",
  "栖": "less-than-common",
  "栗": "common",
  "栘": "less-than-common",
  "栙": "rarely-used",
  "栚": "less-than-common",
  "栛": "rarely-used",
  "栜": "less-than-common",
  "栝": "less-than-common",
  "栟": "less-than-common",
  "栠": "rarely-used",
  "校": "common",
  "栤": "rarely-used",
  "栥": "rarely-used",
  "栦": "rarely-used",
  "栨": "rarely-used",
  "栩": "common",
  "株": "common",
  "栫": "less-than-common",
  "栬": "rarely-used",
  "栭": "less-than-common",
  "栮": "rarely-used",
  "栯": "less-than-common",
  "栱": "less-than-common",
  "栲": "less-than-common",
  "栳": "less-than-common",
  "栴": "less-than-common",
  "栵": "less-than-common",
  "栶": "rarely-used",
  "样": "rarely-used",
  "核": "common",
  "根": "common",
  "栺": "rarely-used",
  "栻": "less-than-common",
  "格": "common",
  "栽": "common",
  "栿": "rarely-used",
  "桀": "common",
  "桁": "less-than-common",
  "桂": "common",
  "桃": "common",
  "桄": "less-than-common",
  "桅": "common",
  "框": "common",
  "桇": "rarely-used",
  "案": "common",
  "桉": "less-than-common",
  "桊": "rarely-used",
  "桋": "less-than-common",
  "桌": "common",
  "桍": "rarely-used",
  "桎": "less-than-common",
  "桏": "less-than-common",
  "桐": "common",
  "桑": "common",
  "桓": "common",
  "桔": "common",
  "桖": "rarely-used",
  "桫": "rarely-used",
  "桭": "less-than-common",
  "桮": "less-than-common",
  "桯": "less-than-common",
  "桱": "rarely-used",
  "桲": "rarely-used",
  "桳": "rarely-used",
  "桴": "less-than-common",
  "桵": "less-than-common",
  "桶": "common",
  "桷": "less-than-common",
  "桸": "rarely-used",
  "桹": "less-than-common",
  "桻": "rarely-used",
  "桼": "less-than-common",
  "桽": "rarely-used",
  "桾": "rarely-used",
  "桿": "common",
  "梀": "rarely-used",
  "梁": "common",
  "梂": "less-than-common",
  "梃": "common",
  "梅": "common",
  "梆": "common",
  "梇": "less-than-common",
  "梈": "rarely-used",
  "梉": "rarely-used",
  "梊": "rarely-used",
  "梋": "rarely-used",
  "梌": "rarely-used",
  "梎": "rarely-used",
  "梏": "less-than-common",
  "梐": "less-than-common",
  "梑": "rarely-used",
  "梒": "less-than-common",
  "梓": "common",
  "梔": "common",
  "梖": "rarely-used",
  "梗": "common",
  "梘": "rarely-used",
  "梚": "rarely-used",
  "梛": "rarely-used",
  "梜": "less-than-common",
  "條": "common",
  "梞": "rarely-used",
  "梟": "common",
  "梠": "rarely-used",
  "梡": "less-than-common",
  "梢": "common",
  "梣": "less-than-common",
  "梤": "rarely-used",
  "梧": "common",
  "梨": "common",
  "梩": "less-than-common",
  "梪": "rarely-used",
  "梫": "less-than-common",
  "梬": "less-than-common",
  "梭": "common",
  "梮": "less-than-common",
  "梯": "common",
  "械": "common",
  "梱": "common",
  "梲": "less-than-common",
  "梳": "common",
  "梴": "less-than-common",
  "梵": "common",
  "梶": "rarely-used",
  "梷": "rarely-used",
  "棄": "common",
  "棆": "less-than-common",
  "棇": "rarely-used",
  "棈": "rarely-used",
  "棉": "common",
  "棋": "common",
  "棌": "less-than-common",
  "棍": "common",
  "棎": "rarely-used",
  "棐": "less-than-common",
  "棑": "rarely-used",
  "棒": "common",
  "棓": "less-than-common",
  "棔": "rarely-used",
  "棕": "common",
  "棖": "less-than-common",
  "棗": "common",
  "棘": "common",
  "棙": "rarely-used",
  "棚": "common",
  "棛": "rarely-used",
  "棜": "less-than-common",
  "棝": "rarely-used",
  "棞": "rarely-used",
  "棟": "common",
  "棠": "common",
  "棡": "less-than-common",
  "棣": "common",
  "棤": "less-than-common",
  "棥": "rarely-used",
  "棦": "rarely-used",
  "棧": "common",
  "棨": "less-than-common",
  "棩": "rarely-used",
  "棪": "less-than-common",
  "棫": "less-than-common",
  "棬": "less-than-common",
  "棭": "rarely-used",
  "森": "common",
  "棯": "less-than-common",
  "棰": "less-than-common",
  "棱": "less-than-common",
  "棲": "common",
  "棳": "less-than-common",
  "棴": "rarely-used",
  "棵": "common",
  "棶": "less-than-common",
  "棷": "less-than-common",
  "棸": "less-than-common",
  "棹": "common",
  "棺": "common",
  "棻": "less-than-common",
  "棼": "less-than-common",
  "棽": "less-than-common",
  "棾": "rarely-used",
  "椂": "rarely-used",
  "椃": "rarely-used",
  "椄": "less-than-common",
  "椅": "common",
  "椆": "rarely-used",
  "椇": "less-than-common",
  "椈": "less-than-common",
  "椊": "rarely-used",
  "椋": "rarely-used",
  "椌": "less-than-common",
  "植": "common",
  "椎": "common",
  "椏": "less-than-common",
  "椐": "less-than-common",
  "椑": "less-than-common",
  "椒": "common",
  "椓": "less-than-common",
  "椔": "less-than-common",
  "椕": "rarely-used",
  "椗": "rarely-used",
  "椞": "rarely-used",
  "椥": "rarely-used",
  "椪": "less-than-common",
  "椯": "rarely-used",
  "椰": "common",
  "椱": "rarely-used",
  "椲": "rarely-used",
  "椳": "less-than-common",
  "椴": "less-than-common",
  "椵": "less-than-common",
  "椷": "rarely-used",
  "椸": "less-than-common",
  "椹": "less-than-common",
  "椺": "rarely-used",
  "椻": "rarely-used",
  "椼": "rarely-used",
  "椽": "less-than-common",
  "椿": "less-than-common",
  "楀": "less-than-common",
  "楁": "rarely-used",
  "楂": "less-than-common",
  "楄": "less-than-common",
  "楅": "less-than-common",
  "楆": "rarely-used",
  "楈": "less-than-common",
  "楉": "less-than-common",
  "楊": "common",
  "楋": "rarely-used",
  "楌": "rarely-used",
  "楎": "less-than-common",
  "楏": "rarely-used",
  "楑": "rarely-used",
  "楒": "rarely-used",
  "楓": "common",
  "楔": "common",
  "楖": "less-than-common",
  "楗": "less-than-common",
  "楘": "less-than-common",
  "楙": "less-than-common",
  "楚": "common",
  "楛": "less-than-common",
  "楜": "rarely-used",
  "楝": "less-than-common",
  "楞": "common",
  "楟": "less-than-common",
  "楠": "common",
  "楢": "less-than-common",
  "楣": "less-than-common",
  "楥": "less-than-common",
  "楦": "less-than-common",
  "楨": "common",
  "楩": "less-than-common",
  "楪": "less-than-common",
  "楫": "common",
  "楬": "less-than-common",
  "業": "common",
  "楮": "less-than-common",
  "楯": "less-than-common",
  "楰": "less-than-common",
  "楱": "less-than-common",
  "楲": "rarely-used",
  "楴": "rarely-used",
  "極": "common",
  "楶": "less-than-common",
  "楷": "common",
  "楸": "less-than-common",
  "楹": "common",
  "楺": "less-than-common",
  "楻": "rarely-used",
  "概": "common",
  "榃": "rarely-used",
  "榆": "common",
  "榍": "less-than-common",
  "榎": "less-than-common",
  "榏": "rarely-used",
  "榐": "rarely-used",
  "榑": "less-than-common",
  "榒": "rarely-used",
  "榓": "rarely-used",
  "榔": "common",
  "榕": "common",
  "榖": "less-than-common",
  "榗": "rarely-used",
  "榙": "less-than-common",
  "榚": "rarely-used",
  "榛": "common",
  "榜": "common",
  "榞": "rarely-used",
  "榠": "less-than-common",
  "榡": "rarely-used",
  "榣": "rarely-used",
  "榤": "less-than-common",
  "榥": "rarely-used",
  "榦": "less-than-common",
  "榧": "less-than-common",
  "榨": "common",
  "榩": "less-than-common",
  "榪": "rarely-used",
  "榫": "common",
  "榬": "less-than-common",
  "榭": "common",
  "榮": "common",
  "榯": "less-than-common",
  "榰": "less-than-common",
  "榱": "less-than-common",
  "榲": "rarely-used",
  "榳": "rarely-used",
  "榴": "common",
  "榵": "rarely-used",
  "榶": "less-than-common",
  "榷": "common",
  "榸": "rarely-used",
  "榹": "less-than-common",
  "榺": "rarely-used",
  "榻": "common",
  "榼": "less-than-common",
  "榽": "less-than-common",
  "榾": "less-than-common",
  "榿": "less-than-common",
  "槁": "common",
  "槂": "rarely-used",
  "槃": "less-than-common",
  "槄": "less-than-common",
  "槅": "rarely-used",
  "槆": "rarely-used",
  "槈": "rarely-used",
  "槉": "less-than-common",
  "槊": "less-than-common",
  "構": "common",
  "槌": "common",
  "槍": "common",
  "槎": "less-than-common",
  "槏": "rarely-used",
  "槐": "common",
  "槓": "common",
  "槔": "less-than-common",
  "槙": "rarely-used",
  "槢": "less-than-common",
  "槣": "rarely-used",
  "槤": "less-than-common",
  "槥": "less-than-common",
  "槦": "rarely-used",
  "槧": "less-than-common",
  "槨": "common",
  "槫": "rarely-used",
  "槬": "less-than-common",
  "槭": "less-than-common",
  "槮": "less-than-common",
  "槯": "rarely-used",
  "槰": "rarely-used",
  "槱": "less-than-common",
  "槲": "less-than-common",
  "槳": "common",
  "槴": "rarely-used",
  "槵": "rarely-used",
  "槶": "rarely-used",
  "槷": "less-than-common",
  "槸": "less-than-common",
  "槻": "rarely-used",
  "槼": "rarely-used",
  "槽": "common",
  "槾": "less-than-common",
  "槿": "less-than-common",
  "樀": "less-than-common",
  "樁": "common",
  "樂": "common",
  "樄": "rarely-used",
  "樅": "common",
  "樆": "less-than-common",
  "樇": "rarely-used",
  "樈": "rarely-used",
  "樉": "rarely-used",
  "樊": "common",
  "樋": "rarely-used",
  "樌": "rarely-used",
  "樍": "rarely-used",
  "樎": "rarely-used",
  "樏": "rarely-used",
  "樓": "common",
  "樔": "less-than-common",
  "樕": "less-than-common",
  "樖": "rarely-used",
  "樗": "less-than-common",
  "樘": "rarely-used",
  "標": "common",
  "樚": "rarely-used",
  "樛": "less-than-common",
  "樜": "rarely-used",
  "樝": "less-than-common",
  "樞": "common",
  "樟": "common",
  "樠": "less-than-common",
  "模": "common",
  "樢": "rarely-used",
  "樣": "common",
  "樥": "rarely-used",
  "樦": "rarely-used",
  "樧": "less-than-common",
  "樨": "less-than-common",
  "樲": "less-than-common",
  "樳": "rarely-used",
  "樴": "less-than-common",
  "樵": "common",
  "樸": "common",
  "樹": "common",
  "樺": "common",
  "樻": "less-than-common",
  "樼": "rarely-used",
  "樽": "common",
  "樾": "less-than-common",
  "樿": "less-than-common",
  "橀": "less-than-common",
  "橁": "less-than-common",
  "橂": "rarely-used",
  "橃": "rarely-used",
  "橄": "common",
  "橆": "rarely-used",
  "橇": "common",
  "橈": "less-than-common",
  "橉": "less-than-common",
  "橋": "common",
  "橌": "rarely-used",
  "橍": "rarely-used",
  "橎": "rarely-used",
  "橏": "rarely-used",
  "橐": "less-than-common",
  "橑": "less-than-common",
  "橒": "rarely-used",
  "橔": "rarely-used",
  "橕": "rarely-used",
  "橖": "rarely-used",
  "橗": "rarely-used",
  "橘": "common",
  "橙": "common",
  "橚": "less-than-common",
  "橛": "less-than-common",
  "橝": "less-than-common",
  "橞": "rarely-used",
  "機": "common",
  "橠": "rarely-used",
  "橡": "common",
  "橢": "common",
  "橣": "rarely-used",
  "橤": "less-than-common",
  "橦": "less-than-common",
  "橧": "less-than-common",
  "橨": "less-than-common",
  "橩": "rarely-used",
  "橪": "less-than-common",
  "橫": "common",
  "橬": "rarely-used",
  "橭": "less-than-common",
  "橮": "rarely-used",
  "橯": "rarely-used",
  "橶": "less-than-common",
  "橽": "rarely-used",
  "橾": "less-than-common",
  "橿": "rarely-used",
  "檀": "common",
  "檁": "less-than-common",
  "檂": "rarely-used",
  "檃": "less-than-common",
  "檄": "common",
  "檅": "rarely-used",
  "檇": "less-than-common",
  "檈": "rarely-used",
  "檉": "less-than-common",
  "檊": "rarely-used",
  "檋": "rarely-used",
  "檌": "rarely-used",
  "檍": "less-than-common",
  "檎": "less-than-common",
  "檐": "less-than-common",
  "檑": "rarely-used",
  "檒": "rarely-used",
  "檓": "less-than-common",
  "檔": "common",
  "檕": "less-than-common",
  "檖": "less-than-common",
  "檗": "less-than-common",
  "檙": "rarely-used",
  "檚": "rarely-used",
  "檛": "less-than-common",
  "檜": "common",
  "檞": "less-than-common",
  "檟": "less-than-common",
  "檠": "less-than-common",
  "檡": "less-than-common",
  "檢": "common",
  "檣": "less-than-common",
  "檤": "rarely-used",
  "檥": "less-than-common",
  "檦": "rarely-used",
  "檧": "rarely-used",
  "檨": "rarely-used",
  "檫": "rarely-used",
  "檬": "common",
  "檭": "rarely-used",
  "檮": "less-than-common",
  "檯": "less-than-common",
  "檰": "rarely-used",
  "檲": "rarely-used",
  "檳": "common",
  "檴": "rarely-used",
  "檵": "rarely-used",
  "檶": "rarely-used",
  "檷": "rarely-used",
  "檸": "common",
  "檹": "less-than-common",
  "檺": "rarely-used",
  "檻": "common",
  "檽": "less-than-common",
  "檾": "rarely-used",
  "櫂": "common",
  "櫃": "common",
  "櫅": "less-than-common",
  "櫆": "less-than-common",
  "櫇": "rarely-used",
  "櫋": "less-than-common",
  "櫌": "less-than-common",
  "櫍": "rarely-used",
  "櫎": "rarely-used",
  "櫏": "rarely-used",
  "櫐": "less-than-common",
  "櫑": "less-than-common",
  "櫓": "common",
  "櫔": "rarely-used",
  "櫖": "rarely-used",
  "櫗": "rarely-used",
  "櫙": "less-than-common",
  "櫚": "common",
  "櫛": "common",
  "櫜": "less-than-common",
  "櫝": "common",
  "櫞": "rarely-used",
  "櫟": "less-than-common",
  "櫠": "less-than-common",
  "櫡": "less-than-common",
  "櫢": "rarely-used",
  "櫣": "rarely-used",
  "櫥": "common",
  "櫧": "less-than-common",
  "櫨": "less-than-common",
  "櫪": "less-than-common",
  "櫫": "less-than-common",
  "櫬": "less-than-common",
  "櫭": "rarely-used",
  "櫮": "rarely-used",
  "櫯": "rarely-used",
  "櫰": "less-than-common",
  "櫱": "less-than-common",
  "櫲": "rarely-used",
  "櫳": "less-than-common",
  "櫴": "rarely-used",
  "櫶": "rarely-used",
  "櫸": "less-than-common",
  "櫹": "less-than-common",
  "櫺": "less-than-common",
  "櫻": "common",
  "櫼": "less-than-common",
  "櫾": "rarely-used",
  "櫿": "rarely-used",
  "欀": "rarely-used",
  "欂": "less-than-common",
  "欃": "less-than-common",
  "欄": "common",
  "欆": "rarely-used",
  "欇": "rarely-used",
  "欈": "less-than-common",
  "欉": "rarely-used",
  "權": "common",
  "欋": "less-than-common",
  "欏": "rarely-used",
  "欐": "less-than-common",
  "欑": "less-than-common",
  "欒": "less-than-common",
  "欓": "rarely-used",
  "欔": "rarely-used",
  "欖": "common",
  "欗": "rarely-used",
  "欘": "less-than-common",
  "欙": "rarely-used",
  "欚": "rarely-used",
  "欜": "rarely-used",
  "欞": "rarely-used",
  "欠": "common",
  "次": "common",
  "欣": "common",
  "欥": "less-than-common",
  "欦": "rarely-used",
  "欨": "less-than-common",
  "欩": "rarely-used",
  "欪": "rarely-used",
  "欫": "rarely-used",
  "欬": "less-than-common",
  "欭": "less-than-common",
  "欮": "rarely-used",
  "欯": "less-than-common",
  "欰": "rarely-used",
  "欱": "less-than-common",
  "欲": "common",
  "欳": "less-than-common",
  "欴": "less-than-common",
  "欶": "less-than-common",
  "欷": "less-than-common",
  "欸": "less-than-common",
  "欹": "less-than-common",
  "欺": "common",
  "欻": "less-than-common",
  "欼": "rarely-used",
  "欽": "common",
  "款": "common",
  "欿": "less-than-common",
  "歁": "rarely-used",
  "歂": "less-than-common",
  "歃": "less-than-common",
  "歄": "rarely-used",
  "歅": "less-than-common",
  "歆": "less-than-common",
  "歇": "common",
  "歈": "less-than-common",
  "歉": "common",
  "歊": "less-than-common",
  "歋": "less-than-common",
  "歌": "common",
  "歍": "less-than-common",
  "歎": "less-than-common",
  "歏": "rarely-used",
  "歐": "common",
  "歑": "rarely-used",
  "歒": "rarely-used",
  "歔": "less-than-common",
  "歕": "less-than-common",
  "歖": "rarely-used",
  "歙": "common",
  "歛": "less-than-common",
  "歜": "less-than-common",
  "歞": "rarely-used",
  "歟": "common",
  "歠": "less-than-common",
  "歡": "common",
  "止": "common",
  "正": "common",
  "此": "common",
  "步": "common",
  "武": "common",
  "歧": "common",
  "歪": "common",
  "歫": "rarely-used",
  "歭": "less-than-common",
  "歲": "common",
  "歵": "rarely-used",
  "歶": "less-than-common",
  "歷": "common",
  "歸": "common",
  "歹": "common",
  "死": "common",
  "歽": "rarely-used",
  "歾": "less-than-common",
  "歿": "common",
  "殀": "less-than-common",
  "殂": "less-than-common",
  "殃": "common",
  "殄": "less-than-common",
  "殅": "rarely-used",
  "殆": "common",
  "殈": "less-than-common",
  "殉": "common",
  "殊": "common",
  "殌": "rarely-used",
  "殍": "less-than-common",
  "殎": "rarely-used",
  "殏": "less-than-common",
  "殐": "rarely-used",
  "殑": "less-than-common",
  "殔": "less-than-common",
  "殕": "rarely-used",
  "殖": "common",
  "殗": "less-than-common",
  "殘": "common",
  "殙": "less-than-common",
  "殛": "less-than-common",
  "殜": "rarely-used",
  "殝": "rarely-used",
  "殞": "less-than-common",
  "殟": "less-than-common",
  "殠": "less-than-common",
  "殢": "less-than-common",
  "殣": "less-than-common",
  "殤": "common",
  "殥": "less-than-common",
  "殦": "less-than-common",
  "殧": "less-than-common",
  "殨": "rarely-used",
  "殩": "rarely-used",
  "殪": "less-than-common",
  "殫": "less-than-common",
  "殬": "rarely-used",
  "殭": "less-than-common",
  "殮": "common",
  "殯": "common",
  "殰": "less-than-common",
  "殲": "common",
  "殳": "less-than-common",
  "段": "common",
  "殶": "less-than-common",
  "殷": "common",
  "殸": "rarely-used",
  "殹": "rarely-used",
  "殺": "common",
  "殼": "common",
  "殽": "less-than-common",
  "殾": "rarely-used",
  "殿": "common",
  "毀": "common",
  "毃": "less-than-common",
  "毄": "less-than-common",
  "毅": "common",
  "毆": "common",
  "毇": "less-than-common",
  "毈": "less-than-common",
  "毉": "less-than-common",
  "毊": "less-than-common",
  "毋": "common",
  "毌": "less-than-common",
  "母": "common",
  "每": "common",
  "毐": "less-than-common",
  "毑": "rarely-used",
  "毒": "common",
  "毓": "common",
  "比": "common",
  "毖": "less-than-common",
  "毗": "common",
  "毘": "less-than-common",
  "毚": "less-than-common",
  "毛": "common",
  "毞": "less-than-common",
  "毠": "rarely-used",
  "毢": "rarely-used",
  "毣": "less-than-common",
  "毤": "less-than-common",
  "毥": "rarely-used",
  "毦": "less-than-common",
  "毧": "rarely-used",
  "毨": "less-than-common",
  "毩": "rarely-used",
  "毪": "rarely-used",
  "毫": "common",
  "毬": "less-than-common",
  "毭": "rarely-used",
  "毯": "common",
  "毰": "less-than-common",
  "毱": "rarely-used",
  "毲": "less-than-common",
  "毳": "less-than-common",
  "毷": "rarely-used",
  "毸": "rarely-used",
  "毹": "less-than-common",
  "毻": "less-than-common",
  "毼": "less-than-common",
  "毽": "common",
  "毾": "less-than-common",
  "毿": "less-than-common",
  "氀": "less-than-common",
  "氁": "less-than-common",
  "氂": "less-than-common",
  "氃": "rarely-used",
  "氄": "less-than-common",
  "氅": "less-than-common",
  "氆": "rarely-used",
  "氈": "less-than-common",
  "氉": "rarely-used",
  "氋": "rarely-used",
  "氌": "rarely-used",
  "氍": "less-than-common",
  "氏": "common",
  "氐": "common",
  "民": "common",
  "氒": "rarely-used",
  "氓": "common",
  "气": "less-than-common",
  "氕": "less-than-common",
  "氖": "common",
  "氘": "less-than-common",
  "氙": "less-than-common",
  "氚": "less-than-common",
  "氛": "common",
  "氝": "rarely-used",
  "氟": "common",
  "氠": "less-than-common",
  "氡": "rarely-used",
  "氣": "common",
  "氤": "common",
  "氥": "rarely-used",
  "氦": "common",
  "氧": "common",
  "氨": "common",
  "氪": "less-than-common",
  "氫": "common",
  "氬": "less-than-common",
  "氭": "rarely-used",
  "氮": "common",
  "氯": "common",
  "氰": "less-than-common",
  "氳": "common",
  "水": "common",
  "氶": "less-than-common",
  "永": "common",
  "氹": "rarely-used",
  "氻": "rarely-used",
  "氾": "common",
  "氿": "less-than-common",
  "汀": "common",
  "汁": "common",
  "求": "common",
  "汃": "less-than-common",
  "汆": "less-than-common",
  "汊": "less-than-common",
  "汋": "less-than-common",
  "汌": "rarely-used",
  "汍": "less-than-common",
  "汎": "less-than-common",
  "汏": "less-than-common",
  "汐": "common",
  "汑": "rarely-used",
  "汒": "less-than-common",
  "汔": "less-than-common",
  "汕": "common",
  "汗": "common",
  "汘": "rarely-used",
  "汙": "common",
  "汛": "less-than-common",
  "汜": "less-than-common",
  "汝": "common",
  "汞": "common",
  "江": "common",
  "池": "common",
  "污": "less-than-common",
  "汥": "rarely-used",
  "汦": "less-than-common",
  "汧": "less-than-common",
  "汨": "common",
  "汩": "less-than-common",
  "汪": "common",
  "汫": "less-than-common",
  "汭": "less-than-common",
  "汮": "rarely-used",
  "汯": "less-than-common",
  "汰": "common",
  "汱": "less-than-common",
  "汲": "common",
  "汳": "less-than-common",
  "汴": "less-than-common",
  "汵": "rarely-used",
  "汶": "less-than-common",
  "汷": "rarely-used",
  "汸": "less-than-common",
  "決": "common",
  "汻": "rarely-used",
  "汼": "rarely-used",
  "汽": "common",
  "汾": "common",
  "汿": "rarely-used",
  "沀": "rarely-used",
  "沁": "common",
  "沂": "less-than-common",
  "沃": "common",
  "沄": "less-than-common",
  "沅": "common",
  "沆": "less-than-common",
  "沇": "less-than-common",
  "沈": "common",
  "沉": "common",
  "沊": "rarely-used",
  "沋": "less-than-common",
  "沌": "common",
  "沍": "less-than-common",
  "沎": "rarely-used",
  "沏": "less-than-common",
  "沐": "common",
  "沑": "rarely-used",
  "沒": "common",
  "沓": "less-than-common",
  "沔": "less-than-common",
  "沕": "less-than-common",
  "沖": "common",
  "沘": "less-than-common",
  "沙": "common",
  "沚": "less-than-common",
  "沛": "common",
  "沜": "less-than-common",
  "沝": "rarely-used",
  "沞": "rarely-used",
  "沟": "rarely-used",
  "沫": "common",
  "沬": "less-than-common",
  "沭": "less-than-common",
  "沮": "common",
  "沰": "rarely-used",
  "沱": "common",
  "河": "common",
  "沴": "less-than-common",
  "沶": "less-than-common",
  "沷": "less-than-common",
  "沸": "common",
  "油": "common",
  "沺": "less-than-common",
  "治": "common",
  "沼": "common",
  "沽": "common",
  "沾": "common",
  "沿": "common",
  "泀": "rarely-used",
  "況": "common",
  "泂": "less-than-common",
  "泃": "less-than-common",
  "泄": "common",
  "泅": "common",
  "泆": "less-than-common",
  "泇": "rarely-used",
  "泉": "common",
  "泊": "common",
  "泋": "rarely-used",
  "泌": "common",
  "泍": "rarely-used",
  "泏": "rarely-used",
  "泐": "less-than-common",
  "泑": "rarely-used",
  "泒": "less-than-common",
  "泓": "common",
  "泔": "less-than-common",
  "法": "common",
  "泖": "less-than-common",
  "泗": "common",
  "泙": "less-than-common",
  "泚": "less-than-common",
  "泛": "common",
  "泜": "less-than-common",
  "泝": "less-than-common",
  "泞": "rarely-used",
  "泠": "less-than-common",
  "泡": "common",
  "波": "common",
  "泣": "common",
  "泥": "common",
  "泦": "rarely-used",
  "泧": "less-than-common",
  "注": "common",
  "泩": "rarely-used",
  "泫": "less-than-common",
  "泬": "less-than-common",
  "泭": "less-than-common",
  "泮": "less-than-common",
  "泯": "less-than-common",
  "泰": "common",
  "泱": "common",
  "泲": "less-than-common",
  "泳": "common",
  "泵": "less-than-common",
  "泹": "rarely-used",
  "泿": "rarely-used",
  "洀": "less-than-common",
  "洁": "rarely-used",
  "洃": "rarely-used",
  "洄": "less-than-common",
  "洅": "rarely-used",
  "洆": "rarely-used",
  "洇": "rarely-used",
  "洈": "rarely-used",
  "洉": "rarely-used",
  "洊": "less-than-common",
  "洋": "common",
  "洌": "common",
  "洍": "less-than-common",
  "洎": "less-than-common",
  "洏": "rarely-used",
  "洐": "rarely-used",
  "洑": "less-than-common",
  "洒": "less-than-common",
  "洓": "rarely-used",
  "洔": "rarely-used",
  "洕": "rarely-used",
  "洖": "rarely-used",
  "洗": "common",
  "洘": "rarely-used",
  "洙": "less-than-common",
  "洚": "less-than-common",
  "洛": "common",
  "洝": "rarely-used",
  "洞": "common",
  "洟": "less-than-common",
  "洠": "rarely-used",
  "洡": "rarely-used",
  "洢": "rarely-used",
  "洣": "rarely-used",
  "津": "common",
  "洧": "less-than-common",
  "洨": "less-than-common",
  "洩": "less-than-common",
  "洪": "common",
  "洫": "less-than-common",
  "洬": "rarely-used",
  "洭": "less-than-common",
  "洮": "less-than-common",
  "洯": "rarely-used",
  "洰": "rarely-used",
  "洱": "common",
  "洲": "common",
  "洳": "less-than-common",
  "洴": "less-than-common",
  "洵": "less-than-common",
  "洶": "common",
  "洷": "rarely-used",
  "洸": "less-than-common",
  "洹": "less-than-common",
  "洺": "less-than-common",
  "活": "common",
  "洼": "less-than-common",
  "洽": "common",
  "派": "common",
  "洿": "less-than-common",
  "浀": "rarely-used",
  "流": "common",
  "浂": "rarely-used",
  "浖": "rarely-used",
  "浗": "rarely-used",
  "浘": "less-than-common",
  "浙": "common",
  "浚": "common",
  "浛": "rarely-used",
  "浝": "rarely-used",
  "浞": "less-than-common",
  "浟": "less-than-common",
  "浠": "less-than-common",
  "浡": "less-than-common",
  "浢": "less-than-common",
  "浣": "less-than-common",
  "浤": "less-than-common",
  "浥": "less-than-common",
  "浦": "common",
  "浧": "less-than-common",
  "浨": "rarely-used",
  "浩": "common",
  "浪": "common",
  "浫": "rarely-used",
  "浬": "common",
  "浭": "less-than-common",
  "浮": "common",
  "浯": "less-than-common",
  "浰": "less-than-common",
  "浳": "rarely-used",
  "浴": "common",
  "浵": "rarely-used",
  "浶": "less-than-common",
  "海": "common",
  "浸": "common",
  "浹": "less-than-common",
  "浺": "less-than-common",
  "浻": "rarely-used",
  "浼": "less-than-common",
  "浽": "rarely-used",
  "浾": "rarely-used",
  "浿": "less-than-common",
  "涀": "rarely-used",
  "涂": "less-than-common",
  "涃": "rarely-used",
  "涄": "rarely-used",
  "涅": "less-than-common",
  "涆": "less-than-common",
  "涇": "common",
  "消": "common",
  "涉": "common",
  "涊": "less-than-common",
  "涋": "rarely-used",
  "涌": "less-than-common",
  "涍": "less-than-common",
  "涎": "common",
  "涏": "rarely-used",
  "涐": "rarely-used",
  "涑": "less-than-common",
  "涒": "less-than-common",
  "涓": "common",
  "涔": "less-than-common",
  "涕": "common",
  "涗": "less-than-common",
  "涘": "less-than-common",
  "涪": "less-than-common",
  "涫": "less-than-common",
  "涬": "less-than-common",
  "涭": "rarely-used",
  "涮": "common",
  "涯": "common",
  "液": "common",
  "涳": "less-than-common",
  "涴": "less-than-common",
  "涵": "common",
  "涶": "rarely-used",
  "涷": "less-than-common",
  "涸": "common",
  "涹": "rarely-used",
  "涺": "rarely-used",
  "涻": "rarely-used",
  "涼": "common",
  "涽": "less-than-common",
  "涾": "less-than-common",
  "涿": "less-than-common",
  "淀": "less-than-common",
  "淁": "rarely-used",
  "淂": "rarely-used",
  "淃": "rarely-used",
  "淄": "common",
  "淅": "common",
  "淆": "common",
  "淇": "common",
  "淈": "less-than-common",
  "淉": "rarely-used",
  "淊": "less-than-common",
  "淋": "common",
  "淌": "common",
  "淍": "rarely-used",
  "淎": "rarely-used",
  "淏": "rarely-used",
  "淐": "rarely-used",
  "淑": "common",
  "淒": "common",
  "淓": "rarely-used",
  "淔": "less-than-common",
  "淕": "rarely-used",
  "淖": "less-than-common",
  "淗": "rarely-used",
  "淘": "common",
  "淙": "common",
  "淚": "common",
  "淛": "less-than-common",
  "淜": "less-than-common",
  "淝": "less-than-common",
  "淞": "common",
  "淟": "less-than-common",
  "淠": "less-than-common",
  "淡": "common",
  "淢": "less-than-common",
  "淣": "rarely-used",
  "淤": "common",
  "淥": "less-than-common",
  "淦": "less-than-common",
  "淨": "common",
  "淩": "less-than-common",
  "淪": "common",
  "淫": "common",
  "淬": "less-than-common",
  "淭": "less-than-common",
  "淮": "common",
  "淯": "less-than-common",
  "淰": "less-than-common",
  "深": "common",
  "淲": "rarely-used",
  "淳": "common",
  "淴": "less-than-common",
  "淵": "common",
  "淶": "less-than-common",
  "混": "common",
  "淹": "common",
  "淺": "common",
  "添": "common",
  "淼": "less-than-common",
  "淽": "rarely-used",
  "渀": "less-than-common",
  "渃": "less-than-common",
  "渄": "rarely-used",
  "清": "common",
  "渘": "rarely-used",
  "渙": "common",
  "渚": "common",
  "減": "common",
  "渜": "less-than-common",
  "渝": "common",
  "渞": "rarely-used",
  "渟": "less-than-common",
  "渠": "common",
  "渡": "common",
  "渢": "less-than-common",
  "渣": "common",
  "渤": "common",
  "渥": "common",
  "渦": "common",
  "渧": "rarely-used",
  "渨": "less-than-common",
  "渫": "less-than-common",
  "測": "common",
  "渭": "common",
  "渮": "less-than-common",
  "港": "common",
  "渰": "less-than-common",
  "渱": "less-than-common",
  "渲": "common",
  "渳": "less-than-common",
  "渴": "common",
  "渵": "rarely-used",
  "渶": "rarely-used",
  "游": "common",
  "渹": "less-than-common",
  "渺": "common",
  "渻": "less-than-common",
  "渼": "less-than-common",
  "渽": "less-than-common",
  "渾": "common",
  "渿": "less-than-common",
  "湀": "less-than-common",
  "湁": "less-than-common",
  "湂": "rarely-used",
  "湃": "common",
  "湄": "less-than-common",
  "湅": "less-than-common",
  "湆": "less-than-common",
  "湇": "less-than-common",
  "湈": "rarely-used",
  "湉": "less-than-common",
  "湊": "common",
  "湋": "less-than-common",
  "湍": "common",
  "湎": "less-than-common",
  "湏": "rarely-used",
  "湑": "less-than-common",
  "湒": "rarely-used",
  "湓": "less-than-common",
  "湔": "common",
  "湕": "rarely-used",
  "湖": "common",
  "湘": "common",
  "湚": "rarely-used",
  "湛": "common",
  "湜": "less-than-common",
  "湝": "less-than-common",
  "湞": "less-than-common",
  "湟": "less-than-common",
  "湠": "less-than-common",
  "湡": "less-than-common",
  "湢": "less-than-common",
  "湣": "less-than-common",
  "湤": "rarely-used",
  "湥": "rarely-used",
  "湦": "rarely-used",
  "湧": "common",
  "湨": "less-than-common",
  "湩": "less-than-common",
  "湪": "rarely-used",
  "湫": "less-than-common",
  "湮": "common",
  "湯": "common",
  "湰": "rarely-used",
  "湱": "less-than-common",
  "湲": "less-than-common",
  "湳": "less-than-common",
  "湴": "less-than-common",
  "湵": "rarely-used",
  "湷": "rarely-used",
  "湸": "rarely-used",
  "湹": "rarely-used",
  "溈": "less-than-common",
  "溉": "common",
  "溍": "rarely-used",
  "溎": "rarely-used",
  "溏": "less-than-common",
  "源": "common",
  "溑": "rarely-used",
  "溒": "rarely-used",
  "溓": "less-than-common",
  "溔": "less-than-common",
  "準": "common",
  "溗": "rarely-used",
  "溘": "common",
  "溙": "rarely-used",
  "溚": "rarely-used",
  "溛": "less-than-common",
  "溜": "common",
  "溝": "common",
  "溞": "less-than-common",
  "溟": "less-than-common",
  "溠": "less-than-common",
  "溡": "rarely-used",
  "溢": "common",
  "溣": "rarely-used",
  "溤": "rarely-used",
  "溥": "common",
  "溦": "less-than-common",
  "溧": "less-than-common",
  "溨": "rarely-used",
  "溩": "rarely-used",
  "溪": "common",
  "溫": "common",
  "溭": "rarely-used",
  "溮": "rarely-used",
  "溯": "common",
  "溰": "less-than-common",
  "溱": "less-than-common",
  "溲": "less-than-common",
  "溳": "rarely-used",
  "溴": "less-than-common",
  "溵": "rarely-used",
  "溶": "common",
  "溷": "less-than-common",
  "溸": "rarely-used",
  "溹": "less-than-common",
  "溺": "common",
  "溻": "rarely-used",
  "溼": "common",
  "溽": "less-than-common",
  "溾": "less-than-common",
  "溿": "rarely-used",
  "滀": "less-than-common",
  "滁": "less-than-common",
  "滂": "common",
  "滃": "less-than-common",
  "滄": "common",
  "滅": "common",
  "滆": "less-than-common",
  "滇": "common",
  "滈": "less-than-common",
  "滉": "less-than-common",
  "滊": "rarely-used",
  "滋": "common",
  "滌": "common",
  "滍": "less-than-common",
  "滎": "less-than-common",
  "滏": "less-than-common",
  "滐": "rarely-used",
  "滑": "common",
  "滒": "less-than-common",
  "滓": "common",
  "滔": "common",
  "滕": "less-than-common",
  "滖": "less-than-common",
  "滘": "rarely-used",
  "滜": "less-than-common",
  "滫": "less-than-common",
  "滬": "common",
  "滭": "less-than-common",
  "滮": "less-than-common",
  "滯": "common",
  "滰": "rarely-used",
  "滱": "less-than-common",
  "滲": "common",
  "滳": "rarely-used",
  "滴": "common",
  "滵": "less-than-common",
  "滶": "rarely-used",
  "滷": "less-than-common",
  "滸": "less-than-common",
  "滹": "less-than-common",
  "滻": "less-than-common",
  "滼": "rarely-used",
  "滽": "rarely-used",
  "滾": "common",
  "滿": "common",
  "漀": "rarely-used",
  "漁": "common",
  "漂": "common",
  "漃": "less-than-common",
  "漅": "less-than-common",
  "漆": "common",
  "漇": "less-than-common",
  "漈": "rarely-used",
  "漉": "less-than-common",
  "漊": "less-than-common",
  "漌": "rarely-used",
  "漍": "rarely-used",
  "漎": "less-than-common",
  "漏": "common",
  "漐": "rarely-used",
  "漒": "less-than-common",
  "漓": "common",
  "演": "common",
  "漕": "common",
  "漖": "rarely-used",
  "漗": "rarely-used",
  "漘": "less-than-common",
  "漙": "less-than-common",
  "漚": "less-than-common",
  "漛": "rarely-used",
  "漜": "rarely-used",
  "漝": "rarely-used",
  "漞": "rarely-used",
  "漟": "rarely-used",
  "漠": "common",
  "漡": "rarely-used",
  "漢": "common",
  "漣": "common",
  "漤": "rarely-used",
  "漥": "less-than-common",
  "漦": "less-than-common",
  "漧": "less-than-common",
  "漨": "rarely-used",
  "漩": "common",
  "漪": "common",
  "漫": "common",
  "漬": "common",
  "漭": "less-than-common",
  "漮": "less-than-common",
  "漯": "common",
  "漰": "less-than-common",
  "漱": "common",
  "漲": "common",
  "漳": "common",
  "漴": "rarely-used",
  "漵": "less-than-common",
  "漶": "less-than-common",
  "漷": "less-than-common",
  "漸": "common",
  "漹": "rarely-used",
  "漺": "rarely-used",
  "漻": "less-than-common",
  "漼": "less-than-common",
  "漾": "common",
  "漿": "common",
  "潀": "less-than-common",
  "潁": "less-than-common",
  "潃": "less-than-common",
  "潎": "less-than-common",
  "潏": "less-than-common",
  "潐": "less-than-common",
  "潑": "common",
  "潒": "less-than-common",
  "潓": "rarely-used",
  "潔": "common",
  "潕": "less-than-common",
  "潖": "rarely-used",
  "潗": "less-than-common",
  "潘": "common",
  "潚": "less-than-common",
  "潛": "common",
  "潝": "less-than-common",
  "潞": "less-than-common",
  "潟": "less-than-common",
  "潠": "less-than-common",
  "潡": "rarely-used",
  "潢": "less-than-common",
  "潣": "rarely-used",
  "潤": "common",
  "潥": "rarely-used",
  "潦": "common",
  "潧": "rarely-used",
  "潩": "rarely-used",
  "潪": "rarely-used",
  "潫": "rarely-used",
  "潬": "less-than-common",
  "潭": "common",
  "潮": "common",
  "潯": "less-than-common",
  "潰": "common",
  "潲": "less-than-common",
  "潳": "less-than-common",
  "潵": "rarely-used",
  "潶": "less-than-common",
  "潷": "rarely-used",
  "潸": "common",
  "潺": "common",
  "潻": "rarely-used",
  "潼": "common",
  "潽": "rarely-used",
  "潾": "less-than-common",
  "潿": "rarely-used",
  "澀": "common",
  "澂": "less-than-common",
  "澃": "rarely-used",
  "澄": "common",
  "澅": "less-than-common",
  "澆": "common",
  "澇": "less-than-common",
  "澈": "common",
  "澉": "less-than-common",
  "澊": "rarely-used",
  "澋": "rarely-used",
  "澌": "less-than-common",
  "澍": "less-than-common",
  "澎": "common",
  "澐": "rarely-used",
  "澒": "less-than-common",
  "澓": "less-than-common",
  "澔": "less-than-common",
  "澕": "rarely-used",
  "澖": "less-than-common",
  "澗": "common",
  "澞": "less-than-common",
  "澠": "less-than-common",
  "澡": "common",
  "澢": "rarely-used",
  "澣": "less-than-common",
  "澤": "common",
  "澥": "less-than-common",
  "澦": "less-than-common",
  "澧": "common",
  "澨": "less-than-common",
  "澩": "less-than-common",
  "澪": "rarely-used",
  "澫": "rarely-used",
  "澬": "rarely-used",
  "澭": "less-than-common",
  "澮": "less-than-common",
  "澯": "rarely-used",
  "澰": "rarely-used",
  "澱": "common",
  "澲": "rarely-used",
  "澳": "common",
  "澴": "less-than-common",
  "澶": "less-than-common",
  "澸": "rarely-used",
  "澹": "common",
  "澺": "rarely-used",
  "澻": "rarely-used",
  "澼": "less-than-common",
  "澽": "less-than-common",
  "澾": "rarely-used",
  "澿": "rarely-used",
  "激": "common",
  "濁": "common",
  "濂": "common",
  "濃": "common",
  "濄": "less-than-common",
  "濆": "less-than-common",
  "濇": "less-than-common",
  "濈": "less-than-common",
  "濉": "rarely-used",
  "濊": "less-than-common",
  "濋": "less-than-common",
  "濌": "less-than-common",
  "濍": "rarely-used",
  "濎": "less-than-common",
  "濏": "rarely-used",
  "濐": "rarely-used",
  "濔": "less-than-common",
  "濕": "less-than-common",
  "濖": "rarely-used",
  "濗": "rarely-used",
  "濘": "common",
  "濛": "common",
  "濜": "less-than-common",
  "濝": "rarely-used",
  "濞": "less-than-common",
  "濟": "common",
  "濠": "common",
  "濡": "common",
  "濢": "rarely-used",
  "濣": "less-than-common",
  "濤": "common",
  "濥": "rarely-used",
  "濦": "less-than-common",
  "濧": "less-than-common",
  "濨": "rarely-used",
  "濩": "less-than-common",
  "濫": "common",
  "濬": "common",
  "濭": "less-than-common",
  "濮": "less-than-common",
  "濯": "common",
  "濰": "less-than-common",
  "濱": "common",
  "濲": "rarely-used",
  "濴": "less-than-common",
  "濷": "rarely-used",
  "濺": "common",
  "濻": "less-than-common",
  "濼": "less-than-common",
  "濾": "common",
  "濿": "less-than-common",
  "瀀": "less-than-common",
  "瀁": "less-than-common",
  "瀃": "rarely-used",
  "瀄": "less-than-common",
  "瀅": "less-than-common",
  "瀆": "common",
  "瀇": "less-than-common",
  "瀈": "rarely-used",
  "瀉": "common",
  "瀊": "rarely-used",
  "瀋": "common",
  "瀌": "less-than-common",
  "瀍": "less-than-common",
  "瀎": "less-than-common",
  "瀏": "common",
  "瀑": "common",
  "瀔": "less-than-common",
  "瀕": "common",
  "瀖": "less-than-common",
  "瀗": "rarely-used",
  "瀘": "less-than-common",
  "瀙": "less-than-common",
  "瀚": "common",
  "瀛": "common",
  "瀜": "rarely-used",
  "瀝": "common",
  "瀟": "common",
  "瀠": "less-than-common",
  "瀡": "less-than-common",
  "瀢": "less-than-common",
  "瀣": "less-than-common",
  "瀤": "rarely-used",
  "瀦": "less-than-common",
  "瀧": "less-than-common",
  "瀨": "common",
  "瀩": "less-than-common",
  "瀪": "rarely-used",
  "瀫": "less-than-common",
  "瀯": "less-than-common",
  "瀰": "common",
  "瀱": "less-than-common",
  "瀲": "less-than-common",
  "瀳": "rarely-used",
  "瀴": "less-than-common",
  "瀵": "less-than-common",
  "瀶": "rarely-used",
  "瀷": "less-than-common",
  "瀸": "less-than-common",
  "瀹": "less-than-common",
  "瀺": "less-than-common",
  "瀻": "rarely-used",
  "瀼": "less-than-common",
  "瀽": "rarely-used",
  "瀾": "common",
  "瀿": "less-than-common",
  "灀": "rarely-used",
  "灁": "rarely-used",
  "灂": "less-than-common",
  "灃": "less-than-common",
  "灄": "less-than-common",
  "灅": "rarely-used",
  "灆": "rarely-used",
  "灈": "less-than-common",
  "灉": "less-than-common",
  "灊": "less-than-common",
  "灌": "common",
  "灑": "common",
  "灒": "rarely-used",
  "灓": "rarely-used",
  "灕": "less-than-common",
  "灖": "less-than-common",
  "灗": "less-than-common",
  "灘": "common",
  "灙": "rarely-used",
  "灚": "rarely-used",
  "灛": "less-than-common",
  "灝": "less-than-common",
  "灞": "less-than-common",
  "灟": "less-than-common",
  "灠": "rarely-used",
  "灡": "less-than-common",
  "灢": "rarely-used",
  "灣": "common",
  "灤": "common",
  "灥": "rarely-used",
  "灦": "rarely-used",
  "灨": "less-than-common",
  "灩": "less-than-common",
  "灪": "less-than-common",
  "火": "common",
  "灰": "common",
  "灱": "rarely-used",
  "灴": "rarely-used",
  "灶": "common",
  "灷": "rarely-used",
  "灸": "common",
  "灹": "rarely-used",
  "灺": "rarely-used",
  "灼": "common",
  "災": "common",
  "炂": "rarely-used",
  "炃": "rarely-used",
  "炄": "rarely-used",
  "炅": "less-than-common",
  "炆": "rarely-used",
  "炈": "rarely-used",
  "炊": "common",
  "炋": "rarely-used",
  "炎": "common",
  "炐": "rarely-used",
  "炑": "rarely-used",
  "炒": "common",
  "炓": "rarely-used",
  "炔": "less-than-common",
  "炕": "common",
  "炖": "rarely-used",
  "炘": "less-than-common",
  "炙": "common",
  "炚": "rarely-used",
  "炟": "less-than-common",
  "炠": "rarely-used",
  "炡": "rarely-used",
  "炢": "rarely-used",
  "炣": "rarely-used",
  "炤": "less-than-common",
  "炥": "rarely-used",
  "炦": "rarely-used",
  "炩": "rarely-used",
  "炪": "rarely-used",
  "炫": "common",
  "炬": "common",
  "炭": "common",
  "炮": "common",
  "炯": "common",
  "炰": "less-than-common",
  "炱": "less-than-common",
  "炳": "common",
  "炴": "rarely-used",
  "炵": "rarely-used",
  "炷": "less-than-common",
  "炸": "common",
  "為": "common",
  "炻": "rarely-used",
  "炾": "less-than-common",
  "烀": "rarely-used",
  "烄": "rarely-used",
  "烅": "rarely-used",
  "烆": "rarely-used",
  "烇": "rarely-used",
  "烈": "common",
  "烊": "common",
  "烋": "less-than-common",
  "烌": "rarely-used",
  "烍": "rarely-used",
  "烎": "rarely-used",
  "烏": "common",
  "烐": "rarely-used",
  "烑": "less-than-common",
  "烒": "rarely-used",
  "烓": "less-than-common",
  "烔": "rarely-used",
  "烗": "rarely-used",
  "烘": "common",
  "烙": "common",
  "烚": "rarely-used",
  "烛": "rarely-used",
  "烜": "less-than-common",
  "烝": "less-than-common",
  "烞": "rarely-used",
  "烠": "rarely-used",
  "烡": "rarely-used",
  "烢": "rarely-used",
  "烤": "common",
  "烯": "less-than-common",
  "烰": "less-than-common",
  "烳": "rarely-used",
  "烴": "less-than-common",
  "烶": "rarely-used",
  "烷": "less-than-common",
  "烸": "rarely-used",
  "烹": "common",
  "烺": "less-than-common",
  "烻": "less-than-common",
  "烼": "rarely-used",
  "烽": "common",
  "烿": "rarely-used",
  "焀": "rarely-used",
  "焁": "rarely-used",
  "焂": "rarely-used",
  "焃": "rarely-used",
  "焄": "less-than-common",
  "焅": "rarely-used",
  "焆": "rarely-used",
  "焇": "rarely-used",
  "焉": "common",
  "焊": "common",
  "焋": "rarely-used",
  "焌": "less-than-common",
  "焍": "less-than-common",
  "焎": "rarely-used",
  "焐": "rarely-used",
  "焓": "rarely-used",
  "焗": "less-than-common",
  "焙": "common",
  "焚": "common",
  "焛": "rarely-used",
  "焜": "less-than-common",
  "焝": "rarely-used",
  "焞": "less-than-common",
  "焟": "rarely-used",
  "焠": "less-than-common",
  "無": "common",
  "焢": "rarely-used",
  "焣": "less-than-common",
  "焥": "rarely-used",
  "焦": "common",
  "焨": "rarely-used",
  "焪": "rarely-used",
  "焬": "rarely-used",
  "焮": "less-than-common",
  "焯": "less-than-common",
  "焰": "common",
  "焱": "less-than-common",
  "焲": "rarely-used",
  "焵": "rarely-used",
  "然": "common",
  "焷": "rarely-used",
  "焸": "rarely-used",
  "焺": "rarely-used",
  "煁": "less-than-common",
  "煂": "rarely-used",
  "煃": "rarely-used",
  "煄": "rarely-used",
  "煆": "less-than-common",
  "煇": "less-than-common",
  "煈": "rarely-used",
  "煉": "common",
  "煋": "rarely-used",
  "煌": "common",
  "煍": "rarely-used",
  "煎": "common",
  "煐": "rarely-used",
  "煒": "less-than-common",
  "煓": "rarely-used",
  "煔": "less-than-common",
  "煖": "less-than-common",
  "煘": "rarely-used",
  "煙": "common",
  "煚": "rarely-used",
  "煛": "rarely-used",
  "煜": "common",
  "煝": "less-than-common",
  "煞": "common",
  "煟": "rarely-used",
  "煠": "less-than-common",
  "煡": "rarely-used",
  "煢": "less-than-common",
  "煣": "less-than-common",
  "煤": "common",
  "煥": "common",
  "煦": "common",
  "照": "common",
  "煨": "less-than-common",
  "煩": "common",
  "煪": "rarely-used",
  "煬": "common",
  "煮": "common",
  "煯": "rarely-used",
  "煰": "rarely-used",
  "煲": "less-than-common",
  "煸": "rarely-used",
  "煹": "rarely-used",
  "煻": "rarely-used",
  "煽": "common",
  "熀": "less-than-common",
  "熁": "rarely-used",
  "熂": "less-than-common",
  "熄": "common",
  "熅": "less-than-common",
  "熆": "rarely-used",
  "熇": "less-than-common",
  "熉": "less-than-common",
  "熊": "common",
  "熋": "rarely-used",
  "熎": "rarely-used",
  "熏": "less-than-common",
  "熐": "less-than-common",
  "熑": "rarely-used",
  "熒": "less-than-common",
  "熓": "rarely-used",
  "熔": "common",
  "熗": "rarely-used",
  "熙": "common",
  "熚": "less-than-common",
  "熛": "less-than-common",
  "熜": "rarely-used",
  "熝": "rarely-used",
  "熞": "rarely-used",
  "熟": "common",
  "熠": "less-than-common",
  "熡": "rarely-used",
  "熣": "rarely-used",
  "熤": "rarely-used",
  "熥": "rarely-used",
  "熧": "rarely-used",
  "熨": "common",
  "熩": "rarely-used",
  "熪": "rarely-used",
  "熬": "common",
  "熭": "rarely-used",
  "熮": "rarely-used",
  "熯": "less-than-common",
  "熰": "less-than-common",
  "熱": "common",
  "熲": "less-than-common",
  "熳": "rarely-used",
  "熵": "rarely-used",
  "熷": "rarely-used",
  "熸": "less-than-common",
  "熹": "common",
  "熻": "rarely-used",
  "熼": "rarely-used",
  "熽": "rarely-used",
  "熾": "common",
  "熿": "less-than-common",
  "燀": "less-than-common",
  "燁": "less-than-common",
  "燂": "less-than-common",
  "燃": "common",
  "燄": "common",
  "燅": "less-than-common",
  "燆": "rarely-used",
  "燇": "rarely-used",
  "燈": "common",
  "燉": "common",
  "燊": "less-than-common",
  "燋": "less-than-common",
  "燍": "rarely-used",
  "燎": "common",
  "燏": "rarely-used",
  "燐": "common",
  "燒": "common",
  "燔": "less-than-common",
  "燕": "common",
  "燖": "less-than-common",
  "燘": "rarely-used",
  "燙": "common",
  "燚": "rarely-used",
  "燛": "rarely-used",
  "燜": "common",
  "營": "common",
  "燠": "less-than-common",
  "燡": "less-than-common",
  "燢": "rarely-used",
  "燣": "rarely-used",
  "燤": "rarely-used",
  "燥": "common",
  "燦": "common",
  "燧": "common",
  "燨": "rarely-used",
  "燩": "rarely-used",
  "燬": "common",
  "燭": "common",
  "燮": "common",
  "燰": "rarely-used",
  "燱": "rarely-used",
  "燲": "rarely-used",
  "燴": "common",
  "燸": "rarely-used",
  "燹": "less-than-common",
  "燻": "common",
  "燼": "less-than-common",
  "燽": "rarely-used",
  "燾": "less-than-common",
  "燿": "less-than-common",
  "爁": "less-than-common",
  "爂": "less-than-common",
  "爃": "rarely-used",
  "爄": "rarely-used",
  "爅": "rarely-used",
  "爆": "common",
  "爇": "less-than-common",
  "爈": "rarely-used",
  "爉": "rarely-used",
  "爊": "less-than-common",
  "爌": "less-than-common",
  "爍": "common",
  "爐": "common",
  "爒": "rarely-used",
  "爓": "less-than-common",
  "爔": "rarely-used",
  "爖": "rarely-used",
  "爙": "rarely-used",
  "爚": "less-than-common",
  "爛": "common",
  "爜": "rarely-used",
  "爝": "less-than-common",
  "爞": "less-than-common",
  "爟": "less-than-common",
  "爡": "rarely-used",
  "爢": "less-than-common",
  "爣": "less-than-common",
  "爦": "rarely-used",
  "爧": "rarely-used",
  "爨": "common",
  "爩": "rarely-used",
  "爪": "common",
  "爬": "common",
  "爭": "common",
  "爮": "rarely-used",
  "爯": "rarely-used",
  "爰": "common",
  "爵": "common",
  "父": "common",
  "爸": "common",
  "爹": "common",
  "爺": "common",
  "爻": "common",
  "爽": "common",
  "爾": "common",
  "爿": "rarely-used",
  "牁": "less-than-common",
  "牂": "less-than-common",
  "牄": "less-than-common",
  "牆": "common",
  "片": "common",
  "版": "common",
  "牉": "less-than-common",
  "牊": "rarely-used",
  "牋": "less-than-common",
  "牌": "common",
  "牏": "less-than-common",
  "牐": "rarely-used",
  "牑": "rarely-used",
  "牒": "common",
  "牓": "less-than-common",
  "牔": "rarely-used",
  "牖": "common",
  "牘": "common",
  "牙": "common",
  "牚": "less-than-common",
  "牛": "common",
  "牝": "common",
  "牞": "rarely-used",
  "牟": "common",
  "牠": "common",
  "牡": "common",
  "牢": "common",
  "牣": "less-than-common",
  "牤": "rarely-used",
  "牥": "rarely-used",
  "牦": "rarely-used",
  "牧": "common",
  "物": "common",
  "牪": "rarely-used",
  "牫": "rarely-used",
  "牬": "less-than-common",
  "牭": "rarely-used",
  "牮": "rarely-used",
  "牯": "common",
  "牰": "less-than-common",
  "牲": "common",
  "牳": "rarely-used",
  "牴": "common",
  "牶": "rarely-used",
  "牷": "less-than-common",
  "牸": "less-than-common",
  "特": "common",
  "牻": "less-than-common",
  "牼": "less-than-common",
  "牽": "common",
  "牾": "less-than-common",
  "牿": "less-than-common",
  "犀": "common",
  "犁": "common",
  "犃": "rarely-used",
  "犄": "common",
  "犅": "less-than-common",
  "犆": "less-than-common",
  "犈": "less-than-common",
  "犉": "less-than-common",
  "犋": "rarely-used",
  "犌": "less-than-common",
  "犍": "less-than-common",
  "犎": "less-than-common",
  "犏": "rarely-used",
  "犐": "less-than-common",
  "犑": "less-than-common",
  "犒": "common",
  "犓": "less-than-common",
  "犔": "rarely-used",
  "犕": "less-than-common",
  "犖": "common",
  "犗": "less-than-common",
  "犘": "less-than-common",
  "犙": "rarely-used",
  "犚": "less-than-common",
  "犛": "common",
  "犜": "rarely-used",
  "犝": "less-than-common",
  "犞": "less-than-common",
  "犟": "rarely-used",
  "犡": "rarely-used",
  "犢": "common",
  "犣": "less-than-common",
  "犤": "less-than-common",
  "犥": "less-than-common",
  "犦": "less-than-common",
  "犧": "common",
  "犨": "less-than-common",
  "犩": "less-than-common",
  "犪": "less-than-common",
  "犬": "common",
  "犮": "less-than-common",
  "犯": "common",
  "犰": "less-than-common",
  "犱": "rarely-used",
  "犳": "rarely-used",
  "犴": "less-than-common",
  "犵": "less-than-common",
  "犹": "rarely-used",
  "犺": "rarely-used",
  "犻": "rarely-used",
  "犼": "rarely-used",
  "犽": "less-than-common",
  "犾": "rarely-used",
  "犿": "less-than-common",
  "狀": "common",
  "狁": "less-than-common",
  "狂": "common",
  "狃": "less-than-common",
  "狄": "common",
  "狅": "rarely-used",
  "狆": "less-than-common",
  "狇": "rarely-used",
  "狉": "less-than-common",
  "狊": "less-than-common",
  "狋": "less-than-common",
  "狌": "less-than-common",
  "狍": "rarely-used",
  "狎": "common",
  "狐": "common",
  "狑": "less-than-common",
  "狒": "less-than-common",
  "狓": "rarely-used",
  "狔": "less-than-common",
  "狕": "rarely-used",
  "狖": "less-than-common",
  "狗": "common",
  "狘": "less-than-common",
  "狙": "common",
  "狚": "less-than-common",
  "狛": "rarely-used",
  "狜": "less-than-common",
  "狟": "less-than-common",
  "狠": "common",
  "狡": "common",
  "狣": "less-than-common",
  "狤": "less-than-common",
  "狦": "less-than-common",
  "狧": "rarely-used",
  "狨": "less-than-common",
  "狩": "common",
  "狪": "less-than-common",
  "狫": "less-than-common",
  "狳": "less-than-common",
  "狴": "less-than-common",
  "狶": "less-than-common",
  "狷": "common",
  "狸": "common",
  "狹": "common",
  "狺": "less-than-common",
  "狻": "less-than-common",
  "狼": "common",
  "狽": "common",
  "狾": "less-than-common",
  "狿": "less-than-common",
  "猀": "less-than-common",
  "猁": "rarely-used",
  "猄": "rarely-used",
  "猅": "rarely-used",
  "猆": "rarely-used",
  "猇": "less-than-common",
  "猈": "less-than-common",
  "猉": "rarely-used",
  "猊": "less-than-common",
  "猋": "less-than-common",
  "猌": "rarely-used",
  "猏": "less-than-common",
  "猑": "less-than-common",
  "猒": "less-than-common",
  "猓": "common",
  "猔": "rarely-used",
  "猖": "common",
  "猗": "less-than-common",
  "猘": "less-than-common",
  "猙": "common",
  "猚": "rarely-used",
  "猛": "common",
  "猜": "common",
  "猝": "less-than-common",
  "猞": "rarely-used",
  "猢": "less-than-common",
  "猣": "less-than-common",
  "猤": "rarely-used",
  "猥": "common",
  "猦": "less-than-common",
  "猧": "less-than-common",
  "猩": "common",
  "猭": "less-than-common",
  "猰": "less-than-common",
  "猱": "less-than-common",
  "猲": "less-than-common",
  "猳": "less-than-common",
  "猴": "common",
  "猵": "less-than-common",
  "猶": "common",
  "猷": "common",
  "猸": "rarely-used",
  "猺": "less-than-common",
  "猻": "less-than-common",
  "猼": "less-than-common",
  "猾": "common",
  "猿": "common",
  "獀": "less-than-common",
  "獁": "rarely-used",
  "獂": "less-than-common",
  "獃": "less-than-common",
  "獄": "common",
  "獅": "common",
  "獉": "rarely-used",
  "獊": "less-than-common",
  "獌": "less-than-common",
  "獍": "less-than-common",
  "獎": "common",
  "獐": "common",
  "獑": "less-than-common",
  "獒": "less-than-common",
  "獓": "rarely-used",
  "獕": "rarely-used",
  "獖": "rarely-used",
  "獗": "common",
  "獘": "less-than-common",
  "獙": "rarely-used",
  "獚": "rarely-used",
  "獛": "less-than-common",
  "獜": "rarely-used",
  "獝": "less-than-common",
  "獞": "less-than-common",
  "獟": "less-than-common",
  "獠": "less-than-common",
  "獡": "less-than-common",
  "獢": "rarely-used",
  "獥": "less-than-common",
  "獦": "less-than-common",
  "獧": "less-than-common",
  "獨": "common",
  "獩": "less-than-common",
  "獪": "less-than-common",
  "獫": "less-than-common",
  "獬": "less-than-common",
  "獮": "less-than-common",
  "獯": "less-than-common",
  "獰": "common",
  "獲": "common",
  "獳": "less-than-common",
  "獴": "rarely-used",
  "獵": "common",
  "獶": "less-than-common",
  "獷": "common",
  "獸": "common",
  "獹": "rarely-used",
  "獺": "common",
  "獻": "common",
  "獼": "less-than-common",
  "獽": "less-than-common",
  "獾": "less-than-common",
  "獿": "less-than-common",
  "玀": "common",
  "玁": "less-than-common",
  "玂": "less-than-common",
  "玃": "less-than-common",
  "玄": "common",
  "玅": "less-than-common",
  "玆": "less-than-common",
  "率": "common",
  "玈": "less-than-common",
  "玉": "common",
  "玊": "less-than-common",
  "王": "common",
  "玍": "rarely-used",
  "玎": "less-than-common",
  "玐": "rarely-used",
  "玒": "rarely-used",
  "玓": "less-than-common",
  "玔": "less-than-common",
  "玕": "less-than-common",
  "玖": "common",
  "玗": "less-than-common",
  "玘": "rarely-used",
  "玝": "rarely-used",
  "玟": "common",
  "玠": "less-than-common",
  "玡": "less-than-common",
  "玢": "less-than-common",
  "玤": "less-than-common",
  "玥": "rarely-used",
  "玦": "less-than-common",
  "玧": "rarely-used",
  "玨": "common",
  "玩": "common",
  "玫": "common",
  "玬": "rarely-used",
  "玭": "less-than-common",
  "玲": "common",
  "玳": "common",
  "玴": "rarely-used",
  "玵": "rarely-used",
  "玶": "rarely-used",
  "玷": "common",
  "玸": "rarely-used",
  "玹": "rarely-used",
  "玻": "common",
  "玼": "less-than-common",
  "玽": "rarely-used",
  "玾": "rarely-used",
  "玿": "rarely-used",
  "珀": "common",
  "珂": "less-than-common",
  "珃": "rarely-used",
  "珄": "rarely-used",
  "珅": "less-than-common",
  "珆": "rarely-used",
  "珇": "rarely-used",
  "珈": "less-than-common",
  "珊": "common",
  "珋": "rarely-used",
  "珌": "less-than-common",
  "珍": "common",
  "珒": "rarely-used",
  "珓": "less-than-common",
  "珔": "rarely-used",
  "珕": "rarely-used",
  "珖": "less-than-common",
  "珗": "rarely-used",
  "珘": "rarely-used",
  "珙": "less-than-common",
  "珚": "rarely-used",
  "珛": "rarely-used",
  "珜": "rarely-used",
  "珝": "rarely-used",
  "珞": "less-than-common",
  "珟": "rarely-used",
  "珠": "common",
  "珢": "rarely-used",
  "珣": "less-than-common",
  "珥": "less-than-common",
  "珦": "rarely-used",
  "珧": "less-than-common",
  "珨": "rarely-used",
  "珩": "less-than-common",
  "珪": "less-than-common",
  "珫": "rarely-used",
  "珬": "rarely-used",
  "班": "common",
  "珮": "common",
  "珳": "rarely-used",
  "珴": "rarely-used",
  "珵": "less-than-common",
  "珶": "less-than-common",
  "珸": "less-than-common",
  "珹": "rarely-used",
  "珺": "rarely-used",
  "珻": "rarely-used",
  "珼": "rarely-used",
  "珽": "less-than-common",
  "現": "common",
  "珿": "rarely-used",
  "琀": "less-than-common",
  "琁": "less-than-common",
  "琂": "rarely-used",
  "球": "common",
  "琄": "less-than-common",
  "琅": "common",
  "理": "common",
  "琇": "less-than-common",
  "琈": "rarely-used",
  "琉": "common",
  "琊": "common",
  "琋": "rarely-used",
  "琌": "rarely-used",
  "琍": "common",
  "琖": "less-than-common",
  "琗": "rarely-used",
  "琙": "rarely-used",
  "琚": "less-than-common",
  "琛": "less-than-common",
  "琝": "rarely-used",
  "琟": "rarely-used",
  "琠": "rarely-used",
  "琡": "less-than-common",
  "琢": "common",
  "琣": "rarely-used",
  "琤": "less-than-common",
  "琥": "common",
  "琦": "less-than-common",
  "琧": "rarely-used",
  "琨": "less-than-common",
  "琩": "rarely-used",
  "琪": "common",
  "琫": "less-than-common",
  "琬": "less-than-common",
  "琭": "less-than-common",
  "琮": "less-than-common",
  "琯": "less-than-common",
  "琰": "less-than-common",
  "琱": "less-than-common",
  "琲": "rarely-used",
  "琳": "common",
  "琴": "common",
  "琵": "common",
  "琶": "common",
  "琸": "rarely-used",
  "琺": "common",
  "琽": "rarely-used",
  "琿": "common",
  "瑀": "less-than-common",
  "瑁": "common",
  "瑂": "rarely-used",
  "瑄": "less-than-common",
  "瑆": "rarely-used",
  "瑈": "rarely-used",
  "瑊": "less-than-common",
  "瑋": "less-than-common",
  "瑍": "rarely-used",
  "瑎": "rarely-used",
  "瑏": "rarely-used",
  "瑐": "rarely-used",
  "瑑": "less-than-common",
  "瑒": "less-than-common",
  "瑓": "rarely-used",
  "瑔": "rarely-used",
  "瑕": "common",
  "瑖": "rarely-used",
  "瑗": "less-than-common",
  "瑙": "common",
  "瑚": "common",
  "瑛": "common",
  "瑜": "common",
  "瑝": "rarely-used",
  "瑞": "common",
  "瑟": "common",
  "瑡": "rarely-used",
  "瑢": "less-than-common",
  "瑣": "common",
  "瑤": "common",
  "瑥": "rarely-used",
  "瑦": "rarely-used",
  "瑧": "rarely-used",
  "瑩": "common",
  "瑪": "common",
  "瑫": "rarely-used",
  "瑬": "rarely-used",
  "瑭": "rarely-used",
  "瑮": "rarely-used",
  "瑯": "common",
  "瑰": "common",
  "瑱": "less-than-common",
  "瑲": "less-than-common",
  "瑳": "less-than-common",
  "瑵": "less-than-common",
  "瑹": "rarely-used",
  "瑺": "rarely-used",
  "瑼": "rarely-used",
  "瑽": "less-than-common",
  "瑾": "less-than-common",
  "瑿": "less-than-common",
  "璀": "less-than-common",
  "璁": "less-than-common",
  "璃": "common",
  "璅": "less-than-common",
  "璆": "less-than-common",
  "璇": "less-than-common",
  "璈": "rarely-used",
  "璉": "less-than-common",
  "璊": "less-than-common",
  "璋": "common",
  "璏": "rarely-used",
  "璐": "less-than-common",
  "璑": "rarely-used",
  "璒": "rarely-used",
  "璔": "rarely-used",
  "璕": "rarely-used",
  "璗": "less-than-common",
  "璘": "less-than-common",
  "璙": "rarely-used",
  "璚": "less-than-common",
  "璛": "rarely-used",
  "璜": "common",
  "璞": "less-than-common",
  "璟": "less-than-common",
  "璠": "less-than-common",
  "璡": "rarely-used",
  "璣": "common",
  "璥": "rarely-used",
  "璦": "common",
  "璧": "common",
  "璨": "less-than-common",
  "璩": "common",
  "璪": "less-than-common",
  "璫": "less-than-common",
  "璬": "rarely-used",
  "璭": "rarely-used",
  "璮": "rarely-used",
  "璯": "rarely-used",
  "環": "common",
  "璱": "rarely-used",
  "璲": "less-than-common",
  "璳": "rarely-used",
  "璵": "less-than-common",
  "璶": "rarely-used",
  "璷": "rarely-used",
  "璸": "less-than-common",
  "璹": "rarely-used",
  "璺": "less-than-common",
  "璻": "rarely-used",
  "璼": "rarely-used",
  "璽": "common",
  "璾": "rarely-used",
  "璿": "less-than-common",
  "瓀": "less-than-common",
  "瓁": "less-than-common",
  "瓂": "rarely-used",
  "瓃": "rarely-used",
  "瓄": "rarely-used",
  "瓅": "less-than-common",
  "瓆": "rarely-used",
  "瓊": "common",
  "瓋": "less-than-common",
  "瓍": "rarely-used",
  "瓏": "common",
  "瓐": "rarely-used",
  "瓓": "rarely-used",
  "瓔": "less-than-common",
  "瓕": "rarely-used",
  "瓖": "less-than-common",
  "瓗": "rarely-used",
  "瓘": "less-than-common",
  "瓙": "rarely-used",
  "瓚": "less-than-common",
  "瓛": "less-than-common",
  "瓜": "common",
  "瓝": "less-than-common",
  "瓞": "less-than-common",
  "瓟": "less-than-common",
  "瓠": "common",
  "瓡": "less-than-common",
  "瓢": "common",
  "瓣": "common",
  "瓤": "less-than-common",
  "瓥": "less-than-common",
  "瓦": "common",
  "瓨": "less-than-common",
  "瓪": "rarely-used",
  "瓬": "less-than-common",
  "瓭": "rarely-used",
  "瓮": "less-than-common",
  "瓳": "rarely-used",
  "瓴": "less-than-common",
  "瓵": "less-than-common",
  "瓶": "common",
  "瓷": "common",
  "瓹": "rarely-used",
  "瓺": "rarely-used",
  "瓻": "rarely-used",
  "瓽": "less-than-common",
  "瓾": "less-than-common",
  "瓿": "less-than-common",
  "甀": "less-than-common",
  "甂": "less-than-common",
  "甃": "less-than-common",
  "甄": "common",
  "甇": "rarely-used",
  "甈": "less-than-common",
  "甉": "rarely-used",
  "甊": "rarely-used",
  "甋": "less-than-common",
  "甌": "common",
  "甍": "less-than-common",
  "甏": "rarely-used",
  "甐": "less-than-common",
  "甑": "less-than-common",
  "甒": "less-than-common",
  "甓": "less-than-common",
  "甔": "less-than-common",
  "甕": "common",
  "甖": "less-than-common",
  "甗": "less-than-common",
  "甘": "common",
  "甚": "common",
  "甜": "common",
  "甝": "less-than-common",
  "生": "common",
  "甡": "less-than-common",
  "產": "common",
  "甥": "common",
  "甦": "common",
  "甧": "rarely-used",
  "用": "common",
  "甩": "common",
  "甪": "less-than-common",
  "甫": "common",
  "甬": "common",
  "甭": "common",
  "甮": "less-than-common",
  "甯": "less-than-common",
  "田": "common",
  "由": "common",
  "甲": "common",
  "申": "common",
  "甶": "rarely-used",
  "男": "common",
  "甸": "common",
  "甹": "less-than-common",
  "町": "less-than-common",
  "甽": "common",
  "甾": "less-than-common",
  "甿": "less-than-common",
  "畀": "less-than-common",
  "畃": "rarely-used",
  "畇": "less-than-common",
  "畈": "rarely-used",
  "畉": "rarely-used",
  "畋": "less-than-common",
  "界": "common",
  "畎": "less-than-common",
  "畏": "common",
  "畐": "rarely-used",
  "畔": "common",
  "畕": "rarely-used",
  "畖": "rarely-used",
  "畘": "rarely-used",
  "留": "common",
  "畚": "common",
  "畛": "less-than-common",
  "畜": "common",
  "畝": "common",
  "畟": "less-than-common",
  "畢": "common",
  "畣": "less-than-common",
  "畤": "less-than-common",
  "略": "common",
  "畦": "common",
  "番": "common",
  "畫": "common",
  "畬": "less-than-common",
  "畯": "less-than-common",
  "異": "common",
  "當": "common",
  "畷": "less-than-common",
  "畸": "common",
  "畹": "less-than-common",
  "畼": "rarely-used",
  "畽": "less-than-common",
  "畾": "rarely-used",
  "畿": "less-than-common",
  "疀": "less-than-common",
  "疁": "rarely-used",
  "疄": "rarely-used",
  "疆": "common",
  "疇": "common",
  "疊": "common",
  "疋": "common",
  "疌": "less-than-common",
  "疏": "common",
  "疐": "less-than-common",
  "疑": "common",
  "疒": "rarely-used",
  "疓": "rarely-used",
  "疔": "less-than-common",
  "疕": "less-than-common",
  "疘": "rarely-used",
  "疙": "common",
  "疚": "common",
  "疛": "rarely-used",
  "疜": "rarely-used",
  "疝": "common",
  "疢": "less-than-common",
  "疣": "less-than-common",
  "疤": "common",
  "疥": "common",
  "疦": "rarely-used",
  "疧": "less-than-common",
  "疪": "rarely-used",
  "疫": "common",
  "疰": "less-than-common",
  "疲": "common",
  "疳": "common",
  "疵": "common",
  "疶": "rarely-used",
  "疸": "less-than-common",
  "疹": "common",
  "疺": "rarely-used",
  "疻": "less-than-common",
  "疼": "common",
  "疽": "common",
  "疾": "common",
  "疿": "rarely-used",
  "痀": "less-than-common",
  "痁": "less-than-common",
  "痂": "less-than-common",
  "痃": "rarely-used",
  "痄": "less-than-common",
  "病": "common",
  "痆": "rarely-used",
  "症": "common",
  "痊": "common",
  "痋": "less-than-common",
  "痌": "less-than-common",
  "痍": "less-than-common",
  "痎": "less-than-common",
  "痏": "less-than-common",
  "痐": "rarely-used",
  "痑": "less-than-common",
  "痒": "less-than-common",
  "痓": "rarely-used",
  "痔": "common",
  "痕": "common",
  "痗": "less-than-common",
  "痘": "common",
  "痙": "common",
  "痚": "less-than-common",
  "痛": "common",
  "痜": "rarely-used",
  "痝": "less-than-common",
  "痞": "common",
  "痟": "less-than-common",
  "痠": "less-than-common",
  "痡": "less-than-common",
  "痢": "common",
  "痣": "common",
  "痤": "less-than-common",
  "痥": "rarely-used",
  "痦": "less-than-common",
  "痧": "less-than-common",
  "痬": "rarely-used",
  "痭": "rarely-used",
  "痯": "less-than-common",
  "痰": "common",
  "痱": "common",
  "痲": "common",
  "痳": "less-than-common",
  "痴": "common",
  "痵": "rarely-used",
  "痶": "rarely-used",
  "痷": "less-than-common",
  "痸": "less-than-common",
  "痹": "less-than-common",
  "痺": "common",
  "痻": "less-than-common",
  "痼": "less-than-common",
  "痽": "rarely-used",
  "痾": "less-than-common",
  "痿": "common",
  "瘀": "common",
  "瘁": "common",
  "瘃": "less-than-common",
  "瘈": "less-than-common",
  "瘉": "common",
  "瘊": "less-than-common",
  "瘋": "common",
  "瘌": "less-than-common",
  "瘍": "common",
  "瘎": "rarely-used",
  "瘏": "less-than-common",
  "瘐": "less-than-common",
  "瘑": "less-than-common",
  "瘒": "rarely-used",
  "瘓": "common",
  "瘔": "rarely-used",
  "瘕": "less-than-common",
  "瘖": "less-than-common",
  "瘙": "less-than-common",
  "瘚": "rarely-used",
  "瘛": "rarely-used",
  "瘜": "less-than-common",
  "瘝": "less-than-common",
  "瘞": "less-than-common",
  "瘟": "common",
  "瘠": "common",
  "瘡": "common",
  "瘢": "less-than-common",
  "瘣": "less-than-common",
  "瘤": "common",
  "瘥": "less-than-common",
  "瘦": "common",
  "瘧": "common",
  "瘨": "rarely-used",
  "瘩": "common",
  "瘭": "less-than-common",
  "瘯": "less-than-common",
  "瘰": "rarely-used",
  "瘱": "less-than-common",
  "瘲": "less-than-common",
  "瘳": "less-than-common",
  "瘴": "common",
  "瘵": "less-than-common",
  "瘸": "common",
  "瘹": "rarely-used",
  "瘺": "less-than-common",
  "瘼": "less-than-common",
  "瘽": "less-than-common",
  "癀": "rarely-used",
  "癁": "rarely-used",
  "療": "common",
  "癃": "less-than-common",
  "癆": "common",
  "癇": "less-than-common",
  "癈": "less-than-common",
  "癉": "less-than-common",
  "癊": "rarely-used",
  "癋": "rarely-used",
  "癌": "common",
  "癐": "less-than-common",
  "癒": "common",
  "癓": "less-than-common",
  "癔": "rarely-used",
  "癖": "common",
  "癗": "rarely-used",
  "癘": "common",
  "癙": "less-than-common",
  "癚": "rarely-used",
  "癛": "rarely-used",
  "癜": "less-than-common",
  "癟": "less-than-common",
  "癠": "less-than-common",
  "癢": "common",
  "癤": "less-than-common",
  "癥": "common",
  "癨": "rarely-used",
  "癩": "common",
  "癪": "less-than-common",
  "癬": "common",
  "癭": "less-than-common",
  "癮": "common",
  "癰": "less-than-common",
  "癱": "common",
  "癲": "common",
  "癵": "less-than-common",
  "癶": "rarely-used",
  "癸": "common",
  "癹": "less-than-common",
  "登": "common",
  "發": "common",
  "白": "common",
  "百": "common",
  "癿": "rarely-used",
  "皀": "rarely-used",
  "皁": "less-than-common",
  "皂": "common",
  "的": "common",
  "皅": "rarely-used",
  "皆": "common",
  "皇": "common",
  "皈": "common",
  "皉": "rarely-used",
  "皊": "less-than-common",
  "皋": "less-than-common",
  "皌": "rarely-used",
  "皎": "common",
  "皏": "less-than-common",
  "皒": "rarely-used",
  "皓": "common",
  "皕": "less-than-common",
  "皖": "common",
  "皗": "rarely-used",
  "皘": "rarely-used",
  "皙": "less-than-common",
  "皚": "common",
  "皛": "less-than-common",
  "皜": "less-than-common",
  "皝": "less-than-common",
  "皞": "less-than-common",
  "皟": "rarely-used",
  "皠": "rarely-used",
  "皢": "rarely-used",
  "皣": "rarely-used",
  "皤": "less-than-common",
  "皦": "less-than-common",
  "皧": "rarely-used",
  "皪": "rarely-used",
  "皫": "less-than-common",
  "皭": "less-than-common",
  "皮": "common",
  "皯": "less-than-common",
  "皰": "common",
  "皴": "common",
  "皵": "less-than-common",
  "皸": "less-than-common",
  "皺": "common",
  "皻": "less-than-common",
  "皽": "less-than-common",
  "皾": "less-than-common",
  "皿": "common",
  "盀": "rarely-used",
  "盂": "common",
  "盃": "common",
  "盄": "less-than-common",
  "盅": "less-than-common",
  "盆": "common",
  "盈": "common",
  "盉": "less-than-common",
  "益": "common",
  "盍": "common",
  "盎": "common",
  "盒": "common",
  "盓": "less-than-common",
  "盔": "common",
  "盚": "rarely-used",
  "盛": "common",
  "盜": "common",
  "盝": "less-than-common",
  "盞": "common",
  "盟": "common",
  "盠": "rarely-used",
  "盡": "common",
  "盢": "rarely-used",
  "監": "common",
  "盤": "common",
  "盥": "common",
  "盦": "less-than-common",
  "盧": "common",
  "盨": "rarely-used",
  "盩": "less-than-common",
  "盪": "common",
  "盬": "less-than-common",
  "盭": "less-than-common",
  "目": "common",
  "盯": "common",
  "盰": "rarely-used",
  "盱": "less-than-common",
  "盲": "common",
  "盳": "less-than-common",
  "直": "common",
  "盵": "rarely-used",
  "盶": "rarely-used",
  "盷": "less-than-common",
  "相": "common",
  "盹": "common",
  "盺": "rarely-used",
  "盻": "less-than-common",
  "盼": "common",
  "盾": "common",
  "盿": "rarely-used",
  "眀": "rarely-used",
  "省": "common",
  "眂": "rarely-used",
  "眃": "less-than-common",
  "眄": "less-than-common",
  "眅": "less-than-common",
  "眆": "rarely-used",
  "眇": "less-than-common",
  "眈": "less-than-common",
  "眉": "common",
  "眊": "less-than-common",
  "看": "common",
  "眏": "rarely-used",
  "眐": "less-than-common",
  "眑": "less-than-common",
  "眒": "less-than-common",
  "眓": "less-than-common",
  "眕": "less-than-common",
  "眖": "rarely-used",
  "眗": "rarely-used",
  "眙": "less-than-common",
  "眚": "less-than-common",
  "眛": "less-than-common",
  "眝": "less-than-common",
  "真": "common",
  "眠": "common",
  "眢": "less-than-common",
  "眣": "less-than-common",
  "眥": "less-than-common",
  "眧": "rarely-used",
  "眨": "common",
  "眩": "common",
  "眪": "rarely-used",
  "眭": "less-than-common",
  "眮": "rarely-used",
  "眯": "less-than-common",
  "眰": "rarely-used",
  "眱": "less-than-common",
  "眲": "less-than-common",
  "眳": "less-than-common",
  "眴": "less-than-common",
  "眵": "rarely-used",
  "眶": "common",
  "眷": "common",
  "眸": "common",
  "眹": "less-than-common",
  "眺": "common",
  "眻": "rarely-used",
  "眼": "common",
  "眽": "less-than-common",
  "眾": "common",
  "睃": "rarely-used",
  "睄": "less-than-common",
  "睅": "less-than-common",
  "睆": "less-than-common",
  "睇": "less-than-common",
  "睈": "rarely-used",
  "睉": "rarely-used",
  "睊": "less-than-common",
  "睋": "less-than-common",
  "睌": "less-than-common",
  "睍": "less-than-common",
  "睎": "less-than-common",
  "睏": "common",
  "睒": "less-than-common",
  "睔": "less-than-common",
  "睕": "less-than-common",
  "睖": "less-than-common",
  "睗": "rarely-used",
  "睙": "rarely-used",
  "睚": "less-than-common",
  "睛": "common",
  "睜": "common",
  "睝": "rarely-used",
  "睞": "common",
  "睟": "less-than-common",
  "睠": "less-than-common",
  "睡": "common",
  "睢": "less-than-common",
  "督": "common",
  "睥": "common",
  "睦": "common",
  "睧": "less-than-common",
  "睨": "common",
  "睩": "less-than-common",
  "睪": "common",
  "睫": "common",
  "睬": "common",
  "睭": "rarely-used",
  "睮": "less-than-common",
  "睯": "less-than-common",
  "睰": "rarely-used",
  "睱": "rarely-used",
  "睲": "rarely-used",
  "睳": "rarely-used",
  "睴": "rarely-used",
  "睵": "rarely-used",
  "睶": "rarely-used",
  "睷": "rarely-used",
  "睸": "rarely-used",
  "睹": "common",
  "睺": "rarely-used",
  "睼": "less-than-common",
  "睽": "common",
  "睾": "less-than-common",
  "睿": "common",
  "瞀": "less-than-common",
  "瞁": "less-than-common",
  "瞂": "less-than-common",
  "瞃": "rarely-used",
  "瞄": "common",
  "瞅": "less-than-common",
  "瞇": "common",
  "瞈": "rarely-used",
  "瞉": "less-than-common",
  "瞊": "rarely-used",
  "瞋": "less-than-common",
  "瞌": "common",
  "瞍": "less-than-common",
  "瞎": "common",
  "瞏": "less-than-common",
  "瞐": "rarely-used",
  "瞑": "common",
  "瞔": "rarely-used",
  "瞕": "rarely-used",
  "瞖": "rarely-used",
  "瞗": "rarely-used",
  "瞘": "rarely-used",
  "瞙": "rarely-used",
  "瞚": "less-than-common",
  "瞛": "less-than-common",
  "瞜": "less-than-common",
  "瞝": "less-than-common",
  "瞞": "common",
  "瞟": "common",
  "瞠": "common",
  "瞡": "less-than-common",
  "瞢": "less-than-common",
  "瞣": "rarely-used",
  "瞤": "rarely-used",
  "瞥": "common",
  "瞦": "rarely-used",
  "瞧": "common",
  "瞨": "rarely-used",
  "瞪": "common",
  "瞫": "less-than-common",
  "瞬": "common",
  "瞭": "common",
  "瞮": "rarely-used",
  "瞰": "common",
  "瞱": "rarely-used",
  "瞲": "less-than-common",
  "瞳": "common",
  "瞴": "less-than-common",
  "瞵": "less-than-common",
  "瞶": "less-than-common",
  "瞷": "less-than-common",
  "瞸": "rarely-used",
  "瞺": "rarely-used",
  "瞻": "common",
  "瞼": "less-than-common",
  "瞽": "common",
  "瞿": "common",
  "矂": "less-than-common",
  "矃": "rarely-used",
  "矄": "rarely-used",
  "矆": "rarely-used",
  "矇": "common",
  "矉": "less-than-common",
  "矊": "less-than-common",
  "矌": "less-than-common",
  "矍": "less-than-common",
  "矎": "less-than-common",
  "矏": "less-than-common",
  "矐": "less-than-common",
  "矑": "rarely-used",
  "矓": "common",
  "矔": "less-than-common",
  "矕": "less-than-common",
  "矗": "common",
  "矘": "less-than-common",
  "矙": "less-than-common",
  "矚": "common",
  "矛": "common",
  "矜": "common",
  "矞": "less-than-common",
  "矠": "less-than-common",
  "矡": "rarely-used",
  "矢": "common",
  "矣": "common",
  "矤": "rarely-used",
  "知": "common",
  "矧": "less-than-common",
  "矨": "rarely-used",
  "矩": "common",
  "矪": "rarely-used",
  "矬": "less-than-common",
  "短": "common",
  "矮": "common",
  "矯": "common",
  "矰": "less-than-common",
  "矱": "less-than-common",
  "矲": "less-than-common",
  "石": "common",
  "矷": "rarely-used",
  "矸": "less-than-common",
  "矹": "less-than-common",
  "矺": "less-than-common",
  "矻": "less-than-common",
  "矼": "less-than-common",
  "矽": "common",
  "砂": "common",
  "砃": "rarely-used",
  "砄": "rarely-used",
  "砅": "less-than-common",
  "砆": "less-than-common",
  "砉": "less-than-common",
  "砊": "rarely-used",
  "砋": "rarely-used",
  "砌": "common",
  "砍": "common",
  "砎": "less-than-common",
  "砏": "less-than-common",
  "砐": "less-than-common",
  "砑": "less-than-common",
  "砒": "less-than-common",
  "砓": "rarely-used",
  "研": "common",
  "砝": "common",
  "砟": "less-than-common",
  "砠": "less-than-common",
  "砡": "rarely-used",
  "砢": "less-than-common",
  "砣": "less-than-common",
  "砥": "common",
  "砦": "less-than-common",
  "砧": "common",
  "砨": "less-than-common",
  "砩": "rarely-used",
  "砪": "rarely-used",
  "砫": "rarely-used",
  "砬": "less-than-common",
  "砭": "common",
  "砮": "less-than-common",
  "砯": "less-than-common",
  "砰": "common",
  "砱": "rarely-used",
  "砲": "less-than-common",
  "砳": "rarely-used",
  "破": "common",
  "砵": "less-than-common",
  "砷": "common",
  "砸": "common",
  "硃": "common",
  "硄": "rarely-used",
  "硅": "rarely-used",
  "硇": "rarely-used",
  "硈": "less-than-common",
  "硉": "less-than-common",
  "硊": "less-than-common",
  "硌": "less-than-common",
  "硍": "less-than-common",
  "硎": "less-than-common",
  "硐": "rarely-used",
  "硒": "less-than-common",
  "硜": "less-than-common",
  "硝": "common",
  "硞": "rarely-used",
  "硟": "rarely-used",
  "硠": "less-than-common",
  "硢": "rarely-used",
  "硣": "rarely-used",
  "硤": "less-than-common",
  "硥": "less-than-common",
  "硧": "rarely-used",
  "硨": "rarely-used",
  "硩": "less-than-common",
  "硪": "less-than-common",
  "硫": "common",
  "硬": "common",
  "硭": "less-than-common",
  "确": "less-than-common",
  "硯": "common",
  "硰": "less-than-common",
  "硱": "less-than-common",
  "硶": "rarely-used",
  "硸": "rarely-used",
  "硹": "rarely-used",
  "硺": "rarely-used",
  "硻": "rarely-used",
  "硼": "common",
  "硽": "rarely-used",
  "硾": "less-than-common",
  "硿": "rarely-used",
  "碀": "rarely-used",
  "碂": "rarely-used",
  "碃": "rarely-used",
  "碄": "less-than-common",
  "碅": "less-than-common",
  "碆": "less-than-common",
  "碇": "less-than-common",
  "碉": "common",
  "碊": "rarely-used",
  "碋": "rarely-used",
  "碌": "common",
  "碎": "common",
  "碏": "less-than-common",
  "碐": "rarely-used",
  "碑": "common",
  "碓": "less-than-common",
  "碔": "less-than-common",
  "碕": "less-than-common",
  "碖": "rarely-used",
  "碗": "common",
  "碘": "common",
  "碙": "rarely-used",
  "碚": "less-than-common",
  "碞": "less-than-common",
  "碟": "common",
  "碠": "rarely-used",
  "碡": "rarely-used",
  "碢": "rarely-used",
  "碣": "less-than-common",
  "碤": "rarely-used",
  "碥": "rarely-used",
  "碦": "rarely-used",
  "碧": "common",
  "碨": "less-than-common",
  "碩": "common",
  "碪": "less-than-common",
  "碫": "less-than-common",
  "碬": "rarely-used",
  "碭": "less-than-common",
  "碮": "rarely-used",
  "碰": "common",
  "碲": "less-than-common",
  "碳": "common",
  "碴": "less-than-common",
  "碸": "rarely-used",
  "確": "common",
  "碻": "less-than-common",
  "碼": "common",
  "碽": "rarely-used",
  "碾": "common",
  "碿": "rarely-used",
  "磁": "common",
  "磃": "less-than-common",
  "磄": "rarely-used",
  "磅": "common",
  "磆": "rarely-used",
  "磈": "less-than-common",
  "磉": "rarely-used",
  "磊": "common",
  "磋": "common",
  "磌": "less-than-common",
  "磍": "less-than-common",
  "磎": "less-than-common",
  "磏": "less-than-common",
  "磐": "common",
  "磑": "less-than-common",
  "磓": "rarely-used",
  "磔": "less-than-common",
  "磕": "common",
  "磖": "rarely-used",
  "磚": "common",
  "磛": "less-than-common",
  "磝": "less-than-common",
  "磞": "less-than-common",
  "磟": "rarely-used",
  "磠": "rarely-used",
  "磡": "rarely-used",
  "磢": "rarely-used",
  "磣": "less-than-common",
  "磤": "rarely-used",
  "磥": "less-than-common",
  "磦": "rarely-used",
  "磧": "less-than-common",
  "磨": "common",
  "磩": "less-than-common",
  "磪": "less-than-common",
  "磫": "rarely-used",
  "磬": "common",
  "磭": "rarely-used",
  "磯": "common",
  "磲": "rarely-used",
  "磳": "less-than-common",
  "磴": "common",
  "磶": "rarely-used",
  "磷": "common",
  "磹": "rarely-used",
  "磺": "common",
  "磻": "less-than-common",
  "磼": "less-than-common",
  "磽": "less-than-common",
  "磾": "rarely-used",
  "磿": "less-than-common",
  "礁": "common",
  "礄": "rarely-used",
  "礅": "rarely-used",
  "礇": "rarely-used",
  "礉": "less-than-common",
  "礊": "rarely-used",
  "礋": "rarely-used",
  "礌": "less-than-common",
  "礎": "common",
  "礐": "less-than-common",
  "礑": "rarely-used",
  "礒": "rarely-used",
  "礓": "less-than-common",
  "礔": "less-than-common",
  "礗": "rarely-used",
  "礘": "rarely-used",
  "礙": "common",
  "礛": "less-than-common",
  "礜": "less-than-common",
  "礝": "less-than-common",
  "礞": "rarely-used",
  "礣": "less-than-common",
  "礤": "rarely-used",
  "礥": "less-than-common",
  "礦": "common",
  "礧": "less-than-common",
  "礨": "less-than-common",
  "礩": "rarely-used",
  "礪": "common",
  "礫": "common",
  "礬": "common",
  "礭": "less-than-common",
  "礯": "rarely-used",
  "礰": "rarely-used",
  "礱": "less-than-common",
  "礴": "less-than-common",
  "礵": "less-than-common",
  "礸": "rarely-used",
  "礹": "rarely-used",
  "示": "common",
  "礽": "less-than-common",
  "社": "common",
  "礿": "less-than-common",
  "祀": "common",
  "祁": "common",
  "祂": "less-than-common",
  "祄": "rarely-used",
  "祅": "less-than-common",
  "祆": "common",
  "祇": "common",
  "祈": "common",
  "祉": "common",
  "祊": "less-than-common",
  "祋": "less-than-common",
  "祌": "less-than-common",
  "祏": "less-than-common",
  "祐": "common",
  "祑": "less-than-common",
  "祒": "less-than-common",
  "祓": "less-than-common",
  "祔": "less-than-common",
  "祕": "common",
  "祖": "common",
  "祗": "common",
  "祚": "common",
  "祛": "less-than-common",
  "祜": "less-than-common",
  "祝": "common",
  "神": "common",
  "祟": "common",
  "祠": "common",
  "祡": "less-than-common",
  "祣": "less-than-common",
  "祤": "less-than-common",
  "祥": "common",
  "祦": "rarely-used",
  "祧": "less-than-common",
  "票": "common",
  "祩": "less-than-common",
  "祪": "less-than-common",
  "祫": "less-than-common",
  "祭": "common",
  "祰": "rarely-used",
  "祱": "rarely-used",
  "祲": "less-than-common",
  "祳": "less-than-common",
  "祴": "less-than-common",
  "祹": "rarely-used",
  "祺": "common",
  "祻": "rarely-used",
  "祼": "less-than-common",
  "祽": "rarely-used",
  "祾": "rarely-used",
  "祿": "common",
  "禁": "common",
  "禂": "less-than-common",
  "禃": "rarely-used",
  "禈": "rarely-used",
  "禊": "less-than-common",
  "禋": "less-than-common",
  "禌": "rarely-used",
  "禍": "common",
  "禎": "common",
  "福": "common",
  "禐": "rarely-used",
  "禑": "rarely-used",
  "禒": "rarely-used",
  "禓": "less-than-common",
  "禔": "less-than-common",
  "禕": "less-than-common",
  "禖": "less-than-common",
  "禗": "less-than-common",
  "禘": "less-than-common",
  "禚": "less-than-common",
  "禛": "rarely-used",
  "禜": "less-than-common",
  "禝": "rarely-used",
  "禟": "rarely-used",
  "禠": "less-than-common",
  "禡": "less-than-common",
  "禢": "rarely-used",
  "禤": "rarely-used",
  "禦": "common",
  "禧": "common",
  "禨": "less-than-common",
  "禪": "common",
  "禫": "less-than-common",
  "禬": "less-than-common",
  "禭": "less-than-common",
  "禮": "common",
  "禯": "rarely-used",
  "禰": "less-than-common",
  "禱": "common",
  "禲": "rarely-used",
  "禳": "less-than-common",
  "禴": "less-than-common",
  "禵": "rarely-used",
  "禶": "rarely-used",
  "禷": "less-than-common",
  "禸": "less-than-common",
  "禹": "common",
  "禺": "less-than-common",
  "离": "less-than-common",
  "禽": "common",
  "禾": "common",
  "禿": "common",
  "秀": "common",
  "私": "common",
  "秂": "rarely-used",
  "秄": "rarely-used",
  "秅": "less-than-common",
  "秈": "less-than-common",
  "秉": "common",
  "秋": "common",
  "种": "less-than-common",
  "秎": "less-than-common",
  "秏": "less-than-common",
  "科": "common",
  "秒": "common",
  "秓": "rarely-used",
  "秕": "less-than-common",
  "秖": "less-than-common",
  "秘": "less-than-common",
  "秙": "rarely-used",
  "秚": "rarely-used",
  "秛": "rarely-used",
  "秜": "rarely-used",
  "秝": "rarely-used",
  "秞": "rarely-used",
  "租": "common",
  "秠": "less-than-common",
  "秡": "rarely-used",
  "秢": "rarely-used",
  "秣": "common",
  "秤": "common",
  "秥": "rarely-used",
  "秦": "common",
  "秧": "common",
  "秨": "rarely-used",
  "秩": "common",
  "秪": "less-than-common",
  "秫": "less-than-common",
  "秬": "less-than-common",
  "秭": "less-than-common",
  "秮": "less-than-common",
  "秱": "rarely-used",
  "秲": "rarely-used",
  "秳": "rarely-used",
  "秵": "rarely-used",
  "秶": "less-than-common",
  "秷": "rarely-used",
  "秸": "less-than-common",
  "秹": "rarely-used",
  "秺": "less-than-common",
  "移": "common",
  "秿": "rarely-used",
  "稀": "common",
  "稂": "less-than-common",
  "稃": "less-than-common",
  "稄": "rarely-used",
  "稅": "common",
  "稇": "rarely-used",
  "稈": "common",
  "稊": "less-than-common",
  "程": "common",
  "稌": "less-than-common",
  "稍": "common",
  "稏": "rarely-used",
  "稐": "rarely-used",
  "稑": "less-than-common",
  "稒": "less-than-common",
  "稓": "rarely-used",
  "稔": "common",
  "稕": "rarely-used",
  "稗": "less-than-common",
  "稘": "less-than-common",
  "稙": "less-than-common",
  "稚": "common",
  "稛": "rarely-used",
  "稜": "common",
  "稝": "rarely-used",
  "稞": "less-than-common",
  "稟": "common",
  "稠": "common",
  "稡": "rarely-used",
  "稢": "rarely-used",
  "稦": "rarely-used",
  "稧": "rarely-used",
  "稨": "rarely-used",
  "稩": "rarely-used",
  "稪": "rarely-used",
  "稫": "less-than-common",
  "種": "common",
  "稯": "less-than-common",
  "稰": "less-than-common",
  "稱": "common",
  "稴": "rarely-used",
  "稵": "rarely-used",
  "稷": "common",
  "稹": "less-than-common",
  "稻": "common",
  "稼": "common",
  "稽": "common",
  "稿": "common",
  "穀": "common",
  "穁": "rarely-used",
  "穄": "less-than-common",
  "穆": "common",
  "穇": "rarely-used",
  "穈": "less-than-common",
  "穊": "less-than-common",
  "穋": "less-than-common",
  "穌": "common",
  "積": "common",
  "穎": "common",
  "穓": "rarely-used",
  "穔": "rarely-used",
  "穕": "rarely-used",
  "穖": "less-than-common",
  "穗": "common",
  "穘": "rarely-used",
  "穙": "rarely-used",
  "穚": "rarely-used",
  "穛": "less-than-common",
  "穜": "less-than-common",
  "穟": "less-than-common",
  "穠": "less-than-common",
  "穡": "common",
  "穢": "common",
  "穥": "rarely-used",
  "穦": "rarely-used",
  "穧": "less-than-common",
  "穨": "less-than-common",
  "穩": "common",
  "穫": "common",
  "穬": "less-than-common",
  "穭": "less-than-common",
  "穮": "less-than-common",
  "穰": "less-than-common",
  "穱": "less-than-common",
  "穲": "rarely-used",
  "穳": "rarely-used",
  "穴": "common",
  "穵": "rarely-used",
  "究": "common",
  "穸": "less-than-common",
  "穹": "common",
  "空": "common",
  "穻": "rarely-used",
  "穼": "rarely-used",
  "穾": "less-than-common",
  "穿": "common",
  "窀": "less-than-common",
  "突": "common",
  "窄": "common",
  "窅": "less-than-common",
  "窆": "less-than-common",
  "窇": "rarely-used",
  "窈": "common",
  "窉": "less-than-common",
  "窊": "less-than-common",
  "窋": "less-than-common",
  "窌": "less-than-common",
  "窏": "less-than-common",
  "窐": "less-than-common",
  "窒": "common",
  "窔": "less-than-common",
  "窕": "common",
  "窖": "common",
  "窗": "common",
  "窘": "common",
  "窙": "less-than-common",
  "窚": "rarely-used",
  "窛": "rarely-used",
  "窞": "less-than-common",
  "窟": "common",
  "窠": "common",
  "窡": "rarely-used",
  "窢": "less-than-common",
  "窣": "less-than-common",
  "窤": "rarely-used",
  "窨": "less-than-common",
  "窩": "common",
  "窪": "common",
  "窫": "less-than-common",
  "窬": "less-than-common",
  "窮": "common",
  "窯": "common",
  "窱": "less-than-common",
  "窲": "less-than-common",
  "窳": "less-than-common",
  "窴": "less-than-common",
  "窵": "less-than-common",
  "窶": "less-than-common",
  "窷": "rarely-used",
  "窸": "less-than-common",
  "窹": "rarely-used",
  "窺": "common",
  "窼": "rarely-used",
  "窾": "less-than-common",
  "窿": "less-than-common",
  "竀": "less-than-common",
  "竁": "less-than-common",
  "竄": "common",
  "竅": "common",
  "竇": "common",
  "竉": "rarely-used",
  "竊": "common",
  "立": "common",
  "竌": "rarely-used",
  "竎": "rarely-used",
  "竑": "less-than-common",
  "竘": "less-than-common",
  "站": "common",
  "竟": "common",
  "章": "common",
  "竣": "common",
  "竤": "rarely-used",
  "童": "common",
  "竦": "less-than-common",
  "竧": "rarely-used",
  "竨": "rarely-used",
  "竫": "less-than-common",
  "竬": "rarely-used",
  "竭": "common",
  "竮": "rarely-used",
  "端": "common",
  "竱": "rarely-used",
  "竲": "rarely-used",
  "竳": "rarely-used",
  "竴": "rarely-used",
  "竵": "rarely-used",
  "競": "common",
  "竷": "less-than-common",
  "竹": "common",
  "竺": "common",
  "竻": "rarely-used",
  "竽": "common",
  "竿": "common",
  "笀": "rarely-used",
  "笁": "rarely-used",
  "笄": "less-than-common",
  "笅": "less-than-common",
  "笆": "common",
  "笈": "less-than-common",
  "笉": "rarely-used",
  "笊": "less-than-common",
  "笌": "rarely-used",
  "笍": "rarely-used",
  "笎": "rarely-used",
  "笏": "less-than-common",
  "笐": "less-than-common",
  "笑": "common",
  "笒": "rarely-used",
  "笓": "less-than-common",
  "笖": "rarely-used",
  "笗": "rarely-used",
  "笘": "less-than-common",
  "笙": "common",
  "笚": "rarely-used",
  "笛": "common",
  "笜": "rarely-used",
  "笝": "less-than-common",
  "笞": "common",
  "笠": "common",
  "笡": "rarely-used",
  "笢": "less-than-common",
  "笣": "rarely-used",
  "笤": "less-than-common",
  "笥": "less-than-common",
  "符": "common",
  "笨": "common",
  "笩": "rarely-used",
  "笪": "less-than-common",
  "笫": "less-than-common",
  "第": "common",
  "笭": "less-than-common",
  "笮": "less-than-common",
  "笯": "less-than-common",
  "笰": "less-than-common",
  "笱": "less-than-common",
  "笲": "less-than-common",
  "笳": "less-than-common",
  "笴": "less-than-common",
  "笵": "less-than-common",
  "笸": "rarely-used",
  "笻": "less-than-common",
  "笿": "rarely-used",
  "筀": "rarely-used",
  "筃": "rarely-used",
  "筄": "less-than-common",
  "筅": "rarely-used",
  "筆": "common",
  "筇": "less-than-common",
  "筈": "less-than-common",
  "等": "common",
  "筊": "less-than-common",
  "筋": "common",
  "筌": "less-than-common",
  "筍": "common",
  "筎": "rarely-used",
  "筏": "common",
  "筐": "common",
  "筑": "less-than-common",
  "筒": "common",
  "答": "common",
  "筕": "rarely-used",
  "策": "common",
  "筗": "rarely-used",
  "筘": "rarely-used",
  "筟": "rarely-used",
  "筠": "common",
  "筡": "less-than-common",
  "筢": "rarely-used",
  "筣": "rarely-used",
  "筤": "less-than-common",
  "筥": "less-than-common",
  "筦": "less-than-common",
  "筧": "less-than-common",
  "筩": "less-than-common",
  "筪": "rarely-used",
  "筫": "rarely-used",
  "筬": "rarely-used",
  "筭": "less-than-common",
  "筮": "less-than-common",
  "筰": "less-than-common",
  "筱": "less-than-common",
  "筲": "less-than-common",
  "筳": "less-than-common",
  "筴": "less-than-common",
  "筵": "common",
  "筶": "rarely-used",
  "筷": "common",
  "筸": "rarely-used",
  "箁": "rarely-used",
  "箂": "rarely-used",
  "箃": "rarely-used",
  "箄": "less-than-common",
  "箅": "less-than-common",
  "箇": "less-than-common",
  "箈": "less-than-common",
  "箉": "rarely-used",
  "箊": "less-than-common",
  "箋": "common",
  "箌": "less-than-common",
  "箍": "less-than-common",
  "箎": "less-than-common",
  "箏": "common",
  "箐": "less-than-common",
  "箑": "less-than-common",
  "箔": "common",
  "箕": "common",
  "箖": "less-than-common",
  "算": "common",
  "箘": "less-than-common",
  "箙": "less-than-common",
  "箛": "less-than-common",
  "箜": "less-than-common",
  "箝": "common",
  "箞": "rarely-used",
  "箠": "less-than-common",
  "管": "common",
  "箢": "rarely-used",
  "箤": "rarely-used",
  "箬": "less-than-common",
  "箭": "common",
  "箮": "rarely-used",
  "箯": "less-than-common",
  "箰": "rarely-used",
  "箱": "common",
  "箳": "rarely-used",
  "箴": "common",
  "箵": "rarely-used",
  "箶": "rarely-used",
  "箷": "less-than-common",
  "箸": "less-than-common",
  "箹": "less-than-common",
  "箺": "rarely-used",
  "箼": "rarely-used",
  "箽": "rarely-used",
  "箾": "less-than-common",
  "箿": "rarely-used",
  "節": "common",
  "篁": "common",
  "篂": "rarely-used",
  "篃": "rarely-used",
  "範": "common",
  "篅": "rarely-used",
  "篆": "common",
  "篇": "common",
  "篈": "rarely-used",
  "築": "common",
  "篊": "rarely-used",
  "篋": "less-than-common",
  "篌": "less-than-common",
  "篍": "rarely-used",
  "篎": "less-than-common",
  "篔": "less-than-common",
  "篕": "less-than-common",
  "篖": "rarely-used",
  "篗": "rarely-used",
  "篘": "rarely-used",
  "篙": "common",
  "篚": "less-than-common",
  "篛": "common",
  "篜": "rarely-used",
  "篝": "less-than-common",
  "篞": "less-than-common",
  "篟": "rarely-used",
  "篠": "less-than-common",
  "篡": "common",
  "篢": "rarely-used",
  "篣": "less-than-common",
  "篤": "common",
  "篥": "less-than-common",
  "篦": "less-than-common",
  "篧": "less-than-common",
  "篨": "less-than-common",
  "篩": "common",
  "篪": "less-than-common",
  "篫": "rarely-used",
  "篬": "rarely-used",
  "篰": "rarely-used",
  "篱": "rarely-used",
  "篲": "less-than-common",
  "篳": "less-than-common",
  "篴": "less-than-common",
  "篵": "rarely-used",
  "篶": "rarely-used",
  "篷": "common",
  "篸": "less-than-common",
  "篹": "less-than-common",
  "篺": "rarely-used",
  "篻": "less-than-common",
  "篼": "rarely-used",
  "篽": "less-than-common",
  "篾": "common",
  "篿": "less-than-common",
  "簀": "less-than-common",
  "簁": "less-than-common",
  "簂": "less-than-common",
  "簃": "less-than-common",
  "簄": "rarely-used",
  "簅": "less-than-common",
  "簆": "rarely-used",
  "簇": "common",
  "簉": "less-than-common",
  "簊": "rarely-used",
  "簋": "less-than-common",
  "簌": "less-than-common",
  "簍": "common",
  "簎": "less-than-common",
  "簏": "less-than-common",
  "簐": "rarely-used",
  "簑": "common",
  "簕": "rarely-used",
  "簙": "less-than-common",
  "簜": "less-than-common",
  "簝": "less-than-common",
  "簞": "common",
  "簟": "less-than-common",
  "簠": "less-than-common",
  "簡": "common",
  "簢": "less-than-common",
  "簣": "common",
  "簥": "less-than-common",
  "簦": "less-than-common",
  "簧": "common",
  "簨": "less-than-common",
  "簩": "less-than-common",
  "簪": "common",
  "簫": "common",
  "簬": "less-than-common",
  "簭": "less-than-common",
  "簰": "rarely-used",
  "簳": "less-than-common",
  "簶": "rarely-used",
  "簷": "common",
  "簸": "common",
  "簹": "less-than-common",
  "簺": "rarely-used",
  "簻": "less-than-common",
  "簼": "less-than-common",
  "簽": "common",
  "簾": "common",
  "簿": "common",
  "籀": "less-than-common",
  "籃": "common",
  "籅": "rarely-used",
  "籆": "rarely-used",
  "籇": "rarely-used",
  "籈": "less-than-common",
  "籉": "less-than-common",
  "籊": "less-than-common",
  "籋": "rarely-used",
  "籌": "common",
  "籍": "common",
  "籐": "common",
  "籓": "rarely-used",
  "籔": "less-than-common",
  "籗": "less-than-common",
  "籙": "less-than-common",
  "籚": "rarely-used",
  "籛": "less-than-common",
  "籜": "less-than-common",
  "籟": "common",
  "籠": "common",
  "籣": "less-than-common",
  "籤": "common",
  "籥": "less-than-common",
  "籦": "less-than-common",
  "籧": "less-than-common",
  "籩": "less-than-common",
  "籪": "rarely-used",
  "籫": "rarely-used",
  "籬": "common",
  "籮": "common",
  "籯": "less-than-common",
  "籰": "rarely-used",
  "籲": "common",
  "米": "common",
  "籷": "rarely-used",
  "籸": "less-than-common",
  "籹": "less-than-common",
  "籺": "less-than-common",
  "籽": "less-than-common",
  "籿": "rarely-used",
  "粀": "rarely-used",
  "粁": "rarely-used",
  "粄": "less-than-common",
  "粅": "rarely-used",
  "粆": "rarely-used",
  "粈": "rarely-used",
  "粉": "common",
  "粊": "less-than-common",
  "粌": "rarely-used",
  "粍": "rarely-used",
  "粑": "less-than-common",
  "粒": "common",
  "粔": "less-than-common",
  "粕": "less-than-common",
  "粖": "rarely-used",
  "粗": "common",
  "粘": "less-than-common",
  "粞": "rarely-used",
  "粟": "common",
  "粡": "rarely-used",
  "粢": "less-than-common",
  "粣": "rarely-used",
  "粥": "common",
  "粨": "rarely-used",
  "粯": "rarely-used",
  "粱": "common",
  "粲": "less-than-common",
  "粳": "common",
  "粴": "rarely-used",
  "粵": "common",
  "粶": "rarely-used",
  "粷": "rarely-used",
  "粸": "rarely-used",
  "粹": "common",
  "粺": "less-than-common",
  "粻": "less-than-common",
  "粼": "less-than-common",
  "粽": "common",
  "精": "common",
  "粿": "less-than-common",
  "糄": "rarely-used",
  "糅": "less-than-common",
  "糈": "less-than-common",
  "糊": "common",
  "糋": "rarely-used",
  "糌": "less-than-common",
  "糏": "rarely-used",
  "糐": "rarely-used",
  "糑": "rarely-used",
  "糒": "less-than-common",
  "糔": "less-than-common",
  "糕": "common",
  "糖": "common",
  "糗": "less-than-common",
  "糙": "common",
  "糜": "common",
  "糝": "less-than-common",
  "糞": "common",
  "糟": "common",
  "糠": "common",
  "糢": "common",
  "糧": "common",
  "糨": "rarely-used",
  "糪": "less-than-common",
  "糫": "rarely-used",
  "糬": "less-than-common",
  "糮": "rarely-used",
  "糯": "common",
  "糰": "less-than-common",
  "糱": "less-than-common",
  "糲": "less-than-common",
  "糴": "less-than-common",
  "糶": "less-than-common",
  "糷": "less-than-common",
  "糸": "common",
  "系": "common",
  "糽": "rarely-used",
  "糾": "common",
  "紀": "common",
  "紁": "rarely-used",
  "紂": "common",
  "紃": "less-than-common",
  "約": "common",
  "紅": "common",
  "紆": "less-than-common",
  "紇": "common",
  "紈": "less-than-common",
  "紉": "common",
  "紊": "common",
  "紋": "common",
  "紌": "rarely-used",
  "納": "common",
  "紎": "less-than-common",
  "紏": "rarely-used",
  "紐": "common",
  "紑": "less-than-common",
  "紒": "less-than-common",
  "紓": "less-than-common",
  "純": "common",
  "紕": "common",
  "紖": "less-than-common",
  "紗": "common",
  "紘": "less-than-common",
  "紙": "common",
  "級": "common",
  "紛": "common",
  "紜": "common",
  "紝": "less-than-common",
  "紞": "less-than-common",
  "紟": "less-than-common",
  "素": "common",
  "紡": "common",
  "索": "common",
  "紤": "rarely-used",
  "紨": "rarely-used",
  "紩": "less-than-common",
  "紫": "common",
  "紬": "less-than-common",
  "紮": "common",
  "累": "common",
  "細": "common",
  "紱": "less-than-common",
  "紲": "less-than-common",
  "紳": "common",
  "紴": "rarely-used",
  "紵": "less-than-common",
  "紶": "less-than-common",
  "紷": "rarely-used",
  "紸": "less-than-common",
  "紹": "common",
  "紺": "less-than-common",
  "紻": "rarely-used",
  "紼": "common",
  "紽": "less-than-common",
  "紾": "less-than-common",
  "紿": "less-than-common",
  "絀": "common",
  "絁": "less-than-common",
  "終": "common",
  "絃": "common",
  "組": "common",
  "絅": "less-than-common",
  "絆": "common",
  "絇": "less-than-common",
  "絉": "rarely-used",
  "絊": "rarely-used",
  "絎": "rarely-used",
  "絏": "less-than-common",
  "結": "common",
  "絑": "rarely-used",
  "絒": "rarely-used",
  "絓": "less-than-common",
  "絔": "rarely-used",
  "絕": "common",
  "絖": "less-than-common",
  "絗": "rarely-used",
  "絘": "less-than-common",
  "絙": "rarely-used",
  "絛": "less-than-common",
  "絜": "less-than-common",
  "絞": "common",
  "絟": "rarely-used",
  "絠": "rarely-used",
  "絡": "common",
  "絢": "common",
  "絣": "less-than-common",
  "給": "common",
  "絧": "less-than-common",
  "絨": "common",
  "絩": "rarely-used",
  "絪": "less-than-common",
  "絫": "less-than-common",
  "絬": "rarely-used",
  "絭": "less-than-common",
  "絮": "common",
  "絯": "less-than-common",
  "絰": "less-than-common",
  "統": "common",
  "絲": "common",
  "絳": "less-than-common",
  "絴": "rarely-used",
  "絹": "common",
  "絺": "less-than-common",
  "絻": "less-than-common",
  "絼": "less-than-common",
  "絽": "rarely-used",
  "絾": "rarely-used",
  "絿": "less-than-common",
  "綀": "less-than-common",
  "綁": "common",
  "綃": "less-than-common",
  "綄": "rarely-used",
  "綅": "less-than-common",
  "綆": "less-than-common",
  "綈": "less-than-common",
  "綊": "rarely-used",
  "綌": "less-than-common",
  "綍": "less-than-common",
  "綎": "less-than-common",
  "綏": "common",
  "綐": "rarely-used",
  "綑": "common",
  "綒": "rarely-used",
  "經": "common",
  "綔": "less-than-common",
  "綖": "less-than-common",
  "綜": "common",
  "綝": "less-than-common",
  "綞": "common",
  "綟": "less-than-common",
  "綠": "common",
  "綡": "rarely-used",
  "綢": "common",
  "綣": "less-than-common",
  "綥": "rarely-used",
  "綦": "less-than-common",
  "綧": "less-than-common",
  "綩": "rarely-used",
  "綪": "less-than-common",
  "綬": "less-than-common",
  "維": "common",
  "綮": "less-than-common",
  "綯": "less-than-common",
  "綰": "common",
  "綱": "common",
  "網": "common",
  "綴": "common",
  "綵": "common",
  "綶": "rarely-used",
  "綷": "less-than-common",
  "綸": "common",
  "綹": "less-than-common",
  "綺": "common",
  "綻": "common",
  "綼": "less-than-common",
  "綽": "common",
  "綾": "common",
  "綿": "common",
  "緀": "less-than-common",
  "緁": "less-than-common",
  "緂": "less-than-common",
  "緃": "rarely-used",
  "緄": "less-than-common",
  "緅": "less-than-common",
  "緆": "less-than-common",
  "緇": "common",
  "緈": "rarely-used",
  "緉": "rarely-used",
  "緊": "common",
  "緋": "less-than-common",
  "緌": "less-than-common",
  "緎": "less-than-common",
  "緒": "common",
  "緗": "less-than-common",
  "緘": "common",
  "緙": "less-than-common",
  "線": "common",
  "緛": "less-than-common",
  "緝": "common",
  "緞": "common",
  "緟": "rarely-used",
  "締": "common",
  "緡": "less-than-common",
  "緢": "rarely-used",
  "緣": "common",
  "緦": "less-than-common",
  "緧": "less-than-common",
  "編": "common",
  "緩": "common",
  "緪": "less-than-common",
  "緬": "common",
  "緭": "rarely-used",
  "緮": "rarely-used",
  "緯": "common",
  "緰": "less-than-common",
  "緱": "less-than-common",
  "緲": "less-than-common",
  "緳": "less-than-common",
  "練": "common",
  "緵": "less-than-common",
  "緶": "less-than-common",
  "緷": "less-than-common",
  "緸": "rarely-used",
  "緹": "less-than-common",
  "緺": "less-than-common",
  "緻": "common",
  "縃": "less-than-common",
  "縈": "common",
  "縉": "less-than-common",
  "縊": "common",
  "縋": "less-than-common",
  "縌": "less-than-common",
  "縍": "rarely-used",
  "縎": "less-than-common",
  "縏": "less-than-common",
  "縐": "less-than-common",
  "縑": "common",
  "縒": "less-than-common",
  "縓": "less-than-common",
  "縔": "rarely-used",
  "縕": "less-than-common",
  "縖": "rarely-used",
  "縗": "less-than-common",
  "縙": "rarely-used",
  "縚": "less-than-common",
  "縛": "common",
  "縜": "less-than-common",
  "縝": "less-than-common",
  "縞": "less-than-common",
  "縟": "less-than-common",
  "縠": "less-than-common",
  "縡": "less-than-common",
  "縢": "less-than-common",
  "縣": "common",
  "縤": "rarely-used",
  "縥": "rarely-used",
  "縩": "less-than-common",
  "縪": "less-than-common",
  "縫": "common",
  "縬": "rarely-used",
  "縭": "less-than-common",
  "縮": "common",
  "縯": "rarely-used",
  "縰": "less-than-common",
  "縱": "common",
  "縲": "common",
  "縳": "less-than-common",
  "縴": "less-than-common",
  "縵": "less-than-common",
  "縶": "less-than-common",
  "縷": "common",
  "縸": "less-than-common",
  "縹": "less-than-common",
  "縺": "rarely-used",
  "縻": "less-than-common",
  "縼": "less-than-common",
  "總": "common",
  "績": "common",
  "縿": "less-than-common",
  "繀": "less-than-common",
  "繁": "common",
  "繂": "less-than-common",
  "繃": "common",
  "繄": "less-than-common",
  "繅": "common",
  "繆": "common",
  "繇": "less-than-common",
  "繈": "less-than-common",
  "繉": "less-than-common",
  "繎": "rarely-used",
  "繐": "less-than-common",
  "繑": "less-than-common",
  "繒": "less-than-common",
  "繓": "rarely-used",
  "織": "common",
  "繕": "common",
  "繖": "less-than-common",
  "繗": "rarely-used",
  "繘": "less-than-common",
  "繙": "less-than-common",
  "繚": "common",
  "繜": "less-than-common",
  "繝": "rarely-used",
  "繞": "common",
  "繟": "less-than-common",
  "繠": "less-than-common",
  "繡": "common",
  "繢": "less-than-common",
  "繣": "less-than-common",
  "繥": "rarely-used",
  "繨": "rarely-used",
  "繩": "common",
  "繪": "common",
  "繫": "common",
  "繬": "rarely-used",
  "繭": "common",
  "繯": "less-than-common",
  "繰": "less-than-common",
  "繲": "less-than-common",
  "繳": "less-than-common",
  "繴": "less-than-common",
  "繵": "less-than-common",
  "繶": "less-than-common",
  "繷": "less-than-common",
  "繸": "less-than-common",
  "繹": "common",
  "繺": "less-than-common",
  "繻": "less-than-common",
  "繼": "common",
  "繽": "common",
  "繾": "less-than-common",
  "纀": "less-than-common",
  "纁": "less-than-common",
  "纂": "common",
  "纅": "rarely-used",
  "纆": "less-than-common",
  "纇": "less-than-common",
  "纈": "less-than-common",
  "纊": "less-than-common",
  "纋": "less-than-common",
  "續": "common",
  "纍": "less-than-common",
  "纏": "common",
  "纑": "less-than-common",
  "纓": "common",
  "纔": "less-than-common",
  "纕": "less-than-common",
  "纖": "common",
  "纗": "less-than-common",
  "纘": "less-than-common",
  "纙": "rarely-used",
  "纚": "less-than-common",
  "纛": "less-than-common",
  "纜": "common",
  "纞": "rarely-used",
  "缶": "common",
  "缸": "common",
  "缹": "less-than-common",
  "缺": "common",
  "缽": "common",
  "缾": "less-than-common",
  "缿": "less-than-common",
  "罃": "less-than-common",
  "罄": "common",
  "罅": "less-than-common",
  "罆": "rarely-used",
  "罈": "common",
  "罊": "less-than-common",
  "罋": "less-than-common",
  "罌": "less-than-common",
  "罍": "less-than-common",
  "罏": "less-than-common",
  "罐": "common",
  "网": "less-than-common",
  "罔": "common",
  "罕": "common",
  "罘": "less-than-common",
  "罛": "less-than-common",
  "罜": "less-than-common",
  "罝": "less-than-common",
  "罞": "less-than-common",
  "罟": "common",
  "罠": "less-than-common",
  "罡": "less-than-common",
  "罣": "less-than-common",
  "罤": "rarely-used",
  "罥": "less-than-common",
  "罦": "less-than-common",
  "罧": "less-than-common",
  "罨": "less-than-common",
  "罩": "common",
  "罪": "common",
  "罫": "less-than-common",
  "罬": "less-than-common",
  "罭": "less-than-common",
  "置": "common",
  "罯": "rarely-used",
  "罰": "common",
  "罱": "rarely-used",
  "署": "common",
  "罳": "less-than-common",
  "罵": "common",
  "罶": "less-than-common",
  "罷": "common",
  "罹": "common",
  "罺": "less-than-common",
  "罻": "less-than-common",
  "罼": "less-than-common",
  "罽": "less-than-common",
  "罾": "less-than-common",
  "罿": "less-than-common",
  "羃": "less-than-common",
  "羅": "common",
  "羆": "less-than-common",
  "羇": "less-than-common",
  "羈": "common",
  "羉": "less-than-common",
  "羊": "common",
  "羋": "common",
  "羌": "common",
  "羍": "less-than-common",
  "美": "common",
  "羏": "rarely-used",
  "羑": "less-than-common",
  "羒": "less-than-common",
  "羓": "rarely-used",
  "羔": "common",
  "羕": "less-than-common",
  "羖": "less-than-common",
  "羘": "rarely-used",
  "羚": "common",
  "羛": "less-than-common",
  "羜": "less-than-common",
  "羝": "less-than-common",
  "羞": "common",
  "羠": "less-than-common",
  "羡": "less-than-common",
  "羢": "less-than-common",
  "群": "common",
  "羥": "less-than-common",
  "羦": "less-than-common",
  "羧": "less-than-common",
  "羨": "common",
  "義": "common",
  "羫": "rarely-used",
  "羬": "less-than-common",
  "羭": "less-than-common",
  "羯": "common",
  "羰": "less-than-common",
  "羱": "less-than-common",
  "羲": "common",
  "羳": "less-than-common",
  "羵": "less-than-common",
  "羶": "common",
  "羷": "less-than-common",
  "羸": "common",
  "羹": "common",
  "羺": "less-than-common",
  "羻": "rarely-used",
  "羼": "less-than-common",
  "羽": "common",
  "羾": "less-than-common",
  "羿": "common",
  "翀": "rarely-used",
  "翁": "common",
  "翂": "less-than-common",
  "翃": "less-than-common",
  "翅": "common",
  "翇": "less-than-common",
  "翈": "rarely-used",
  "翉": "rarely-used",
  "翊": "less-than-common",
  "翋": "less-than-common",
  "翌": "common",
  "翍": "less-than-common",
  "翎": "common",
  "翏": "less-than-common",
  "翐": "less-than-common",
  "翑": "less-than-common",
  "習": "common",
  "翓": "rarely-used",
  "翔": "common",
  "翕": "common",
  "翗": "rarely-used",
  "翛": "less-than-common",
  "翜": "less-than-common",
  "翞": "rarely-used",
  "翟": "common",
  "翠": "common",
  "翡": "common",
  "翢": "less-than-common",
  "翣": "less-than-common",
  "翥": "less-than-common",
  "翦": "less-than-common",
  "翧": "rarely-used",
  "翨": "less-than-common",
  "翩": "common",
  "翪": "less-than-common",
  "翫": "less-than-common",
  "翬": "less-than-common",
  "翭": "less-than-common",
  "翮": "less-than-common",
  "翯": "less-than-common",
  "翰": "common",
  "翱": "common",
  "翲": "less-than-common",
  "翳": "common",
  "翴": "less-than-common",
  "翵": "rarely-used",
  "翷": "rarely-used",
  "翸": "rarely-used",
  "翹": "common",
  "翻": "common",
  "翼": "common",
  "翽": "less-than-common",
  "翾": "less-than-common",
  "翿": "less-than-common",
  "耀": "common",
  "老": "common",
  "考": "common",
  "耄": "less-than-common",
  "者": "common",
  "耆": "common",
  "耇": "less-than-common",
  "耋": "less-than-common",
  "而": "common",
  "耍": "common",
  "耎": "less-than-common",
  "耏": "less-than-common",
  "耐": "common",
  "耑": "less-than-common",
  "耒": "common",
  "耓": "rarely-used",
  "耔": "less-than-common",
  "耕": "common",
  "耖": "less-than-common",
  "耗": "common",
  "耘": "common",
  "耙": "common",
  "耚": "rarely-used",
  "耛": "rarely-used",
  "耜": "common",
  "耞": "less-than-common",
  "耟": "less-than-common",
  "耠": "rarely-used",
  "耡": "less-than-common",
  "耤": "less-than-common",
  "耥": "rarely-used",
  "耦": "less-than-common",
  "耨": "less-than-common",
  "耩": "rarely-used",
  "耪": "less-than-common",
  "耫": "rarely-used",
  "耬": "less-than-common",
  "耭": "rarely-used",
  "耰": "less-than-common",
  "耱": "rarely-used",
  "耲": "rarely-used",
  "耳": "common",
  "耴": "less-than-common",
  "耵": "less-than-common",
  "耶": "common",
  "耷": "less-than-common",
  "耹": "less-than-common",
  "耺": "rarely-used",
  "耽": "common",
  "耾": "less-than-common",
  "耿": "common",
  "聃": "less-than-common",
  "聄": "rarely-used",
  "聅": "rarely-used",
  "聆": "common",
  "聇": "less-than-common",
  "聈": "less-than-common",
  "聉": "rarely-used",
  "聊": "common",
  "聎": "rarely-used",
  "聏": "less-than-common",
  "聐": "rarely-used",
  "聑": "less-than-common",
  "聒": "less-than-common",
  "聕": "rarely-used",
  "聖": "common",
  "聗": "rarely-used",
  "聘": "common",
  "聙": "rarely-used",
  "聚": "common",
  "聛": "rarely-used",
  "聜": "rarely-used",
  "聝": "less-than-common",
  "聞": "common",
  "聠": "rarely-used",
  "聤": "rarely-used",
  "聥": "rarely-used",
  "聧": "rarely-used",
  "聬": "rarely-used",
  "聯": "common",
  "聰": "common",
  "聱": "common",
  "聲": "common",
  "聳": "common",
  "聵": "less-than-common",
  "聶": "common",
  "職": "common",
  "聸": "rarely-used",
  "聹": "less-than-common",
  "聺": "rarely-used",
  "聻": "rarely-used",
  "聽": "common",
  "聾": "common",
  "聿": "common",
  "肂": "less-than-common",
  "肄": "common",
  "肅": "common",
  "肆": "common",
  "肇": "common",
  "肉": "common",
  "肋": "common",
  "肌": "common",
  "肍": "rarely-used",
  "肏": "less-than-common",
  "肐": "less-than-common",
  "肑": "rarely-used",
  "肒": "less-than-common",
  "肓": "common",
  "肕": "less-than-common",
  "肖": "common",
  "肗": "rarely-used",
  "肘": "common",
  "肙": "less-than-common",
  "肚": "common",
  "肛": "common",
  "肜": "less-than-common",
  "肝": "common",
  "肞": "rarely-used",
  "肟": "rarely-used",
  "股": "common",
  "肢": "common",
  "肣": "less-than-common",
  "肥": "common",
  "肨": "rarely-used",
  "肩": "common",
  "肪": "common",
  "肫": "common",
  "肭": "rarely-used",
  "肮": "less-than-common",
  "肯": "common",
  "肰": "rarely-used",
  "肱": "common",
  "育": "common",
  "肳": "rarely-used",
  "肴": "common",
  "肵": "less-than-common",
  "肷": "rarely-used",
  "肸": "less-than-common",
  "肺": "common",
  "胂": "less-than-common",
  "胃": "common",
  "胄": "common",
  "胅": "less-than-common",
  "胇": "less-than-common",
  "胈": "less-than-common",
  "胉": "less-than-common",
  "胊": "less-than-common",
  "胋": "rarely-used",
  "背": "common",
  "胍": "rarely-used",
  "胎": "common",
  "胏": "less-than-common",
  "胐": "less-than-common",
  "胑": "less-than-common",
  "胒": "rarely-used",
  "胓": "rarely-used",
  "胔": "less-than-common",
  "胕": "less-than-common",
  "胖": "common",
  "胗": "less-than-common",
  "胘": "less-than-common",
  "胙": "less-than-common",
  "胚": "common",
  "胛": "common",
  "胜": "less-than-common",
  "胝": "less-than-common",
  "胞": "common",
  "胠": "less-than-common",
  "胡": "common",
  "胣": "less-than-common",
  "胤": "common",
  "胥": "common",
  "胦": "rarely-used",
  "胭": "common",
  "胮": "rarely-used",
  "胯": "less-than-common",
  "胰": "common",
  "胱": "common",
  "胲": "less-than-common",
  "胳": "common",
  "胴": "common",
  "胵": "less-than-common",
  "胶": "rarely-used",
  "胸": "common",
  "胹": "less-than-common",
  "胺": "less-than-common",
  "胻": "less-than-common",
  "胼": "less-than-common",
  "能": "common",
  "胾": "less-than-common",
  "胿": "rarely-used",
  "脀": "less-than-common",
  "脁": "less-than-common",
  "脂": "common",
  "脅": "common",
  "脆": "common",
  "脈": "common",
  "脊": "common",
  "脕": "less-than-common",
  "脖": "common",
  "脘": "less-than-common",
  "脙": "less-than-common",
  "脛": "less-than-common",
  "脜": "rarely-used",
  "脝": "rarely-used",
  "脞": "less-than-common",
  "脟": "less-than-common",
  "脠": "rarely-used",
  "脡": "less-than-common",
  "脢": "rarely-used",
  "脣": "common",
  "脤": "less-than-common",
  "脥": "less-than-common",
  "脦": "rarely-used",
  "脧": "less-than-common",
  "脩": "common",
  "脪": "rarely-used",
  "脫": "common",
  "脬": "less-than-common",
  "脭": "less-than-common",
  "脮": "rarely-used",
  "脯": "common",
  "脰": "less-than-common",
  "脹": "common",
  "脺": "rarely-used",
  "脻": "rarely-used",
  "脼": "rarely-used",
  "脽": "less-than-common",
  "脾": "common",
  "腀": "rarely-used",
  "腂": "rarely-used",
  "腃": "less-than-common",
  "腄": "less-than-common",
  "腅": "rarely-used",
  "腆": "common",
  "腇": "less-than-common",
  "腈": "rarely-used",
  "腉": "rarely-used",
  "腊": "less-than-common",
  "腋": "common",
  "腌": "less-than-common",
  "腍": "less-than-common",
  "腎": "common",
  "腏": "less-than-common",
  "腐": "common",
  "腑": "common",
  "腒": "less-than-common",
  "腓": "less-than-common",
  "腔": "common",
  "腕": "common",
  "腛": "less-than-common",
  "腜": "less-than-common",
  "腝": "rarely-used",
  "腞": "less-than-common",
  "腠": "less-than-common",
  "腡": "rarely-used",
  "腢": "less-than-common",
  "腣": "rarely-used",
  "腤": "less-than-common",
  "腥": "common",
  "腦": "common",
  "腧": "less-than-common",
  "腨": "rarely-used",
  "腩": "less-than-common",
  "腪": "rarely-used",
  "腫": "common",
  "腬": "rarely-used",
  "腮": "common",
  "腯": "less-than-common",
  "腰": "common",
  "腱": "common",
  "腲": "less-than-common",
  "腳": "common",
  "腴": "less-than-common",
  "腵": "rarely-used",
  "腶": "less-than-common",
  "腷": "less-than-common",
  "腸": "common",
  "腹": "common",
  "腺": "common",
  "腿": "common",
  "膀": "common",
  "膁": "rarely-used",
  "膂": "less-than-common",
  "膃": "less-than-common",
  "膅": "rarely-used",
  "膆": "less-than-common",
  "膇": "less-than-common",
  "膈": "common",
  "膉": "less-than-common",
  "膊": "common",
  "膋": "less-than-common",
  "膌": "less-than-common",
  "膍": "less-than-common",
  "膎": "rarely-used",
  "膏": "common",
  "膒": "rarely-used",
  "膔": "rarely-used",
  "膕": "less-than-common",
  "膖": "rarely-used",
  "膗": "rarely-used",
  "膘": "less-than-common",
  "膙": "rarely-used",
  "膚": "common",
  "膛": "common",
  "膜": "common",
  "膝": "common",
  "膞": "less-than-common",
  "膟": "less-than-common",
  "膠": "common",
  "膡": "rarely-used",
  "膢": "less-than-common",
  "膣": "less-than-common",
  "膦": "less-than-common",
  "膧": "rarely-used",
  "膨": "common",
  "膩": "common",
  "膫": "less-than-common",
  "膬": "less-than-common",
  "膭": "rarely-used",
  "膮": "less-than-common",
  "膯": "rarely-used",
  "膰": "less-than-common",
  "膱": "less-than-common",
  "膲": "less-than-common",
  "膳": "common",
  "膴": "less-than-common",
  "膵": "less-than-common",
  "膷": "less-than-common",
  "膸": "rarely-used",
  "膹": "less-than-common",
  "膺": "common",
  "膻": "less-than-common",
  "膼": "rarely-used",
  "膽": "common",
  "膾": "common",
  "膿": "common",
  "臀": "common",
  "臁": "rarely-used",
  "臂": "common",
  "臃": "common",
  "臄": "less-than-common",
  "臅": "less-than-common",
  "臆": "common",
  "臇": "less-than-common",
  "臈": "rarely-used",
  "臉": "common",
  "臊": "less-than-common",
  "臌": "less-than-common",
  "臍": "common",
  "臎": "rarely-used",
  "臏": "common",
  "臐": "less-than-common",
  "臑": "less-than-common",
  "臒": "less-than-common",
  "臔": "rarely-used",
  "臕": "less-than-common",
  "臖": "rarely-used",
  "臗": "less-than-common",
  "臘": "common",
  "臙": "less-than-common",
  "臚": "common",
  "臛": "less-than-common",
  "臝": "less-than-common",
  "臞": "less-than-common",
  "臟": "common",
  "臠": "less-than-common",
  "臡": "less-than-common",
  "臢": "less-than-common",
  "臣": "common",
  "臤": "rarely-used",
  "臥": "common",
  "臦": "less-than-common",
  "臧": "common",
  "臨": "common",
  "臩": "less-than-common",
  "自": "common",
  "臫": "rarely-used",
  "臬": "common",
  "臭": "common",
  "臮": "less-than-common",
  "臱": "rarely-used",
  "臲": "less-than-common",
  "至": "common",
  "致": "common",
  "臶": "rarely-used",
  "臷": "less-than-common",
  "臸": "less-than-common",
  "臹": "rarely-used",
  "臺": "common",
  "臻": "common",
  "臼": "common",
  "臾": "common",
  "臿": "less-than-common",
  "舀": "common",
  "舁": "less-than-common",
  "舂": "common",
  "舄": "less-than-common",
  "舅": "common",
  "與": "common",
  "興": "common",
  "舉": "common",
  "舊": "common",
  "舋": "less-than-common",
  "舌": "common",
  "舍": "common",
  "舏": "rarely-used",
  "舐": "common",
  "舑": "less-than-common",
  "舒": "common",
  "舔": "common",
  "舕": "less-than-common",
  "舙": "rarely-used",
  "舛": "common",
  "舜": "common",
  "舝": "less-than-common",
  "舞": "common",
  "舟": "common",
  "舠": "less-than-common",
  "舡": "less-than-common",
  "舢": "common",
  "舥": "rarely-used",
  "舦": "rarely-used",
  "舧": "rarely-used",
  "舨": "common",
  "航": "common",
  "舫": "common",
  "般": "common",
  "舭": "rarely-used",
  "舯": "less-than-common",
  "舲": "less-than-common",
  "舳": "less-than-common",
  "舴": "less-than-common",
  "舵": "common",
  "舶": "common",
  "舷": "common",
  "舸": "less-than-common",
  "船": "common",
  "舺": "less-than-common",
  "舼": "less-than-common",
  "舽": "less-than-common",
  "舿": "rarely-used",
  "艀": "less-than-common",
  "艂": "less-than-common",
  "艃": "rarely-used",
  "艄": "less-than-common",
  "艅": "less-than-common",
  "艆": "rarely-used",
  "艇": "common",
  "艉": "less-than-common",
  "艋": "less-than-common",
  "艎": "less-than-common",
  "艏": "less-than-common",
  "艐": "less-than-common",
  "艑": "less-than-common",
  "艒": "less-than-common",
  "艓": "less-than-common",
  "艕": "less-than-common",
  "艖": "rarely-used",
  "艗": "rarely-used",
  "艘": "common",
  "艙": "common",
  "艚": "rarely-used",
  "艛": "less-than-common",
  "艜": "rarely-used",
  "艞": "rarely-used",
  "艟": "less-than-common",
  "艡": "rarely-used",
  "艣": "rarely-used",
  "艤": "less-than-common",
  "艦": "common",
  "艧": "rarely-used",
  "艨": "less-than-common",
  "艩": "rarely-used",
  "艫": "less-than-common",
  "艬": "rarely-used",
  "艭": "rarely-used",
  "艮": "common",
  "良": "common",
  "艱": "common",
  "色": "common",
  "艴": "less-than-common",
  "艵": "less-than-common",
  "艸": "less-than-common",
  "艻": "rarely-used",
  "艼": "less-than-common",
  "艽": "less-than-common",
  "艾": "common",
  "艿": "rarely-used",
  "芀": "less-than-common",
  "芃": "less-than-common",
  "芄": "less-than-common",
  "芅": "less-than-common",
  "芆": "rarely-used",
  "芇": "rarely-used",
  "芉": "rarely-used",
  "芊": "less-than-common",
  "芋": "common",
  "芍": "common",
  "芎": "less-than-common",
  "芏": "less-than-common",
  "芐": "less-than-common",
  "芑": "less-than-common",
  "芒": "common",
  "芓": "less-than-common",
  "芔": "less-than-common",
  "芖": "rarely-used",
  "芘": "less-than-common",
  "芙": "common",
  "芚": "less-than-common",
  "芛": "less-than-common",
  "芜": "rarely-used",
  "芝": "common",
  "芞": "less-than-common",
  "芟": "common",
  "芠": "less-than-common",
  "芡": "less-than-common",
  "芢": "rarely-used",
  "芣": "less-than-common",
  "芤": "rarely-used",
  "芥": "common",
  "芧": "less-than-common",
  "芨": "less-than-common",
  "芩": "less-than-common",
  "芪": "rarely-used",
  "芫": "less-than-common",
  "芬": "common",
  "芭": "common",
  "芮": "less-than-common",
  "芯": "less-than-common",
  "芰": "less-than-common",
  "花": "common",
  "芳": "common",
  "芴": "less-than-common",
  "芵": "less-than-common",
  "芶": "rarely-used",
  "芷": "less-than-common",
  "芸": "less-than-common",
  "芹": "common",
  "芺": "less-than-common",
  "芻": "common",
  "芼": "less-than-common",
  "芽": "common",
  "芾": "less-than-common",
  "芿": "rarely-used",
  "苀": "less-than-common",
  "苂": "rarely-used",
  "苃": "rarely-used",
  "苄": "rarely-used",
  "苉": "rarely-used",
  "苊": "rarely-used",
  "苑": "common",
  "苒": "common",
  "苓": "common",
  "苔": "common",
  "苕": "less-than-common",
  "苖": "less-than-common",
  "苗": "common",
  "苘": "rarely-used",
  "苙": "less-than-common",
  "苚": "rarely-used",
  "苛": "common",
  "苜": "common",
  "苝": "rarely-used",
  "苞": "common",
  "苟": "common",
  "苠": "rarely-used",
  "苡": "less-than-common",
  "苣": "common",
  "苤": "rarely-used",
  "若": "common",
  "苦": "common",
  "苧": "common",
  "苨": "less-than-common",
  "苩": "rarely-used",
  "苪": "rarely-used",
  "苫": "less-than-common",
  "苬": "less-than-common",
  "苭": "rarely-used",
  "苮": "rarely-used",
  "苯": "less-than-common",
  "苰": "rarely-used",
  "英": "common",
  "苲": "less-than-common",
  "苳": "rarely-used",
  "苴": "less-than-common",
  "苵": "less-than-common",
  "苶": "less-than-common",
  "苷": "rarely-used",
  "苸": "rarely-used",
  "苹": "less-than-common",
  "苺": "rarely-used",
  "苻": "less-than-common",
  "苼": "rarely-used",
  "苾": "less-than-common",
  "茀": "less-than-common",
  "茁": "common",
  "茂": "common",
  "范": "common",
  "茄": "common",
  "茅": "common",
  "茆": "less-than-common",
  "茇": "less-than-common",
  "茈": "less-than-common",
  "茉": "common",
  "茌": "less-than-common",
  "茍": "less-than-common",
  "茖": "less-than-common",
  "茗": "common",
  "茙": "less-than-common",
  "茚": "rarely-used",
  "茛": "less-than-common",
  "茜": "less-than-common",
  "茝": "rarely-used",
  "茞": "rarely-used",
  "茟": "rarely-used",
  "茠": "less-than-common",
  "茢": "less-than-common",
  "茤": "less-than-common",
  "茥": "less-than-common",
  "茦": "less-than-common",
  "茧": "rarely-used",
  "茨": "less-than-common",
  "茩": "less-than-common",
  "茪": "less-than-common",
  "茫": "common",
  "茬": "rarely-used",
  "茭": "less-than-common",
  "茮": "rarely-used",
  "茯": "less-than-common",
  "茱": "common",
  "茲": "common",
  "茳": "less-than-common",
  "茴": "common",
  "茵": "common",
  "茶": "common",
  "茷": "less-than-common",
  "茸": "common",
  "茹": "common",
  "茺": "less-than-common",
  "茻": "less-than-common",
  "茼": "less-than-common",
  "茽": "rarely-used",
  "茾": "rarely-used",
  "茿": "less-than-common",
  "荀": "common",
  "荁": "less-than-common",
  "荂": "less-than-common",
  "荃": "less-than-common",
  "荄": "less-than-common",
  "荅": "less-than-common",
  "荇": "less-than-common",
  "荈": "rarely-used",
  "草": "common",
  "荊": "common",
  "荋": "rarely-used",
  "荌": "rarely-used",
  "荍": "less-than-common",
  "荎": "less-than-common",
  "荏": "common",
  "荐": "common",
  "荑": "less-than-common",
  "荒": "common",
  "荓": "rarely-used",
  "荔": "common",
  "荕": "rarely-used",
  "荖": "less-than-common",
  "荗": "rarely-used",
  "荰": "rarely-used",
  "荱": "rarely-used",
  "荲": "rarely-used",
  "荳": "less-than-common",
  "荴": "less-than-common",
  "荵": "less-than-common",
  "荶": "rarely-used",
  "荷": "common",
  "荸": "common",
  "荹": "rarely-used",
  "荺": "less-than-common",
  "荻": "common",
  "荼": "common",
  "荽": "less-than-common",
  "荾": "less-than-common",
  "荿": "rarely-used",
  "莀": "rarely-used",
  "莁": "less-than-common",
  "莂": "rarely-used",
  "莃": "less-than-common",
  "莄": "rarely-used",
  "莆": "less-than-common",
  "莇": "rarely-used",
  "莈": "rarely-used",
  "莉": "common",
  "莊": "common",
  "莋": "less-than-common",
  "莌": "less-than-common",
  "莍": "less-than-common",
  "莎": "common",
  "莏": "less-than-common",
  "莐": "less-than-common",
  "莑": "rarely-used",
  "莒": "common",
  "莓": "common",
  "莔": "less-than-common",
  "莕": "less-than-common",
  "莖": "common",
  "莗": "rarely-used",
  "莘": "common",
  "莙": "less-than-common",
  "莚": "rarely-used",
  "莛": "less-than-common",
  "莝": "less-than-common",
  "莞": "common",
  "莟": "rarely-used",
  "莠": "common",
  "莡": "rarely-used",
  "莢": "common",
  "莣": "less-than-common",
  "莤": "less-than-common",
  "莥": "less-than-common",
  "莦": "rarely-used",
  "莧": "less-than-common",
  "莨": "less-than-common",
  "莩": "less-than-common",
  "莪": "less-than-common",
  "莫": "common",
  "莬": "rarely-used",
  "莭": "rarely-used",
  "莮": "rarely-used",
  "莯": "rarely-used",
  "莰": "rarely-used",
  "莽": "common",
  "莿": "less-than-common",
  "菀": "less-than-common",
  "菁": "common",
  "菂": "less-than-common",
  "菃": "rarely-used",
  "菄": "rarely-used",
  "菅": "common",
  "菆": "less-than-common",
  "菇": "less-than-common",
  "菈": "less-than-common",
  "菉": "less-than-common",
  "菊": "common",
  "菋": "less-than-common",
  "菌": "common",
  "菎": "less-than-common",
  "菏": "less-than-common",
  "菐": "rarely-used",
  "菑": "less-than-common",
  "菒": "rarely-used",
  "菔": "less-than-common",
  "菕": "less-than-common",
  "菖": "less-than-common",
  "菗": "rarely-used",
  "菘": "less-than-common",
  "菙": "less-than-common",
  "菚": "rarely-used",
  "菛": "rarely-used",
  "菜": "common",
  "菝": "less-than-common",
  "菞": "less-than-common",
  "菟": "less-than-common",
  "菠": "common",
  "菡": "less-than-common",
  "菢": "rarely-used",
  "菣": "less-than-common",
  "菤": "less-than-common",
  "菥": "less-than-common",
  "菧": "less-than-common",
  "菨": "less-than-common",
  "菩": "common",
  "菪": "rarely-used",
  "菫": "less-than-common",
  "菬": "rarely-used",
  "菭": "rarely-used",
  "菮": "rarely-used",
  "華": "common",
  "菰": "common",
  "菱": "common",
  "菲": "common",
  "菳": "less-than-common",
  "菴": "common",
  "菵": "less-than-common",
  "菶": "less-than-common",
  "菸": "common",
  "菹": "less-than-common",
  "菺": "less-than-common",
  "菻": "rarely-used",
  "菼": "less-than-common",
  "菽": "common",
  "菾": "rarely-used",
  "菿": "less-than-common",
  "萀": "rarely-used",
  "萁": "less-than-common",
  "萃": "common",
  "萄": "common",
  "萆": "less-than-common",
  "萇": "less-than-common",
  "萈": "rarely-used",
  "萉": "less-than-common",
  "萊": "common",
  "萋": "common",
  "萌": "common",
  "萍": "common",
  "萎": "common",
  "萏": "less-than-common",
  "萐": "less-than-common",
  "萑": "less-than-common",
  "萓": "rarely-used",
  "萘": "rarely-used",
  "萛": "rarely-used",
  "萣": "less-than-common",
  "萩": "less-than-common",
  "萪": "rarely-used",
  "萫": "rarely-used",
  "萬": "common",
  "萭": "less-than-common",
  "萮": "rarely-used",
  "萯": "less-than-common",
  "萰": "less-than-common",
  "萱": "common",
  "萲": "less-than-common",
  "萳": "rarely-used",
  "萴": "less-than-common",
  "萵": "common",
  "萶": "rarely-used",
  "萷": "less-than-common",
  "萸": "common",
  "萹": "less-than-common",
  "萺": "less-than-common",
  "萻": "rarely-used",
  "萼": "common",
  "落": "common",
  "萿": "less-than-common",
  "葀": "less-than-common",
  "葂": "less-than-common",
  "葃": "less-than-common",
  "葄": "rarely-used",
  "葅": "less-than-common",
  "葆": "less-than-common",
  "葇": "rarely-used",
  "葈": "rarely-used",
  "葉": "common",
  "葋": "less-than-common",
  "葌": "less-than-common",
  "葍": "less-than-common",
  "葎": "less-than-common",
  "葏": "rarely-used",
  "葐": "rarely-used",
  "葑": "less-than-common",
  "葒": "less-than-common",
  "葔": "rarely-used",
  "葖": "less-than-common",
  "著": "common",
  "葙": "less-than-common",
  "葚": "less-than-common",
  "葛": "common",
  "葜": "rarely-used",
  "葝": "less-than-common",
  "葞": "less-than-common",
  "葟": "less-than-common",
  "葠": "rarely-used",
  "葡": "common",
  "董": "common",
  "葤": "rarely-used",
  "葥": "less-than-common",
  "葦": "common",
  "葧": "less-than-common",
  "葨": "rarely-used",
  "葩": "common",
  "葪": "rarely-used",
  "葫": "common",
  "葬": "common",
  "葭": "less-than-common",
  "葮": "rarely-used",
  "葯": "less-than-common",
  "葰": "less-than-common",
  "葲": "rarely-used",
  "葳": "less-than-common",
  "葴": "less-than-common",
  "葵": "common",
  "葶": "less-than-common",
  "葷": "common",
  "葸": "less-than-common",
  "葹": "less-than-common",
  "葺": "less-than-common",
  "葻": "rarely-used",
  "葼": "rarely-used",
  "葽": "less-than-common",
  "葾": "rarely-used",
  "葿": "rarely-used",
  "蒁": "rarely-used",
  "蒂": "common",
  "蒄": "rarely-used",
  "蒈": "rarely-used",
  "蒍": "less-than-common",
  "蒎": "rarely-used",
  "蒐": "common",
  "蒑": "rarely-used",
  "蒒": "rarely-used",
  "蒔": "less-than-common",
  "蒕": "rarely-used",
  "蒖": "rarely-used",
  "蒗": "less-than-common",
  "蒘": "less-than-common",
  "蒙": "common",
  "蒚": "less-than-common",
  "蒛": "less-than-common",
  "蒜": "common",
  "蒝": "less-than-common",
  "蒞": "common",
  "蒟": "less-than-common",
  "蒠": "less-than-common",
  "蒡": "less-than-common",
  "蒢": "less-than-common",
  "蒣": "rarely-used",
  "蒤": "less-than-common",
  "蒥": "rarely-used",
  "蒧": "less-than-common",
  "蒨": "less-than-common",
  "蒩": "less-than-common",
  "蒪": "less-than-common",
  "蒫": "less-than-common",
  "蒬": "less-than-common",
  "蒮": "less-than-common",
  "蒯": "less-than-common",
  "蒰": "rarely-used",
  "蒱": "less-than-common",
  "蒲": "common",
  "蒳": "rarely-used",
  "蒴": "less-than-common",
  "蒵": "rarely-used",
  "蒶": "less-than-common",
  "蒸": "common",
  "蒹": "less-than-common",
  "蒺": "less-than-common",
  "蒻": "less-than-common",
  "蒼": "common",
  "蒽": "rarely-used",
  "蒾": "rarely-used",
  "蒿": "common",
  "蓀": "common",
  "蓁": "less-than-common",
  "蓂": "less-than-common",
  "蓃": "rarely-used",
  "蓄": "common",
  "蓅": "rarely-used",
  "蓆": "common",
  "蓇": "less-than-common",
  "蓉": "common",
  "蓊": "less-than-common",
  "蓋": "common",
  "蓌": "less-than-common",
  "蓍": "less-than-common",
  "蓎": "less-than-common",
  "蓏": "less-than-common",
  "蓐": "less-than-common",
  "蓑": "less-than-common",
  "蓒": "rarely-used",
  "蓓": "common",
  "蓔": "rarely-used",
  "蓖": "less-than-common",
  "蓗": "rarely-used",
  "蓛": "rarely-used",
  "蓧": "less-than-common",
  "蓨": "less-than-common",
  "蓩": "less-than-common",
  "蓪": "less-than-common",
  "蓫": "less-than-common",
  "蓬": "common",
  "蓮": "common",
  "蓯": "less-than-common",
  "蓰": "less-than-common",
  "蓱": "less-than-common",
  "蓲": "less-than-common",
  "蓳": "less-than-common",
  "蓴": "less-than-common",
  "蓵": "rarely-used",
  "蓶": "less-than-common",
  "蓷": "less-than-common",
  "蓸": "rarely-used",
  "蓹": "less-than-common",
  "蓺": "less-than-common",
  "蓻": "less-than-common",
  "蓼": "less-than-common",
  "蓽": "less-than-common",
  "蓾": "less-than-common",
  "蓿": "common",
  "蔀": "less-than-common",
  "蔁": "rarely-used",
  "蔂": "less-than-common",
  "蔃": "rarely-used",
  "蔄": "rarely-used",
  "蔆": "less-than-common",
  "蔇": "less-than-common",
  "蔈": "less-than-common",
  "蔉": "less-than-common",
  "蔊": "less-than-common",
  "蔋": "rarely-used",
  "蔌": "less-than-common",
  "蔍": "less-than-common",
  "蔎": "less-than-common",
  "蔏": "less-than-common",
  "蔑": "common",
  "蔒": "less-than-common",
  "蔓": "common",
  "蔔": "common",
  "蔕": "less-than-common",
  "蔖": "less-than-common",
  "蔗": "common",
  "蔘": "less-than-common",
  "蔙": "rarely-used",
  "蔚": "common",
  "蔛": "rarely-used",
  "蔜": "less-than-common",
  "蔝": "less-than-common",
  "蔞": "less-than-common",
  "蔟": "less-than-common",
  "蔠": "less-than-common",
  "蔡": "common",
  "蔢": "rarely-used",
  "蔣": "common",
  "蔤": "less-than-common",
  "蔥": "common",
  "蔦": "less-than-common",
  "蔧": "less-than-common",
  "蔨": "less-than-common",
  "蔩": "less-than-common",
  "蔪": "less-than-common",
  "蔫": "less-than-common",
  "蔬": "common",
  "蔭": "common",
  "蔮": "less-than-common",
  "蔯": "rarely-used",
  "蔰": "less-than-common",
  "蔱": "less-than-common",
  "蔸": "rarely-used",
  "蔻": "less-than-common",
  "蔽": "common",
  "蔾": "less-than-common",
  "蕀": "less-than-common",
  "蕁": "less-than-common",
  "蕂": "rarely-used",
  "蕃": "common",
  "蕄": "less-than-common",
  "蕅": "less-than-common",
  "蕆": "less-than-common",
  "蕇": "less-than-common",
  "蕈": "common",
  "蕉": "common",
  "蕊": "common",
  "蕌": "rarely-used",
  "蕍": "less-than-common",
  "蕎": "less-than-common",
  "蕑": "less-than-common",
  "蕒": "rarely-used",
  "蕓": "less-than-common",
  "蕔": "rarely-used",
  "蕕": "less-than-common",
  "蕖": "less-than-common",
  "蕗": "less-than-common",
  "蕘": "less-than-common",
  "蕙": "common",
  "蕛": "less-than-common",
  "蕜": "rarely-used",
  "蕝": "less-than-common",
  "蕞": "less-than-common",
  "蕠": "less-than-common",
  "蕡": "less-than-common",
  "蕢": "less-than-common",
  "蕣": "less-than-common",
  "蕤": "less-than-common",
  "蕥": "rarely-used",
  "蕦": "less-than-common",
  "蕧": "less-than-common",
  "蕨": "common",
  "蕩": "common",
  "蕪": "common",
  "蕫": "less-than-common",
  "蕬": "rarely-used",
  "蕭": "common",
  "蕮": "less-than-common",
  "蕯": "rarely-used",
  "蕱": "less-than-common",
  "蕵": "less-than-common",
  "蕶": "rarely-used",
  "蕷": "less-than-common",
  "蕸": "less-than-common",
  "蕹": "rarely-used",
  "蕺": "less-than-common",
  "蕻": "less-than-common",
  "蕼": "less-than-common",
  "蕽": "rarely-used",
  "蕾": "common",
  "薀": "less-than-common",
  "薁": "less-than-common",
  "薂": "less-than-common",
  "薃": "less-than-common",
  "薄": "common",
  "薅": "less-than-common",
  "薆": "less-than-common",
  "薇": "common",
  "薈": "less-than-common",
  "薉": "less-than-common",
  "薊": "less-than-common",
  "薋": "less-than-common",
  "薌": "less-than-common",
  "薍": "less-than-common",
  "薎": "less-than-common",
  "薏": "less-than-common",
  "薐": "rarely-used",
  "薑": "common",
  "薒": "rarely-used",
  "薔": "common",
  "薕": "less-than-common",
  "薖": "less-than-common",
  "薘": "rarely-used",
  "薙": "less-than-common",
  "薚": "less-than-common",
  "薛": "common",
  "薜": "common",
  "薝": "less-than-common",
  "薞": "less-than-common",
  "薟": "rarely-used",
  "薠": "less-than-common",
  "薡": "less-than-common",
  "薢": "less-than-common",
  "薣": "less-than-common",
  "薤": "less-than-common",
  "薥": "rarely-used",
  "薧": "less-than-common",
  "薨": "less-than-common",
  "薩": "common",
  "薪": "common",
  "薯": "common",
  "薰": "common",
  "薱": "less-than-common",
  "薳": "less-than-common",
  "薴": "less-than-common",
  "薵": "less-than-common",
  "薶": "less-than-common",
  "薷": "rarely-used",
  "薸": "rarely-used",
  "薹": "less-than-common",
  "薺": "less-than-common",
  "薽": "less-than-common",
  "薾": "rarely-used",
  "薿": "less-than-common",
  "藀": "less-than-common",
  "藂": "less-than-common",
  "藃": "less-than-common",
  "藄": "less-than-common",
  "藅": "less-than-common",
  "藆": "less-than-common",
  "藇": "less-than-common",
  "藈": "less-than-common",
  "藉": "common",
  "藊": "rarely-used",
  "藋": "less-than-common",
  "藍": "common",
  "藎": "less-than-common",
  "藏": "common",
  "藐": "common",
  "藑": "less-than-common",
  "藒": "less-than-common",
  "藕": "common",
  "藖": "rarely-used",
  "藗": "less-than-common",
  "藘": "less-than-common",
  "藙": "less-than-common",
  "藚": "less-than-common",
  "藛": "rarely-used",
  "藜": "less-than-common",
  "藝": "common",
  "藞": "rarely-used",
  "藟": "less-than-common",
  "藠": "rarely-used",
  "藡": "less-than-common",
  "藢": "rarely-used",
  "藣": "less-than-common",
  "藤": "common",
  "藥": "common",
  "藦": "rarely-used",
  "藧": "rarely-used",
  "藨": "less-than-common",
  "藩": "common",
  "藪": "common",
  "藫": "less-than-common",
  "藬": "less-than-common",
  "藭": "less-than-common",
  "藯": "rarely-used",
  "藰": "less-than-common",
  "藱": "less-than-common",
  "藲": "less-than-common",
  "藶": "less-than-common",
  "藷": "less-than-common",
  "藸": "less-than-common",
  "藹": "common",
  "藺": "common",
  "藻": "common",
  "藽": "rarely-used",
  "藾": "less-than-common",
  "藿": "less-than-common",
  "蘀": "less-than-common",
  "蘁": "less-than-common",
  "蘄": "less-than-common",
  "蘅": "less-than-common",
  "蘆": "common",
  "蘇": "common",
  "蘉": "less-than-common",
  "蘊": "common",
  "蘋": "common",
  "蘌": "less-than-common",
  "蘑": "common",
  "蘗": "common",
  "蘘": "less-than-common",
  "蘙": "less-than-common",
  "蘚": "common",
  "蘛": "less-than-common",
  "蘜": "less-than-common",
  "蘞": "less-than-common",
  "蘟": "less-than-common",
  "蘠": "less-than-common",
  "蘡": "less-than-common",
  "蘢": "less-than-common",
  "蘣": "less-than-common",
  "蘤": "less-than-common",
  "蘥": "less-than-common",
  "蘦": "less-than-common",
  "蘧": "less-than-common",
  "蘩": "less-than-common",
  "蘪": "less-than-common",
  "蘫": "rarely-used",
  "蘬": "less-than-common",
  "蘭": "common",
  "蘮": "less-than-common",
  "蘱": "less-than-common",
  "蘲": "rarely-used",
  "蘳": "less-than-common",
  "蘴": "less-than-common",
  "蘵": "less-than-common",
  "蘶": "rarely-used",
  "蘸": "common",
  "蘹": "less-than-common",
  "蘺": "less-than-common",
  "蘻": "less-than-common",
  "蘼": "less-than-common",
  "蘽": "rarely-used",
  "蘾": "less-than-common",
  "蘿": "common",
  "虀": "less-than-common",
  "虂": "rarely-used",
  "虃": "less-than-common",
  "虆": "less-than-common",
  "虇": "less-than-common",
  "虈": "less-than-common",
  "虋": "less-than-common",
  "虌": "less-than-common",
  "虍": "rarely-used",
  "虎": "common",
  "虐": "common",
  "虑": "rarely-used",
  "虒": "less-than-common",
  "虓": "less-than-common",
  "虔": "common",
  "處": "common",
  "虖": "less-than-common",
  "虘": "rarely-used",
  "虙": "less-than-common",
  "虛": "common",
  "虜": "common",
  "虞": "common",
  "號": "common",
  "虠": "rarely-used",
  "虡": "less-than-common",
  "虢": "less-than-common",
  "虣": "less-than-common",
  "虤": "rarely-used",
  "虥": "rarely-used",
  "虧": "common",
  "虨": "rarely-used",
  "虩": "less-than-common",
  "虪": "less-than-common",
  "虫": "common",
  "虭": "less-than-common",
  "虮": "less-than-common",
  "虯": "less-than-common",
  "虰": "less-than-common",
  "虱": "common",
  "虳": "rarely-used",
  "虴": "less-than-common",
  "虶": "rarely-used",
  "虷": "less-than-common",
  "虸": "rarely-used",
  "虹": "common",
  "虺": "less-than-common",
  "虻": "less-than-common",
  "虼": "rarely-used",
  "蚄": "rarely-used",
  "蚅": "less-than-common",
  "蚆": "less-than-common",
  "蚇": "less-than-common",
  "蚈": "rarely-used",
  "蚊": "common",
  "蚋": "less-than-common",
  "蚌": "common",
  "蚍": "less-than-common",
  "蚎": "rarely-used",
  "蚐": "rarely-used",
  "蚑": "less-than-common",
  "蚓": "common",
  "蚔": "rarely-used",
  "蚕": "less-than-common",
  "蚖": "less-than-common",
  "蚗": "less-than-common",
  "蚘": "rarely-used",
  "蚙": "less-than-common",
  "蚚": "less-than-common",
  "蚛": "rarely-used",
  "蚜": "less-than-common",
  "蚝": "rarely-used",
  "蚞": "less-than-common",
  "蚟": "rarely-used",
  "蚡": "less-than-common",
  "蚢": "less-than-common",
  "蚣": "common",
  "蚤": "common",
  "蚥": "less-than-common",
  "蚧": "less-than-common",
  "蚨": "less-than-common",
  "蚩": "common",
  "蚪": "common",
  "蚭": "rarely-used",
  "蚮": "rarely-used",
  "蚯": "common",
  "蚰": "less-than-common",
  "蚱": "common",
  "蚲": "rarely-used",
  "蚳": "less-than-common",
  "蚴": "less-than-common",
  "蚵": "common",
  "蚶": "common",
  "蚷": "less-than-common",
  "蚸": "less-than-common",
  "蚹": "less-than-common",
  "蚺": "less-than-common",
  "蚻": "less-than-common",
  "蚼": "less-than-common",
  "蚽": "rarely-used",
  "蚾": "rarely-used",
  "蚿": "less-than-common",
  "蛀": "common",
  "蛁": "less-than-common",
  "蛂": "less-than-common",
  "蛃": "rarely-used",
  "蛄": "common",
  "蛅": "less-than-common",
  "蛆": "common",
  "蛇": "common",
  "蛈": "less-than-common",
  "蛉": "less-than-common",
  "蛋": "common",
  "蛌": "less-than-common",
  "蛐": "less-than-common",
  "蛑": "rarely-used",
  "蛒": "rarely-used",
  "蛓": "less-than-common",
  "蛔": "common",
  "蛕": "rarely-used",
  "蛖": "less-than-common",
  "蛗": "less-than-common",
  "蛘": "less-than-common",
  "蛙": "common",
  "蛚": "less-than-common",
  "蛛": "common",
  "蛜": "less-than-common",
  "蛝": "less-than-common",
  "蛞": "less-than-common",
  "蛟": "common",
  "蛡": "rarely-used",
  "蛢": "less-than-common",
  "蛣": "less-than-common",
  "蛤": "common",
  "蛥": "rarely-used",
  "蛦": "less-than-common",
  "蛧": "rarely-used",
  "蛨": "rarely-used",
  "蛩": "less-than-common",
  "蛪": "less-than-common",
  "蛫": "less-than-common",
  "蛬": "less-than-common",
  "蛭": "common",
  "蛵": "less-than-common",
  "蛶": "less-than-common",
  "蛷": "less-than-common",
  "蛸": "less-than-common",
  "蛹": "common",
  "蛺": "less-than-common",
  "蛻": "common",
  "蛼": "rarely-used",
  "蛽": "rarely-used",
  "蛾": "common",
  "蜀": "common",
  "蜁": "less-than-common",
  "蜂": "common",
  "蜃": "common",
  "蜄": "less-than-common",
  "蜅": "rarely-used",
  "蜆": "less-than-common",
  "蜇": "common",
  "蜈": "common",
  "蜉": "less-than-common",
  "蜊": "less-than-common",
  "蜋": "less-than-common",
  "蜌": "less-than-common",
  "蜍": "less-than-common",
  "蜎": "less-than-common",
  "蜏": "rarely-used",
  "蜐": "rarely-used",
  "蜑": "less-than-common",
  "蜒": "less-than-common",
  "蜓": "common",
  "蜔": "rarely-used",
  "蜘": "common",
  "蜙": "less-than-common",
  "蜚": "less-than-common",
  "蜛": "less-than-common",
  "蜜": "common",
  "蜞": "less-than-common",
  "蜟": "rarely-used",
  "蜠": "less-than-common",
  "蜡": "less-than-common",
  "蜢": "common",
  "蜣": "less-than-common",
  "蜤": "less-than-common",
  "蜥": "common",
  "蜦": "less-than-common",
  "蜧": "less-than-common",
  "蜨": "less-than-common",
  "蜩": "less-than-common",
  "蜪": "less-than-common",
  "蜬": "less-than-common",
  "蜭": "less-than-common",
  "蜮": "less-than-common",
  "蜰": "less-than-common",
  "蜱": "less-than-common",
  "蜲": "less-than-common",
  "蜳": "less-than-common",
  "蜴": "common",
  "蜵": "less-than-common",
  "蜶": "rarely-used",
  "蜷": "less-than-common",
  "蜸": "less-than-common",
  "蜺": "less-than-common",
  "蜻": "common",
  "蜼": "less-than-common",
  "蜾": "less-than-common",
  "蜿": "common",
  "蝀": "less-than-common",
  "蝁": "less-than-common",
  "蝂": "less-than-common",
  "蝃": "less-than-common",
  "蝆": "less-than-common",
  "蝌": "common",
  "蝍": "less-than-common",
  "蝎": "less-than-common",
  "蝏": "rarely-used",
  "蝐": "less-than-common",
  "蝑": "less-than-common",
  "蝒": "less-than-common",
  "蝓": "less-than-common",
  "蝔": "less-than-common",
  "蝕": "common",
  "蝖": "less-than-common",
  "蝗": "common",
  "蝘": "less-than-common",
  "蝙": "common",
  "蝚": "less-than-common",
  "蝛": "less-than-common",
  "蝜": "less-than-common",
  "蝝": "less-than-common",
  "蝞": "less-than-common",
  "蝟": "less-than-common",
  "蝠": "common",
  "蝡": "less-than-common",
  "蝢": "rarely-used",
  "蝣": "less-than-common",
  "蝤": "less-than-common",
  "蝥": "less-than-common",
  "蝦": "common",
  "蝧": "rarely-used",
  "蝨": "common",
  "蝩": "rarely-used",
  "蝪": "less-than-common",
  "蝫": "less-than-common",
  "蝬": "less-than-common",
  "蝭": "less-than-common",
  "蝮": "less-than-common",
  "蝯": "less-than-common",
  "蝰": "rarely-used",
  "蝲": "rarely-used",
  "蝳": "less-than-common",
  "蝴": "common",
  "蝵": "rarely-used",
  "蝶": "common",
  "蝷": "less-than-common",
  "蝸": "common",
  "蝹": "less-than-common",
  "蝺": "less-than-common",
  "蝻": "rarely-used",
  "螁": "less-than-common",
  "螂": "common",
  "螃": "common",
  "螄": "less-than-common",
  "螅": "less-than-common",
  "螆": "rarely-used",
  "螇": "less-than-common",
  "螈": "less-than-common",
  "螉": "rarely-used",
  "螊": "rarely-used",
  "螋": "rarely-used",
  "螌": "rarely-used",
  "融": "common",
  "螏": "less-than-common",
  "螐": "less-than-common",
  "螑": "less-than-common",
  "螒": "less-than-common",
  "螓": "less-than-common",
  "螔": "less-than-common",
  "螕": "rarely-used",
  "螖": "less-than-common",
  "螗": "less-than-common",
  "螘": "less-than-common",
  "螚": "less-than-common",
  "螛": "less-than-common",
  "螜": "less-than-common",
  "螝": "less-than-common",
  "螞": "common",
  "螟": "common",
  "螠": "rarely-used",
  "螢": "common",
  "螣": "less-than-common",
  "螤": "less-than-common",
  "螪": "less-than-common",
  "螫": "common",
  "螬": "less-than-common",
  "螭": "less-than-common",
  "螮": "less-than-common",
  "螯": "less-than-common",
  "螰": "less-than-common",
  "螲": "rarely-used",
  "螳": "common",
  "螴": "less-than-common",
  "螵": "less-than-common",
  "螶": "less-than-common",
  "螷": "less-than-common",
  "螸": "less-than-common",
  "螹": "less-than-common",
  "螺": "common",
  "螻": "common",
  "螼": "less-than-common",
  "螽": "less-than-common",
  "螾": "less-than-common",
  "螿": "less-than-common",
  "蟀": "common",
  "蟂": "less-than-common",
  "蟃": "less-than-common",
  "蟄": "less-than-common",
  "蟅": "less-than-common",
  "蟆": "common",
  "蟈": "common",
  "蟉": "less-than-common",
  "蟊": "less-than-common",
  "蟋": "common",
  "蟌": "less-than-common",
  "蟎": "rarely-used",
  "蟑": "common",
  "蟒": "common",
  "蟓": "less-than-common",
  "蟔": "less-than-common",
  "蟕": "rarely-used",
  "蟗": "less-than-common",
  "蟘": "less-than-common",
  "蟙": "less-than-common",
  "蟛": "less-than-common",
  "蟜": "less-than-common",
  "蟝": "rarely-used",
  "蟞": "less-than-common",
  "蟟": "less-than-common",
  "蟠": "less-than-common",
  "蟡": "less-than-common",
  "蟢": "less-than-common",
  "蟣": "less-than-common",
  "蟤": "less-than-common",
  "蟥": "less-than-common",
  "蟦": "less-than-common",
  "蟧": "less-than-common",
  "蟨": "less-than-common",
  "蟩": "rarely-used",
  "蟪": "less-than-common",
  "蟫": "less-than-common",
  "蟬": "common",
  "蟭": "less-than-common",
  "蟯": "common",
  "蟱": "rarely-used",
  "蟲": "common",
  "蟳": "less-than-common",
  "蟴": "less-than-common",
  "蟶": "less-than-common",
  "蟷": "less-than-common",
  "蟹": "common",
  "蟺": "less-than-common",
  "蟻": "common",
  "蟼": "less-than-common",
  "蟽": "rarely-used",
  "蟾": "less-than-common",
  "蟿": "less-than-common",
  "蠀": "less-than-common",
  "蠁": "less-than-common",
  "蠂": "rarely-used",
  "蠃": "less-than-common",
  "蠄": "rarely-used",
  "蠅": "common",
  "蠆": "less-than-common",
  "蠈": "less-than-common",
  "蠉": "less-than-common",
  "蠊": "rarely-used",
  "蠋": "less-than-common",
  "蠌": "less-than-common",
  "蠍": "common",
  "蠐": "less-than-common",
  "蠑": "less-than-common",
  "蠓": "less-than-common",
  "蠔": "common",
  "蠕": "common",
  "蠖": "less-than-common",
  "蠗": "less-than-common",
  "蠘": "rarely-used",
  "蠙": "less-than-common",
  "蠚": "rarely-used",
  "蠛": "less-than-common",
  "蠜": "less-than-common",
  "蠝": "less-than-common",
  "蠞": "rarely-used",
  "蠟": "common",
  "蠠": "less-than-common",
  "蠡": "common",
  "蠢": "common",
  "蠣": "common",
  "蠤": "less-than-common",
  "蠥": "less-than-common",
  "蠦": "less-than-common",
  "蠨": "less-than-common",
  "蠩": "less-than-common",
  "蠪": "less-than-common",
  "蠫": "less-than-common",
  "蠬": "less-than-common",
  "蠮": "less-than-common",
  "蠯": "less-than-common",
  "蠰": "less-than-common",
  "蠱": "common",
  "蠲": "less-than-common",
  "蠳": "less-than-common",
  "蠵": "less-than-common",
  "蠶": "common",
  "蠷": "less-than-common",
  "蠸": "less-than-common",
  "蠹": "common",
  "蠻": "common",
  "蠼": "less-than-common",
  "蠽": "less-than-common",
  "蠾": "less-than-common",
  "蠿": "less-than-common",
  "血": "common",
  "衁": "less-than-common",
  "衃": "less-than-common",
  "衄": "less-than-common",
  "衈": "less-than-common",
  "衊": "less-than-common",
  "衋": "less-than-common",
  "行": "common",
  "衍": "common",
  "衎": "less-than-common",
  "衏": "rarely-used",
  "衑": "rarely-used",
  "衒": "less-than-common",
  "術": "common",
  "衕": "less-than-common",
  "衖": "less-than-common",
  "街": "common",
  "衙": "common",
  "衚": "less-than-common",
  "衛": "common",
  "衝": "common",
  "衠": "rarely-used",
  "衡": "common",
  "衢": "common",
  "衣": "common",
  "衦": "rarely-used",
  "衧": "less-than-common",
  "表": "common",
  "衩": "less-than-common",
  "衪": "less-than-common",
  "衫": "common",
  "衭": "less-than-common",
  "衯": "less-than-common",
  "衰": "common",
  "衱": "less-than-common",
  "衲": "less-than-common",
  "衴": "rarely-used",
  "衵": "less-than-common",
  "衶": "less-than-common",
  "衷": "common",
  "衸": "rarely-used",
  "衹": "less-than-common",
  "衼": "rarely-used",
  "衽": "less-than-common",
  "衾": "less-than-common",
  "衿": "less-than-common",
  "袀": "less-than-common",
  "袁": "common",
  "袂": "common",
  "袃": "less-than-common",
  "袈": "common",
  "袉": "less-than-common",
  "袊": "rarely-used",
  "袋": "common",
  "袌": "less-than-common",
  "袍": "common",
  "袎": "rarely-used",
  "袏": "rarely-used",
  "袑": "less-than-common",
  "袒": "common",
  "袓": "rarely-used",
  "袔": "rarely-used",
  "袕": "less-than-common",
  "袖": "common",
  "袗": "less-than-common",
  "袘": "less-than-common",
  "袙": "less-than-common",
  "袚": "less-than-common",
  "袛": "less-than-common",
  "袜": "rarely-used",
  "袝": "rarely-used",
  "袞": "common",
  "袟": "less-than-common",
  "袡": "less-than-common",
  "袢": "less-than-common",
  "袣": "rarely-used",
  "袤": "less-than-common",
  "袥": "rarely-used",
  "袦": "rarely-used",
  "袧": "less-than-common",
  "袨": "less-than-common",
  "袩": "rarely-used",
  "袪": "less-than-common",
  "被": "common",
  "袬": "less-than-common",
  "袱": "common",
  "袲": "less-than-common",
  "袳": "rarely-used",
  "袶": "less-than-common",
  "袷": "less-than-common",
  "袸": "less-than-common",
  "袹": "less-than-common",
  "袺": "less-than-common",
  "袻": "rarely-used",
  "袼": "less-than-common",
  "袽": "less-than-common",
  "袾": "less-than-common",
  "裀": "less-than-common",
  "裁": "common",
  "裂": "common",
  "裉": "rarely-used",
  "裊": "common",
  "裋": "less-than-common",
  "裌": "rarely-used",
  "裍": "less-than-common",
  "裎": "less-than-common",
  "裐": "rarely-used",
  "裑": "rarely-used",
  "裒": "less-than-common",
  "裓": "rarely-used",
  "裔": "common",
  "裕": "common",
  "裖": "less-than-common",
  "裗": "less-than-common",
  "裘": "common",
  "裙": "common",
  "裚": "less-than-common",
  "裛": "less-than-common",
  "補": "common",
  "裝": "common",
  "裞": "less-than-common",
  "裟": "common",
  "裡": "common",
  "裧": "less-than-common",
  "裨": "common",
  "裪": "rarely-used",
  "裫": "rarely-used",
  "裬": "rarely-used",
  "裮": "less-than-common",
  "裯": "less-than-common",
  "裰": "rarely-used",
  "裱": "less-than-common",
  "裲": "less-than-common",
  "裳": "common",
  "裴": "common",
  "裶": "less-than-common",
  "裷": "less-than-common",
  "裸": "common",
  "裹": "common",
  "裺": "less-than-common",
  "裻": "less-than-common",
  "裼": "less-than-common",
  "製": "common",
  "裾": "less-than-common",
  "裿": "rarely-used",
  "褁": "less-than-common",
  "褂": "common",
  "褅": "less-than-common",
  "褆": "less-than-common",
  "複": "common",
  "褉": "rarely-used",
  "褊": "less-than-common",
  "褋": "less-than-common",
  "褌": "less-than-common",
  "褍": "rarely-used",
  "褎": "less-than-common",
  "褐": "common",
  "褑": "less-than-common",
  "褒": "common",
  "褓": "common",
  "褔": "less-than-common",
  "褕": "less-than-common",
  "褖": "less-than-common",
  "褗": "less-than-common",
  "褘": "less-than-common",
  "褙": "less-than-common",
  "褚": "common",
  "褞": "less-than-common",
  "褟": "rarely-used",
  "褡": "less-than-common",
  "褢": "less-than-common",
  "褣": "rarely-used",
  "褥": "common",
  "褦": "less-than-common",
  "褧": "less-than-common",
  "褨": "rarely-used",
  "褩": "less-than-common",
  "褪": "common",
  "褫": "common",
  "褬": "rarely-used",
  "褭": "less-than-common",
  "褮": "less-than-common",
  "褯": "rarely-used",
  "褰": "less-than-common",
  "褱": "less-than-common",
  "褲": "common",
  "褳": "less-than-common",
  "褵": "less-than-common",
  "褶": "common",
  "褷": "less-than-common",
  "褸": "common",
  "褹": "rarely-used",
  "褺": "rarely-used",
  "褻": "common",
  "褼": "less-than-common",
  "褽": "less-than-common",
  "褾": "less-than-common",
  "褿": "rarely-used",
  "襀": "rarely-used",
  "襁": "less-than-common",
  "襂": "less-than-common",
  "襄": "common",
  "襆": "less-than-common",
  "襈": "rarely-used",
  "襉": "rarely-used",
  "襊": "rarely-used",
  "襋": "less-than-common",
  "襌": "less-than-common",
  "襎": "rarely-used",
  "襏": "less-than-common",
  "襐": "less-than-common",
  "襑": "rarely-used",
  "襒": "less-than-common",
  "襓": "less-than-common",
  "襖": "common",
  "襗": "less-than-common",
  "襘": "less-than-common",
  "襙": "rarely-used",
  "襚": "less-than-common",
  "襛": "less-than-common",
  "襜": "less-than-common",
  "襝": "less-than-common",
  "襞": "less-than-common",
  "襟": "common",
  "襠": "common",
  "襡": "less-than-common",
  "襢": "less-than-common",
  "襣": "less-than-common",
  "襤": "common",
  "襦": "less-than-common",
  "襩": "less-than-common",
  "襪": "common",
  "襫": "rarely-used",
  "襬": "less-than-common",
  "襭": "less-than-common",
  "襮": "less-than-common",
  "襯": "common",
  "襰": "rarely-used",
  "襱": "rarely-used",
  "襲": "common",
  "襳": "less-than-common",
  "襴": "less-than-common",
  "襵": "rarely-used",
  "襶": "less-than-common",
  "襸": "rarely-used",
  "襹": "less-than-common",
  "襺": "less-than-common",
  "襻": "rarely-used",
  "襼": "rarely-used",
  "襾": "less-than-common",
  "西": "common",
  "要": "common",
  "覂": "less-than-common",
  "覃": "common",
  "覅": "less-than-common",
  "覆": "common",
  "覈": "less-than-common",
  "見": "common",
  "覎": "rarely-used",
  "規": "common",
  "覑": "rarely-used",
  "覒": "rarely-used",
  "覓": "common",
  "覕": "less-than-common",
  "視": "common",
  "覗": "rarely-used",
  "覘": "less-than-common",
  "覛": "less-than-common",
  "覜": "less-than-common",
  "覝": "less-than-common",
  "覞": "rarely-used",
  "覟": "rarely-used",
  "覠": "rarely-used",
  "覡": "less-than-common",
  "覢": "less-than-common",
  "覣": "less-than-common",
  "覤": "less-than-common",
  "覦": "common",
  "覨": "rarely-used",
  "親": "common",
  "覫": "rarely-used",
  "覬": "common",
  "覭": "less-than-common",
  "覮": "less-than-common",
  "覯": "less-than-common",
  "覱": "rarely-used",
  "覲": "common",
  "覶": "less-than-common",
  "覷": "less-than-common",
  "覹": "rarely-used",
  "覺": "common",
  "覽": "common",
  "覾": "rarely-used",
  "覿": "less-than-common",
  "觀": "common",
  "角": "common",
  "觓": "less-than-common",
  "觔": "less-than-common",
  "觕": "less-than-common",
  "觖": "less-than-common",
  "觗": "rarely-used",
  "觘": "rarely-used",
  "觙": "less-than-common",
  "觚": "less-than-common",
  "觛": "rarely-used",
  "觜": "less-than-common",
  "觝": "less-than-common",
  "觟": "less-than-common",
  "觠": "less-than-common",
  "觡": "less-than-common",
  "觢": "less-than-common",
  "解": "common",
  "觤": "less-than-common",
  "觥": "less-than-common",
  "触": "rarely-used",
  "觨": "rarely-used",
  "觩": "less-than-common",
  "觪": "rarely-used",
  "觫": "less-than-common",
  "觬": "less-than-common",
  "觭": "less-than-common",
  "觰": "less-than-common",
  "觱": "less-than-common",
  "觲": "less-than-common",
  "觳": "less-than-common",
  "觴": "common",
  "觶": "less-than-common",
  "觷": "less-than-common",
  "觸": "common",
  "觺": "less-than-common",
  "觻": "less-than-common",
  "觼": "less-than-common",
  "觾": "less-than-common",
  "觿": "less-than-common",
  "言": "common",
  "訂": "common",
  "訃": "common",
  "訄": "less-than-common",
  "訅": "rarely-used",
  "訇": "less-than-common",
  "計": "common",
  "訉": "rarely-used",
  "訊": "common",
  "訋": "rarely-used",
  "訌": "common",
  "訍": "rarely-used",
  "討": "common",
  "訏": "less-than-common",
  "訐": "common",
  "訑": "less-than-common",
  "訒": "less-than-common",
  "訓": "common",
  "訔": "rarely-used",
  "訕": "common",
  "訖": "common",
  "託": "common",
  "記": "common",
  "訛": "common",
  "訜": "rarely-used",
  "訝": "common",
  "訞": "less-than-common",
  "訟": "common",
  "訢": "less-than-common",
  "訣": "common",
  "訥": "common",
  "訦": "rarely-used",
  "訧": "less-than-common",
  "訨": "rarely-used",
  "訪": "common",
  "訬": "less-than-common",
  "設": "common",
  "訮": "rarely-used",
  "訯": "rarely-used",
  "訰": "less-than-common",
  "許": "common",
  "訲": "rarely-used",
  "訴": "common",
  "訵": "rarely-used",
  "訶": "less-than-common",
  "訷": "rarely-used",
  "訸": "rarely-used",
  "訹": "less-than-common",
  "診": "common",
  "註": "common",
  "証": "common",
  "訾": "less-than-common",
  "訿": "less-than-common",
  "詀": "less-than-common",
  "詁": "common",
  "詂": "rarely-used",
  "詃": "rarely-used",
  "詄": "less-than-common",
  "詅": "less-than-common",
  "詆": "common",
  "詇": "rarely-used",
  "詈": "less-than-common",
  "詉": "rarely-used",
  "詊": "rarely-used",
  "詌": "rarely-used",
  "詍": "less-than-common",
  "詎": "less-than-common",
  "詏": "rarely-used",
  "詐": "common",
  "詑": "rarely-used",
  "詒": "less-than-common",
  "詓": "rarely-used",
  "詔": "common",
  "評": "common",
  "詖": "less-than-common",
  "詗": "less-than-common",
  "詘": "less-than-common",
  "詙": "less-than-common",
  "詚": "rarely-used",
  "詛": "common",
  "詜": "rarely-used",
  "詞": "common",
  "詠": "common",
  "詡": "less-than-common",
  "詢": "common",
  "詣": "common",
  "詥": "rarely-used",
  "試": "common",
  "詨": "rarely-used",
  "詩": "common",
  "詪": "rarely-used",
  "詫": "common",
  "詬": "common",
  "詭": "common",
  "詮": "common",
  "詯": "rarely-used",
  "詰": "common",
  "話": "common",
  "該": "common",
  "詳": "common",
  "詴": "rarely-used",
  "詵": "less-than-common",
  "詶": "less-than-common",
  "詷": "less-than-common",
  "詹": "common",
  "詺": "rarely-used",
  "詻": "less-than-common",
  "詼": "common",
  "詿": "less-than-common",
  "誀": "rarely-used",
  "誁": "rarely-used",
  "誂": "less-than-common",
  "誃": "less-than-common",
  "誄": "less-than-common",
  "誅": "common",
  "誆": "less-than-common",
  "誇": "common",
  "誋": "less-than-common",
  "誌": "common",
  "認": "common",
  "誎": "rarely-used",
  "誏": "rarely-used",
  "誐": "rarely-used",
  "誑": "common",
  "誒": "less-than-common",
  "誓": "common",
  "誔": "rarely-used",
  "誕": "common",
  "誖": "rarely-used",
  "誗": "rarely-used",
  "誘": "common",
  "誙": "less-than-common",
  "誚": "less-than-common",
  "誛": "rarely-used",
  "誜": "rarely-used",
  "語": "common",
  "誠": "common",
  "誡": "common",
  "誢": "rarely-used",
  "誣": "common",
  "誤": "common",
  "誥": "common",
  "誦": "common",
  "誧": "rarely-used",
  "誨": "common",
  "誩": "rarely-used",
  "說": "common",
  "誫": "less-than-common",
  "誰": "common",
  "誱": "rarely-used",
  "課": "common",
  "誵": "rarely-used",
  "誶": "less-than-common",
  "誷": "rarely-used",
  "誸": "less-than-common",
  "誹": "less-than-common",
  "誺": "rarely-used",
  "誻": "less-than-common",
  "誼": "common",
  "誽": "rarely-used",
  "誾": "less-than-common",
  "調": "common",
  "諀": "less-than-common",
  "諂": "common",
  "諃": "rarely-used",
  "諄": "common",
  "諅": "less-than-common",
  "諆": "less-than-common",
  "談": "common",
  "諈": "less-than-common",
  "諉": "common",
  "請": "common",
  "諌": "rarely-used",
  "諍": "common",
  "諎": "rarely-used",
  "諏": "less-than-common",
  "諑": "less-than-common",
  "諒": "common",
  "諓": "less-than-common",
  "諔": "less-than-common",
  "諕": "less-than-common",
  "論": "common",
  "諗": "less-than-common",
  "諘": "rarely-used",
  "諙": "rarely-used",
  "諛": "less-than-common",
  "諜": "common",
  "諝": "less-than-common",
  "諞": "less-than-common",
  "諟": "less-than-common",
  "諠": "less-than-common",
  "諡": "less-than-common",
  "諢": "less-than-common",
  "諣": "rarely-used",
  "諤": "less-than-common",
  "諥": "rarely-used",
  "諦": "common",
  "諧": "common",
  "諨": "rarely-used",
  "諪": "rarely-used",
  "諫": "common",
  "諭": "common",
  "諮": "common",
  "諯": "rarely-used",
  "諰": "less-than-common",
  "諱": "common",
  "諲": "less-than-common",
  "諳": "less-than-common",
  "諴": "less-than-common",
  "諵": "less-than-common",
  "諶": "less-than-common",
  "諷": "common",
  "諸": "common",
  "諹": "rarely-used",
  "諺": "common",
  "諻": "rarely-used",
  "諼": "less-than-common",
  "諽": "rarely-used",
  "諾": "common",
  "諿": "rarely-used",
  "謀": "common",
  "謁": "common",
  "謂": "common",
  "謄": "common",
  "謅": "less-than-common",
  "謆": "rarely-used",
  "謇": "less-than-common",
  "謈": "less-than-common",
  "謉": "rarely-used",
  "謊": "common",
  "謋": "less-than-common",
  "謍": "less-than-common",
  "謎": "common",
  "謏": "less-than-common",
  "謐": "less-than-common",
  "謑": "less-than-common",
  "謒": "less-than-common",
  "謓": "rarely-used",
  "謔": "less-than-common",
  "謕": "less-than-common",
  "謖": "less-than-common",
  "謗": "common",
  "謘": "less-than-common",
  "謙": "common",
  "謚": "rarely-used",
  "講": "common",
  "謜": "rarely-used",
  "謝": "common",
  "謞": "less-than-common",
  "謟": "rarely-used",
  "謠": "common",
  "謣": "less-than-common",
  "謤": "rarely-used",
  "謥": "less-than-common",
  "謦": "less-than-common",
  "謧": "less-than-common",
  "謨": "common",
  "謪": "less-than-common",
  "謫": "less-than-common",
  "謬": "common",
  "謮": "rarely-used",
  "謯": "less-than-common",
  "謰": "less-than-common",
  "謱": "less-than-common",
  "謲": "rarely-used",
  "謳": "less-than-common",
  "謵": "less-than-common",
  "謶": "rarely-used",
  "謷": "less-than-common",
  "謸": "rarely-used",
  "謹": "common",
  "謺": "rarely-used",
  "謻": "rarely-used",
  "謼": "less-than-common",
  "謽": "rarely-used",
  "謾": "less-than-common",
  "譀": "less-than-common",
  "譁": "common",
  "譂": "rarely-used",
  "譄": "rarely-used",
  "譅": "less-than-common",
  "譆": "less-than-common",
  "譇": "less-than-common",
  "譈": "less-than-common",
  "證": "common",
  "譊": "less-than-common",
  "譋": "less-than-common",
  "譎": "common",
  "譏": "common",
  "譐": "less-than-common",
  "譑": "less-than-common",
  "譒": "rarely-used",
  "譓": "less-than-common",
  "譔": "less-than-common",
  "譕": "less-than-common",
  "譖": "less-than-common",
  "譗": "rarely-used",
  "識": "common",
  "譙": "less-than-common",
  "譚": "common",
  "譜": "common",
  "譝": "less-than-common",
  "譞": "rarely-used",
  "譟": "less-than-common",
  "譠": "less-than-common",
  "譢": "rarely-used",
  "譣": "less-than-common",
  "譥": "less-than-common",
  "警": "common",
  "譧": "rarely-used",
  "譨": "less-than-common",
  "譩": "rarely-used",
  "譪": "less-than-common",
  "譫": "rarely-used",
  "譬": "common",
  "譭": "rarely-used",
  "譮": "rarely-used",
  "譯": "common",
  "議": "common",
  "譳": "rarely-used",
  "譴": "common",
  "譶": "rarely-used",
  "護": "common",
  "譸": "less-than-common",
  "譹": "less-than-common",
  "譺": "less-than-common",
  "譻": "less-than-common",
  "譽": "common",
  "譾": "less-than-common",
  "譿": "rarely-used",
  "讀": "common",
  "讂": "less-than-common",
  "讄": "less-than-common",
  "讅": "rarely-used",
  "讆": "less-than-common",
  "讈": "rarely-used",
  "讉": "rarely-used",
  "變": "common",
  "讋": "less-than-common",
  "讌": "less-than-common",
  "讎": "less-than-common",
  "讑": "rarely-used",
  "讒": "common",
  "讓": "common",
  "讔": "less-than-common",
  "讕": "less-than-common",
  "讖": "common",
  "讗": "rarely-used",
  "讘": "less-than-common",
  "讙": "less-than-common",
  "讚": "common",
  "讜": "less-than-common",
  "讝": "rarely-used",
  "讞": "less-than-common",
  "讟": "less-than-common",
  "谷": "common",
  "谸": "rarely-used",
  "谹": "less-than-common",
  "谻": "less-than-common",
  "谼": "less-than-common",
  "谽": "less-than-common",
  "谾": "less-than-common",
  "谿": "common",
  "豁": "common",
  "豂": "rarely-used",
  "豃": "less-than-common",
  "豅": "rarely-used",
  "豆": "common",
  "豇": "less-than-common",
  "豈": "common",
  "豉": "common",
  "豊": "rarely-used",
  "豋": "less-than-common",
  "豌": "common",
  "豍": "less-than-common",
  "豎": "common",
  "豏": "less-than-common",
  "豐": "common",
  "豔": "common",
  "豕": "common",
  "豖": "rarely-used",
  "豗": "less-than-common",
  "豚": "common",
  "豛": "rarely-used",
  "豜": "less-than-common",
  "豝": "less-than-common",
  "豞": "rarely-used",
  "豟": "less-than-common",
  "豠": "rarely-used",
  "象": "common",
  "豢": "common",
  "豤": "less-than-common",
  "豥": "less-than-common",
  "豦": "less-than-common",
  "豧": "rarely-used",
  "豨": "less-than-common",
  "豩": "rarely-used",
  "豪": "common",
  "豫": "common",
  "豬": "common",
  "豭": "less-than-common",
  "豯": "less-than-common",
  "豰": "less-than-common",
  "豱": "less-than-common",
  "豲": "less-than-common",
  "豳": "less-than-common",
  "豵": "less-than-common",
  "豶": "less-than-common",
  "豷": "less-than-common",
  "豸": "less-than-common",
  "豹": "common",
  "豺": "common",
  "豻": "less-than-common",
  "豽": "less-than-common",
  "豿": "rarely-used",
  "貀": "less-than-common",
  "貁": "less-than-common",
  "貂": "common",
  "貄": "less-than-common",
  "貅": "less-than-common",
  "貆": "less-than-common",
  "貇": "rarely-used",
  "貉": "common",
  "貊": "common",
  "貌": "common",
  "貍": "common",
  "貏": "less-than-common",
  "貐": "rarely-used",
  "貑": "less-than-common",
  "貒": "less-than-common",
  "貓": "common",
  "貔": "less-than-common",
  "貕": "less-than-common",
  "貗": "less-than-common",
  "貘": "less-than-common",
  "貙": "less-than-common",
  "貚": "rarely-used",
  "貜": "less-than-common",
  "貝": "common",
  "貞": "common",
  "負": "common",
  "財": "common",
  "貢": "common",
  "貣": "less-than-common",
  "貤": "less-than-common",
  "貥": "rarely-used",
  "貧": "common",
  "貨": "common",
  "販": "common",
  "貪": "common",
  "貫": "common",
  "責": "common",
  "貯": "common",
  "貰": "less-than-common",
  "貱": "rarely-used",
  "貲": "common",
  "貳": "common",
  "貴": "common",
  "貵": "rarely-used",
  "貶": "common",
  "買": "common",
  "貸": "common",
  "貹": "rarely-used",
  "貺": "less-than-common",
  "費": "common",
  "貼": "common",
  "貽": "common",
  "貾": "less-than-common",
  "貿": "common",
  "賀": "common",
  "賁": "common",
  "賂": "common",
  "賃": "common",
  "賄": "common",
  "賅": "common",
  "賆": "rarely-used",
  "資": "common",
  "賈": "common",
  "賊": "common",
  "賋": "rarely-used",
  "賌": "less-than-common",
  "賏": "rarely-used",
  "賑": "common",
  "賒": "common",
  "賓": "common",
  "賕": "less-than-common",
  "賗": "rarely-used",
  "賙": "less-than-common",
  "賚": "less-than-common",
  "賜": "common",
  "賝": "rarely-used",
  "賞": "common",
  "賟": "less-than-common",
  "賠": "common",
  "賡": "less-than-common",
  "賢": "common",
  "賣": "common",
  "賤": "common",
  "賥": "less-than-common",
  "賦": "common",
  "賧": "rarely-used",
  "賨": "less-than-common",
  "質": "common",
  "賬": "common",
  "賭": "common",
  "賮": "less-than-common",
  "賰": "rarely-used",
  "賱": "rarely-used",
  "賲": "rarely-used",
  "賳": "rarely-used",
  "賴": "common",
  "賵": "less-than-common",
  "賶": "rarely-used",
  "賸": "less-than-common",
  "賹": "rarely-used",
  "賺": "common",
  "賻": "less-than-common",
  "購": "common",
  "賽": "common",
  "賾": "less-than-common",
  "賿": "rarely-used",
  "贀": "rarely-used",
  "贂": "rarely-used",
  "贃": "rarely-used",
  "贄": "less-than-common",
  "贅": "common",
  "贆": "less-than-common",
  "贇": "less-than-common",
  "贈": "common",
  "贉": "rarely-used",
  "贊": "common",
  "贍": "common",
  "贎": "rarely-used",
  "贏": "common",
  "贐": "less-than-common",
  "贓": "common",
  "贔": "less-than-common",
  "贕": "less-than-common",
  "贖": "common",
  "贗": "common",
  "贙": "less-than-common",
  "贚": "rarely-used",
  "贛": "common",
  "赤": "common",
  "赥": "rarely-used",
  "赦": "common",
  "赧": "common",
  "赨": "less-than-common",
  "赩": "less-than-common",
  "赫": "common",
  "赬": "less-than-common",
  "赭": "common",
  "赮": "less-than-common",
  "赯": "rarely-used",
  "走": "common",
  "赲": "rarely-used",
  "赳": "common",
  "赴": "common",
  "赶": "less-than-common",
  "起": "common",
  "赸": "less-than-common",
  "赹": "rarely-used",
  "赻": "rarely-used",
  "赽": "rarely-used",
  "赾": "rarely-used",
  "趀": "less-than-common",
  "趁": "common",
  "趃": "rarely-used",
  "趄": "less-than-common",
  "超": "common",
  "趆": "rarely-used",
  "趇": "rarely-used",
  "趈": "rarely-used",
  "趉": "rarely-used",
  "越": "common",
  "趌": "less-than-common",
  "趍": "less-than-common",
  "趎": "less-than-common",
  "趏": "less-than-common",
  "趐": "rarely-used",
  "趑": "less-than-common",
  "趒": "rarely-used",
  "趓": "less-than-common",
  "趔": "rarely-used",
  "趕": "common",
  "趖": "rarely-used",
  "趗": "rarely-used",
  "趘": "rarely-used",
  "趙": "common",
  "趚": "rarely-used",
  "趛": "rarely-used",
  "趜": "less-than-common",
  "趝": "rarely-used",
  "趟": "common",
  "趠": "less-than-common",
  "趡": "less-than-common",
  "趢": "rarely-used",
  "趣": "common",
  "趤": "rarely-used",
  "趥": "less-than-common",
  "趧": "less-than-common",
  "趨": "common",
  "趩": "rarely-used",
  "趪": "less-than-common",
  "趫": "less-than-common",
  "趬": "less-than-common",
  "趭": "less-than-common",
  "趮": "less-than-common",
  "趯": "less-than-common",
  "趲": "less-than-common",
  "足": "common",
  "趴": "common",
  "趵": "less-than-common",
  "趶": "rarely-used",
  "趷": "less-than-common",
  "趹": "less-than-common",
  "趺": "less-than-common",
  "趼": "less-than-common",
  "趽": "rarely-used",
  "趾": "common",
  "趿": "less-than-common",
  "跁": "rarely-used",
  "跂": "less-than-common",
  "跅": "less-than-common",
  "跆": "common",
  "跇": "less-than-common",
  "跈": "less-than-common",
  "跊": "rarely-used",
  "跋": "common",
  "跌": "common",
  "跍": "less-than-common",
  "跎": "common",
  "跏": "less-than-common",
  "跐": "less-than-common",
  "跑": "common",
  "跒": "rarely-used",
  "跓": "less-than-common",
  "跕": "less-than-common",
  "跖": "less-than-common",
  "跗": "less-than-common",
  "跘": "less-than-common",
  "跙": "less-than-common",
  "跚": "common",
  "跛": "common",
  "跜": "less-than-common",
  "距": "common",
  "跟": "common",
  "跠": "less-than-common",
  "跡": "common",
  "跢": "less-than-common",
  "跣": "less-than-common",
  "跤": "less-than-common",
  "跦": "less-than-common",
  "跧": "less-than-common",
  "跨": "common",
  "跩": "less-than-common",
  "跪": "common",
  "跫": "less-than-common",
  "跬": "less-than-common",
  "跭": "rarely-used",
  "跮": "less-than-common",
  "路": "common",
  "跰": "less-than-common",
  "跱": "less-than-common",
  "跲": "less-than-common",
  "跳": "common",
  "跴": "rarely-used",
  "跺": "common",
  "跼": "common",
  "跽": "less-than-common",
  "跾": "less-than-common",
  "跿": "less-than-common",
  "踀": "rarely-used",
  "踂": "less-than-common",
  "踃": "less-than-common",
  "踄": "rarely-used",
  "踅": "less-than-common",
  "踆": "less-than-common",
  "踇": "less-than-common",
  "踉": "less-than-common",
  "踊": "less-than-common",
  "踍": "less-than-common",
  "踏": "common",
  "踐": "common",
  "踑": "less-than-common",
  "踒": "less-than-common",
  "踓": "less-than-common",
  "踔": "less-than-common",
  "踕": "less-than-common",
  "踖": "less-than-common",
  "踗": "rarely-used",
  "踘": "less-than-common",
  "踙": "less-than-common",
  "踚": "rarely-used",
  "踛": "less-than-common",
  "踜": "rarely-used",
  "踝": "common",
  "踞": "less-than-common",
  "踟": "common",
  "踠": "less-than-common",
  "踡": "less-than-common",
  "踢": "common",
  "踣": "less-than-common",
  "踤": "less-than-common",
  "踥": "less-than-common",
  "踦": "less-than-common",
  "踧": "less-than-common",
  "踩": "common",
  "踫": "common",
  "踮": "less-than-common",
  "踰": "less-than-common",
  "踱": "common",
  "踳": "less-than-common",
  "踴": "common",
  "踵": "common",
  "踶": "less-than-common",
  "踷": "rarely-used",
  "踸": "less-than-common",
  "踹": "common",
  "踺": "rarely-used",
  "踻": "rarely-used",
  "踼": "less-than-common",
  "踽": "less-than-common",
  "踾": "less-than-common",
  "踿": "rarely-used",
  "蹀": "less-than-common",
  "蹁": "less-than-common",
  "蹂": "common",
  "蹃": "rarely-used",
  "蹄": "common",
  "蹅": "less-than-common",
  "蹇": "less-than-common",
  "蹈": "common",
  "蹉": "common",
  "蹊": "common",
  "蹋": "common",
  "蹌": "less-than-common",
  "蹍": "less-than-common",
  "蹎": "less-than-common",
  "蹐": "less-than-common",
  "蹓": "less-than-common",
  "蹔": "less-than-common",
  "蹕": "less-than-common",
  "蹖": "less-than-common",
  "蹗": "less-than-common",
  "蹘": "rarely-used",
  "蹙": "common",
  "蹚": "less-than-common",
  "蹛": "less-than-common",
  "蹜": "less-than-common",
  "蹝": "less-than-common",
  "蹞": "less-than-common",
  "蹟": "less-than-common",
  "蹠": "less-than-common",
  "蹡": "less-than-common",
  "蹢": "less-than-common",
  "蹣": "common",
  "蹤": "common",
  "蹥": "less-than-common",
  "蹦": "common",
  "蹧": "less-than-common",
  "蹨": "rarely-used",
  "蹩": "less-than-common",
  "蹪": "less-than-common",
  "蹫": "rarely-used",
  "蹬": "common",
  "蹭": "less-than-common",
  "蹯": "less-than-common",
  "蹱": "rarely-used",
  "蹲": "common",
  "蹳": "less-than-common",
  "蹴": "less-than-common",
  "蹶": "common",
  "蹸": "less-than-common",
  "蹺": "common",
  "蹻": "less-than-common",
  "蹼": "common",
  "躁": "common",
  "躂": "common",
  "躄": "less-than-common",
  "躅": "common",
  "躆": "less-than-common",
  "躇": "common",
  "躈": "less-than-common",
  "躉": "common",
  "躊": "common",
  "躋": "less-than-common",
  "躌": "rarely-used",
  "躍": "common",
  "躎": "rarely-used",
  "躐": "less-than-common",
  "躑": "common",
  "躒": "less-than-common",
  "躓": "less-than-common",
  "躔": "less-than-common",
  "躕": "less-than-common",
  "躖": "less-than-common",
  "躗": "less-than-common",
  "躘": "rarely-used",
  "躚": "less-than-common",
  "躝": "rarely-used",
  "躞": "less-than-common",
  "躟": "less-than-common",
  "躠": "less-than-common",
  "躡": "common",
  "躣": "less-than-common",
  "躤": "less-than-common",
  "躥": "less-than-common",
  "躦": "less-than-common",
  "躨": "less-than-common",
  "躩": "less-than-common",
  "躪": "common",
  "身": "common",
  "躬": "common",
  "躲": "common",
  "躴": "rarely-used",
  "躸": "rarely-used",
  "躺": "common",
  "躽": "less-than-common",
  "躿": "rarely-used",
  "軀": "common",
  "軂": "rarely-used",
  "軇": "rarely-used",
  "軉": "rarely-used",
  "車": "common",
  "軋": "common",
  "軌": "common",
  "軍": "common",
  "軎": "rarely-used",
  "軏": "less-than-common",
  "軐": "rarely-used",
  "軑": "less-than-common",
  "軒": "common",
  "軓": "less-than-common",
  "軔": "common",
  "軖": "rarely-used",
  "軗": "rarely-used",
  "軘": "less-than-common",
  "軛": "common",
  "軜": "rarely-used",
  "軝": "less-than-common",
  "軞": "less-than-common",
  "軟": "common",
  "軠": "rarely-used",
  "軡": "rarely-used",
  "軤": "rarely-used",
  "軥": "less-than-common",
  "軦": "less-than-common",
  "軧": "less-than-common",
  "軨": "less-than-common",
  "軩": "rarely-used",
  "軪": "rarely-used",
  "軫": "less-than-common",
  "軬": "less-than-common",
  "軭": "rarely-used",
  "軮": "less-than-common",
  "軯": "less-than-common",
  "軱": "less-than-common",
  "軲": "rarely-used",
  "軳": "rarely-used",
  "軴": "rarely-used",
  "軵": "less-than-common",
  "軶": "less-than-common",
  "軷": "less-than-common",
  "軸": "common",
  "軹": "less-than-common",
  "軺": "less-than-common",
  "軻": "common",
  "軼": "common",
  "軾": "common",
  "軿": "less-than-common",
  "輀": "less-than-common",
  "輁": "less-than-common",
  "輂": "less-than-common",
  "較": "common",
  "輅": "less-than-common",
  "輆": "less-than-common",
  "輇": "less-than-common",
  "輈": "less-than-common",
  "載": "common",
  "輊": "common",
  "輋": "less-than-common",
  "輍": "rarely-used",
  "輎": "rarely-used",
  "輐": "less-than-common",
  "輑": "less-than-common",
  "輒": "common",
  "輓": "common",
  "輔": "common",
  "輕": "common",
  "輖": "less-than-common",
  "輗": "less-than-common",
  "輘": "less-than-common",
  "輚": "less-than-common",
  "輛": "common",
  "輜": "common",
  "輝": "common",
  "輞": "less-than-common",
  "輟": "common",
  "輠": "less-than-common",
  "輢": "rarely-used",
  "輣": "less-than-common",
  "輤": "less-than-common",
  "輥": "less-than-common",
  "輦": "common",
  "輩": "common",
  "輪": "common",
  "輫": "rarely-used",
  "輬": "less-than-common",
  "輮": "less-than-common",
  "輯": "common",
  "輰": "rarely-used",
  "輱": "rarely-used",
  "輲": "less-than-common",
  "輳": "less-than-common",
  "輴": "less-than-common",
  "輵": "less-than-common",
  "輶": "less-than-common",
  "輷": "less-than-common",
  "輸": "common",
  "輹": "less-than-common",
  "輻": "common",
  "輾": "common",
  "輿": "common",
  "轀": "less-than-common",
  "轂": "common",
  "轃": "less-than-common",
  "轄": "common",
  "轅": "common",
  "轆": "less-than-common",
  "轇": "less-than-common",
  "轈": "less-than-common",
  "轉": "common",
  "轋": "rarely-used",
  "轍": "common",
  "轎": "common",
  "轏": "less-than-common",
  "轐": "less-than-common",
  "轑": "less-than-common",
  "轒": "less-than-common",
  "轓": "less-than-common",
  "轔": "common",
  "轕": "less-than-common",
  "轖": "less-than-common",
  "轗": "less-than-common",
  "轘": "less-than-common",
  "轙": "less-than-common",
  "轚": "less-than-common",
  "轛": "less-than-common",
  "轝": "less-than-common",
  "轞": "less-than-common",
  "轟": "common",
  "轠": "less-than-common",
  "轡": "common",
  "轢": "less-than-common",
  "轣": "rarely-used",
  "轤": "less-than-common",
  "辛": "common",
  "辜": "common",
  "辟": "common",
  "辡": "rarely-used",
  "辣": "common",
  "辦": "common",
  "辨": "common",
  "辭": "common",
  "辮": "common",
  "辯": "common",
  "辰": "common",
  "辱": "common",
  "農": "common",
  "辴": "less-than-common",
  "辵": "rarely-used",
  "辸": "rarely-used",
  "达": "rarely-used",
  "辿": "rarely-used",
  "迀": "rarely-used",
  "迂": "common",
  "迄": "common",
  "迅": "common",
  "迆": "common",
  "迉": "less-than-common",
  "迋": "less-than-common",
  "迌": "rarely-used",
  "迍": "less-than-common",
  "迎": "common",
  "运": "rarely-used",
  "近": "common",
  "迒": "less-than-common",
  "迓": "less-than-common",
  "返": "common",
  "迕": "less-than-common",
  "迖": "less-than-common",
  "迗": "rarely-used",
  "迠": "rarely-used",
  "迡": "less-than-common",
  "迢": "common",
  "迣": "less-than-common",
  "迤": "less-than-common",
  "迥": "common",
  "迦": "common",
  "迨": "less-than-common",
  "迪": "common",
  "迫": "common",
  "迭": "common",
  "迮": "less-than-common",
  "述": "common",
  "迴": "common",
  "迵": "less-than-common",
  "迶": "rarely-used",
  "迷": "common",
  "迸": "less-than-common",
  "迺": "common",
  "迻": "less-than-common",
  "迼": "rarely-used",
  "追": "common",
  "迾": "less-than-common",
  "迿": "less-than-common",
  "退": "common",
  "送": "common",
  "适": "less-than-common",
  "逃": "common",
  "逄": "less-than-common",
  "逅": "common",
  "逆": "common",
  "逇": "rarely-used",
  "逋": "less-than-common",
  "逌": "less-than-common",
  "逍": "common",
  "透": "common",
  "逐": "common",
  "逑": "less-than-common",
  "途": "common",
  "逕": "common",
  "逖": "common",
  "逗": "common",
  "逘": "rarely-used",
  "這": "common",
  "通": "common",
  "逛": "common",
  "逜": "less-than-common",
  "逝": "common",
  "逞": "common",
  "速": "common",
  "造": "common",
  "逡": "less-than-common",
  "逢": "common",
  "連": "common",
  "逤": "less-than-common",
  "逨": "rarely-used",
  "逩": "rarely-used",
  "逪": "rarely-used",
  "逫": "rarely-used",
  "逭": "less-than-common",
  "逮": "common",
  "逯": "less-than-common",
  "週": "common",
  "進": "common",
  "逳": "rarely-used",
  "逴": "less-than-common",
  "逵": "common",
  "逶": "less-than-common",
  "逸": "common",
  "逼": "common",
  "逽": "rarely-used",
  "逾": "common",
  "逿": "less-than-common",
  "遁": "common",
  "遂": "common",
  "遃": "rarely-used",
  "遄": "less-than-common",
  "遆": "rarely-used",
  "遇": "common",
  "遈": "rarely-used",
  "遉": "rarely-used",
  "遊": "common",
  "運": "common",
  "遍": "common",
  "過": "common",
  "遏": "common",
  "遐": "common",
  "遑": "common",
  "遒": "less-than-common",
  "道": "common",
  "達": "common",
  "違": "common",
  "遘": "common",
  "遙": "common",
  "遚": "rarely-used",
  "遛": "less-than-common",
  "遜": "common",
  "遝": "less-than-common",
  "遞": "common",
  "遠": "common",
  "遢": "less-than-common",
  "遣": "common",
  "遦": "rarely-used",
  "遧": "rarely-used",
  "遨": "common",
  "適": "common",
  "遪": "rarely-used",
  "遫": "rarely-used",
  "遭": "common",
  "遮": "common",
  "遯": "less-than-common",
  "遰": "less-than-common",
  "遱": "rarely-used",
  "遲": "common",
  "遳": "less-than-common",
  "遴": "common",
  "遵": "common",
  "遶": "less-than-common",
  "遷": "common",
  "選": "common",
  "遹": "less-than-common",
  "遺": "common",
  "遻": "less-than-common",
  "遼": "common",
  "遽": "common",
  "遾": "less-than-common",
  "避": "common",
  "邀": "common",
  "邁": "common",
  "邂": "common",
  "邃": "less-than-common",
  "還": "common",
  "邅": "less-than-common",
  "邆": "less-than-common",
  "邇": "common",
  "邈": "less-than-common",
  "邊": "common",
  "邋": "less-than-common",
  "邌": "rarely-used",
  "邍": "less-than-common",
  "邏": "common",
  "邐": "common",
  "邑": "common",
  "邒": "rarely-used",
  "邓": "rarely-used",
  "邔": "less-than-common",
  "邕": "common",
  "邖": "rarely-used",
  "邗": "less-than-common",
  "邘": "less-than-common",
  "邙": "less-than-common",
  "邛": "less-than-common",
  "邞": "less-than-common",
  "邟": "less-than-common",
  "邠": "less-than-common",
  "邡": "less-than-common",
  "邢": "common",
  "那": "common",
  "邤": "rarely-used",
  "邥": "less-than-common",
  "邦": "common",
  "邧": "less-than-common",
  "邩": "rarely-used",
  "邪": "common",
  "邭": "rarely-used",
  "邮": "rarely-used",
  "邯": "less-than-common",
  "邰": "less-than-common",
  "邱": "common",
  "邲": "less-than-common",
  "邳": "less-than-common",
  "邴": "less-than-common",
  "邵": "common",
  "邶": "less-than-common",
  "邷": "rarely-used",
  "邸": "common",
  "邼": "rarely-used",
  "邽": "less-than-common",
  "邾": "less-than-common",
  "邿": "less-than-common",
  "郀": "rarely-used",
  "郁": "common",
  "郂": "rarely-used",
  "郃": "less-than-common",
  "郅": "less-than-common",
  "郆": "rarely-used",
  "郇": "less-than-common",
  "郈": "less-than-common",
  "郊": "common",
  "郋": "less-than-common",
  "郍": "rarely-used",
  "郎": "common",
  "郔": "less-than-common",
  "郕": "less-than-common",
  "郖": "less-than-common",
  "郗": "less-than-common",
  "郘": "less-than-common",
  "郙": "less-than-common",
  "郚": "less-than-common",
  "郛": "less-than-common",
  "郜": "less-than-common",
  "郝": "less-than-common",
  "郟": "less-than-common",
  "郠": "less-than-common",
  "郡": "common",
  "郢": "less-than-common",
  "郣": "less-than-common",
  "郤": "less-than-common",
  "郥": "less-than-common",
  "部": "common",
  "郩": "rarely-used",
  "郪": "less-than-common",
  "郫": "less-than-common",
  "郬": "rarely-used",
  "郭": "common",
  "郮": "rarely-used",
  "郯": "less-than-common",
  "郰": "less-than-common",
  "郱": "less-than-common",
  "郲": "less-than-common",
  "郳": "less-than-common",
  "郴": "less-than-common",
  "郵": "common",
  "郹": "less-than-common",
  "郺": "less-than-common",
  "郻": "less-than-common",
  "郼": "less-than-common",
  "都": "common",
  "郾": "less-than-common",
  "郿": "less-than-common",
  "鄀": "less-than-common",
  "鄁": "less-than-common",
  "鄂": "common",
  "鄃": "less-than-common",
  "鄄": "less-than-common",
  "鄅": "less-than-common",
  "鄆": "less-than-common",
  "鄇": "less-than-common",
  "鄈": "less-than-common",
  "鄉": "common",
  "鄋": "less-than-common",
  "鄍": "less-than-common",
  "鄎": "less-than-common",
  "鄏": "less-than-common",
  "鄐": "less-than-common",
  "鄑": "less-than-common",
  "鄒": "common",
  "鄔": "less-than-common",
  "鄖": "less-than-common",
  "鄗": "less-than-common",
  "鄘": "less-than-common",
  "鄙": "common",
  "鄚": "less-than-common",
  "鄛": "less-than-common",
  "鄜": "less-than-common",
  "鄝": "less-than-common",
  "鄞": "less-than-common",
  "鄟": "less-than-common",
  "鄠": "less-than-common",
  "鄡": "less-than-common",
  "鄢": "less-than-common",
  "鄣": "less-than-common",
  "鄤": "less-than-common",
  "鄦": "less-than-common",
  "鄧": "common",
  "鄨": "less-than-common",
  "鄩": "less-than-common",
  "鄪": "less-than-common",
  "鄫": "less-than-common",
  "鄬": "less-than-common",
  "鄭": "common",
  "鄮": "less-than-common",
  "鄯": "less-than-common",
  "鄰": "common",
  "鄱": "common",
  "鄲": "less-than-common",
  "鄳": "less-than-common",
  "鄴": "less-than-common",
  "鄵": "less-than-common",
  "鄶": "less-than-common",
  "鄸": "less-than-common",
  "鄹": "common",
  "鄺": "less-than-common",
  "鄻": "less-than-common",
  "鄾": "less-than-common",
  "鄿": "rarely-used",
  "酀": "less-than-common",
  "酁": "less-than-common",
  "酃": "less-than-common",
  "酄": "less-than-common",
  "酅": "less-than-common",
  "酆": "less-than-common",
  "酇": "less-than-common",
  "酈": "less-than-common",
  "酉": "common",
  "酊": "common",
  "酋": "common",
  "酌": "common",
  "配": "common",
  "酎": "less-than-common",
  "酏": "less-than-common",
  "酐": "less-than-common",
  "酑": "rarely-used",
  "酒": "common",
  "酓": "less-than-common",
  "酕": "rarely-used",
  "酖": "less-than-common",
  "酗": "common",
  "酘": "less-than-common",
  "酚": "less-than-common",
  "酟": "less-than-common",
  "酠": "rarely-used",
  "酡": "less-than-common",
  "酢": "less-than-common",
  "酣": "common",
  "酤": "less-than-common",
  "酥": "common",
  "酨": "less-than-common",
  "酩": "common",
  "酪": "common",
  "酫": "rarely-used",
  "酬": "common",
  "酭": "rarely-used",
  "酮": "less-than-common",
  "酯": "less-than-common",
  "酰": "rarely-used",
  "酲": "less-than-common",
  "酳": "less-than-common",
  "酴": "less-than-common",
  "酵": "common",
  "酶": "rarely-used",
  "酷": "common",
  "酸": "common",
  "酹": "less-than-common",
  "酺": "less-than-common",
  "酻": "rarely-used",
  "醀": "rarely-used",
  "醁": "less-than-common",
  "醂": "rarely-used",
  "醃": "common",
  "醄": "rarely-used",
  "醅": "less-than-common",
  "醆": "less-than-common",
  "醇": "common",
  "醈": "rarely-used",
  "醉": "common",
  "醊": "less-than-common",
  "醋": "common",
  "醌": "rarely-used",
  "醍": "less-than-common",
  "醏": "rarely-used",
  "醐": "less-than-common",
  "醑": "less-than-common",
  "醒": "common",
  "醓": "less-than-common",
  "醘": "rarely-used",
  "醙": "less-than-common",
  "醚": "less-than-common",
  "醛": "less-than-common",
  "醜": "common",
  "醝": "rarely-used",
  "醞": "common",
  "醟": "less-than-common",
  "醠": "rarely-used",
  "醡": "rarely-used",
  "醢": "less-than-common",
  "醣": "common",
  "醥": "less-than-common",
  "醦": "rarely-used",
  "醧": "less-than-common",
  "醨": "less-than-common",
  "醪": "less-than-common",
  "醫": "common",
  "醬": "common",
  "醭": "less-than-common",
  "醮": "less-than-common",
  "醯": "less-than-common",
  "醰": "less-than-common",
  "醱": "less-than-common",
  "醲": "less-than-common",
  "醳": "less-than-common",
  "醴": "less-than-common",
  "醵": "less-than-common",
  "醶": "rarely-used",
  "醷": "less-than-common",
  "醹": "less-than-common",
  "醺": "common",
  "醼": "less-than-common",
  "醽": "less-than-common",
  "醾": "less-than-common",
  "釀": "common",
  "釁": "common",
  "釂": "less-than-common",
  "釃": "less-than-common",
  "釅": "less-than-common",
  "釆": "less-than-common",
  "采": "common",
  "釉": "common",
  "釋": "common",
  "里": "common",
  "重": "common",
  "野": "common",
  "量": "common",
  "釐": "common",
  "金": "common",
  "釓": "rarely-used",
  "釔": "less-than-common",
  "釕": "less-than-common",
  "釗": "common",
  "釘": "common",
  "釙": "less-than-common",
  "釚": "rarely-used",
  "釛": "rarely-used",
  "釜": "common",
  "針": "common",
  "釞": "rarely-used",
  "釟": "rarely-used",
  "釢": "less-than-common",
  "釣": "common",
  "釤": "less-than-common",
  "釥": "rarely-used",
  "釦": "common",
  "釧": "common",
  "釨": "rarely-used",
  "釩": "less-than-common",
  "釪": "rarely-used",
  "釫": "rarely-used",
  "釬": "less-than-common",
  "釭": "less-than-common",
  "釮": "rarely-used",
  "釰": "rarely-used",
  "釱": "less-than-common",
  "釲": "rarely-used",
  "釳": "less-than-common",
  "釴": "less-than-common",
  "釵": "common",
  "釷": "rarely-used",
  "釸": "less-than-common",
  "釹": "less-than-common",
  "釽": "less-than-common",
  "釾": "rarely-used",
  "釿": "less-than-common",
  "鈀": "less-than-common",
  "鈁": "less-than-common",
  "鈂": "rarely-used",
  "鈃": "less-than-common",
  "鈄": "rarely-used",
  "鈅": "rarely-used",
  "鈆": "less-than-common",
  "鈇": "less-than-common",
  "鈉": "common",
  "鈊": "less-than-common",
  "鈋": "rarely-used",
  "鈌": "less-than-common",
  "鈍": "common",
  "鈏": "less-than-common",
  "鈐": "common",
  "鈑": "less-than-common",
  "鈒": "less-than-common",
  "鈔": "common",
  "鈕": "common",
  "鈖": "rarely-used",
  "鈗": "rarely-used",
  "鈙": "rarely-used",
  "鈚": "less-than-common",
  "鈜": "rarely-used",
  "鈝": "rarely-used",
  "鈞": "common",
  "鈠": "rarely-used",
  "鈣": "common",
  "鈤": "rarely-used",
  "鈥": "less-than-common",
  "鈦": "less-than-common",
  "鈧": "rarely-used",
  "鈭": "rarely-used",
  "鈮": "less-than-common",
  "鈯": "rarely-used",
  "鈰": "less-than-common",
  "鈱": "rarely-used",
  "鈲": "rarely-used",
  "鈳": "less-than-common",
  "鈴": "common",
  "鈵": "rarely-used",
  "鈶": "less-than-common",
  "鈷": "common",
  "鈸": "common",
  "鈹": "less-than-common",
  "鈺": "less-than-common",
  "鈼": "rarely-used",
  "鈽": "common",
  "鈾": "common",
  "鈿": "less-than-common",
  "鉀": "common",
  "鉂": "rarely-used",
  "鉅": "less-than-common",
  "鉆": "less-than-common",
  "鉈": "less-than-common",
  "鉉": "less-than-common",
  "鉊": "less-than-common",
  "鉋": "common",
  "鉌": "rarely-used",
  "鉍": "less-than-common",
  "鉎": "rarely-used",
  "鉏": "less-than-common",
  "鉐": "rarely-used",
  "鉑": "common",
  "鉒": "less-than-common",
  "鉓": "rarely-used",
  "鉔": "rarely-used",
  "鉕": "rarely-used",
  "鉖": "rarely-used",
  "鉗": "common",
  "鉘": "rarely-used",
  "鉙": "rarely-used",
  "鉚": "less-than-common",
  "鉛": "common",
  "鉜": "rarely-used",
  "鉝": "rarely-used",
  "鉞": "less-than-common",
  "鉠": "less-than-common",
  "鉡": "rarely-used",
  "鉣": "rarely-used",
  "鉤": "common",
  "鉥": "less-than-common",
  "鉦": "less-than-common",
  "鉧": "less-than-common",
  "鉨": "rarely-used",
  "鉩": "rarely-used",
  "鉬": "less-than-common",
  "鉭": "less-than-common",
  "鉯": "less-than-common",
  "鉰": "rarely-used",
  "鉲": "rarely-used",
  "鉵": "rarely-used",
  "鉶": "less-than-common",
  "鉸": "common",
  "鉹": "less-than-common",
  "鉺": "less-than-common",
  "鉻": "common",
  "鉼": "less-than-common",
  "鉽": "rarely-used",
  "鉾": "rarely-used",
  "鉿": "less-than-common",
  "銀": "common",
  "銂": "rarely-used",
  "銃": "less-than-common",
  "銅": "common",
  "銆": "rarely-used",
  "銇": "rarely-used",
  "銈": "rarely-used",
  "銉": "rarely-used",
  "銊": "rarely-used",
  "銋": "rarely-used",
  "銌": "rarely-used",
  "銍": "less-than-common",
  "銎": "less-than-common",
  "銏": "rarely-used",
  "銑": "less-than-common",
  "銓": "common",
  "銔": "less-than-common",
  "銕": "rarely-used",
  "銖": "common",
  "銗": "less-than-common",
  "銘": "common",
  "銙": "rarely-used",
  "銚": "less-than-common",
  "銛": "less-than-common",
  "銜": "common",
  "銝": "rarely-used",
  "銟": "rarely-used",
  "銠": "less-than-common",
  "銡": "rarely-used",
  "銢": "rarely-used",
  "銣": "less-than-common",
  "銤": "less-than-common",
  "銥": "less-than-common",
  "銦": "less-than-common",
  "銧": "rarely-used",
  "銨": "less-than-common",
  "銩": "rarely-used",
  "銪": "less-than-common",
  "銫": "less-than-common",
  "銬": "common",
  "銱": "rarely-used",
  "銲": "less-than-common",
  "銳": "common",
  "銴": "rarely-used",
  "銵": "rarely-used",
  "銶": "less-than-common",
  "銷": "common",
  "銸": "rarely-used",
  "銺": "rarely-used",
  "銻": "common",
  "銼": "common",
  "銾": "rarely-used",
  "銿": "rarely-used",
  "鋀": "less-than-common",
  "鋁": "common",
  "鋂": "less-than-common",
  "鋃": "less-than-common",
  "鋄": "less-than-common",
  "鋅": "common",
  "鋆": "rarely-used",
  "鋇": "less-than-common",
  "鋈": "less-than-common",
  "鋉": "rarely-used",
  "鋊": "less-than-common",
  "鋋": "less-than-common",
  "鋌": "less-than-common",
  "鋍": "rarely-used",
  "鋎": "rarely-used",
  "鋏": "less-than-common",
  "鋐": "less-than-common",
  "鋑": "rarely-used",
  "鋒": "common",
  "鋓": "rarely-used",
  "鋔": "rarely-used",
  "鋕": "rarely-used",
  "鋖": "rarely-used",
  "鋗": "less-than-common",
  "鋘": "less-than-common",
  "鋙": "less-than-common",
  "鋚": "rarely-used",
  "鋜": "rarely-used",
  "鋝": "less-than-common",
  "鋞": "rarely-used",
  "鋟": "less-than-common",
  "鋠": "rarely-used",
  "鋡": "rarely-used",
  "鋤": "common",
  "鋥": "rarely-used",
  "鋦": "rarely-used",
  "鋧": "rarely-used",
  "鋨": "less-than-common",
  "鋩": "less-than-common",
  "鋪": "common",
  "鋬": "rarely-used",
  "鋮": "less-than-common",
  "鋯": "less-than-common",
  "鋰": "less-than-common",
  "鋱": "less-than-common",
  "鋶": "rarely-used",
  "鋷": "rarely-used",
  "鋸": "common",
  "鋹": "rarely-used",
  "鋺": "rarely-used",
  "鋻": "rarely-used",
  "鋼": "common",
  "鋽": "rarely-used",
  "鋾": "rarely-used",
  "鋿": "rarely-used",
  "錀": "rarely-used",
  "錁": "less-than-common",
  "錂": "rarely-used",
  "錄": "common",
  "錆": "less-than-common",
  "錈": "less-than-common",
  "錉": "rarely-used",
  "錊": "rarely-used",
  "錋": "rarely-used",
  "錌": "rarely-used",
  "錍": "less-than-common",
  "錎": "less-than-common",
  "錏": "less-than-common",
  "錐": "common",
  "錑": "rarely-used",
  "錒": "less-than-common",
  "錓": "rarely-used",
  "錔": "rarely-used",
  "錕": "less-than-common",
  "錖": "rarely-used",
  "錗": "rarely-used",
  "錘": "common",
  "錙": "less-than-common",
  "錚": "common",
  "錛": "less-than-common",
  "錜": "rarely-used",
  "錝": "rarely-used",
  "錞": "less-than-common",
  "錟": "less-than-common",
  "錠": "common",
  "錡": "less-than-common",
  "錢": "common",
  "錣": "less-than-common",
  "錤": "rarely-used",
  "錥": "rarely-used",
  "錦": "common",
  "錧": "less-than-common",
  "錨": "common",
  "錩": "rarely-used",
  "錪": "rarely-used",
  "錫": "common",
  "錭": "less-than-common",
  "錮": "less-than-common",
  "錯": "common",
  "錳": "common",
  "錴": "rarely-used",
  "錵": "rarely-used",
  "錶": "common",
  "錷": "rarely-used",
  "錸": "less-than-common",
  "錹": "rarely-used",
  "錼": "less-than-common",
  "鍃": "rarely-used",
  "鍆": "less-than-common",
  "鍇": "less-than-common",
  "鍉": "less-than-common",
  "鍊": "common",
  "鍋": "common",
  "鍌": "less-than-common",
  "鍍": "common",
  "鍎": "rarely-used",
  "鍏": "rarely-used",
  "鍐": "less-than-common",
  "鍑": "less-than-common",
  "鍒": "rarely-used",
  "鍔": "less-than-common",
  "鍕": "rarely-used",
  "鍖": "less-than-common",
  "鍗": "rarely-used",
  "鍘": "less-than-common",
  "鍙": "rarely-used",
  "鍚": "less-than-common",
  "鍛": "common",
  "鍜": "less-than-common",
  "鍝": "rarely-used",
  "鍞": "rarely-used",
  "鍠": "less-than-common",
  "鍡": "rarely-used",
  "鍣": "rarely-used",
  "鍤": "less-than-common",
  "鍥": "common",
  "鍦": "rarely-used",
  "鍧": "rarely-used",
  "鍩": "rarely-used",
  "鍪": "less-than-common",
  "鍬": "common",
  "鍭": "less-than-common",
  "鍮": "rarely-used",
  "鍰": "common",
  "鍱": "rarely-used",
  "鍴": "rarely-used",
  "鍵": "common",
  "鍶": "less-than-common",
  "鍷": "rarely-used",
  "鍸": "rarely-used",
  "鍹": "rarely-used",
  "鍺": "less-than-common",
  "鍻": "rarely-used",
  "鍼": "less-than-common",
  "鍽": "rarely-used",
  "鍾": "common",
  "鎀": "rarely-used",
  "鎂": "common",
  "鎃": "less-than-common",
  "鎈": "rarely-used",
  "鎉": "less-than-common",
  "鎊": "common",
  "鎌": "less-than-common",
  "鎍": "rarely-used",
  "鎎": "less-than-common",
  "鎏": "less-than-common",
  "鎐": "rarely-used",
  "鎑": "rarely-used",
  "鎒": "less-than-common",
  "鎓": "rarely-used",
  "鎔": "common",
  "鎕": "rarely-used",
  "鎖": "common",
  "鎗": "less-than-common",
  "鎘": "less-than-common",
  "鎙": "rarely-used",
  "鎚": "less-than-common",
  "鎛": "less-than-common",
  "鎝": "less-than-common",
  "鎞": "less-than-common",
  "鎟": "rarely-used",
  "鎠": "rarely-used",
  "鎡": "less-than-common",
  "鎢": "common",
  "鎣": "rarely-used",
  "鎤": "rarely-used",
  "鎥": "rarely-used",
  "鎦": "less-than-common",
  "鎧": "less-than-common",
  "鎨": "rarely-used",
  "鎩": "less-than-common",
  "鎪": "less-than-common",
  "鎬": "less-than-common",
  "鎮": "common",
  "鎯": "less-than-common",
  "鎰": "less-than-common",
  "鎱": "rarely-used",
  "鎲": "rarely-used",
  "鎳": "common",
  "鎴": "rarely-used",
  "鎵": "less-than-common",
  "鎶": "rarely-used",
  "鎷": "less-than-common",
  "鏀": "rarely-used",
  "鏂": "less-than-common",
  "鏃": "common",
  "鏄": "rarely-used",
  "鏅": "rarely-used",
  "鏆": "rarely-used",
  "鏇": "less-than-common",
  "鏈": "common",
  "鏉": "rarely-used",
  "鏊": "less-than-common",
  "鏋": "rarely-used",
  "鏌": "less-than-common",
  "鏍": "common",
  "鏎": "rarely-used",
  "鏏": "less-than-common",
  "鏐": "less-than-common",
  "鏑": "common",
  "鏒": "rarely-used",
  "鏓": "rarely-used",
  "鏔": "rarely-used",
  "鏕": "rarely-used",
  "鏖": "common",
  "鏗": "common",
  "鏘": "common",
  "鏙": "less-than-common",
  "鏚": "less-than-common",
  "鏜": "common",
  "鏝": "common",
  "鏞": "less-than-common",
  "鏟": "common",
  "鏡": "common",
  "鏢": "common",
  "鏣": "rarely-used",
  "鏤": "common",
  "鏦": "less-than-common",
  "鏧": "rarely-used",
  "鏨": "less-than-common",
  "鏩": "rarely-used",
  "鏪": "rarely-used",
  "鏬": "less-than-common",
  "鏭": "rarely-used",
  "鏮": "rarely-used",
  "鏴": "rarely-used",
  "鏵": "less-than-common",
  "鏶": "rarely-used",
  "鏷": "less-than-common",
  "鏸": "rarely-used",
  "鏹": "less-than-common",
  "鏺": "rarely-used",
  "鏻": "less-than-common",
  "鏼": "rarely-used",
  "鏽": "common",
  "鏾": "less-than-common",
  "鏿": "rarely-used",
  "鐀": "less-than-common",
  "鐁": "rarely-used",
  "鐃": "common",
  "鐄": "rarely-used",
  "鐅": "rarely-used",
  "鐆": "rarely-used",
  "鐇": "less-than-common",
  "鐈": "rarely-used",
  "鐉": "rarely-used",
  "鐊": "rarely-used",
  "鐋": "less-than-common",
  "鐌": "rarely-used",
  "鐍": "less-than-common",
  "鐎": "less-than-common",
  "鐏": "less-than-common",
  "鐐": "less-than-common",
  "鐑": "rarely-used",
  "鐒": "rarely-used",
  "鐓": "less-than-common",
  "鐔": "less-than-common",
  "鐕": "less-than-common",
  "鐖": "less-than-common",
  "鐗": "rarely-used",
  "鐘": "common",
  "鐙": "less-than-common",
  "鐟": "rarely-used",
  "鐠": "less-than-common",
  "鐨": "less-than-common",
  "鐩": "rarely-used",
  "鐪": "rarely-used",
  "鐫": "less-than-common",
  "鐬": "rarely-used",
  "鐭": "rarely-used",
  "鐮": "common",
  "鐰": "rarely-used",
  "鐱": "rarely-used",
  "鐲": "common",
  "鐳": "common",
  "鐴": "rarely-used",
  "鐵": "common",
  "鐶": "less-than-common",
  "鐷": "rarely-used",
  "鐸": "common",
  "鐹": "rarely-used",
  "鐺": "common",
  "鐻": "less-than-common",
  "鐼": "rarely-used",
  "鐽": "rarely-used",
  "鐿": "less-than-common",
  "鑀": "rarely-used",
  "鑂": "rarely-used",
  "鑄": "common",
  "鑅": "rarely-used",
  "鑆": "rarely-used",
  "鑇": "rarely-used",
  "鑈": "rarely-used",
  "鑉": "rarely-used",
  "鑊": "less-than-common",
  "鑋": "less-than-common",
  "鑌": "less-than-common",
  "鑍": "rarely-used",
  "鑏": "rarely-used",
  "鑐": "less-than-common",
  "鑑": "common",
  "鑒": "common",
  "鑔": "rarely-used",
  "鑕": "less-than-common",
  "鑖": "rarely-used",
  "鑗": "rarely-used",
  "鑘": "rarely-used",
  "鑙": "rarely-used",
  "鑝": "rarely-used",
  "鑞": "rarely-used",
  "鑟": "rarely-used",
  "鑠": "common",
  "鑡": "rarely-used",
  "鑢": "less-than-common",
  "鑣": "common",
  "鑤": "rarely-used",
  "鑨": "rarely-used",
  "鑩": "rarely-used",
  "鑪": "less-than-common",
  "鑫": "less-than-common",
  "鑭": "less-than-common",
  "鑮": "less-than-common",
  "鑯": "less-than-common",
  "鑰": "common",
  "鑱": "less-than-common",
  "鑲": "common",
  "鑳": "rarely-used",
  "鑴": "less-than-common",
  "鑵": "rarely-used",
  "鑶": "rarely-used",
  "鑷": "less-than-common",
  "鑸": "rarely-used",
  "鑹": "rarely-used",
  "鑼": "common",
  "鑽": "common",
  "鑾": "common",
  "鑿": "common",
  "钀": "less-than-common",
  "钁": "less-than-common",
  "钂": "less-than-common",
  "钃": "less-than-common",
  "長": "common",
  "镹": "rarely-used",
  "镺": "less-than-common",
  "镻": "less-than-common",
  "镼": "less-than-common",
  "镽": "less-than-common",
  "镾": "rarely-used",
  "門": "common",
  "閁": "rarely-used",
  "閂": "common",
  "閃": "common",
  "閄": "rarely-used",
  "閆": "less-than-common",
  "閈": "less-than-common",
  "閉": "common",
  "開": "common",
  "閌": "less-than-common",
  "閍": "less-than-common",
  "閎": "less-than-common",
  "閏": "common",
  "閐": "rarely-used",
  "閑": "common",
  "閒": "common",
  "間": "common",
  "閔": "common",
  "閕": "rarely-used",
  "閘": "common",
  "閚": "rarely-used",
  "閛": "rarely-used",
  "閜": "less-than-common",
  "閞": "less-than-common",
  "閟": "less-than-common",
  "閡": "common",
  "閣": "common",
  "閤": "common",
  "閥": "common",
  "閦": "rarely-used",
  "閨": "common",
  "閩": "common",
  "閫": "less-than-common",
  "閬": "less-than-common",
  "閭": "common",
  "閮": "rarely-used",
  "閯": "rarely-used",
  "閰": "rarely-used",
  "閱": "common",
  "閵": "less-than-common",
  "閶": "less-than-common",
  "閷": "less-than-common",
  "閸": "rarely-used",
  "閹": "less-than-common",
  "閺": "less-than-common",
  "閻": "common",
  "閼": "less-than-common",
  "閽": "less-than-common",
  "閾": "less-than-common",
  "閿": "less-than-common",
  "闀": "less-than-common",
  "闂": "rarely-used",
  "闃": "less-than-common",
  "闄": "rarely-used",
  "闅": "less-than-common",
  "闆": "common",
  "闇": "less-than-common",
  "闈": "common",
  "闉": "less-than-common",
  "闊": "common",
  "闋": "common",
  "闌": "common",
  "闍": "less-than-common",
  "闐": "common",
  "闑": "less-than-common",
  "闒": "less-than-common",
  "闓": "less-than-common",
  "闔": "common",
  "闕": "less-than-common",
  "闖": "common",
  "闚": "less-than-common",
  "闛": "less-than-common",
  "關": "common",
  "闞": "less-than-common",
  "闟": "less-than-common",
  "闠": "less-than-common",
  "闡": "common",
  "闢": "common",
  "闣": "rarely-used",
  "闤": "less-than-common",
  "闥": "less-than-common",
  "阜": "common",
  "阞": "less-than-common",
  "阠": "less-than-common",
  "阡": "common",
  "阢": "less-than-common",
  "阣": "rarely-used",
  "阤": "less-than-common",
  "阨": "less-than-common",
  "阪": "common",
  "阬": "less-than-common",
  "阭": "rarely-used",
  "阮": "common",
  "阯": "less-than-common",
  "阰": "less-than-common",
  "阱": "common",
  "防": "common",
  "阷": "rarely-used",
  "阸": "less-than-common",
  "阹": "less-than-common",
  "阺": "less-than-common",
  "阻": "common",
  "阼": "less-than-common",
  "阽": "less-than-common",
  "阿": "common",
  "陀": "common",
  "陂": "less-than-common",
  "陃": "rarely-used",
  "附": "common",
  "陊": "less-than-common",
  "陋": "common",
  "陌": "common",
  "降": "common",
  "陎": "rarely-used",
  "陏": "less-than-common",
  "限": "common",
  "陑": "less-than-common",
  "陓": "less-than-common",
  "陔": "less-than-common",
  "陘": "less-than-common",
  "陙": "rarely-used",
  "陚": "rarely-used",
  "陛": "common",
  "陜": "less-than-common",
  "陝": "common",
  "陞": "less-than-common",
  "陟": "less-than-common",
  "陠": "rarely-used",
  "陡": "common",
  "院": "common",
  "陣": "common",
  "除": "common",
  "陪": "common",
  "陫": "less-than-common",
  "陬": "less-than-common",
  "陭": "less-than-common",
  "陮": "rarely-used",
  "陯": "rarely-used",
  "陰": "common",
  "陱": "rarely-used",
  "陲": "common",
  "陳": "common",
  "陴": "common",
  "陵": "common",
  "陶": "common",
  "陷": "common",
  "陸": "common",
  "陼": "less-than-common",
  "陽": "common",
  "陾": "less-than-common",
  "隀": "rarely-used",
  "隃": "less-than-common",
  "隄": "less-than-common",
  "隅": "common",
  "隆": "common",
  "隇": "less-than-common",
  "隈": "less-than-common",
  "隉": "less-than-common",
  "隊": "common",
  "隋": "common",
  "隍": "common",
  "階": "common",
  "隑": "less-than-common",
  "隒": "less-than-common",
  "隓": "less-than-common",
  "隔": "common",
  "隕": "common",
  "隗": "less-than-common",
  "隘": "common",
  "隙": "common",
  "隚": "rarely-used",
  "際": "common",
  "障": "common",
  "隞": "less-than-common",
  "隢": "rarely-used",
  "隤": "less-than-common",
  "隦": "rarely-used",
  "隧": "common",
  "隨": "common",
  "隩": "less-than-common",
  "險": "common",
  "隬": "rarely-used",
  "隮": "less-than-common",
  "隰": "less-than-common",
  "隱": "common",
  "隳": "less-than-common",
  "隴": "common",
  "隵": "rarely-used",
  "隶": "rarely-used",
  "隸": "common",
  "隹": "less-than-common",
  "隺": "rarely-used",
  "隻": "common",
  "隼": "less-than-common",
  "隿": "less-than-common",
  "雀": "common",
  "雁": "common",
  "雂": "less-than-common",
  "雃": "rarely-used",
  "雄": "common",
  "雅": "common",
  "集": "common",
  "雇": "common",
  "雈": "less-than-common",
  "雉": "common",
  "雊": "less-than-common",
  "雋": "common",
  "雌": "common",
  "雍": "common",
  "雎": "less-than-common",
  "雐": "rarely-used",
  "雒": "less-than-common",
  "雓": "less-than-common",
  "雔": "less-than-common",
  "雕": "common",
  "雖": "common",
  "雗": "less-than-common",
  "雘": "less-than-common",
  "雙": "common",
  "雚": "less-than-common",
  "雛": "common",
  "雜": "common",
  "雝": "less-than-common",
  "雞": "common",
  "雟": "less-than-common",
  "雡": "rarely-used",
  "離": "common",
  "難": "common",
  "雥": "rarely-used",
  "雨": "common",
  "雩": "less-than-common",
  "雪": "common",
  "雭": "rarely-used",
  "雮": "rarely-used",
  "雯": "common",
  "雰": "less-than-common",
  "雱": "less-than-common",
  "雲": "common",
  "雴": "rarely-used",
  "雵": "rarely-used",
  "零": "common",
  "雷": "common",
  "雸": "rarely-used",
  "雹": "common",
  "雺": "less-than-common",
  "電": "common",
  "雼": "rarely-used",
  "雽": "less-than-common",
  "雿": "less-than-common",
  "需": "common",
  "霂": "less-than-common",
  "霃": "rarely-used",
  "霄": "common",
  "霅": "less-than-common",
  "霆": "common",
  "震": "common",
  "霈": "less-than-common",
  "霉": "common",
  "霋": "less-than-common",
  "霌": "rarely-used",
  "霍": "common",
  "霎": "common",
  "霏": "common",
  "霐": "less-than-common",
  "霑": "common",
  "霒": "less-than-common",
  "霓": "common",
  "霔": "rarely-used",
  "霕": "rarely-used",
  "霖": "common",
  "霘": "rarely-used",
  "霙": "rarely-used",
  "霜": "common",
  "霝": "rarely-used",
  "霞": "common",
  "霟": "rarely-used",
  "霠": "less-than-common",
  "霢": "less-than-common",
  "霣": "less-than-common",
  "霤": "less-than-common",
  "霥": "rarely-used",
  "霦": "rarely-used",
  "霧": "common",
  "霨": "rarely-used",
  "霩": "less-than-common",
  "霪": "common",
  "霫": "less-than-common",
  "霬": "less-than-common",
  "霮": "less-than-common",
  "霯": "rarely-used",
  "霰": "less-than-common",
  "霱": "rarely-used",
  "露": "common",
  "霳": "rarely-used",
  "霵": "less-than-common",
  "霷": "rarely-used",
  "霸": "common",
  "霹": "common",
  "霺": "rarely-used",
  "霼": "rarely-used",
  "霽": "common",
  "霾": "common",
  "霿": "less-than-common",
  "靀": "rarely-used",
  "靂": "common",
  "靃": "less-than-common",
  "靄": "common",
  "靆": "less-than-common",
  "靇": "rarely-used",
  "靈": "common",
  "靉": "less-than-common",
  "靊": "rarely-used",
  "靋": "rarely-used",
  "靐": "rarely-used",
  "青": "common",
  "靕": "rarely-used",
  "靖": "common",
  "靗": "rarely-used",
  "靘": "rarely-used",
  "靚": "less-than-common",
  "靛": "common",
  "靜": "common",
  "非": "common",
  "靟": "rarely-used",
  "靠": "common",
  "靡": "common",
  "面": "common",
  "靦": "common",
  "靨": "common",
  "革": "common",
  "靪": "less-than-common",
  "靫": "rarely-used",
  "靬": "less-than-common",
  "靮": "less-than-common",
  "靯": "rarely-used",
  "靰": "less-than-common",
  "靲": "less-than-common",
  "靳": "less-than-common",
  "靴": "common",
  "靶": "common",
  "靷": "less-than-common",
  "靸": "less-than-common",
  "靹": "rarely-used",
  "靺": "less-than-common",
  "靻": "less-than-common",
  "靼": "common",
  "靽": "less-than-common",
  "靾": "less-than-common",
  "靿": "rarely-used",
  "鞀": "less-than-common",
  "鞁": "rarely-used",
  "鞂": "less-than-common",
  "鞃": "less-than-common",
  "鞄": "less-than-common",
  "鞅": "common",
  "鞇": "rarely-used",
  "鞈": "less-than-common",
  "鞊": "less-than-common",
  "鞋": "common",
  "鞍": "common",
  "鞎": "less-than-common",
  "鞏": "common",
  "鞓": "rarely-used",
  "鞔": "less-than-common",
  "鞕": "rarely-used",
  "鞗": "less-than-common",
  "鞘": "common",
  "鞙": "less-than-common",
  "鞚": "less-than-common",
  "鞜": "less-than-common",
  "鞝": "rarely-used",
  "鞞": "less-than-common",
  "鞠": "common",
  "鞡": "less-than-common",
  "鞢": "rarely-used",
  "鞣": "common",
  "鞤": "less-than-common",
  "鞥": "rarely-used",
  "鞦": "common",
  "鞨": "less-than-common",
  "鞪": "less-than-common",
  "鞫": "less-than-common",
  "鞬": "less-than-common",
  "鞭": "common",
  "鞮": "less-than-common",
  "鞳": "less-than-common",
  "鞶": "less-than-common",
  "鞷": "less-than-common",
  "鞹": "less-than-common",
  "鞻": "less-than-common",
  "鞼": "rarely-used",
  "鞿": "less-than-common",
  "韁": "common",
  "韂": "rarely-used",
  "韃": "common",
  "韄": "less-than-common",
  "韅": "less-than-common",
  "韆": "common",
  "韇": "less-than-common",
  "韉": "less-than-common",
  "韋": "common",
  "韌": "common",
  "韍": "less-than-common",
  "韎": "less-than-common",
  "韏": "less-than-common",
  "韐": "less-than-common",
  "韑": "rarely-used",
  "韓": "common",
  "韔": "less-than-common",
  "韕": "less-than-common",
  "韖": "rarely-used",
  "韗": "less-than-common",
  "韘": "rarely-used",
  "韙": "less-than-common",
  "韚": "rarely-used",
  "韜": "common",
  "韝": "less-than-common",
  "韞": "less-than-common",
  "韟": "less-than-common",
  "韠": "rarely-used",
  "韡": "less-than-common",
  "韢": "rarely-used",
  "韣": "less-than-common",
  "韥": "less-than-common",
  "韭": "common",
  "韰": "less-than-common",
  "韱": "less-than-common",
  "音": "common",
  "韴": "rarely-used",
  "韶": "common",
  "韷": "rarely-used",
  "韸": "rarely-used",
  "韹": "less-than-common",
  "韺": "rarely-used",
  "韻": "common",
  "韽": "less-than-common",
  "韾": "rarely-used",
  "響": "common",
  "頀": "rarely-used",
  "頁": "common",
  "頂": "common",
  "頃": "common",
  "頄": "less-than-common",
  "項": "common",
  "順": "common",
  "頇": "less-than-common",
  "須": "common",
  "頉": "rarely-used",
  "頊": "common",
  "頋": "rarely-used",
  "頌": "common",
  "頍": "less-than-common",
  "頎": "less-than-common",
  "頏": "less-than-common",
  "預": "common",
  "頑": "common",
  "頒": "common",
  "頓": "common",
  "頔": "rarely-used",
  "頕": "rarely-used",
  "頖": "less-than-common",
  "頗": "common",
  "領": "common",
  "頙": "rarely-used",
  "頛": "rarely-used",
  "頜": "less-than-common",
  "頝": "less-than-common",
  "頞": "less-than-common",
  "頠": "less-than-common",
  "頡": "common",
  "頢": "rarely-used",
  "頣": "rarely-used",
  "頤": "common",
  "頦": "less-than-common",
  "頧": "rarely-used",
  "頨": "less-than-common",
  "頩": "less-than-common",
  "頪": "rarely-used",
  "頫": "less-than-common",
  "頭": "common",
  "頯": "less-than-common",
  "頰": "common",
  "頱": "rarely-used",
  "頲": "less-than-common",
  "頵": "less-than-common",
  "頶": "rarely-used",
  "頷": "common",
  "頸": "common",
  "頹": "common",
  "頻": "common",
  "顀": "rarely-used",
  "顁": "less-than-common",
  "顂": "rarely-used",
  "顃": "rarely-used",
  "顄": "less-than-common",
  "顅": "less-than-common",
  "顆": "common",
  "顈": "less-than-common",
  "顉": "less-than-common",
  "顊": "less-than-common",
  "題": "common",
  "額": "common",
  "顎": "common",
  "顏": "common",
  "顐": "less-than-common",
  "顑": "less-than-common",
  "顒": "less-than-common",
  "顓": "common",
  "顗": "less-than-common",
  "願": "common",
  "顙": "less-than-common",
  "顛": "common",
  "顜": "less-than-common",
  "顝": "less-than-common",
  "類": "common",
  "顟": "less-than-common",
  "顠": "less-than-common",
  "顡": "rarely-used",
  "顢": "less-than-common",
  "顣": "less-than-common",
  "顤": "less-than-common",
  "顥": "less-than-common",
  "顧": "common",
  "顩": "less-than-common",
  "顪": "less-than-common",
  "顫": "common",
  "顬": "rarely-used",
  "顮": "rarely-used",
  "顯": "common",
  "顰": "common",
  "顱": "common",
  "顲": "less-than-common",
  "顳": "less-than-common",
  "顴": "less-than-common",
  "風": "common",
  "颩": "rarely-used",
  "颬": "less-than-common",
  "颭": "less-than-common",
  "颮": "less-than-common",
  "颯": "common",
  "颰": "rarely-used",
  "颱": "common",
  "颲": "less-than-common",
  "颳": "common",
  "颵": "rarely-used",
  "颶": "common",
  "颸": "less-than-common",
  "颹": "rarely-used",
  "颺": "common",
  "颻": "less-than-common",
  "颼": "common",
  "颽": "less-than-common",
  "颾": "less-than-common",
  "颿": "less-than-common",
  "飀": "rarely-used",
  "飁": "less-than-common",
  "飂": "less-than-common",
  "飄": "common",
  "飆": "less-than-common",
  "飉": "less-than-common",
  "飋": "less-than-common",
  "飌": "less-than-common",
  "飍": "rarely-used",
  "飛": "common",
  "食": "common",
  "飢": "common",
  "飣": "less-than-common",
  "飤": "rarely-used",
  "飥": "rarely-used",
  "飧": "common",
  "飩": "common",
  "飪": "common",
  "飫": "less-than-common",
  "飭": "common",
  "飯": "common",
  "飲": "common",
  "飳": "rarely-used",
  "飴": "common",
  "飵": "rarely-used",
  "飶": "less-than-common",
  "飷": "rarely-used",
  "飹": "rarely-used",
  "飺": "less-than-common",
  "飼": "common",
  "飽": "common",
  "飾": "common",
  "飿": "rarely-used",
  "餀": "less-than-common",
  "餂": "less-than-common",
  "餃": "common",
  "餄": "rarely-used",
  "餅": "common",
  "餆": "rarely-used",
  "餇": "rarely-used",
  "餈": "less-than-common",
  "餉": "common",
  "養": "common",
  "餋": "rarely-used",
  "餌": "common",
  "餐": "common",
  "餑": "less-than-common",
  "餒": "common",
  "餓": "common",
  "餔": "less-than-common",
  "餕": "less-than-common",
  "餖": "less-than-common",
  "餗": "less-than-common",
  "餘": "common",
  "餚": "less-than-common",
  "餛": "common",
  "餞": "common",
  "餟": "less-than-common",
  "餡": "common",
  "餢": "rarely-used",
  "餣": "rarely-used",
  "餤": "less-than-common",
  "餥": "less-than-common",
  "餧": "less-than-common",
  "館": "common",
  "餩": "rarely-used",
  "餪": "less-than-common",
  "餫": "less-than-common",
  "餬": "less-than-common",
  "餭": "less-than-common",
  "餮": "less-than-common",
  "餯": "less-than-common",
  "餰": "less-than-common",
  "餱": "less-than-common",
  "餲": "less-than-common",
  "餳": "less-than-common",
  "餵": "common",
  "餶": "rarely-used",
  "餷": "rarely-used",
  "餸": "rarely-used",
  "餺": "rarely-used",
  "餼": "less-than-common",
  "餽": "common",
  "餾": "common",
  "餿": "common",
  "饀": "rarely-used",
  "饁": "less-than-common",
  "饃": "less-than-common",
  "饅": "common",
  "饆": "rarely-used",
  "饇": "less-than-common",
  "饈": "less-than-common",
  "饉": "less-than-common",
  "饊": "rarely-used",
  "饋": "less-than-common",
  "饌": "less-than-common",
  "饎": "less-than-common",
  "饐": "less-than-common",
  "饑": "common",
  "饒": "common",
  "饓": "rarely-used",
  "饔": "less-than-common",
  "饕": "less-than-common",
  "饖": "rarely-used",
  "饗": "less-than-common",
  "饘": "less-than-common",
  "饙": "less-than-common",
  "饛": "less-than-common",
  "饜": "common",
  "饞": "common",
  "饟": "less-than-common",
  "饠": "rarely-used",
  "饡": "less-than-common",
  "首": "common",
  "馗": "less-than-common",
  "馘": "less-than-common",
  "香": "common",
  "馛": "rarely-used",
  "馜": "rarely-used",
  "馝": "less-than-common",
  "馞": "rarely-used",
  "馟": "rarely-used",
  "馠": "rarely-used",
  "馡": "rarely-used",
  "馣": "less-than-common",
  "馤": "rarely-used",
  "馥": "common",
  "馦": "less-than-common",
  "馧": "rarely-used",
  "馨": "common",
  "馩": "rarely-used",
  "馪": "rarely-used",
  "馫": "rarely-used",
  "馬": "common",
  "馭": "common",
  "馮": "common",
  "馯": "less-than-common",
  "馰": "less-than-common",
  "馱": "common",
  "馲": "less-than-common",
  "馳": "common",
  "馴": "common",
  "馵": "less-than-common",
  "馶": "rarely-used",
  "馷": "rarely-used",
  "馸": "rarely-used",
  "馹": "less-than-common",
  "馺": "less-than-common",
  "馻": "less-than-common",
  "馼": "rarely-used",
  "馽": "less-than-common",
  "馾": "rarely-used",
  "駀": "rarely-used",
  "駁": "common",
  "駂": "less-than-common",
  "駃": "less-than-common",
  "駇": "rarely-used",
  "駉": "less-than-common",
  "駊": "rarely-used",
  "駋": "rarely-used",
  "駌": "rarely-used",
  "駍": "less-than-common",
  "駎": "less-than-common",
  "駏": "less-than-common",
  "駐": "common",
  "駑": "common",
  "駒": "common",
  "駓": "less-than-common",
  "駔": "less-than-common",
  "駕": "common",
  "駖": "less-than-common",
  "駗": "rarely-used",
  "駘": "less-than-common",
  "駙": "common",
  "駚": "rarely-used",
  "駛": "common",
  "駜": "less-than-common",
  "駝": "common",
  "駟": "common",
  "駢": "common",
  "駣": "less-than-common",
  "駤": "less-than-common",
  "駥": "less-than-common",
  "駧": "rarely-used",
  "駨": "rarely-used",
  "駩": "less-than-common",
  "駪": "less-than-common",
  "駬": "less-than-common",
  "駭": "common",
  "駮": "less-than-common",
  "駯": "rarely-used",
  "駰": "less-than-common",
  "駱": "common",
  "駳": "rarely-used",
  "駴": "less-than-common",
  "駶": "less-than-common",
  "駷": "less-than-common",
  "駸": "less-than-common",
  "駹": "less-than-common",
  "駺": "less-than-common",
  "駻": "less-than-common",
  "駼": "less-than-common",
  "駽": "less-than-common",
  "駾": "less-than-common",
  "駿": "common",
  "騀": "rarely-used",
  "騁": "common",
  "騂": "less-than-common",
  "騃": "less-than-common",
  "騄": "less-than-common",
  "騅": "less-than-common",
  "騆": "rarely-used",
  "騇": "less-than-common",
  "騉": "less-than-common",
  "騊": "less-than-common",
  "騋": "less-than-common",
  "騍": "less-than-common",
  "騎": "common",
  "騏": "less-than-common",
  "騑": "less-than-common",
  "騔": "rarely-used",
  "騕": "less-than-common",
  "騖": "common",
  "騙": "common",
  "騚": "less-than-common",
  "騛": "less-than-common",
  "騜": "less-than-common",
  "騝": "less-than-common",
  "騞": "less-than-common",
  "騟": "rarely-used",
  "騠": "less-than-common",
  "騢": "less-than-common",
  "騣": "less-than-common",
  "騤": "less-than-common",
  "騥": "less-than-common",
  "騦": "rarely-used",
  "騧": "less-than-common",
  "騩": "less-than-common",
  "騪": "less-than-common",
  "騫": "common",
  "騬": "less-than-common",
  "騭": "less-than-common",
  "騮": "less-than-common",
  "騯": "rarely-used",
  "騰": "common",
  "騱": "less-than-common",
  "騲": "less-than-common",
  "騳": "rarely-used",
  "騴": "less-than-common",
  "騵": "less-than-common",
  "騶": "less-than-common",
  "騷": "common",
  "騸": "less-than-common",
  "騹": "less-than-common",
  "騺": "less-than-common",
  "騼": "rarely-used",
  "騽": "less-than-common",
  "騾": "common",
  "騿": "rarely-used",
  "驀": "common",
  "驁": "less-than-common",
  "驂": "less-than-common",
  "驃": "common",
  "驄": "less-than-common",
  "驅": "common",
  "驆": "less-than-common",
  "驈": "less-than-common",
  "驉": "less-than-common",
  "驊": "less-than-common",
  "驋": "rarely-used",
  "驌": "less-than-common",
  "驍": "less-than-common",
  "驎": "less-than-common",
  "驏": "less-than-common",
  "驐": "rarely-used",
  "驒": "less-than-common",
  "驓": "less-than-common",
  "驔": "less-than-common",
  "驕": "common",
  "驖": "less-than-common",
  "驗": "common",
  "驙": "rarely-used",
  "驚": "common",
  "驛": "common",
  "驜": "rarely-used",
  "驝": "rarely-used",
  "驞": "less-than-common",
  "驟": "common",
  "驠": "less-than-common",
  "驡": "rarely-used",
  "驢": "common",
  "驤": "less-than-common",
  "驥": "common",
  "驦": "less-than-common",
  "驧": "rarely-used",
  "驨": "less-than-common",
  "驩": "less-than-common",
  "驪": "common",
  "驫": "less-than-common",
  "骨": "common",
  "骫": "less-than-common",
  "骬": "rarely-used",
  "骭": "less-than-common",
  "骯": "common",
  "骰": "common",
  "骱": "rarely-used",
  "骲": "rarely-used",
  "骳": "rarely-used",
  "骴": "less-than-common",
  "骶": "rarely-used",
  "骷": "common",
  "骸": "common",
  "骹": "less-than-common",
  "骺": "rarely-used",
  "骻": "rarely-used",
  "骼": "common",
  "骾": "less-than-common",
  "骿": "less-than-common",
  "髀": "less-than-common",
  "髁": "less-than-common",
  "髂": "less-than-common",
  "髆": "less-than-common",
  "髇": "less-than-common",
  "髉": "rarely-used",
  "髊": "less-than-common",
  "髍": "less-than-common",
  "髎": "rarely-used",
  "髏": "common",
  "髐": "less-than-common",
  "髑": "less-than-common",
  "髒": "common",
  "髓": "common",
  "體": "common",
  "髕": "less-than-common",
  "髖": "less-than-common",
  "高": "common",
  "髛": "rarely-used",
  "髜": "rarely-used",
  "髝": "rarely-used",
  "髞": "rarely-used",
  "髟": "less-than-common",
  "髡": "less-than-common",
  "髣": "less-than-common",
  "髦": "common",
  "髧": "less-than-common",
  "髫": "less-than-common",
  "髬": "less-than-common",
  "髭": "common",
  "髮": "common",
  "髯": "common",
  "髱": "rarely-used",
  "髲": "less-than-common",
  "髳": "less-than-common",
  "髵": "rarely-used",
  "髶": "less-than-common",
  "髷": "rarely-used",
  "髸": "rarely-used",
  "髹": "less-than-common",
  "髺": "less-than-common",
  "髻": "common",
  "髼": "less-than-common",
  "髽": "less-than-common",
  "髾": "less-than-common",
  "髿": "rarely-used",
  "鬁": "less-than-common",
  "鬃": "common",
  "鬄": "less-than-common",
  "鬅": "less-than-common",
  "鬆": "common",
  "鬇": "rarely-used",
  "鬈": "less-than-common",
  "鬉": "rarely-used",
  "鬊": "less-than-common",
  "鬋": "less-than-common",
  "鬌": "less-than-common",
  "鬍": "common",
  "鬎": "less-than-common",
  "鬏": "rarely-used",
  "鬐": "less-than-common",
  "鬑": "rarely-used",
  "鬒": "less-than-common",
  "鬕": "less-than-common",
  "鬖": "less-than-common",
  "鬗": "less-than-common",
  "鬘": "less-than-common",
  "鬙": "less-than-common",
  "鬚": "common",
  "鬜": "rarely-used",
  "鬞": "less-than-common",
  "鬟": "less-than-common",
  "鬠": "less-than-common",
  "鬡": "rarely-used",
  "鬢": "common",
  "鬣": "less-than-common",
  "鬤": "less-than-common",
  "鬥": "common",
  "鬧": "common",
  "鬨": "common",
  "鬩": "less-than-common",
  "鬫": "less-than-common",
  "鬮": "less-than-common",
  "鬯": "less-than-common",
  "鬱": "common",
  "鬲": "common",
  "鬳": "less-than-common",
  "鬵": "less-than-common",
  "鬷": "less-than-common",
  "鬸": "rarely-used",
  "鬹": "rarely-used",
  "鬺": "less-than-common",
  "鬻": "less-than-common",
  "鬼": "common",
  "鬾": "less-than-common",
  "鬿": "less-than-common",
  "魁": "common",
  "魂": "common",
  "魃": "less-than-common",
  "魄": "common",
  "魅": "common",
  "魆": "less-than-common",
  "魈": "less-than-common",
  "魊": "less-than-common",
  "魋": "less-than-common",
  "魌": "less-than-common",
  "魍": "less-than-common",
  "魎": "less-than-common",
  "魏": "common",
  "魑": "less-than-common",
  "魒": "rarely-used",
  "魔": "common",
  "魕": "rarely-used",
  "魖": "less-than-common",
  "魘": "common",
  "魙": "rarely-used",
  "魚": "common",
  "魛": "rarely-used",
  "魜": "rarely-used",
  "魝": "rarely-used",
  "魟": "rarely-used",
  "魠": "less-than-common",
  "魡": "less-than-common",
  "魢": "rarely-used",
  "魤": "rarely-used",
  "魥": "rarely-used",
  "魦": "less-than-common",
  "魧": "less-than-common",
  "魨": "rarely-used",
  "魩": "rarely-used",
  "魪": "rarely-used",
  "魫": "rarely-used",
  "魬": "rarely-used",
  "魮": "rarely-used",
  "魯": "common",
  "魰": "rarely-used",
  "魱": "less-than-common",
  "魳": "rarely-used",
  "魴": "less-than-common",
  "魵": "less-than-common",
  "魶": "less-than-common",
  "魷": "common",
  "魺": "rarely-used",
  "魻": "less-than-common",
  "魼": "less-than-common",
  "魽": "rarely-used",
  "魾": "less-than-common",
  "魿": "rarely-used",
  "鮀": "less-than-common",
  "鮁": "rarely-used",
  "鮂": "less-than-common",
  "鮃": "rarely-used",
  "鮄": "rarely-used",
  "鮅": "less-than-common",
  "鮆": "less-than-common",
  "鮇": "less-than-common",
  "鮈": "rarely-used",
  "鮊": "rarely-used",
  "鮋": "rarely-used",
  "鮍": "rarely-used",
  "鮏": "rarely-used",
  "鮐": "less-than-common",
  "鮑": "common",
  "鮒": "less-than-common",
  "鮓": "less-than-common",
  "鮔": "rarely-used",
  "鮕": "rarely-used",
  "鮚": "less-than-common",
  "鮛": "less-than-common",
  "鮜": "rarely-used",
  "鮞": "less-than-common",
  "鮟": "rarely-used",
  "鮠": "rarely-used",
  "鮡": "less-than-common",
  "鮢": "rarely-used",
  "鮣": "rarely-used",
  "鮤": "less-than-common",
  "鮥": "less-than-common",
  "鮦": "less-than-common",
  "鮧": "rarely-used",
  "鮨": "less-than-common",
  "鮩": "rarely-used",
  "鮪": "common",
  "鮫": "common",
  "鮬": "rarely-used",
  "鮭": "less-than-common",
  "鮮": "common",
  "鮯": "rarely-used",
  "鮰": "rarely-used",
  "鮳": "rarely-used",
  "鮵": "less-than-common",
  "鮶": "rarely-used",
  "鮸": "less-than-common",
  "鮹": "rarely-used",
  "鮺": "rarely-used",
  "鮻": "rarely-used",
  "鮼": "rarely-used",
  "鮽": "rarely-used",
  "鮿": "less-than-common",
  "鯀": "less-than-common",
  "鯁": "less-than-common",
  "鯂": "rarely-used",
  "鯃": "less-than-common",
  "鯄": "rarely-used",
  "鯅": "rarely-used",
  "鯆": "less-than-common",
  "鯇": "less-than-common",
  "鯈": "less-than-common",
  "鯉": "common",
  "鯊": "common",
  "鯌": "rarely-used",
  "鯒": "rarely-used",
  "鯓": "less-than-common",
  "鯔": "less-than-common",
  "鯕": "rarely-used",
  "鯖": "less-than-common",
  "鯗": "less-than-common",
  "鯘": "rarely-used",
  "鯙": "rarely-used",
  "鯚": "rarely-used",
  "鯛": "less-than-common",
  "鯜": "rarely-used",
  "鯝": "rarely-used",
  "鯞": "less-than-common",
  "鯟": "rarely-used",
  "鯠": "less-than-common",
  "鯡": "rarely-used",
  "鯢": "less-than-common",
  "鯣": "rarely-used",
  "鯤": "less-than-common",
  "鯥": "rarely-used",
  "鯦": "less-than-common",
  "鯧": "common",
  "鯨": "common",
  "鯩": "rarely-used",
  "鯪": "less-than-common",
  "鯫": "less-than-common",
  "鯬": "less-than-common",
  "鯰": "less-than-common",
  "鯴": "rarely-used",
  "鯷": "less-than-common",
  "鯸": "less-than-common",
  "鯺": "rarely-used",
  "鯻": "rarely-used",
  "鯼": "rarely-used",
  "鯽": "common",
  "鯾": "rarely-used",
  "鰁": "rarely-used",
  "鰃": "rarely-used",
  "鰄": "rarely-used",
  "鰅": "less-than-common",
  "鰆": "rarely-used",
  "鰇": "rarely-used",
  "鰈": "less-than-common",
  "鰉": "rarely-used",
  "鰊": "rarely-used",
  "鰋": "less-than-common",
  "鰌": "less-than-common",
  "鰍": "common",
  "鰎": "rarely-used",
  "鰏": "rarely-used",
  "鰑": "rarely-used",
  "鰒": "less-than-common",
  "鰓": "common",
  "鰔": "rarely-used",
  "鰗": "rarely-used",
  "鰜": "less-than-common",
  "鰝": "less-than-common",
  "鰞": "rarely-used",
  "鰠": "rarely-used",
  "鰡": "rarely-used",
  "鰢": "rarely-used",
  "鰣": "less-than-common",
  "鰤": "rarely-used",
  "鰥": "common",
  "鰦": "rarely-used",
  "鰧": "rarely-used",
  "鰨": "less-than-common",
  "鰩": "less-than-common",
  "鰪": "rarely-used",
  "鰫": "less-than-common",
  "鰬": "less-than-common",
  "鰭": "common",
  "鰮": "rarely-used",
  "鰱": "common",
  "鰲": "less-than-common",
  "鰳": "less-than-common",
  "鰴": "less-than-common",
  "鰶": "rarely-used",
  "鰷": "less-than-common",
  "鰸": "rarely-used",
  "鰹": "less-than-common",
  "鰻": "common",
  "鰼": "less-than-common",
  "鰽": "rarely-used",
  "鰾": "common",
  "鰿": "less-than-common",
  "鱀": "less-than-common",
  "鱁": "less-than-common",
  "鱃": "rarely-used",
  "鱄": "less-than-common",
  "鱆": "less-than-common",
  "鱈": "less-than-common",
  "鱉": "common",
  "鱊": "less-than-common",
  "鱋": "less-than-common",
  "鱌": "rarely-used",
  "鱍": "less-than-common",
  "鱎": "rarely-used",
  "鱐": "less-than-common",
  "鱒": "less-than-common",
  "鱔": "common",
  "鱕": "less-than-common",
  "鱖": "common",
  "鱗": "common",
  "鱘": "less-than-common",
  "鱙": "rarely-used",
  "鱞": "less-than-common",
  "鱟": "less-than-common",
  "鱠": "less-than-common",
  "鱢": "less-than-common",
  "鱣": "less-than-common",
  "鱤": "rarely-used",
  "鱦": "less-than-common",
  "鱧": "less-than-common",
  "鱨": "less-than-common",
  "鱬": "rarely-used",
  "鱭": "rarely-used",
  "鱮": "less-than-common",
  "鱱": "rarely-used",
  "鱲": "rarely-used",
  "鱳": "less-than-common",
  "鱴": "less-than-common",
  "鱵": "rarely-used",
  "鱷": "common",
  "鱸": "common",
  "鱹": "less-than-common",
  "鱺": "less-than-common",
  "鳥": "common",
  "鳦": "less-than-common",
  "鳧": "less-than-common",
  "鳨": "rarely-used",
  "鳩": "common",
  "鳪": "less-than-common",
  "鳭": "less-than-common",
  "鳱": "less-than-common",
  "鳲": "less-than-common",
  "鳳": "common",
  "鳴": "common",
  "鳵": "less-than-common",
  "鳶": "common",
  "鳷": "less-than-common",
  "鳹": "less-than-common",
  "鳺": "less-than-common",
  "鳻": "less-than-common",
  "鳼": "less-than-common",
  "鳽": "less-than-common",
  "鳿": "less-than-common",
  "鴀": "less-than-common",
  "鴁": "rarely-used",
  "鴃": "less-than-common",
  "鴄": "rarely-used",
  "鴅": "less-than-common",
  "鴆": "common",
  "鴇": "less-than-common",
  "鴈": "less-than-common",
  "鴉": "common",
  "鴊": "rarely-used",
  "鴍": "rarely-used",
  "鴏": "rarely-used",
  "鴐": "less-than-common",
  "鴒": "common",
  "鴓": "rarely-used",
  "鴔": "less-than-common",
  "鴕": "common",
  "鴗": "less-than-common",
  "鴘": "less-than-common",
  "鴙": "rarely-used",
  "鴛": "common",
  "鴜": "rarely-used",
  "鴝": "less-than-common",
  "鴞": "less-than-common",
  "鴟": "rarely-used",
  "鴠": "less-than-common",
  "鴢": "less-than-common",
  "鴣": "common",
  "鴤": "rarely-used",
  "鴥": "less-than-common",
  "鴦": "common",
  "鴨": "common",
  "鴩": "less-than-common",
  "鴭": "rarely-used",
  "鴮": "less-than-common",
  "鴯": "less-than-common",
  "鴰": "less-than-common",
  "鴱": "less-than-common",
  "鴲": "rarely-used",
  "鴳": "less-than-common",
  "鴴": "rarely-used",
  "鴶": "less-than-common",
  "鴷": "less-than-common",
  "鴸": "less-than-common",
  "鴺": "rarely-used",
  "鴻": "common",
  "鴼": "rarely-used",
  "鴽": "less-than-common",
  "鴾": "less-than-common",
  "鴿": "common",
  "鵀": "less-than-common",
  "鵁": "less-than-common",
  "鵂": "less-than-common",
  "鵃": "less-than-common",
  "鵅": "less-than-common",
  "鵊": "less-than-common",
  "鵋": "less-than-common",
  "鵌": "less-than-common",
  "鵍": "rarely-used",
  "鵎": "rarely-used",
  "鵏": "less-than-common",
  "鵑": "common",
  "鵒": "less-than-common",
  "鵓": "less-than-common",
  "鵔": "less-than-common",
  "鵖": "less-than-common",
  "鵗": "less-than-common",
  "鵘": "rarely-used",
  "鵙": "less-than-common",
  "鵚": "rarely-used",
  "鵛": "less-than-common",
  "鵜": "less-than-common",
  "鵝": "common",
  "鵟": "less-than-common",
  "鵠": "common",
  "鵡": "common",
  "鵢": "rarely-used",
  "鵣": "rarely-used",
  "鵦": "rarely-used",
  "鵧": "less-than-common",
  "鵨": "rarely-used",
  "鵩": "less-than-common",
  "鵪": "common",
  "鵫": "less-than-common",
  "鵬": "common",
  "鵮": "rarely-used",
  "鵯": "less-than-common",
  "鵰": "less-than-common",
  "鵱": "less-than-common",
  "鵲": "common",
  "鵳": "less-than-common",
  "鵴": "less-than-common",
  "鵵": "less-than-common",
  "鵷": "less-than-common",
  "鵸": "less-than-common",
  "鵹": "less-than-common",
  "鵺": "rarely-used",
  "鵻": "less-than-common",
  "鵼": "rarely-used",
  "鵽": "less-than-common",
  "鵿": "rarely-used",
  "鶀": "less-than-common",
  "鶁": "less-than-common",
  "鶂": "less-than-common",
  "鶄": "less-than-common",
  "鶅": "less-than-common",
  "鶆": "less-than-common",
  "鶇": "rarely-used",
  "鶈": "less-than-common",
  "鶉": "common",
  "鶊": "less-than-common",
  "鶋": "less-than-common",
  "鶌": "less-than-common",
  "鶐": "less-than-common",
  "鶒": "less-than-common",
  "鶓": "rarely-used",
  "鶔": "less-than-common",
  "鶕": "rarely-used",
  "鶖": "less-than-common",
  "鶗": "less-than-common",
  "鶘": "less-than-common",
  "鶙": "less-than-common",
  "鶚": "less-than-common",
  "鶛": "less-than-common",
  "鶜": "less-than-common",
  "鶝": "less-than-common",
  "鶞": "less-than-common",
  "鶟": "less-than-common",
  "鶠": "less-than-common",
  "鶡": "less-than-common",
  "鶢": "less-than-common",
  "鶣": "less-than-common",
  "鶤": "less-than-common",
  "鶥": "rarely-used",
  "鶦": "rarely-used",
  "鶧": "rarely-used",
  "鶨": "less-than-common",
  "鶩": "less-than-common",
  "鶪": "less-than-common",
  "鶬": "less-than-common",
  "鶭": "less-than-common",
  "鶯": "common",
  "鶰": "rarely-used",
  "鶱": "less-than-common",
  "鶲": "rarely-used",
  "鶳": "rarely-used",
  "鶴": "common",
  "鶵": "less-than-common",
  "鶶": "less-than-common",
  "鶷": "less-than-common",
  "鶸": "rarely-used",
  "鶹": "less-than-common",
  "鶺": "less-than-common",
  "鶻": "less-than-common",
  "鶼": "less-than-common",
  "鶽": "rarely-used",
  "鶾": "less-than-common",
  "鶿": "less-than-common",
  "鷁": "less-than-common",
  "鷂": "common",
  "鷃": "less-than-common",
  "鷅": "less-than-common",
  "鷇": "less-than-common",
  "鷈": "less-than-common",
  "鷊": "less-than-common",
  "鷋": "less-than-common",
  "鷌": "rarely-used",
  "鷍": "rarely-used",
  "鷎": "less-than-common",
  "鷏": "less-than-common",
  "鷐": "less-than-common",
  "鷑": "less-than-common",
  "鷒": "less-than-common",
  "鷓": "common",
  "鷔": "rarely-used",
  "鷕": "less-than-common",
  "鷖": "less-than-common",
  "鷗": "common",
  "鷘": "less-than-common",
  "鷙": "less-than-common",
  "鷚": "less-than-common",
  "鷛": "less-than-common",
  "鷜": "less-than-common",
  "鷝": "rarely-used",
  "鷞": "less-than-common",
  "鷟": "less-than-common",
  "鷠": "rarely-used",
  "鷡": "less-than-common",
  "鷢": "less-than-common",
  "鷣": "less-than-common",
  "鷤": "less-than-common",
  "鷥": "common",
  "鷦": "less-than-common",
  "鷧": "rarely-used",
  "鷨": "rarely-used",
  "鷩": "less-than-common",
  "鷫": "less-than-common",
  "鷬": "rarely-used",
  "鷭": "rarely-used",
  "鷮": "less-than-common",
  "鷯": "less-than-common",
  "鷰": "less-than-common",
  "鷲": "less-than-common",
  "鷳": "rarely-used",
  "鷴": "rarely-used",
  "鷵": "less-than-common",
  "鷶": "less-than-common",
  "鷷": "less-than-common",
  "鷸": "less-than-common",
  "鷹": "common",
  "鷺": "common",
  "鷻": "less-than-common",
  "鷽": "less-than-common",
  "鷾": "less-than-common",
  "鷿": "less-than-common",
  "鸀": "less-than-common",
  "鸁": "less-than-common",
  "鸂": "less-than-common",
  "鸃": "less-than-common",
  "鸄": "less-than-common",
  "鸅": "less-than-common",
  "鸆": "less-than-common",
  "鸇": "less-than-common",
  "鸈": "rarely-used",
  "鸉": "less-than-common",
  "鸋": "less-than-common",
  "鸌": "rarely-used",
  "鸍": "less-than-common",
  "鸏": "less-than-common",
  "鸐": "less-than-common",
  "鸑": "less-than-common",
  "鸒": "less-than-common",
  "鸓": "less-than-common",
  "鸔": "less-than-common",
  "鸕": "less-than-common",
  "鸗": "less-than-common",
  "鸙": "less-than-common",
  "鸚": "common",
  "鸛": "less-than-common",
  "鸝": "less-than-common",
  "鸞": "common",
  "鹵": "less-than-common",
  "鹶": "rarely-used",
  "鹷": "rarely-used",
  "鹹": "common",
  "鹺": "less-than-common",
  "鹼": "common",
  "鹽": "common",
  "鹿": "common",
  "麀": "less-than-common",
  "麂": "common",
  "麃": "less-than-common",
  "麆": "less-than-common",
  "麇": "less-than-common",
  "麈": "less-than-common",
  "麉": "less-than-common",
  "麊": "less-than-common",
  "麋": "common",
  "麌": "less-than-common",
  "麍": "rarely-used",
  "麎": "less-than-common",
  "麑": "less-than-common",
  "麒": "common",
  "麓": "common",
  "麔": "less-than-common",
  "麗": "common",
  "麘": "rarely-used",
  "麙": "less-than-common",
  "麚": "less-than-common",
  "麛": "less-than-common",
  "麜": "less-than-common",
  "麝": "common",
  "麟": "common",
  "麠": "less-than-common",
  "麡": "less-than-common",
  "麣": "rarely-used",
  "麤": "less-than-common",
  "麥": "common",
  "麧": "less-than-common",
  "麨": "rarely-used",
  "麩": "common",
  "麭": "rarely-used",
  "麮": "less-than-common",
  "麰": "less-than-common",
  "麲": "rarely-used",
  "麴": "common",
  "麵": "common",
  "麶": "less-than-common",
  "麷": "less-than-common",
  "麻": "common",
  "麼": "common",
  "麾": "common",
  "黀": "less-than-common",
  "黁": "rarely-used",
  "黂": "less-than-common",
  "黃": "common",
  "黅": "rarely-used",
  "黆": "rarely-used",
  "黇": "rarely-used",
  "黈": "less-than-common",
  "黊": "rarely-used",
  "黌": "less-than-common",
  "黍": "common",
  "黎": "common",
  "黏": "common",
  "黐": "less-than-common",
  "黑": "common",
  "黓": "less-than-common",
  "黔": "common",
  "黕": "less-than-common",
  "黖": "less-than-common",
  "黗": "rarely-used",
  "默": "common",
  "黚": "less-than-common",
  "黛": "common",
  "黜": "common",
  "黝": "common",
  "點": "common",
  "黟": "less-than-common",
  "黠": "common",
  "黢": "rarely-used",
  "黣": "rarely-used",
  "黤": "less-than-common",
  "黥": "less-than-common",
  "黦": "rarely-used",
  "黧": "less-than-common",
  "黨": "common",
  "黫": "less-than-common",
  "黭": "less-than-common",
  "黮": "less-than-common",
  "黯": "common",
  "黰": "less-than-common",
  "黲": "less-than-common",
  "黳": "less-than-common",
  "黴": "common",
  "黵": "less-than-common",
  "黶": "less-than-common",
  "黷": "common",
  "黸": "rarely-used",
  "黹": "less-than-common",
  "黺": "less-than-common",
  "黻": "less-than-common",
  "黼": "less-than-common",
  "黽": "less-than-common",
  "黿": "less-than-common",
  "鼀": "less-than-common",
  "鼁": "less-than-common",
  "鼆": "less-than-common",
  "鼇": "common",
  "鼉": "less-than-common",
  "鼊": "less-than-common",
  "鼎": "common",
  "鼏": "less-than-common",
  "鼐": "less-than-common",
  "鼒": "less-than-common",
  "鼓": "common",
  "鼕": "common",
  "鼖": "less-than-common",
  "鼘": "less-than-common",
  "鼙": "common",
  "鼚": "rarely-used",
  "鼛": "less-than-common",
  "鼜": "less-than-common",
  "鼞": "rarely-used",
  "鼟": "rarely-used",
  "鼠": "common",
  "鼢": "less-than-common",
  "鼣": "less-than-common",
  "鼤": "less-than-common",
  "鼥": "less-than-common",
  "鼧": "rarely-used",
  "鼨": "less-than-common",
  "鼩": "less-than-common",
  "鼪": "less-than-common",
  "鼫": "less-than-common",
  "鼬": "common",
  "鼭": "less-than-common",
  "鼮": "less-than-common",
  "鼯": "less-than-common",
  "鼰": "less-than-common",
  "鼱": "less-than-common",
  "鼲": "less-than-common",
  "鼳": "less-than-common",
  "鼴": "common",
  "鼵": "less-than-common",
  "鼶": "less-than-common",
  "鼷": "less-than-common",
  "鼸": "less-than-common",
  "鼺": "rarely-used",
  "鼻": "common",
  "鼽": "less-than-common",
  "鼾": "common",
  "鼿": "rarely-used",
  "齀": "less-than-common",
  "齁": "less-than-common",
  "齂": "less-than-common",
  "齃": "less-than-common",
  "齆": "rarely-used",
  "齇": "less-than-common",
  "齈": "rarely-used",
  "齉": "less-than-common",
  "齊": "common",
  "齋": "common",
  "齌": "less-than-common",
  "齍": "less-than-common",
  "齎": "less-than-common",
  "齏": "less-than-common",
  "齒": "common",
  "齔": "less-than-common",
  "齕": "less-than-common",
  "齖": "less-than-common",
  "齗": "less-than-common",
  "齘": "less-than-common",
  "齙": "rarely-used",
  "齛": "less-than-common",
  "齜": "common",
  "齝": "less-than-common",
  "齞": "less-than-common",
  "齟": "common",
  "齠": "less-than-common",
  "齡": "common",
  "齣": "common",
  "齤": "less-than-common",
  "齥": "less-than-common",
  "齦": "common",
  "齧": "less-than-common",
  "齨": "rarely-used",
  "齪": "common",
  "齫": "less-than-common",
  "齬": "common",
  "齭": "rarely-used",
  "齮": "less-than-common",
  "齯": "less-than-common",
  "齰": "less-than-common",
  "齱": "less-than-common",
  "齲": "common",
  "齳": "rarely-used",
  "齴": "less-than-common",
  "齵": "less-than-common",
  "齶": "less-than-common",
  "齷": "common",
  "齸": "less-than-common",
  "齹": "less-than-common",
  "齺": "less-than-common",
  "齻": "less-than-common",
  "齽": "rarely-used",
  "齾": "less-than-common",
  "龍": "common",
  "龏": "rarely-used",
  "龐": "common",
  "龑": "rarely-used",
  "龒": "less-than-common",
  "龓": "rarely-used",
  "龔": "common",
  "龕": "less-than-common",
  "龖": "rarely-used",
  "龗": "rarely-used",
  "龘": "rarely-used",
  "龜": "common",
  "龠": "less-than-common",
  "龢": "less-than-common",
  "龣": "rarely-used",
  "龤": "less-than-common",
  "鿃": "rarely-used",
  "𠀀": "rarely-used",
  "𠀉": "rarely-used",
  "𠀔": "rarely-used",
  "𠀢": "rarely-used",
  "𠁁": "rarely-used",
  "𠁃": "rarely-used",
  "𠁥": "rarely-used",
  "𠁫": "rarely-used",
  "𠁭": "rarely-used",
  "𠁷": "rarely-used",
  "𠁾": "rarely-used",
  "𠂆": "rarely-used",
  "𠂇": "rarely-used",
  "𠂔": "rarely-used",
  "𠂣": "rarely-used",
  "𠂤": "rarely-used",
  "𠂥": "rarely-used",
  "𠂹": "rarely-used",
  "𠃆": "rarely-used",
  "𠃉": "rarely-used",
  "𠃋": "rarely-used",
  "𠃑": "rarely-used",
  "𠃒": "rarely-used",
  "𠃖": "rarely-used",
  "𠃡": "rarely-used",
  "𠃽": "rarely-used",
  "𠄅": "rarely-used",
  "𠄌": "rarely-used",
  "𠄍": "rarely-used",
  "𠄎": "rarely-used",
  "𠄏": "rarely-used",
  "𠄑": "rarely-used",
  "𠄖": "rarely-used",
  "𠄚": "rarely-used",
  "𠄭": "rarely-used",
  "𠄮": "rarely-used",
  "𠄱": "rarely-used",
  "𠅈": "rarely-used",
  "𠅌": "rarely-used",
  "𠅗": "rarely-used",
  "𠅣": "rarely-used",
  "𠅬": "rarely-used",
  "𠆁": "rarely-used",
  "𠆎": "rarely-used",
  "𠆩": "rarely-used",
  "𠆲": "rarely-used",
  "𠆵": "rarely-used",
  "𠆶": "rarely-used",
  "𠆺": "rarely-used",
  "𠇋": "rarely-used",
  "𠇐": "rarely-used",
  "𠇘": "rarely-used",
  "𠇱": "rarely-used",
  "𠈀": "rarely-used",
  "𠈅": "rarely-used",
  "𠈆": "rarely-used",
  "𠈈": "rarely-used",
  "𠈊": "rarely-used",
  "𠈋": "rarely-used",
  "𠈌": "rarely-used",
  "𠈕": "rarely-used",
  "𠈪": "rarely-used",
  "𠈬": "rarely-used",
  "𠈭": "rarely-used",
  "𠈰": "rarely-used",
  "𠈱": "rarely-used",
  "𠈵": "rarely-used",
  "𠈶": "rarely-used",
  "𠈸": "rarely-used",
  "𠈹": "rarely-used",
  "𠈺": "rarely-used",
  "𠉢": "rarely-used",
  "𠉣": "rarely-used",
  "𠉤": "rarely-used",
  "𠉧": "rarely-used",
  "𠉩": "rarely-used",
  "𠉬": "rarely-used",
  "𠉮": "rarely-used",
  "𠉶": "rarely-used",
  "𠊔": "rarely-used",
  "𠊢": "rarely-used",
  "𠊣": "rarely-used",
  "𠊤": "rarely-used",
  "𠊥": "rarely-used",
  "𠊦": "rarely-used",
  "𠊧": "rarely-used",
  "𠊫": "rarely-used",
  "𠊬": "rarely-used",
  "𠊰": "rarely-used",
  "𠊲": "rarely-used",
  "𠊵": "rarely-used",
  "𠊶": "rarely-used",
  "𠊷": "rarely-used",
  "𠋖": "rarely-used",
  "𠋝": "rarely-used",
  "𠋡": "rarely-used",
  "𠋧": "rarely-used",
  "𠋨": "rarely-used",
  "𠋩": "rarely-used",
  "𠋬": "rarely-used",
  "𠋯": "rarely-used",
  "𠋰": "rarely-used",
  "𠋲": "rarely-used",
  "𠋳": "rarely-used",
  "𠋴": "rarely-used",
  "𠋵": "rarely-used",
  "𠋷": "rarely-used",
  "𠋸": "rarely-used",
  "𠋺": "rarely-used",
  "𠋻": "rarely-used",
  "𠌉": "rarely-used",
  "𠌡": "rarely-used",
  "𠌢": "rarely-used",
  "𠌪": "rarely-used",
  "𠌭": "rarely-used",
  "𠌮": "rarely-used",
  "𠌰": "rarely-used",
  "𠌱": "rarely-used",
  "𠌲": "rarely-used",
  "𠌴": "rarely-used",
  "𠌾": "rarely-used",
  "𠍀": "rarely-used",
  "𠍨": "rarely-used",
  "𠍩": "rarely-used",
  "𠍪": "rarely-used",
  "𠍫": "rarely-used",
  "𠍯": "rarely-used",
  "𠍱": "rarely-used",
  "𠍲": "rarely-used",
  "𠍵": "rarely-used",
  "𠍹": "rarely-used",
  "𠎙": "rarely-used",
  "𠎮": "rarely-used",
  "𠎳": "rarely-used",
  "𠎶": "rarely-used",
  "𠎷": "rarely-used",
  "𠎸": "rarely-used",
  "𠎿": "rarely-used",
  "𠏀": "rarely-used",
  "𠏃": "rarely-used",
  "𠏇": "rarely-used",
  "𠏈": "rarely-used",
  "𠏖": "rarely-used",
  "𠏢": "rarely-used",
  "𠏤": "rarely-used",
  "𠏧": "rarely-used",
  "𠏨": "rarely-used",
  "𠏩": "rarely-used",
  "𠏫": "rarely-used",
  "𠏭": "rarely-used",
  "𠏮": "rarely-used",
  "𠏰": "rarely-used",
  "𠏴": "rarely-used",
  "𠐀": "rarely-used",
  "𠐆": "rarely-used",
  "𠐉": "rarely-used",
  "𠐊": "rarely-used",
  "𠐋": "rarely-used",
  "𠐌": "rarely-used",
  "𠐍": "rarely-used",
  "𠐡": "rarely-used",
  "𠐲": "rarely-used",
  "𠐵": "rarely-used",
  "𠐶": "rarely-used",
  "𠐺": "rarely-used",
  "𠐻": "rarely-used",
  "𠐼": "rarely-used",
  "𠐽": "rarely-used",
  "𠐾": "rarely-used",
  "𠐿": "rarely-used",
  "𠑄": "rarely-used",
  "𠑅": "rarely-used",
  "𠑌": "rarely-used",
  "𠑑": "rarely-used",
  "𠑙": "rarely-used",
  "𠑛": "rarely-used",
  "𠑟": "rarely-used",
  "𠑩": "rarely-used",
  "𠑪": "rarely-used",
  "𠑯": "rarely-used",
  "𠑲": "rarely-used",
  "𠑹": "rarely-used",
  "𠒀": "rarely-used",
  "𠒢": "rarely-used",
  "𠒵": "rarely-used",
  "𠒸": "rarely-used",
  "𠒿": "rarely-used",
  "𠓌": "rarely-used",
  "𠓗": "rarely-used",
  "𠓜": "rarely-used",
  "𠓝": "rarely-used",
  "𠓤": "rarely-used",
  "𠓧": "rarely-used",
  "𠓪": "rarely-used",
  "𠓫": "rarely-used",
  "𠓭": "rarely-used",
  "𠓶": "rarely-used",
  "𠓷": "rarely-used",
  "𠓽": "rarely-used",
  "𠔂": "rarely-used",
  "𠔆": "rarely-used",
  "𠔌": "rarely-used",
  "𠔕": "rarely-used",
  "𠔠": "rarely-used",
  "𠔨": "rarely-used",
  "𠔯": "rarely-used",
  "𠔶": "rarely-used",
  "𠔼": "rarely-used",
  "𠕄": "rarely-used",
  "𠕊": "rarely-used",
  "𠕓": "rarely-used",
  "𠕖": "rarely-used",
  "𠕟": "rarely-used",
  "𠕠": "rarely-used",
  "𠕦": "rarely-used",
  "𠕧": "rarely-used",
  "𠕭": "rarely-used",
  "𠕳": "rarely-used",
  "𠕻": "rarely-used",
  "𠖄": "rarely-used",
  "𠖓": "rarely-used",
  "𠖟": "rarely-used",
  "𠖩": "rarely-used",
  "𠖫": "rarely-used",
  "𠖶": "rarely-used",
  "𠖷": "rarely-used",
  "𠖹": "rarely-used",
  "𠗂": "rarely-used",
  "𠗆": "rarely-used",
  "𠗈": "rarely-used",
  "𠗉": "rarely-used",
  "𠗊": "rarely-used",
  "𠗋": "rarely-used",
  "𠗌": "rarely-used",
  "𠗍": "rarely-used",
  "𠗘": "rarely-used",
  "𠗙": "rarely-used",
  "𠗚": "rarely-used",
  "𠗛": "rarely-used",
  "𠗝": "rarely-used",
  "𠗥": "rarely-used",
  "𠗨": "rarely-used",
  "𠗲": "rarely-used",
  "𠗳": "rarely-used",
  "𠗴": "rarely-used",
  "𠗵": "rarely-used",
  "𠗶": "rarely-used",
  "𠗺": "rarely-used",
  "𠗻": "rarely-used",
  "𠗼": "rarely-used",
  "𠗽": "rarely-used",
  "𠗾": "rarely-used",
  "𠗿": "rarely-used",
  "𠘅": "rarely-used",
  "𠘆": "rarely-used",
  "𠘊": "rarely-used",
  "𠘋": "rarely-used",
  "𠘌": "rarely-used",
  "𠘖": "rarely-used",
  "𠘘": "rarely-used",
  "𠘝": "rarely-used",
  "𠘞": "rarely-used",
  "𠘟": "rarely-used",
  "𠘢": "rarely-used",
  "𠘣": "rarely-used",
  "𠘥": "rarely-used",
  "𠘧": "rarely-used",
  "𠘱": "rarely-used",
  "𠘳": "rarely-used",
  "𠙈": "rarely-used",
  "𠙴": "rarely-used",
  "𠙶": "rarely-used",
  "𠙺": "rarely-used",
  "𠚆": "rarely-used",
  "𠚘": "rarely-used",
  "𠚞": "rarely-used",
  "𠚟": "rarely-used",
  "𠚥": "rarely-used",
  "𠚧": "rarely-used",
  "𠚨": "rarely-used",
  "𠚭": "rarely-used",
  "𠚮": "rarely-used",
  "𠚯": "rarely-used",
  "𠚱": "rarely-used",
  "𠚷": "rarely-used",
  "𠚹": "rarely-used",
  "𠚺": "rarely-used",
  "𠚻": "rarely-used",
  "𠚼": "rarely-used",
  "𠚽": "rarely-used",
  "𠛀": "rarely-used",
  "𠛃": "rarely-used",
  "𠛎": "rarely-used",
  "𠛑": "rarely-used",
  "𠛒": "rarely-used",
  "𠛓": "rarely-used",
  "𠛔": "rarely-used",
  "𠛕": "rarely-used",
  "𠛖": "rarely-used",
  "𠛘": "rarely-used",
  "𠛙": "rarely-used",
  "𠛚": "rarely-used",
  "𠛥": "rarely-used",
  "𠛦": "rarely-used",
  "𠛨": "rarely-used",
  "𠛩": "rarely-used",
  "𠛪": "rarely-used",
  "𠛫": "rarely-used",
  "𠛮": "rarely-used",
  "𠛵": "rarely-used",
  "𠛶": "rarely-used",
  "𠛸": "rarely-used",
  "𠛻": "rarely-used",
  "𠜉": "rarely-used",
  "𠜐": "rarely-used",
  "𠜑": "rarely-used",
  "𠜒": "rarely-used",
  "𠜖": "rarely-used",
  "𠜘": "rarely-used",
  "𠜙": "rarely-used",
  "𠜦": "rarely-used",
  "𠜱": "rarely-used",
  "𠜲": "rarely-used",
  "𠜳": "rarely-used",
  "𠜴": "rarely-used",
  "𠜵": "rarely-used",
  "𠜹": "rarely-used",
  "𠜻": "rarely-used",
  "𠜼": "rarely-used",
  "𠝄": "rarely-used",
  "𠝘": "rarely-used",
  "𠝙": "rarely-used",
  "𠝚": "rarely-used",
  "𠝛": "rarely-used",
  "𠝝": "rarely-used",
  "𠝞": "rarely-used",
  "𠝟": "rarely-used",
  "𠝠": "rarely-used",
  "𠝢": "rarely-used",
  "𠝤": "rarely-used",
  "𠝨": "rarely-used",
  "𠝩": "rarely-used",
  "𠝪": "rarely-used",
  "𠝿": "rarely-used",
  "𠞀": "rarely-used",
  "𠞃": "rarely-used",
  "𠞄": "rarely-used",
  "𠞅": "rarely-used",
  "𠞆": "rarely-used",
  "𠞈": "rarely-used",
  "𠞉": "rarely-used",
  "𠞊": "rarely-used",
  "𠞎": "rarely-used",
  "𠞏": "rarely-used",
  "𠞤": "rarely-used",
  "𠞧": "rarely-used",
  "𠞩": "rarely-used",
  "𠞪": "rarely-used",
  "𠞬": "rarely-used",
  "𠞭": "rarely-used",
  "𠞮": "rarely-used",
  "𠞯": "rarely-used",
  "𠞱": "rarely-used",
  "𠞾": "rarely-used",
  "𠞿": "rarely-used",
  "𠟂": "rarely-used",
  "𠟃": "rarely-used",
  "𠟅": "rarely-used",
  "𠟈": "rarely-used",
  "𠟉": "rarely-used",
  "𠟊": "rarely-used",
  "𠟋": "rarely-used",
  "𠟌": "rarely-used",
  "𠟍": "rarely-used",
  "𠟒": "rarely-used",
  "𠟓": "rarely-used",
  "𠟕": "rarely-used",
  "𠟗": "rarely-used",
  "𠟦": "rarely-used",
  "𠟧": "rarely-used",
  "𠟨": "rarely-used",
  "𠟩": "rarely-used",
  "𠟪": "rarely-used",
  "𠟰": "rarely-used",
  "𠟺": "rarely-used",
  "𠟼": "rarely-used",
  "𠠁": "rarely-used",
  "𠠂": "rarely-used",
  "𠠃": "rarely-used",
  "𠠄": "rarely-used",
  "𠠋": "rarely-used",
  "𠠍": "rarely-used",
  "𠠎": "rarely-used",
  "𠠏": "rarely-used",
  "𠠐": "rarely-used",
  "𠠗": "rarely-used",
  "𠠜": "rarely-used",
  "𠠝": "rarely-used",
  "𠠠": "rarely-used",
  "𠠪": "rarely-used",
  "𠠮": "rarely-used",
  "𠠯": "rarely-used",
  "𠠳": "rarely-used",
  "𠠶": "rarely-used",
  "𠠷": "rarely-used",
  "𠠸": "rarely-used",
  "𠠹": "rarely-used",
  "𠠻": "rarely-used",
  "𠡁": "rarely-used",
  "𠡃": "rarely-used",
  "𠡄": "rarely-used",
  "𠡑": "rarely-used",
  "𠡒": "rarely-used",
  "𠡔": "rarely-used",
  "𠡞": "rarely-used",
  "𠡟": "rarely-used",
  "𠡡": "rarely-used",
  "𠡢": "rarely-used",
  "𠡭": "rarely-used",
  "𠡮": "rarely-used",
  "𠡯": "rarely-used",
  "𠡰": "rarely-used",
  "𠡱": "rarely-used",
  "𠡻": "rarely-used",
  "𠢅": "rarely-used",
  "𠢆": "rarely-used",
  "𠢇": "rarely-used",
  "𠢈": "rarely-used",
  "𠢉": "rarely-used",
  "𠢓": "rarely-used",
  "𠢔": "rarely-used",
  "𠢕": "rarely-used",
  "𠢙": "rarely-used",
  "𠢠": "rarely-used",
  "𠢡": "rarely-used",
  "𠢢": "rarely-used",
  "𠢣": "rarely-used",
  "𠢤": "rarely-used",
  "𠢥": "rarely-used",
  "𠢦": "rarely-used",
  "𠢰": "rarely-used",
  "𠢱": "rarely-used",
  "𠢲": "rarely-used",
  "𠢳": "rarely-used",
  "𠢴": "rarely-used",
  "𠢷": "rarely-used",
  "𠢹": "rarely-used",
  "𠢺": "rarely-used",
  "𠣀": "rarely-used",
  "𠣄": "rarely-used",
  "𠣅": "rarely-used",
  "𠣇": "rarely-used",
  "𠣉": "rarely-used",
  "𠣊": "rarely-used",
  "𠣌": "rarely-used",
  "𠣏": "rarely-used",
  "𠣑": "rarely-used",
  "𠣒": "rarely-used",
  "𠣖": "rarely-used",
  "𠣗": "rarely-used",
  "𠣘": "rarely-used",
  "𠣟": "rarely-used",
  "𠣤": "rarely-used",
  "𠣫": "rarely-used",
  "𠣰": "rarely-used",
  "𠣱": "rarely-used",
  "𠣳": "rarely-used",
  "𠣹": "rarely-used",
  "𠣺": "rarely-used",
  "𠣾": "rarely-used",
  "𠣿": "rarely-used",
  "𠤀": "rarely-used",
  "𠤄": "rarely-used",
  "𠤊": "rarely-used",
  "𠤏": "rarely-used",
  "𠤓": "rarely-used",
  "𠤗": "rarely-used",
  "𠤫": "rarely-used",
  "𠤮": "rarely-used",
  "𠤰": "rarely-used",
  "𠤴": "rarely-used",
  "𠤹": "rarely-used",
  "𠤺": "rarely-used",
  "𠤼": "rarely-used",
  "𠤿": "rarely-used",
  "𠥁": "rarely-used",
  "𠥉": "rarely-used",
  "𠥌": "rarely-used",
  "𠥐": "rarely-used",
  "𠥖": "rarely-used",
  "𠥙": "rarely-used",
  "𠥜": "rarely-used",
  "𠥝": "rarely-used",
  "𠥞": "rarely-used",
  "𠥢": "rarely-used",
  "𠥦": "rarely-used",
  "𠥮": "rarely-used",
  "𠥰": "rarely-used",
  "𠥵": "rarely-used",
  "𠥽": "rarely-used",
  "𠥾": "rarely-used",
  "𠦈": "rarely-used",
  "𠦌": "rarely-used",
  "𠦒": "rarely-used",
  "𠦘": "rarely-used",
  "𠦪": "rarely-used",
  "𠦫": "rarely-used",
  "𠦬": "rarely-used",
  "𠧀": "rarely-used",
  "𠧙": "rarely-used",
  "𠧚": "rarely-used",
  "𠧛": "rarely-used",
  "𠧟": "rarely-used",
  "𠧩": "rarely-used",
  "𠧪": "rarely-used",
  "𠧫": "rarely-used",
  "𠧵": "rarely-used",
  "𠨃": "rarely-used",
  "𠨆": "rarely-used",
  "𠨍": "rarely-used",
  "𠨎": "rarely-used",
  "𠨘": "rarely-used",
  "𠨚": "rarely-used",
  "𠨠": "rarely-used",
  "𠨢": "rarely-used",
  "𠨥": "rarely-used",
  "𠨬": "rarely-used",
  "𠨭": "rarely-used",
  "𠨲": "rarely-used",
  "𠨴": "rarely-used",
  "𠨵": "rarely-used",
  "𠨸": "rarely-used",
  "𠨹": "rarely-used",
  "𠨺": "rarely-used",
  "𠨻": "rarely-used",
  "𠩁": "rarely-used",
  "𠩃": "rarely-used",
  "𠩎": "rarely-used",
  "𠩏": "rarely-used",
  "𠩗": "rarely-used",
  "𠩘": "rarely-used",
  "𠩩": "rarely-used",
  "𠩪": "rarely-used",
  "𠩫": "rarely-used",
  "𠩲": "rarely-used",
  "𠩺": "rarely-used",
  "𠩿": "rarely-used",
  "𠪆": "rarely-used",
  "𠪇": "rarely-used",
  "𠪑": "rarely-used",
  "𠪒": "rarely-used",
  "𠪙": "rarely-used",
  "𠪚": "rarely-used",
  "𠪟": "rarely-used",
  "𠪮": "rarely-used",
  "𠪯": "rarely-used",
  "𠪺": "rarely-used",
  "𠫌": "rarely-used",
  "𠫓": "rarely-used",
  "𠫨": "rarely-used",
  "𠫳": "rarely-used",
  "𠫿": "rarely-used",
  "𠬆": "rarely-used",
  "𠬈": "rarely-used",
  "𠬓": "rarely-used",
  "𠬛": "rarely-used",
  "𠬝": "rarely-used",
  "𠬢": "rarely-used",
  "𠬣": "rarely-used",
  "𠬦": "rarely-used",
  "𠬬": "rarely-used",
  "𠬮": "rarely-used",
  "𠬳": "rarely-used",
  "𠭉": "rarely-used",
  "𠭋": "rarely-used",
  "𠭗": "rarely-used",
  "𠭘": "rarely-used",
  "𠭝": "rarely-used",
  "𠭣": "rarely-used",
  "𠭥": "rarely-used",
  "𠭦": "rarely-used",
  "𠭰": "rarely-used",
  "𠭴": "rarely-used",
  "𠭿": "rarely-used",
  "𠮃": "rarely-used",
  "𠮄": "rarely-used",
  "𠮆": "rarely-used",
  "𠮊": "rarely-used",
  "𠮐": "rarely-used",
  "𠮖": "rarely-used",
  "𠮙": "rarely-used",
  "𠮜": "rarely-used",
  "𠮠": "rarely-used",
  "𠮫": "rarely-used",
  "𠮭": "rarely-used",
  "𠮯": "rarely-used",
  "𠮰": "rarely-used",
  "𠮳": "rarely-used",
  "𠮴": "rarely-used",
  "𠮵": "rarely-used",
  "𠯈": "rarely-used",
  "𠯋": "rarely-used",
  "𠯐": "rarely-used",
  "𠯑": "rarely-used",
  "𠯓": "rarely-used",
  "𠯔": "rarely-used",
  "𠯖": "rarely-used",
  "𠯗": "rarely-used",
  "𠯘": "rarely-used",
  "𠯙": "rarely-used",
  "𠯛": "rarely-used",
  "𠯜": "rarely-used",
  "𠯝": "rarely-used",
  "𠯡": "rarely-used",
  "𠯶": "rarely-used",
  "𠰄": "rarely-used",
  "𠰅": "rarely-used",
  "𠰈": "rarely-used",
  "𠰉": "rarely-used",
  "𠰋": "rarely-used",
  "𠰌": "rarely-used",
  "𠰍": "rarely-used",
  "𠰏": "rarely-used",
  "𠰐": "rarely-used",
  "𠰑": "rarely-used",
  "𠰒": "rarely-used",
  "𠰓": "rarely-used",
  "𠰕": "rarely-used",
  "𠰖": "rarely-used",
  "𠰘": "rarely-used",
  "𠰙": "rarely-used",
  "𠰚": "rarely-used",
  "𠰛": "rarely-used",
  "𠰜": "rarely-used",
  "𠰝": "rarely-used",
  "𠰡": "rarely-used",
  "𠰲": "rarely-used",
  "𠰶": "rarely-used",
  "𠱐": "rarely-used",
  "𠱑": "rarely-used",
  "𠱒": "rarely-used",
  "𠱓": "rarely-used",
  "𠱔": "rarely-used",
  "𠱕": "rarely-used",
  "𠱘": "rarely-used",
  "𠱙": "rarely-used",
  "𠱚": "rarely-used",
  "𠱛": "rarely-used",
  "𠱜": "rarely-used",
  "𠱝": "rarely-used",
  "𠱞": "rarely-used",
  "𠱟": "rarely-used",
  "𠱠": "rarely-used",
  "𠱡": "rarely-used",
  "𠱢": "rarely-used",
  "𠱣": "rarely-used",
  "𠱤": "rarely-used",
  "𠱥": "rarely-used",
  "𠱨": "rarely-used",
  "𠱫": "rarely-used",
  "𠱮": "rarely-used",
  "𠱲": "rarely-used",
  "𠱳": "rarely-used",
  "𠲋": "rarely-used",
  "𠲌": "rarely-used",
  "𠲎": "rarely-used",
  "𠲗": "rarely-used",
  "𠲩": "rarely-used",
  "𠲪": "rarely-used",
  "𠲮": "rarely-used",
  "𠲱": "rarely-used",
  "𠲳": "rarely-used",
  "𠲴": "rarely-used",
  "𠲵": "rarely-used",
  "𠲶": "rarely-used",
  "𠲷": "rarely-used",
  "𠲸": "rarely-used",
  "𠲹": "rarely-used",
  "𠲺": "rarely-used",
  "𠲻": "rarely-used",
  "𠲼": "rarely-used",
  "𠲽": "rarely-used",
  "𠲾": "rarely-used",
  "𠲿": "rarely-used",
  "𠳂": "rarely-used",
  "𠳃": "rarely-used",
  "𠳄": "rarely-used",
  "𠳇": "rarely-used",
  "𠳉": "rarely-used",
  "𠳊": "rarely-used",
  "𠳋": "rarely-used",
  "𠳌": "rarely-used",
  "𠳍": "rarely-used",
  "𠳎": "rarely-used",
  "𠳯": "rarely-used",
  "𠳰": "rarely-used",
  "𠳱": "rarely-used",
  "𠳷": "rarely-used",
  "𠳸": "rarely-used",
  "𠳹": "rarely-used",
  "𠳺": "rarely-used",
  "𠳻": "rarely-used",
  "𠴃": "rarely-used",
  "𠴡": "rarely-used",
  "𠴢": "rarely-used",
  "𠴣": "rarely-used",
  "𠴦": "rarely-used",
  "𠴧": "rarely-used",
  "𠴨": "rarely-used",
  "𠴭": "rarely-used",
  "𠴮": "rarely-used",
  "𠴯": "rarely-used",
  "𠴰": "rarely-used",
  "𠴱": "rarely-used",
  "𠴳": "rarely-used",
  "𠴵": "rarely-used",
  "𠴶": "rarely-used",
  "𠴷": "rarely-used",
  "𠴸": "rarely-used",
  "𠴹": "rarely-used",
  "𠴺": "rarely-used",
  "𠴻": "rarely-used",
  "𠴼": "rarely-used",
  "𠵂": "rarely-used",
  "𠵃": "rarely-used",
  "𠵑": "rarely-used",
  "𠵠": "rarely-used",
  "𠵢": "rarely-used",
  "𠵪": "rarely-used",
  "𠵰": "rarely-used",
  "𠵵": "rarely-used",
  "𠵹": "rarely-used",
  "𠶧": "rarely-used",
  "𠶨": "rarely-used",
  "𠶩": "rarely-used",
  "𠶪": "rarely-used",
  "𠶫": "rarely-used",
  "𠶬": "rarely-used",
  "𠶰": "rarely-used",
  "𠶱": "rarely-used",
  "𠶴": "rarely-used",
  "𠶵": "rarely-used",
  "𠶷": "rarely-used",
  "𠶸": "rarely-used",
  "𠶻": "rarely-used",
  "𠶾": "rarely-used",
  "𠷀": "rarely-used",
  "𠷁": "rarely-used",
  "𠷂": "rarely-used",
  "𠷃": "rarely-used",
  "𠷄": "rarely-used",
  "𠷅": "rarely-used",
  "𠷆": "rarely-used",
  "𠷇": "rarely-used",
  "𠷈": "rarely-used",
  "𠷉": "rarely-used",
  "𠷊": "rarely-used",
  "𠷋": "rarely-used",
  "𠷌": "rarely-used",
  "𠷍": "rarely-used",
  "𠷏": "rarely-used",
  "𠷑": "rarely-used",
  "𠷒": "rarely-used",
  "𠷓": "rarely-used",
  "𠷖": "rarely-used",
  "𠷚": "rarely-used",
  "𠷞": "rarely-used",
  "𠷟": "rarely-used",
  "𠷸": "rarely-used",
  "𠷻": "rarely-used",
  "𠷼": "rarely-used",
  "𠷽": "rarely-used",
  "𠷾": "rarely-used",
  "𠸭": "rarely-used",
  "𠸮": "rarely-used",
  "𠸱": "rarely-used",
  "𠸲": "rarely-used",
  "𠸳": "rarely-used",
  "𠸷": "rarely-used",
  "𠸸": "rarely-used",
  "𠸹": "rarely-used",
  "𠸻": "rarely-used",
  "𠹀": "rarely-used",
  "𠹁": "rarely-used",
  "𠹃": "rarely-used",
  "𠹆": "rarely-used",
  "𠹇": "rarely-used",
  "𠹊": "rarely-used",
  "𠹋": "rarely-used",
  "𠹌": "rarely-used",
  "𠹍": "rarely-used",
  "𠹐": "rarely-used",
  "𠹑": "rarely-used",
  "𠹓": "rarely-used",
  "𠹔": "rarely-used",
  "𠹕": "rarely-used",
  "𠹖": "rarely-used",
  "𠹘": "rarely-used",
  "𠹚": "rarely-used",
  "𠹛": "rarely-used",
  "𠹢": "rarely-used",
  "𠹤": "rarely-used",
  "𠹥": "rarely-used",
  "𠹦": "rarely-used",
  "𠻌": "rarely-used",
  "𠻍": "rarely-used",
  "𠻎": "rarely-used",
  "𠻏": "rarely-used",
  "𠻐": "rarely-used",
  "𠻗": "rarely-used",
  "𠻜": "rarely-used",
  "𠻞": "rarely-used",
  "𠻟": "rarely-used",
  "𠻠": "rarely-used",
  "𠻡": "rarely-used",
  "𠻤": "rarely-used",
  "𠻥": "rarely-used",
  "𠻦": "rarely-used",
  "𠻧": "rarely-used",
  "𠻨": "rarely-used",
  "𠻪": "rarely-used",
  "𠻫": "rarely-used",
  "𠻬": "rarely-used",
  "𠻱": "rarely-used",
  "𠼘": "rarely-used",
  "𠼚": "rarely-used",
  "𠼞": "rarely-used",
  "𠽜": "rarely-used",
  "𠽝": "rarely-used",
  "𠽣": "rarely-used",
  "𠽦": "rarely-used",
  "𠽩": "rarely-used",
  "𠽪": "rarely-used",
  "𠽫": "rarely-used",
  "𠽭": "rarely-used",
  "𠽰": "rarely-used",
  "𠽲": "rarely-used",
  "𠽵": "rarely-used",
  "𠽶": "rarely-used",
  "𠽹": "rarely-used",
  "𠽻": "rarely-used",
  "𠽼": "rarely-used",
  "𠽾": "rarely-used",
  "𠾀": "rarely-used",
  "𠾉": "rarely-used",
  "𠾌": "rarely-used",
  "𠾗": "rarely-used",
  "𠾥": "rarely-used",
  "𠿅": "rarely-used",
  "𠿆": "rarely-used",
  "𠿈": "rarely-used",
  "𠿉": "rarely-used",
  "𠿋": "rarely-used",
  "𠿎": "rarely-used",
  "𠿏": "rarely-used",
  "𠿑": "rarely-used",
  "𠿓": "rarely-used",
  "𠿔": "rarely-used",
  "𠿕": "rarely-used",
  "𠿖": "rarely-used",
  "𠿗": "rarely-used",
  "𠿛": "rarely-used",
  "𠿝": "rarely-used",
  "𠿞": "rarely-used",
  "𠿟": "rarely-used",
  "𠿠": "rarely-used",
  "𠿡": "rarely-used",
  "𠿣": "rarely-used",
  "𠿤": "rarely-used",
  "𠿺": "rarely-used",
  "𡀺": "rarely-used",
  "𡀼": "rarely-used",
  "𡀿": "rarely-used",
  "𡁁": "rarely-used",
  "𡁆": "rarely-used",
  "𡁇": "rarely-used",
  "𡁈": "rarely-used",
  "𡁉": "rarely-used",
  "𡁋": "rarely-used",
  "𡁌": "rarely-used",
  "𡁎": "rarely-used",
  "𡁓": "rarely-used",
  "𡁕": "rarely-used",
  "𡂊": "rarely-used",
  "𡂋": "rarely-used",
  "𡂏": "rarely-used",
  "𡂒": "rarely-used",
  "𡂓": "rarely-used",
  "𡂕": "rarely-used",
  "𡂖": "rarely-used",
  "𡂗": "rarely-used",
  "𡂙": "rarely-used",
  "𡂚": "rarely-used",
  "𡂛": "rarely-used",
  "𡂜": "rarely-used",
  "𡂟": "rarely-used",
  "𡂡": "rarely-used",
  "𡂣": "rarely-used",
  "𡂩": "rarely-used",
  "𡃝": "rarely-used",
  "𡃡": "rarely-used",
  "𡃢": "rarely-used",
  "𡃦": "rarely-used",
  "𡃧": "rarely-used",
  "𡃩": "rarely-used",
  "𡃷": "rarely-used",
  "𡄑": "rarely-used",
  "𡄒": "rarely-used",
  "𡄓": "rarely-used",
  "𡄔": "rarely-used",
  "𡄕": "rarely-used",
  "𡄣": "rarely-used",
  "𡄲": "rarely-used",
  "𡄳": "rarely-used",
  "𡄴": "rarely-used",
  "𡄵": "rarely-used",
  "𡄷": "rarely-used",
  "𡄹": "rarely-used",
  "𡄻": "rarely-used",
  "𡅁": "rarely-used",
  "𡅙": "rarely-used",
  "𡅭": "rarely-used",
  "𡅹": "rarely-used",
  "𡅺": "rarely-used",
  "𡅻": "rarely-used",
  "𡆅": "rarely-used",
  "𡆆": "rarely-used",
  "𡆣": "rarely-used",
  "𡆩": "rarely-used",
  "𡆳": "rarely-used",
  "𡇈": "rarely-used",
  "𡇑": "rarely-used",
  "𡇒": "rarely-used",
  "𡇓": "rarely-used",
  "𡇖": "rarely-used",
  "𡇠": "rarely-used",
  "𡇤": "rarely-used",
  "𡇰": "rarely-used",
  "𡇱": "rarely-used",
  "𡇳": "rarely-used",
  "𡇷": "rarely-used",
  "𡇼": "rarely-used",
  "𡇿": "rarely-used",
  "𡈀": "rarely-used",
  "𡈉": "rarely-used",
  "𡈊": "rarely-used",
  "𡈌": "rarely-used",
  "𡈏": "rarely-used",
  "𡈗": "rarely-used",
  "𡈳": "rarely-used",
  "𡈼": "rarely-used",
  "𡈾": "rarely-used",
  "𡉷": "rarely-used",
  "𡊀": "rarely-used",
  "𡊁": "rarely-used",
  "𡊂": "rarely-used",
  "𡊃": "rarely-used",
  "𡊄": "rarely-used",
  "𡊉": "rarely-used",
  "𡊍": "rarely-used",
  "𡊵": "rarely-used",
  "𡊶": "rarely-used",
  "𡊸": "rarely-used",
  "𡊻": "rarely-used",
  "𡊼": "rarely-used",
  "𡋧": "rarely-used",
  "𡋨": "rarely-used",
  "𡋩": "rarely-used",
  "𡋪": "rarely-used",
  "𡋫": "rarely-used",
  "𡋬": "rarely-used",
  "𡋭": "rarely-used",
  "𡋯": "rarely-used",
  "𡌘": "rarely-used",
  "𡌤": "rarely-used",
  "𡌥": "rarely-used",
  "𡌦": "rarely-used",
  "𡌩": "rarely-used",
  "𡌪": "rarely-used",
  "𡌭": "rarely-used",
  "𡌯": "rarely-used",
  "𡌲": "rarely-used",
  "𡍊": "rarely-used",
  "𡍠": "rarely-used",
  "𡍡": "rarely-used",
  "𡍦": "rarely-used",
  "𡍨": "rarely-used",
  "𡍪": "rarely-used",
  "𡍫": "rarely-used",
  "𡍲": "rarely-used",
  "𡍵": "rarely-used",
  "𡍶": "rarely-used",
  "𡍻": "rarely-used",
  "𡎧": "rarely-used",
  "𡎨": "rarely-used",
  "𡎪": "rarely-used",
  "𡎫": "rarely-used",
  "𡎬": "rarely-used",
  "𡎮": "rarely-used",
  "𡎳": "rarely-used",
  "𡎴": "rarely-used",
  "𡎷": "rarely-used",
  "𡎹": "rarely-used",
  "𡎺": "rarely-used",
  "𡎻": "rarely-used",
  "𡎾": "rarely-used",
  "𡎿": "rarely-used",
  "𡏀": "rarely-used",
  "𡏁": "rarely-used",
  "𡏩": "rarely-used",
  "𡏪": "rarely-used",
  "𡏫": "rarely-used",
  "𡏭": "rarely-used",
  "𡏮": "rarely-used",
  "𡏯": "rarely-used",
  "𡏱": "rarely-used",
  "𡏵": "rarely-used",
  "𡏷": "rarely-used",
  "𡐔": "rarely-used",
  "𡐝": "rarely-used",
  "𡐞": "rarely-used",
  "𡐠": "rarely-used",
  "𡐤": "rarely-used",
  "𡐥": "rarely-used",
  "𡐰": "rarely-used",
  "𡐱": "rarely-used",
  "𡑈": "rarely-used",
  "𡑘": "rarely-used",
  "𡑙": "rarely-used",
  "𡑚": "rarely-used",
  "𡑜": "rarely-used",
  "𡑡": "rarely-used",
  "𡑶": "rarely-used",
  "𡑸": "rarely-used",
  "𡑹": "rarely-used",
  "𡒈": "rarely-used",
  "𡒊": "rarely-used",
  "𡒌": "rarely-used",
  "𡒓": "rarely-used",
  "𡒯": "rarely-used",
  "𡒱": "rarely-used",
  "𡒳": "rarely-used",
  "𡓉": "rarely-used",
  "𡓊": "rarely-used",
  "𡓍": "rarely-used",
  "𡓒": "rarely-used",
  "𡓦": "rarely-used",
  "𡓰": "rarely-used",
  "𡓲": "rarely-used",
  "𡓸": "rarely-used",
  "𡓿": "rarely-used",
  "𡔁": "rarely-used",
  "𡔇": "rarely-used",
  "𡔉": "rarely-used",
  "𡔕": "rarely-used",
  "𡔗": "rarely-used",
  "𡔢": "rarely-used",
  "𡔨": "rarely-used",
  "𡕒": "rarely-used",
  "𡕠": "rarely-used",
  "𡕡": "rarely-used",
  "𡕢": "rarely-used",
  "𡕧": "rarely-used",
  "𡕪": "rarely-used",
  "𡕮": "rarely-used",
  "𡕶": "rarely-used",
  "𡖑": "rarely-used",
  "𡖒": "rarely-used",
  "𡖓": "rarely-used",
  "𡖔": "rarely-used",
  "𡖜": "rarely-used",
  "𡖞": "rarely-used",
  "𡖢": "rarely-used",
  "𡖣": "rarely-used",
  "𡖤": "rarely-used",
  "𡖪": "rarely-used",
  "𡖫": "rarely-used",
  "𡖬": "rarely-used",
  "𡖭": "rarely-used",
  "𡖯": "rarely-used",
  "𡖲": "rarely-used",
  "𡖳": "rarely-used",
  "𡖶": "rarely-used",
  "𡖽": "rarely-used",
  "𡖾": "rarely-used",
  "𡗁": "rarely-used",
  "𡗆": "rarely-used",
  "𡗈": "rarely-used",
  "𡗜": "rarely-used",
  "𡗞": "rarely-used",
  "𡗥": "rarely-used",
  "𡗦": "rarely-used",
  "𡗷": "rarely-used",
  "𡗸": "rarely-used",
  "𡗹": "rarely-used",
  "𡗼": "rarely-used",
  "𡘌": "rarely-used",
  "𡘍": "rarely-used",
  "𡘎": "rarely-used",
  "𡘏": "rarely-used",
  "𡘐": "rarely-used",
  "𡘝": "rarely-used",
  "𡘢": "rarely-used",
  "𡘣": "rarely-used",
  "𡘰": "rarely-used",
  "𡘲": "rarely-used",
  "𡘴": "rarely-used",
  "𡙄": "rarely-used",
  "𡙐": "rarely-used",
  "𡙗": "rarely-used",
  "𡙘": "rarely-used",
  "𡙠": "rarely-used",
  "𡙨": "rarely-used",
  "𡙩": "rarely-used",
  "𡙪": "rarely-used",
  "𡙬": "rarely-used",
  "𡙭": "rarely-used",
  "𡙮": "rarely-used",
  "𡙶": "rarely-used",
  "𡙷": "rarely-used",
  "𡙽": "rarely-used",
  "𡚅": "rarely-used",
  "𡚇": "rarely-used",
  "𡚊": "rarely-used",
  "𡚑": "rarely-used",
  "𡚗": "rarely-used",
  "𡚛": "rarely-used",
  "𡚠": "rarely-used",
  "𡚨": "rarely-used",
  "𡚰": "rarely-used",
  "𡚸": "rarely-used",
  "𡚹": "rarely-used",
  "𡚻": "rarely-used",
  "𡚽": "rarely-used",
  "𡚾": "rarely-used",
  "𡛖": "rarely-used",
  "𡛗": "rarely-used",
  "𡛘": "rarely-used",
  "𡛙": "rarely-used",
  "𡛜": "rarely-used",
  "𡛝": "rarely-used",
  "𡛞": "rarely-used",
  "𡛟": "rarely-used",
  "𡛠": "rarely-used",
  "𡛡": "rarely-used",
  "𡛽": "rarely-used",
  "𡛾": "rarely-used",
  "𡜀": "rarely-used",
  "𡜁": "rarely-used",
  "𡜂": "rarely-used",
  "𡜃": "rarely-used",
  "𡜇": "rarely-used",
  "𡜉": "rarely-used",
  "𡜊": "rarely-used",
  "𡜋": "rarely-used",
  "𡜏": "rarely-used",
  "𡜥": "rarely-used",
  "𡜦": "rarely-used",
  "𡜧": "rarely-used",
  "𡜨": "rarely-used",
  "𡜫": "rarely-used",
  "𡜬": "rarely-used",
  "𡜯": "rarely-used",
  "𡜱": "rarely-used",
  "𡜲": "rarely-used",
  "𡜳": "rarely-used",
  "𡜵": "rarely-used",
  "𡝍": "rarely-used",
  "𡝙": "rarely-used",
  "𡝚": "rarely-used",
  "𡝛": "rarely-used",
  "𡝜": "rarely-used",
  "𡝝": "rarely-used",
  "𡝢": "rarely-used",
  "𡝦": "rarely-used",
  "𡝧": "rarely-used",
  "𡝫": "rarely-used",
  "𡞘": "rarely-used",
  "𡞙": "rarely-used",
  "𡞚": "rarely-used",
  "𡞛": "rarely-used",
  "𡞜": "rarely-used",
  "𡞞": "rarely-used",
  "𡞟": "rarely-used",
  "𡞢": "rarely-used",
  "𡞣": "rarely-used",
  "𡞧": "rarely-used",
  "𡞪": "rarely-used",
  "𡞫": "rarely-used",
  "𡞬": "rarely-used",
  "𡞭": "rarely-used",
  "𡞮": "rarely-used",
  "𡞯": "rarely-used",
  "𡟑": "rarely-used",
  "𡟕": "rarely-used",
  "𡟝": "rarely-used",
  "𡟞": "rarely-used",
  "𡟟": "rarely-used",
  "𡟠": "rarely-used",
  "𡟡": "rarely-used",
  "𡟢": "rarely-used",
  "𡟣": "rarely-used",
  "𡟤": "rarely-used",
  "𡟥": "rarely-used",
  "𡟨": "rarely-used",
  "𡟩": "rarely-used",
  "𡟪": "rarely-used",
  "𡟫": "rarely-used",
  "𡟭": "rarely-used",
  "𡟯": "rarely-used",
  "𡟰": "rarely-used",
  "𡟴": "rarely-used",
  "𡟷": "rarely-used",
  "𡠑": "rarely-used",
  "𡠒": "rarely-used",
  "𡠓": "rarely-used",
  "𡠙": "rarely-used",
  "𡠚": "rarely-used",
  "𡠞": "rarely-used",
  "𡠥": "rarely-used",
  "𡠦": "rarely-used",
  "𡠧": "rarely-used",
  "𡡂": "rarely-used",
  "𡡈": "rarely-used",
  "𡡉": "rarely-used",
  "𡡊": "rarely-used",
  "𡡌": "rarely-used",
  "𡡏": "rarely-used",
  "𡡐": "rarely-used",
  "𡡑": "rarely-used",
  "𡡒": "rarely-used",
  "𡡔": "rarely-used",
  "𡡕": "rarely-used",
  "𡡖": "rarely-used",
  "𡡙": "rarely-used",
  "𡡥": "rarely-used",
  "𡡨": "rarely-used",
  "𡢆": "rarely-used",
  "𡢇": "rarely-used",
  "𡢈": "rarely-used",
  "𡢊": "rarely-used",
  "𡢑": "rarely-used",
  "𡢒": "rarely-used",
  "𡢕": "rarely-used",
  "𡢖": "rarely-used",
  "𡢚": "rarely-used",
  "𡢜": "rarely-used",
  "𡢱": "rarely-used",
  "𡣀": "rarely-used",
  "𡣁": "rarely-used",
  "𡣂": "rarely-used",
  "𡣈": "rarely-used",
  "𡣋": "rarely-used",
  "𡣏": "rarely-used",
  "𡣔": "rarely-used",
  "𡣪": "rarely-used",
  "𡣫": "rarely-used",
  "𡣮": "rarely-used",
  "𡣯": "rarely-used",
  "𡣽": "rarely-used",
  "𡣾": "rarely-used",
  "𡤋": "rarely-used",
  "𡤌": "rarely-used",
  "𡤒": "rarely-used",
  "𡤖": "rarely-used",
  "𡤗": "rarely-used",
  "𡤙": "rarely-used",
  "𡤛": "rarely-used",
  "𡤢": "rarely-used",
  "𡤫": "rarely-used",
  "𡤶": "rarely-used",
  "𡤺": "rarely-used",
  "𡤿": "rarely-used",
  "𡥈": "rarely-used",
  "𡥉": "rarely-used",
  "𡥍": "rarely-used",
  "𡥎": "rarely-used",
  "𡥩": "rarely-used",
  "𡥭": "rarely-used",
  "𡥶": "rarely-used",
  "𡥹": "rarely-used",
  "𡦃": "rarely-used",
  "𡦄": "rarely-used",
  "𡦆": "rarely-used",
  "𡦎": "rarely-used",
  "𡦏": "rarely-used",
  "𡦕": "rarely-used",
  "𡦝": "rarely-used",
  "𡦢": "rarely-used",
  "𡦵": "rarely-used",
  "𡦼": "rarely-used",
  "𡧍": "rarely-used",
  "𡧖": "rarely-used",
  "𡧗": "rarely-used",
  "𡧙": "rarely-used",
  "𡧩": "rarely-used",
  "𡧬": "rarely-used",
  "𡧭": "rarely-used",
  "𡨀": "rarely-used",
  "𡨂": "rarely-used",
  "𡨃": "rarely-used",
  "𡨄": "rarely-used",
  "𡨅": "rarely-used",
  "𡨊": "rarely-used",
  "𡨟": "rarely-used",
  "𡨠": "rarely-used",
  "𡨢": "rarely-used",
  "𡨣": "rarely-used",
  "𡨩": "rarely-used",
  "𡨻": "rarely-used",
  "𡨽": "rarely-used",
  "𡨿": "rarely-used",
  "𡩂": "rarely-used",
  "𡩃": "rarely-used",
  "𡩄": "rarely-used",
  "𡩆": "rarely-used",
  "𡩇": "rarely-used",
  "𡩡": "rarely-used",
  "𡩣": "rarely-used",
  "𡩥": "rarely-used",
  "𡩩": "rarely-used",
  "𡩽": "rarely-used",
  "𡩾": "rarely-used",
  "𡪁": "rarely-used",
  "𡪅": "rarely-used",
  "𡪗": "rarely-used",
  "𡪠": "rarely-used",
  "𡪺": "rarely-used",
  "𡪽": "rarely-used",
  "𡫀": "rarely-used",
  "𡫁": "rarely-used",
  "𡫂": "rarely-used",
  "𡫃": "rarely-used",
  "𡫔": "rarely-used",
  "𡫝": "rarely-used",
  "𡫟": "rarely-used",
  "𡫬": "rarely-used",
  "𡫯": "rarely-used",
  "𡫽": "rarely-used",
  "𡬄": "rarely-used",
  "𡬅": "rarely-used",
  "𡬇": "rarely-used",
  "𡬌": "rarely-used",
  "𡬍": "rarely-used",
  "𡬓": "rarely-used",
  "𡬖": "rarely-used",
  "𡬘": "rarely-used",
  "𡬙": "rarely-used",
  "𡬧": "rarely-used",
  "𡬳": "rarely-used",
  "𡭂": "rarely-used",
  "𡭋": "rarely-used",
  "𡭐": "rarely-used",
  "𡭚": "rarely-used",
  "𡭞": "rarely-used",
  "𡭥": "rarely-used",
  "𡭳": "rarely-used",
  "𡭴": "rarely-used",
  "𡭾": "rarely-used",
  "𡭿": "rarely-used",
  "𡮙": "rarely-used",
  "𡮞": "rarely-used",
  "𡮦": "rarely-used",
  "𡮰": "rarely-used",
  "𡮻": "rarely-used",
  "𡮿": "rarely-used",
  "𡯄": "rarely-used",
  "𡯍": "rarely-used",
  "𡯏": "rarely-used",
  "𡯐": "rarely-used",
  "𡯒": "rarely-used",
  "𡯖": "rarely-used",
  "𡯘": "rarely-used",
  "𡯙": "rarely-used",
  "𡯜": "rarely-used",
  "𡯡": "rarely-used",
  "𡯢": "rarely-used",
  "𡯦": "rarely-used",
  "𡯨": "rarely-used",
  "𡯬": "rarely-used",
  "𡯳": "rarely-used",
  "𡯴": "rarely-used",
  "𡯵": "rarely-used",
  "𡰇": "rarely-used",
  "𡰋": "rarely-used",
  "𡰌": "rarely-used",
  "𡰎": "rarely-used",
  "𡰖": "rarely-used",
  "𡰝": "rarely-used",
  "𡰠": "rarely-used",
  "𡰢": "rarely-used",
  "𡰥": "rarely-used",
  "𡰫": "rarely-used",
  "𡰽": "rarely-used",
  "𡰾": "rarely-used",
  "𡰿": "rarely-used",
  "𡱂": "rarely-used",
  "𡱋": "rarely-used",
  "𡱌": "rarely-used",
  "𡱏": "rarely-used",
  "𡱐": "rarely-used",
  "𡱑": "rarely-used",
  "𡱡": "rarely-used",
  "𡱣": "rarely-used",
  "𡱥": "rarely-used",
  "𡱰": "rarely-used",
  "𡱱": "rarely-used",
  "𡱷": "rarely-used",
  "𡱼": "rarely-used",
  "𡱽": "rarely-used",
  "𡱾": "rarely-used",
  "𡱿": "rarely-used",
  "𡲀": "rarely-used",
  "𡲁": "rarely-used",
  "𡲗": "rarely-used",
  "𡲚": "rarely-used",
  "𡲛": "rarely-used",
  "𡲜": "rarely-used",
  "𡲪": "rarely-used",
  "𡲭": "rarely-used",
  "𡲮": "rarely-used",
  "𡲰": "rarely-used",
  "𡳂": "rarely-used",
  "𡳄": "rarely-used",
  "𡳆": "rarely-used",
  "𡳏": "rarely-used",
  "𡳑": "rarely-used",
  "𡳘": "rarely-used",
  "𡳞": "rarely-used",
  "𡳭": "rarely-used",
  "𡳴": "rarely-used",
  "𡳸": "rarely-used",
  "𡳾": "rarely-used",
  "𡴅": "rarely-used",
  "𡴆": "rarely-used",
  "𡴎": "rarely-used",
  "𡴒": "rarely-used",
  "𡴞": "rarely-used",
  "𡴭": "rarely-used",
  "𡴯": "rarely-used",
  "𡴻": "rarely-used",
  "𡵋": "rarely-used",
  "𡵑": "rarely-used",
  "𡵔": "rarely-used",
  "𡵕": "rarely-used",
  "𡵖": "rarely-used",
  "𡵘": "rarely-used",
  "𡵙": "rarely-used",
  "𡵚": "rarely-used",
  "𡵛": "rarely-used",
  "𡵜": "rarely-used",
  "𡶂": "rarely-used",
  "𡶃": "rarely-used",
  "𡶄": "rarely-used",
  "𡶈": "rarely-used",
  "𡶉": "rarely-used",
  "𡶋": "rarely-used",
  "𡶎": "rarely-used",
  "𡶐": "rarely-used",
  "𡶑": "rarely-used",
  "𡶪": "rarely-used",
  "𡶭": "rarely-used",
  "𡶯": "rarely-used",
  "𡶱": "rarely-used",
  "𡷓": "rarely-used",
  "𡷔": "rarely-used",
  "𡷕": "rarely-used",
  "𡷖": "rarely-used",
  "𡷗": "rarely-used",
  "𡷘": "rarely-used",
  "𡷙": "rarely-used",
  "𡷛": "rarely-used",
  "𡷜": "rarely-used",
  "𡷝": "rarely-used",
  "𡷞": "rarely-used",
  "𡷠": "rarely-used",
  "𡷡": "rarely-used",
  "𡷢": "rarely-used",
  "𡷥": "rarely-used",
  "𡷨": "rarely-used",
  "𡷸": "rarely-used",
  "𡸈": "rarely-used",
  "𡸉": "rarely-used",
  "𡸊": "rarely-used",
  "𡸌": "rarely-used",
  "𡸎": "rarely-used",
  "𡸑": "rarely-used",
  "𡸗": "rarely-used",
  "𡸛": "rarely-used",
  "𡸜": "rarely-used",
  "𡸤": "rarely-used",
  "𡸥": "rarely-used",
  "𡸦": "rarely-used",
  "𡸨": "rarely-used",
  "𡸩": "rarely-used",
  "𡸪": "rarely-used",
  "𡹢": "rarely-used",
  "𡹣": "rarely-used",
  "𡹤": "rarely-used",
  "𡹥": "rarely-used",
  "𡹧": "rarely-used",
  "𡹨": "rarely-used",
  "𡹩": "rarely-used",
  "𡹪": "rarely-used",
  "𡹬": "rarely-used",
  "𡹯": "rarely-used",
  "𡹰": "rarely-used",
  "𡹲": "rarely-used",
  "𡹳": "rarely-used",
  "𡹵": "rarely-used",
  "𡹶": "rarely-used",
  "𡹷": "rarely-used",
  "𡹸": "rarely-used",
  "𡹹": "rarely-used",
  "𡹼": "rarely-used",
  "𡹾": "rarely-used",
  "𡺊": "rarely-used",
  "𡺔": "rarely-used",
  "𡺫": "rarely-used",
  "𡺭": "rarely-used",
  "𡺮": "rarely-used",
  "𡺯": "rarely-used",
  "𡺴": "rarely-used",
  "𡺵": "rarely-used",
  "𡺷": "rarely-used",
  "𡺽": "rarely-used",
  "𡻑": "rarely-used",
  "𡻘": "rarely-used",
  "𡻙": "rarely-used",
  "𡻚": "rarely-used",
  "𡻝": "rarely-used",
  "𡻞": "rarely-used",
  "𡻟": "rarely-used",
  "𡻠": "rarely-used",
  "𡻡": "rarely-used",
  "𡻢": "rarely-used",
  "𡻣": "rarely-used",
  "𡻤": "rarely-used",
  "𡻧": "rarely-used",
  "𡻨": "rarely-used",
  "𡻩": "rarely-used",
  "𡻬": "rarely-used",
  "𡻮": "rarely-used",
  "𡻯": "rarely-used",
  "𡻰": "rarely-used",
  "𡻵": "rarely-used",
  "𡼊": "rarely-used",
  "𡼎": "rarely-used",
  "𡼓": "rarely-used",
  "𡼖": "rarely-used",
  "𡼚": "rarely-used",
  "𡼛": "rarely-used",
  "𡼜": "rarely-used",
  "𡼬": "rarely-used",
  "𡼺": "rarely-used",
  "𡼽": "rarely-used",
  "𡼾": "rarely-used",
  "𡼿": "rarely-used",
  "𡽁": "rarely-used",
  "𡽂": "rarely-used",
  "𡽄": "rarely-used",
  "𡽅": "rarely-used",
  "𡽆": "rarely-used",
  "𡽉": "rarely-used",
  "𡽊": "rarely-used",
  "𡽛": "rarely-used",
  "𡽜": "rarely-used",
  "𡽝": "rarely-used",
  "𡽞": "rarely-used",
  "𡽠": "rarely-used",
  "𡽣": "rarely-used",
  "𡽧": "rarely-used",
  "𡾀": "rarely-used",
  "𡾅": "rarely-used",
  "𡾇": "rarely-used",
  "𡾈": "rarely-used",
  "𡾉": "rarely-used",
  "𡾌": "rarely-used",
  "𡾔": "rarely-used",
  "𡾕": "rarely-used",
  "𡾙": "rarely-used",
  "𡾛": "rarely-used",
  "𡾜": "rarely-used",
  "𡾮": "rarely-used",
  "𡾰": "rarely-used",
  "𡾱": "rarely-used",
  "𡾻": "rarely-used",
  "𡾼": "rarely-used",
  "𡾽": "rarely-used",
  "𡾾": "rarely-used",
  "𡿇": "rarely-used",
  "𡿈": "rarely-used",
  "𡿉": "rarely-used",
  "𡿑": "rarely-used",
  "𡿕": "rarely-used",
  "𡿖": "rarely-used",
  "𡿛": "rarely-used",
  "𡿝": "rarely-used",
  "𡿠": "rarely-used",
  "𡿡": "rarely-used",
  "𡿢": "rarely-used",
  "𡿥": "rarely-used",
  "𡿨": "rarely-used",
  "𡿩": "rarely-used",
  "𡿪": "rarely-used",
  "𡿭": "rarely-used",
  "𡿯": "rarely-used",
  "𡿰": "rarely-used",
  "𡿾": "rarely-used",
  "𡿿": "rarely-used",
  "𢀁": "rarely-used",
  "𢀄": "rarely-used",
  "𢀊": "rarely-used",
  "𢀘": "rarely-used",
  "𢀙": "rarely-used",
  "𢀜": "rarely-used",
  "𢀶": "rarely-used",
  "𢁁": "rarely-used",
  "𢁂": "rarely-used",
  "𢁄": "rarely-used",
  "𢁒": "rarely-used",
  "𢁕": "rarely-used",
  "𢁖": "rarely-used",
  "𢁗": "rarely-used",
  "𢁘": "rarely-used",
  "𢁢": "rarely-used",
  "𢁤": "rarely-used",
  "𢁧": "rarely-used",
  "𢁩": "rarely-used",
  "𢁪": "rarely-used",
  "𢁬": "rarely-used",
  "𢁮": "rarely-used",
  "𢁱": "rarely-used",
  "𢁹": "rarely-used",
  "𢁻": "rarely-used",
  "𢁼": "rarely-used",
  "𢁽": "rarely-used",
  "𢁾": "rarely-used",
  "𢁿": "rarely-used",
  "𢂀": "rarely-used",
  "𢂁": "rarely-used",
  "𢂃": "rarely-used",
  "𢂆": "rarely-used",
  "𢂊": "rarely-used",
  "𢂍": "rarely-used",
  "𢂏": "rarely-used",
  "𢂐": "rarely-used",
  "𢂒": "rarely-used",
  "𢂓": "rarely-used",
  "𢂔": "rarely-used",
  "𢂕": "rarely-used",
  "𢂗": "rarely-used",
  "𢂘": "rarely-used",
  "𢂝": "rarely-used",
  "𢂱": "rarely-used",
  "𢂴": "rarely-used",
  "𢂶": "rarely-used",
  "𢂷": "rarely-used",
  "𢂹": "rarely-used",
  "𢂺": "rarely-used",
  "𢂼": "rarely-used",
  "𢃀": "rarely-used",
  "𢃍": "rarely-used",
  "𢃎": "rarely-used",
  "𢃏": "rarely-used",
  "𢃐": "rarely-used",
  "𢃑": "rarely-used",
  "𢃒": "rarely-used",
  "𢃔": "rarely-used",
  "𢃕": "rarely-used",
  "𢃗": "rarely-used",
  "𢃘": "rarely-used",
  "𢃜": "rarely-used",
  "𢃮": "rarely-used",
  "𢃯": "rarely-used",
  "𢃰": "rarely-used",
  "𢃱": "rarely-used",
  "𢃳": "rarely-used",
  "𢃴": "rarely-used",
  "𢃵": "rarely-used",
  "𢃺": "rarely-used",
  "𢄄": "rarely-used",
  "𢄅": "rarely-used",
  "𢄇": "rarely-used",
  "𢄊": "rarely-used",
  "𢄋": "rarely-used",
  "𢄌": "rarely-used",
  "𢄍": "rarely-used",
  "𢄎": "rarely-used",
  "𢄏": "rarely-used",
  "𢄐": "rarely-used",
  "𢄓": "rarely-used",
  "𢄔": "rarely-used",
  "𢄚": "rarely-used",
  "𢄜": "rarely-used",
  "𢄞": "rarely-used",
  "𢄡": "rarely-used",
  "𢄢": "rarely-used",
  "𢄣": "rarely-used",
  "𢄤": "rarely-used",
  "𢄦": "rarely-used",
  "𢄧": "rarely-used",
  "𢄰": "rarely-used",
  "𢄱": "rarely-used",
  "𢄲": "rarely-used",
  "𢄳": "rarely-used",
  "𢄶": "rarely-used",
  "𢄷": "rarely-used",
  "𢄸": "rarely-used",
  "𢄹": "rarely-used",
  "𢄺": "rarely-used",
  "𢄼": "rarely-used",
  "𢄽": "rarely-used",
  "𢅉": "rarely-used",
  "𢅊": "rarely-used",
  "𢅋": "rarely-used",
  "𢅎": "rarely-used",
  "𢅑": "rarely-used",
  "𢅒": "rarely-used",
  "𢅕": "rarely-used",
  "𢅗": "rarely-used",
  "𢅚": "rarely-used",
  "𢅟": "rarely-used",
  "𢅠": "rarely-used",
  "𢅡": "rarely-used",
  "𢅩": "rarely-used",
  "𢅪": "rarely-used",
  "𢅫": "rarely-used",
  "𢅮": "rarely-used",
  "𢅯": "rarely-used",
  "𢅰": "rarely-used",
  "𢅵": "rarely-used",
  "𢅹": "rarely-used",
  "𢅽": "rarely-used",
  "𢅾": "rarely-used",
  "𢆅": "rarely-used",
  "𢆉": "rarely-used",
  "𢆋": "rarely-used",
  "𢆚": "rarely-used",
  "𢆜": "rarely-used",
  "𢆢": "rarely-used",
  "𢆳": "rarely-used",
  "𢆶": "rarely-used",
  "𢆷": "rarely-used",
  "𢆸": "rarely-used",
  "𢆽": "rarely-used",
  "𢆾": "rarely-used",
  "𢇇": "rarely-used",
  "𢇋": "rarely-used",
  "𢇌": "rarely-used",
  "𢇗": "rarely-used",
  "𢇘": "rarely-used",
  "𢇚": "rarely-used",
  "𢇞": "rarely-used",
  "𢇤": "rarely-used",
  "𢇥": "rarely-used",
  "𢇦": "rarely-used",
  "𢇧": "rarely-used",
  "𢇨": "rarely-used",
  "𢇰": "rarely-used",
  "𢇲": "rarely-used",
  "𢇳": "rarely-used",
  "𢇴": "rarely-used",
  "𢇵": "rarely-used",
  "𢇶": "rarely-used",
  "𢇷": "rarely-used",
  "𢈂": "rarely-used",
  "𢈄": "rarely-used",
  "𢈇": "rarely-used",
  "𢈈": "rarely-used",
  "𢈉": "rarely-used",
  "𢈋": "rarely-used",
  "𢈙": "rarely-used",
  "𢈚": "rarely-used",
  "𢈛": "rarely-used",
  "𢈜": "rarely-used",
  "𢈝": "rarely-used",
  "𢈠": "rarely-used",
  "𢈡": "rarely-used",
  "𢈢": "rarely-used",
  "𢈤": "rarely-used",
  "𢈲": "rarely-used",
  "𢈳": "rarely-used",
  "𢈴": "rarely-used",
  "𢈵": "rarely-used",
  "𢈶": "rarely-used",
  "𢈸": "rarely-used",
  "𢈻": "rarely-used",
  "𢈼": "rarely-used",
  "𢈽": "rarely-used",
  "𢈾": "rarely-used",
  "𢉁": "rarely-used",
  "𢉂": "rarely-used",
  "𢉃": "rarely-used",
  "𢉅": "rarely-used",
  "𢉆": "rarely-used",
  "𢉘": "rarely-used",
  "𢉚": "rarely-used",
  "𢉜": "rarely-used",
  "𢉝": "rarely-used",
  "𢉞": "rarely-used",
  "𢉟": "rarely-used",
  "𢉢": "rarely-used",
  "𢉤": "rarely-used",
  "𢉥": "rarely-used",
  "𢉦": "rarely-used",
  "𢉩": "rarely-used",
  "𢉭": "rarely-used",
  "𢉿": "rarely-used",
  "𢊀": "rarely-used",
  "𢊄": "rarely-used",
  "𢊅": "rarely-used",
  "𢊇": "rarely-used",
  "𢊒": "rarely-used",
  "𢊓": "rarely-used",
  "𢊕": "rarely-used",
  "𢊖": "rarely-used",
  "𢊗": "rarely-used",
  "𢊘": "rarely-used",
  "𢊛": "rarely-used",
  "𢊜": "rarely-used",
  "𢊮": "rarely-used",
  "𢊯": "rarely-used",
  "𢊰": "rarely-used",
  "𢊱": "rarely-used",
  "𢊲": "rarely-used",
  "𢊵": "rarely-used",
  "𢊶": "rarely-used",
  "𢋂": "rarely-used",
  "𢋃": "rarely-used",
  "𢋄": "rarely-used",
  "𢋅": "rarely-used",
  "𢋆": "rarely-used",
  "𢋇": "rarely-used",
  "𢋌": "rarely-used",
  "𢋒": "rarely-used",
  "𢋚": "rarely-used",
  "𢋝": "rarely-used",
  "𢋣": "rarely-used",
  "𢋱": "rarely-used",
  "𢋲": "rarely-used",
  "𢋸": "rarely-used",
  "𢋻": "rarely-used",
  "𢋼": "rarely-used",
  "𢋿": "rarely-used",
  "𢌄": "rarely-used",
  "𢌈": "rarely-used",
  "𢌍": "rarely-used",
  "𢌔": "rarely-used",
  "𢌕": "rarely-used",
  "𢌦": "rarely-used",
  "𢌫": "rarely-used",
  "𢌳": "rarely-used",
  "𢌻": "rarely-used",
  "𢍁": "rarely-used",
  "𢍏": "rarely-used",
  "𢍚": "rarely-used",
  "𢍣": "rarely-used",
  "𢍫": "rarely-used",
  "𢍰": "rarely-used",
  "𢍱": "rarely-used",
  "𢍿": "rarely-used",
  "𢎃": "rarely-used",
  "𢎌": "rarely-used",
  "𢎎": "rarely-used",
  "𢎘": "rarely-used",
  "𢎙": "rarely-used",
  "𢎪": "rarely-used",
  "𢎫": "rarely-used",
  "𢎭": "rarely-used",
  "𢎷": "rarely-used",
  "𢎹": "rarely-used",
  "𢎻": "rarely-used",
  "𢏅": "rarely-used",
  "𢏆": "rarely-used",
  "𢏕": "rarely-used",
  "𢏙": "rarely-used",
  "𢏤": "rarely-used",
  "𢏦": "rarely-used",
  "𢏧": "rarely-used",
  "𢏪": "rarely-used",
  "𢏮": "rarely-used",
  "𢏯": "rarely-used",
  "𢏰": "rarely-used",
  "𢏳": "rarely-used",
  "𢏷": "rarely-used",
  "𢐂": "rarely-used",
  "𢐃": "rarely-used",
  "𢐄": "rarely-used",
  "𢐆": "rarely-used",
  "𢐊": "rarely-used",
  "𢐒": "rarely-used",
  "𢐔": "rarely-used",
  "𢐞": "rarely-used",
  "𢐟": "rarely-used",
  "𢐦": "rarely-used",
  "𢐲": "rarely-used",
  "𢐳": "rarely-used",
  "𢐷": "rarely-used",
  "𢐾": "rarely-used",
  "𢐿": "rarely-used",
  "𢑄": "rarely-used",
  "𢑆": "rarely-used",
  "𢑇": "rarely-used",
  "𢑊": "rarely-used",
  "𢑓": "rarely-used",
  "𢑢": "rarely-used",
  "𢑦": "rarely-used",
  "𢒉": "rarely-used",
  "𢒐": "rarely-used",
  "𢒑": "rarely-used",
  "𢒔": "rarely-used",
  "𢒝": "rarely-used",
  "𢒯": "rarely-used",
  "𢒲": "rarely-used",
  "𢒹": "rarely-used",
  "𢒾": "rarely-used",
  "𢓀": "rarely-used",
  "𢓃": "rarely-used",
  "𢓄": "rarely-used",
  "𢓆": "rarely-used",
  "𢓋": "rarely-used",
  "𢓒": "rarely-used",
  "𢓔": "rarely-used",
  "𢓖": "rarely-used",
  "𢓗": "rarely-used",
  "𢓜": "rarely-used",
  "𢓞": "rarely-used",
  "𢓟": "rarely-used",
  "𢓢": "rarely-used",
  "𢓣": "rarely-used",
  "𢓬": "rarely-used",
  "𢓮": "rarely-used",
  "𢓯": "rarely-used",
  "𢓰": "rarely-used",
  "𢓱": "rarely-used",
  "𢓳": "rarely-used",
  "𢓵": "rarely-used",
  "𢔁": "rarely-used",
  "𢔂": "rarely-used",
  "𢔅": "rarely-used",
  "𢔆": "rarely-used",
  "𢔇": "rarely-used",
  "𢔈": "rarely-used",
  "𢔊": "rarely-used",
  "𢔑": "rarely-used",
  "𢔟": "rarely-used",
  "𢔠": "rarely-used",
  "𢔡": "rarely-used",
  "𢔢": "rarely-used",
  "𢔣": "rarely-used",
  "𢔤": "rarely-used",
  "𢔥": "rarely-used",
  "𢔧": "rarely-used",
  "𢔩": "rarely-used",
  "𢔪": "rarely-used",
  "𢔱": "rarely-used",
  "𢔳": "rarely-used",
  "𢔴": "rarely-used",
  "𢕍": "rarely-used",
  "𢕎": "rarely-used",
  "𢕑": "rarely-used",
  "𢕓": "rarely-used",
  "𢕔": "rarely-used",
  "𢕘": "rarely-used",
  "𢕙": "rarely-used",
  "𢕚": "rarely-used",
  "𢕞": "rarely-used",
  "𢕪": "rarely-used",
  "𢕫": "rarely-used",
  "𢕬": "rarely-used",
  "𢕭": "rarely-used",
  "𢕮": "rarely-used",
  "𢕯": "rarely-used",
  "𢕺": "rarely-used",
  "𢕻": "rarely-used",
  "𢖄": "rarely-used",
  "𢖈": "rarely-used",
  "𢖎": "rarely-used",
  "𢖏": "rarely-used",
  "𢖑": "rarely-used",
  "𢖗": "rarely-used",
  "𢖝": "rarely-used",
  "𢖟": "rarely-used",
  "𢖤": "rarely-used",
  "𢖦": "rarely-used",
  "𢖧": "rarely-used",
  "𢖩": "rarely-used",
  "𢖫": "rarely-used",
  "𢖬": "rarely-used",
  "𢖳": "rarely-used",
  "𢖵": "rarely-used",
  "𢖷": "rarely-used",
  "𢖺": "rarely-used",
  "𢗇": "rarely-used",
  "𢗈": "rarely-used",
  "𢗉": "rarely-used",
  "𢗊": "rarely-used",
  "𢗲": "rarely-used",
  "𢗹": "rarely-used",
  "𢗺": "rarely-used",
  "𢗿": "rarely-used",
  "𢘃": "rarely-used",
  "𢘆": "rarely-used",
  "𢘉": "rarely-used",
  "𢘊": "rarely-used",
  "𢘋": "rarely-used",
  "𢘌": "rarely-used",
  "𢘏": "rarely-used",
  "𢘸": "rarely-used",
  "𢘺": "rarely-used",
  "𢘼": "rarely-used",
  "𢘽": "rarely-used",
  "𢙁": "rarely-used",
  "𢙂": "rarely-used",
  "𢙅": "rarely-used",
  "𢙇": "rarely-used",
  "𢙈": "rarely-used",
  "𢙮": "rarely-used",
  "𢙱": "rarely-used",
  "𢙲": "rarely-used",
  "𢙳": "rarely-used",
  "𢙺": "rarely-used",
  "𢙾": "rarely-used",
  "𢙿": "rarely-used",
  "𢚀": "rarely-used",
  "𢚁": "rarely-used",
  "𢚂": "rarely-used",
  "𢚅": "rarely-used",
  "𢚋": "rarely-used",
  "𢚌": "rarely-used",
  "𢚎": "rarely-used",
  "𢚑": "rarely-used",
  "𢚗": "rarely-used",
  "𢚺": "rarely-used",
  "𢚻": "rarely-used",
  "𢛃": "rarely-used",
  "𢛄": "rarely-used",
  "𢛆": "rarely-used",
  "𢛉": "rarely-used",
  "𢛍": "rarely-used",
  "𢛎": "rarely-used",
  "𢛒": "rarely-used",
  "𢛓": "rarely-used",
  "𢛔": "rarely-used",
  "𢛕": "rarely-used",
  "𢛖": "rarely-used",
  "𢛘": "rarely-used",
  "𢛛": "rarely-used",
  "𢛜": "rarely-used",
  "𢛞": "rarely-used",
  "𢛟": "rarely-used",
  "𢛥": "rarely-used",
  "𢛦": "rarely-used",
  "𢛨": "rarely-used",
  "𢛮": "rarely-used",
  "𢜗": "rarely-used",
  "𢜩": "rarely-used",
  "𢜪": "rarely-used",
  "𢜫": "rarely-used",
  "𢜬": "rarely-used",
  "𢜭": "rarely-used",
  "𢜮": "rarely-used",
  "𢜱": "rarely-used",
  "𢜳": "rarely-used",
  "𢜴": "rarely-used",
  "𢜵": "rarely-used",
  "𢜶": "rarely-used",
  "𢜸": "rarely-used",
  "𢜹": "rarely-used",
  "𢜻": "rarely-used",
  "𢜽": "rarely-used",
  "𢜿": "rarely-used",
  "𢝀": "rarely-used",
  "𢝁": "rarely-used",
  "𢝂": "rarely-used",
  "𢝄": "rarely-used",
  "𢝅": "rarely-used",
  "𢝆": "rarely-used",
  "𢝇": "rarely-used",
  "𢝈": "rarely-used",
  "𢝉": "rarely-used",
  "𢝊": "rarely-used",
  "𢝌": "rarely-used",
  "𢝍": "rarely-used",
  "𢝓": "rarely-used",
  "𢝗": "rarely-used",
  "𢝞": "rarely-used",
  "𢝟": "rarely-used",
  "𢞇": "rarely-used",
  "𢞉": "rarely-used",
  "𢞊": "rarely-used",
  "𢞎": "rarely-used",
  "𢞏": "rarely-used",
  "𢞐": "rarely-used",
  "𢞒": "rarely-used",
  "𢞓": "rarely-used",
  "𢞕": "rarely-used",
  "𢞖": "rarely-used",
  "𢞗": "rarely-used",
  "𢞚": "rarely-used",
  "𢞜": "rarely-used",
  "𢞟": "rarely-used",
  "𢞠": "rarely-used",
  "𢞡": "rarely-used",
  "𢞦": "rarely-used",
  "𢞬": "rarely-used",
  "𢞭": "rarely-used",
  "𢞮": "rarely-used",
  "𢞲": "rarely-used",
  "𢟊": "rarely-used",
  "𢟢": "rarely-used",
  "𢟣": "rarely-used",
  "𢟤": "rarely-used",
  "𢟧": "rarely-used",
  "𢟨": "rarely-used",
  "𢟩": "rarely-used",
  "𢟪": "rarely-used",
  "𢟯": "rarely-used",
  "𢟰": "rarely-used",
  "𢟱": "rarely-used",
  "𢟲": "rarely-used",
  "𢟳": "rarely-used",
  "𢟴": "rarely-used",
  "𢟵": "rarely-used",
  "𢟾": "rarely-used",
  "𢟿": "rarely-used",
  "𢠠": "rarely-used",
  "𢠬": "rarely-used",
  "𢠮": "rarely-used",
  "𢠲": "rarely-used",
  "𢠷": "rarely-used",
  "𢠹": "rarely-used",
  "𢠺": "rarely-used",
  "𢠼": "rarely-used",
  "𢠿": "rarely-used",
  "𢡀": "rarely-used",
  "𢡁": "rarely-used",
  "𢡂": "rarely-used",
  "𢡃": "rarely-used",
  "𢡅": "rarely-used",
  "𢡇": "rarely-used",
  "𢡈": "rarely-used",
  "𢡉": "rarely-used",
  "𢡎": "rarely-used",
  "𢡏": "rarely-used",
  "𢡐": "rarely-used",
  "𢡑": "rarely-used",
  "𢡒": "rarely-used",
  "𢡤": "rarely-used",
  "𢡴": "rarely-used",
  "𢢌": "rarely-used",
  "𢢍": "rarely-used",
  "𢢒": "rarely-used",
  "𢢓": "rarely-used",
  "𢢖": "rarely-used",
  "𢢗": "rarely-used",
  "𢢘": "rarely-used",
  "𢢜": "rarely-used",
  "𢢞": "rarely-used",
  "𢢤": "rarely-used",
  "𢢰": "rarely-used",
  "𢣉": "rarely-used",
  "𢣊": "rarely-used",
  "𢣎": "rarely-used",
  "𢣏": "rarely-used",
  "𢣐": "rarely-used",
  "𢣒": "rarely-used",
  "𢣓": "rarely-used",
  "𢣔": "rarely-used",
  "𢣘": "rarely-used",
  "𢣙": "rarely-used",
  "𢣚": "rarely-used",
  "𢣝": "rarely-used",
  "𢣞": "rarely-used",
  "𢣠": "rarely-used",
  "𢣻": "rarely-used",
  "𢣼": "rarely-used",
  "𢣿": "rarely-used",
  "𢤁": "rarely-used",
  "𢤂": "rarely-used",
  "𢤄": "rarely-used",
  "𢤆": "rarely-used",
  "𢤇": "rarely-used",
  "𢤋": "rarely-used",
  "𢤎": "rarely-used",
  "𢤐": "rarely-used",
  "𢤖": "rarely-used",
  "𢤘": "rarely-used",
  "𢤤": "rarely-used",
  "𢤩": "rarely-used",
  "𢤫": "rarely-used",
  "𢤯": "rarely-used",
  "𢤰": "rarely-used",
  "𢤱": "rarely-used",
  "𢤲": "rarely-used",
  "𢤶": "rarely-used",
  "𢥃": "rarely-used",
  "𢥄": "rarely-used",
  "𢥋": "rarely-used",
  "𢥌": "rarely-used",
  "𢥏": "rarely-used",
  "𢥘": "rarely-used",
  "𢥚": "rarely-used",
  "𢥰": "rarely-used",
  "𢥻": "rarely-used",
  "𢥽": "rarely-used",
  "𢦅": "rarely-used",
  "𢦈": "rarely-used",
  "𢦉": "rarely-used",
  "𢦎": "rarely-used",
  "𢦏": "rarely-used",
  "𢦔": "rarely-used",
  "𢦚": "rarely-used",
  "𢦟": "rarely-used",
  "𢦪": "rarely-used",
  "𢦸": "rarely-used",
  "𢦺": "rarely-used",
  "𢦿": "rarely-used",
  "𢧀": "rarely-used",
  "𢧇": "rarely-used",
  "𢧌": "rarely-used",
  "𢧑": "rarely-used",
  "𢧒": "rarely-used",
  "𢧖": "rarely-used",
  "𢧘": "rarely-used",
  "𢧜": "rarely-used",
  "𢧠": "rarely-used",
  "𢧥": "rarely-used",
  "𢧦": "rarely-used",
  "𢧧": "rarely-used",
  "𢧩": "rarely-used",
  "𢧳": "rarely-used",
  "𢧴": "rarely-used",
  "𢨔": "rarely-used",
  "𢨟": "rarely-used",
  "𢨡": "rarely-used",
  "𢨥": "rarely-used",
  "𢨯": "rarely-used",
  "𢨺": "rarely-used",
  "𢩄": "rarely-used",
  "𢩈": "rarely-used",
  "𢩋": "rarely-used",
  "𢩑": "rarely-used",
  "𢩒": "rarely-used",
  "𢩓": "rarely-used",
  "𢩕": "rarely-used",
  "𢩖": "rarely-used",
  "𢩘": "rarely-used",
  "𢩠": "rarely-used",
  "𢩢": "rarely-used",
  "𢩦": "rarely-used",
  "𢩫": "rarely-used",
  "𢩬": "rarely-used",
  "𢩰": "rarely-used",
  "𢩱": "rarely-used",
  "𢩲": "rarely-used",
  "𢩴": "rarely-used",
  "𢪂": "rarely-used",
  "𢪃": "rarely-used",
  "𢪇": "rarely-used",
  "𢪈": "rarely-used",
  "𢪊": "rarely-used",
  "𢪋": "rarely-used",
  "𢪍": "rarely-used",
  "𢪎": "rarely-used",
  "𢪕": "rarely-used",
  "𢪷": "rarely-used",
  "𢪸": "rarely-used",
  "𢪼": "rarely-used",
  "𢪾": "rarely-used",
  "𢫢": "rarely-used",
  "𢫧": "rarely-used",
  "𢫨": "rarely-used",
  "𢫫": "rarely-used",
  "𢫬": "rarely-used",
  "𢫭": "rarely-used",
  "𢫯": "rarely-used",
  "𢫰": "rarely-used",
  "𢫲": "rarely-used",
  "𢫳": "rarely-used",
  "𢫴": "rarely-used",
  "𢫵": "rarely-used",
  "𢫷": "rarely-used",
  "𢫺": "rarely-used",
  "𢫻": "rarely-used",
  "𢫿": "rarely-used",
  "𢬀": "rarely-used",
  "𢬪": "rarely-used",
  "𢬫": "rarely-used",
  "𢬬": "rarely-used",
  "𢬱": "rarely-used",
  "𢬲": "rarely-used",
  "𢬳": "rarely-used",
  "𢬴": "rarely-used",
  "𢬵": "rarely-used",
  "𢬶": "rarely-used",
  "𢬷": "rarely-used",
  "𢬼": "rarely-used",
  "𢬿": "rarely-used",
  "𢭁": "rarely-used",
  "𢭂": "rarely-used",
  "𢭃": "rarely-used",
  "𢭄": "rarely-used",
  "𢭅": "rarely-used",
  "𢭆": "rarely-used",
  "𢭈": "rarely-used",
  "𢭎": "rarely-used",
  "𢮁": "rarely-used",
  "𢮂": "rarely-used",
  "𢮃": "rarely-used",
  "𢮄": "rarely-used",
  "𢮇": "rarely-used",
  "𢮉": "rarely-used",
  "𢮊": "rarely-used",
  "𢮌": "rarely-used",
  "𢮍": "rarely-used",
  "𢮎": "rarely-used",
  "𢮏": "rarely-used",
  "𢮐": "rarely-used",
  "𢮒": "rarely-used",
  "𢮚": "rarely-used",
  "𢮝": "rarely-used",
  "𢮡": "rarely-used",
  "𢮨": "rarely-used",
  "𢯈": "rarely-used",
  "𢯩": "rarely-used",
  "𢯫": "rarely-used",
  "𢯮": "rarely-used",
  "𢯰": "rarely-used",
  "𢯳": "rarely-used",
  "𢯴": "rarely-used",
  "𢯵": "rarely-used",
  "𢯶": "rarely-used",
  "𢯷": "rarely-used",
  "𢯸": "rarely-used",
  "𢯹": "rarely-used",
  "𢯺": "rarely-used",
  "𢯻": "rarely-used",
  "𢯼": "rarely-used",
  "𢯽": "rarely-used",
  "𢯾": "rarely-used",
  "𢰂": "rarely-used",
  "𢰆": "rarely-used",
  "𢰇": "rarely-used",
  "𢰊": "rarely-used",
  "𢰋": "rarely-used",
  "𢰍": "rarely-used",
  "𢰖": "rarely-used",
  "𢰘": "rarely-used",
  "𢰙": "rarely-used",
  "𢰜": "rarely-used",
  "𢱇": "rarely-used",
  "𢱟": "rarely-used",
  "𢱡": "rarely-used",
  "𢱢": "rarely-used",
  "𢱣": "rarely-used",
  "𢱤": "rarely-used",
  "𢱦": "rarely-used",
  "𢱨": "rarely-used",
  "𢱫": "rarely-used",
  "𢱬": "rarely-used",
  "𢱮": "rarely-used",
  "𢱴": "rarely-used",
  "𢱶": "rarely-used",
  "𢱷": "rarely-used",
  "𢱺": "rarely-used",
  "𢱾": "rarely-used",
  "𢲀": "rarely-used",
  "𢲰": "rarely-used",
  "𢲴": "rarely-used",
  "𢲵": "rarely-used",
  "𢲶": "rarely-used",
  "𢲸": "rarely-used",
  "𢲼": "rarely-used",
  "𢲾": "rarely-used",
  "𢳁": "rarely-used",
  "𢳂": "rarely-used",
  "𢳄": "rarely-used",
  "𢳆": "rarely-used",
  "𢳇": "rarely-used",
  "𢳋": "rarely-used",
  "𢳑": "rarely-used",
  "𢳓": "rarely-used",
  "𢳙": "rarely-used",
  "𢳚": "rarely-used",
  "𢴢": "rarely-used",
  "𢴧": "rarely-used",
  "𢴨": "rarely-used",
  "𢴩": "rarely-used",
  "𢴪": "rarely-used",
  "𢴬": "rarely-used",
  "𢴮": "rarely-used",
  "𢴰": "rarely-used",
  "𢴲": "rarely-used",
  "𢴳": "rarely-used",
  "𢴼": "rarely-used",
  "𢴾": "rarely-used",
  "𢵈": "rarely-used",
  "𢶀": "rarely-used",
  "𢶃": "rarely-used",
  "𢶄": "rarely-used",
  "𢶉": "rarely-used",
  "𢶋": "rarely-used",
  "𢶌": "rarely-used",
  "𢶍": "rarely-used",
  "𢶒": "rarely-used",
  "𢶙": "rarely-used",
  "𢶚": "rarely-used",
  "𢷋": "rarely-used",
  "𢷍": "rarely-used",
  "𢷕": "rarely-used",
  "𢷖": "rarely-used",
  "𢷗": "rarely-used",
  "𢷶": "rarely-used",
  "𢷸": "rarely-used",
  "𢷹": "rarely-used",
  "𢷺": "rarely-used",
  "𢷻": "rarely-used",
  "𢸀": "rarely-used",
  "𢸁": "rarely-used",
  "𢸣": "rarely-used",
  "𢸥": "rarely-used",
  "𢸧": "rarely-used",
  "𢸫": "rarely-used",
  "𢸭": "rarely-used",
  "𢸴": "rarely-used",
  "𢹍": "rarely-used",
  "𢹏": "rarely-used",
  "𢹘": "rarely-used",
  "𢹙": "rarely-used",
  "𢹚": "rarely-used",
  "𢹮": "rarely-used",
  "𢹳": "rarely-used",
  "𢺄": "rarely-used",
  "𢺅": "rarely-used",
  "𢺆": "rarely-used",
  "𢺈": "rarely-used",
  "𢺉": "rarely-used",
  "𢺑": "rarely-used",
  "𢺟": "rarely-used",
  "𢺡": "rarely-used",
  "𢺰": "rarely-used",
  "𢺵": "rarely-used",
  "𢻂": "rarely-used",
  "𢻃": "rarely-used",
  "𢻔": "rarely-used",
  "𢻚": "rarely-used",
  "𢻠": "rarely-used",
  "𢻧": "rarely-used",
  "𢻬": "rarely-used",
  "𢻮": "rarely-used",
  "𢻱": "rarely-used",
  "𢻶": "rarely-used",
  "𢻷": "rarely-used",
  "𢻹": "rarely-used",
  "𢼆": "rarely-used",
  "𢼇": "rarely-used",
  "𢼈": "rarely-used",
  "𢼋": "rarely-used",
  "𢼌": "rarely-used",
  "𢼐": "rarely-used",
  "𢼑": "rarely-used",
  "𢼔": "rarely-used",
  "𢼕": "rarely-used",
  "𢼟": "rarely-used",
  "𢼣": "rarely-used",
  "𢼧": "rarely-used",
  "𢼨": "rarely-used",
  "𢼬": "rarely-used",
  "𢼭": "rarely-used",
  "𢼶": "rarely-used",
  "𢼺": "rarely-used",
  "𢼽": "rarely-used",
  "𢽂": "rarely-used",
  "𢽃": "rarely-used",
  "𢽄": "rarely-used",
  "𢽇": "rarely-used",
  "𢽊": "rarely-used",
  "𢽋": "rarely-used",
  "𢽏": "rarely-used",
  "𢽐": "rarely-used",
  "𢽗": "rarely-used",
  "𢽝": "rarely-used",
  "𢽦": "rarely-used",
  "𢽧": "rarely-used",
  "𢽨": "rarely-used",
  "𢽩": "rarely-used",
  "𢽪": "rarely-used",
  "𢽭": "rarely-used",
  "𢽲": "rarely-used",
  "𢽳": "rarely-used",
  "𢽴": "rarely-used",
  "𢽵": "rarely-used",
  "𢽶": "rarely-used",
  "𢽷": "rarely-used",
  "𢾀": "rarely-used",
  "𢾂": "rarely-used",
  "𢾃": "rarely-used",
  "𢾄": "rarely-used",
  "𢾅": "rarely-used",
  "𢾒": "rarely-used",
  "𢾔": "rarely-used",
  "𢾚": "rarely-used",
  "𢾛": "rarely-used",
  "𢾜": "rarely-used",
  "𢾝": "rarely-used",
  "𢾡": "rarely-used",
  "𢾣": "rarely-used",
  "𢾤": "rarely-used",
  "𢾧": "rarely-used",
  "𢾩": "rarely-used",
  "𢾫": "rarely-used",
  "𢾬": "rarely-used",
  "𢾮": "rarely-used",
  "𢾱": "rarely-used",
  "𢾳": "rarely-used",
  "𢾺": "rarely-used",
  "𢾼": "rarely-used",
  "𢾽": "rarely-used",
  "𢿆": "rarely-used",
  "𢿇": "rarely-used",
  "𢿈": "rarely-used",
  "𢿎": "rarely-used",
  "𢿓": "rarely-used",
  "𢿕": "rarely-used",
  "𢿖": "rarely-used",
  "𢿞": "rarely-used",
  "𢿤": "rarely-used",
  "𢿭": "rarely-used",
  "𢿲": "rarely-used",
  "𢿳": "rarely-used",
  "𢿴": "rarely-used",
  "𢿵": "rarely-used",
  "𢿸": "rarely-used",
  "𢿽": "rarely-used",
  "𣀀": "rarely-used",
  "𣀁": "rarely-used",
  "𣀂": "rarely-used",
  "𣀆": "rarely-used",
  "𣀉": "rarely-used",
  "𣀊": "rarely-used",
  "𣀏": "rarely-used",
  "𣀐": "rarely-used",
  "𣀒": "rarely-used",
  "𣀔": "rarely-used",
  "𣀘": "rarely-used",
  "𣀝": "rarely-used",
  "𣀞": "rarely-used",
  "𣀠": "rarely-used",
  "𣀡": "rarely-used",
  "𣀣": "rarely-used",
  "𣀥": "rarely-used",
  "𣀧": "rarely-used",
  "𣀫": "rarely-used",
  "𣀯": "rarely-used",
  "𣀱": "rarely-used",
  "𣀳": "rarely-used",
  "𣀶": "rarely-used",
  "𣀷": "rarely-used",
  "𣀼": "rarely-used",
  "𣁗": "rarely-used",
  "𣁜": "rarely-used",
  "𣁟": "rarely-used",
  "𣁢": "rarely-used",
  "𣁳": "rarely-used",
  "𣁴": "rarely-used",
  "𣁵": "rarely-used",
  "𣁷": "rarely-used",
  "𣂁": "rarely-used",
  "𣂄": "rarely-used",
  "𣂆": "rarely-used",
  "𣂉": "rarely-used",
  "𣂞": "rarely-used",
  "𣂤": "rarely-used",
  "𣂮": "rarely-used",
  "𣂵": "rarely-used",
  "𣂻": "rarely-used",
  "𣂽": "rarely-used",
  "𣂿": "rarely-used",
  "𣃈": "rarely-used",
  "𣃍": "rarely-used",
  "𣃘": "rarely-used",
  "𣃝": "rarely-used",
  "𣃦": "rarely-used",
  "𣃧": "rarely-used",
  "𣃳": "rarely-used",
  "𣃽": "rarely-used",
  "𣃾": "rarely-used",
  "𣄉": "rarely-used",
  "𣄎": "rarely-used",
  "𣄏": "rarely-used",
  "𣄑": "rarely-used",
  "𣄙": "rarely-used",
  "𣄝": "rarely-used",
  "𣄟": "rarely-used",
  "𣄠": "rarely-used",
  "𣄧": "rarely-used",
  "𣄮": "rarely-used",
  "𣄰": "rarely-used",
  "𣄱": "rarely-used",
  "𣄲": "rarely-used",
  "𣄴": "rarely-used",
  "𣄸": "rarely-used",
  "𣄿": "rarely-used",
  "𣅉": "rarely-used",
  "𣅚": "rarely-used",
  "𣅝": "rarely-used",
  "𣅟": "rarely-used",
  "𣅡": "rarely-used",
  "𣅤": "rarely-used",
  "𣅥": "rarely-used",
  "𣅷": "rarely-used",
  "𣅺": "rarely-used",
  "𣅻": "rarely-used",
  "𣆒": "rarely-used",
  "𣆔": "rarely-used",
  "𣆕": "rarely-used",
  "𣆖": "rarely-used",
  "𣆗": "rarely-used",
  "𣆘": "rarely-used",
  "𣆙": "rarely-used",
  "𣆝": "rarely-used",
  "𣆲": "rarely-used",
  "𣆳": "rarely-used",
  "𣆴": "rarely-used",
  "𣆽": "rarely-used",
  "𣇢": "rarely-used",
  "𣇦": "rarely-used",
  "𣇧": "rarely-used",
  "𣇩": "rarely-used",
  "𣇫": "rarely-used",
  "𣇬": "rarely-used",
  "𣇰": "rarely-used",
  "𣇲": "rarely-used",
  "𣈠": "rarely-used",
  "𣈡": "rarely-used",
  "𣈥": "rarely-used",
  "𣉄": "rarely-used",
  "𣉑": "rarely-used",
  "𣉒": "rarely-used",
  "𣉓": "rarely-used",
  "𣉔": "rarely-used",
  "𣉕": "rarely-used",
  "𣉗": "rarely-used",
  "𣉘": "rarely-used",
  "𣉙": "rarely-used",
  "𣉚": "rarely-used",
  "𣉛": "rarely-used",
  "𣉜": "rarely-used",
  "𣉪": "rarely-used",
  "𣉿": "rarely-used",
  "𣊁": "rarely-used",
  "𣊔": "rarely-used",
  "𣊝": "rarely-used",
  "𣊞": "rarely-used",
  "𣊟": "rarely-used",
  "𣊶": "rarely-used",
  "𣋄": "rarely-used",
  "𣋊": "rarely-used",
  "𣋋": "rarely-used",
  "𣋍": "rarely-used",
  "𣋞": "rarely-used",
  "𣋟": "rarely-used",
  "𣋣": "rarely-used",
  "𣋲": "rarely-used",
  "𣋵": "rarely-used",
  "𣋶": "rarely-used",
  "𣋿": "rarely-used",
  "𣌅": "rarely-used",
  "𣌏": "rarely-used",
  "𣌓": "rarely-used",
  "𣌗": "rarely-used",
  "𣌜": "rarely-used",
  "𣌧": "rarely-used",
  "𣌨": "rarely-used",
  "𣌾": "rarely-used",
  "𣍆": "rarely-used",
  "𣍇": "rarely-used",
  "𣍏": "rarely-used",
  "𣍒": "rarely-used",
  "𣍖": "rarely-used",
  "𣍛": "rarely-used",
  "𣍟": "rarely-used",
  "𣍥": "rarely-used",
  "𣍦": "rarely-used",
  "𣍴": "rarely-used",
  "𣍺": "rarely-used",
  "𣎅": "rarely-used",
  "𣎓": "rarely-used",
  "𣎔": "rarely-used",
  "𣎗": "rarely-used",
  "𣎚": "rarely-used",
  "𣎛": "rarely-used",
  "𣎜": "rarely-used",
  "𣎟": "rarely-used",
  "𣎩": "rarely-used",
  "𣎮": "rarely-used",
  "𣎱": "rarely-used",
  "𣎲": "rarely-used",
  "𣎳": "rarely-used",
  "𣎴": "rarely-used",
  "𣎵": "rarely-used",
  "𣎸": "rarely-used",
  "𣎺": "rarely-used",
  "𣏀": "rarely-used",
  "𣏋": "rarely-used",
  "𣏑": "rarely-used",
  "𣏒": "rarely-used",
  "𣏕": "rarely-used",
  "𣏖": "rarely-used",
  "𣏗": "rarely-used",
  "𣏙": "rarely-used",
  "𣏚": "rarely-used",
  "𣏞": "rarely-used",
  "𣏟": "rarely-used",
  "𣏠": "rarely-used",
  "𣏡": "rarely-used",
  "𣏶": "rarely-used",
  "𣐃": "rarely-used",
  "𣐊": "rarely-used",
  "𣐋": "rarely-used",
  "𣐎": "rarely-used",
  "𣐏": "rarely-used",
  "𣐑": "rarely-used",
  "𣐒": "rarely-used",
  "𣐓": "rarely-used",
  "𣐰": "rarely-used",
  "𣐻": "rarely-used",
  "𣐿": "rarely-used",
  "𣑁": "rarely-used",
  "𣑂": "rarely-used",
  "𣑃": "rarely-used",
  "𣑫": "rarely-used",
  "𣑸": "rarely-used",
  "𣑹": "rarely-used",
  "𣒂": "rarely-used",
  "𣒃": "rarely-used",
  "𣒄": "rarely-used",
  "𣒆": "rarely-used",
  "𣒇": "rarely-used",
  "𣒷": "rarely-used",
  "𣒸": "rarely-used",
  "𣒹": "rarely-used",
  "𣒺": "rarely-used",
  "𣒻": "rarely-used",
  "𣓃": "rarely-used",
  "𣓅": "rarely-used",
  "𣓆": "rarely-used",
  "𣓈": "rarely-used",
  "𣓉": "rarely-used",
  "𣓊": "rarely-used",
  "𣓋": "rarely-used",
  "𣓌": "rarely-used",
  "𣓏": "rarely-used",
  "𣓒": "rarely-used",
  "𣓔": "rarely-used",
  "𣓕": "rarely-used",
  "𣓗": "rarely-used",
  "𣓛": "rarely-used",
  "𣓝": "rarely-used",
  "𣓧": "rarely-used",
  "𣔓": "rarely-used",
  "𣔫": "rarely-used",
  "𣔬": "rarely-used",
  "𣔭": "rarely-used",
  "𣔮": "rarely-used",
  "𣔯": "rarely-used",
  "𣔵": "rarely-used",
  "𣔷": "rarely-used",
  "𣔸": "rarely-used",
  "𣔹": "rarely-used",
  "𣔺": "rarely-used",
  "𣔻": "rarely-used",
  "𣔽": "rarely-used",
  "𣔿": "rarely-used",
  "𣕁": "rarely-used",
  "𣕂": "rarely-used",
  "𣕄": "rarely-used",
  "𣕅": "rarely-used",
  "𣕇": "rarely-used",
  "𣕌": "rarely-used",
  "𣕎": "rarely-used",
  "𣖣": "rarely-used",
  "𣖤": "rarely-used",
  "𣖨": "rarely-used",
  "𣖪": "rarely-used",
  "𣖫": "rarely-used",
  "𣖬": "rarely-used",
  "𣖭": "rarely-used",
  "𣖮": "rarely-used",
  "𣖰": "rarely-used",
  "𣖱": "rarely-used",
  "𣖵": "rarely-used",
  "𣖷": "rarely-used",
  "𣖸": "rarely-used",
  "𣖹": "rarely-used",
  "𣖻": "rarely-used",
  "𣖼": "rarely-used",
  "𣖾": "rarely-used",
  "𣖿": "rarely-used",
  "𣗁": "rarely-used",
  "𣗃": "rarely-used",
  "𣗐": "rarely-used",
  "𣗺": "rarely-used",
  "𣗻": "rarely-used",
  "𣘖": "rarely-used",
  "𣘗": "rarely-used",
  "𣘘": "rarely-used",
  "𣘚": "rarely-used",
  "𣘛": "rarely-used",
  "𣘟": "rarely-used",
  "𣘠": "rarely-used",
  "𣘣": "rarely-used",
  "𣘤": "rarely-used",
  "𣘥": "rarely-used",
  "𣘦": "rarely-used",
  "𣘧": "rarely-used",
  "𣘨": "rarely-used",
  "𣘪": "rarely-used",
  "𣘬": "rarely-used",
  "𣘮": "rarely-used",
  "𣘯": "rarely-used",
  "𣘱": "rarely-used",
  "𣘲": "rarely-used",
  "𣘻": "rarely-used",
  "𣙤": "rarely-used",
  "𣙰": "rarely-used",
  "𣙱": "rarely-used",
  "𣙴": "rarely-used",
  "𣙵": "rarely-used",
  "𣙶": "rarely-used",
  "𣙻": "rarely-used",
  "𣙼": "rarely-used",
  "𣙿": "rarely-used",
  "𣚀": "rarely-used",
  "𣚄": "rarely-used",
  "𣚇": "rarely-used",
  "𣚌": "rarely-used",
  "𣚎": "rarely-used",
  "𣚏": "rarely-used",
  "𣚒": "rarely-used",
  "𣚔": "rarely-used",
  "𣚕": "rarely-used",
  "𣚘": "rarely-used",
  "𣚙": "rarely-used",
  "𣚝": "rarely-used",
  "𣚟": "rarely-used",
  "𣚠": "rarely-used",
  "𣚡": "rarely-used",
  "𣚢": "rarely-used",
  "𣚣": "rarely-used",
  "𣚩": "rarely-used",
  "𣚪": "rarely-used",
  "𣚯": "rarely-used",
  "𣛫": "rarely-used",
  "𣛱": "rarely-used",
  "𣛴": "rarely-used",
  "𣛷": "rarely-used",
  "𣛸": "rarely-used",
  "𣛹": "rarely-used",
  "𣛺": "rarely-used",
  "𣛻": "rarely-used",
  "𣛽": "rarely-used",
  "𣜁": "rarely-used",
  "𣜂": "rarely-used",
  "𣜄": "rarely-used",
  "𣜆": "rarely-used",
  "𣜇": "rarely-used",
  "𣜍": "rarely-used",
  "𣜤": "rarely-used",
  "𣜹": "rarely-used",
  "𣜺": "rarely-used",
  "𣝁": "rarely-used",
  "𣝂": "rarely-used",
  "𣝅": "rarely-used",
  "𣝇": "rarely-used",
  "𣝈": "rarely-used",
  "𣝉": "rarely-used",
  "𣝋": "rarely-used",
  "𣝌": "rarely-used",
  "𣝍": "rarely-used",
  "𣝎": "rarely-used",
  "𣝏": "rarely-used",
  "𣝑": "rarely-used",
  "𣝒": "rarely-used",
  "𣝓": "rarely-used",
  "𣝕": "rarely-used",
  "𣝘": "rarely-used",
  "𣝚": "rarely-used",
  "𣝜": "rarely-used",
  "𣝝": "rarely-used",
  "𣝞": "rarely-used",
  "𣝥": "rarely-used",
  "𣝾": "rarely-used",
  "𣞆": "rarely-used",
  "𣞇": "rarely-used",
  "𣞐": "rarely-used",
  "𣞒": "rarely-used",
  "𣞓": "rarely-used",
  "𣞔": "rarely-used",
  "𣞗": "rarely-used",
  "𣞙": "rarely-used",
  "𣞜": "rarely-used",
  "𣞝": "rarely-used",
  "𣞟": "rarely-used",
  "𣞰": "rarely-used",
  "𣞷": "rarely-used",
  "𣟆": "rarely-used",
  "𣟈": "rarely-used",
  "𣟉": "rarely-used",
  "𣟊": "rarely-used",
  "𣟋": "rarely-used",
  "𣟌": "rarely-used",
  "𣟎": "rarely-used",
  "𣟏": "rarely-used",
  "𣟐": "rarely-used",
  "𣟑": "rarely-used",
  "𣟒": "rarely-used",
  "𣟘": "rarely-used",
  "𣟲": "rarely-used",
  "𣟳": "rarely-used",
  "𣟵": "rarely-used",
  "𣟸": "rarely-used",
  "𣟹": "rarely-used",
  "𣟺": "rarely-used",
  "𣟼": "rarely-used",
  "𣟽": "rarely-used",
  "𣠎": "rarely-used",
  "𣠏": "rarely-used",
  "𣠔": "rarely-used",
  "𣠚": "rarely-used",
  "𣠛": "rarely-used",
  "𣠜": "rarely-used",
  "𣠝": "rarely-used",
  "𣠞": "rarely-used",
  "𣠟": "rarely-used",
  "𣠠": "rarely-used",
  "𣠷": "rarely-used",
  "𣠸": "rarely-used",
  "𣠹": "rarely-used",
  "𣠺": "rarely-used",
  "𣠼": "rarely-used",
  "𣠾": "rarely-used",
  "𣡀": "rarely-used",
  "𣡉": "rarely-used",
  "𣡊": "rarely-used",
  "𣡎": "rarely-used",
  "𣡠": "rarely-used",
  "𣡥": "rarely-used",
  "𣡧": "rarely-used",
  "𣡩": "rarely-used",
  "𣡭": "rarely-used",
  "𣡶": "rarely-used",
  "𣢁": "rarely-used",
  "𣢅": "rarely-used",
  "𣢇": "rarely-used",
  "𣢉": "rarely-used",
  "𣢊": "rarely-used",
  "𣢋": "rarely-used",
  "𣢍": "rarely-used",
  "𣢏": "rarely-used",
  "𣢐": "rarely-used",
  "𣢑": "rarely-used",
  "𣢒": "rarely-used",
  "𣢓": "rarely-used",
  "𣢗": "rarely-used",
  "𣢛": "rarely-used",
  "𣢜": "rarely-used",
  "𣢝": "rarely-used",
  "𣢞": "rarely-used",
  "𣢠": "rarely-used",
  "𣢡": "rarely-used",
  "𣢣": "rarely-used",
  "𣢪": "rarely-used",
  "𣢬": "rarely-used",
  "𣢯": "rarely-used",
  "𣢰": "rarely-used",
  "𣢱": "rarely-used",
  "𣢲": "rarely-used",
  "𣢳": "rarely-used",
  "𣢴": "rarely-used",
  "𣢺": "rarely-used",
  "𣣈": "rarely-used",
  "𣣉": "rarely-used",
  "𣣊": "rarely-used",
  "𣣋": "rarely-used",
  "𣣌": "rarely-used",
  "𣣎": "rarely-used",
  "𣣏": "rarely-used",
  "𣣑": "rarely-used",
  "𣣒": "rarely-used",
  "𣣕": "rarely-used",
  "𣣞": "rarely-used",
  "𣣟": "rarely-used",
  "𣣠": "rarely-used",
  "𣣢": "rarely-used",
  "𣣩": "rarely-used",
  "𣣲": "rarely-used",
  "𣣳": "rarely-used",
  "𣣴": "rarely-used",
  "𣣸": "rarely-used",
  "𣣹": "rarely-used",
  "𣣼": "rarely-used",
  "𣣿": "rarely-used",
  "𣤇": "rarely-used",
  "𣤈": "rarely-used",
  "𣤊": "rarely-used",
  "𣤋": "rarely-used",
  "𣤌": "rarely-used",
  "𣤔": "rarely-used",
  "𣤘": "rarely-used",
  "𣤢": "rarely-used",
  "𣤩": "rarely-used",
  "𣤬": "rarely-used",
  "𣤭": "rarely-used",
  "𣤱": "rarely-used",
  "𣤴": "rarely-used",
  "𣤵": "rarely-used",
  "𣤶": "rarely-used",
  "𣤷": "rarely-used",
  "𣤹": "rarely-used",
  "𣥀": "rarely-used",
  "𣥂": "rarely-used",
  "𣥃": "rarely-used",
  "𣥇": "rarely-used",
  "𣥊": "rarely-used",
  "𣥋": "rarely-used",
  "𣥖": "rarely-used",
  "𣥙": "rarely-used",
  "𣥣": "rarely-used",
  "𣥥": "rarely-used",
  "𣥨": "rarely-used",
  "𣥳": "rarely-used",
  "𣥹": "rarely-used",
  "𣥺": "rarely-used",
  "𣥻": "rarely-used",
  "𣥼": "rarely-used",
  "𣥾": "rarely-used",
  "𣦇": "rarely-used",
  "𣦉": "rarely-used",
  "𣦢": "rarely-used",
  "𣦦": "rarely-used",
  "𣦧": "rarely-used",
  "𣦯": "rarely-used",
  "𣦵": "rarely-used",
  "𣦶": "rarely-used",
  "𣦷": "rarely-used",
  "𣦹": "rarely-used",
  "𣦻": "rarely-used",
  "𣧂": "rarely-used",
  "𣧄": "rarely-used",
  "𣧊": "rarely-used",
  "𣧋": "rarely-used",
  "𣧌": "rarely-used",
  "𣧍": "rarely-used",
  "𣧎": "rarely-used",
  "𣧏": "rarely-used",
  "𣧐": "rarely-used",
  "𣧖": "rarely-used",
  "𣧝": "rarely-used",
  "𣧞": "rarely-used",
  "𣧡": "rarely-used",
  "𣧣": "rarely-used",
  "𣧤": "rarely-used",
  "𣧥": "rarely-used",
  "𣧦": "rarely-used",
  "𣧧": "rarely-used",
  "𣧬": "rarely-used",
  "𣧱": "rarely-used",
  "𣧲": "rarely-used",
  "𣧳": "rarely-used",
  "𣧵": "rarely-used",
  "𣧷": "rarely-used",
  "𣧸": "rarely-used",
  "𣧹": "rarely-used",
  "𣧽": "rarely-used",
  "𣧾": "rarely-used",
  "𣧿": "rarely-used",
  "𣨀": "rarely-used",
  "𣨅": "rarely-used",
  "𣨇": "rarely-used",
  "𣨉": "rarely-used",
  "𣨊": "rarely-used",
  "𣨋": "rarely-used",
  "𣨍": "rarely-used",
  "𣨎": "rarely-used",
  "𣨘": "rarely-used",
  "𣨙": "rarely-used",
  "𣨛": "rarely-used",
  "𣨜": "rarely-used",
  "𣨝": "rarely-used",
  "𣨞": "rarely-used",
  "𣨟": "rarely-used",
  "𣨠": "rarely-used",
  "𣨡": "rarely-used",
  "𣨢": "rarely-used",
  "𣨣": "rarely-used",
  "𣨤": "rarely-used",
  "𣨲": "rarely-used",
  "𣨳": "rarely-used",
  "𣨶": "rarely-used",
  "𣩅": "rarely-used",
  "𣩈": "rarely-used",
  "𣩏": "rarely-used",
  "𣩑": "rarely-used",
  "𣩔": "rarely-used",
  "𣩕": "rarely-used",
  "𣩙": "rarely-used",
  "𣩟": "rarely-used",
  "𣩠": "rarely-used",
  "𣩡": "rarely-used",
  "𣩢": "rarely-used",
  "𣩪": "rarely-used",
  "𣩭": "rarely-used",
  "𣩯": "rarely-used",
  "𣩰": "rarely-used",
  "𣩱": "rarely-used",
  "𣩴": "rarely-used",
  "𣩷": "rarely-used",
  "𣩺": "rarely-used",
  "𣩻": "rarely-used",
  "𣩿": "rarely-used",
  "𣪀": "rarely-used",
  "𣪂": "rarely-used",
  "𣪃": "rarely-used",
  "𣪈": "rarely-used",
  "𣪋": "rarely-used",
  "𣪌": "rarely-used",
  "𣪗": "rarely-used",
  "𣪬": "rarely-used",
  "𣪭": "rarely-used",
  "𣪮": "rarely-used",
  "𣪯": "rarely-used",
  "𣪶": "rarely-used",
  "𣫀": "rarely-used",
  "𣫐": "rarely-used",
  "𣫒": "rarely-used",
  "𣫓": "rarely-used",
  "𣫙": "rarely-used",
  "𣫢": "rarely-used",
  "𣫣": "rarely-used",
  "𣫥": "rarely-used",
  "𣫧": "rarely-used",
  "𣫨": "rarely-used",
  "𣫬": "rarely-used",
  "𣫹": "rarely-used",
  "𣬂": "rarely-used",
  "𣬆": "rarely-used",
  "𣬍": "rarely-used",
  "𣬎": "rarely-used",
  "𣬏": "rarely-used",
  "𣬐": "rarely-used",
  "𣬕": "rarely-used",
  "𣬗": "rarely-used",
  "𣬚": "rarely-used",
  "𣬛": "rarely-used",
  "𣬩": "rarely-used",
  "𣬪": "rarely-used",
  "𣬫": "rarely-used",
  "𣬬": "rarely-used",
  "𣬵": "rarely-used",
  "𣬹": "rarely-used",
  "𣬺": "rarely-used",
  "𣬻": "rarely-used",
  "𣬼": "rarely-used",
  "𣬽": "rarely-used",
  "𣬿": "rarely-used",
  "𣭄": "rarely-used",
  "𣭇": "rarely-used",
  "𣭝": "rarely-used",
  "𣭠": "rarely-used",
  "𣭡": "rarely-used",
  "𣭣": "rarely-used",
  "𣭮": "rarely-used",
  "𣭴": "rarely-used",
  "𣭷": "rarely-used",
  "𣭹": "rarely-used",
  "𣭺": "rarely-used",
  "𣭻": "rarely-used",
  "𣮈": "rarely-used",
  "𣮉": "rarely-used",
  "𣮊": "rarely-used",
  "𣮎": "rarely-used",
  "𣮏": "rarely-used",
  "𣮐": "rarely-used",
  "𣮔": "rarely-used",
  "𣮧": "rarely-used",
  "𣮹": "rarely-used",
  "𣯆": "rarely-used",
  "𣯇": "rarely-used",
  "𣯎": "rarely-used",
  "𣯏": "rarely-used",
  "𣯜": "rarely-used",
  "𣯨": "rarely-used",
  "𣯩": "rarely-used",
  "𣯪": "rarely-used",
  "𣯬": "rarely-used",
  "𣯭": "rarely-used",
  "𣯹": "rarely-used",
  "𣯻": "rarely-used",
  "𣯼": "rarely-used",
  "𣰌": "rarely-used",
  "𣰎": "rarely-used",
  "𣰚": "rarely-used",
  "𣰛": "rarely-used",
  "𣰜": "rarely-used",
  "𣰡": "rarely-used",
  "𣰨": "rarely-used",
  "𣰬": "rarely-used",
  "𣰶": "rarely-used",
  "𣰷": "rarely-used",
  "𣰼": "rarely-used",
  "𣰿": "rarely-used",
  "𣱈": "rarely-used",
  "𣱉": "rarely-used",
  "𣱐": "rarely-used",
  "𣱓": "rarely-used",
  "𣱠": "rarely-used",
  "𣱡": "rarely-used",
  "𣱤": "rarely-used",
  "𣱶": "rarely-used",
  "𣲀": "rarely-used",
  "𣲂": "rarely-used",
  "𣲏": "rarely-used",
  "𣲑": "rarely-used",
  "𣲒": "rarely-used",
  "𣲓": "rarely-used",
  "𣲲": "rarely-used",
  "𣲳": "rarely-used",
  "𣲵": "rarely-used",
  "𣲶": "rarely-used",
  "𣲷": "rarely-used",
  "𣲽": "rarely-used",
  "𣲾": "rarely-used",
  "𣳀": "rarely-used",
  "𣳊": "rarely-used",
  "𣳣": "rarely-used",
  "𣳤": "rarely-used",
  "𣳦": "rarely-used",
  "𣳩": "rarely-used",
  "𣳬": "rarely-used",
  "𣳭": "rarely-used",
  "𣳰": "rarely-used",
  "𣳲": "rarely-used",
  "𣳷": "rarely-used",
  "𣴖": "rarely-used",
  "𣴞": "rarely-used",
  "𣴟": "rarely-used",
  "𣴢": "rarely-used",
  "𣴣": "rarely-used",
  "𣴥": "rarely-used",
  "𣴨": "rarely-used",
  "𣴷": "rarely-used",
  "𣵱": "rarely-used",
  "𣵷": "rarely-used",
  "𣵸": "rarely-used",
  "𣵹": "rarely-used",
  "𣶀": "rarely-used",
  "𣶂": "rarely-used",
  "𣶆": "rarely-used",
  "𣶈": "rarely-used",
  "𣶋": "rarely-used",
  "𣶍": "rarely-used",
  "𣶏": "rarely-used",
  "𣶐": "rarely-used",
  "𣶖": "rarely-used",
  "𣶘": "rarely-used",
  "𣶝": "rarely-used",
  "𣶞": "rarely-used",
  "𣶡": "rarely-used",
  "𣶤": "rarely-used",
  "𣶥": "rarely-used",
  "𣶾": "rarely-used",
  "𣷡": "rarely-used",
  "𣷵": "rarely-used",
  "𣷶": "rarely-used",
  "𣷾": "rarely-used",
  "𣷿": "rarely-used",
  "𣸀": "rarely-used",
  "𣸃": "rarely-used",
  "𣸄": "rarely-used",
  "𣸅": "rarely-used",
  "𣸇": "rarely-used",
  "𣸉": "rarely-used",
  "𣸊": "rarely-used",
  "𣸋": "rarely-used",
  "𣸎": "rarely-used",
  "𣸔": "rarely-used",
  "𣸗": "rarely-used",
  "𣸘": "rarely-used",
  "𣸙": "rarely-used",
  "𣸚": "rarely-used",
  "𣸛": "rarely-used",
  "𣸝": "rarely-used",
  "𣸠": "rarely-used",
  "𣹇": "rarely-used",
  "𣹚": "rarely-used",
  "𣹞": "rarely-used",
  "𣹡": "rarely-used",
  "𣹤": "rarely-used",
  "𣹧": "rarely-used",
  "𣹩": "rarely-used",
  "𣹪": "rarely-used",
  "𣹮": "rarely-used",
  "𣹯": "rarely-used",
  "𣹱": "rarely-used",
  "𣹲": "rarely-used",
  "𣹵": "rarely-used",
  "𣹶": "rarely-used",
  "𣺀": "rarely-used",
  "𣺁": "rarely-used",
  "𣺬": "rarely-used",
  "𣺰": "rarely-used",
  "𣻐": "rarely-used",
  "𣻑": "rarely-used",
  "𣻓": "rarely-used",
  "𣻕": "rarely-used",
  "𣻖": "rarely-used",
  "𣻗": "rarely-used",
  "𣻘": "rarely-used",
  "𣻛": "rarely-used",
  "𣻠": "rarely-used",
  "𣻡": "rarely-used",
  "𣻢": "rarely-used",
  "𣻥": "rarely-used",
  "𣻪": "rarely-used",
  "𣻫": "rarely-used",
  "𣻬": "rarely-used",
  "𣻮": "rarely-used",
  "𣻱": "rarely-used",
  "𣻿": "rarely-used",
  "𣼚": "rarely-used",
  "𣼠": "rarely-used",
  "𣽆": "rarely-used",
  "𣽌": "rarely-used",
  "𣽒": "rarely-used",
  "𣽕": "rarely-used",
  "𣽚": "rarely-used",
  "𣽛": "rarely-used",
  "𣽝": "rarely-used",
  "𣽟": "rarely-used",
  "𣽡": "rarely-used",
  "𣽤": "rarely-used",
  "𣽥": "rarely-used",
  "𣽫": "rarely-used",
  "𣽯": "rarely-used",
  "𣽰": "rarely-used",
  "𣽳": "rarely-used",
  "𣽴": "rarely-used",
  "𣾄": "rarely-used",
  "𣿅": "rarely-used",
  "𣿆": "rarely-used",
  "𣿇": "rarely-used",
  "𣿈": "rarely-used",
  "𣿉": "rarely-used",
  "𣿊": "rarely-used",
  "𣿌": "rarely-used",
  "𣿐": "rarely-used",
  "𣿒": "rarely-used",
  "𣿓": "rarely-used",
  "𣿝": "rarely-used",
  "𣿞": "rarely-used",
  "𣿟": "rarely-used",
  "𣿢": "rarely-used",
  "𣿣": "rarely-used",
  "𣿤": "rarely-used",
  "𤀄": "rarely-used",
  "𤀢": "rarely-used",
  "𤀣": "rarely-used",
  "𤀤": "rarely-used",
  "𤀦": "rarely-used",
  "𤀩": "rarely-used",
  "𤀪": "rarely-used",
  "𤀫": "rarely-used",
  "𤀲": "rarely-used",
  "𤀵": "rarely-used",
  "𤀷": "rarely-used",
  "𤁊": "rarely-used",
  "𤁡": "rarely-used",
  "𤁢": "rarely-used",
  "𤁣": "rarely-used",
  "𤁥": "rarely-used",
  "𤁦": "rarely-used",
  "𤁧": "rarely-used",
  "𤁪": "rarely-used",
  "𤁫": "rarely-used",
  "𤁬": "rarely-used",
  "𤁮": "rarely-used",
  "𤁯": "rarely-used",
  "𤁰": "rarely-used",
  "𤁱": "rarely-used",
  "𤁳": "rarely-used",
  "𤁵": "rarely-used",
  "𤁹": "rarely-used",
  "𤁽": "rarely-used",
  "𤁾": "rarely-used",
  "𤁿": "rarely-used",
  "𤂀": "rarely-used",
  "𤂁": "rarely-used",
  "𤂂": "rarely-used",
  "𤂃": "rarely-used",
  "𤂊": "rarely-used",
  "𤂲": "rarely-used",
  "𤂶": "rarely-used",
  "𤂷": "rarely-used",
  "𤂹": "rarely-used",
  "𤃀": "rarely-used",
  "𤃄": "rarely-used",
  "𤃩": "rarely-used",
  "𤃪": "rarely-used",
  "𤃫": "rarely-used",
  "𤃭": "rarely-used",
  "𤃲": "rarely-used",
  "𤃶": "rarely-used",
  "𤃷": "rarely-used",
  "𤃸": "rarely-used",
  "𤃻": "rarely-used",
  "𤃼": "rarely-used",
  "𤃽": "rarely-used",
  "𤄎": "rarely-used",
  "𤄏": "rarely-used",
  "𤄑": "rarely-used",
  "𤄓": "rarely-used",
  "𤄔": "rarely-used",
  "𤄖": "rarely-used",
  "𤄛": "rarely-used",
  "𤄫": "rarely-used",
  "𤄷": "rarely-used",
  "𤄸": "rarely-used",
  "𤄺": "rarely-used",
  "𤄽": "rarely-used",
  "𤅊": "rarely-used",
  "𤅋": "rarely-used",
  "𤅎": "rarely-used",
  "𤅒": "rarely-used",
  "𤅡": "rarely-used",
  "𤅣": "rarely-used",
  "𤅦": "rarely-used",
  "𤅱": "rarely-used",
  "𤅲": "rarely-used",
  "𤅳": "rarely-used",
  "𤅸": "rarely-used",
  "𤅹": "rarely-used",
  "𤅽": "rarely-used",
  "𤆀": "rarely-used",
  "𤆏": "rarely-used",
  "𤆑": "rarely-used",
  "𤆒": "rarely-used",
  "𤆝": "rarely-used",
  "𤆞": "rarely-used",
  "𤆟": "rarely-used",
  "𤆴": "rarely-used",
  "𤆼": "rarely-used",
  "𤆾": "rarely-used",
  "𤇀": "rarely-used",
  "𤇠": "rarely-used",
  "𤇯": "rarely-used",
  "𤇰": "rarely-used",
  "𤇴": "rarely-used",
  "𤈑": "rarely-used",
  "𤈣": "rarely-used",
  "𤈧": "rarely-used",
  "𤈩": "rarely-used",
  "𤉝": "rarely-used",
  "𤉟": "rarely-used",
  "𤉥": "rarely-used",
  "𤉦": "rarely-used",
  "𤉪": "rarely-used",
  "𤉹": "rarely-used",
  "𤉺": "rarely-used",
  "𤊯": "rarely-used",
  "𤊲": "rarely-used",
  "𤊶": "rarely-used",
  "𤊻": "rarely-used",
  "𤊾": "rarely-used",
  "𤊿": "rarely-used",
  "𤋄": "rarely-used",
  "𤌁": "rarely-used",
  "𤌂": "rarely-used",
  "𤌃": "rarely-used",
  "𤌊": "rarely-used",
  "𤌌": "rarely-used",
  "𤌍": "rarely-used",
  "𤌎": "rarely-used",
  "𤌏": "rarely-used",
  "𤌐": "rarely-used",
  "𤌔": "rarely-used",
  "𤌹": "rarely-used",
  "𤍓": "rarely-used",
  "𤍗": "rarely-used",
  "𤍝": "rarely-used",
  "𤎗": "rarely-used",
  "𤎘": "rarely-used",
  "𤎣": "rarely-used",
  "𤎤": "rarely-used",
  "𤎭": "rarely-used",
  "𤎲": "rarely-used",
  "𤎳": "rarely-used",
  "𤏘": "rarely-used",
  "𤏭": "rarely-used",
  "𤏮": "rarely-used",
  "𤏶": "rarely-used",
  "𤏸": "rarely-used",
  "𤏻": "rarely-used",
  "𤏽": "rarely-used",
  "𤏿": "rarely-used",
  "𤐀": "rarely-used",
  "𤐞": "rarely-used",
  "𤐧": "rarely-used",
  "𤐩": "rarely-used",
  "𤐰": "rarely-used",
  "𤐱": "rarely-used",
  "𤐲": "rarely-used",
  "𤑓": "rarely-used",
  "𤑳": "rarely-used",
  "𤑷": "rarely-used",
  "𤑸": "rarely-used",
  "𤑹": "rarely-used",
  "𤑿": "rarely-used",
  "𤒞": "rarely-used",
  "𤒤": "rarely-used",
  "𤒦": "rarely-used",
  "𤒻": "rarely-used",
  "𤒼": "rarely-used",
  "𤓕": "rarely-used",
  "𤓚": "rarely-used",
  "𤓦": "rarely-used",
  "𤓯": "rarely-used",
  "𤓴": "rarely-used",
  "𤓾": "rarely-used",
  "𤔀": "rarely-used",
  "𤔂": "rarely-used",
  "𤔌": "rarely-used",
  "𤔎": "rarely-used",
  "𤔔": "rarely-used",
  "𤔣": "rarely-used",
  "𤔨": "rarely-used",
  "𤔱": "rarely-used",
  "𤕀": "rarely-used",
  "𤕚": "rarely-used",
  "𤕛": "rarely-used",
  "𤕞": "rarely-used",
  "𤕟": "rarely-used",
  "𤕠": "rarely-used",
  "𤕢": "rarely-used",
  "𤕦": "rarely-used",
  "𤕩": "rarely-used",
  "𤕷": "rarely-used",
  "𤕾": "rarely-used",
  "𤖖": "rarely-used",
  "𤖗": "rarely-used",
  "𤖘": "rarely-used",
  "𤖛": "rarely-used",
  "𤖞": "rarely-used",
  "𤖢": "rarely-used",
  "𤖦": "rarely-used",
  "𤖪": "rarely-used",
  "𤖬": "rarely-used",
  "𤖳": "rarely-used",
  "𤖷": "rarely-used",
  "𤖺": "rarely-used",
  "𤖻": "rarely-used",
  "𤖼": "rarely-used",
  "𤗀": "rarely-used",
  "𤗁": "rarely-used",
  "𤗈": "rarely-used",
  "𤗍": "rarely-used",
  "𤗎": "rarely-used",
  "𤗏": "rarely-used",
  "𤗑": "rarely-used",
  "𤗘": "rarely-used",
  "𤗚": "rarely-used",
  "𤗛": "rarely-used",
  "𤗜": "rarely-used",
  "𤗢": "rarely-used",
  "𤗨": "rarely-used",
  "𤗪": "rarely-used",
  "𤗫": "rarely-used",
  "𤗬": "rarely-used",
  "𤗯": "rarely-used",
  "𤗳": "rarely-used",
  "𤗴": "rarely-used",
  "𤗵": "rarely-used",
  "𤗷": "rarely-used",
  "𤗺": "rarely-used",
  "𤗻": "rarely-used",
  "𤗿": "rarely-used",
  "𤘀": "rarely-used",
  "𤘃": "rarely-used",
  "𤘅": "rarely-used",
  "𤘌": "rarely-used",
  "𤘔": "rarely-used",
  "𤘜": "rarely-used",
  "𤘝": "rarely-used",
  "𤘞": "rarely-used",
  "𤘟": "rarely-used",
  "𤘠": "rarely-used",
  "𤘡": "rarely-used",
  "𤘣": "rarely-used",
  "𤘤": "rarely-used",
  "𤘦": "rarely-used",
  "𤘧": "rarely-used",
  "𤘫": "rarely-used",
  "𤘲": "rarely-used",
  "𤘸": "rarely-used",
  "𤘹": "rarely-used",
  "𤘺": "rarely-used",
  "𤘽": "rarely-used",
  "𤘾": "rarely-used",
  "𤙏": "rarely-used",
  "𤙑": "rarely-used",
  "𤙒": "rarely-used",
  "𤙓": "rarely-used",
  "𤙔": "rarely-used",
  "𤙕": "rarely-used",
  "𤙘": "rarely-used",
  "𤙛": "rarely-used",
  "𤙞": "rarely-used",
  "𤙟": "rarely-used",
  "𤙤": "rarely-used",
  "𤙭": "rarely-used",
  "𤙰": "rarely-used",
  "𤙲": "rarely-used",
  "𤙴": "rarely-used",
  "𤙵": "rarely-used",
  "𤚈": "rarely-used",
  "𤚉": "rarely-used",
  "𤚊": "rarely-used",
  "𤚍": "rarely-used",
  "𤚎": "rarely-used",
  "𤚏": "rarely-used",
  "𤚐": "rarely-used",
  "𤚓": "rarely-used",
  "𤚞": "rarely-used",
  "𤚨": "rarely-used",
  "𤚩": "rarely-used",
  "𤚪": "rarely-used",
  "𤚫": "rarely-used",
  "𤚬": "rarely-used",
  "𤚭": "rarely-used",
  "𤚰": "rarely-used",
  "𤚱": "rarely-used",
  "𤚵": "rarely-used",
  "𤚼": "rarely-used",
  "𤚽": "rarely-used",
  "𤛉": "rarely-used",
  "𤛊": "rarely-used",
  "𤛍": "rarely-used",
  "𤛎": "rarely-used",
  "𤛏": "rarely-used",
  "𤛐": "rarely-used",
  "𤛑": "rarely-used",
  "𤛢": "rarely-used",
  "𤛣": "rarely-used",
  "𤛥": "rarely-used",
  "𤛦": "rarely-used",
  "𤛧": "rarely-used",
  "𤛩": "rarely-used",
  "𤛱": "rarely-used",
  "𤛻": "rarely-used",
  "𤜂": "rarely-used",
  "𤜄": "rarely-used",
  "𤜅": "rarely-used",
  "𤜇": "rarely-used",
  "𤜉": "rarely-used",
  "𤜋": "rarely-used",
  "𤜍": "rarely-used",
  "𤜐": "rarely-used",
  "𤜔": "rarely-used",
  "𤜜": "rarely-used",
  "𤜝": "rarely-used",
  "𤜡": "rarely-used",
  "𤜢": "rarely-used",
  "𤜣": "rarely-used",
  "𤜤": "rarely-used",
  "𤜫": "rarely-used",
  "𤜯": "rarely-used",
  "𤜰": "rarely-used",
  "𤜵": "rarely-used",
  "𤜷": "rarely-used",
  "𤜹": "rarely-used",
  "𤜻": "rarely-used",
  "𤜼": "rarely-used",
  "𤜽": "rarely-used",
  "𤝍": "rarely-used",
  "𤝐": "rarely-used",
  "𤝒": "rarely-used",
  "𤝕": "rarely-used",
  "𤝖": "rarely-used",
  "𤝘": "rarely-used",
  "𤝙": "rarely-used",
  "𤝚": "rarely-used",
  "𤝛": "rarely-used",
  "𤝟": "rarely-used",
  "𤝣": "rarely-used",
  "𤝬": "rarely-used",
  "𤝮": "rarely-used",
  "𤝯": "rarely-used",
  "𤝱": "rarely-used",
  "𤝳": "rarely-used",
  "𤝷": "rarely-used",
  "𤝸": "rarely-used",
  "𤝹": "rarely-used",
  "𤝻": "rarely-used",
  "𤝾": "rarely-used",
  "𤞀": "rarely-used",
  "𤞁": "rarely-used",
  "𤞂": "rarely-used",
  "𤞗": "rarely-used",
  "𤞚": "rarely-used",
  "𤞛": "rarely-used",
  "𤞞": "rarely-used",
  "𤞟": "rarely-used",
  "𤞠": "rarely-used",
  "𤞡": "rarely-used",
  "𤞢": "rarely-used",
  "𤞰": "rarely-used",
  "𤞲": "rarely-used",
  "𤞾": "rarely-used",
  "𤟀": "rarely-used",
  "𤟃": "rarely-used",
  "𤟅": "rarely-used",
  "𤟆": "rarely-used",
  "𤟇": "rarely-used",
  "𤟊": "rarely-used",
  "𤟍": "rarely-used",
  "𤟎": "rarely-used",
  "𤟑": "rarely-used",
  "𤟚": "rarely-used",
  "𤟝": "rarely-used",
  "𤟞": "rarely-used",
  "𤟟": "rarely-used",
  "𤟠": "rarely-used",
  "𤟢": "rarely-used",
  "𤟣": "rarely-used",
  "𤟤": "rarely-used",
  "𤟥": "rarely-used",
  "𤟦": "rarely-used",
  "𤟧": "rarely-used",
  "𤟩": "rarely-used",
  "𤟪": "rarely-used",
  "𤠇": "rarely-used",
  "𤠍": "rarely-used",
  "𤠎": "rarely-used",
  "𤠐": "rarely-used",
  "𤠑": "rarely-used",
  "𤠓": "rarely-used",
  "𤠘": "rarely-used",
  "𤠙": "rarely-used",
  "𤠚": "rarely-used",
  "𤠝": "rarely-used",
  "𤠟": "rarely-used",
  "𤠠": "rarely-used",
  "𤠤": "rarely-used",
  "𤠫": "rarely-used",
  "𤠵": "rarely-used",
  "𤠺": "rarely-used",
  "𤠽": "rarely-used",
  "𤠿": "rarely-used",
  "𤡀": "rarely-used",
  "𤡂": "rarely-used",
  "𤡃": "rarely-used",
  "𤡄": "rarely-used",
  "𤡇": "rarely-used",
  "𤡝": "rarely-used",
  "𤡞": "rarely-used",
  "𤡟": "rarely-used",
  "𤡠": "rarely-used",
  "𤡢": "rarely-used",
  "𤡤": "rarely-used",
  "𤡥": "rarely-used",
  "𤡧": "rarely-used",
  "𤡪": "rarely-used",
  "𤡭": "rarely-used",
  "𤡮": "rarely-used",
  "𤡰": "rarely-used",
  "𤡱": "rarely-used",
  "𤡲": "rarely-used",
  "𤡳": "rarely-used",
  "𤡴": "rarely-used",
  "𤡶": "rarely-used",
  "𤡹": "rarely-used",
  "𤡺": "rarely-used",
  "𤡿": "rarely-used",
  "𤢊": "rarely-used",
  "𤢋": "rarely-used",
  "𤢌": "rarely-used",
  "𤢎": "rarely-used",
  "𤢏": "rarely-used",
  "𤢐": "rarely-used",
  "𤢒": "rarely-used",
  "𤢕": "rarely-used",
  "𤢗": "rarely-used",
  "𤢘": "rarely-used",
  "𤢣": "rarely-used",
  "𤢦": "rarely-used",
  "𤢨": "rarely-used",
  "𤢵": "rarely-used",
  "𤢶": "rarely-used",
  "𤢺": "rarely-used",
  "𤣃": "rarely-used",
  "𤣅": "rarely-used",
  "𤣎": "rarely-used",
  "𤣑": "rarely-used",
  "𤣓": "rarely-used",
  "𤣘": "rarely-used",
  "𤣟": "rarely-used",
  "𤣩": "rarely-used",
  "𤣯": "rarely-used",
  "𤣰": "rarely-used",
  "𤣲": "rarely-used",
  "𤣸": "rarely-used",
  "𤣹": "rarely-used",
  "𤣻": "rarely-used",
  "𤣼": "rarely-used",
  "𤤐": "rarely-used",
  "𤤑": "rarely-used",
  "𤤒": "rarely-used",
  "𤤱": "rarely-used",
  "𤤲": "rarely-used",
  "𤤶": "rarely-used",
  "𤤷": "rarely-used",
  "𤤸": "rarely-used",
  "𤤺": "rarely-used",
  "𤥔": "rarely-used",
  "𤥗": "rarely-used",
  "𤥙": "rarely-used",
  "𤥷": "rarely-used",
  "𤥽": "rarely-used",
  "𤥾": "rarely-used",
  "𤥿": "rarely-used",
  "𤦃": "rarely-used",
  "𤦮": "rarely-used",
  "𤦼": "rarely-used",
  "𤧗": "rarely-used",
  "𤧙": "rarely-used",
  "𤧠": "rarely-used",
  "𤧫": "rarely-used",
  "𤧭": "rarely-used",
  "𤧮": "rarely-used",
  "𤨍": "rarely-used",
  "𤨕": "rarely-used",
  "𤨖": "rarely-used",
  "𤨹": "rarely-used",
  "𤨻": "rarely-used",
  "𤩂": "rarely-used",
  "𤩃": "rarely-used",
  "𤩄": "rarely-used",
  "𤩨": "rarely-used",
  "𤩩": "rarely-used",
  "𤩭": "rarely-used",
  "𤩮": "rarely-used",
  "𤩱": "rarely-used",
  "𤩲": "rarely-used",
  "𤪃": "rarely-used",
  "𤪋": "rarely-used",
  "𤪌": "rarely-used",
  "𤪍": "rarely-used",
  "𤪎": "rarely-used",
  "𤪫": "rarely-used",
  "𤪮": "rarely-used",
  "𤪿": "rarely-used",
  "𤫉": "rarely-used",
  "𤫘": "rarely-used",
  "𤫣": "rarely-used",
  "𤫨": "rarely-used",
  "𤫫": "rarely-used",
  "𤫬": "rarely-used",
  "𤫱": "rarely-used",
  "𤫲": "rarely-used",
  "𤫶": "rarely-used",
  "𤫷": "rarely-used",
  "𤫺": "rarely-used",
  "𤫻": "rarely-used",
  "𤬁": "rarely-used",
  "𤬂": "rarely-used",
  "𤬃": "rarely-used",
  "𤬉": "rarely-used",
  "𤬌": "rarely-used",
  "𤬏": "rarely-used",
  "𤬐": "rarely-used",
  "𤬖": "rarely-used",
  "𤬘": "rarely-used",
  "𤬛": "rarely-used",
  "𤬝": "rarely-used",
  "𤬠": "rarely-used",
  "𤬦": "rarely-used",
  "𤬨": "rarely-used",
  "𤬩": "rarely-used",
  "𤬬": "rarely-used",
  "𤬭": "rarely-used",
  "𤬯": "rarely-used",
  "𤬴": "rarely-used",
  "𤬵": "rarely-used",
  "𤬷": "rarely-used",
  "𤬾": "rarely-used",
  "𤭂": "rarely-used",
  "𤭄": "rarely-used",
  "𤭌": "rarely-used",
  "𤭍": "rarely-used",
  "𤭐": "rarely-used",
  "𤭑": "rarely-used",
  "𤭒": "rarely-used",
  "𤭔": "rarely-used",
  "𤭕": "rarely-used",
  "𤭜": "rarely-used",
  "𤭞": "rarely-used",
  "𤭟": "rarely-used",
  "𤭢": "rarely-used",
  "𤭧": "rarely-used",
  "𤭩": "rarely-used",
  "𤭬": "rarely-used",
  "𤭴": "rarely-used",
  "𤭻": "rarely-used",
  "𤭼": "rarely-used",
  "𤭽": "rarely-used",
  "𤮆": "rarely-used",
  "𤮈": "rarely-used",
  "𤮉": "rarely-used",
  "𤮊": "rarely-used",
  "𤮋": "rarely-used",
  "𤮍": "rarely-used",
  "𤮎": "rarely-used",
  "𤮏": "rarely-used",
  "𤮖": "rarely-used",
  "𤮙": "rarely-used",
  "𤮚": "rarely-used",
  "𤮜": "rarely-used",
  "𤮡": "rarely-used",
  "𤮨": "rarely-used",
  "𤮩": "rarely-used",
  "𤮪": "rarely-used",
  "𤮭": "rarely-used",
  "𤮯": "rarely-used",
  "𤮰": "rarely-used",
  "𤮱": "rarely-used",
  "𤮳": "rarely-used",
  "𤮸": "rarely-used",
  "𤮼": "rarely-used",
  "𤮽": "rarely-used",
  "𤯇": "rarely-used",
  "𤯍": "rarely-used",
  "𤯐": "rarely-used",
  "𤯖": "rarely-used",
  "𤯚": "rarely-used",
  "𤯟": "rarely-used",
  "𤯡": "rarely-used",
  "𤯷": "rarely-used",
  "𤰅": "rarely-used",
  "𤰈": "rarely-used",
  "𤰑": "rarely-used",
  "𤰟": "rarely-used",
  "𤰠": "rarely-used",
  "𤰩": "rarely-used",
  "𤰪": "rarely-used",
  "𤰬": "rarely-used",
  "𤰮": "rarely-used",
  "𤰳": "rarely-used",
  "𤰶": "rarely-used",
  "𤱋": "rarely-used",
  "𤱌": "rarely-used",
  "𤱍": "rarely-used",
  "𤱎": "rarely-used",
  "𤱣": "rarely-used",
  "𤱤": "rarely-used",
  "𤱧": "rarely-used",
  "𤱨": "rarely-used",
  "𤱩": "rarely-used",
  "𤱽": "rarely-used",
  "𤱾": "rarely-used",
  "𤲒": "rarely-used",
  "𤲓": "rarely-used",
  "𤲖": "rarely-used",
  "𤲗": "rarely-used",
  "𤲚": "rarely-used",
  "𤲣": "rarely-used",
  "𤲬": "rarely-used",
  "𤲭": "rarely-used",
  "𤳅": "rarely-used",
  "𤳉": "rarely-used",
  "𤳌": "rarely-used",
  "𤳓": "rarely-used",
  "𤳕": "rarely-used",
  "𤳖": "rarely-used",
  "𤳘": "rarely-used",
  "𤳟": "rarely-used",
  "𤳠": "rarely-used",
  "𤳤": "rarely-used",
  "𤳪": "rarely-used",
  "𤳯": "rarely-used",
  "𤴀": "rarely-used",
  "𤴘": "rarely-used",
  "𤴙": "rarely-used",
  "𤴟": "rarely-used",
  "𤴥": "rarely-used",
  "𤴦": "rarely-used",
  "𤴧": "rarely-used",
  "𤴨": "rarely-used",
  "𤴱": "rarely-used",
  "𤴳": "rarely-used",
  "𤴻": "rarely-used",
  "𤴼": "rarely-used",
  "𤴽": "rarely-used",
  "𤴾": "rarely-used",
  "𤴿": "rarely-used",
  "𤵀": "rarely-used",
  "𤵁": "rarely-used",
  "𤵂": "rarely-used",
  "𤵃": "rarely-used",
  "𤵘": "rarely-used",
  "𤵙": "rarely-used",
  "𤵛": "rarely-used",
  "𤵞": "rarely-used",
  "𤵟": "rarely-used",
  "𤵠": "rarely-used",
  "𤵥": "rarely-used",
  "𤵨": "rarely-used",
  "𤵹": "rarely-used",
  "𤵻": "rarely-used",
  "𤵼": "rarely-used",
  "𤵽": "rarely-used",
  "𤵾": "rarely-used",
  "𤶁": "rarely-used",
  "𤶓": "rarely-used",
  "𤶔": "rarely-used",
  "𤶕": "rarely-used",
  "𤶖": "rarely-used",
  "𤶘": "rarely-used",
  "𤶚": "rarely-used",
  "𤶛": "rarely-used",
  "𤶜": "rarely-used",
  "𤶝": "rarely-used",
  "𤶠": "rarely-used",
  "𤶤": "rarely-used",
  "𤷀": "rarely-used",
  "𤷁": "rarely-used",
  "𤷃": "rarely-used",
  "𤷄": "rarely-used",
  "𤷅": "rarely-used",
  "𤷆": "rarely-used",
  "𤷇": "rarely-used",
  "𤷈": "rarely-used",
  "𤷉": "rarely-used",
  "𤷊": "rarely-used",
  "𤷌": "rarely-used",
  "𤷍": "rarely-used",
  "𤷎": "rarely-used",
  "𤷏": "rarely-used",
  "𤷑": "rarely-used",
  "𤷔": "rarely-used",
  "𤷕": "rarely-used",
  "𤷖": "rarely-used",
  "𤷗": "rarely-used",
  "𤷘": "rarely-used",
  "𤷙": "rarely-used",
  "𤷷": "rarely-used",
  "𤷸": "rarely-used",
  "𤷹": "rarely-used",
  "𤷻": "rarely-used",
  "𤷼": "rarely-used",
  "𤷽": "rarely-used",
  "𤷿": "rarely-used",
  "𤸀": "rarely-used",
  "𤸁": "rarely-used",
  "𤸈": "rarely-used",
  "𤸉": "rarely-used",
  "𤸊": "rarely-used",
  "𤸎": "rarely-used",
  "𤸑": "rarely-used",
  "𤸒": "rarely-used",
  "𤸓": "rarely-used",
  "𤸔": "rarely-used",
  "𤸖": "rarely-used",
  "𤸗": "rarely-used",
  "𤸩": "rarely-used",
  "𤸪": "rarely-used",
  "𤸫": "rarely-used",
  "𤸬": "rarely-used",
  "𤸭": "rarely-used",
  "𤸮": "rarely-used",
  "𤸯": "rarely-used",
  "𤸱": "rarely-used",
  "𤸲": "rarely-used",
  "𤸳": "rarely-used",
  "𤸴": "rarely-used",
  "𤸵": "rarely-used",
  "𤸷": "rarely-used",
  "𤸸": "rarely-used",
  "𤸹": "rarely-used",
  "𤸻": "rarely-used",
  "𤸼": "rarely-used",
  "𤹛": "rarely-used",
  "𤹜": "rarely-used",
  "𤹝": "rarely-used",
  "𤹞": "rarely-used",
  "𤹡": "rarely-used",
  "𤹢": "rarely-used",
  "𤹣": "rarely-used",
  "𤹤": "rarely-used",
  "𤹥": "rarely-used",
  "𤹧": "rarely-used",
  "𤹨": "rarely-used",
  "𤹩": "rarely-used",
  "𤹬": "rarely-used",
  "𤹴": "rarely-used",
  "𤺀": "rarely-used",
  "𤺄": "rarely-used",
  "𤺅": "rarely-used",
  "𤺆": "rarely-used",
  "𤺉": "rarely-used",
  "𤺊": "rarely-used",
  "𤺌": "rarely-used",
  "𤺎": "rarely-used",
  "𤺏": "rarely-used",
  "𤺐": "rarely-used",
  "𤺓": "rarely-used",
  "𤺔": "rarely-used",
  "𤺕": "rarely-used",
  "𤺖": "rarely-used",
  "𤺗": "rarely-used",
  "𤺩": "rarely-used",
  "𤺷": "rarely-used",
  "𤺸": "rarely-used",
  "𤺻": "rarely-used",
  "𤺼": "rarely-used",
  "𤺾": "rarely-used",
  "𤻀": "rarely-used",
  "𤻁": "rarely-used",
  "𤻂": "rarely-used",
  "𤻃": "rarely-used",
  "𤻄": "rarely-used",
  "𤻅": "rarely-used",
  "𤻆": "rarely-used",
  "𤻇": "rarely-used",
  "𤻍": "rarely-used",
  "𤻖": "rarely-used",
  "𤻘": "rarely-used",
  "𤻙": "rarely-used",
  "𤻜": "rarely-used",
  "𤻝": "rarely-used",
  "𤻢": "rarely-used",
  "𤻱": "rarely-used",
  "𤻶": "rarely-used",
  "𤻷": "rarely-used",
  "𤼀": "rarely-used",
  "𤼁": "rarely-used",
  "𤼂": "rarely-used",
  "𤼃": "rarely-used",
  "𤼅": "rarely-used",
  "𤼋": "rarely-used",
  "𤼌": "rarely-used",
  "𤼍": "rarely-used",
  "𤼒": "rarely-used",
  "𤼗": "rarely-used",
  "𤼘": "rarely-used",
  "𤼢": "rarely-used",
  "𤼱": "rarely-used",
  "𤽁": "rarely-used",
  "𤽂": "rarely-used",
  "𤽃": "rarely-used",
  "𤽆": "rarely-used",
  "𤽇": "rarely-used",
  "𤽉": "rarely-used",
  "𤽊": "rarely-used",
  "𤽌": "rarely-used",
  "𤽖": "rarely-used",
  "𤽥": "rarely-used",
  "𤽦": "rarely-used",
  "𤽹": "rarely-used",
  "𤽺": "rarely-used",
  "𤽿": "rarely-used",
  "𤾈": "rarely-used",
  "𤾛": "rarely-used",
  "𤾝": "rarely-used",
  "𤾢": "rarely-used",
  "𤾣": "rarely-used",
  "𤾥": "rarely-used",
  "𤾧": "rarely-used",
  "𤾫": "rarely-used",
  "𤾬": "rarely-used",
  "𤾭": "rarely-used",
  "𤾲": "rarely-used",
  "𤾸": "rarely-used",
  "𤿀": "rarely-used",
  "𤿆": "rarely-used",
  "𤿇": "rarely-used",
  "𤿋": "rarely-used",
  "𤿏": "rarely-used",
  "𤿐": "rarely-used",
  "𤿕": "rarely-used",
  "𤿖": "rarely-used",
  "𤿙": "rarely-used",
  "𤿚": "rarely-used",
  "𤿠": "rarely-used",
  "𤿧": "rarely-used",
  "𤿩": "rarely-used",
  "𤿫": "rarely-used",
  "𤿳": "rarely-used",
  "𤿴": "rarely-used",
  "𤿵": "rarely-used",
  "𤿶": "rarely-used",
  "𤿷": "rarely-used",
  "𥀁": "rarely-used",
  "𥀂": "rarely-used",
  "𥀃": "rarely-used",
  "𥀈": "rarely-used",
  "𥀎": "rarely-used",
  "𥀏": "rarely-used",
  "𥀐": "rarely-used",
  "𥀔": "rarely-used",
  "𥀕": "rarely-used",
  "𥀖": "rarely-used",
  "𥀘": "rarely-used",
  "𥀙": "rarely-used",
  "𥀛": "rarely-used",
  "𥀢": "rarely-used",
  "𥀣": "rarely-used",
  "𥀫": "rarely-used",
  "𥀬": "rarely-used",
  "𥀰": "rarely-used",
  "𥀱": "rarely-used",
  "𥀵": "rarely-used",
  "𥀹": "rarely-used",
  "𥀺": "rarely-used",
  "𥁁": "rarely-used",
  "𥁂": "rarely-used",
  "𥁃": "rarely-used",
  "𥁅": "rarely-used",
  "𥁆": "rarely-used",
  "𥁇": "rarely-used",
  "𥁈": "rarely-used",
  "𥁎": "rarely-used",
  "𥁑": "rarely-used",
  "𥁒": "rarely-used",
  "𥁕": "rarely-used",
  "𥁟": "rarely-used",
  "𥁠": "rarely-used",
  "𥁮": "rarely-used",
  "𥁯": "rarely-used",
  "𥁹": "rarely-used",
  "𥂇": "rarely-used",
  "𥂓": "rarely-used",
  "𥂘": "rarely-used",
  "𥂙": "rarely-used",
  "𥂤": "rarely-used",
  "𥂥": "rarely-used",
  "𥂦": "rarely-used",
  "𥂨": "rarely-used",
  "𥂬": "rarely-used",
  "𥂵": "rarely-used",
  "𥂸": "rarely-used",
  "𥂹": "rarely-used",
  "𥃂": "rarely-used",
  "𥃇": "rarely-used",
  "𥃉": "rarely-used",
  "𥃔": "rarely-used",
  "𥃙": "rarely-used",
  "𥃤": "rarely-used",
  "𥃧": "rarely-used",
  "𥃨": "rarely-used",
  "𥃪": "rarely-used",
  "𥃫": "rarely-used",
  "𥃴": "rarely-used",
  "𥃵": "rarely-used",
  "𥃹": "rarely-used",
  "𥃺": "rarely-used",
  "𥃽": "rarely-used",
  "𥄉": "rarely-used",
  "𥄋": "rarely-used",
  "𥄍": "rarely-used",
  "𥄎": "rarely-used",
  "𥄑": "rarely-used",
  "𥄒": "rarely-used",
  "𥄓": "rarely-used",
  "𥄔": "rarely-used",
  "𥄕": "rarely-used",
  "𥄖": "rarely-used",
  "𥄗": "rarely-used",
  "𥄘": "rarely-used",
  "𥄛": "rarely-used",
  "𥄜": "rarely-used",
  "𥄝": "rarely-used",
  "𥄞": "rarely-used",
  "𥄱": "rarely-used",
  "𥄲": "rarely-used",
  "𥄳": "rarely-used",
  "𥄴": "rarely-used",
  "𥄵": "rarely-used",
  "𥄷": "rarely-used",
  "𥄸": "rarely-used",
  "𥄹": "rarely-used",
  "𥄻": "rarely-used",
  "𥄽": "rarely-used",
  "𥅁": "rarely-used",
  "𥅄": "rarely-used",
  "𥅗": "rarely-used",
  "𥅘": "rarely-used",
  "𥅞": "rarely-used",
  "𥅟": "rarely-used",
  "𥅠": "rarely-used",
  "𥅦": "rarely-used",
  "𥅧": "rarely-used",
  "𥅨": "rarely-used",
  "𥅪": "rarely-used",
  "𥅬": "rarely-used",
  "𥆅": "rarely-used",
  "𥆈": "rarely-used",
  "𥆉": "rarely-used",
  "𥆋": "rarely-used",
  "𥆌": "rarely-used",
  "𥆏": "rarely-used",
  "𥆑": "rarely-used",
  "𥆔": "rarely-used",
  "𥆗": "rarely-used",
  "𥆘": "rarely-used",
  "𥆙": "rarely-used",
  "𥆚": "rarely-used",
  "𥆛": "rarely-used",
  "𥆜": "rarely-used",
  "𥆞": "rarely-used",
  "𥆟": "rarely-used",
  "𥆡": "rarely-used",
  "𥆣": "rarely-used",
  "𥆥": "rarely-used",
  "𥆦": "rarely-used",
  "𥇄": "rarely-used",
  "𥇆": "rarely-used",
  "𥇇": "rarely-used",
  "𥇌": "rarely-used",
  "𥇍": "rarely-used",
  "𥇏": "rarely-used",
  "𥇑": "rarely-used",
  "𥇓": "rarely-used",
  "𥇔": "rarely-used",
  "𥇖": "rarely-used",
  "𥇘": "rarely-used",
  "𥇚": "rarely-used",
  "𥇛": "rarely-used",
  "𥇜": "rarely-used",
  "𥇞": "rarely-used",
  "𥇟": "rarely-used",
  "𥇠": "rarely-used",
  "𥇵": "rarely-used",
  "𥇾": "rarely-used",
  "𥇿": "rarely-used",
  "𥈂": "rarely-used",
  "𥈆": "rarely-used",
  "𥈇": "rarely-used",
  "𥈉": "rarely-used",
  "𥈊": "rarely-used",
  "𥈒": "rarely-used",
  "𥈓": "rarely-used",
  "𥈗": "rarely-used",
  "𥈙": "rarely-used",
  "𥈚": "rarely-used",
  "𥈛": "rarely-used",
  "𥈩": "rarely-used",
  "𥈸": "rarely-used",
  "𥈻": "rarely-used",
  "𥈽": "rarely-used",
  "𥈾": "rarely-used",
  "𥈿": "rarely-used",
  "𥉀": "rarely-used",
  "𥉁": "rarely-used",
  "𥉃": "rarely-used",
  "𥉄": "rarely-used",
  "𥉅": "rarely-used",
  "𥉇": "rarely-used",
  "𥉈": "rarely-used",
  "𥉊": "rarely-used",
  "𥉋": "rarely-used",
  "𥉌": "rarely-used",
  "𥉎": "rarely-used",
  "𥉐": "rarely-used",
  "𥉑": "rarely-used",
  "𥉒": "rarely-used",
  "𥉓": "rarely-used",
  "𥉔": "rarely-used",
  "𥉘": "rarely-used",
  "𥉙": "rarely-used",
  "𥉛": "rarely-used",
  "𥉜": "rarely-used",
  "𥉝": "rarely-used",
  "𥉞": "rarely-used",
  "𥉟": "rarely-used",
  "𥉰": "rarely-used",
  "𥉴": "rarely-used",
  "𥉵": "rarely-used",
  "𥉶": "rarely-used",
  "𥉷": "rarely-used",
  "𥉸": "rarely-used",
  "𥉹": "rarely-used",
  "𥉺": "rarely-used",
  "𥉻": "rarely-used",
  "𥉼": "rarely-used",
  "𥉽": "rarely-used",
  "𥉾": "rarely-used",
  "𥉿": "rarely-used",
  "𥊀": "rarely-used",
  "𥊇": "rarely-used",
  "𥊉": "rarely-used",
  "𥊧": "rarely-used",
  "𥊨": "rarely-used",
  "𥊪": "rarely-used",
  "𥊫": "rarely-used",
  "𥊭": "rarely-used",
  "𥊮": "rarely-used",
  "𥊯": "rarely-used",
  "𥊴": "rarely-used",
  "𥊶": "rarely-used",
  "𥊸": "rarely-used",
  "𥊿": "rarely-used",
  "𥋁": "rarely-used",
  "𥋙": "rarely-used",
  "𥋜": "rarely-used",
  "𥋞": "rarely-used",
  "𥋡": "rarely-used",
  "𥋢": "rarely-used",
  "𥋣": "rarely-used",
  "𥋤": "rarely-used",
  "𥋥": "rarely-used",
  "𥋨": "rarely-used",
  "𥋯": "rarely-used",
  "𥋿": "rarely-used",
  "𥌀": "rarely-used",
  "𥌁": "rarely-used",
  "𥌃": "rarely-used",
  "𥌄": "rarely-used",
  "𥌅": "rarely-used",
  "𥌆": "rarely-used",
  "𥌈": "rarely-used",
  "𥌊": "rarely-used",
  "𥌍": "rarely-used",
  "𥌏": "rarely-used",
  "𥌐": "rarely-used",
  "𥌚": "rarely-used",
  "𥌛": "rarely-used",
  "𥌜": "rarely-used",
  "𥌞": "rarely-used",
  "𥌟": "rarely-used",
  "𥌨": "rarely-used",
  "𥌮": "rarely-used",
  "𥌯": "rarely-used",
  "𥌰": "rarely-used",
  "𥌱": "rarely-used",
  "𥌺": "rarely-used",
  "𥌻": "rarely-used",
  "𥌽": "rarely-used",
  "𥌾": "rarely-used",
  "𥍀": "rarely-used",
  "𥍃": "rarely-used",
  "𥍆": "rarely-used",
  "𥍉": "rarely-used",
  "𥍋": "rarely-used",
  "𥍓": "rarely-used",
  "𥍚": "rarely-used",
  "𥍞": "rarely-used",
  "𥍟": "rarely-used",
  "𥍡": "rarely-used",
  "𥍢": "rarely-used",
  "𥍣": "rarely-used",
  "𥍧": "rarely-used",
  "𥍨": "rarely-used",
  "𥍪": "rarely-used",
  "𥍫": "rarely-used",
  "𥍬": "rarely-used",
  "𥍭": "rarely-used",
  "𥍮": "rarely-used",
  "𥍯": "rarely-used",
  "𥍱": "rarely-used",
  "𥍲": "rarely-used",
  "𥍳": "rarely-used",
  "𥍵": "rarely-used",
  "𥍸": "rarely-used",
  "𥍹": "rarely-used",
  "𥍺": "rarely-used",
  "𥍻": "rarely-used",
  "𥍼": "rarely-used",
  "𥍽": "rarely-used",
  "𥎂": "rarely-used",
  "𥎃": "rarely-used",
  "𥎅": "rarely-used",
  "𥎆": "rarely-used",
  "𥎉": "rarely-used",
  "𥎋": "rarely-used",
  "𥎍": "rarely-used",
  "𥎎": "rarely-used",
  "𥎐": "rarely-used",
  "𥎒": "rarely-used",
  "𥎓": "rarely-used",
  "𥎔": "rarely-used",
  "𥎕": "rarely-used",
  "𥎖": "rarely-used",
  "𥎗": "rarely-used",
  "𥎘": "rarely-used",
  "𥎙": "rarely-used",
  "𥎡": "rarely-used",
  "𥎬": "rarely-used",
  "𥎰": "rarely-used",
  "𥎱": "rarely-used",
  "𥎸": "rarely-used",
  "𥎹": "rarely-used",
  "𥎺": "rarely-used",
  "𥎾": "rarely-used",
  "𥏎": "rarely-used",
  "𥏘": "rarely-used",
  "𥏙": "rarely-used",
  "𥏜": "rarely-used",
  "𥏝": "rarely-used",
  "𥏟": "rarely-used",
  "𥏠": "rarely-used",
  "𥏪": "rarely-used",
  "𥏫": "rarely-used",
  "𥏯": "rarely-used",
  "𥏰": "rarely-used",
  "𥐀": "rarely-used",
  "𥐁": "rarely-used",
  "𥐑": "rarely-used",
  "𥐓": "rarely-used",
  "𥐕": "rarely-used",
  "𥐙": "rarely-used",
  "𥐚": "rarely-used",
  "𥐝": "rarely-used",
  "𥐩": "rarely-used",
  "𥐪": "rarely-used",
  "𥐬": "rarely-used",
  "𥑄": "rarely-used",
  "𥑅": "rarely-used",
  "𥑇": "rarely-used",
  "𥑋": "rarely-used",
  "𥑍": "rarely-used",
  "𥑎": "rarely-used",
  "𥑏": "rarely-used",
  "𥑐": "rarely-used",
  "𥑑": "rarely-used",
  "𥑒": "rarely-used",
  "𥑓": "rarely-used",
  "𥑔": "rarely-used",
  "𥑘": "rarely-used",
  "𥑙": "rarely-used",
  "𥑢": "rarely-used",
  "𥑣": "rarely-used",
  "𥑯": "rarely-used",
  "𥑰": "rarely-used",
  "𥑳": "rarely-used",
  "𥑴": "rarely-used",
  "𥑸": "rarely-used",
  "𥑹": "rarely-used",
  "𥑺": "rarely-used",
  "𥑼": "rarely-used",
  "𥑽": "rarely-used",
  "𥑾": "rarely-used",
  "𥑿": "rarely-used",
  "𥒀": "rarely-used",
  "𥒁": "rarely-used",
  "𥒂": "rarely-used",
  "𥒜": "rarely-used",
  "𥒧": "rarely-used",
  "𥒨": "rarely-used",
  "𥒪": "rarely-used",
  "𥒫": "rarely-used",
  "𥒬": "rarely-used",
  "𥒭": "rarely-used",
  "𥒮": "rarely-used",
  "𥒰": "rarely-used",
  "𥒱": "rarely-used",
  "𥒲": "rarely-used",
  "𥒳": "rarely-used",
  "𥒵": "rarely-used",
  "𥒶": "rarely-used",
  "𥓆": "rarely-used",
  "𥓇": "rarely-used",
  "𥓊": "rarely-used",
  "𥓌": "rarely-used",
  "𥓍": "rarely-used",
  "𥓐": "rarely-used",
  "𥓒": "rarely-used",
  "𥓖": "rarely-used",
  "𥓗": "rarely-used",
  "𥓻": "rarely-used",
  "𥓾": "rarely-used",
  "𥔀": "rarely-used",
  "𥔁": "rarely-used",
  "𥔂": "rarely-used",
  "𥔄": "rarely-used",
  "𥔇": "rarely-used",
  "𥔉": "rarely-used",
  "𥔊": "rarely-used",
  "𥔨": "rarely-used",
  "𥔩": "rarely-used",
  "𥔪": "rarely-used",
  "𥔫": "rarely-used",
  "𥔭": "rarely-used",
  "𥔮": "rarely-used",
  "𥔯": "rarely-used",
  "𥔱": "rarely-used",
  "𥔲": "rarely-used",
  "𥔴": "rarely-used",
  "𥕇": "rarely-used",
  "𥕈": "rarely-used",
  "𥕍": "rarely-used",
  "𥕎": "rarely-used",
  "𥕏": "rarely-used",
  "𥕔": "rarely-used",
  "𥕘": "rarely-used",
  "𥕡": "rarely-used",
  "𥕦": "rarely-used",
  "𥕰": "rarely-used",
  "𥕲": "rarely-used",
  "𥕵": "rarely-used",
  "𥕶": "rarely-used",
  "𥕸": "rarely-used",
  "𥕹": "rarely-used",
  "𥕻": "rarely-used",
  "𥕼": "rarely-used",
  "𥕽": "rarely-used",
  "𥕾": "rarely-used",
  "𥕿": "rarely-used",
  "𥖘": "rarely-used",
  "𥖙": "rarely-used",
  "𥖜": "rarely-used",
  "𥖞": "rarely-used",
  "𥖠": "rarely-used",
  "𥖪": "rarely-used",
  "𥖫": "rarely-used",
  "𥖬": "rarely-used",
  "𥖻": "rarely-used",
  "𥖼": "rarely-used",
  "𥖿": "rarely-used",
  "𥗀": "rarely-used",
  "𥗁": "rarely-used",
  "𥗒": "rarely-used",
  "𥗓": "rarely-used",
  "𥗝": "rarely-used",
  "𥗟": "rarely-used",
  "𥗪": "rarely-used",
  "𥗫": "rarely-used",
  "𥗭": "rarely-used",
  "𥗮": "rarely-used",
  "𥗾": "rarely-used",
  "𥗿": "rarely-used",
  "𥘄": "rarely-used",
  "𥘫": "rarely-used",
  "𥘭": "rarely-used",
  "𥘮": "rarely-used",
  "𥙎": "rarely-used",
  "𥙨": "rarely-used",
  "𥙬": "rarely-used",
  "𥙰": "rarely-used",
  "𥚉": "rarely-used",
  "𥚊": "rarely-used",
  "𥚋": "rarely-used",
  "𥚦": "rarely-used",
  "𥛂": "rarely-used",
  "𥛅": "rarely-used",
  "𥛘": "rarely-used",
  "𥛚": "rarely-used",
  "𥛝": "rarely-used",
  "𥛞": "rarely-used",
  "𥛟": "rarely-used",
  "𥛯": "rarely-used",
  "𥜃": "rarely-used",
  "𥜄": "rarely-used",
  "𥜑": "rarely-used",
  "𥜒": "rarely-used",
  "𥜚": "rarely-used",
  "𥜰": "rarely-used",
  "𥜲": "rarely-used",
  "𥜴": "rarely-used",
  "𥜾": "rarely-used",
  "𥝊": "rarely-used",
  "𥝌": "rarely-used",
  "𥝔": "rarely-used",
  "𥝕": "rarely-used",
  "𥝘": "rarely-used",
  "𥝥": "rarely-used",
  "𥝦": "rarely-used",
  "𥝨": "rarely-used",
  "𥝬": "rarely-used",
  "𥝮": "rarely-used",
  "𥝾": "rarely-used",
  "𥝿": "rarely-used",
  "𥞁": "rarely-used",
  "𥞃": "rarely-used",
  "𥞄": "rarely-used",
  "𥞅": "rarely-used",
  "𥞘": "rarely-used",
  "𥞚": "rarely-used",
  "𥞛": "rarely-used",
  "𥞜": "rarely-used",
  "𥞞": "rarely-used",
  "𥞩": "rarely-used",
  "𥞲": "rarely-used",
  "𥞳": "rarely-used",
  "𥞴": "rarely-used",
  "𥞵": "rarely-used",
  "𥞺": "rarely-used",
  "𥟅": "rarely-used",
  "𥟍": "rarely-used",
  "𥟎": "rarely-used",
  "𥟒": "rarely-used",
  "𥟓": "rarely-used",
  "𥟔": "rarely-used",
  "𥟕": "rarely-used",
  "𥟖": "rarely-used",
  "𥟗": "rarely-used",
  "𥟘": "rarely-used",
  "𥟚": "rarely-used",
  "𥟺": "rarely-used",
  "𥟻": "rarely-used",
  "𥟽": "rarely-used",
  "𥟿": "rarely-used",
  "𥠀": "rarely-used",
  "𥠄": "rarely-used",
  "𥠅": "rarely-used",
  "𥠆": "rarely-used",
  "𥠉": "rarely-used",
  "𥠊": "rarely-used",
  "𥠋": "rarely-used",
  "𥠍": "rarely-used",
  "𥠱": "rarely-used",
  "𥠲": "rarely-used",
  "𥠳": "rarely-used",
  "𥠶": "rarely-used",
  "𥠷": "rarely-used",
  "𥠽": "rarely-used",
  "𥠿": "rarely-used",
  "𥡀": "rarely-used",
  "𥡁": "rarely-used",
  "𥡃": "rarely-used",
  "𥡅": "rarely-used",
  "𥡜": "rarely-used",
  "𥡟": "rarely-used",
  "𥡠": "rarely-used",
  "𥡢": "rarely-used",
  "𥡣": "rarely-used",
  "𥡥": "rarely-used",
  "𥡦": "rarely-used",
  "𥡧": "rarely-used",
  "𥡪": "rarely-used",
  "𥡬": "rarely-used",
  "𥡭": "rarely-used",
  "𥡮": "rarely-used",
  "𥡱": "rarely-used",
  "𥢇": "rarely-used",
  "𥢈": "rarely-used",
  "𥢊": "rarely-used",
  "𥢋": "rarely-used",
  "𥢌": "rarely-used",
  "𥢍": "rarely-used",
  "𥢎": "rarely-used",
  "𥢏": "rarely-used",
  "𥢑": "rarely-used",
  "𥢓": "rarely-used",
  "𥢔": "rarely-used",
  "𥢕": "rarely-used",
  "𥢭": "rarely-used",
  "𥢰": "rarely-used",
  "𥢴": "rarely-used",
  "𥢵": "rarely-used",
  "𥢶": "rarely-used",
  "𥢷": "rarely-used",
  "𥢸": "rarely-used",
  "𥢹": "rarely-used",
  "𥢻": "rarely-used",
  "𥢽": "rarely-used",
  "𥣓": "rarely-used",
  "𥣖": "rarely-used",
  "𥣗": "rarely-used",
  "𥣘": "rarely-used",
  "𥣙": "rarely-used",
  "𥣞": "rarely-used",
  "𥣟": "rarely-used",
  "𥣩": "rarely-used",
  "𥣫": "rarely-used",
  "𥣬": "rarely-used",
  "𥣮": "rarely-used",
  "𥣯": "rarely-used",
  "𥣰": "rarely-used",
  "𥣾": "rarely-used",
  "𥤂": "rarely-used",
  "𥤆": "rarely-used",
  "𥤊": "rarely-used",
  "𥤋": "rarely-used",
  "𥤎": "rarely-used",
  "𥤗": "rarely-used",
  "𥤘": "rarely-used",
  "𥤜": "rarely-used",
  "𥤞": "rarely-used",
  "𥤟": "rarely-used",
  "𥤣": "rarely-used",
  "𥤤": "rarely-used",
  "𥤧": "rarely-used",
  "𥤨": "rarely-used",
  "𥤩": "rarely-used",
  "𥤸": "rarely-used",
  "𥤹": "rarely-used",
  "𥤺": "rarely-used",
  "𥤻": "rarely-used",
  "𥤿": "rarely-used",
  "𥥇": "rarely-used",
  "𥥈": "rarely-used",
  "𥥊": "rarely-used",
  "𥥋": "rarely-used",
  "𥥌": "rarely-used",
  "𥥍": "rarely-used",
  "𥥏": "rarely-used",
  "𥥑": "rarely-used",
  "𥥔": "rarely-used",
  "𥥗": "rarely-used",
  "𥥠": "rarely-used",
  "𥥡": "rarely-used",
  "𥥥": "rarely-used",
  "𥥦": "rarely-used",
  "𥥧": "rarely-used",
  "𥥨": "rarely-used",
  "𥥶": "rarely-used",
  "𥥷": "rarely-used",
  "𥥸": "rarely-used",
  "𥥻": "rarely-used",
  "𥥽": "rarely-used",
  "𥥾": "rarely-used",
  "𥥿": "rarely-used",
  "𥦁": "rarely-used",
  "𥦃": "rarely-used",
  "𥦅": "rarely-used",
  "𥦆": "rarely-used",
  "𥦇": "rarely-used",
  "𥦊": "rarely-used",
  "𥦌": "rarely-used",
  "𥦍": "rarely-used",
  "𥦏": "rarely-used",
  "𥦐": "rarely-used",
  "𥦛": "rarely-used",
  "𥦝": "rarely-used",
  "𥦞": "rarely-used",
  "𥦟": "rarely-used",
  "𥦢": "rarely-used",
  "𥦤": "rarely-used",
  "𥦥": "rarely-used",
  "𥦨": "rarely-used",
  "𥦺": "rarely-used",
  "𥦿": "rarely-used",
  "𥧇": "rarely-used",
  "𥧒": "rarely-used",
  "𥧓": "rarely-used",
  "𥧔": "rarely-used",
  "𥧕": "rarely-used",
  "𥧗": "rarely-used",
  "𥧘": "rarely-used",
  "𥧙": "rarely-used",
  "𥧚": "rarely-used",
  "𥧛": "rarely-used",
  "𥧝": "rarely-used",
  "𥧞": "rarely-used",
  "𥧟": "rarely-used",
  "𥧠": "rarely-used",
  "𥧥": "rarely-used",
  "𥧬": "rarely-used",
  "𥧭": "rarely-used",
  "𥧮": "rarely-used",
  "𥧯": "rarely-used",
  "𥧰": "rarely-used",
  "𥧱": "rarely-used",
  "𥧴": "rarely-used",
  "𥧵": "rarely-used",
  "𥧶": "rarely-used",
  "𥧷": "rarely-used",
  "𥧸": "rarely-used",
  "𥧹": "rarely-used",
  "𥧻": "rarely-used",
  "𥧼": "rarely-used",
  "𥧽": "rarely-used",
  "𥨍": "rarely-used",
  "𥨎": "rarely-used",
  "𥨐": "rarely-used",
  "𥨑": "rarely-used",
  "𥨕": "rarely-used",
  "𥨘": "rarely-used",
  "𥨡": "rarely-used",
  "𥨢": "rarely-used",
  "𥨪": "rarely-used",
  "𥨭": "rarely-used",
  "𥨲": "rarely-used",
  "𥨳": "rarely-used",
  "𥨴": "rarely-used",
  "𥨻": "rarely-used",
  "𥨽": "rarely-used",
  "𥨿": "rarely-used",
  "𥩀": "rarely-used",
  "𥩂": "rarely-used",
  "𥩊": "rarely-used",
  "𥩌": "rarely-used",
  "𥩒": "rarely-used",
  "𥩔": "rarely-used",
  "𥩗": "rarely-used",
  "𥩙": "rarely-used",
  "𥩡": "rarely-used",
  "𥩢": "rarely-used",
  "𥩣": "rarely-used",
  "𥩤": "rarely-used",
  "𥩥": "rarely-used",
  "𥩲": "rarely-used",
  "𥩶": "rarely-used",
  "𥪀": "rarely-used",
  "𥪁": "rarely-used",
  "𥪂": "rarely-used",
  "𥪃": "rarely-used",
  "𥪊": "rarely-used",
  "𥪋": "rarely-used",
  "𥪌": "rarely-used",
  "𥪍": "rarely-used",
  "𥪏": "rarely-used",
  "𥪘": "rarely-used",
  "𥪚": "rarely-used",
  "𥪛": "rarely-used",
  "𥪧": "rarely-used",
  "𥪯": "rarely-used",
  "𥪱": "rarely-used",
  "𥪵": "rarely-used",
  "𥪻": "rarely-used",
  "𥪼": "rarely-used",
  "𥫃": "rarely-used",
  "𥫎": "rarely-used",
  "𥫙": "rarely-used",
  "𥫛": "rarely-used",
  "𥫜": "rarely-used",
  "𥫝": "rarely-used",
  "𥫞": "rarely-used",
  "𥫟": "rarely-used",
  "𥫢": "rarely-used",
  "𥫯": "rarely-used",
  "𥫰": "rarely-used",
  "𥫱": "rarely-used",
  "𥫳": "rarely-used",
  "𥫴": "rarely-used",
  "𥫵": "rarely-used",
  "𥫷": "rarely-used",
  "𥫸": "rarely-used",
  "𥫹": "rarely-used",
  "𥫼": "rarely-used",
  "𥫽": "rarely-used",
  "𥬎": "rarely-used",
  "𥬏": "rarely-used",
  "𥬐": "rarely-used",
  "𥬒": "rarely-used",
  "𥬔": "rarely-used",
  "𥬕": "rarely-used",
  "𥬗": "rarely-used",
  "𥬙": "rarely-used",
  "𥬝": "rarely-used",
  "𥬞": "rarely-used",
  "𥬪": "rarely-used",
  "𥬫": "rarely-used",
  "𥬬": "rarely-used",
  "𥬭": "rarely-used",
  "𥬮": "rarely-used",
  "𥬯": "rarely-used",
  "𥬱": "rarely-used",
  "𥬲": "rarely-used",
  "𥬳": "rarely-used",
  "𥬴": "rarely-used",
  "𥬷": "rarely-used",
  "𥬼": "rarely-used",
  "𥬿": "rarely-used",
  "𥭀": "rarely-used",
  "𥭋": "rarely-used",
  "𥭐": "rarely-used",
  "𥭑": "rarely-used",
  "𥭒": "rarely-used",
  "𥭓": "rarely-used",
  "𥭔": "rarely-used",
  "𥭕": "rarely-used",
  "𥭖": "rarely-used",
  "𥭗": "rarely-used",
  "𥭘": "rarely-used",
  "𥭙": "rarely-used",
  "𥭚": "rarely-used",
  "𥭜": "rarely-used",
  "𥭝": "rarely-used",
  "𥭞": "rarely-used",
  "𥭟": "rarely-used",
  "𥭠": "rarely-used",
  "𥭡": "rarely-used",
  "𥭢": "rarely-used",
  "𥭬": "rarely-used",
  "𥭭": "rarely-used",
  "𥭮": "rarely-used",
  "𥭯": "rarely-used",
  "𥮍": "rarely-used",
  "𥮎": "rarely-used",
  "𥮏": "rarely-used",
  "𥮐": "rarely-used",
  "𥮒": "rarely-used",
  "𥮕": "rarely-used",
  "𥮖": "rarely-used",
  "𥮗": "rarely-used",
  "𥮘": "rarely-used",
  "𥮚": "rarely-used",
  "𥮜": "rarely-used",
  "𥮝": "rarely-used",
  "𥮢": "rarely-used",
  "𥮣": "rarely-used",
  "𥮤": "rarely-used",
  "𥮥": "rarely-used",
  "𥮧": "rarely-used",
  "𥮨": "rarely-used",
  "𥮪": "rarely-used",
  "𥮭": "rarely-used",
  "𥮯": "rarely-used",
  "𥯑": "rarely-used",
  "𥯔": "rarely-used",
  "𥯖": "rarely-used",
  "𥯙": "rarely-used",
  "𥯚": "rarely-used",
  "𥯛": "rarely-used",
  "𥯜": "rarely-used",
  "𥯝": "rarely-used",
  "𥯞": "rarely-used",
  "𥯟": "rarely-used",
  "𥯡": "rarely-used",
  "𥯢": "rarely-used",
  "𥯤": "rarely-used",
  "𥯥": "rarely-used",
  "𥯦": "rarely-used",
  "𥯧": "rarely-used",
  "𥯨": "rarely-used",
  "𥯩": "rarely-used",
  "𥯪": "rarely-used",
  "𥯫": "rarely-used",
  "𥯬": "rarely-used",
  "𥯮": "rarely-used",
  "𥯯": "rarely-used",
  "𥯳": "rarely-used",
  "𥯶": "rarely-used",
  "𥯸": "rarely-used",
  "𥯺": "rarely-used",
  "𥯾": "rarely-used",
  "𥰅": "rarely-used",
  "𥰘": "rarely-used",
  "𥰛": "rarely-used",
  "𥰜": "rarely-used",
  "𥰝": "rarely-used",
  "𥰟": "rarely-used",
  "𥰠": "rarely-used",
  "𥰡": "rarely-used",
  "𥰢": "rarely-used",
  "𥰣": "rarely-used",
  "𥰦": "rarely-used",
  "𥰧": "rarely-used",
  "𥰨": "rarely-used",
  "𥰪": "rarely-used",
  "𥰭": "rarely-used",
  "𥰮": "rarely-used",
  "𥰱": "rarely-used",
  "𥰲": "rarely-used",
  "𥰵": "rarely-used",
  "𥰶": "rarely-used",
  "𥰸": "rarely-used",
  "𥰹": "rarely-used",
  "𥰻": "rarely-used",
  "𥰼": "rarely-used",
  "𥱀": "rarely-used",
  "𥱁": "rarely-used",
  "𥱂": "rarely-used",
  "𥱇": "rarely-used",
  "𥱍": "rarely-used",
  "𥱵": "rarely-used",
  "𥱶": "rarely-used",
  "𥱷": "rarely-used",
  "𥱸": "rarely-used",
  "𥱹": "rarely-used",
  "𥱺": "rarely-used",
  "𥱻": "rarely-used",
  "𥱿": "rarely-used",
  "𥲀": "rarely-used",
  "𥲁": "rarely-used",
  "𥲄": "rarely-used",
  "𥲅": "rarely-used",
  "𥲆": "rarely-used",
  "𥲇": "rarely-used",
  "𥲈": "rarely-used",
  "𥲉": "rarely-used",
  "𥲊": "rarely-used",
  "𥲋": "rarely-used",
  "𥲍": "rarely-used",
  "𥲎": "rarely-used",
  "𥲏": "rarely-used",
  "𥲑": "rarely-used",
  "𥲕": "rarely-used",
  "𥲖": "rarely-used",
  "𥲗": "rarely-used",
  "𥲚": "rarely-used",
  "𥲛": "rarely-used",
  "𥲜": "rarely-used",
  "𥲝": "rarely-used",
  "𥲟": "rarely-used",
  "𥲠": "rarely-used",
  "𥲡": "rarely-used",
  "𥲢": "rarely-used",
  "𥲤": "rarely-used",
  "𥲥": "rarely-used",
  "𥲦": "rarely-used",
  "𥲧": "rarely-used",
  "𥲨": "rarely-used",
  "𥲪": "rarely-used",
  "𥳆": "rarely-used",
  "𥳇": "rarely-used",
  "𥳈": "rarely-used",
  "𥳉": "rarely-used",
  "𥳋": "rarely-used",
  "𥳌": "rarely-used",
  "𥳍": "rarely-used",
  "𥳎": "rarely-used",
  "𥳏": "rarely-used",
  "𥳐": "rarely-used",
  "𥳒": "rarely-used",
  "𥳓": "rarely-used",
  "𥳔": "rarely-used",
  "𥳕": "rarely-used",
  "𥳖": "rarely-used",
  "𥳗": "rarely-used",
  "𥳘": "rarely-used",
  "𥳚": "rarely-used",
  "𥳛": "rarely-used",
  "𥳜": "rarely-used",
  "𥳝": "rarely-used",
  "𥳞": "rarely-used",
  "𥳟": "rarely-used",
  "𥳡": "rarely-used",
  "𥳢": "rarely-used",
  "𥳣": "rarely-used",
  "𥳥": "rarely-used",
  "𥳧": "rarely-used",
  "𥳪": "rarely-used",
  "𥳬": "rarely-used",
  "𥳰": "rarely-used",
  "𥳱": "rarely-used",
  "𥳲": "rarely-used",
  "𥳳": "rarely-used",
  "𥳴": "rarely-used",
  "𥳵": "rarely-used",
  "𥳶": "rarely-used",
  "𥳷": "rarely-used",
  "𥳺": "rarely-used",
  "𥳿": "rarely-used",
  "𥴀": "rarely-used",
  "𥴡": "rarely-used",
  "𥴢": "rarely-used",
  "𥴦": "rarely-used",
  "𥴧": "rarely-used",
  "𥴨": "rarely-used",
  "𥴩": "rarely-used",
  "𥴪": "rarely-used",
  "𥴫": "rarely-used",
  "𥴬": "rarely-used",
  "𥴮": "rarely-used",
  "𥴯": "rarely-used",
  "𥴱": "rarely-used",
  "𥴴": "rarely-used",
  "𥴵": "rarely-used",
  "𥴶": "rarely-used",
  "𥴷": "rarely-used",
  "𥴸": "rarely-used",
  "𥴹": "rarely-used",
  "𥴺": "rarely-used",
  "𥴻": "rarely-used",
  "𥴿": "rarely-used",
  "𥵄": "rarely-used",
  "𥵜": "rarely-used",
  "𥵝": "rarely-used",
  "𥵞": "rarely-used",
  "𥵟": "rarely-used",
  "𥵠": "rarely-used",
  "𥵢": "rarely-used",
  "𥵣": "rarely-used",
  "𥵦": "rarely-used",
  "𥵧": "rarely-used",
  "𥵪": "rarely-used",
  "𥵫": "rarely-used",
  "𥵬": "rarely-used",
  "𥵯": "rarely-used",
  "𥵲": "rarely-used",
  "𥶆": "rarely-used",
  "𥶇": "rarely-used",
  "𥶈": "rarely-used",
  "𥶋": "rarely-used",
  "𥶌": "rarely-used",
  "𥶍": "rarely-used",
  "𥶏": "rarely-used",
  "𥶐": "rarely-used",
  "𥶑": "rarely-used",
  "𥶒": "rarely-used",
  "𥶓": "rarely-used",
  "𥶔": "rarely-used",
  "𥶕": "rarely-used",
  "𥶗": "rarely-used",
  "𥶘": "rarely-used",
  "𥶚": "rarely-used",
  "𥶛": "rarely-used",
  "𥶜": "rarely-used",
  "𥶶": "rarely-used",
  "𥶷": "rarely-used",
  "𥶸": "rarely-used",
  "𥶹": "rarely-used",
  "𥶺": "rarely-used",
  "𥶻": "rarely-used",
  "𥶽": "rarely-used",
  "𥶿": "rarely-used",
  "𥷀": "rarely-used",
  "𥷁": "rarely-used",
  "𥷄": "rarely-used",
  "𥷅": "rarely-used",
  "𥷆": "rarely-used",
  "𥷇": "rarely-used",
  "𥷈": "rarely-used",
  "𥷔": "rarely-used",
  "𥷕": "rarely-used",
  "𥷗": "rarely-used",
  "𥷘": "rarely-used",
  "𥷙": "rarely-used",
  "𥷜": "rarely-used",
  "𥷞": "rarely-used",
  "𥷨": "rarely-used",
  "𥷫": "rarely-used",
  "𥷬": "rarely-used",
  "𥷮": "rarely-used",
  "𥷱": "rarely-used",
  "𥷼": "rarely-used",
  "𥸈": "rarely-used",
  "𥸉": "rarely-used",
  "𥸊": "rarely-used",
  "𥸗": "rarely-used",
  "𥸘": "rarely-used",
  "𥸡": "rarely-used",
  "𥸢": "rarely-used",
  "𥸣": "rarely-used",
  "𥸥": "rarely-used",
  "𥸧": "rarely-used",
  "𥸬": "rarely-used",
  "𥸴": "rarely-used",
  "𥸶": "rarely-used",
  "𥸸": "rarely-used",
  "𥹁": "rarely-used",
  "𥹂": "rarely-used",
  "𥹅": "rarely-used",
  "𥹆": "rarely-used",
  "𥹇": "rarely-used",
  "𥹈": "rarely-used",
  "𥹉": "rarely-used",
  "𥹊": "rarely-used",
  "𥹌": "rarely-used",
  "𥹍": "rarely-used",
  "𥹚": "rarely-used",
  "𥹜": "rarely-used",
  "𥹠": "rarely-used",
  "𥹲": "rarely-used",
  "𥹳": "rarely-used",
  "𥹵": "rarely-used",
  "𥹶": "rarely-used",
  "𥹷": "rarely-used",
  "𥹸": "rarely-used",
  "𥹻": "rarely-used",
  "𥹼": "rarely-used",
  "𥹽": "rarely-used",
  "𥹾": "rarely-used",
  "𥺙": "rarely-used",
  "𥺜": "rarely-used",
  "𥺝": "rarely-used",
  "𥺡": "rarely-used",
  "𥺣": "rarely-used",
  "𥺤": "rarely-used",
  "𥻄": "rarely-used",
  "𥻇": "rarely-used",
  "𥻈": "rarely-used",
  "𥻉": "rarely-used",
  "𥻊": "rarely-used",
  "𥻋": "rarely-used",
  "𥻌": "rarely-used",
  "𥻍": "rarely-used",
  "𥻐": "rarely-used",
  "𥻑": "rarely-used",
  "𥻒": "rarely-used",
  "𥻓": "rarely-used",
  "𥻕": "rarely-used",
  "𥻖": "rarely-used",
  "𥻤": "rarely-used",
  "𥻥": "rarely-used",
  "𥻦": "rarely-used",
  "𥻧": "rarely-used",
  "𥻨": "rarely-used",
  "𥻩": "rarely-used",
  "𥻬": "rarely-used",
  "𥻮": "rarely-used",
  "𥻯": "rarely-used",
  "𥻰": "rarely-used",
  "𥻿": "rarely-used",
  "𥼀": "rarely-used",
  "𥼂": "rarely-used",
  "𥼃": "rarely-used",
  "𥼄": "rarely-used",
  "𥼅": "rarely-used",
  "𥼘": "rarely-used",
  "𥼚": "rarely-used",
  "𥼛": "rarely-used",
  "𥼜": "rarely-used",
  "𥼞": "rarely-used",
  "𥼟": "rarely-used",
  "𥼡": "rarely-used",
  "𥼤": "rarely-used",
  "𥼶": "rarely-used",
  "𥼺": "rarely-used",
  "𥼻": "rarely-used",
  "𥼼": "rarely-used",
  "𥽁": "rarely-used",
  "𥽂": "rarely-used",
  "𥽅": "rarely-used",
  "𥽐": "rarely-used",
  "𥽗": "rarely-used",
  "𥽘": "rarely-used",
  "𥽙": "rarely-used",
  "𥽥": "rarely-used",
  "𥽧": "rarely-used",
  "𥽬": "rarely-used",
  "𥽭": "rarely-used",
  "𥽰": "rarely-used",
  "𥽳": "rarely-used",
  "𥽴": "rarely-used",
  "𥽶": "rarely-used",
  "𥽸": "rarely-used",
  "𥽹": "rarely-used",
  "𥽽": "rarely-used",
  "𥽿": "rarely-used",
  "𥾂": "rarely-used",
  "𥾅": "rarely-used",
  "𥾇": "rarely-used",
  "𥾊": "rarely-used",
  "𥾌": "rarely-used",
  "𥾏": "rarely-used",
  "𥾐": "rarely-used",
  "𥾓": "rarely-used",
  "𥾛": "rarely-used",
  "𥾝": "rarely-used",
  "𥾢": "rarely-used",
  "𥾣": "rarely-used",
  "𥾩": "rarely-used",
  "𥾬": "rarely-used",
  "𥾮": "rarely-used",
  "𥾯": "rarely-used",
  "𥿃": "rarely-used",
  "𥿄": "rarely-used",
  "𥿆": "rarely-used",
  "𥿇": "rarely-used",
  "𥿊": "rarely-used",
  "𥿍": "rarely-used",
  "𥿎": "rarely-used",
  "𥿦": "rarely-used",
  "𥿧": "rarely-used",
  "𥿨": "rarely-used",
  "𥿩": "rarely-used",
  "𥿫": "rarely-used",
  "𥿮": "rarely-used",
  "𥿯": "rarely-used",
  "𥿵": "rarely-used",
  "𥿹": "rarely-used",
  "𥿺": "rarely-used",
  "𥿼": "rarely-used",
  "𦀉": "rarely-used",
  "𦀔": "rarely-used",
  "𦀕": "rarely-used",
  "𦀖": "rarely-used",
  "𦀘": "rarely-used",
  "𦀛": "rarely-used",
  "𦀜": "rarely-used",
  "𦀝": "rarely-used",
  "𦀡": "rarely-used",
  "𦀣": "rarely-used",
  "𦁄": "rarely-used",
  "𦁆": "rarely-used",
  "𦁈": "rarely-used",
  "𦁉": "rarely-used",
  "𦁊": "rarely-used",
  "𦁍": "rarely-used",
  "𦁎": "rarely-used",
  "𦁏": "rarely-used",
  "𦁐": "rarely-used",
  "𦁕": "rarely-used",
  "𦁖": "rarely-used",
  "𦁗": "rarely-used",
  "𦁙": "rarely-used",
  "𦁜": "rarely-used",
  "𦁝": "rarely-used",
  "𦁤": "rarely-used",
  "𦂀": "rarely-used",
  "𦂄": "rarely-used",
  "𦂅": "rarely-used",
  "𦂆": "rarely-used",
  "𦂇": "rarely-used",
  "𦂈": "rarely-used",
  "𦂉": "rarely-used",
  "𦂋": "rarely-used",
  "𦂍": "rarely-used",
  "𦂑": "rarely-used",
  "𦂒": "rarely-used",
  "𦂕": "rarely-used",
  "𦂗": "rarely-used",
  "𦂘": "rarely-used",
  "𦂠": "rarely-used",
  "𦂡": "rarely-used",
  "𦂢": "rarely-used",
  "𦃄": "rarely-used",
  "𦃇": "rarely-used",
  "𦃊": "rarely-used",
  "𦃋": "rarely-used",
  "𦃒": "rarely-used",
  "𦃓": "rarely-used",
  "𦃔": "rarely-used",
  "𦃕": "rarely-used",
  "𦃖": "rarely-used",
  "𦃗": "rarely-used",
  "𦃘": "rarely-used",
  "𦃙": "rarely-used",
  "𦃢": "rarely-used",
  "𦃦": "rarely-used",
  "𦄋": "rarely-used",
  "𦄌": "rarely-used",
  "𦄍": "rarely-used",
  "𦄏": "rarely-used",
  "𦄑": "rarely-used",
  "𦄓": "rarely-used",
  "𦄔": "rarely-used",
  "𦄙": "rarely-used",
  "𦄜": "rarely-used",
  "𦄽": "rarely-used",
  "𦅀": "rarely-used",
  "𦅃": "rarely-used",
  "𦅄": "rarely-used",
  "𦅆": "rarely-used",
  "𦅇": "rarely-used",
  "𦅈": "rarely-used",
  "𦅋": "rarely-used",
  "𦅔": "rarely-used",
  "𦅧": "rarely-used",
  "𦅵": "rarely-used",
  "𦅶": "rarely-used",
  "𦅸": "rarely-used",
  "𦅺": "rarely-used",
  "𦅼": "rarely-used",
  "𦅿": "rarely-used",
  "𦆀": "rarely-used",
  "𦆁": "rarely-used",
  "𦆄": "rarely-used",
  "𦆆": "rarely-used",
  "𦆋": "rarely-used",
  "𦆞": "rarely-used",
  "𦆟": "rarely-used",
  "𦆦": "rarely-used",
  "𦆻": "rarely-used",
  "𦆾": "rarely-used",
  "𦇎": "rarely-used",
  "𦇑": "rarely-used",
  "𦇔": "rarely-used",
  "𦇖": "rarely-used",
  "𦇗": "rarely-used",
  "𦇘": "rarely-used",
  "𦇙": "rarely-used",
  "𦇚": "rarely-used",
  "𦇛": "rarely-used",
  "𦇧": "rarely-used",
  "𦇱": "rarely-used",
  "𦇸": "rarely-used",
  "𦇺": "rarely-used",
  "𦈅": "rarely-used",
  "𦈣": "rarely-used",
  "𦈦": "rarely-used",
  "𦈨": "rarely-used",
  "𦈩": "rarely-used",
  "𦈬": "rarely-used",
  "𦈰": "rarely-used",
  "𦈲": "rarely-used",
  "𦈸": "rarely-used",
  "𦈺": "rarely-used",
  "𦉂": "rarely-used",
  "𦉈": "rarely-used",
  "𦉉": "rarely-used",
  "𦉎": "rarely-used",
  "𦉐": "rarely-used",
  "𦉝": "rarely-used",
  "𦉞": "rarely-used",
  "𦉟": "rarely-used",
  "𦉢": "rarely-used",
  "𦉧": "rarely-used",
  "𦉬": "rarely-used",
  "𦉹": "rarely-used",
  "𦊂": "rarely-used",
  "𦊃": "rarely-used",
  "𦊈": "rarely-used",
  "𦊋": "rarely-used",
  "𦊐": "rarely-used",
  "𦊓": "rarely-used",
  "𦊔": "rarely-used",
  "𦊜": "rarely-used",
  "𦊧": "rarely-used",
  "𦊳": "rarely-used",
  "𦊴": "rarely-used",
  "𦊼": "rarely-used",
  "𦊽": "rarely-used",
  "𦊾": "rarely-used",
  "𦋅": "rarely-used",
  "𦋈": "rarely-used",
  "𦋉": "rarely-used",
  "𦋞": "rarely-used",
  "𦋡": "rarely-used",
  "𦋣": "rarely-used",
  "𦋯": "rarely-used",
  "𦋰": "rarely-used",
  "𦋳": "rarely-used",
  "𦋴": "rarely-used",
  "𦋿": "rarely-used",
  "𦌆": "rarely-used",
  "𦌉": "rarely-used",
  "𦌊": "rarely-used",
  "𦌒": "rarely-used",
  "𦌔": "rarely-used",
  "𦌕": "rarely-used",
  "𦌡": "rarely-used",
  "𦌢": "rarely-used",
  "𦌩": "rarely-used",
  "𦌪": "rarely-used",
  "𦌬": "rarely-used",
  "𦌵": "rarely-used",
  "𦌶": "rarely-used",
  "𦌸": "rarely-used",
  "𦌺": "rarely-used",
  "𦌾": "rarely-used",
  "𦍁": "rarely-used",
  "𦍂": "rarely-used",
  "𦍏": "rarely-used",
  "𦍕": "rarely-used",
  "𦍦": "rarely-used",
  "𦍧": "rarely-used",
  "𦍪": "rarely-used",
  "𦍭": "rarely-used",
  "𦍹": "rarely-used",
  "𦍺": "rarely-used",
  "𦍾": "rarely-used",
  "𦎇": "rarely-used",
  "𦎊": "rarely-used",
  "𦎗": "rarely-used",
  "𦎚": "rarely-used",
  "𦎢": "rarely-used",
  "𦎣": "rarely-used",
  "𦎦": "rarely-used",
  "𦎫": "rarely-used",
  "𦎯": "rarely-used",
  "𦎰": "rarely-used",
  "𦎱": "rarely-used",
  "𦎷": "rarely-used",
  "𦎸": "rarely-used",
  "𦎹": "rarely-used",
  "𦏅": "rarely-used",
  "𦏆": "rarely-used",
  "𦏇": "rarely-used",
  "𦏑": "rarely-used",
  "𦏕": "rarely-used",
  "𦏗": "rarely-used",
  "𦏜": "rarely-used",
  "𦏢": "rarely-used",
  "𦏨": "rarely-used",
  "𦏷": "rarely-used",
  "𦏸": "rarely-used",
  "𦏹": "rarely-used",
  "𦐄": "rarely-used",
  "𦐅": "rarely-used",
  "𦐆": "rarely-used",
  "𦐇": "rarely-used",
  "𦐋": "rarely-used",
  "𦐕": "rarely-used",
  "𦐣": "rarely-used",
  "𦐤": "rarely-used",
  "𦐨": "rarely-used",
  "𦐰": "rarely-used",
  "𦐸": "rarely-used",
  "𦐹": "rarely-used",
  "𦐺": "rarely-used",
  "𦐾": "rarely-used",
  "𦑀": "rarely-used",
  "𦑇": "rarely-used",
  "𦑈": "rarely-used",
  "𦑊": "rarely-used",
  "𦑋": "rarely-used",
  "𦑌": "rarely-used",
  "𦑍": "rarely-used",
  "𦑎": "rarely-used",
  "𦑏": "rarely-used",
  "𦑑": "rarely-used",
  "𦑘": "rarely-used",
  "𦑙": "rarely-used",
  "𦑛": "rarely-used",
  "𦑜": "rarely-used",
  "𦑝": "rarely-used",
  "𦑞": "rarely-used",
  "𦑠": "rarely-used",
  "𦑣": "rarely-used",
  "𦑲": "rarely-used",
  "𦑸": "rarely-used",
  "𦑹": "rarely-used",
  "𦑺": "rarely-used",
  "𦑻": "rarely-used",
  "𦑼": "rarely-used",
  "𦑾": "rarely-used",
  "𦒅": "rarely-used",
  "𦒈": "rarely-used",
  "𦒍": "rarely-used",
  "𦒎": "rarely-used",
  "𦒐": "rarely-used",
  "𦒑": "rarely-used",
  "𦒜": "rarely-used",
  "𦒝": "rarely-used",
  "𦒟": "rarely-used",
  "𦒦": "rarely-used",
  "𦒶": "rarely-used",
  "𦒺": "rarely-used",
  "𦒻": "rarely-used",
  "𦓐": "rarely-used",
  "𦓓": "rarely-used",
  "𦓔": "rarely-used",
  "𦓖": "rarely-used",
  "𦓚": "rarely-used",
  "𦓤": "rarely-used",
  "𦓬": "rarely-used",
  "𦓯": "rarely-used",
  "𦓰": "rarely-used",
  "𦓱": "rarely-used",
  "𦓴": "rarely-used",
  "𦓸": "rarely-used",
  "𦓹": "rarely-used",
  "𦓺": "rarely-used",
  "𦓻": "rarely-used",
  "𦓼": "rarely-used",
  "𦓽": "rarely-used",
  "𦓾": "rarely-used",
  "𦔂": "rarely-used",
  "𦔃": "rarely-used",
  "𦔄": "rarely-used",
  "𦔅": "rarely-used",
  "𦔆": "rarely-used",
  "𦔋": "rarely-used",
  "𦔌": "rarely-used",
  "𦔍": "rarely-used",
  "𦔎": "rarely-used",
  "𦔓": "rarely-used",
  "𦔔": "rarely-used",
  "𦔛": "rarely-used",
  "𦔜": "rarely-used",
  "𦔠": "rarely-used",
  "𦔦": "rarely-used",
  "𦔫": "rarely-used",
  "𦔬": "rarely-used",
  "𦔭": "rarely-used",
  "𦔯": "rarely-used",
  "𦔰": "rarely-used",
  "𦔷": "rarely-used",
  "𦔸": "rarely-used",
  "𦔹": "rarely-used",
  "𦔼": "rarely-used",
  "𦔾": "rarely-used",
  "𦕀": "rarely-used",
  "𦕏": "rarely-used",
  "𦕒": "rarely-used",
  "𦕕": "rarely-used",
  "𦕠": "rarely-used",
  "𦕴": "rarely-used",
  "𦕷": "rarely-used",
  "𦕸": "rarely-used",
  "𦕽": "rarely-used",
  "𦖈": "rarely-used",
  "𦖉": "rarely-used",
  "𦖊": "rarely-used",
  "𦖋": "rarely-used",
  "𦖍": "rarely-used",
  "𦖎": "rarely-used",
  "𦖐": "rarely-used",
  "𦖝": "rarely-used",
  "𦖢": "rarely-used",
  "𦖤": "rarely-used",
  "𦖦": "rarely-used",
  "𦖧": "rarely-used",
  "𦖨": "rarely-used",
  "𦖩": "rarely-used",
  "𦖬": "rarely-used",
  "𦖼": "rarely-used",
  "𦖽": "rarely-used",
  "𦖾": "rarely-used",
  "𦖿": "rarely-used",
  "𦗀": "rarely-used",
  "𦗍": "rarely-used",
  "𦗐": "rarely-used",
  "𦗑": "rarely-used",
  "𦗒": "rarely-used",
  "𦗔": "rarely-used",
  "𦗕": "rarely-used",
  "𦗖": "rarely-used",
  "𦗗": "rarely-used",
  "𦗡": "rarely-used",
  "𦗢": "rarely-used",
  "𦗣": "rarely-used",
  "𦗥": "rarely-used",
  "𦗧": "rarely-used",
  "𦗨": "rarely-used",
  "𦗴": "rarely-used",
  "𦗵": "rarely-used",
  "𦘅": "rarely-used",
  "𦘊": "rarely-used",
  "𦘍": "rarely-used",
  "𦘒": "rarely-used",
  "𦘔": "rarely-used",
  "𦘩": "rarely-used",
  "𦘪": "rarely-used",
  "𦘲": "rarely-used",
  "𦘳": "rarely-used",
  "𦘴": "rarely-used",
  "𦘵": "rarely-used",
  "𦘿": "rarely-used",
  "𦙀": "rarely-used",
  "𦙆": "rarely-used",
  "𦙈": "rarely-used",
  "𦙉": "rarely-used",
  "𦙋": "rarely-used",
  "𦙜": "rarely-used",
  "𦙧": "rarely-used",
  "𦙨": "rarely-used",
  "𦙫": "rarely-used",
  "𦙬": "rarely-used",
  "𦙮": "rarely-used",
  "𦙯": "rarely-used",
  "𦙱": "rarely-used",
  "𦙴": "rarely-used",
  "𦙸": "rarely-used",
  "𦙺": "rarely-used",
  "𦙻": "rarely-used",
  "𦙿": "rarely-used",
  "𦚝": "rarely-used",
  "𦚞": "rarely-used",
  "𦚟": "rarely-used",
  "𦚢": "rarely-used",
  "𦚥": "rarely-used",
  "𦚧": "rarely-used",
  "𦚨": "rarely-used",
  "𦚩": "rarely-used",
  "𦚫": "rarely-used",
  "𦚭": "rarely-used",
  "𦚲": "rarely-used",
  "𦚸": "rarely-used",
  "𦚹": "rarely-used",
  "𦛏": "rarely-used",
  "𦛐": "rarely-used",
  "𦛒": "rarely-used",
  "𦛓": "rarely-used",
  "𦛖": "rarely-used",
  "𦛗": "rarely-used",
  "𦛘": "rarely-used",
  "𦛙": "rarely-used",
  "𦛚": "rarely-used",
  "𦛛": "rarely-used",
  "𦛝": "rarely-used",
  "𦛠": "rarely-used",
  "𦛣": "rarely-used",
  "𦛤": "rarely-used",
  "𦛥": "rarely-used",
  "𦛩": "rarely-used",
  "𦛪": "rarely-used",
  "𦜂": "rarely-used",
  "𦜃": "rarely-used",
  "𦜄": "rarely-used",
  "𦜇": "rarely-used",
  "𦜊": "rarely-used",
  "𦜍": "rarely-used",
  "𦜎": "rarely-used",
  "𦜒": "rarely-used",
  "𦜖": "rarely-used",
  "𦜛": "rarely-used",
  "𦜜": "rarely-used",
  "𦝏": "rarely-used",
  "𦝑": "rarely-used",
  "𦝒": "rarely-used",
  "𦝓": "rarely-used",
  "𦝔": "rarely-used",
  "𦝖": "rarely-used",
  "𦝚": "rarely-used",
  "𦝛": "rarely-used",
  "𦝜": "rarely-used",
  "𦝝": "rarely-used",
  "𦝞": "rarely-used",
  "𦝟": "rarely-used",
  "𦝠": "rarely-used",
  "𦝢": "rarely-used",
  "𦝤": "rarely-used",
  "𦝥": "rarely-used",
  "𦝦": "rarely-used",
  "𦝨": "rarely-used",
  "𦝪": "rarely-used",
  "𦝭": "rarely-used",
  "𦝰": "rarely-used",
  "𦝲": "rarely-used",
  "𦝳": "rarely-used",
  "𦝴": "rarely-used",
  "𦝵": "rarely-used",
  "𦝷": "rarely-used",
  "𦞖": "rarely-used",
  "𦞗": "rarely-used",
  "𦞙": "rarely-used",
  "𦞚": "rarely-used",
  "𦞜": "rarely-used",
  "𦞝": "rarely-used",
  "𦞟": "rarely-used",
  "𦞡": "rarely-used",
  "𦞢": "rarely-used",
  "𦞤": "rarely-used",
  "𦞥": "rarely-used",
  "𦞦": "rarely-used",
  "𦞨": "rarely-used",
  "𦞫": "rarely-used",
  "𦞭": "rarely-used",
  "𦞰": "rarely-used",
  "𦞲": "rarely-used",
  "𦞵": "rarely-used",
  "𦟔": "rarely-used",
  "𦟕": "rarely-used",
  "𦟘": "rarely-used",
  "𦟙": "rarely-used",
  "𦟜": "rarely-used",
  "𦟟": "rarely-used",
  "𦟠": "rarely-used",
  "𦟣": "rarely-used",
  "𦟥": "rarely-used",
  "𦟧": "rarely-used",
  "𦠁": "rarely-used",
  "𦠄": "rarely-used",
  "𦠅": "rarely-used",
  "𦠇": "rarely-used",
  "𦠈": "rarely-used",
  "𦠉": "rarely-used",
  "𦠌": "rarely-used",
  "𦠍": "rarely-used",
  "𦠎": "rarely-used",
  "𦠏": "rarely-used",
  "𦠐": "rarely-used",
  "𦠓": "rarely-used",
  "𦠕": "rarely-used",
  "𦠖": "rarely-used",
  "𦠷": "rarely-used",
  "𦠸": "rarely-used",
  "𦠹": "rarely-used",
  "𦠺": "rarely-used",
  "𦠻": "rarely-used",
  "𦠾": "rarely-used",
  "𦠿": "rarely-used",
  "𦡂": "rarely-used",
  "𦡃": "rarely-used",
  "𦡅": "rarely-used",
  "𦡆": "rarely-used",
  "𦡇": "rarely-used",
  "𦡌": "rarely-used",
  "𦡨": "rarely-used",
  "𦡪": "rarely-used",
  "𦡫": "rarely-used",
  "𦡰": "rarely-used",
  "𦡱": "rarely-used",
  "𦡲": "rarely-used",
  "𦡴": "rarely-used",
  "𦡵": "rarely-used",
  "𦡷": "rarely-used",
  "𦡹": "rarely-used",
  "𦡻": "rarely-used",
  "𦡼": "rarely-used",
  "𦡽": "rarely-used",
  "𦢈": "rarely-used",
  "𦢊": "rarely-used",
  "𦢎": "rarely-used",
  "𦢏": "rarely-used",
  "𦢐": "rarely-used",
  "𦢧": "rarely-used",
  "𦢨": "rarely-used",
  "𦢩": "rarely-used",
  "𦢪": "rarely-used",
  "𦢫": "rarely-used",
  "𦢺": "rarely-used",
  "𦢿": "rarely-used",
  "𦣀": "rarely-used",
  "𦣇": "rarely-used",
  "𦣋": "rarely-used",
  "𦣍": "rarely-used",
  "𦣒": "rarely-used",
  "𦣖": "rarely-used",
  "𦣛": "rarely-used",
  "𦣜": "rarely-used",
  "𦣞": "rarely-used",
  "𦣴": "rarely-used",
  "𦣸": "rarely-used",
  "𦣻": "rarely-used",
  "𦣾": "rarely-used",
  "𦤂": "rarely-used",
  "𦤕": "rarely-used",
  "𦤘": "rarely-used",
  "𦤙": "rarely-used",
  "𦤚": "rarely-used",
  "𦤟": "rarely-used",
  "𦤢": "rarely-used",
  "𦤣": "rarely-used",
  "𦤦": "rarely-used",
  "𦤧": "rarely-used",
  "𦤨": "rarely-used",
  "𦤫": "rarely-used",
  "𦤬": "rarely-used",
  "𦤻": "rarely-used",
  "𦥁": "rarely-used",
  "𦥂": "rarely-used",
  "𦥅": "rarely-used",
  "𦥈": "rarely-used",
  "𦥋": "rarely-used",
  "𦥏": "rarely-used",
  "𦥐": "rarely-used",
  "𦥑": "rarely-used",
  "𦥦": "rarely-used",
  "𦥭": "rarely-used",
  "𦥲": "rarely-used",
  "𦥳": "rarely-used",
  "𦥻": "rarely-used",
  "𦦄": "rarely-used",
  "𦦅": "rarely-used",
  "𦦆": "rarely-used",
  "𦦑": "rarely-used",
  "𦦗": "rarely-used",
  "𦦘": "rarely-used",
  "𦦜": "rarely-used",
  "𦦝": "rarely-used",
  "𦦢": "rarely-used",
  "𦦣": "rarely-used",
  "𦦧": "rarely-used",
  "𦦩": "rarely-used",
  "𦦪": "rarely-used",
  "𦦫": "rarely-used",
  "𦦯": "rarely-used",
  "𦦲": "rarely-used",
  "𦦻": "rarely-used",
  "𦦽": "rarely-used",
  "𦦾": "rarely-used",
  "𦦿": "rarely-used",
  "𦧅": "rarely-used",
  "𦧈": "rarely-used",
  "𦧉": "rarely-used",
  "𦧏": "rarely-used",
  "𦧐": "rarely-used",
  "𦧝": "rarely-used",
  "𦧟": "rarely-used",
  "𦧠": "rarely-used",
  "𦧡": "rarely-used",
  "𦧮": "rarely-used",
  "𦧴": "rarely-used",
  "𦧸": "rarely-used",
  "𦧹": "rarely-used",
  "𦧼": "rarely-used",
  "𦧾": "rarely-used",
  "𦧿": "rarely-used",
  "𦨆": "rarely-used",
  "𦨇": "rarely-used",
  "𦨉": "rarely-used",
  "𦨍": "rarely-used",
  "𦨎": "rarely-used",
  "𦨖": "rarely-used",
  "𦨙": "rarely-used",
  "𦨡": "rarely-used",
  "𦨢": "rarely-used",
  "𦨦": "rarely-used",
  "𦨬": "rarely-used",
  "𦨯": "rarely-used",
  "𦨲": "rarely-used",
  "𦨵": "rarely-used",
  "𦨼": "rarely-used",
  "𦨾": "rarely-used",
  "𦩉": "rarely-used",
  "𦩋": "rarely-used",
  "𦩌": "rarely-used",
  "𦩜": "rarely-used",
  "𦩝": "rarely-used",
  "𦩞": "rarely-used",
  "𦩟": "rarely-used",
  "𦩠": "rarely-used",
  "𦩡": "rarely-used",
  "𦩢": "rarely-used",
  "𦩣": "rarely-used",
  "𦩤": "rarely-used",
  "𦩧": "rarely-used",
  "𦩬": "rarely-used",
  "𦩱": "rarely-used",
  "𦩲": "rarely-used",
  "𦩴": "rarely-used",
  "𦩵": "rarely-used",
  "𦩶": "rarely-used",
  "𦩸": "rarely-used",
  "𦩼": "rarely-used",
  "𦪇": "rarely-used",
  "𦪈": "rarely-used",
  "𦪉": "rarely-used",
  "𦪊": "rarely-used",
  "𦪋": "rarely-used",
  "𦪍": "rarely-used",
  "𦪎": "rarely-used",
  "𦪑": "rarely-used",
  "𦪒": "rarely-used",
  "𦪔": "rarely-used",
  "𦪕": "rarely-used",
  "𦪖": "rarely-used",
  "𦪗": "rarely-used",
  "𦪘": "rarely-used",
  "𦪙": "rarely-used",
  "𦪚": "rarely-used",
  "𦪛": "rarely-used",
  "𦪜": "rarely-used",
  "𦪝": "rarely-used",
  "𦪧": "rarely-used",
  "𦪪": "rarely-used",
  "𦪫": "rarely-used",
  "𦪬": "rarely-used",
  "𦪭": "rarely-used",
  "𦪱": "rarely-used",
  "𦪶": "rarely-used",
  "𦪷": "rarely-used",
  "𦪽": "rarely-used",
  "𦪾": "rarely-used",
  "𦪿": "rarely-used",
  "𦫈": "rarely-used",
  "𦫎": "rarely-used",
  "𦫔": "rarely-used",
  "𦫕": "rarely-used",
  "𦫙": "rarely-used",
  "𦫪": "rarely-used",
  "𦫫": "rarely-used",
  "𦫯": "rarely-used",
  "𦫰": "rarely-used",
  "𦫳": "rarely-used",
  "𦫶": "rarely-used",
  "𦫻": "rarely-used",
  "𦬁": "rarely-used",
  "𦬂": "rarely-used",
  "𦬃": "rarely-used",
  "𦬅": "rarely-used",
  "𦬔": "rarely-used",
  "𦬕": "rarely-used",
  "𦬖": "rarely-used",
  "𦬗": "rarely-used",
  "𦬘": "rarely-used",
  "𦬙": "rarely-used",
  "𦬚": "rarely-used",
  "𦬛": "rarely-used",
  "𦬝": "rarely-used",
  "𦬞": "rarely-used",
  "𦬣": "rarely-used",
  "𦬸": "rarely-used",
  "𦬹": "rarely-used",
  "𦬺": "rarely-used",
  "𦬻": "rarely-used",
  "𦭁": "rarely-used",
  "𦭈": "rarely-used",
  "𦭉": "rarely-used",
  "𦭋": "rarely-used",
  "𦭭": "rarely-used",
  "𦭮": "rarely-used",
  "𦭯": "rarely-used",
  "𦭰": "rarely-used",
  "𦭱": "rarely-used",
  "𦭲": "rarely-used",
  "𦭳": "rarely-used",
  "𦭴": "rarely-used",
  "𦭵": "rarely-used",
  "𦭶": "rarely-used",
  "𦭷": "rarely-used",
  "𦭸": "rarely-used",
  "𦭹": "rarely-used",
  "𦭻": "rarely-used",
  "𦭼": "rarely-used",
  "𦭿": "rarely-used",
  "𦮁": "rarely-used",
  "𦮈": "rarely-used",
  "𦮎": "rarely-used",
  "𦮐": "rarely-used",
  "𦮑": "rarely-used",
  "𦮷": "rarely-used",
  "𦮸": "rarely-used",
  "𦮹": "rarely-used",
  "𦮺": "rarely-used",
  "𦮻": "rarely-used",
  "𦮼": "rarely-used",
  "𦮽": "rarely-used",
  "𦮾": "rarely-used",
  "𦯀": "rarely-used",
  "𦯅": "rarely-used",
  "𦯈": "rarely-used",
  "𦯉": "rarely-used",
  "𦯍": "rarely-used",
  "𦯔": "rarely-used",
  "𦯕": "rarely-used",
  "𦯖": "rarely-used",
  "𦯚": "rarely-used",
  "𦯟": "rarely-used",
  "𦯣": "rarely-used",
  "𦯤": "rarely-used",
  "𦯫": "rarely-used",
  "𦯬": "rarely-used",
  "𦯮": "rarely-used",
  "𦯯": "rarely-used",
  "𦯰": "rarely-used",
  "𦰖": "rarely-used",
  "𦰘": "rarely-used",
  "𦰧": "rarely-used",
  "𦰪": "rarely-used",
  "𦰫": "rarely-used",
  "𦰬": "rarely-used",
  "𦰭": "rarely-used",
  "𦰮": "rarely-used",
  "𦰯": "rarely-used",
  "𦰰": "rarely-used",
  "𦰱": "rarely-used",
  "𦰲": "rarely-used",
  "𦰸": "rarely-used",
  "𦰹": "rarely-used",
  "𦰺": "rarely-used",
  "𦰽": "rarely-used",
  "𦰾": "rarely-used",
  "𦰿": "rarely-used",
  "𦱀": "rarely-used",
  "𦱁": "rarely-used",
  "𦱂": "rarely-used",
  "𦱃": "rarely-used",
  "𦱄": "rarely-used",
  "𦱅": "rarely-used",
  "𦱇": "rarely-used",
  "𦱊": "rarely-used",
  "𦱌": "rarely-used",
  "𦱖": "rarely-used",
  "𦱟": "rarely-used",
  "𦱣": "rarely-used",
  "𦱧": "rarely-used",
  "𦱯": "rarely-used",
  "𦱰": "rarely-used",
  "𦱵": "rarely-used",
  "𦱷": "rarely-used",
  "𦲯": "rarely-used",
  "𦳁": "rarely-used",
  "𦳄": "rarely-used",
  "𦳆": "less-than-common",
  "𦳇": "rarely-used",
  "𦳈": "rarely-used",
  "𦳋": "rarely-used",
  "𦳌": "rarely-used",
  "𦳍": "rarely-used",
  "𦳏": "rarely-used",
  "𦳐": "rarely-used",
  "𦳑": "rarely-used",
  "𦳔": "rarely-used",
  "𦳗": "rarely-used",
  "𦳙": "rarely-used",
  "𦳚": "rarely-used",
  "𦳛": "rarely-used",
  "𦳝": "rarely-used",
  "𦳞": "rarely-used",
  "𦳟": "rarely-used",
  "𦳡": "rarely-used",
  "𦳢": "rarely-used",
  "𦳣": "rarely-used",
  "𦳥": "rarely-used",
  "𦳦": "rarely-used",
  "𦳧": "rarely-used",
  "𦳩": "rarely-used",
  "𦳫": "rarely-used",
  "𦳬": "rarely-used",
  "𦳭": "rarely-used",
  "𦳮": "rarely-used",
  "𦳵": "rarely-used",
  "𦳹": "rarely-used",
  "𦳽": "rarely-used",
  "𦳾": "rarely-used",
  "𦳿": "rarely-used",
  "𦴀": "rarely-used",
  "𦴉": "rarely-used",
  "𦴊": "rarely-used",
  "𦴌": "rarely-used",
  "𦴍": "rarely-used",
  "𦴎": "rarely-used",
  "𦴏": "rarely-used",
  "𦴑": "rarely-used",
  "𦴔": "rarely-used",
  "𦴕": "rarely-used",
  "𦴚": "rarely-used",
  "𦴬": "rarely-used",
  "𦴭": "rarely-used",
  "𦵐": "rarely-used",
  "𦵟": "rarely-used",
  "𦵣": "rarely-used",
  "𦵦": "rarely-used",
  "𦵧": "rarely-used",
  "𦵩": "rarely-used",
  "𦵫": "rarely-used",
  "𦵭": "rarely-used",
  "𦵯": "rarely-used",
  "𦵱": "rarely-used",
  "𦵴": "rarely-used",
  "𦵵": "rarely-used",
  "𦵷": "rarely-used",
  "𦵸": "rarely-used",
  "𦵽": "rarely-used",
  "𦵾": "rarely-used",
  "𦵿": "rarely-used",
  "𦶀": "rarely-used",
  "𦶂": "rarely-used",
  "𦶅": "rarely-used",
  "𦶇": "rarely-used",
  "𦶈": "rarely-used",
  "𦶋": "rarely-used",
  "𦶌": "rarely-used",
  "𦶍": "rarely-used",
  "𦶎": "rarely-used",
  "𦶏": "rarely-used",
  "𦶐": "rarely-used",
  "𦶑": "rarely-used",
  "𦶕": "rarely-used",
  "𦶙": "rarely-used",
  "𦶚": "rarely-used",
  "𦶩": "rarely-used",
  "𦷔": "rarely-used",
  "𦷙": "rarely-used",
  "𦷳": "rarely-used",
  "𦷴": "rarely-used",
  "𦷵": "rarely-used",
  "𦷷": "rarely-used",
  "𦷹": "rarely-used",
  "𦷺": "rarely-used",
  "𦷻": "rarely-used",
  "𦷽": "rarely-used",
  "𦸁": "rarely-used",
  "𦸂": "rarely-used",
  "𦸆": "rarely-used",
  "𦸊": "rarely-used",
  "𦸐": "rarely-used",
  "𦸒": "rarely-used",
  "𦸓": "rarely-used",
  "𦸔": "rarely-used",
  "𦸗": "rarely-used",
  "𦸘": "rarely-used",
  "𦸙": "rarely-used",
  "𦸚": "rarely-used",
  "𦸛": "rarely-used",
  "𦸡": "rarely-used",
  "𦸢": "rarely-used",
  "𦸪": "rarely-used",
  "𦸮": "rarely-used",
  "𦸰": "rarely-used",
  "𦸱": "rarely-used",
  "𦸶": "rarely-used",
  "𦸷": "rarely-used",
  "𦸸": "rarely-used",
  "𦸺": "rarely-used",
  "𦹇": "rarely-used",
  "𦹣": "rarely-used",
  "𦹽": "rarely-used",
  "𦹿": "rarely-used",
  "𦺀": "rarely-used",
  "𦺉": "rarely-used",
  "𦺌": "rarely-used",
  "𦺎": "rarely-used",
  "𦺐": "rarely-used",
  "𦺑": "rarely-used",
  "𦺓": "rarely-used",
  "𦺔": "rarely-used",
  "𦺖": "rarely-used",
  "𦺗": "rarely-used",
  "𦺘": "rarely-used",
  "𦺙": "rarely-used",
  "𦺛": "rarely-used",
  "𦺞": "rarely-used",
  "𦺟": "rarely-used",
  "𦺡": "rarely-used",
  "𦺢": "rarely-used",
  "𦺥": "rarely-used",
  "𦺦": "rarely-used",
  "𦺧": "rarely-used",
  "𦺨": "rarely-used",
  "𦺬": "rarely-used",
  "𦺭": "rarely-used",
  "𦺱": "rarely-used",
  "𦺲": "rarely-used",
  "𦺴": "rarely-used",
  "𦺶": "rarely-used",
  "𦺷": "rarely-used",
  "𦺸": "rarely-used",
  "𦺹": "rarely-used",
  "𦺻": "rarely-used",
  "𦺽": "rarely-used",
  "𦺾": "rarely-used",
  "𦻃": "rarely-used",
  "𦻅": "rarely-used",
  "𦻜": "rarely-used",
  "𦻝": "rarely-used",
  "𦻞": "rarely-used",
  "𦼊": "rarely-used",
  "𦼎": "rarely-used",
  "𦼏": "rarely-used",
  "𦼡": "rarely-used",
  "𦼢": "rarely-used",
  "𦼪": "rarely-used",
  "𦼫": "rarely-used",
  "𦼱": "rarely-used",
  "𦼲": "rarely-used",
  "𦼳": "rarely-used",
  "𦼴": "rarely-used",
  "𦼷": "rarely-used",
  "𦼹": "rarely-used",
  "𦼼": "rarely-used",
  "𦽀": "rarely-used",
  "𦽁": "rarely-used",
  "𦽃": "rarely-used",
  "𦽄": "rarely-used",
  "𦽅": "rarely-used",
  "𦽇": "rarely-used",
  "𦽋": "rarely-used",
  "𦽎": "rarely-used",
  "𦽏": "rarely-used",
  "𦽐": "rarely-used",
  "𦽒": "rarely-used",
  "𦽔": "rarely-used",
  "𦽕": "rarely-used",
  "𦽗": "rarely-used",
  "𦽫": "rarely-used",
  "𦽬": "rarely-used",
  "𦽮": "rarely-used",
  "𦽵": "rarely-used",
  "𦽶": "rarely-used",
  "𦾏": "rarely-used",
  "𦾬": "rarely-used",
  "𦾮": "rarely-used",
  "𦾰": "rarely-used",
  "𦾱": "rarely-used",
  "𦾲": "rarely-used",
  "𦾳": "rarely-used",
  "𦾵": "rarely-used",
  "𦾶": "rarely-used",
  "𦾸": "rarely-used",
  "𦾹": "rarely-used",
  "𦾺": "rarely-used",
  "𦾻": "rarely-used",
  "𦾽": "rarely-used",
  "𦾿": "rarely-used",
  "𦿀": "rarely-used",
  "𦿁": "rarely-used",
  "𦿂": "rarely-used",
  "𦿃": "rarely-used",
  "𦿅": "rarely-used",
  "𦿆": "rarely-used",
  "𦿊": "rarely-used",
  "𦿌": "rarely-used",
  "𦿍": "rarely-used",
  "𦿎": "rarely-used",
  "𦿏": "rarely-used",
  "𦿖": "rarely-used",
  "𧀄": "rarely-used",
  "𧀆": "rarely-used",
  "𧀔": "rarely-used",
  "𧀕": "rarely-used",
  "𧀖": "rarely-used",
  "𧀘": "rarely-used",
  "𧀙": "rarely-used",
  "𧀚": "rarely-used",
  "𧀠": "rarely-used",
  "𧀡": "rarely-used",
  "𧀣": "rarely-used",
  "𧀤": "rarely-used",
  "𧀥": "rarely-used",
  "𧀧": "rarely-used",
  "𧀨": "rarely-used",
  "𧀩": "rarely-used",
  "𧀬": "rarely-used",
  "𧀭": "rarely-used",
  "𧀯": "rarely-used",
  "𧀰": "rarely-used",
  "𧀲": "rarely-used",
  "𧀴": "rarely-used",
  "𧀺": "rarely-used",
  "𧀻": "rarely-used",
  "𧁈": "rarely-used",
  "𧁉": "rarely-used",
  "𧁊": "rarely-used",
  "𧁋": "rarely-used",
  "𧁾": "rarely-used",
  "𧁿": "rarely-used",
  "𧂁": "rarely-used",
  "𧂂": "rarely-used",
  "𧂅": "rarely-used",
  "𧂆": "rarely-used",
  "𧂈": "rarely-used",
  "𧂉": "rarely-used",
  "𧂋": "rarely-used",
  "𧂏": "rarely-used",
  "𧂐": "rarely-used",
  "𧂒": "rarely-used",
  "𧂔": "rarely-used",
  "𧂛": "rarely-used",
  "𧂜": "rarely-used",
  "𧂞": "rarely-used",
  "𧂣": "rarely-used",
  "𧂨": "rarely-used",
  "𧂩": "rarely-used",
  "𧃐": "rarely-used",
  "𧃑": "rarely-used",
  "𧃒": "rarely-used",
  "𧃔": "rarely-used",
  "𧃖": "rarely-used",
  "𧃙": "rarely-used",
  "𧃛": "rarely-used",
  "𧃝": "rarely-used",
  "𧃞": "rarely-used",
  "𧃟": "rarely-used",
  "𧃢": "rarely-used",
  "𧃨": "rarely-used",
  "𧃩": "rarely-used",
  "𧃪": "rarely-used",
  "𧃹": "rarely-used",
  "𧄍": "rarely-used",
  "𧄎": "rarely-used",
  "𧄏": "rarely-used",
  "𧄐": "rarely-used",
  "𧄑": "rarely-used",
  "𧄓": "rarely-used",
  "𧄚": "rarely-used",
  "𧄛": "rarely-used",
  "𧄠": "rarely-used",
  "𧄹": "rarely-used",
  "𧄺": "rarely-used",
  "𧄻": "rarely-used",
  "𧄼": "rarely-used",
  "𧄽": "rarely-used",
  "𧄾": "rarely-used",
  "𧄿": "rarely-used",
  "𧅀": "rarely-used",
  "𧅃": "rarely-used",
  "𧅄": "rarely-used",
  "𧅆": "rarely-used",
  "𧅋": "rarely-used",
  "𧅖": "rarely-used",
  "𧅗": "rarely-used",
  "𧅘": "rarely-used",
  "𧅚": "rarely-used",
  "𧅢": "rarely-used",
  "𧅮": "rarely-used",
  "𧅰": "rarely-used",
  "𧅺": "rarely-used",
  "𧅻": "rarely-used",
  "𧆇": "rarely-used",
  "𧆉": "rarely-used",
  "𧆏": "rarely-used",
  "𧆐": "rarely-used",
  "𧆓": "rarely-used",
  "𧆕": "rarely-used",
  "𧆘": "rarely-used",
  "𧆙": "rarely-used",
  "𧆣": "rarely-used",
  "𧆤": "rarely-used",
  "𧆥": "rarely-used",
  "𧆦": "rarely-used",
  "𧆲": "rarely-used",
  "𧆺": "rarely-used",
  "𧆻": "rarely-used",
  "𧆼": "rarely-used",
  "𧇁": "rarely-used",
  "𧇉": "rarely-used",
  "𧇓": "rarely-used",
  "𧇜": "rarely-used",
  "𧇝": "rarely-used",
  "𧇞": "rarely-used",
  "𧇟": "rarely-used",
  "𧇠": "rarely-used",
  "𧇡": "rarely-used",
  "𧇦": "rarely-used",
  "𧇧": "rarely-used",
  "𧇬": "rarely-used",
  "𧇼": "rarely-used",
  "𧇿": "rarely-used",
  "𧈁": "rarely-used",
  "𧈈": "rarely-used",
  "𧈍": "rarely-used",
  "𧈑": "rarely-used",
  "𧈓": "rarely-used",
  "𧈕": "rarely-used",
  "𧈘": "rarely-used",
  "𧈜": "rarely-used",
  "𧈝": "rarely-used",
  "𧈟": "rarely-used",
  "𧈪": "rarely-used",
  "𧈭": "rarely-used",
  "𧈻": "rarely-used",
  "𧈽": "rarely-used",
  "𧈾": "rarely-used",
  "𧉀": "rarely-used",
  "𧉁": "rarely-used",
  "𧉃": "rarely-used",
  "𧉄": "rarely-used",
  "𧉆": "rarely-used",
  "𧉈": "rarely-used",
  "𧉊": "rarely-used",
  "𧉋": "rarely-used",
  "𧉍": "rarely-used",
  "𧉎": "rarely-used",
  "𧉑": "rarely-used",
  "𧉛": "rarely-used",
  "𧉞": "rarely-used",
  "𧉟": "rarely-used",
  "𧉡": "rarely-used",
  "𧉢": "rarely-used",
  "𧉣": "rarely-used",
  "𧉤": "rarely-used",
  "𧉥": "rarely-used",
  "𧉩": "rarely-used",
  "𧉪": "rarely-used",
  "𧉫": "rarely-used",
  "𧉭": "rarely-used",
  "𧉰": "rarely-used",
  "𧊅": "rarely-used",
  "𧊍": "rarely-used",
  "𧊎": "rarely-used",
  "𧊏": "rarely-used",
  "𧊒": "rarely-used",
  "𧊔": "rarely-used",
  "𧊕": "rarely-used",
  "𧊖": "rarely-used",
  "𧊗": "rarely-used",
  "𧊘": "rarely-used",
  "𧊙": "rarely-used",
  "𧊚": "rarely-used",
  "𧊞": "rarely-used",
  "𧊟": "rarely-used",
  "𧊣": "rarely-used",
  "𧊥": "rarely-used",
  "𧊦": "rarely-used",
  "𧊬": "rarely-used",
  "𧊭": "rarely-used",
  "𧊯": "rarely-used",
  "𧊶": "rarely-used",
  "𧊷": "rarely-used",
  "𧋊": "rarely-used",
  "𧋍": "rarely-used",
  "𧋎": "rarely-used",
  "𧋏": "rarely-used",
  "𧋐": "rarely-used",
  "𧋑": "rarely-used",
  "𧋒": "rarely-used",
  "𧋓": "rarely-used",
  "𧋔": "rarely-used",
  "𧋕": "rarely-used",
  "𧋖": "rarely-used",
  "𧋘": "rarely-used",
  "𧋡": "rarely-used",
  "𧌃": "rarely-used",
  "𧌄": "rarely-used",
  "𧌅": "rarely-used",
  "𧌆": "rarely-used",
  "𧌇": "rarely-used",
  "𧌉": "rarely-used",
  "𧌌": "rarely-used",
  "𧌍": "rarely-used",
  "𧌎": "rarely-used",
  "𧌏": "rarely-used",
  "𧌔": "rarely-used",
  "𧌗": "rarely-used",
  "𧌙": "rarely-used",
  "𧌚": "rarely-used",
  "𧌝": "rarely-used",
  "𧌢": "rarely-used",
  "𧌣": "rarely-used",
  "𧌧": "rarely-used",
  "𧌬": "rarely-used",
  "𧌴": "rarely-used",
  "𧌽": "rarely-used",
  "𧍒": "rarely-used",
  "𧍔": "rarely-used",
  "𧍕": "rarely-used",
  "𧍖": "rarely-used",
  "𧍙": "rarely-used",
  "𧍜": "rarely-used",
  "𧍠": "rarely-used",
  "𧍢": "rarely-used",
  "𧍥": "rarely-used",
  "𧍩": "rarely-used",
  "𧍪": "rarely-used",
  "𧍫": "rarely-used",
  "𧍬": "rarely-used",
  "𧍭": "rarely-used",
  "𧍮": "rarely-used",
  "𧍯": "rarely-used",
  "𧍰": "rarely-used",
  "𧍲": "rarely-used",
  "𧍳": "rarely-used",
  "𧍴": "rarely-used",
  "𧍵": "rarely-used",
  "𧍶": "rarely-used",
  "𧎃": "rarely-used",
  "𧎄": "rarely-used",
  "𧎈": "rarely-used",
  "𧎡": "rarely-used",
  "𧎣": "rarely-used",
  "𧎤": "rarely-used",
  "𧎥": "rarely-used",
  "𧎦": "rarely-used",
  "𧎨": "rarely-used",
  "𧎫": "rarely-used",
  "𧎭": "rarely-used",
  "𧎯": "rarely-used",
  "𧎰": "rarely-used",
  "𧎱": "rarely-used",
  "𧎳": "rarely-used",
  "𧎵": "rarely-used",
  "𧎷": "rarely-used",
  "𧎸": "rarely-used",
  "𧎹": "rarely-used",
  "𧎺": "rarely-used",
  "𧎼": "rarely-used",
  "𧎿": "rarely-used",
  "𧏂": "rarely-used",
  "𧏄": "rarely-used",
  "𧏇": "rarely-used",
  "𧏊": "rarely-used",
  "𧏌": "rarely-used",
  "𧏹": "rarely-used",
  "𧏺": "rarely-used",
  "𧏻": "rarely-used",
  "𧐇": "rarely-used",
  "𧐈": "rarely-used",
  "𧐍": "rarely-used",
  "𧐎": "rarely-used",
  "𧐓": "rarely-used",
  "𧐔": "rarely-used",
  "𧐖": "rarely-used",
  "𧐙": "rarely-used",
  "𧐞": "rarely-used",
  "𧐟": "rarely-used",
  "𧐴": "rarely-used",
  "𧑀": "rarely-used",
  "𧑅": "rarely-used",
  "𧑊": "rarely-used",
  "𧑋": "rarely-used",
  "𧑌": "rarely-used",
  "𧑍": "rarely-used",
  "𧑎": "rarely-used",
  "𧑐": "rarely-used",
  "𧑑": "rarely-used",
  "𧑒": "rarely-used",
  "𧑓": "rarely-used",
  "𧑔": "rarely-used",
  "𧑕": "rarely-used",
  "𧑖": "rarely-used",
  "𧑗": "rarely-used",
  "𧑘": "rarely-used",
  "𧑚": "rarely-used",
  "𧑜": "rarely-used",
  "𧑝": "rarely-used",
  "𧑡": "rarely-used",
  "𧑤": "rarely-used",
  "𧑦": "rarely-used",
  "𧑧": "rarely-used",
  "𧑩": "rarely-used",
  "𧑫": "rarely-used",
  "𧒂": "rarely-used",
  "𧒈": "rarely-used",
  "𧒖": "rarely-used",
  "𧒗": "rarely-used",
  "𧒘": "rarely-used",
  "𧒝": "rarely-used",
  "𧒨": "rarely-used",
  "𧒽": "rarely-used",
  "𧓋": "rarely-used",
  "𧓏": "rarely-used",
  "𧓐": "rarely-used",
  "𧓓": "rarely-used",
  "𧓕": "rarely-used",
  "𧓖": "rarely-used",
  "𧓘": "rarely-used",
  "𧓝": "rarely-used",
  "𧓬": "rarely-used",
  "𧓴": "rarely-used",
  "𧓸": "rarely-used",
  "𧓺": "rarely-used",
  "𧓻": "rarely-used",
  "𧔂": "rarely-used",
  "𧔎": "rarely-used",
  "𧔏": "rarely-used",
  "𧔝": "rarely-used",
  "𧔞": "rarely-used",
  "𧔟": "rarely-used",
  "𧔠": "rarely-used",
  "𧔣": "rarely-used",
  "𧔤": "rarely-used",
  "𧔥": "rarely-used",
  "𧔧": "rarely-used",
  "𧔨": "rarely-used",
  "𧔪": "rarely-used",
  "𧔳": "rarely-used",
  "𧔴": "rarely-used",
  "𧔷": "rarely-used",
  "𧕃": "rarely-used",
  "𧕄": "rarely-used",
  "𧕅": "rarely-used",
  "𧕇": "rarely-used",
  "𧕋": "rarely-used",
  "𧕍": "rarely-used",
  "𧕒": "rarely-used",
  "𧕕": "rarely-used",
  "𧕛": "rarely-used",
  "𧕝": "rarely-used",
  "𧕞": "rarely-used",
  "𧕟": "rarely-used",
  "𧕡": "rarely-used",
  "𧕤": "rarely-used",
  "𧕥": "rarely-used",
  "𧕧": "rarely-used",
  "𧕨": "rarely-used",
  "𧕮": "rarely-used",
  "𧕯": "rarely-used",
  "𧕰": "rarely-used",
  "𧕱": "rarely-used",
  "𧕲": "rarely-used",
  "𧕴": "rarely-used",
  "𧕸": "rarely-used",
  "𧕹": "rarely-used",
  "𧕼": "rarely-used",
  "𧖆": "rarely-used",
  "𧖒": "rarely-used",
  "𧖔": "rarely-used",
  "𧖕": "rarely-used",
  "𧖘": "rarely-used",
  "𧖛": "rarely-used",
  "𧖜": "rarely-used",
  "𧖧": "rarely-used",
  "𧖪": "rarely-used",
  "𧖬": "rarely-used",
  "𧖵": "rarely-used",
  "𧖺": "rarely-used",
  "𧖻": "rarely-used",
  "𧖼": "rarely-used",
  "𧗁": "rarely-used",
  "𧗆": "rarely-used",
  "𧗇": "rarely-used",
  "𧗈": "rarely-used",
  "𧗋": "rarely-used",
  "𧗌": "rarely-used",
  "𧗎": "rarely-used",
  "𧗕": "rarely-used",
  "𧗖": "rarely-used",
  "𧗣": "rarely-used",
  "𧗦": "rarely-used",
  "𧗩": "rarely-used",
  "𧗫": "rarely-used",
  "𧗴": "rarely-used",
  "𧗹": "rarely-used",
  "𧗿": "rarely-used",
  "𧘈": "rarely-used",
  "𧘍": "rarely-used",
  "𧘏": "rarely-used",
  "𧘐": "rarely-used",
  "𧘑": "rarely-used",
  "𧘓": "rarely-used",
  "𧘚": "rarely-used",
  "𧘜": "rarely-used",
  "𧘞": "rarely-used",
  "𧘢": "rarely-used",
  "𧘥": "rarely-used",
  "𧘧": "rarely-used",
  "𧘩": "rarely-used",
  "𧘮": "rarely-used",
  "𧘳": "rarely-used",
  "𧘽": "rarely-used",
  "𧘾": "rarely-used",
  "𧙀": "rarely-used",
  "𧙂": "rarely-used",
  "𧙃": "rarely-used",
  "𧙅": "rarely-used",
  "𧙆": "rarely-used",
  "𧙇": "rarely-used",
  "𧙈": "rarely-used",
  "𧙉": "rarely-used",
  "𧙌": "rarely-used",
  "𧙛": "rarely-used",
  "𧙝": "rarely-used",
  "𧙞": "rarely-used",
  "𧙡": "rarely-used",
  "𧙣": "rarely-used",
  "𧙤": "rarely-used",
  "𧙧": "rarely-used",
  "𧙫": "rarely-used",
  "𧙬": "rarely-used",
  "𧙭": "rarely-used",
  "𧙮": "rarely-used",
  "𧙯": "rarely-used",
  "𧙾": "rarely-used",
  "𧚀": "rarely-used",
  "𧚁": "rarely-used",
  "𧚂": "rarely-used",
  "𧚃": "rarely-used",
  "𧚄": "rarely-used",
  "𧚅": "rarely-used",
  "𧚆": "rarely-used",
  "𧚇": "rarely-used",
  "𧚈": "rarely-used",
  "𧚉": "rarely-used",
  "𧚋": "rarely-used",
  "𧚏": "rarely-used",
  "𧚐": "rarely-used",
  "𧚡": "rarely-used",
  "𧚥": "rarely-used",
  "𧚨": "rarely-used",
  "𧚩": "rarely-used",
  "𧚪": "rarely-used",
  "𧚫": "rarely-used",
  "𧚬": "rarely-used",
  "𧚭": "rarely-used",
  "𧚯": "rarely-used",
  "𧚵": "rarely-used",
  "𧚷": "rarely-used",
  "𧛃": "rarely-used",
  "𧛏": "rarely-used",
  "𧛒": "rarely-used",
  "𧛖": "rarely-used",
  "𧛗": "rarely-used",
  "𧛚": "rarely-used",
  "𧛞": "rarely-used",
  "𧛟": "rarely-used",
  "𧛣": "rarely-used",
  "𧛧": "rarely-used",
  "𧛩": "rarely-used",
  "𧛸": "rarely-used",
  "𧛹": "rarely-used",
  "𧛻": "rarely-used",
  "𧛼": "rarely-used",
  "𧛾": "rarely-used",
  "𧜂": "rarely-used",
  "𧜃": "rarely-used",
  "𧜅": "rarely-used",
  "𧜈": "rarely-used",
  "𧜊": "rarely-used",
  "𧜍": "rarely-used",
  "𧜝": "rarely-used",
  "𧜞": "rarely-used",
  "𧜠": "rarely-used",
  "𧜣": "rarely-used",
  "𧜤": "rarely-used",
  "𧜥": "rarely-used",
  "𧜦": "rarely-used",
  "𧜧": "rarely-used",
  "𧜲": "rarely-used",
  "𧜽": "rarely-used",
  "𧝃": "rarely-used",
  "𧝆": "rarely-used",
  "𧝇": "rarely-used",
  "𧝉": "rarely-used",
  "𧝊": "rarely-used",
  "𧝋": "rarely-used",
  "𧝌": "rarely-used",
  "𧝏": "rarely-used",
  "𧝑": "rarely-used",
  "𧝒": "rarely-used",
  "𧝔": "rarely-used",
  "𧝗": "rarely-used",
  "𧝘": "rarely-used",
  "𧝙": "rarely-used",
  "𧝚": "rarely-used",
  "𧝪": "rarely-used",
  "𧝫": "rarely-used",
  "𧝬": "rarely-used",
  "𧝭": "rarely-used",
  "𧝮": "rarely-used",
  "𧝯": "rarely-used",
  "𧝲": "rarely-used",
  "𧝳": "rarely-used",
  "𧝴": "rarely-used",
  "𧝷": "rarely-used",
  "𧝸": "rarely-used",
  "𧞍": "rarely-used",
  "𧞏": "rarely-used",
  "𧞐": "rarely-used",
  "𧞒": "rarely-used",
  "𧞕": "rarely-used",
  "𧞛": "rarely-used",
  "𧞝": "rarely-used",
  "𧞞": "rarely-used",
  "𧞦": "rarely-used",
  "𧞩": "rarely-used",
  "𧞪": "rarely-used",
  "𧞭": "rarely-used",
  "𧞸": "rarely-used",
  "𧞹": "rarely-used",
  "𧞺": "rarely-used",
  "𧟃": "rarely-used",
  "𧟌": "rarely-used",
  "𧟑": "rarely-used",
  "𧟙": "rarely-used",
  "𧟞": "rarely-used",
  "𧟡": "rarely-used",
  "𧟦": "rarely-used",
  "𧟧": "rarely-used",
  "𧟵": "rarely-used",
  "𧠂": "rarely-used",
  "𧠆": "rarely-used",
  "𧠋": "rarely-used",
  "𧠎": "rarely-used",
  "𧠏": "rarely-used",
  "𧠒": "rarely-used",
  "𧠓": "rarely-used",
  "𧠘": "rarely-used",
  "𧠚": "rarely-used",
  "𧠛": "rarely-used",
  "𧠠": "rarely-used",
  "𧠩": "rarely-used",
  "𧠪": "rarely-used",
  "𧠫": "rarely-used",
  "𧠰": "rarely-used",
  "𧠼": "rarely-used",
  "𧠽": "rarely-used",
  "𧠾": "rarely-used",
  "𧠿": "rarely-used",
  "𧡅": "rarely-used",
  "𧡈": "rarely-used",
  "𧡋": "rarely-used",
  "𧡍": "rarely-used",
  "𧡏": "rarely-used",
  "𧡑": "rarely-used",
  "𧡖": "rarely-used",
  "𧡡": "rarely-used",
  "𧡢": "rarely-used",
  "𧡣": "rarely-used",
  "𧡤": "rarely-used",
  "𧡦": "rarely-used",
  "𧡨": "rarely-used",
  "𧡫": "rarely-used",
  "𧡬": "rarely-used",
  "𧡮": "rarely-used",
  "𧡯": "rarely-used",
  "𧡸": "rarely-used",
  "𧡹": "rarely-used",
  "𧡺": "rarely-used",
  "𧢂": "rarely-used",
  "𧢄": "rarely-used",
  "𧢆": "rarely-used",
  "𧢒": "rarely-used",
  "𧢖": "rarely-used",
  "𧢜": "rarely-used",
  "𧢝": "rarely-used",
  "𧢞": "rarely-used",
  "𧢢": "rarely-used",
  "𧢦": "rarely-used",
  "𧢧": "rarely-used",
  "𧢭": "rarely-used",
  "𧢯": "rarely-used",
  "𧢵": "rarely-used",
  "𧢷": "rarely-used",
  "𧢹": "rarely-used",
  "𧢼": "rarely-used",
  "𧢽": "rarely-used",
  "𧢾": "rarely-used",
  "𧣁": "rarely-used",
  "𧣃": "rarely-used",
  "𧣑": "rarely-used",
  "𧣒": "rarely-used",
  "𧣕": "rarely-used",
  "𧣚": "rarely-used",
  "𧣛": "rarely-used",
  "𧣡": "rarely-used",
  "𧣢": "rarely-used",
  "𧣣": "rarely-used",
  "𧣩": "rarely-used",
  "𧣪": "rarely-used",
  "𧣬": "rarely-used",
  "𧣭": "rarely-used",
  "𧣵": "rarely-used",
  "𧣷": "rarely-used",
  "𧣸": "rarely-used",
  "𧣹": "rarely-used",
  "𧣺": "rarely-used",
  "𧣼": "rarely-used",
  "𧤃": "rarely-used",
  "𧤆": "rarely-used",
  "𧤉": "rarely-used",
  "𧤍": "rarely-used",
  "𧤎": "rarely-used",
  "𧤏": "rarely-used",
  "𧤐": "rarely-used",
  "𧤑": "rarely-used",
  "𧤒": "rarely-used",
  "𧤕": "rarely-used",
  "𧤖": "rarely-used",
  "𧤗": "rarely-used",
  "𧤛": "rarely-used",
  "𧤟": "rarely-used",
  "𧤠": "rarely-used",
  "𧤣": "rarely-used",
  "𧤮": "rarely-used",
  "𧤲": "rarely-used",
  "𧤻": "rarely-used",
  "𧤼": "rarely-used",
  "𧤽": "rarely-used",
  "𧥈": "rarely-used",
  "𧥌": "rarely-used",
  "𧥍": "rarely-used",
  "𧥓": "rarely-used",
  "𧥖": "rarely-used",
  "𧥙": "rarely-used",
  "𧥛": "rarely-used",
  "𧥜": "rarely-used",
  "𧥣": "rarely-used",
  "𧥤": "rarely-used",
  "𧥦": "rarely-used",
  "𧥮": "rarely-used",
  "𧥱": "rarely-used",
  "𧥴": "rarely-used",
  "𧥵": "rarely-used",
  "𧥸": "rarely-used",
  "𧥹": "rarely-used",
  "𧥼": "rarely-used",
  "𧦀": "rarely-used",
  "𧦛": "rarely-used",
  "𧦝": "rarely-used",
  "𧦞": "rarely-used",
  "𧦟": "rarely-used",
  "𧦤": "rarely-used",
  "𧦨": "rarely-used",
  "𧦭": "rarely-used",
  "𧦮": "rarely-used",
  "𧦯": "rarely-used",
  "𧧄": "rarely-used",
  "𧧅": "rarely-used",
  "𧧆": "rarely-used",
  "𧧉": "rarely-used",
  "𧧊": "rarely-used",
  "𧧋": "rarely-used",
  "𧧒": "rarely-used",
  "𧧓": "rarely-used",
  "𧧔": "rarely-used",
  "𧧕": "rarely-used",
  "𧧝": "rarely-used",
  "𧧟": "rarely-used",
  "𧧠": "rarely-used",
  "𧧨": "rarely-used",
  "𧧵": "rarely-used",
  "𧧶": "rarely-used",
  "𧧷": "rarely-used",
  "𧧸": "rarely-used",
  "𧧹": "rarely-used",
  "𧧺": "rarely-used",
  "𧧻": "rarely-used",
  "𧧾": "rarely-used",
  "𧨀": "rarely-used",
  "𧨂": "rarely-used",
  "𧨄": "rarely-used",
  "𧨊": "rarely-used",
  "𧨋": "rarely-used",
  "𧨜": "rarely-used",
  "𧨧": "rarely-used",
  "𧨩": "rarely-used",
  "𧨪": "rarely-used",
  "𧨰": "rarely-used",
  "𧨱": "rarely-used",
  "𧨲": "rarely-used",
  "𧨳": "rarely-used",
  "𧨴": "rarely-used",
  "𧨵": "rarely-used",
  "𧨷": "rarely-used",
  "𧨸": "rarely-used",
  "𧨹": "rarely-used",
  "𧨾": "rarely-used",
  "𧨿": "rarely-used",
  "𧩃": "rarely-used",
  "𧩄": "rarely-used",
  "𧩅": "rarely-used",
  "𧩆": "rarely-used",
  "𧩇": "rarely-used",
  "𧩚": "rarely-used",
  "𧩝": "rarely-used",
  "𧩣": "rarely-used",
  "𧩦": "rarely-used",
  "𧩧": "rarely-used",
  "𧩨": "rarely-used",
  "𧩬": "rarely-used",
  "𧩮": "rarely-used",
  "𧩲": "rarely-used",
  "𧩴": "rarely-used",
  "𧩶": "rarely-used",
  "𧩹": "rarely-used",
  "𧩼": "rarely-used",
  "𧪃": "rarely-used",
  "𧪅": "rarely-used",
  "𧪇": "rarely-used",
  "𧪘": "rarely-used",
  "𧪙": "rarely-used",
  "𧪚": "rarely-used",
  "𧪜": "rarely-used",
  "𧪝": "rarely-used",
  "𧪞": "rarely-used",
  "𧪠": "rarely-used",
  "𧪡": "rarely-used",
  "𧪢": "rarely-used",
  "𧪣": "rarely-used",
  "𧪦": "rarely-used",
  "𧪨": "rarely-used",
  "𧪫": "rarely-used",
  "𧪯": "rarely-used",
  "𧪵": "rarely-used",
  "𧪶": "rarely-used",
  "𧪹": "rarely-used",
  "𧫓": "rarely-used",
  "𧫕": "rarely-used",
  "𧫗": "rarely-used",
  "𧫛": "rarely-used",
  "𧫜": "rarely-used",
  "𧫝": "rarely-used",
  "𧫞": "rarely-used",
  "𧫡": "rarely-used",
  "𧫢": "rarely-used",
  "𧫤": "rarely-used",
  "𧫥": "rarely-used",
  "𧫦": "rarely-used",
  "𧫬": "rarely-used",
  "𧫾": "rarely-used",
  "𧫿": "rarely-used",
  "𧬂": "rarely-used",
  "𧬆": "rarely-used",
  "𧬇": "rarely-used",
  "𧬈": "rarely-used",
  "𧬊": "rarely-used",
  "𧬋": "rarely-used",
  "𧬌": "rarely-used",
  "𧬕": "rarely-used",
  "𧬖": "rarely-used",
  "𧬤": "rarely-used",
  "𧬧": "rarely-used",
  "𧬨": "rarely-used",
  "𧬩": "rarely-used",
  "𧬪": "rarely-used",
  "𧬬": "rarely-used",
  "𧬮": "rarely-used",
  "𧬰": "rarely-used",
  "𧭈": "rarely-used",
  "𧭊": "rarely-used",
  "𧭍": "rarely-used",
  "𧭎": "rarely-used",
  "𧭏": "rarely-used",
  "𧭓": "rarely-used",
  "𧭔": "rarely-used",
  "𧭕": "rarely-used",
  "𧭚": "rarely-used",
  "𧭜": "rarely-used",
  "𧭝": "rarely-used",
  "𧭞": "rarely-used",
  "𧭟": "rarely-used",
  "𧭠": "rarely-used",
  "𧭣": "rarely-used",
  "𧭤": "rarely-used",
  "𧭥": "rarely-used",
  "𧭪": "rarely-used",
  "𧭮": "rarely-used",
  "𧭸": "rarely-used",
  "𧭹": "rarely-used",
  "𧭻": "rarely-used",
  "𧭼": "rarely-used",
  "𧭽": "rarely-used",
  "𧮑": "rarely-used",
  "𧮓": "rarely-used",
  "𧮙": "rarely-used",
  "𧮝": "rarely-used",
  "𧮞": "rarely-used",
  "𧮫": "rarely-used",
  "𧮬": "rarely-used",
  "𧮭": "rarely-used",
  "𧮮": "rarely-used",
  "𧮯": "rarely-used",
  "𧮱": "rarely-used",
  "𧮵": "rarely-used",
  "𧮶": "rarely-used",
  "𧮺": "rarely-used",
  "𧮻": "rarely-used",
  "𧮼": "rarely-used",
  "𧮽": "rarely-used",
  "𧯀": "rarely-used",
  "𧯉": "rarely-used",
  "𧯍": "rarely-used",
  "𧯏": "rarely-used",
  "𧯕": "rarely-used",
  "𧯘": "rarely-used",
  "𧯠": "rarely-used",
  "𧯡": "rarely-used",
  "𧯥": "rarely-used",
  "𧯦": "rarely-used",
  "𧯩": "rarely-used",
  "𧯫": "rarely-used",
  "𧯰": "rarely-used",
  "𧯱": "rarely-used",
  "𧯷": "rarely-used",
  "𧯺": "rarely-used",
  "𧯼": "rarely-used",
  "𧯾": "rarely-used",
  "𧰀": "rarely-used",
  "𧰃": "rarely-used",
  "𧰄": "rarely-used",
  "𧰆": "rarely-used",
  "𧰇": "rarely-used",
  "𧰊": "rarely-used",
  "𧰐": "rarely-used",
  "𧰑": "rarely-used",
  "𧰒": "rarely-used",
  "𧰓": "rarely-used",
  "𧰕": "rarely-used",
  "𧰘": "rarely-used",
  "𧰙": "rarely-used",
  "𧰠": "rarely-used",
  "𧰡": "rarely-used",
  "𧰣": "rarely-used",
  "𧰨": "rarely-used",
  "𧰩": "rarely-used",
  "𧰪": "rarely-used",
  "𧰫": "rarely-used",
  "𧰰": "rarely-used",
  "𧰵": "rarely-used",
  "𧰷": "rarely-used",
  "𧰸": "rarely-used",
  "𧰹": "rarely-used",
  "𧰻": "rarely-used",
  "𧰿": "rarely-used",
  "𧱀": "rarely-used",
  "𧱁": "rarely-used",
  "𧱄": "rarely-used",
  "𧱅": "rarely-used",
  "𧱆": "rarely-used",
  "𧱉": "rarely-used",
  "𧱊": "rarely-used",
  "𧱏": "rarely-used",
  "𧱐": "rarely-used",
  "𧱒": "rarely-used",
  "𧱓": "rarely-used",
  "𧱘": "rarely-used",
  "𧱙": "rarely-used",
  "𧱜": "rarely-used",
  "𧱝": "rarely-used",
  "𧱠": "rarely-used",
  "𧱡": "rarely-used",
  "𧱣": "rarely-used",
  "𧱨": "rarely-used",
  "𧱩": "rarely-used",
  "𧱪": "rarely-used",
  "𧱬": "rarely-used",
  "𧱰": "rarely-used",
  "𧱲": "rarely-used",
  "𧱳": "rarely-used",
  "𧱴": "rarely-used",
  "𧱵": "rarely-used",
  "𧱻": "rarely-used",
  "𧱼": "rarely-used",
  "𧱾": "rarely-used",
  "𧲂": "rarely-used",
  "𧲃": "rarely-used",
  "𧲄": "rarely-used",
  "𧲆": "rarely-used",
  "𧲇": "rarely-used",
  "𧲈": "rarely-used",
  "𧲋": "rarely-used",
  "𧲌": "rarely-used",
  "𧲍": "rarely-used",
  "𧲗": "rarely-used",
  "𧲜": "rarely-used",
  "𧲝": "rarely-used",
  "𧲡": "rarely-used",
  "𧲤": "rarely-used",
  "𧲥": "rarely-used",
  "𧲦": "rarely-used",
  "𧲧": "rarely-used",
  "𧲨": "rarely-used",
  "𧲭": "rarely-used",
  "𧲮": "rarely-used",
  "𧲯": "rarely-used",
  "𧲰": "rarely-used",
  "𧲱": "rarely-used",
  "𧲴": "rarely-used",
  "𧲵": "rarely-used",
  "𧳀": "rarely-used",
  "𧳂": "rarely-used",
  "𧳄": "rarely-used",
  "𧳅": "rarely-used",
  "𧳉": "rarely-used",
  "𧳌": "rarely-used",
  "𧳍": "rarely-used",
  "𧳎": "rarely-used",
  "𧳐": "rarely-used",
  "𧳙": "rarely-used",
  "𧳚": "rarely-used",
  "𧳜": "rarely-used",
  "𧳝": "rarely-used",
  "𧳞": "rarely-used",
  "𧳧": "rarely-used",
  "𧳫": "rarely-used",
  "𧳬": "rarely-used",
  "𧳮": "rarely-used",
  "𧳶": "rarely-used",
  "𧳸": "rarely-used",
  "𧳹": "rarely-used",
  "𧳺": "rarely-used",
  "𧳻": "rarely-used",
  "𧳼": "rarely-used",
  "𧴂": "rarely-used",
  "𧴄": "rarely-used",
  "𧴅": "rarely-used",
  "𧴇": "rarely-used",
  "𧴌": "rarely-used",
  "𧴎": "rarely-used",
  "𧴕": "rarely-used",
  "𧴖": "rarely-used",
  "𧴗": "rarely-used",
  "𧴙": "rarely-used",
  "𧴚": "rarely-used",
  "𧴝": "rarely-used",
  "𧴣": "rarely-used",
  "𧴤": "rarely-used",
  "𧴥": "rarely-used",
  "𧴪": "rarely-used",
  "𧴬": "rarely-used",
  "𧴭": "rarely-used",
  "𧴺": "rarely-used",
  "𧵈": "rarely-used",
  "𧵊": "rarely-used",
  "𧵋": "rarely-used",
  "𧵌": "rarely-used",
  "𧵑": "rarely-used",
  "𧵠": "rarely-used",
  "𧵣": "rarely-used",
  "𧵧": "rarely-used",
  "𧵨": "rarely-used",
  "𧵫": "rarely-used",
  "𧵬": "rarely-used",
  "𧵭": "rarely-used",
  "𧵱": "rarely-used",
  "𧶂": "rarely-used",
  "𧶆": "rarely-used",
  "𧶇": "rarely-used",
  "𧶍": "rarely-used",
  "𧶝": "rarely-used",
  "𧶠": "rarely-used",
  "𧶢": "rarely-used",
  "𧶲": "rarely-used",
  "𧶵": "rarely-used",
  "𧶸": "rarely-used",
  "𧶺": "rarely-used",
  "𧷋": "rarely-used",
  "𧷍": "rarely-used",
  "𧷎": "rarely-used",
  "𧷏": "rarely-used",
  "𧷐": "rarely-used",
  "𧷑": "rarely-used",
  "𧷒": "rarely-used",
  "𧷟": "rarely-used",
  "𧷡": "rarely-used",
  "𧷥": "rarely-used",
  "𧷦": "rarely-used",
  "𧷧": "rarely-used",
  "𧷻": "rarely-used",
  "𧷾": "rarely-used",
  "𧷿": "rarely-used",
  "𧸂": "rarely-used",
  "𧸅": "rarely-used",
  "𧸈": "rarely-used",
  "𧸕": "rarely-used",
  "𧸗": "rarely-used",
  "𧸘": "rarely-used",
  "𧸙": "rarely-used",
  "𧸦": "rarely-used",
  "𧸧": "rarely-used",
  "𧸨": "rarely-used",
  "𧸫": "rarely-used",
  "𧸲": "rarely-used",
  "𧸳": "rarely-used",
  "𧸿": "rarely-used",
  "𧹛": "rarely-used",
  "𧹣": "rarely-used",
  "𧹬": "rarely-used",
  "𧹭": "rarely-used",
  "𧹲": "rarely-used",
  "𧹳": "rarely-used",
  "𧹴": "rarely-used",
  "𧹶": "rarely-used",
  "𧹽": "rarely-used",
  "𧺎": "rarely-used",
  "𧺏": "rarely-used",
  "𧺓": "rarely-used",
  "𧺝": "rarely-used",
  "𧺟": "rarely-used",
  "𧺠": "rarely-used",
  "𧺡": "rarely-used",
  "𧺢": "rarely-used",
  "𧺣": "rarely-used",
  "𧺤": "rarely-used",
  "𧺧": "rarely-used",
  "𧺨": "rarely-used",
  "𧺪": "rarely-used",
  "𧺲": "rarely-used",
  "𧺳": "rarely-used",
  "𧺶": "rarely-used",
  "𧺷": "rarely-used",
  "𧺸": "rarely-used",
  "𧺹": "rarely-used",
  "𧺼": "rarely-used",
  "𧺽": "rarely-used",
  "𧺾": "rarely-used",
  "𧻀": "rarely-used",
  "𧻁": "rarely-used",
  "𧻒": "rarely-used",
  "𧻓": "rarely-used",
  "𧻕": "rarely-used",
  "𧻖": "rarely-used",
  "𧻗": "rarely-used",
  "𧻘": "rarely-used",
  "𧻙": "rarely-used",
  "𧻚": "rarely-used",
  "𧻝": "rarely-used",
  "𧻰": "rarely-used",
  "𧻱": "rarely-used",
  "𧻲": "rarely-used",
  "𧻴": "rarely-used",
  "𧻵": "rarely-used",
  "𧻶": "rarely-used",
  "𧻺": "rarely-used",
  "𧻼": "rarely-used",
  "𧻿": "rarely-used",
  "𧼎": "rarely-used",
  "𧼏": "rarely-used",
  "𧼐": "rarely-used",
  "𧼑": "rarely-used",
  "𧼒": "rarely-used",
  "𧼓": "rarely-used",
  "𧼔": "rarely-used",
  "𧼖": "rarely-used",
  "𧼗": "rarely-used",
  "𧼙": "rarely-used",
  "𧼠": "rarely-used",
  "𧼡": "rarely-used",
  "𧼨": "rarely-used",
  "𧼩": "rarely-used",
  "𧼬": "rarely-used",
  "𧼭": "rarely-used",
  "𧼮": "rarely-used",
  "𧼯": "rarely-used",
  "𧼱": "rarely-used",
  "𧼴": "rarely-used",
  "𧼵": "rarely-used",
  "𧽄": "rarely-used",
  "𧽅": "rarely-used",
  "𧽆": "rarely-used",
  "𧽉": "rarely-used",
  "𧽊": "rarely-used",
  "𧽋": "rarely-used",
  "𧽌": "rarely-used",
  "𧽍": "rarely-used",
  "𧽎": "rarely-used",
  "𧽏": "rarely-used",
  "𧽐": "rarely-used",
  "𧽑": "rarely-used",
  "𧽒": "rarely-used",
  "𧽓": "rarely-used",
  "𧽔": "rarely-used",
  "𧽖": "rarely-used",
  "𧽞": "rarely-used",
  "𧽟": "rarely-used",
  "𧽠": "rarely-used",
  "𧽣": "rarely-used",
  "𧽤": "rarely-used",
  "𧽥": "rarely-used",
  "𧽦": "rarely-used",
  "𧽧": "rarely-used",
  "𧽨": "rarely-used",
  "𧽫": "rarely-used",
  "𧽶": "rarely-used",
  "𧽷": "rarely-used",
  "𧽸": "rarely-used",
  "𧽹": "rarely-used",
  "𧽻": "rarely-used",
  "𧽼": "rarely-used",
  "𧽽": "rarely-used",
  "𧽾": "rarely-used",
  "𧽿": "rarely-used",
  "𧾁": "rarely-used",
  "𧾂": "rarely-used",
  "𧾍": "rarely-used",
  "𧾎": "rarely-used",
  "𧾐": "rarely-used",
  "𧾑": "rarely-used",
  "𧾔": "rarely-used",
  "𧾙": "rarely-used",
  "𧾚": "rarely-used",
  "𧾛": "rarely-used",
  "𧾠": "rarely-used",
  "𧾡": "rarely-used",
  "𧾢": "rarely-used",
  "𧾣": "rarely-used",
  "𧾤": "rarely-used",
  "𧾥": "rarely-used",
  "𧾨": "rarely-used",
  "𧾩": "rarely-used",
  "𧾮": "rarely-used",
  "𧾯": "rarely-used",
  "𧾰": "rarely-used",
  "𧾱": "rarely-used",
  "𧾵": "rarely-used",
  "𧾶": "rarely-used",
  "𧾻": "rarely-used",
  "𧿅": "rarely-used",
  "𧿆": "rarely-used",
  "𧿔": "rarely-used",
  "𧿕": "rarely-used",
  "𧿗": "rarely-used",
  "𧿙": "rarely-used",
  "𧿚": "rarely-used",
  "𧿝": "rarely-used",
  "𧿮": "rarely-used",
  "𧿯": "rarely-used",
  "𧿲": "rarely-used",
  "𧿳": "rarely-used",
  "𧿴": "rarely-used",
  "𧿵": "rarely-used",
  "𧿷": "rarely-used",
  "𧿹": "rarely-used",
  "𧿺": "rarely-used",
  "𧿻": "rarely-used",
  "𧿼": "rarely-used",
  "𧿽": "rarely-used",
  "𨀀": "rarely-used",
  "𨀔": "rarely-used",
  "𨀕": "rarely-used",
  "𨀖": "rarely-used",
  "𨀘": "rarely-used",
  "𨀙": "rarely-used",
  "𨀜": "rarely-used",
  "𨀝": "rarely-used",
  "𨀠": "rarely-used",
  "𨀤": "rarely-used",
  "𨀧": "rarely-used",
  "𨀨": "rarely-used",
  "𨀩": "rarely-used",
  "𨀫": "rarely-used",
  "𨀬": "rarely-used",
  "𨀮": "rarely-used",
  "𨁁": "rarely-used",
  "𨁂": "rarely-used",
  "𨁃": "rarely-used",
  "𨁄": "rarely-used",
  "𨁅": "rarely-used",
  "𨁆": "rarely-used",
  "𨁇": "rarely-used",
  "𨁊": "rarely-used",
  "𨁋": "rarely-used",
  "𨁌": "rarely-used",
  "𨁍": "rarely-used",
  "𨁎": "rarely-used",
  "𨁏": "rarely-used",
  "𨁐": "rarely-used",
  "𨁑": "rarely-used",
  "𨁒": "rarely-used",
  "𨁔": "rarely-used",
  "𨁳": "rarely-used",
  "𨁶": "rarely-used",
  "𨁷": "rarely-used",
  "𨁸": "rarely-used",
  "𨁹": "rarely-used",
  "𨁺": "rarely-used",
  "𨁽": "rarely-used",
  "𨁿": "rarely-used",
  "𨂀": "rarely-used",
  "𨂁": "rarely-used",
  "𨂃": "rarely-used",
  "𨂄": "rarely-used",
  "𨂅": "rarely-used",
  "𨂇": "rarely-used",
  "𨂜": "rarely-used",
  "𨂝": "rarely-used",
  "𨂞": "rarely-used",
  "𨂟": "rarely-used",
  "𨂡": "rarely-used",
  "𨂢": "rarely-used",
  "𨂣": "rarely-used",
  "𨂤": "rarely-used",
  "𨂦": "rarely-used",
  "𨂪": "rarely-used",
  "𨂭": "rarely-used",
  "𨂯": "rarely-used",
  "𨂰": "rarely-used",
  "𨂱": "rarely-used",
  "𨂲": "rarely-used",
  "𨂴": "rarely-used",
  "𨂵": "rarely-used",
  "𨂷": "rarely-used",
  "𨂸": "rarely-used",
  "𨂿": "rarely-used",
  "𨃓": "rarely-used",
  "𨃔": "rarely-used",
  "𨃕": "rarely-used",
  "𨃗": "rarely-used",
  "𨃘": "rarely-used",
  "𨃙": "rarely-used",
  "𨃚": "rarely-used",
  "𨃞": "rarely-used",
  "𨃣": "rarely-used",
  "𨃤": "rarely-used",
  "𨃿": "rarely-used",
  "𨄀": "rarely-used",
  "𨄅": "rarely-used",
  "𨄇": "rarely-used",
  "𨄈": "rarely-used",
  "𨄉": "rarely-used",
  "𨄊": "rarely-used",
  "𨄋": "rarely-used",
  "𨄌": "rarely-used",
  "𨄍": "rarely-used",
  "𨄎": "rarely-used",
  "𨄐": "rarely-used",
  "𨄓": "rarely-used",
  "𨄕": "rarely-used",
  "𨄗": "rarely-used",
  "𨄘": "rarely-used",
  "𨄙": "rarely-used",
  "𨄚": "rarely-used",
  "𨄛": "rarely-used",
  "𨄨": "rarely-used",
  "𨅅": "rarely-used",
  "𨅊": "rarely-used",
  "𨅋": "rarely-used",
  "𨅎": "rarely-used",
  "𨅏": "rarely-used",
  "𨅑": "rarely-used",
  "𨅓": "rarely-used",
  "𨅔": "rarely-used",
  "𨅖": "rarely-used",
  "𨅗": "rarely-used",
  "𨅚": "rarely-used",
  "𨅞": "rarely-used",
  "𨅣": "rarely-used",
  "𨅤": "rarely-used",
  "𨅩": "rarely-used",
  "𨅪": "rarely-used",
  "𨆁": "rarely-used",
  "𨆂": "rarely-used",
  "𨆃": "rarely-used",
  "𨆅": "rarely-used",
  "𨆆": "rarely-used",
  "𨆇": "rarely-used",
  "𨆊": "rarely-used",
  "𨆋": "rarely-used",
  "𨆎": "rarely-used",
  "𨆏": "rarely-used",
  "𨆐": "rarely-used",
  "𨆦": "rarely-used",
  "𨆧": "rarely-used",
  "𨆨": "rarely-used",
  "𨆪": "rarely-used",
  "𨆬": "rarely-used",
  "𨆭": "rarely-used",
  "𨆰": "rarely-used",
  "𨆱": "rarely-used",
  "𨆲": "rarely-used",
  "𨆵": "rarely-used",
  "𨇁": "rarely-used",
  "𨇄": "rarely-used",
  "𨇅": "rarely-used",
  "𨇆": "rarely-used",
  "𨇇": "rarely-used",
  "𨇊": "rarely-used",
  "𨇔": "rarely-used",
  "𨇖": "rarely-used",
  "𨇗": "rarely-used",
  "𨇘": "rarely-used",
  "𨇝": "rarely-used",
  "𨇞": "rarely-used",
  "𨇦": "rarely-used",
  "𨇧": "rarely-used",
  "𨇩": "rarely-used",
  "𨇯": "rarely-used",
  "𨇻": "rarely-used",
  "𨇼": "rarely-used",
  "𨇽": "rarely-used",
  "𨈄": "rarely-used",
  "𨈈": "rarely-used",
  "𨈓": "rarely-used",
  "𨈕": "rarely-used",
  "𨈘": "rarely-used",
  "𨈙": "rarely-used",
  "𨈚": "rarely-used",
  "𨈩": "rarely-used",
  "𨈫": "rarely-used",
  "𨈮": "rarely-used",
  "𨈹": "rarely-used",
  "𨉈": "rarely-used",
  "𨉋": "rarely-used",
  "𨉕": "rarely-used",
  "𨉢": "rarely-used",
  "𨉣": "rarely-used",
  "𨉤": "rarely-used",
  "𨉱": "rarely-used",
  "𨉹": "rarely-used",
  "𨊍": "rarely-used",
  "𨊔": "rarely-used",
  "𨊛": "rarely-used",
  "𨊝": "rarely-used",
  "𨊡": "rarely-used",
  "𨊩": "rarely-used",
  "𨊱": "rarely-used",
  "𨊳": "rarely-used",
  "𨊸": "rarely-used",
  "𨊹": "rarely-used",
  "𨊻": "rarely-used",
  "𨊿": "rarely-used",
  "𨋀": "rarely-used",
  "𨋐": "rarely-used",
  "𨋑": "rarely-used",
  "𨋕": "rarely-used",
  "𨋖": "rarely-used",
  "𨋗": "rarely-used",
  "𨋘": "rarely-used",
  "𨋙": "rarely-used",
  "𨋛": "rarely-used",
  "𨋜": "rarely-used",
  "𨋦": "rarely-used",
  "𨋧": "rarely-used",
  "𨋪": "rarely-used",
  "𨋭": "rarely-used",
  "𨋮": "rarely-used",
  "𨋯": "rarely-used",
  "𨋰": "rarely-used",
  "𨋲": "rarely-used",
  "𨌁": "rarely-used",
  "𨌄": "rarely-used",
  "𨌅": "rarely-used",
  "𨌈": "rarely-used",
  "𨌍": "rarely-used",
  "𨌎": "rarely-used",
  "𨌝": "rarely-used",
  "𨌟": "rarely-used",
  "𨌢": "rarely-used",
  "𨌧": "rarely-used",
  "𨌫": "rarely-used",
  "𨌬": "rarely-used",
  "𨌭": "rarely-used",
  "𨌳": "rarely-used",
  "𨌴": "rarely-used",
  "𨌶": "rarely-used",
  "𨍅": "rarely-used",
  "𨍆": "rarely-used",
  "𨍈": "rarely-used",
  "𨍊": "rarely-used",
  "𨍌": "rarely-used",
  "𨍏": "rarely-used",
  "𨍐": "rarely-used",
  "𨍑": "rarely-used",
  "𨍖": "rarely-used",
  "𨍧": "rarely-used",
  "𨍨": "rarely-used",
  "𨍫": "rarely-used",
  "𨍰": "rarely-used",
  "𨍲": "rarely-used",
  "𨍴": "rarely-used",
  "𨍶": "rarely-used",
  "𨍸": "rarely-used",
  "𨍹": "rarely-used",
  "𨍿": "rarely-used",
  "𨎀": "rarely-used",
  "𨎇": "rarely-used",
  "𨎈": "rarely-used",
  "𨎉": "rarely-used",
  "𨎊": "rarely-used",
  "𨎍": "rarely-used",
  "𨎐": "rarely-used",
  "𨎡": "rarely-used",
  "𨎢": "rarely-used",
  "𨎤": "rarely-used",
  "𨎩": "rarely-used",
  "𨎬": "rarely-used",
  "𨎭": "rarely-used",
  "𨎮": "rarely-used",
  "𨎳": "rarely-used",
  "𨎴": "rarely-used",
  "𨎶": "rarely-used",
  "𨎷": "rarely-used",
  "𨎹": "rarely-used",
  "𨏆": "rarely-used",
  "𨏈": "rarely-used",
  "𨏉": "rarely-used",
  "𨏒": "rarely-used",
  "𨏠": "rarely-used",
  "𨏦": "rarely-used",
  "𨏨": "rarely-used",
  "𨏩": "rarely-used",
  "𨏪": "rarely-used",
  "𨏫": "rarely-used",
  "𨏱": "rarely-used",
  "𨏳": "rarely-used",
  "𨏴": "rarely-used",
  "𨏵": "rarely-used",
  "𨏶": "rarely-used",
  "𨏹": "rarely-used",
  "𨐁": "rarely-used",
  "𨐐": "rarely-used",
  "𨐑": "rarely-used",
  "𨐔": "rarely-used",
  "𨐘": "rarely-used",
  "𨐛": "rarely-used",
  "𨐟": "rarely-used",
  "𨐡": "rarely-used",
  "𨐨": "rarely-used",
  "𨐩": "rarely-used",
  "𨐯": "rarely-used",
  "𨐰": "rarely-used",
  "𨐱": "rarely-used",
  "𨐶": "rarely-used",
  "𨑊": "rarely-used",
  "𨑑": "rarely-used",
  "𨑠": "rarely-used",
  "𨑣": "rarely-used",
  "𨑤": "rarely-used",
  "𨑥": "rarely-used",
  "𨑨": "rarely-used",
  "𨑩": "rarely-used",
  "𨑪": "rarely-used",
  "𨑫": "rarely-used",
  "𨑼": "rarely-used",
  "𨑽": "rarely-used",
  "𨑿": "rarely-used",
  "𨒃": "rarely-used",
  "𨒄": "rarely-used",
  "𨒅": "rarely-used",
  "𨒇": "rarely-used",
  "𨒉": "rarely-used",
  "𨒊": "rarely-used",
  "𨒋": "rarely-used",
  "𨒍": "rarely-used",
  "𨒢": "rarely-used",
  "𨒣": "rarely-used",
  "𨒦": "rarely-used",
  "𨒨": "rarely-used",
  "𨒩": "rarely-used",
  "𨒫": "rarely-used",
  "𨒬": "rarely-used",
  "𨒼": "rarely-used",
  "𨒾": "rarely-used",
  "𨓁": "rarely-used",
  "𨓂": "rarely-used",
  "𨓃": "rarely-used",
  "𨓇": "rarely-used",
  "𨓊": "rarely-used",
  "𨓍": "rarely-used",
  "𨓥": "rarely-used",
  "𨓦": "rarely-used",
  "𨓨": "rarely-used",
  "𨓩": "rarely-used",
  "𨓬": "rarely-used",
  "𨓭": "rarely-used",
  "𨓮": "rarely-used",
  "𨓯": "rarely-used",
  "𨓰": "rarely-used",
  "𨓲": "rarely-used",
  "𨓳": "rarely-used",
  "𨓴": "rarely-used",
  "𨔖": "rarely-used",
  "𨔙": "rarely-used",
  "𨔚": "rarely-used",
  "𨔛": "rarely-used",
  "𨔢": "rarely-used",
  "𨔣": "rarely-used",
  "𨔦": "rarely-used",
  "𨔯": "rarely-used",
  "𨕚": "rarely-used",
  "𨕛": "rarely-used",
  "𨕜": "rarely-used",
  "𨕢": "rarely-used",
  "𨕦": "rarely-used",
  "𨕧": "rarely-used",
  "𨖃": "rarely-used",
  "𨖋": "rarely-used",
  "𨖌": "rarely-used",
  "𨖍": "rarely-used",
  "𨖎": "rarely-used",
  "𨖏": "rarely-used",
  "𨖙": "rarely-used",
  "𨖬": "rarely-used",
  "𨖭": "rarely-used",
  "𨖮": "rarely-used",
  "𨖯": "rarely-used",
  "𨖰": "rarely-used",
  "𨖱": "rarely-used",
  "𨖳": "rarely-used",
  "𨖵": "rarely-used",
  "𨖶": "rarely-used",
  "𨖷": "rarely-used",
  "𨖹": "rarely-used",
  "𨖾": "rarely-used",
  "𨗞": "rarely-used",
  "𨗟": "rarely-used",
  "𨗡": "rarely-used",
  "𨗣": "rarely-used",
  "𨗥": "rarely-used",
  "𨗦": "rarely-used",
  "𨗨": "rarely-used",
  "𨗪": "rarely-used",
  "𨗰": "rarely-used",
  "𨗱": "rarely-used",
  "𨘁": "rarely-used",
  "𨘂": "rarely-used",
  "𨘃": "rarely-used",
  "𨘄": "rarely-used",
  "𨘇": "rarely-used",
  "𨘌": "rarely-used",
  "𨘙": "rarely-used",
  "𨘝": "rarely-used",
  "𨘞": "rarely-used",
  "𨘟": "rarely-used",
  "𨘲": "rarely-used",
  "𨘵": "rarely-used",
  "𨘸": "rarely-used",
  "𨘼": "rarely-used",
  "𨙀": "rarely-used",
  "𨙂": "rarely-used",
  "𨙄": "rarely-used",
  "𨙎": "rarely-used",
  "𨙏": "rarely-used",
  "𨙐": "rarely-used",
  "𨙒": "rarely-used",
  "𨙓": "rarely-used",
  "𨙔": "rarely-used",
  "𨙣": "rarely-used",
  "𨙩": "rarely-used",
  "𨙫": "rarely-used",
  "𨙭": "rarely-used",
  "𨙮": "rarely-used",
  "𨙯": "rarely-used",
  "𨙰": "rarely-used",
  "𨙵": "rarely-used",
  "𨙶": "rarely-used",
  "𨙷": "rarely-used",
  "𨙸": "rarely-used",
  "𨙹": "rarely-used",
  "𨙺": "rarely-used",
  "𨙽": "rarely-used",
  "𨚓": "rarely-used",
  "𨚔": "rarely-used",
  "𨚕": "rarely-used",
  "𨚘": "rarely-used",
  "𨚙": "rarely-used",
  "𨚮": "rarely-used",
  "𨚯": "rarely-used",
  "𨚰": "rarely-used",
  "𨚱": "rarely-used",
  "𨚲": "rarely-used",
  "𨚳": "rarely-used",
  "𨚴": "rarely-used",
  "𨚵": "rarely-used",
  "𨚶": "rarely-used",
  "𨛈": "rarely-used",
  "𨛉": "rarely-used",
  "𨛊": "rarely-used",
  "𨛋": "rarely-used",
  "𨛌": "rarely-used",
  "𨛍": "rarely-used",
  "𨛏": "rarely-used",
  "𨛐": "rarely-used",
  "𨛑": "rarely-used",
  "𨛒": "rarely-used",
  "𨛓": "rarely-used",
  "𨛔": "rarely-used",
  "𨛖": "rarely-used",
  "𨛡": "rarely-used",
  "𨛣": "rarely-used",
  "𨛤": "rarely-used",
  "𨛥": "rarely-used",
  "𨛫": "rarely-used",
  "𨛬": "rarely-used",
  "𨛭": "rarely-used",
  "𨛮": "rarely-used",
  "𨛯": "rarely-used",
  "𨛰": "rarely-used",
  "𨛱": "rarely-used",
  "𨛳": "rarely-used",
  "𨛴": "rarely-used",
  "𨛶": "rarely-used",
  "𨜌": "rarely-used",
  "𨜍": "rarely-used",
  "𨜎": "rarely-used",
  "𨜏": "rarely-used",
  "𨜐": "rarely-used",
  "𨜑": "rarely-used",
  "𨜒": "rarely-used",
  "𨜓": "rarely-used",
  "𨜔": "rarely-used",
  "𨜖": "rarely-used",
  "𨜗": "rarely-used",
  "𨜘": "rarely-used",
  "𨜙": "rarely-used",
  "𨜜": "rarely-used",
  "𨜰": "rarely-used",
  "𨜳": "rarely-used",
  "𨜴": "rarely-used",
  "𨜵": "rarely-used",
  "𨜶": "rarely-used",
  "𨜷": "rarely-used",
  "𨜸": "rarely-used",
  "𨜺": "rarely-used",
  "𨜻": "rarely-used",
  "𨜼": "rarely-used",
  "𨜽": "rarely-used",
  "𨜾": "rarely-used",
  "𨜿": "rarely-used",
  "𨝀": "rarely-used",
  "𨝃": "rarely-used",
  "𨝊": "rarely-used",
  "𨝋": "rarely-used",
  "𨝌": "rarely-used",
  "𨝍": "rarely-used",
  "𨝎": "rarely-used",
  "𨝏": "rarely-used",
  "𨝐": "rarely-used",
  "𨝑": "rarely-used",
  "𨝓": "rarely-used",
  "𨝘": "rarely-used",
  "𨝛": "rarely-used",
  "𨝢": "rarely-used",
  "𨝦": "rarely-used",
  "𨝧": "rarely-used",
  "𨝨": "rarely-used",
  "𨝪": "rarely-used",
  "𨝫": "rarely-used",
  "𨝭": "rarely-used",
  "𨝯": "rarely-used",
  "𨝰": "rarely-used",
  "𨝱": "rarely-used",
  "𨝳": "rarely-used",
  "𨝴": "rarely-used",
  "𨝵": "rarely-used",
  "𨝸": "rarely-used",
  "𨞌": "rarely-used",
  "𨞎": "rarely-used",
  "𨞑": "rarely-used",
  "𨞒": "rarely-used",
  "𨞓": "rarely-used",
  "𨞕": "rarely-used",
  "𨞗": "rarely-used",
  "𨞘": "rarely-used",
  "𨞚": "rarely-used",
  "𨞛": "rarely-used",
  "𨞦": "rarely-used",
  "𨞩": "rarely-used",
  "𨞪": "rarely-used",
  "𨞫": "rarely-used",
  "𨞶": "rarely-used",
  "𨞷": "rarely-used",
  "𨞺": "rarely-used",
  "𨞽": "rarely-used",
  "𨞾": "rarely-used",
  "𨞿": "rarely-used",
  "𨟂": "rarely-used",
  "𨟃": "rarely-used",
  "𨟅": "rarely-used",
  "𨟏": "rarely-used",
  "𨟑": "rarely-used",
  "𨟖": "rarely-used",
  "𨟗": "rarely-used",
  "𨟘": "rarely-used",
  "𨟙": "rarely-used",
  "𨟚": "rarely-used",
  "𨟠": "rarely-used",
  "𨟮": "rarely-used",
  "𨟴": "rarely-used",
  "𨟵": "rarely-used",
  "𨟸": "rarely-used",
  "𨟹": "rarely-used",
  "𨟽": "rarely-used",
  "𨟾": "rarely-used",
  "𨠌": "rarely-used",
  "𨠍": "rarely-used",
  "𨠐": "rarely-used",
  "𨠑": "rarely-used",
  "𨠒": "rarely-used",
  "𨠖": "rarely-used",
  "𨠤": "rarely-used",
  "𨠥": "rarely-used",
  "𨠦": "rarely-used",
  "𨠶": "rarely-used",
  "𨠸": "rarely-used",
  "𨠹": "rarely-used",
  "𨡌": "rarely-used",
  "𨡎": "rarely-used",
  "𨡏": "rarely-used",
  "𨡑": "rarely-used",
  "𨡘": "rarely-used",
  "𨡫": "rarely-used",
  "𨡭": "rarely-used",
  "𨡱": "rarely-used",
  "𨡲": "rarely-used",
  "𨡴": "rarely-used",
  "𨡸": "rarely-used",
  "𨢅": "rarely-used",
  "𨢆": "rarely-used",
  "𨢇": "rarely-used",
  "𨢈": "rarely-used",
  "𨢉": "rarely-used",
  "𨢋": "rarely-used",
  "𨢌": "rarely-used",
  "𨢎": "rarely-used",
  "𨢐": "rarely-used",
  "𨢠": "rarely-used",
  "𨢡": "rarely-used",
  "𨢢": "rarely-used",
  "𨢣": "rarely-used",
  "𨢦": "rarely-used",
  "𨢨": "rarely-used",
  "𨢪": "rarely-used",
  "𨢯": "rarely-used",
  "𨢹": "rarely-used",
  "𨢿": "rarely-used",
  "𨣀": "rarely-used",
  "𨣁": "rarely-used",
  "𨣂": "rarely-used",
  "𨣃": "rarely-used",
  "𨣄": "rarely-used",
  "𨣅": "rarely-used",
  "𨣆": "rarely-used",
  "𨣇": "rarely-used",
  "𨣔": "rarely-used",
  "𨣕": "rarely-used",
  "𨣗": "rarely-used",
  "𨣘": "rarely-used",
  "𨣙": "rarely-used",
  "𨣚": "rarely-used",
  "𨣛": "rarely-used",
  "𨣦": "rarely-used",
  "𨣧": "rarely-used",
  "𨣨": "rarely-used",
  "𨣩": "rarely-used",
  "𨣱": "rarely-used",
  "𨣸": "rarely-used",
  "𨣻": "rarely-used",
  "𨣾": "rarely-used",
  "𨤂": "rarely-used",
  "𨤇": "rarely-used",
  "𨤐": "rarely-used",
  "𨤑": "rarely-used",
  "𨤕": "rarely-used",
  "𨤘": "rarely-used",
  "𨤚": "rarely-used",
  "𨤡": "rarely-used",
  "𨤢": "rarely-used",
  "𨤨": "rarely-used",
  "𨤩": "rarely-used",
  "𨤴": "rarely-used",
  "𨤷": "rarely-used",
  "𨤹": "rarely-used",
  "𨥂": "rarely-used",
  "𨥦": "rarely-used",
  "𨦂": "rarely-used",
  "𨦄": "rarely-used",
  "𨦆": "rarely-used",
  "𨦭": "rarely-used",
  "𨦮": "rarely-used",
  "𨦳": "rarely-used",
  "𨧛": "rarely-used",
  "𨧥": "rarely-used",
  "𨧦": "rarely-used",
  "𨧧": "rarely-used",
  "𨧨": "rarely-used",
  "𨧩": "rarely-used",
  "𨧪": "rarely-used",
  "𨧰": "rarely-used",
  "𨧱": "rarely-used",
  "𨧵": "rarely-used",
  "𨨬": "rarely-used",
  "𨨭": "rarely-used",
  "𨨮": "rarely-used",
  "𨨯": "rarely-used",
  "𨨰": "rarely-used",
  "𨨲": "rarely-used",
  "𨨳": "rarely-used",
  "𨨴": "rarely-used",
  "𨨶": "rarely-used",
  "𨨷": "rarely-used",
  "𨨹": "rarely-used",
  "𨨺": "rarely-used",
  "𨪄": "rarely-used",
  "𨪅": "rarely-used",
  "𨪇": "rarely-used",
  "𨪈": "rarely-used",
  "𨪉": "rarely-used",
  "𨪊": "rarely-used",
  "𨪋": "rarely-used",
  "𨪌": "rarely-used",
  "𨪎": "rarely-used",
  "𨪏": "rarely-used",
  "𨪐": "rarely-used",
  "𨪒": "rarely-used",
  "𨪗": "rarely-used",
  "𨪟": "rarely-used",
  "𨫒": "rarely-used",
  "𨫔": "rarely-used",
  "𨬅": "rarely-used",
  "𨬍": "rarely-used",
  "𨬐": "rarely-used",
  "𨬒": "rarely-used",
  "𨬔": "rarely-used",
  "𨬖": "rarely-used",
  "𨬚": "rarely-used",
  "𨬟": "rarely-used",
  "𨭖": "rarely-used",
  "𨭛": "rarely-used",
  "𨮒": "rarely-used",
  "𨮷": "rarely-used",
  "𨮸": "rarely-used",
  "𨮹": "rarely-used",
  "𨮻": "rarely-used",
  "𨯞": "rarely-used",
  "𨰏": "rarely-used",
  "𨰝": "rarely-used",
  "𨰞": "rarely-used",
  "𨰸": "rarely-used",
  "𨱙": "rarely-used",
  "𨱚": "rarely-used",
  "𨱜": "rarely-used",
  "𨱝": "rarely-used",
  "𨱥": "rarely-used",
  "𨱦": "rarely-used",
  "𨱵": "rarely-used",
  "𨱺": "rarely-used",
  "𨱿": "rarely-used",
  "𨲀": "rarely-used",
  "𨲁": "rarely-used",
  "𨲆": "rarely-used",
  "𨲇": "rarely-used",
  "𨲈": "rarely-used",
  "𨲉": "rarely-used",
  "𨲊": "rarely-used",
  "𨲋": "rarely-used",
  "𨲌": "rarely-used",
  "𨲓": "rarely-used",
  "𨲕": "rarely-used",
  "𨲞": "rarely-used",
  "𨲟": "rarely-used",
  "𨲧": "rarely-used",
  "𨲩": "rarely-used",
  "𨲭": "rarely-used",
  "𨲮": "rarely-used",
  "𨲯": "rarely-used",
  "𨲲": "rarely-used",
  "𨲳": "rarely-used",
  "𨲸": "rarely-used",
  "𨳀": "rarely-used",
  "𨳁": "rarely-used",
  "𨳂": "rarely-used",
  "𨳉": "rarely-used",
  "𨳊": "rarely-used",
  "𨳋": "rarely-used",
  "𨳌": "rarely-used",
  "𨳐": "rarely-used",
  "𨳑": "rarely-used",
  "𨳗": "rarely-used",
  "𨳘": "rarely-used",
  "𨳙": "rarely-used",
  "𨳚": "rarely-used",
  "𨳛": "rarely-used",
  "𨳝": "rarely-used",
  "𨳞": "rarely-used",
  "𨳟": "rarely-used",
  "𨳠": "rarely-used",
  "𨳣": "rarely-used",
  "𨳲": "rarely-used",
  "𨳳": "rarely-used",
  "𨳶": "rarely-used",
  "𨳷": "rarely-used",
  "𨳺": "rarely-used",
  "𨳻": "rarely-used",
  "𨳼": "rarely-used",
  "𨳽": "rarely-used",
  "𨳿": "rarely-used",
  "𨴀": "rarely-used",
  "𨴍": "rarely-used",
  "𨴎": "rarely-used",
  "𨴏": "rarely-used",
  "𨴐": "rarely-used",
  "𨴑": "rarely-used",
  "𨴒": "rarely-used",
  "𨴓": "rarely-used",
  "𨴕": "rarely-used",
  "𨴖": "rarely-used",
  "𨴗": "rarely-used",
  "𨴘": "rarely-used",
  "𨴙": "rarely-used",
  "𨴥": "rarely-used",
  "𨴩": "rarely-used",
  "𨴪": "rarely-used",
  "𨴬": "rarely-used",
  "𨴭": "rarely-used",
  "𨴯": "rarely-used",
  "𨴰": "rarely-used",
  "𨴱": "rarely-used",
  "𨵄": "rarely-used",
  "𨵅": "rarely-used",
  "𨵆": "rarely-used",
  "𨵈": "rarely-used",
  "𨵉": "rarely-used",
  "𨵊": "rarely-used",
  "𨵋": "rarely-used",
  "𨵍": "rarely-used",
  "𨵏": "rarely-used",
  "𨵐": "rarely-used",
  "𨵤": "rarely-used",
  "𨵦": "rarely-used",
  "𨵧": "rarely-used",
  "𨵩": "rarely-used",
  "𨵪": "rarely-used",
  "𨵫": "rarely-used",
  "𨵬": "rarely-used",
  "𨵮": "rarely-used",
  "𨵰": "rarely-used",
  "𨶀": "rarely-used",
  "𨶁": "rarely-used",
  "𨶂": "rarely-used",
  "𨶃": "rarely-used",
  "𨶅": "rarely-used",
  "𨶆": "rarely-used",
  "𨶇": "rarely-used",
  "𨶉": "rarely-used",
  "𨶊": "rarely-used",
  "𨶋": "rarely-used",
  "𨶜": "rarely-used",
  "𨶟": "rarely-used",
  "𨶠": "rarely-used",
  "𨶢": "rarely-used",
  "𨶬": "rarely-used",
  "𨶭": "rarely-used",
  "𨶮": "rarely-used",
  "𨶯": "rarely-used",
  "𨶰": "rarely-used",
  "𨶱": "rarely-used",
  "𨶲": "rarely-used",
  "𨶶": "rarely-used",
  "𨷁": "rarely-used",
  "𨷃": "rarely-used",
  "𨷄": "rarely-used",
  "𨷅": "rarely-used",
  "𨷆": "rarely-used",
  "𨷇": "rarely-used",
  "𨷒": "rarely-used",
  "𨷓": "rarely-used",
  "𨷔": "rarely-used",
  "𨷦": "rarely-used",
  "𨷰": "rarely-used",
  "𨷱": "rarely-used",
  "𨷲": "rarely-used",
  "𨷻": "rarely-used",
  "𨸐": "rarely-used",
  "𨸑": "rarely-used",
  "𨸒": "rarely-used",
  "𨸓": "rarely-used",
  "𨸔": "rarely-used",
  "𨸖": "rarely-used",
  "𨸚": "rarely-used",
  "𨸛": "rarely-used",
  "𨸜": "rarely-used",
  "𨸝": "rarely-used",
  "𨸞": "rarely-used",
  "𨸫": "rarely-used",
  "𨸭": "rarely-used",
  "𨸮": "rarely-used",
  "𨸯": "rarely-used",
  "𨸰": "rarely-used",
  "𨸱": "rarely-used",
  "𨹁": "rarely-used",
  "𨹅": "rarely-used",
  "𨹌": "rarely-used",
  "𨹙": "rarely-used",
  "𨹚": "rarely-used",
  "𨹜": "rarely-used",
  "𨹝": "rarely-used",
  "𨹡": "rarely-used",
  "𨹵": "rarely-used",
  "𨹸": "rarely-used",
  "𨹺": "rarely-used",
  "𨹻": "rarely-used",
  "𨺟": "rarely-used",
  "𨺠": "rarely-used",
  "𨺡": "rarely-used",
  "𨺢": "rarely-used",
  "𨺣": "rarely-used",
  "𨺦": "rarely-used",
  "𨺧": "rarely-used",
  "𨺨": "rarely-used",
  "𨺭": "rarely-used",
  "𨺿": "rarely-used",
  "𨻁": "rarely-used",
  "𨻂": "rarely-used",
  "𨻆": "rarely-used",
  "𨻇": "rarely-used",
  "𨻈": "rarely-used",
  "𨻌": "rarely-used",
  "𨻍": "rarely-used",
  "𨻒": "rarely-used",
  "𨻖": "rarely-used",
  "𨻴": "rarely-used",
  "𨻷": "rarely-used",
  "𨻺": "rarely-used",
  "𨻻": "rarely-used",
  "𨻼": "rarely-used",
  "𨼈": "rarely-used",
  "𨼊": "rarely-used",
  "𨼋": "rarely-used",
  "𨼌": "rarely-used",
  "𨼎": "rarely-used",
  "𨼏": "rarely-used",
  "𨼐": "rarely-used",
  "𨼒": "rarely-used",
  "𨼓": "rarely-used",
  "𨼔": "rarely-used",
  "𨼪": "rarely-used",
  "𨼫": "rarely-used",
  "𨼬": "rarely-used",
  "𨼮": "rarely-used",
  "𨼯": "rarely-used",
  "𨼽": "rarely-used",
  "𨼿": "rarely-used",
  "𨽀": "rarely-used",
  "𨽄": "rarely-used",
  "𨽍": "rarely-used",
  "𨽖": "rarely-used",
  "𨽝": "rarely-used",
  "𨽦": "rarely-used",
  "𨽲": "rarely-used",
  "𨽳": "rarely-used",
  "𨽸": "rarely-used",
  "𨽼": "rarely-used",
  "𨾂": "rarely-used",
  "𨾉": "rarely-used",
  "𨾊": "rarely-used",
  "𨾔": "rarely-used",
  "𨾛": "rarely-used",
  "𨾡": "rarely-used",
  "𨾴": "rarely-used",
  "𨾻": "rarely-used",
  "𨾾": "rarely-used",
  "𨿁": "rarely-used",
  "𨿂": "rarely-used",
  "𨿐": "rarely-used",
  "𨿙": "rarely-used",
  "𨿠": "rarely-used",
  "𨿢": "rarely-used",
  "𨿭": "rarely-used",
  "𨿿": "rarely-used",
  "𩀋": "rarely-used",
  "𩀜": "rarely-used",
  "𩀟": "rarely-used",
  "𩀨": "rarely-used",
  "𩀪": "rarely-used",
  "𩀫": "rarely-used",
  "𩀼": "rarely-used",
  "𩀿": "rarely-used",
  "𩁷": "rarely-used",
  "𩁻": "rarely-used",
  "𩂂": "rarely-used",
  "𩂃": "rarely-used",
  "𩂄": "rarely-used",
  "𩂅": "rarely-used",
  "𩂆": "rarely-used",
  "𩂈": "rarely-used",
  "𩂒": "rarely-used",
  "𩂓": "rarely-used",
  "𩂔": "rarely-used",
  "𩂕": "rarely-used",
  "𩂖": "rarely-used",
  "𩂗": "rarely-used",
  "𩂡": "rarely-used",
  "𩂢": "rarely-used",
  "𩂣": "rarely-used",
  "𩂤": "rarely-used",
  "𩂥": "rarely-used",
  "𩂦": "rarely-used",
  "𩂧": "rarely-used",
  "𩂨": "rarely-used",
  "𩂪": "rarely-used",
  "𩂹": "rarely-used",
  "𩂺": "rarely-used",
  "𩂻": "rarely-used",
  "𩂼": "rarely-used",
  "𩂽": "rarely-used",
  "𩂾": "rarely-used",
  "𩂿": "rarely-used",
  "𩃀": "rarely-used",
  "𩃁": "rarely-used",
  "𩃐": "rarely-used",
  "𩃑": "rarely-used",
  "𩃒": "rarely-used",
  "𩃕": "rarely-used",
  "𩃖": "rarely-used",
  "𩃗": "rarely-used",
  "𩃙": "rarely-used",
  "𩃚": "rarely-used",
  "𩃜": "rarely-used",
  "𩃠": "rarely-used",
  "𩃴": "rarely-used",
  "𩃵": "rarely-used",
  "𩃶": "rarely-used",
  "𩃷": "rarely-used",
  "𩃸": "rarely-used",
  "𩃹": "rarely-used",
  "𩃺": "rarely-used",
  "𩃼": "rarely-used",
  "𩃾": "rarely-used",
  "𩄁": "rarely-used",
  "𩄖": "rarely-used",
  "𩄗": "rarely-used",
  "𩄘": "rarely-used",
  "𩄛": "rarely-used",
  "𩄝": "rarely-used",
  "𩄡": "rarely-used",
  "𩄢": "rarely-used",
  "𩄦": "rarely-used",
  "𩄷": "rarely-used",
  "𩄸": "rarely-used",
  "𩄺": "rarely-used",
  "𩄻": "rarely-used",
  "𩄼": "rarely-used",
  "𩄽": "rarely-used",
  "𩄾": "rarely-used",
  "𩄿": "rarely-used",
  "𩅀": "rarely-used",
  "𩅁": "rarely-used",
  "𩅂": "rarely-used",
  "𩅃": "rarely-used",
  "𩅄": "rarely-used",
  "𩅅": "rarely-used",
  "𩅉": "rarely-used",
  "𩅞": "rarely-used",
  "𩅠": "rarely-used",
  "𩅡": "rarely-used",
  "𩅦": "rarely-used",
  "𩅨": "rarely-used",
  "𩅼": "rarely-used",
  "𩅽": "rarely-used",
  "𩅿": "rarely-used",
  "𩆀": "rarely-used",
  "𩆁": "rarely-used",
  "𩆄": "rarely-used",
  "𩆅": "rarely-used",
  "𩆑": "rarely-used",
  "𩆒": "rarely-used",
  "𩆓": "rarely-used",
  "𩆕": "rarely-used",
  "𩆘": "rarely-used",
  "𩆚": "rarely-used",
  "𩆛": "rarely-used",
  "𩆤": "rarely-used",
  "𩆫": "rarely-used",
  "𩆭": "rarely-used",
  "𩆮": "rarely-used",
  "𩆯": "rarely-used",
  "𩆵": "rarely-used",
  "𩆶": "rarely-used",
  "𩆷": "rarely-used",
  "𩆸": "rarely-used",
  "𩆽": "rarely-used",
  "𩆿": "rarely-used",
  "𩇁": "rarely-used",
  "𩇇": "rarely-used",
  "𩇎": "rarely-used",
  "𩇔": "rarely-used",
  "𩇕": "rarely-used",
  "𩇜": "rarely-used",
  "𩇟": "rarely-used",
  "𩇣": "rarely-used",
  "𩇩": "rarely-used",
  "𩇫": "rarely-used",
  "𩇮": "rarely-used",
  "𩈆": "rarely-used",
  "𩈈": "rarely-used",
  "𩈉": "rarely-used",
  "𩈎": "rarely-used",
  "𩈏": "rarely-used",
  "𩈙": "rarely-used",
  "𩈚": "rarely-used",
  "𩈛": "rarely-used",
  "𩈜": "rarely-used",
  "𩈡": "rarely-used",
  "𩈢": "rarely-used",
  "𩈣": "rarely-used",
  "𩈤": "rarely-used",
  "𩈥": "rarely-used",
  "𩈦": "rarely-used",
  "𩈬": "rarely-used",
  "𩈭": "rarely-used",
  "𩈮": "rarely-used",
  "𩈯": "rarely-used",
  "𩈲": "rarely-used",
  "𩈴": "rarely-used",
  "𩈵": "rarely-used",
  "𩈶": "rarely-used",
  "𩈸": "rarely-used",
  "𩈹": "rarely-used",
  "𩈻": "rarely-used",
  "𩈼": "rarely-used",
  "𩉀": "rarely-used",
  "𩉁": "rarely-used",
  "𩉃": "rarely-used",
  "𩉄": "rarely-used",
  "𩉍": "rarely-used",
  "𩉔": "rarely-used",
  "𩉝": "rarely-used",
  "𩉡": "rarely-used",
  "𩉢": "rarely-used",
  "𩉥": "rarely-used",
  "𩉧": "rarely-used",
  "𩉫": "rarely-used",
  "𩉬": "rarely-used",
  "𩉸": "rarely-used",
  "𩉹": "rarely-used",
  "𩉺": "rarely-used",
  "𩉽": "rarely-used",
  "𩉾": "rarely-used",
  "𩉿": "rarely-used",
  "𩊀": "rarely-used",
  "𩊁": "rarely-used",
  "𩊂": "rarely-used",
  "𩊃": "rarely-used",
  "𩊅": "rarely-used",
  "𩊑": "rarely-used",
  "𩊖": "rarely-used",
  "𩊚": "rarely-used",
  "𩊛": "rarely-used",
  "𩊜": "rarely-used",
  "𩊝": "rarely-used",
  "𩊟": "rarely-used",
  "𩊪": "rarely-used",
  "𩊫": "rarely-used",
  "𩊭": "rarely-used",
  "𩊯": "rarely-used",
  "𩊰": "rarely-used",
  "𩋁": "rarely-used",
  "𩋂": "rarely-used",
  "𩋃": "rarely-used",
  "𩋄": "rarely-used",
  "𩋆": "rarely-used",
  "𩋈": "rarely-used",
  "𩋊": "rarely-used",
  "𩋌": "rarely-used",
  "𩋍": "rarely-used",
  "𩋏": "rarely-used",
  "𩋒": "rarely-used",
  "𩋝": "rarely-used",
  "𩋞": "rarely-used",
  "𩋠": "rarely-used",
  "𩋡": "rarely-used",
  "𩋢": "rarely-used",
  "𩋣": "rarely-used",
  "𩋤": "rarely-used",
  "𩋧": "rarely-used",
  "𩋨": "rarely-used",
  "𩋩": "rarely-used",
  "𩋬": "rarely-used",
  "𩋮": "rarely-used",
  "𩋯": "rarely-used",
  "𩋵": "rarely-used",
  "𩋹": "rarely-used",
  "𩋺": "rarely-used",
  "𩋽": "rarely-used",
  "𩋾": "rarely-used",
  "𩋿": "rarely-used",
  "𩌀": "rarely-used",
  "𩌃": "rarely-used",
  "𩌄": "rarely-used",
  "𩌅": "rarely-used",
  "𩌆": "rarely-used",
  "𩌇": "rarely-used",
  "𩌈": "rarely-used",
  "𩌊": "rarely-used",
  "𩌌": "rarely-used",
  "𩌍": "rarely-used",
  "𩌏": "rarely-used",
  "𩌑": "rarely-used",
  "𩌓": "rarely-used",
  "𩌝": "rarely-used",
  "𩌠": "rarely-used",
  "𩌢": "rarely-used",
  "𩌦": "rarely-used",
  "𩌧": "rarely-used",
  "𩌨": "rarely-used",
  "𩌩": "rarely-used",
  "𩌪": "rarely-used",
  "𩌬": "rarely-used",
  "𩌮": "rarely-used",
  "𩌯": "rarely-used",
  "𩌰": "rarely-used",
  "𩌲": "rarely-used",
  "𩌾": "rarely-used",
  "𩍀": "rarely-used",
  "𩍃": "rarely-used",
  "𩍅": "rarely-used",
  "𩍉": "rarely-used",
  "𩍊": "rarely-used",
  "𩍋": "rarely-used",
  "𩍎": "rarely-used",
  "𩍏": "rarely-used",
  "𩍓": "rarely-used",
  "𩍖": "rarely-used",
  "𩍗": "rarely-used",
  "𩍜": "rarely-used",
  "𩍝": "rarely-used",
  "𩍤": "rarely-used",
  "𩍥": "rarely-used",
  "𩍦": "rarely-used",
  "𩍧": "rarely-used",
  "𩍩": "rarely-used",
  "𩍪": "rarely-used",
  "𩍲": "rarely-used",
  "𩍳": "rarely-used",
  "𩍵": "rarely-used",
  "𩍷": "rarely-used",
  "𩍿": "rarely-used",
  "𩎂": "rarely-used",
  "𩎇": "rarely-used",
  "𩎊": "rarely-used",
  "𩎌": "rarely-used",
  "𩎑": "rarely-used",
  "𩎒": "rarely-used",
  "𩎓": "rarely-used",
  "𩎗": "rarely-used",
  "𩎙": "rarely-used",
  "𩎚": "rarely-used",
  "𩎛": "rarely-used",
  "𩎜": "rarely-used",
  "𩎡": "rarely-used",
  "𩎤": "rarely-used",
  "𩎥": "rarely-used",
  "𩎦": "rarely-used",
  "𩎧": "rarely-used",
  "𩎭": "rarely-used",
  "𩎮": "rarely-used",
  "𩎯": "rarely-used",
  "𩎲": "rarely-used",
  "𩎳": "rarely-used",
  "𩎵": "rarely-used",
  "𩎷": "rarely-used",
  "𩎸": "rarely-used",
  "𩎺": "rarely-used",
  "𩎽": "rarely-used",
  "𩎾": "rarely-used",
  "𩏇": "rarely-used",
  "𩏊": "rarely-used",
  "𩏖": "rarely-used",
  "𩏗": "rarely-used",
  "𩏞": "rarely-used",
  "𩏟": "rarely-used",
  "𩏠": "rarely-used",
  "𩏡": "rarely-used",
  "𩏢": "rarely-used",
  "𩏣": "rarely-used",
  "𩏥": "rarely-used",
  "𩏦": "rarely-used",
  "𩏩": "rarely-used",
  "𩏪": "rarely-used",
  "𩏭": "rarely-used",
  "𩏲": "rarely-used",
  "𩏵": "rarely-used",
  "𩏹": "rarely-used",
  "𩏺": "rarely-used",
  "𩏻": "rarely-used",
  "𩐁": "rarely-used",
  "𩐅": "rarely-used",
  "𩐌": "rarely-used",
  "𩐘": "rarely-used",
  "𩐙": "rarely-used",
  "𩐚": "rarely-used",
  "𩐛": "rarely-used",
  "𩐜": "rarely-used",
  "𩐞": "rarely-used",
  "𩐠": "rarely-used",
  "𩐡": "rarely-used",
  "𩐣": "rarely-used",
  "𩐤": "rarely-used",
  "𩐥": "rarely-used",
  "𩐦": "rarely-used",
  "𩐧": "rarely-used",
  "𩐨": "rarely-used",
  "𩐫": "rarely-used",
  "𩐮": "rarely-used",
  "𩐰": "rarely-used",
  "𩐱": "rarely-used",
  "𩐲": "rarely-used",
  "𩐴": "rarely-used",
  "𩐵": "rarely-used",
  "𩐶": "rarely-used",
  "𩐷": "rarely-used",
  "𩐻": "rarely-used",
  "𩐼": "rarely-used",
  "𩐾": "rarely-used",
  "𩑀": "rarely-used",
  "𩑁": "rarely-used",
  "𩑂": "rarely-used",
  "𩑃": "rarely-used",
  "𩑈": "rarely-used",
  "𩑉": "rarely-used",
  "𩑊": "rarely-used",
  "𩑍": "rarely-used",
  "𩑐": "rarely-used",
  "𩑑": "rarely-used",
  "𩑒": "rarely-used",
  "𩑓": "rarely-used",
  "𩑔": "rarely-used",
  "𩑕": "rarely-used",
  "𩑖": "rarely-used",
  "𩑘": "rarely-used",
  "𩑚": "rarely-used",
  "𩑜": "rarely-used",
  "𩑝": "rarely-used",
  "𩑟": "rarely-used",
  "𩑠": "rarely-used",
  "𩑡": "rarely-used",
  "𩑢": "rarely-used",
  "𩑣": "rarely-used",
  "𩑤": "rarely-used",
  "𩑦": "rarely-used",
  "𩑧": "rarely-used",
  "𩑬": "rarely-used",
  "𩑮": "rarely-used",
  "𩑰": "rarely-used",
  "𩑳": "rarely-used",
  "𩑴": "rarely-used",
  "𩑵": "rarely-used",
  "𩑶": "rarely-used",
  "𩑷": "rarely-used",
  "𩑸": "rarely-used",
  "𩑹": "rarely-used",
  "𩑻": "rarely-used",
  "𩑼": "rarely-used",
  "𩑾": "rarely-used",
  "𩒃": "rarely-used",
  "𩒄": "rarely-used",
  "𩒇": "rarely-used",
  "𩒊": "rarely-used",
  "𩒏": "rarely-used",
  "𩒐": "rarely-used",
  "𩒓": "rarely-used",
  "𩒔": "rarely-used",
  "𩒕": "rarely-used",
  "𩒖": "rarely-used",
  "𩒘": "rarely-used",
  "𩒚": "rarely-used",
  "𩒭": "rarely-used",
  "𩒮": "rarely-used",
  "𩒯": "rarely-used",
  "𩒰": "rarely-used",
  "𩒱": "rarely-used",
  "𩒳": "rarely-used",
  "𩒴": "rarely-used",
  "𩒷": "rarely-used",
  "𩒸": "rarely-used",
  "𩒻": "rarely-used",
  "𩒼": "rarely-used",
  "𩒽": "rarely-used",
  "𩒾": "rarely-used",
  "𩒿": "rarely-used",
  "𩓂": "rarely-used",
  "𩓖": "rarely-used",
  "𩓘": "rarely-used",
  "𩓝": "rarely-used",
  "𩓞": "rarely-used",
  "𩓟": "rarely-used",
  "𩓠": "rarely-used",
  "𩓢": "rarely-used",
  "𩓤": "rarely-used",
  "𩓥": "rarely-used",
  "𩓦": "rarely-used",
  "𩓧": "rarely-used",
  "𩓨": "rarely-used",
  "𩓩": "rarely-used",
  "𩓪": "rarely-used",
  "𩓬": "rarely-used",
  "𩓮": "rarely-used",
  "𩓻": "rarely-used",
  "𩓼": "rarely-used",
  "𩔀": "rarely-used",
  "𩔁": "rarely-used",
  "𩔂": "rarely-used",
  "𩔃": "rarely-used",
  "𩔄": "rarely-used",
  "𩔅": "rarely-used",
  "𩔆": "rarely-used",
  "𩔈": "rarely-used",
  "𩔉": "rarely-used",
  "𩔊": "rarely-used",
  "𩔋": "rarely-used",
  "𩔚": "rarely-used",
  "𩔝": "rarely-used",
  "𩔠": "rarely-used",
  "𩔡": "rarely-used",
  "𩔢": "rarely-used",
  "𩔣": "rarely-used",
  "𩔦": "rarely-used",
  "𩔳": "rarely-used",
  "𩔴": "rarely-used",
  "𩔵": "rarely-used",
  "𩔶": "rarely-used",
  "𩔸": "rarely-used",
  "𩔹": "rarely-used",
  "𩔼": "rarely-used",
  "𩕆": "rarely-used",
  "𩕉": "rarely-used",
  "𩕊": "rarely-used",
  "𩕌": "rarely-used",
  "𩕏": "rarely-used",
  "𩕐": "rarely-used",
  "𩕔": "rarely-used",
  "𩕕": "rarely-used",
  "𩕖": "rarely-used",
  "𩕠": "rarely-used",
  "𩕡": "rarely-used",
  "𩕤": "rarely-used",
  "𩕯": "rarely-used",
  "𩕱": "rarely-used",
  "𩕲": "rarely-used",
  "𩕳": "rarely-used",
  "𩕵": "rarely-used",
  "𩕾": "rarely-used",
  "𩖀": "rarely-used",
  "𩖁": "rarely-used",
  "𩖆": "rarely-used",
  "𩖇": "rarely-used",
  "𩖊": "rarely-used",
  "𩖌": "rarely-used",
  "𩖏": "rarely-used",
  "𩖛": "rarely-used",
  "𩖝": "rarely-used",
  "𩖢": "rarely-used",
  "𩖣": "rarely-used",
  "𩖤": "rarely-used",
  "𩖥": "rarely-used",
  "𩖦": "rarely-used",
  "𩖩": "rarely-used",
  "𩖬": "rarely-used",
  "𩖲": "rarely-used",
  "𩖴": "rarely-used",
  "𩖵": "rarely-used",
  "𩖶": "rarely-used",
  "𩖷": "rarely-used",
  "𩖸": "rarely-used",
  "𩖹": "rarely-used",
  "𩖺": "rarely-used",
  "𩖼": "rarely-used",
  "𩗄": "rarely-used",
  "𩗅": "rarely-used",
  "𩗆": "rarely-used",
  "𩗊": "rarely-used",
  "𩗓": "rarely-used",
  "𩗔": "rarely-used",
  "𩗕": "rarely-used",
  "𩗘": "rarely-used",
  "𩗙": "rarely-used",
  "𩗚": "rarely-used",
  "𩗞": "rarely-used",
  "𩗟": "rarely-used",
  "𩗢": "rarely-used",
  "𩗣": "rarely-used",
  "𩗪": "rarely-used",
  "𩗫": "rarely-used",
  "𩗬": "rarely-used",
  "𩗭": "rarely-used",
  "𩗰": "rarely-used",
  "𩗱": "rarely-used",
  "𩗳": "rarely-used",
  "𩗴": "rarely-used",
  "𩗵": "rarely-used",
  "𩗶": "rarely-used",
  "𩗷": "rarely-used",
  "𩘅": "rarely-used",
  "𩘈": "rarely-used",
  "𩘊": "rarely-used",
  "𩘋": "rarely-used",
  "𩘍": "rarely-used",
  "𩘎": "rarely-used",
  "𩘏": "rarely-used",
  "𩘑": "rarely-used",
  "𩘒": "rarely-used",
  "𩘓": "rarely-used",
  "𩘜": "rarely-used",
  "𩘝": "rarely-used",
  "𩘞": "rarely-used",
  "𩘠": "rarely-used",
  "𩘭": "rarely-used",
  "𩘮": "rarely-used",
  "𩘯": "rarely-used",
  "𩘱": "rarely-used",
  "𩘳": "rarely-used",
  "𩘵": "rarely-used",
  "𩘶": "rarely-used",
  "𩘹": "rarely-used",
  "𩘺": "rarely-used",
  "𩘻": "rarely-used",
  "𩘽": "rarely-used",
  "𩙑": "rarely-used",
  "𩙒": "rarely-used",
  "𩙖": "rarely-used",
  "𩙙": "rarely-used",
  "𩙚": "rarely-used",
  "𩙛": "rarely-used",
  "𩙜": "rarely-used",
  "𩙝": "rarely-used",
  "𩙡": "rarely-used",
  "𩙲": "rarely-used",
  "𩙷": "rarely-used",
  "𩙽": "rarely-used",
  "𩚄": "rarely-used",
  "𩚇": "rarely-used",
  "𩚈": "rarely-used",
  "𩚉": "rarely-used",
  "𩚌": "rarely-used",
  "𩚒": "rarely-used",
  "𩚖": "rarely-used",
  "𩚗": "rarely-used",
  "𩚛": "rarely-used",
  "𩚝": "rarely-used",
  "𩚤": "rarely-used",
  "𩚪": "rarely-used",
  "𩚫": "rarely-used",
  "𩚬": "rarely-used",
  "𩚭": "rarely-used",
  "𩚮": "rarely-used",
  "𩚯": "rarely-used",
  "𩚱": "rarely-used",
  "𩚵": "rarely-used",
  "𩚹": "rarely-used",
  "𩚻": "rarely-used",
  "𩛅": "rarely-used",
  "𩛆": "rarely-used",
  "𩛋": "rarely-used",
  "𩛌": "rarely-used",
  "𩛎": "rarely-used",
  "𩛏": "rarely-used",
  "𩛑": "rarely-used",
  "𩛝": "rarely-used",
  "𩛟": "rarely-used",
  "𩛠": "rarely-used",
  "𩛡": "rarely-used",
  "𩛢": "rarely-used",
  "𩛣": "rarely-used",
  "𩛤": "rarely-used",
  "𩛥": "rarely-used",
  "𩛦": "rarely-used",
  "𩛨": "rarely-used",
  "𩛪": "rarely-used",
  "𩛭": "rarely-used",
  "𩛳": "rarely-used",
  "𩛺": "rarely-used",
  "𩛻": "rarely-used",
  "𩛼": "rarely-used",
  "𩛽": "rarely-used",
  "𩜀": "rarely-used",
  "𩜁": "rarely-used",
  "𩜃": "rarely-used",
  "𩜅": "rarely-used",
  "𩜇": "rarely-used",
  "𩜊": "rarely-used",
  "𩜍": "rarely-used",
  "𩜒": "rarely-used",
  "𩜖": "rarely-used",
  "𩜚": "rarely-used",
  "𩜟": "rarely-used",
  "𩜬": "rarely-used",
  "𩜭": "rarely-used",
  "𩜰": "rarely-used",
  "𩜱": "rarely-used",
  "𩜲": "rarely-used",
  "𩜳": "rarely-used",
  "𩜵": "rarely-used",
  "𩜶": "rarely-used",
  "𩜸": "rarely-used",
  "𩜽": "rarely-used",
  "𩝀": "rarely-used",
  "𩝗": "rarely-used",
  "𩝚": "rarely-used",
  "𩝛": "rarely-used",
  "𩝝": "rarely-used",
  "𩝞": "rarely-used",
  "𩝟": "rarely-used",
  "𩝡": "rarely-used",
  "𩝢": "rarely-used",
  "𩝣": "rarely-used",
  "𩝨": "rarely-used",
  "𩝸": "rarely-used",
  "𩝽": "rarely-used",
  "𩝿": "rarely-used",
  "𩞃": "rarely-used",
  "𩞄": "rarely-used",
  "𩞅": "rarely-used",
  "𩞆": "rarely-used",
  "𩞈": "rarely-used",
  "𩞉": "rarely-used",
  "𩞊": "rarely-used",
  "𩞋": "rarely-used",
  "𩞙": "rarely-used",
  "𩞞": "rarely-used",
  "𩞤": "rarely-used",
  "𩞦": "rarely-used",
  "𩞨": "rarely-used",
  "𩞩": "rarely-used",
  "𩞬": "rarely-used",
  "𩞾": "rarely-used",
  "𩞿": "rarely-used",
  "𩟂": "rarely-used",
  "𩟃": "rarely-used",
  "𩟅": "rarely-used",
  "𩟇": "rarely-used",
  "𩟈": "rarely-used",
  "𩟉": "rarely-used",
  "𩟊": "rarely-used",
  "𩟌": "rarely-used",
  "𩟍": "rarely-used",
  "𩟓": "rarely-used",
  "𩟔": "rarely-used",
  "𩟕": "rarely-used",
  "𩟙": "rarely-used",
  "𩟤": "rarely-used",
  "𩟦": "rarely-used",
  "𩟧": "rarely-used",
  "𩟨": "rarely-used",
  "𩟭": "rarely-used",
  "𩟮": "rarely-used",
  "𩟶": "rarely-used",
  "𩟸": "rarely-used",
  "𩠚": "rarely-used",
  "𩠻": "rarely-used",
  "𩠾": "rarely-used",
  "𩡍": "rarely-used",
  "𩡎": "rarely-used",
  "𩡐": "rarely-used",
  "𩡓": "rarely-used",
  "𩡔": "rarely-used",
  "𩡕": "rarely-used",
  "𩡝": "rarely-used",
  "𩡥": "rarely-used",
  "𩡧": "rarely-used",
  "𩡨": "rarely-used",
  "𩡩": "rarely-used",
  "𩡰": "rarely-used",
  "𩡷": "rarely-used",
  "𩡺": "rarely-used",
  "𩡾": "rarely-used",
  "𩢌": "rarely-used",
  "𩢎": "rarely-used",
  "𩢑": "rarely-used",
  "𩢒": "rarely-used",
  "𩢓": "rarely-used",
  "𩢔": "rarely-used",
  "𩢕": "rarely-used",
  "𩢖": "rarely-used",
  "𩢗": "rarely-used",
  "𩢙": "rarely-used",
  "𩢛": "rarely-used",
  "𩢞": "rarely-used",
  "𩢡": "rarely-used",
  "𩢮": "rarely-used",
  "𩢰": "rarely-used",
  "𩢱": "rarely-used",
  "𩢲": "rarely-used",
  "𩢳": "rarely-used",
  "𩢴": "rarely-used",
  "𩢶": "rarely-used",
  "𩢷": "rarely-used",
  "𩢸": "rarely-used",
  "𩢹": "rarely-used",
  "𩢻": "rarely-used",
  "𩢼": "rarely-used",
  "𩢽": "rarely-used",
  "𩢾": "rarely-used",
  "𩢿": "rarely-used",
  "𩣇": "rarely-used",
  "𩣊": "rarely-used",
  "𩣖": "rarely-used",
  "𩣘": "rarely-used",
  "𩣝": "rarely-used",
  "𩣞": "rarely-used",
  "𩣡": "rarely-used",
  "𩣣": "rarely-used",
  "𩣤": "rarely-used",
  "𩣮": "rarely-used",
  "𩣯": "rarely-used",
  "𩣰": "rarely-used",
  "𩣱": "rarely-used",
  "𩣲": "rarely-used",
  "𩣳": "rarely-used",
  "𩣴": "rarely-used",
  "𩣵": "rarely-used",
  "𩣶": "rarely-used",
  "𩣸": "rarely-used",
  "𩣹": "rarely-used",
  "𩣺": "rarely-used",
  "𩣻": "rarely-used",
  "𩣼": "rarely-used",
  "𩤁": "rarely-used",
  "𩤒": "rarely-used",
  "𩤖": "rarely-used",
  "𩤗": "rarely-used",
  "𩤘": "rarely-used",
  "𩤙": "rarely-used",
  "𩤚": "rarely-used",
  "𩤜": "rarely-used",
  "𩤞": "rarely-used",
  "𩤟": "rarely-used",
  "𩤠": "rarely-used",
  "𩤡": "rarely-used",
  "𩤣": "rarely-used",
  "𩤤": "rarely-used",
  "𩤥": "rarely-used",
  "𩤦": "rarely-used",
  "𩤩": "rarely-used",
  "𩤽": "rarely-used",
  "𩥀": "rarely-used",
  "𩥁": "rarely-used",
  "𩥂": "rarely-used",
  "𩥃": "rarely-used",
  "𩥄": "rarely-used",
  "𩥅": "rarely-used",
  "𩥇": "rarely-used",
  "𩥈": "rarely-used",
  "𩥊": "rarely-used",
  "𩥋": "rarely-used",
  "𩥌": "rarely-used",
  "𩥎": "rarely-used",
  "𩥏": "rarely-used",
  "𩥐": "rarely-used",
  "𩥑": "rarely-used",
  "𩥫": "rarely-used",
  "𩥬": "rarely-used",
  "𩥭": "rarely-used",
  "𩥮": "rarely-used",
  "𩥯": "rarely-used",
  "𩥰": "rarely-used",
  "𩦂": "rarely-used",
  "𩦄": "rarely-used",
  "𩦇": "rarely-used",
  "𩦉": "rarely-used",
  "𩦊": "rarely-used",
  "𩦋": "rarely-used",
  "𩦌": "rarely-used",
  "𩦏": "rarely-used",
  "𩦙": "rarely-used",
  "𩦛": "rarely-used",
  "𩦠": "rarely-used",
  "𩦡": "rarely-used",
  "𩦤": "rarely-used",
  "𩦶": "rarely-used",
  "𩦹": "rarely-used",
  "𩧂": "rarely-used",
  "𩧄": "rarely-used",
  "𩧅": "rarely-used",
  "𩧆": "rarely-used",
  "𩧇": "rarely-used",
  "𩧉": "rarely-used",
  "𩧊": "rarely-used",
  "𩧏": "rarely-used",
  "𩧐": "rarely-used",
  "𩧔": "rarely-used",
  "𩧘": "rarely-used",
  "𩧡": "rarely-used",
  "𩨑": "rarely-used",
  "𩨜": "rarely-used",
  "𩨞": "rarely-used",
  "𩨠": "rarely-used",
  "𩨡": "rarely-used",
  "𩨬": "rarely-used",
  "𩨭": "rarely-used",
  "𩨮": "rarely-used",
  "𩨯": "rarely-used",
  "𩨲": "rarely-used",
  "𩨳": "rarely-used",
  "𩨽": "rarely-used",
  "𩨾": "rarely-used",
  "𩩋": "rarely-used",
  "𩩍": "rarely-used",
  "𩩗": "rarely-used",
  "𩩛": "rarely-used",
  "𩩝": "rarely-used",
  "𩩞": "rarely-used",
  "𩩟": "rarely-used",
  "𩩠": "rarely-used",
  "𩩡": "rarely-used",
  "𩩢": "rarely-used",
  "𩩦": "rarely-used",
  "𩩮": "rarely-used",
  "𩩯": "rarely-used",
  "𩩲": "rarely-used",
  "𩩳": "rarely-used",
  "𩩴": "rarely-used",
  "𩪀": "rarely-used",
  "𩪁": "rarely-used",
  "𩪂": "rarely-used",
  "𩪃": "rarely-used",
  "𩪊": "rarely-used",
  "𩪌": "rarely-used",
  "𩪍": "rarely-used",
  "𩪎": "rarely-used",
  "𩪑": "rarely-used",
  "𩪗": "rarely-used",
  "𩪛": "rarely-used",
  "𩪢": "rarely-used",
  "𩪤": "rarely-used",
  "𩪧": "rarely-used",
  "𩪭": "rarely-used",
  "𩪮": "rarely-used",
  "𩪲": "rarely-used",
  "𩪸": "rarely-used",
  "𩪾": "rarely-used",
  "𩫀": "rarely-used",
  "𩫁": "rarely-used",
  "𩫂": "rarely-used",
  "𩫗": "rarely-used",
  "𩫠": "rarely-used",
  "𩫥": "rarely-used",
  "𩫿": "rarely-used",
  "𩬀": "rarely-used",
  "𩬏": "rarely-used",
  "𩬐": "rarely-used",
  "𩬑": "rarely-used",
  "𩬔": "rarely-used",
  "𩬖": "rarely-used",
  "𩬙": "rarely-used",
  "𩬚": "rarely-used",
  "𩬛": "rarely-used",
  "𩬜": "rarely-used",
  "𩬝": "rarely-used",
  "𩬞": "rarely-used",
  "𩬟": "rarely-used",
  "𩬠": "rarely-used",
  "𩬱": "rarely-used",
  "𩬳": "rarely-used",
  "𩬵": "rarely-used",
  "𩬶": "rarely-used",
  "𩬷": "rarely-used",
  "𩬸": "rarely-used",
  "𩬹": "rarely-used",
  "𩬺": "rarely-used",
  "𩬻": "rarely-used",
  "𩬽": "rarely-used",
  "𩭇": "rarely-used",
  "𩭊": "rarely-used",
  "𩭋": "rarely-used",
  "𩭌": "rarely-used",
  "𩭎": "rarely-used",
  "𩭏": "rarely-used",
  "𩭐": "rarely-used",
  "𩭒": "rarely-used",
  "𩭟": "rarely-used",
  "𩭠": "rarely-used",
  "𩭡": "rarely-used",
  "𩭢": "rarely-used",
  "𩭣": "rarely-used",
  "𩭥": "rarely-used",
  "𩭨": "rarely-used",
  "𩭩": "rarely-used",
  "𩭫": "rarely-used",
  "𩭷": "rarely-used",
  "𩭺": "rarely-used",
  "𩭽": "rarely-used",
  "𩭾": "rarely-used",
  "𩭿": "rarely-used",
  "𩮀": "rarely-used",
  "𩮄": "rarely-used",
  "𩮅": "rarely-used",
  "𩮈": "rarely-used",
  "𩮖": "rarely-used",
  "𩮘": "rarely-used",
  "𩮙": "rarely-used",
  "𩮚": "rarely-used",
  "𩮛": "rarely-used",
  "𩮝": "rarely-used",
  "𩮞": "rarely-used",
  "𩮟": "rarely-used",
  "𩮠": "rarely-used",
  "𩮮": "rarely-used",
  "𩮯": "rarely-used",
  "𩮰": "rarely-used",
  "𩮱": "rarely-used",
  "𩮳": "rarely-used",
  "𩮴": "rarely-used",
  "𩮵": "rarely-used",
  "𩮶": "rarely-used",
  "𩮷": "rarely-used",
  "𩮹": "rarely-used",
  "𩯃": "rarely-used",
  "𩯄": "rarely-used",
  "𩯆": "rarely-used",
  "𩯇": "rarely-used",
  "𩯈": "rarely-used",
  "𩯉": "rarely-used",
  "𩯊": "rarely-used",
  "𩯋": "rarely-used",
  "𩯌": "rarely-used",
  "𩯍": "rarely-used",
  "𩯏": "rarely-used",
  "𩯛": "rarely-used",
  "𩯜": "rarely-used",
  "𩯞": "rarely-used",
  "𩯦": "rarely-used",
  "𩯨": "rarely-used",
  "𩯰": "rarely-used",
  "𩯲": "rarely-used",
  "𩯺": "rarely-used",
  "𩰃": "rarely-used",
  "𩰇": "rarely-used",
  "𩰉": "rarely-used",
  "𩰌": "rarely-used",
  "𩰍": "rarely-used",
  "𩰎": "rarely-used",
  "𩰗": "rarely-used",
  "𩰞": "rarely-used",
  "𩰟": "rarely-used",
  "𩰡": "rarely-used",
  "𩰢": "rarely-used",
  "𩰪": "rarely-used",
  "𩰫": "rarely-used",
  "𩰳": "rarely-used",
  "𩰶": "rarely-used",
  "𩰹": "rarely-used",
  "𩰾": "rarely-used",
  "𩱄": "rarely-used",
  "𩱇": "rarely-used",
  "𩱍": "rarely-used",
  "𩱏": "rarely-used",
  "𩱓": "rarely-used",
  "𩱘": "rarely-used",
  "𩱙": "rarely-used",
  "𩱚": "rarely-used",
  "𩱜": "rarely-used",
  "𩱦": "rarely-used",
  "𩱫": "rarely-used",
  "𩱲": "rarely-used",
  "𩱳": "rarely-used",
  "𩱴": "rarely-used",
  "𩱺": "rarely-used",
  "𩱾": "rarely-used",
  "𩲁": "rarely-used",
  "𩲃": "rarely-used",
  "𩲄": "rarely-used",
  "𩲊": "rarely-used",
  "𩲋": "rarely-used",
  "𩲌": "rarely-used",
  "𩲍": "rarely-used",
  "𩲎": "rarely-used",
  "𩲏": "rarely-used",
  "𩲢": "rarely-used",
  "𩲦": "rarely-used",
  "𩲧": "rarely-used",
  "𩲨": "rarely-used",
  "𩲩": "rarely-used",
  "𩲪": "rarely-used",
  "𩲬": "rarely-used",
  "𩲳": "rarely-used",
  "𩲹": "rarely-used",
  "𩲻": "rarely-used",
  "𩲽": "rarely-used",
  "𩲾": "rarely-used",
  "𩳁": "rarely-used",
  "𩳅": "rarely-used",
  "𩳆": "rarely-used",
  "𩳇": "rarely-used",
  "𩳈": "rarely-used",
  "𩳋": "rarely-used",
  "𩳌": "rarely-used",
  "𩳍": "rarely-used",
  "𩳎": "rarely-used",
  "𩳏": "rarely-used",
  "𩳐": "rarely-used",
  "𩳒": "rarely-used",
  "𩳓": "rarely-used",
  "𩳔": "rarely-used",
  "𩳕": "rarely-used",
  "𩳝": "rarely-used",
  "𩳡": "rarely-used",
  "𩳢": "rarely-used",
  "𩳤": "rarely-used",
  "𩳥": "rarely-used",
  "𩳧": "rarely-used",
  "𩳨": "rarely-used",
  "𩳯": "rarely-used",
  "𩳲": "rarely-used",
  "𩳵": "rarely-used",
  "𩳶": "rarely-used",
  "𩳸": "rarely-used",
  "𩴀": "rarely-used",
  "𩴃": "rarely-used",
  "𩴉": "rarely-used",
  "𩴍": "rarely-used",
  "𩴐": "rarely-used",
  "𩴑": "rarely-used",
  "𩴒": "rarely-used",
  "𩴓": "rarely-used",
  "𩴘": "rarely-used",
  "𩴙": "rarely-used",
  "𩴜": "rarely-used",
  "𩴝": "rarely-used",
  "𩴞": "rarely-used",
  "𩴠": "rarely-used",
  "𩴡": "rarely-used",
  "𩴣": "rarely-used",
  "𩴤": "rarely-used",
  "𩴨": "rarely-used",
  "𩴩": "rarely-used",
  "𩴪": "rarely-used",
  "𩴮": "rarely-used",
  "𩴯": "rarely-used",
  "𩴱": "rarely-used",
  "𩴲": "rarely-used",
  "𩴳": "rarely-used",
  "𩴺": "rarely-used",
  "𩴻": "rarely-used",
  "𩵀": "rarely-used",
  "𩵄": "rarely-used",
  "𩵅": "rarely-used",
  "𩵇": "rarely-used",
  "𩵈": "rarely-used",
  "𩵊": "rarely-used",
  "𩵍": "rarely-used",
  "𩵏": "rarely-used",
  "𩵑": "rarely-used",
  "𩵕": "rarely-used",
  "𩵖": "rarely-used",
  "𩵗": "rarely-used",
  "𩵛": "rarely-used",
  "𩵠": "rarely-used",
  "𩵡": "rarely-used",
  "𩵢": "rarely-used",
  "𩵣": "rarely-used",
  "𩵥": "rarely-used",
  "𩵦": "rarely-used",
  "𩵩": "rarely-used",
  "𩵫": "rarely-used",
  "𩵬": "rarely-used",
  "𩵭": "rarely-used",
  "𩵱": "rarely-used",
  "𩵹": "rarely-used",
  "𩶀": "rarely-used",
  "𩶁": "rarely-used",
  "𩶂": "rarely-used",
  "𩶄": "rarely-used",
  "𩶅": "rarely-used",
  "𩶆": "rarely-used",
  "𩶇": "rarely-used",
  "𩶈": "rarely-used",
  "𩶎": "rarely-used",
  "𩶖": "rarely-used",
  "𩶞": "rarely-used",
  "𩶢": "rarely-used",
  "𩶣": "rarely-used",
  "𩶤": "rarely-used",
  "𩶥": "rarely-used",
  "𩶦": "rarely-used",
  "𩶧": "rarely-used",
  "𩶩": "rarely-used",
  "𩶯": "rarely-used",
  "𩶰": "rarely-used",
  "𩶶": "rarely-used",
  "𩶿": "rarely-used",
  "𩷂": "rarely-used",
  "𩷋": "rarely-used",
  "𩷌": "rarely-used",
  "𩷍": "rarely-used",
  "𩷎": "rarely-used",
  "𩷏": "rarely-used",
  "𩷐": "rarely-used",
  "𩷓": "rarely-used",
  "𩷕": "rarely-used",
  "𩷖": "rarely-used",
  "𩷗": "rarely-used",
  "𩷘": "rarely-used",
  "𩷙": "rarely-used",
  "𩷚": "rarely-used",
  "𩷴": "rarely-used",
  "𩷵": "rarely-used",
  "𩷹": "rarely-used",
  "𩷻": "rarely-used",
  "𩷼": "rarely-used",
  "𩷽": "rarely-used",
  "𩸀": "rarely-used",
  "𩸁": "rarely-used",
  "𩸂": "rarely-used",
  "𩸃": "rarely-used",
  "𩸄": "rarely-used",
  "𩸆": "rarely-used",
  "𩸇": "rarely-used",
  "𩸋": "rarely-used",
  "𩸍": "rarely-used",
  "𩸎": "rarely-used",
  "𩸐": "rarely-used",
  "𩸟": "rarely-used",
  "𩸥": "rarely-used",
  "𩸧": "rarely-used",
  "𩸨": "rarely-used",
  "𩸹": "rarely-used",
  "𩸾": "rarely-used",
  "𩹀": "rarely-used",
  "𩹁": "rarely-used",
  "𩹂": "rarely-used",
  "𩹄": "rarely-used",
  "𩹅": "rarely-used",
  "𩹈": "rarely-used",
  "𩹉": "rarely-used",
  "𩹊": "rarely-used",
  "𩹍": "rarely-used",
  "𩹎": "rarely-used",
  "𩹑": "rarely-used",
  "𩹢": "rarely-used",
  "𩹱": "rarely-used",
  "𩹳": "rarely-used",
  "𩹴": "rarely-used",
  "𩹵": "rarely-used",
  "𩹶": "rarely-used",
  "𩹷": "rarely-used",
  "𩹸": "rarely-used",
  "𩹺": "rarely-used",
  "𩹼": "rarely-used",
  "𩹾": "rarely-used",
  "𩹿": "rarely-used",
  "𩺄": "rarely-used",
  "𩺛": "rarely-used",
  "𩺫": "rarely-used",
  "𩺯": "rarely-used",
  "𩺰": "rarely-used",
  "𩺱": "rarely-used",
  "𩺲": "rarely-used",
  "𩺵": "rarely-used",
  "𩺸": "rarely-used",
  "𩻊": "rarely-used",
  "𩻖": "rarely-used",
  "𩻘": "rarely-used",
  "𩻚": "rarely-used",
  "𩻛": "rarely-used",
  "𩻜": "rarely-used",
  "𩻝": "rarely-used",
  "𩻟": "rarely-used",
  "𩻤": "rarely-used",
  "𩻧": "rarely-used",
  "𩼃": "rarely-used",
  "𩼄": "rarely-used",
  "𩼅": "rarely-used",
  "𩼈": "rarely-used",
  "𩼉": "rarely-used",
  "𩼊": "rarely-used",
  "𩼋": "rarely-used",
  "𩼌": "rarely-used",
  "𩼍": "rarely-used",
  "𩼎": "rarely-used",
  "𩼒": "rarely-used",
  "𩼟": "rarely-used",
  "𩼦": "rarely-used",
  "𩼧": "rarely-used",
  "𩼨": "rarely-used",
  "𩼭": "rarely-used",
  "𩼴": "rarely-used",
  "𩽀": "rarely-used",
  "𩽁": "rarely-used",
  "𩽍": "rarely-used",
  "𩽎": "rarely-used",
  "𩽐": "rarely-used",
  "𩽕": "rarely-used",
  "𩽛": "rarely-used",
  "𩽜": "rarely-used",
  "𩽝": "rarely-used",
  "𩽡": "rarely-used",
  "𩽧": "rarely-used",
  "𩽨": "rarely-used",
  "𩽩": "rarely-used",
  "𩽪": "rarely-used",
  "𩽬": "rarely-used",
  "𩽰": "rarely-used",
  "𩽳": "rarely-used",
  "𩽵": "rarely-used",
  "𩽷": "rarely-used",
  "𩾔": "rarely-used",
  "𩾕": "rarely-used",
  "𩾙": "rarely-used",
  "𩾞": "rarely-used",
  "𩾠": "rarely-used",
  "𩾡": "rarely-used",
  "𩾧": "rarely-used",
  "𩾬": "rarely-used",
  "𩾶": "rarely-used",
  "𩾷": "rarely-used",
  "𩾸": "rarely-used",
  "𩾹": "rarely-used",
  "𩾼": "rarely-used",
  "𩾽": "rarely-used",
  "𩾾": "rarely-used",
  "𩾿": "rarely-used",
  "𩿀": "rarely-used",
  "𩿁": "rarely-used",
  "𩿂": "rarely-used",
  "𩿃": "rarely-used",
  "𩿅": "rarely-used",
  "𩿈": "rarely-used",
  "𩿉": "rarely-used",
  "𩿓": "rarely-used",
  "𩿔": "rarely-used",
  "𩿕": "rarely-used",
  "𩿛": "rarely-used",
  "𩿝": "rarely-used",
  "𩿞": "rarely-used",
  "𩿟": "rarely-used",
  "𩿠": "rarely-used",
  "𩿡": "rarely-used",
  "𩿢": "rarely-used",
  "𩿣": "rarely-used",
  "𩿤": "rarely-used",
  "𩿧": "rarely-used",
  "𩿪": "rarely-used",
  "𩿬": "rarely-used",
  "𪀍": "rarely-used",
  "𪀓": "rarely-used",
  "𪀔": "rarely-used",
  "𪀕": "rarely-used",
  "𪀗": "rarely-used",
  "𪀘": "rarely-used",
  "𪀚": "rarely-used",
  "𪀛": "rarely-used",
  "𪀞": "rarely-used",
  "𪀟": "rarely-used",
  "𪀠": "rarely-used",
  "𪀡": "rarely-used",
  "𪀢": "rarely-used",
  "𪀤": "rarely-used",
  "𪀥": "rarely-used",
  "𪀩": "rarely-used",
  "𪀬": "rarely-used",
  "𪀭": "rarely-used",
  "𪀺": "rarely-used",
  "𪀿": "rarely-used",
  "𪁀": "rarely-used",
  "𪁋": "rarely-used",
  "𪁍": "rarely-used",
  "𪁎": "rarely-used",
  "𪁏": "rarely-used",
  "𪁐": "rarely-used",
  "𪁑": "rarely-used",
  "𪁒": "rarely-used",
  "𪁓": "rarely-used",
  "𪁔": "rarely-used",
  "𪁕": "rarely-used",
  "𪁘": "rarely-used",
  "𪁚": "rarely-used",
  "𪁛": "rarely-used",
  "𪁜": "rarely-used",
  "𪁞": "rarely-used",
  "𪁡": "rarely-used",
  "𪁥": "rarely-used",
  "𪁧": "rarely-used",
  "𪁮": "rarely-used",
  "𪁲": "rarely-used",
  "𪁸": "rarely-used",
  "𪁻": "rarely-used",
  "𪁼": "rarely-used",
  "𪁽": "rarely-used",
  "𪂀": "rarely-used",
  "𪂄": "rarely-used",
  "𪂅": "rarely-used",
  "𪂆": "rarely-used",
  "𪂇": "rarely-used",
  "𪂈": "rarely-used",
  "𪂉": "rarely-used",
  "𪂌": "rarely-used",
  "𪂍": "rarely-used",
  "𪂑": "rarely-used",
  "𪂓": "rarely-used",
  "𪂕": "rarely-used",
  "𪂛": "rarely-used",
  "𪂞": "rarely-used",
  "𪂪": "rarely-used",
  "𪂵": "rarely-used",
  "𪂶": "rarely-used",
  "𪂷": "rarely-used",
  "𪂹": "rarely-used",
  "𪂺": "rarely-used",
  "𪂼": "rarely-used",
  "𪂽": "rarely-used",
  "𪃀": "rarely-used",
  "𪃁": "rarely-used",
  "𪃂": "rarely-used",
  "𪃄": "rarely-used",
  "𪃅": "rarely-used",
  "𪃆": "rarely-used",
  "𪃇": "rarely-used",
  "𪃈": "rarely-used",
  "𪃉": "rarely-used",
  "𪃋": "rarely-used",
  "𪃌": "rarely-used",
  "𪃍": "rarely-used",
  "𪃎": "rarely-used",
  "𪃏": "rarely-used",
  "𪃐": "rarely-used",
  "𪃑": "rarely-used",
  "𪃒": "rarely-used",
  "𪃓": "rarely-used",
  "𪃚": "rarely-used",
  "𪃛": "rarely-used",
  "𪃜": "rarely-used",
  "𪃝": "rarely-used",
  "𪃶": "rarely-used",
  "𪃺": "rarely-used",
  "𪃼": "rarely-used",
  "𪃾": "rarely-used",
  "𪃿": "rarely-used",
  "𪄀": "rarely-used",
  "𪄁": "rarely-used",
  "𪄂": "rarely-used",
  "𪄅": "rarely-used",
  "𪄆": "rarely-used",
  "𪄋": "rarely-used",
  "𪄌": "rarely-used",
  "𪄍": "rarely-used",
  "𪄎": "rarely-used",
  "𪄏": "rarely-used",
  "𪄒": "rarely-used",
  "𪄓": "rarely-used",
  "𪄗": "rarely-used",
  "𪄩": "rarely-used",
  "𪄫": "rarely-used",
  "𪄭": "rarely-used",
  "𪄮": "rarely-used",
  "𪄯": "rarely-used",
  "𪄱": "rarely-used",
  "𪄲": "rarely-used",
  "𪄳": "rarely-used",
  "𪄴": "rarely-used",
  "𪄵": "rarely-used",
  "𪄶": "rarely-used",
  "𪄷": "rarely-used",
  "𪄸": "rarely-used",
  "𪄹": "rarely-used",
  "𪄿": "rarely-used",
  "𪅂": "rarely-used",
  "𪅃": "rarely-used",
  "𪅅": "rarely-used",
  "𪅇": "rarely-used",
  "𪅈": "rarely-used",
  "𪅉": "rarely-used",
  "𪅋": "rarely-used",
  "𪅖": "rarely-used",
  "𪅮": "rarely-used",
  "𪅲": "rarely-used",
  "𪅴": "rarely-used",
  "𪅵": "rarely-used",
  "𪅶": "rarely-used",
  "𪅹": "rarely-used",
  "𪅺": "rarely-used",
  "𪅻": "rarely-used",
  "𪅼": "rarely-used",
  "𪅽": "rarely-used",
  "𪅿": "rarely-used",
  "𪆀": "rarely-used",
  "𪆁": "rarely-used",
  "𪆂": "rarely-used",
  "𪆄": "rarely-used",
  "𪆆": "rarely-used",
  "𪆉": "rarely-used",
  "𪆋": "rarely-used",
  "𪆑": "rarely-used",
  "𪆨": "rarely-used",
  "𪆫": "rarely-used",
  "𪆯": "rarely-used",
  "𪆰": "rarely-used",
  "𪆱": "rarely-used",
  "𪆲": "rarely-used",
  "𪆳": "rarely-used",
  "𪆴": "rarely-used",
  "𪆶": "rarely-used",
  "𪆷": "rarely-used",
  "𪆻": "rarely-used",
  "𪆿": "rarely-used",
  "𪇁": "rarely-used",
  "𪇂": "rarely-used",
  "𪇉": "rarely-used",
  "𪇑": "rarely-used",
  "𪇒": "rarely-used",
  "𪇓": "rarely-used",
  "𪇕": "rarely-used",
  "𪇖": "rarely-used",
  "𪇗": "rarely-used",
  "𪇘": "rarely-used",
  "𪇜": "rarely-used",
  "𪇭": "rarely-used",
  "𪇯": "rarely-used",
  "𪇱": "rarely-used",
  "𪇲": "rarely-used",
  "𪇳": "rarely-used",
  "𪇴": "rarely-used",
  "𪇵": "rarely-used",
  "𪇷": "rarely-used",
  "𪇹": "rarely-used",
  "𪈃": "rarely-used",
  "𪈆": "rarely-used",
  "𪈇": "rarely-used",
  "𪈉": "rarely-used",
  "𪈊": "rarely-used",
  "𪈋": "rarely-used",
  "𪈌": "rarely-used",
  "𪈐": "rarely-used",
  "𪈘": "rarely-used",
  "𪈟": "rarely-used",
  "𪈥": "rarely-used",
  "𪈨": "rarely-used",
  "𪈰": "rarely-used",
  "𪈱": "rarely-used",
  "𪈴": "rarely-used",
  "𪈸": "rarely-used",
  "𪈺": "rarely-used",
  "𪈼": "rarely-used",
  "𪈿": "rarely-used",
  "𪉖": "rarely-used",
  "𪉗": "rarely-used",
  "𪉘": "rarely-used",
  "𪉜": "rarely-used",
  "𪉝": "rarely-used",
  "𪉣": "rarely-used",
  "𪉦": "rarely-used",
  "𪉨": "rarely-used",
  "𪉮": "rarely-used",
  "𪉯": "rarely-used",
  "𪉱": "rarely-used",
  "𪉸": "rarely-used",
  "𪉿": "rarely-used",
  "𪊂": "rarely-used",
  "𪊄": "rarely-used",
  "𪊆": "rarely-used",
  "𪊇": "rarely-used",
  "𪊉": "rarely-used",
  "𪊍": "rarely-used",
  "𪊐": "rarely-used",
  "𪊕": "rarely-used",
  "𪊗": "rarely-used",
  "𪊜": "rarely-used",
  "𪊥": "rarely-used",
  "𪊦": "rarely-used",
  "𪊧": "rarely-used",
  "𪊪": "rarely-used",
  "𪊫": "rarely-used",
  "𪊳": "rarely-used",
  "𪊵": "rarely-used",
  "𪊶": "rarely-used",
  "𪊷": "rarely-used",
  "𪊻": "rarely-used",
  "𪋃": "rarely-used",
  "𪋄": "rarely-used",
  "𪋅": "rarely-used",
  "𪋆": "rarely-used",
  "𪋇": "rarely-used",
  "𪋉": "rarely-used",
  "𪋍": "rarely-used",
  "𪋏": "rarely-used",
  "𪋖": "rarely-used",
  "𪋗": "rarely-used",
  "𪋚": "rarely-used",
  "𪋜": "rarely-used",
  "𪋝": "rarely-used",
  "𪋡": "rarely-used",
  "𪋢": "rarely-used",
  "𪋣": "rarely-used",
  "𪋫": "rarely-used",
  "𪋮": "rarely-used",
  "𪋯": "rarely-used",
  "𪋰": "rarely-used",
  "𪋺": "rarely-used",
  "𪋾": "rarely-used",
  "𪌅": "rarely-used",
  "𪌆": "rarely-used",
  "𪌈": "rarely-used",
  "𪌉": "rarely-used",
  "𪌍": "rarely-used",
  "𪌐": "rarely-used",
  "𪌘": "rarely-used",
  "𪌝": "rarely-used",
  "𪌢": "rarely-used",
  "𪌣": "rarely-used",
  "𪌮": "rarely-used",
  "𪌰": "rarely-used",
  "𪌱": "rarely-used",
  "𪌳": "rarely-used",
  "𪌼": "rarely-used",
  "𪌽": "rarely-used",
  "𪍁": "rarely-used",
  "𪍂": "rarely-used",
  "𪍄": "rarely-used",
  "𪍅": "rarely-used",
  "𪍇": "rarely-used",
  "𪍌": "rarely-used",
  "𪍏": "rarely-used",
  "𪍓": "rarely-used",
  "𪍔": "rarely-used",
  "𪍛": "rarely-used",
  "𪍝": "rarely-used",
  "𪍟": "rarely-used",
  "𪍢": "rarely-used",
  "𪍣": "rarely-used",
  "𪍤": "rarely-used",
  "𪍦": "rarely-used",
  "𪍧": "rarely-used",
  "𪍭": "rarely-used",
  "𪍲": "rarely-used",
  "𪍴": "rarely-used",
  "𪍵": "rarely-used",
  "𪍶": "rarely-used",
  "𪍸": "rarely-used",
  "𪍹": "rarely-used",
  "𪍺": "rarely-used",
  "𪍽": "rarely-used",
  "𪎃": "rarely-used",
  "𪎇": "rarely-used",
  "𪎒": "rarely-used",
  "𪎓": "rarely-used",
  "𪎔": "rarely-used",
  "𪎕": "rarely-used",
  "𪎗": "rarely-used",
  "𪎛": "rarely-used",
  "𪎝": "rarely-used",
  "𪎞": "rarely-used",
  "𪎠": "rarely-used",
  "𪎡": "rarely-used",
  "𪎣": "rarely-used",
  "𪎤": "rarely-used",
  "𪎦": "rarely-used",
  "𪎫": "rarely-used",
  "𪎲": "rarely-used",
  "𪎵": "rarely-used",
  "𪎶": "rarely-used",
  "𪎹": "rarely-used",
  "𪎺": "rarely-used",
  "𪎻": "rarely-used",
  "𪎽": "rarely-used",
  "𪎾": "rarely-used",
  "𪏁": "rarely-used",
  "𪏂": "rarely-used",
  "𪏆": "rarely-used",
  "𪏇": "rarely-used",
  "𪏈": "rarely-used",
  "𪏉": "rarely-used",
  "𪏓": "rarely-used",
  "𪏔": "rarely-used",
  "𪏕": "rarely-used",
  "𪏙": "rarely-used",
  "𪏤": "rarely-used",
  "𪏦": "rarely-used",
  "𪏨": "rarely-used",
  "𪏮": "rarely-used",
  "𪏲": "rarely-used",
  "𪏳": "rarely-used",
  "𪏴": "rarely-used",
  "𪏶": "rarely-used",
  "𪏸": "rarely-used",
  "𪏺": "rarely-used",
  "𪏻": "rarely-used",
  "𪏼": "rarely-used",
  "𪏿": "rarely-used",
  "𪐀": "rarely-used",
  "𪐂": "rarely-used",
  "𪐃": "rarely-used",
  "𪐄": "rarely-used",
  "𪐇": "rarely-used",
  "𪐋": "rarely-used",
  "𪐌": "rarely-used",
  "𪐍": "rarely-used",
  "𪐎": "rarely-used",
  "𪐏": "rarely-used",
  "𪐓": "rarely-used",
  "𪐔": "rarely-used",
  "𪐖": "rarely-used",
  "𪐘": "rarely-used",
  "𪐞": "rarely-used",
  "𪐟": "rarely-used",
  "𪐥": "rarely-used",
  "𪐦": "rarely-used",
  "𪐧": "rarely-used",
  "𪐲": "rarely-used",
  "𪐴": "rarely-used",
  "𪐿": "rarely-used",
  "𪑀": "rarely-used",
  "𪑂": "rarely-used",
  "𪑃": "rarely-used",
  "𪑄": "rarely-used",
  "𪑈": "rarely-used",
  "𪑉": "rarely-used",
  "𪑊": "rarely-used",
  "𪑋": "rarely-used",
  "𪑌": "rarely-used",
  "𪑒": "rarely-used",
  "𪑓": "rarely-used",
  "𪑕": "rarely-used",
  "𪑖": "rarely-used",
  "𪑗": "rarely-used",
  "𪑙": "rarely-used",
  "𪑚": "rarely-used",
  "𪑜": "rarely-used",
  "𪑝": "rarely-used",
  "𪑦": "rarely-used",
  "𪑧": "rarely-used",
  "𪑨": "rarely-used",
  "𪑩": "rarely-used",
  "𪑪": "rarely-used",
  "𪑬": "rarely-used",
  "𪑭": "rarely-used",
  "𪑮": "rarely-used",
  "𪑯": "rarely-used",
  "𪑰": "rarely-used",
  "𪑷": "rarely-used",
  "𪑾": "rarely-used",
  "𪑿": "rarely-used",
  "𪒄": "rarely-used",
  "𪒋": "rarely-used",
  "𪒏": "rarely-used",
  "𪒑": "rarely-used",
  "𪒒": "rarely-used",
  "𪒓": "rarely-used",
  "𪒔": "rarely-used",
  "𪒕": "rarely-used",
  "𪒘": "rarely-used",
  "𪒙": "rarely-used",
  "𪒛": "rarely-used",
  "𪒝": "rarely-used",
  "𪒟": "rarely-used",
  "𪒢": "rarely-used",
  "𪒩": "rarely-used",
  "𪒪": "rarely-used",
  "𪒫": "rarely-used",
  "𪒬": "rarely-used",
  "𪒴": "rarely-used",
  "𪒹": "rarely-used",
  "𪒻": "rarely-used",
  "𪒾": "rarely-used",
  "𪒿": "rarely-used",
  "𪓀": "rarely-used",
  "𪓃": "rarely-used",
  "𪓄": "rarely-used",
  "𪓉": "rarely-used",
  "𪓌": "rarely-used",
  "𪓎": "rarely-used",
  "𪓏": "rarely-used",
  "𪓐": "rarely-used",
  "𪓔": "rarely-used",
  "𪓛": "rarely-used",
  "𪓬": "rarely-used",
  "𪓮": "rarely-used",
  "𪓷": "rarely-used",
  "𪓹": "rarely-used",
  "𪓻": "rarely-used",
  "𪓼": "rarely-used",
  "𪓿": "rarely-used",
  "𪔆": "rarely-used",
  "𪔋": "rarely-used",
  "𪔍": "rarely-used",
  "𪔏": "rarely-used",
  "𪔑": "rarely-used",
  "𪔕": "rarely-used",
  "𪔗": "rarely-used",
  "𪔘": "rarely-used",
  "𪔢": "rarely-used",
  "𪔣": "rarely-used",
  "𪔦": "rarely-used",
  "𪔩": "rarely-used",
  "𪔪": "rarely-used",
  "𪔬": "rarely-used",
  "𪔰": "rarely-used",
  "𪔳": "rarely-used",
  "𪔶": "rarely-used",
  "𪔷": "rarely-used",
  "𪔺": "rarely-used",
  "𪔼": "rarely-used",
  "𪔽": "rarely-used",
  "𪔾": "rarely-used",
  "𪔿": "rarely-used",
  "𪕀": "rarely-used",
  "𪕁": "rarely-used",
  "𪕃": "rarely-used",
  "𪕆": "rarely-used",
  "𪕈": "rarely-used",
  "𪕋": "rarely-used",
  "𪕌": "rarely-used",
  "𪕍": "rarely-used",
  "𪕎": "rarely-used",
  "𪕒": "rarely-used",
  "𪕓": "rarely-used",
  "𪕔": "rarely-used",
  "𪕝": "rarely-used",
  "𪕞": "rarely-used",
  "𪕤": "rarely-used",
  "𪕨": "rarely-used",
  "𪕩": "rarely-used",
  "𪕫": "rarely-used",
  "𪕭": "rarely-used",
  "𪕮": "rarely-used",
  "𪕯": "rarely-used",
  "𪕶": "rarely-used",
  "𪕷": "rarely-used",
  "𪕹": "rarely-used",
  "𪕿": "rarely-used",
  "𪖀": "rarely-used",
  "𪖁": "rarely-used",
  "𪖂": "rarely-used",
  "𪖇": "rarely-used",
  "𪖈": "rarely-used",
  "𪖋": "rarely-used",
  "𪖌": "rarely-used",
  "𪖍": "rarely-used",
  "𪖐": "rarely-used",
  "𪖕": "rarely-used",
  "𪖚": "rarely-used",
  "𪖛": "rarely-used",
  "𪖢": "rarely-used",
  "𪖣": "rarely-used",
  "𪖥": "rarely-used",
  "𪖦": "rarely-used",
  "𪖩": "rarely-used",
  "𪖪": "rarely-used",
  "𪖯": "rarely-used",
  "𪖳": "rarely-used",
  "𪖶": "rarely-used",
  "𪖷": "rarely-used",
  "𪖼": "rarely-used",
  "𪗁": "rarely-used",
  "𪗂": "rarely-used",
  "𪗆": "rarely-used",
  "𪗋": "rarely-used",
  "𪗏": "rarely-used",
  "𪗐": "rarely-used",
  "𪗔": "rarely-used",
  "𪗙": "rarely-used",
  "𪗜": "rarely-used",
  "𪗝": "rarely-used",
  "𪗤": "rarely-used",
  "𪗦": "rarely-used",
  "𪗧": "rarely-used",
  "𪗨": "rarely-used",
  "𪗬": "rarely-used",
  "𪗷": "rarely-used",
  "𪗸": "rarely-used",
  "𪗻": "rarely-used",
  "𪗼": "rarely-used",
  "𪗽": "rarely-used",
  "𪗾": "rarely-used",
  "𪘀": "rarely-used",
  "𪘁": "rarely-used",
  "𪘊": "rarely-used",
  "𪘍": "rarely-used",
  "𪘐": "rarely-used",
  "𪘑": "rarely-used",
  "𪘒": "rarely-used",
  "𪘕": "rarely-used",
  "𪘗": "rarely-used",
  "𪘜": "rarely-used",
  "𪘤": "rarely-used",
  "𪘥": "rarely-used",
  "𪘦": "rarely-used",
  "𪘧": "rarely-used",
  "𪘪": "rarely-used",
  "𪘬": "rarely-used",
  "𪘭": "rarely-used",
  "𪘲": "rarely-used",
  "𪘹": "rarely-used",
  "𪘺": "rarely-used",
  "𪘼": "rarely-used",
  "𪘾": "rarely-used",
  "𪙀": "rarely-used",
  "𪙈": "rarely-used",
  "𪙊": "rarely-used",
  "𪙌": "rarely-used",
  "𪙎": "rarely-used",
  "𪙏": "rarely-used",
  "𪙙": "rarely-used",
  "𪙛": "rarely-used",
  "𪙝": "rarely-used",
  "𪙞": "rarely-used",
  "𪙟": "rarely-used",
  "𪙤": "rarely-used",
  "𪙦": "rarely-used",
  "𪙧": "rarely-used",
  "𪙩": "rarely-used",
  "𪙳": "rarely-used",
  "𪙹": "rarely-used",
  "𪙽": "rarely-used",
  "𪚁": "rarely-used",
  "𪚃": "rarely-used",
  "𪚉": "rarely-used",
  "𪚍": "rarely-used",
  "𪚎": "rarely-used",
  "𪚑": "rarely-used",
  "𪚓": "rarely-used",
  "𪚘": "rarely-used",
  "𪚠": "rarely-used",
  "𪚥": "rarely-used",
  "𪚬": "rarely-used",
  "𪚭": "rarely-used",
  "𪚮": "rarely-used",
  "𪚯": "rarely-used",
  "𪚰": "rarely-used",
  "𪚶": "rarely-used",
  "𪚷": "rarely-used",
  "𪚹": "rarely-used",
  "𪚺": "rarely-used",
  "𪚻": "rarely-used",
  "𪛀": "rarely-used",
  "𪛂": "rarely-used",
  "𪛃": "rarely-used",
  "𪛈": "rarely-used",
  "𪛊": "rarely-used",
  "𪛎": "rarely-used",
  "𪛏": "rarely-used",
  "𪛒": "rarely-used"
}
